import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  date: { input: any; output: any; }
  day_enum: { input: any; output: any; }
  float8: { input: any; output: any; }
  interval: { input: string; output: string; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  time: { input: any; output: any; }
  timestamp: { input: string; output: string; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type FileUrlResponse = {
  __typename?: 'FileUrlResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FileUrlResponseV2 = {
  __typename?: 'FileUrlResponseV2';
  fileName?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GroupedIndicatorResult = {
  __typename?: 'GroupedIndicatorResult';
  group: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
  nameEs: Scalars['String']['output'];
  nameFr: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type IndicatorAnalysisDataData = {
  __typename?: 'IndicatorAnalysisDataData';
  aggregated?: Maybe<Array<GroupedIndicatorResult>>;
  total?: Maybe<Array<IndicatorResult>>;
};

export type IndicatorAnalysisDataOutput = {
  __typename?: 'IndicatorAnalysisDataOutput';
  data?: Maybe<IndicatorAnalysisDataData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type IndicatorResult = {
  __typename?: 'IndicatorResult';
  id: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
  nameEs: Scalars['String']['output'];
  nameFr: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type IndicatorVariables = {
  __typename?: 'IndicatorVariables';
  activityId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type IndicatorVariablesResults = {
  __typename?: 'IndicatorVariablesResults';
  data?: Maybe<Array<Maybe<IndicatorVariables>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['Int']['input']>>;
  _eq?: InputMaybe<Array<Scalars['Int']['input']>>;
  _gt?: InputMaybe<Array<Scalars['Int']['input']>>;
  _gte?: InputMaybe<Array<Scalars['Int']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['Int']['input']>>;
  _lte?: InputMaybe<Array<Scalars['Int']['input']>>;
  _neq?: InputMaybe<Array<Scalars['Int']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MutationBasicResult = {
  __typename?: 'MutationBasicResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum RingAggregationCriticalTaskEnum {
  Both = 'BOTH',
  Critical = 'CRITICAL',
  NonCritical = 'NON_CRITICAL'
}

export enum RingAggregationGroupByEnum {
  Ring = 'RING',
  Tasks = 'TASKS'
}

export type RingAggregationTasksAnalyzer = {
  __typename?: 'RingAggregationTasksAnalyzer';
  activityId: Scalars['ID']['output'];
  activityName: Scalars['ID']['output'];
  activityNameExport: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  ring?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type RingAggregationTasksAnalyzerInput = {
  activityLevelAggregation: Scalars['Int']['input'];
  activityList: Array<Scalars['ID']['input']>;
  constructionSiteId: Scalars['ID']['input'];
  critical: RingAggregationCriticalTaskEnum;
  endRing: Scalars['Int']['input'];
  groupBy: RingAggregationGroupByEnum;
  startRing: Scalars['Int']['input'];
};

export type RingComplianceInvalidationResult = {
  __typename?: 'RingComplianceInvalidationResult';
  count: Scalars['Int']['output'];
};

export enum ShiftReportAggregateGroupByEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type ShiftReportAggregatePdfDataReponse = {
  __typename?: 'ShiftReportAggregatePdfDataReponse';
  distance: Scalars['Float']['output'];
  distanceUnit: Scalars['String']['output'];
  endMetricPoint: Scalars['Float']['output'];
  endRing: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startMetricPoint: Scalars['Float']['output'];
  startRing: Scalars['Int']['output'];
  topLevelCriticalTasksAggregate: Array<ShiftReportAggregateTopLevelTask>;
  topLevelTasksAggregate: Array<ShiftReportAggregateTopLevelTask>;
  totalRing: Scalars['Int']['output'];
};

export type ShiftReportAggregatePdfInput = {
  constructionSiteId: Scalars['ID']['input'];
  endDate: Scalars['date']['input'];
  groupBy: ShiftReportAggregateGroupByEnum;
  startDate: Scalars['date']['input'];
};

export type ShiftReportAggregateTopLevelTask = {
  __typename?: 'ShiftReportAggregateTopLevelTask';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type ShiftReportAutofillInput = {
  endDate: Scalars['date']['input'];
  shiftReportId: Scalars['ID']['input'];
  startDate: Scalars['date']['input'];
};

export type ShiftReportAutofillResponse = {
  __typename?: 'ShiftReportAutofillResponse';
  count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ShiftReportAutofillV2Input = {
  endDate: Scalars['date']['input'];
  shiftReportId: Scalars['ID']['input'];
  startDate: Scalars['date']['input'];
};

export type ShiftReportAutofillV2Response = {
  __typename?: 'ShiftReportAutofillV2Response';
  count: Scalars['Int']['output'];
};

export enum ShiftReportCriticalTaskEnum {
  Both = 'BOTH',
  Critical = 'CRITICAL',
  NonCritical = 'NON_CRITICAL'
}

export enum ShiftReportGroupByEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Report = 'REPORT',
  Tasks = 'TASKS',
  Week = 'WEEK'
}

export type ShiftReportIndicatorsResults = {
  __typename?: 'ShiftReportIndicatorsResults';
  data?: Maybe<Array<IndicatorResult>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ShiftReportTasksAnalyzer = {
  __typename?: 'ShiftReportTasksAnalyzer';
  activityId: Scalars['ID']['output'];
  activityName: Scalars['String']['output'];
  activityNameExport: Scalars['String']['output'];
  groupByValue?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  shiftName?: Maybe<Scalars['String']['output']>;
  shiftReportDate?: Maybe<Scalars['date']['output']>;
  total: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type ShiftReportTasksAnalyzerInput = {
  activityLevelAggregation: Scalars['Int']['input'];
  activityList: Array<Scalars['ID']['input']>;
  constructionSiteId: Scalars['ID']['input'];
  critical: ShiftReportCriticalTaskEnum;
  endDate: Scalars['date']['input'];
  groupBy: ShiftReportGroupByEnum;
  startDate: Scalars['date']['input'];
};

export type ShiftReportTasksPieChartData = {
  __typename?: 'ShiftReportTasksPieChartData';
  activityId: Scalars['ID']['output'];
  activityName: Scalars['String']['output'];
  activityNameExport: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type TempUrlResponse = {
  __typename?: 'TempUrlResponse';
  fileName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TempUrlsResponse = {
  __typename?: 'TempUrlsResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
  urls: Array<Scalars['String']['output']>;
};

/** columns and relationships of "activity" */
export type Activity = {
  __typename?: 'activity';
  /** An array relationship */
  child: Array<Activity>;
  /** An aggregate relationship */
  child_aggregate: Activity_Aggregate;
  color: Scalars['String']['output'];
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  isAlwaysDisplayedInPdfReport?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** An object relationship */
  parent?: Maybe<Activity>;
  parentId?: Maybe<Scalars['uuid']['output']>;
  parentIdLevel1?: Maybe<Scalars['uuid']['output']>;
  parentIdLevel2?: Maybe<Scalars['uuid']['output']>;
  parentIdLevel3?: Maybe<Scalars['uuid']['output']>;
  parentIdLevel4?: Maybe<Scalars['uuid']['output']>;
  secondaryColor: Scalars['String']['output'];
  showRingNumber: Scalars['Boolean']['output'];
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
  type: Scalars['String']['output'];
};


/** columns and relationships of "activity" */
export type ActivityChildArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


/** columns and relationships of "activity" */
export type ActivityChild_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


/** columns and relationships of "activity" */
export type ActivityTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "activity" */
export type ActivityTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** columns and relationships of "activityFullName" */
export type ActivityFullName = {
  __typename?: 'activityFullName';
  /** An object relationship */
  activity?: Maybe<Activity>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameLevel2?: Maybe<Scalars['String']['output']>;
  nameLevelMax?: Maybe<Scalars['String']['output']>;
  namesArray?: Maybe<Array<Scalars['String']['output']>>;
};

/** aggregated selection of "activityFullName" */
export type ActivityFullName_Aggregate = {
  __typename?: 'activityFullName_aggregate';
  aggregate?: Maybe<ActivityFullName_Aggregate_Fields>;
  nodes: Array<ActivityFullName>;
};

/** aggregate fields of "activityFullName" */
export type ActivityFullName_Aggregate_Fields = {
  __typename?: 'activityFullName_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ActivityFullName_Max_Fields>;
  min?: Maybe<ActivityFullName_Min_Fields>;
};


/** aggregate fields of "activityFullName" */
export type ActivityFullName_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ActivityFullName_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "activityFullName". All fields are combined with a logical 'AND'. */
export type ActivityFullName_Bool_Exp = {
  _and?: InputMaybe<Array<ActivityFullName_Bool_Exp>>;
  _not?: InputMaybe<ActivityFullName_Bool_Exp>;
  _or?: InputMaybe<Array<ActivityFullName_Bool_Exp>>;
  activity?: InputMaybe<Activity_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nameLevel2?: InputMaybe<String_Comparison_Exp>;
  nameLevelMax?: InputMaybe<String_Comparison_Exp>;
  namesArray?: InputMaybe<String_Array_Comparison_Exp>;
};

/** input type for inserting data into table "activityFullName" */
export type ActivityFullName_Insert_Input = {
  activity?: InputMaybe<Activity_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameLevel2?: InputMaybe<Scalars['String']['input']>;
  nameLevelMax?: InputMaybe<Scalars['String']['input']>;
  namesArray?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** aggregate max on columns */
export type ActivityFullName_Max_Fields = {
  __typename?: 'activityFullName_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameLevel2?: Maybe<Scalars['String']['output']>;
  nameLevelMax?: Maybe<Scalars['String']['output']>;
  namesArray?: Maybe<Array<Scalars['String']['output']>>;
};

/** aggregate min on columns */
export type ActivityFullName_Min_Fields = {
  __typename?: 'activityFullName_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameLevel2?: Maybe<Scalars['String']['output']>;
  nameLevelMax?: Maybe<Scalars['String']['output']>;
  namesArray?: Maybe<Array<Scalars['String']['output']>>;
};

/** input type for inserting object relation for remote table "activityFullName" */
export type ActivityFullName_Obj_Rel_Insert_Input = {
  data: ActivityFullName_Insert_Input;
};

/** Ordering options when selecting data from "activityFullName". */
export type ActivityFullName_Order_By = {
  activity?: InputMaybe<Activity_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nameLevel2?: InputMaybe<Order_By>;
  nameLevelMax?: InputMaybe<Order_By>;
  namesArray?: InputMaybe<Order_By>;
};

/** select columns of table "activityFullName" */
export enum ActivityFullName_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NameLevel2 = 'nameLevel2',
  /** column name */
  NameLevelMax = 'nameLevelMax',
  /** column name */
  NamesArray = 'namesArray'
}

/** Streaming cursor of the table "activityFullName" */
export type ActivityFullName_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ActivityFullName_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ActivityFullName_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameLevel2?: InputMaybe<Scalars['String']['input']>;
  nameLevelMax?: InputMaybe<Scalars['String']['input']>;
  namesArray?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** aggregated selection of "activity" */
export type Activity_Aggregate = {
  __typename?: 'activity_aggregate';
  aggregate?: Maybe<Activity_Aggregate_Fields>;
  nodes: Array<Activity>;
};

export type Activity_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Activity_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Activity_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Activity_Aggregate_Bool_Exp_Count>;
};

export type Activity_Aggregate_Bool_Exp_Bool_And = {
  arguments: Activity_Select_Column_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Activity_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Activity_Select_Column_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Activity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Activity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Activity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "activity" */
export type Activity_Aggregate_Fields = {
  __typename?: 'activity_aggregate_fields';
  avg?: Maybe<Activity_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Activity_Max_Fields>;
  min?: Maybe<Activity_Min_Fields>;
  stddev?: Maybe<Activity_Stddev_Fields>;
  stddev_pop?: Maybe<Activity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Activity_Stddev_Samp_Fields>;
  sum?: Maybe<Activity_Sum_Fields>;
  var_pop?: Maybe<Activity_Var_Pop_Fields>;
  var_samp?: Maybe<Activity_Var_Samp_Fields>;
  variance?: Maybe<Activity_Variance_Fields>;
};


/** aggregate fields of "activity" */
export type Activity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "activity" */
export type Activity_Aggregate_Order_By = {
  avg?: InputMaybe<Activity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Activity_Max_Order_By>;
  min?: InputMaybe<Activity_Min_Order_By>;
  stddev?: InputMaybe<Activity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Activity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Activity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Activity_Sum_Order_By>;
  var_pop?: InputMaybe<Activity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Activity_Var_Samp_Order_By>;
  variance?: InputMaybe<Activity_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "activity" */
export type Activity_Arr_Rel_Insert_Input = {
  data: Array<Activity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Activity_On_Conflict>;
};

/** aggregate avg on columns */
export type Activity_Avg_Fields = {
  __typename?: 'activity_avg_fields';
  level?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "activity" */
export type Activity_Avg_Order_By = {
  level?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "activity". All fields are combined with a logical 'AND'. */
export type Activity_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Bool_Exp>>;
  _not?: InputMaybe<Activity_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Bool_Exp>>;
  child?: InputMaybe<Activity_Bool_Exp>;
  child_aggregate?: InputMaybe<Activity_Aggregate_Bool_Exp>;
  color?: InputMaybe<String_Comparison_Exp>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isAlwaysDisplayedInPdfReport?: InputMaybe<Boolean_Comparison_Exp>;
  level?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  parent?: InputMaybe<Activity_Bool_Exp>;
  parentId?: InputMaybe<Uuid_Comparison_Exp>;
  parentIdLevel1?: InputMaybe<Uuid_Comparison_Exp>;
  parentIdLevel2?: InputMaybe<Uuid_Comparison_Exp>;
  parentIdLevel3?: InputMaybe<Uuid_Comparison_Exp>;
  parentIdLevel4?: InputMaybe<Uuid_Comparison_Exp>;
  secondaryColor?: InputMaybe<String_Comparison_Exp>;
  showRingNumber?: InputMaybe<Boolean_Comparison_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "activity" */
export enum Activity_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActivityPkey = 'activity_pkey'
}

/** input type for incrementing numeric columns in table "activity" */
export type Activity_Inc_Input = {
  level?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "activity" */
export type Activity_Insert_Input = {
  child?: InputMaybe<Activity_Arr_Rel_Insert_Input>;
  color?: InputMaybe<Scalars['String']['input']>;
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAlwaysDisplayedInPdfReport?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parent?: InputMaybe<Activity_Obj_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  parentIdLevel1?: InputMaybe<Scalars['uuid']['input']>;
  parentIdLevel2?: InputMaybe<Scalars['uuid']['input']>;
  parentIdLevel3?: InputMaybe<Scalars['uuid']['input']>;
  parentIdLevel4?: InputMaybe<Scalars['uuid']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  showRingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Activity_Max_Fields = {
  __typename?: 'activity_max_fields';
  color?: Maybe<Scalars['String']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['uuid']['output']>;
  parentIdLevel1?: Maybe<Scalars['uuid']['output']>;
  parentIdLevel2?: Maybe<Scalars['uuid']['output']>;
  parentIdLevel3?: Maybe<Scalars['uuid']['output']>;
  parentIdLevel4?: Maybe<Scalars['uuid']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "activity" */
export type Activity_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  parentIdLevel1?: InputMaybe<Order_By>;
  parentIdLevel2?: InputMaybe<Order_By>;
  parentIdLevel3?: InputMaybe<Order_By>;
  parentIdLevel4?: InputMaybe<Order_By>;
  secondaryColor?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Activity_Min_Fields = {
  __typename?: 'activity_min_fields';
  color?: Maybe<Scalars['String']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['uuid']['output']>;
  parentIdLevel1?: Maybe<Scalars['uuid']['output']>;
  parentIdLevel2?: Maybe<Scalars['uuid']['output']>;
  parentIdLevel3?: Maybe<Scalars['uuid']['output']>;
  parentIdLevel4?: Maybe<Scalars['uuid']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "activity" */
export type Activity_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  parentIdLevel1?: InputMaybe<Order_By>;
  parentIdLevel2?: InputMaybe<Order_By>;
  parentIdLevel3?: InputMaybe<Order_By>;
  parentIdLevel4?: InputMaybe<Order_By>;
  secondaryColor?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "activity" */
export type Activity_Mutation_Response = {
  __typename?: 'activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Activity>;
};

/** input type for inserting object relation for remote table "activity" */
export type Activity_Obj_Rel_Insert_Input = {
  data: Activity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Activity_On_Conflict>;
};

/** on_conflict condition type for table "activity" */
export type Activity_On_Conflict = {
  constraint: Activity_Constraint;
  update_columns?: Array<Activity_Update_Column>;
  where?: InputMaybe<Activity_Bool_Exp>;
};

/** Ordering options when selecting data from "activity". */
export type Activity_Order_By = {
  child_aggregate?: InputMaybe<Activity_Aggregate_Order_By>;
  color?: InputMaybe<Order_By>;
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isAlwaysDisplayedInPdfReport?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parent?: InputMaybe<Activity_Order_By>;
  parentId?: InputMaybe<Order_By>;
  parentIdLevel1?: InputMaybe<Order_By>;
  parentIdLevel2?: InputMaybe<Order_By>;
  parentIdLevel3?: InputMaybe<Order_By>;
  parentIdLevel4?: InputMaybe<Order_By>;
  secondaryColor?: InputMaybe<Order_By>;
  showRingNumber?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: activity */
export type Activity_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "activity" */
export enum Activity_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  IsAlwaysDisplayedInPdfReport = 'isAlwaysDisplayedInPdfReport',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  ParentIdLevel1 = 'parentIdLevel1',
  /** column name */
  ParentIdLevel2 = 'parentIdLevel2',
  /** column name */
  ParentIdLevel3 = 'parentIdLevel3',
  /** column name */
  ParentIdLevel4 = 'parentIdLevel4',
  /** column name */
  SecondaryColor = 'secondaryColor',
  /** column name */
  ShowRingNumber = 'showRingNumber',
  /** column name */
  Type = 'type'
}

/** select "activity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "activity" */
export enum Activity_Select_Column_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Hidden = 'hidden',
  /** column name */
  IsAlwaysDisplayedInPdfReport = 'isAlwaysDisplayedInPdfReport',
  /** column name */
  ShowRingNumber = 'showRingNumber'
}

/** select "activity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "activity" */
export enum Activity_Select_Column_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Hidden = 'hidden',
  /** column name */
  IsAlwaysDisplayedInPdfReport = 'isAlwaysDisplayedInPdfReport',
  /** column name */
  ShowRingNumber = 'showRingNumber'
}

/** input type for updating data in table "activity" */
export type Activity_Set_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAlwaysDisplayedInPdfReport?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  parentIdLevel1?: InputMaybe<Scalars['uuid']['input']>;
  parentIdLevel2?: InputMaybe<Scalars['uuid']['input']>;
  parentIdLevel3?: InputMaybe<Scalars['uuid']['input']>;
  parentIdLevel4?: InputMaybe<Scalars['uuid']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  showRingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Activity_Stddev_Fields = {
  __typename?: 'activity_stddev_fields';
  level?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "activity" */
export type Activity_Stddev_Order_By = {
  level?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Activity_Stddev_Pop_Fields = {
  __typename?: 'activity_stddev_pop_fields';
  level?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "activity" */
export type Activity_Stddev_Pop_Order_By = {
  level?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Activity_Stddev_Samp_Fields = {
  __typename?: 'activity_stddev_samp_fields';
  level?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "activity" */
export type Activity_Stddev_Samp_Order_By = {
  level?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "activity" */
export type Activity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAlwaysDisplayedInPdfReport?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  parentIdLevel1?: InputMaybe<Scalars['uuid']['input']>;
  parentIdLevel2?: InputMaybe<Scalars['uuid']['input']>;
  parentIdLevel3?: InputMaybe<Scalars['uuid']['input']>;
  parentIdLevel4?: InputMaybe<Scalars['uuid']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  showRingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Activity_Sum_Fields = {
  __typename?: 'activity_sum_fields';
  level?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "activity" */
export type Activity_Sum_Order_By = {
  level?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "activity" */
export enum Activity_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  IsAlwaysDisplayedInPdfReport = 'isAlwaysDisplayedInPdfReport',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  ParentIdLevel1 = 'parentIdLevel1',
  /** column name */
  ParentIdLevel2 = 'parentIdLevel2',
  /** column name */
  ParentIdLevel3 = 'parentIdLevel3',
  /** column name */
  ParentIdLevel4 = 'parentIdLevel4',
  /** column name */
  SecondaryColor = 'secondaryColor',
  /** column name */
  ShowRingNumber = 'showRingNumber',
  /** column name */
  Type = 'type'
}

export type Activity_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Activity_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Activity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Activity_Var_Pop_Fields = {
  __typename?: 'activity_var_pop_fields';
  level?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "activity" */
export type Activity_Var_Pop_Order_By = {
  level?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Activity_Var_Samp_Fields = {
  __typename?: 'activity_var_samp_fields';
  level?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "activity" */
export type Activity_Var_Samp_Order_By = {
  level?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Activity_Variance_Fields = {
  __typename?: 'activity_variance_fields';
  level?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "activity" */
export type Activity_Variance_Order_By = {
  level?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "autofillApi" */
export type AutofillApi = {
  __typename?: 'autofillApi';
  buildLane: Scalars['numeric']['output'];
  emptyRangeTolerance: Scalars['Int']['output'];
  excavationLane: Scalars['numeric']['output'];
  host: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  path: Scalars['String']['output'];
  port: Scalars['numeric']['output'];
  protocol: Scalars['String']['output'];
  queryParamDo: Scalars['String']['output'];
  queryParamFreq: Scalars['numeric']['output'];
  queryParamKey: Scalars['String']['output'];
  queryParamUser: Scalars['String']['output'];
  ringLane: Scalars['numeric']['output'];
};

/** aggregated selection of "autofillApi" */
export type AutofillApi_Aggregate = {
  __typename?: 'autofillApi_aggregate';
  aggregate?: Maybe<AutofillApi_Aggregate_Fields>;
  nodes: Array<AutofillApi>;
};

/** aggregate fields of "autofillApi" */
export type AutofillApi_Aggregate_Fields = {
  __typename?: 'autofillApi_aggregate_fields';
  avg?: Maybe<AutofillApi_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AutofillApi_Max_Fields>;
  min?: Maybe<AutofillApi_Min_Fields>;
  stddev?: Maybe<AutofillApi_Stddev_Fields>;
  stddev_pop?: Maybe<AutofillApi_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AutofillApi_Stddev_Samp_Fields>;
  sum?: Maybe<AutofillApi_Sum_Fields>;
  var_pop?: Maybe<AutofillApi_Var_Pop_Fields>;
  var_samp?: Maybe<AutofillApi_Var_Samp_Fields>;
  variance?: Maybe<AutofillApi_Variance_Fields>;
};


/** aggregate fields of "autofillApi" */
export type AutofillApi_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AutofillApi_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type AutofillApi_Avg_Fields = {
  __typename?: 'autofillApi_avg_fields';
  buildLane?: Maybe<Scalars['Float']['output']>;
  emptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  excavationLane?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  queryParamFreq?: Maybe<Scalars['Float']['output']>;
  ringLane?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "autofillApi". All fields are combined with a logical 'AND'. */
export type AutofillApi_Bool_Exp = {
  _and?: InputMaybe<Array<AutofillApi_Bool_Exp>>;
  _not?: InputMaybe<AutofillApi_Bool_Exp>;
  _or?: InputMaybe<Array<AutofillApi_Bool_Exp>>;
  buildLane?: InputMaybe<Numeric_Comparison_Exp>;
  emptyRangeTolerance?: InputMaybe<Int_Comparison_Exp>;
  excavationLane?: InputMaybe<Numeric_Comparison_Exp>;
  host?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  path?: InputMaybe<String_Comparison_Exp>;
  port?: InputMaybe<Numeric_Comparison_Exp>;
  protocol?: InputMaybe<String_Comparison_Exp>;
  queryParamDo?: InputMaybe<String_Comparison_Exp>;
  queryParamFreq?: InputMaybe<Numeric_Comparison_Exp>;
  queryParamKey?: InputMaybe<String_Comparison_Exp>;
  queryParamUser?: InputMaybe<String_Comparison_Exp>;
  ringLane?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "autofillApi" */
export enum AutofillApi_Constraint {
  /** unique or primary key constraint on columns "id" */
  AutofillApiPkey = 'autofillApi_pkey'
}

/** input type for incrementing numeric columns in table "autofillApi" */
export type AutofillApi_Inc_Input = {
  buildLane?: InputMaybe<Scalars['numeric']['input']>;
  emptyRangeTolerance?: InputMaybe<Scalars['Int']['input']>;
  excavationLane?: InputMaybe<Scalars['numeric']['input']>;
  port?: InputMaybe<Scalars['numeric']['input']>;
  queryParamFreq?: InputMaybe<Scalars['numeric']['input']>;
  ringLane?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "autofillApi" */
export type AutofillApi_Insert_Input = {
  buildLane?: InputMaybe<Scalars['numeric']['input']>;
  emptyRangeTolerance?: InputMaybe<Scalars['Int']['input']>;
  excavationLane?: InputMaybe<Scalars['numeric']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['numeric']['input']>;
  protocol?: InputMaybe<Scalars['String']['input']>;
  queryParamDo?: InputMaybe<Scalars['String']['input']>;
  queryParamFreq?: InputMaybe<Scalars['numeric']['input']>;
  queryParamKey?: InputMaybe<Scalars['String']['input']>;
  queryParamUser?: InputMaybe<Scalars['String']['input']>;
  ringLane?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type AutofillApi_Max_Fields = {
  __typename?: 'autofillApi_max_fields';
  buildLane?: Maybe<Scalars['numeric']['output']>;
  emptyRangeTolerance?: Maybe<Scalars['Int']['output']>;
  excavationLane?: Maybe<Scalars['numeric']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['numeric']['output']>;
  protocol?: Maybe<Scalars['String']['output']>;
  queryParamDo?: Maybe<Scalars['String']['output']>;
  queryParamFreq?: Maybe<Scalars['numeric']['output']>;
  queryParamKey?: Maybe<Scalars['String']['output']>;
  queryParamUser?: Maybe<Scalars['String']['output']>;
  ringLane?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type AutofillApi_Min_Fields = {
  __typename?: 'autofillApi_min_fields';
  buildLane?: Maybe<Scalars['numeric']['output']>;
  emptyRangeTolerance?: Maybe<Scalars['Int']['output']>;
  excavationLane?: Maybe<Scalars['numeric']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['numeric']['output']>;
  protocol?: Maybe<Scalars['String']['output']>;
  queryParamDo?: Maybe<Scalars['String']['output']>;
  queryParamFreq?: Maybe<Scalars['numeric']['output']>;
  queryParamKey?: Maybe<Scalars['String']['output']>;
  queryParamUser?: Maybe<Scalars['String']['output']>;
  ringLane?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "autofillApi" */
export type AutofillApi_Mutation_Response = {
  __typename?: 'autofillApi_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AutofillApi>;
};

/** input type for inserting object relation for remote table "autofillApi" */
export type AutofillApi_Obj_Rel_Insert_Input = {
  data: AutofillApi_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AutofillApi_On_Conflict>;
};

/** on_conflict condition type for table "autofillApi" */
export type AutofillApi_On_Conflict = {
  constraint: AutofillApi_Constraint;
  update_columns?: Array<AutofillApi_Update_Column>;
  where?: InputMaybe<AutofillApi_Bool_Exp>;
};

/** Ordering options when selecting data from "autofillApi". */
export type AutofillApi_Order_By = {
  buildLane?: InputMaybe<Order_By>;
  emptyRangeTolerance?: InputMaybe<Order_By>;
  excavationLane?: InputMaybe<Order_By>;
  host?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  port?: InputMaybe<Order_By>;
  protocol?: InputMaybe<Order_By>;
  queryParamDo?: InputMaybe<Order_By>;
  queryParamFreq?: InputMaybe<Order_By>;
  queryParamKey?: InputMaybe<Order_By>;
  queryParamUser?: InputMaybe<Order_By>;
  ringLane?: InputMaybe<Order_By>;
};

/** primary key columns input for table: autofillApi */
export type AutofillApi_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "autofillApi" */
export enum AutofillApi_Select_Column {
  /** column name */
  BuildLane = 'buildLane',
  /** column name */
  EmptyRangeTolerance = 'emptyRangeTolerance',
  /** column name */
  ExcavationLane = 'excavationLane',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  Path = 'path',
  /** column name */
  Port = 'port',
  /** column name */
  Protocol = 'protocol',
  /** column name */
  QueryParamDo = 'queryParamDo',
  /** column name */
  QueryParamFreq = 'queryParamFreq',
  /** column name */
  QueryParamKey = 'queryParamKey',
  /** column name */
  QueryParamUser = 'queryParamUser',
  /** column name */
  RingLane = 'ringLane'
}

/** input type for updating data in table "autofillApi" */
export type AutofillApi_Set_Input = {
  buildLane?: InputMaybe<Scalars['numeric']['input']>;
  emptyRangeTolerance?: InputMaybe<Scalars['Int']['input']>;
  excavationLane?: InputMaybe<Scalars['numeric']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['numeric']['input']>;
  protocol?: InputMaybe<Scalars['String']['input']>;
  queryParamDo?: InputMaybe<Scalars['String']['input']>;
  queryParamFreq?: InputMaybe<Scalars['numeric']['input']>;
  queryParamKey?: InputMaybe<Scalars['String']['input']>;
  queryParamUser?: InputMaybe<Scalars['String']['input']>;
  ringLane?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type AutofillApi_Stddev_Fields = {
  __typename?: 'autofillApi_stddev_fields';
  buildLane?: Maybe<Scalars['Float']['output']>;
  emptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  excavationLane?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  queryParamFreq?: Maybe<Scalars['Float']['output']>;
  ringLane?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type AutofillApi_Stddev_Pop_Fields = {
  __typename?: 'autofillApi_stddev_pop_fields';
  buildLane?: Maybe<Scalars['Float']['output']>;
  emptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  excavationLane?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  queryParamFreq?: Maybe<Scalars['Float']['output']>;
  ringLane?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type AutofillApi_Stddev_Samp_Fields = {
  __typename?: 'autofillApi_stddev_samp_fields';
  buildLane?: Maybe<Scalars['Float']['output']>;
  emptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  excavationLane?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  queryParamFreq?: Maybe<Scalars['Float']['output']>;
  ringLane?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "autofillApi" */
export type AutofillApi_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AutofillApi_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AutofillApi_Stream_Cursor_Value_Input = {
  buildLane?: InputMaybe<Scalars['numeric']['input']>;
  emptyRangeTolerance?: InputMaybe<Scalars['Int']['input']>;
  excavationLane?: InputMaybe<Scalars['numeric']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['numeric']['input']>;
  protocol?: InputMaybe<Scalars['String']['input']>;
  queryParamDo?: InputMaybe<Scalars['String']['input']>;
  queryParamFreq?: InputMaybe<Scalars['numeric']['input']>;
  queryParamKey?: InputMaybe<Scalars['String']['input']>;
  queryParamUser?: InputMaybe<Scalars['String']['input']>;
  ringLane?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type AutofillApi_Sum_Fields = {
  __typename?: 'autofillApi_sum_fields';
  buildLane?: Maybe<Scalars['numeric']['output']>;
  emptyRangeTolerance?: Maybe<Scalars['Int']['output']>;
  excavationLane?: Maybe<Scalars['numeric']['output']>;
  port?: Maybe<Scalars['numeric']['output']>;
  queryParamFreq?: Maybe<Scalars['numeric']['output']>;
  ringLane?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "autofillApi" */
export enum AutofillApi_Update_Column {
  /** column name */
  BuildLane = 'buildLane',
  /** column name */
  EmptyRangeTolerance = 'emptyRangeTolerance',
  /** column name */
  ExcavationLane = 'excavationLane',
  /** column name */
  Host = 'host',
  /** column name */
  Id = 'id',
  /** column name */
  Path = 'path',
  /** column name */
  Port = 'port',
  /** column name */
  Protocol = 'protocol',
  /** column name */
  QueryParamDo = 'queryParamDo',
  /** column name */
  QueryParamFreq = 'queryParamFreq',
  /** column name */
  QueryParamKey = 'queryParamKey',
  /** column name */
  QueryParamUser = 'queryParamUser',
  /** column name */
  RingLane = 'ringLane'
}

export type AutofillApi_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AutofillApi_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AutofillApi_Set_Input>;
  /** filter the rows which have to be updated */
  where: AutofillApi_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AutofillApi_Var_Pop_Fields = {
  __typename?: 'autofillApi_var_pop_fields';
  buildLane?: Maybe<Scalars['Float']['output']>;
  emptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  excavationLane?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  queryParamFreq?: Maybe<Scalars['Float']['output']>;
  ringLane?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type AutofillApi_Var_Samp_Fields = {
  __typename?: 'autofillApi_var_samp_fields';
  buildLane?: Maybe<Scalars['Float']['output']>;
  emptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  excavationLane?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  queryParamFreq?: Maybe<Scalars['Float']['output']>;
  ringLane?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type AutofillApi_Variance_Fields = {
  __typename?: 'autofillApi_variance_fields';
  buildLane?: Maybe<Scalars['Float']['output']>;
  emptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  excavationLane?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  queryParamFreq?: Maybe<Scalars['Float']['output']>;
  ringLane?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "constructionSite" */
export type ConstructionSite = {
  __typename?: 'constructionSite';
  aggregatedReportActivityLevel: Scalars['Int']['output'];
  /** An object relationship */
  autofillApi?: Maybe<AutofillApi>;
  autofillApiId?: Maybe<Scalars['uuid']['output']>;
  autofillOpcuaEmptyRangeTolerance: Scalars['Int']['output'];
  autofillOpcuaEnabled: Scalars['Boolean']['output'];
  bestBuildThreshold: Scalars['Int']['output'];
  bestExcavationThreshold: Scalars['Int']['output'];
  /** An array relationship */
  boardConfigs: Array<Quality_BoardConfig>;
  /** An aggregate relationship */
  boardConfigs_aggregate: Quality_BoardConfig_Aggregate;
  distanceUnit: Scalars['String']['output'];
  /** An array relationship */
  enabledModules: Array<ConstructionSiteEnabledModule>;
  /** An aggregate relationship */
  enabledModules_aggregate: ConstructionSiteEnabledModule_Aggregate;
  haveRingZero: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  isArticulated?: Maybe<Scalars['Boolean']['output']>;
  isAutofillEnabled: Scalars['Boolean']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isEngineerRequiredInReport: Scalars['Boolean']['output'];
  isManagerRequiredInReport: Scalars['Boolean']['output'];
  isQualityValidatorActivated: Scalars['Boolean']['output'];
  keyPositionPrefix?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  /** A computed field, executes function "construction_site_lower_case_name" */
  lowerCaseName?: Maybe<Scalars['String']['output']>;
  managerValidationRequired: Scalars['Boolean']['output'];
  /** An object relationship */
  mapConfiguration?: Maybe<MapConfiguration>;
  /** An array relationship */
  mapPois: Array<MapPoi>;
  /** An aggregate relationship */
  mapPois_aggregate: MapPoi_Aggregate;
  /** An array relationship */
  mapTraces: Array<MapTrace>;
  /** An aggregate relationship */
  mapTraces_aggregate: MapTrace_Aggregate;
  /** An array relationship */
  metrics: Array<Parameter_Metric>;
  /** An aggregate relationship */
  metrics_aggregate: Parameter_Metric_Aggregate;
  name: Scalars['String']['output'];
  nbDaysPerWeek: Scalars['Int']['output'];
  nbKeyPosition?: Maybe<Scalars['Int']['output']>;
  nbTotalMeters?: Maybe<Scalars['numeric']['output']>;
  nbTotalRings?: Maybe<Scalars['Int']['output']>;
  opcua?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  ringLengthCode0?: Maybe<Scalars['numeric']['output']>;
  ringLengthCode1?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  rings: Array<Parameter_Ring>;
  /** An aggregate relationship */
  rings_aggregate: Parameter_Ring_Aggregate;
  /** An array relationship */
  shiftReports: Array<ShiftReport>;
  /** An aggregate relationship */
  shiftReports_aggregate: ShiftReport_Aggregate;
  timeZone: Scalars['String']['output'];
  tolerance: Scalars['Int']['output'];
  tunnelBoringMachineName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  userPermissions: Array<UserPermission>;
  /** An aggregate relationship */
  userPermissions_aggregate: UserPermission_Aggregate;
  /** An array relationship */
  userQualityRoles: Array<Quality_UserQualityRole>;
  /** An aggregate relationship */
  userQualityRoles_aggregate: Quality_UserQualityRole_Aggregate;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteBoardConfigsArgs = {
  distinct_on?: InputMaybe<Array<Quality_BoardConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_BoardConfig_Order_By>>;
  where?: InputMaybe<Quality_BoardConfig_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteBoardConfigs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_BoardConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_BoardConfig_Order_By>>;
  where?: InputMaybe<Quality_BoardConfig_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteEnabledModulesArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSiteEnabledModule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSiteEnabledModule_Order_By>>;
  where?: InputMaybe<ConstructionSiteEnabledModule_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteEnabledModules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSiteEnabledModule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSiteEnabledModule_Order_By>>;
  where?: InputMaybe<ConstructionSiteEnabledModule_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteMapPoisArgs = {
  distinct_on?: InputMaybe<Array<MapPoi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapPoi_Order_By>>;
  where?: InputMaybe<MapPoi_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteMapPois_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MapPoi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapPoi_Order_By>>;
  where?: InputMaybe<MapPoi_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteMapTracesArgs = {
  distinct_on?: InputMaybe<Array<MapTrace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapTrace_Order_By>>;
  where?: InputMaybe<MapTrace_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteMapTraces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MapTrace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapTrace_Order_By>>;
  where?: InputMaybe<MapTrace_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteMetricsArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Metric_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Metric_Order_By>>;
  where?: InputMaybe<Parameter_Metric_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteMetrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Metric_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Metric_Order_By>>;
  where?: InputMaybe<Parameter_Metric_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteRingsArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Ring_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Ring_Order_By>>;
  where?: InputMaybe<Parameter_Ring_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteRings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Ring_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Ring_Order_By>>;
  where?: InputMaybe<Parameter_Ring_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteShiftReportsArgs = {
  distinct_on?: InputMaybe<Array<ShiftReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftReport_Order_By>>;
  where?: InputMaybe<ShiftReport_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteShiftReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ShiftReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftReport_Order_By>>;
  where?: InputMaybe<ShiftReport_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteUserPermissionsArgs = {
  distinct_on?: InputMaybe<Array<UserPermission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPermission_Order_By>>;
  where?: InputMaybe<UserPermission_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteUserPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPermission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPermission_Order_By>>;
  where?: InputMaybe<UserPermission_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteUserQualityRolesArgs = {
  distinct_on?: InputMaybe<Array<Quality_UserQualityRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_UserQualityRole_Order_By>>;
  where?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
};


/** columns and relationships of "constructionSite" */
export type ConstructionSiteUserQualityRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_UserQualityRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_UserQualityRole_Order_By>>;
  where?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
};

/** columns and relationships of "constructionSiteEnabledModule" */
export type ConstructionSiteEnabledModule = {
  __typename?: 'constructionSiteEnabledModule';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  module: Module_Enum;
};

/** aggregated selection of "constructionSiteEnabledModule" */
export type ConstructionSiteEnabledModule_Aggregate = {
  __typename?: 'constructionSiteEnabledModule_aggregate';
  aggregate?: Maybe<ConstructionSiteEnabledModule_Aggregate_Fields>;
  nodes: Array<ConstructionSiteEnabledModule>;
};

export type ConstructionSiteEnabledModule_Aggregate_Bool_Exp = {
  count?: InputMaybe<ConstructionSiteEnabledModule_Aggregate_Bool_Exp_Count>;
};

export type ConstructionSiteEnabledModule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionSiteEnabledModule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionSiteEnabledModule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "constructionSiteEnabledModule" */
export type ConstructionSiteEnabledModule_Aggregate_Fields = {
  __typename?: 'constructionSiteEnabledModule_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionSiteEnabledModule_Max_Fields>;
  min?: Maybe<ConstructionSiteEnabledModule_Min_Fields>;
};


/** aggregate fields of "constructionSiteEnabledModule" */
export type ConstructionSiteEnabledModule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionSiteEnabledModule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "constructionSiteEnabledModule" */
export type ConstructionSiteEnabledModule_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionSiteEnabledModule_Max_Order_By>;
  min?: InputMaybe<ConstructionSiteEnabledModule_Min_Order_By>;
};

/** input type for inserting array relation for remote table "constructionSiteEnabledModule" */
export type ConstructionSiteEnabledModule_Arr_Rel_Insert_Input = {
  data: Array<ConstructionSiteEnabledModule_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionSiteEnabledModule_On_Conflict>;
};

/** Boolean expression to filter rows from the table "constructionSiteEnabledModule". All fields are combined with a logical 'AND'. */
export type ConstructionSiteEnabledModule_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionSiteEnabledModule_Bool_Exp>>;
  _not?: InputMaybe<ConstructionSiteEnabledModule_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionSiteEnabledModule_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  module?: InputMaybe<Module_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "constructionSiteEnabledModule" */
export enum ConstructionSiteEnabledModule_Constraint {
  /** unique or primary key constraint on columns "module", "constructionSiteId" */
  ConstructionSiteEnabledModuleConstructionSiteIdModuleKey = 'constructionSiteEnabledModule_constructionSiteId_module_key',
  /** unique or primary key constraint on columns "id" */
  ConstructionSiteEnabledModulePkey = 'constructionSiteEnabledModule_pkey'
}

/** input type for inserting data into table "constructionSiteEnabledModule" */
export type ConstructionSiteEnabledModule_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  module?: InputMaybe<Module_Enum>;
};

/** aggregate max on columns */
export type ConstructionSiteEnabledModule_Max_Fields = {
  __typename?: 'constructionSiteEnabledModule_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "constructionSiteEnabledModule" */
export type ConstructionSiteEnabledModule_Max_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionSiteEnabledModule_Min_Fields = {
  __typename?: 'constructionSiteEnabledModule_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "constructionSiteEnabledModule" */
export type ConstructionSiteEnabledModule_Min_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "constructionSiteEnabledModule" */
export type ConstructionSiteEnabledModule_Mutation_Response = {
  __typename?: 'constructionSiteEnabledModule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionSiteEnabledModule>;
};

/** on_conflict condition type for table "constructionSiteEnabledModule" */
export type ConstructionSiteEnabledModule_On_Conflict = {
  constraint: ConstructionSiteEnabledModule_Constraint;
  update_columns?: Array<ConstructionSiteEnabledModule_Update_Column>;
  where?: InputMaybe<ConstructionSiteEnabledModule_Bool_Exp>;
};

/** Ordering options when selecting data from "constructionSiteEnabledModule". */
export type ConstructionSiteEnabledModule_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module?: InputMaybe<Order_By>;
};

/** primary key columns input for table: constructionSiteEnabledModule */
export type ConstructionSiteEnabledModule_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "constructionSiteEnabledModule" */
export enum ConstructionSiteEnabledModule_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Module = 'module'
}

/** input type for updating data in table "constructionSiteEnabledModule" */
export type ConstructionSiteEnabledModule_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  module?: InputMaybe<Module_Enum>;
};

/** Streaming cursor of the table "constructionSiteEnabledModule" */
export type ConstructionSiteEnabledModule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionSiteEnabledModule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionSiteEnabledModule_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  module?: InputMaybe<Module_Enum>;
};

/** update columns of table "constructionSiteEnabledModule" */
export enum ConstructionSiteEnabledModule_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Module = 'module'
}

export type ConstructionSiteEnabledModule_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionSiteEnabledModule_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionSiteEnabledModule_Bool_Exp;
};

/** aggregated selection of "constructionSite" */
export type ConstructionSite_Aggregate = {
  __typename?: 'constructionSite_aggregate';
  aggregate?: Maybe<ConstructionSite_Aggregate_Fields>;
  nodes: Array<ConstructionSite>;
};

export type ConstructionSite_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ConstructionSite_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ConstructionSite_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ConstructionSite_Aggregate_Bool_Exp_Count>;
};

export type ConstructionSite_Aggregate_Bool_Exp_Bool_And = {
  arguments: ConstructionSite_Select_Column_ConstructionSite_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionSite_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ConstructionSite_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ConstructionSite_Select_Column_ConstructionSite_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionSite_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ConstructionSite_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ConstructionSite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ConstructionSite_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "constructionSite" */
export type ConstructionSite_Aggregate_Fields = {
  __typename?: 'constructionSite_aggregate_fields';
  avg?: Maybe<ConstructionSite_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ConstructionSite_Max_Fields>;
  min?: Maybe<ConstructionSite_Min_Fields>;
  stddev?: Maybe<ConstructionSite_Stddev_Fields>;
  stddev_pop?: Maybe<ConstructionSite_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ConstructionSite_Stddev_Samp_Fields>;
  sum?: Maybe<ConstructionSite_Sum_Fields>;
  var_pop?: Maybe<ConstructionSite_Var_Pop_Fields>;
  var_samp?: Maybe<ConstructionSite_Var_Samp_Fields>;
  variance?: Maybe<ConstructionSite_Variance_Fields>;
};


/** aggregate fields of "constructionSite" */
export type ConstructionSite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ConstructionSite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "constructionSite" */
export type ConstructionSite_Aggregate_Order_By = {
  avg?: InputMaybe<ConstructionSite_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ConstructionSite_Max_Order_By>;
  min?: InputMaybe<ConstructionSite_Min_Order_By>;
  stddev?: InputMaybe<ConstructionSite_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ConstructionSite_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ConstructionSite_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ConstructionSite_Sum_Order_By>;
  var_pop?: InputMaybe<ConstructionSite_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ConstructionSite_Var_Samp_Order_By>;
  variance?: InputMaybe<ConstructionSite_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "constructionSite" */
export type ConstructionSite_Arr_Rel_Insert_Input = {
  data: Array<ConstructionSite_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionSite_On_Conflict>;
};

/** aggregate avg on columns */
export type ConstructionSite_Avg_Fields = {
  __typename?: 'constructionSite_avg_fields';
  aggregatedReportActivityLevel?: Maybe<Scalars['Float']['output']>;
  autofillOpcuaEmptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  bestBuildThreshold?: Maybe<Scalars['Float']['output']>;
  bestExcavationThreshold?: Maybe<Scalars['Float']['output']>;
  nbDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  nbKeyPosition?: Maybe<Scalars['Float']['output']>;
  nbTotalMeters?: Maybe<Scalars['Float']['output']>;
  nbTotalRings?: Maybe<Scalars['Float']['output']>;
  ringLengthCode0?: Maybe<Scalars['Float']['output']>;
  ringLengthCode1?: Maybe<Scalars['Float']['output']>;
  tolerance?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "constructionSite" */
export type ConstructionSite_Avg_Order_By = {
  aggregatedReportActivityLevel?: InputMaybe<Order_By>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Order_By>;
  bestBuildThreshold?: InputMaybe<Order_By>;
  bestExcavationThreshold?: InputMaybe<Order_By>;
  nbDaysPerWeek?: InputMaybe<Order_By>;
  nbKeyPosition?: InputMaybe<Order_By>;
  nbTotalMeters?: InputMaybe<Order_By>;
  nbTotalRings?: InputMaybe<Order_By>;
  ringLengthCode0?: InputMaybe<Order_By>;
  ringLengthCode1?: InputMaybe<Order_By>;
  tolerance?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "constructionSite". All fields are combined with a logical 'AND'. */
export type ConstructionSite_Bool_Exp = {
  _and?: InputMaybe<Array<ConstructionSite_Bool_Exp>>;
  _not?: InputMaybe<ConstructionSite_Bool_Exp>;
  _or?: InputMaybe<Array<ConstructionSite_Bool_Exp>>;
  aggregatedReportActivityLevel?: InputMaybe<Int_Comparison_Exp>;
  autofillApi?: InputMaybe<AutofillApi_Bool_Exp>;
  autofillApiId?: InputMaybe<Uuid_Comparison_Exp>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Int_Comparison_Exp>;
  autofillOpcuaEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  bestBuildThreshold?: InputMaybe<Int_Comparison_Exp>;
  bestExcavationThreshold?: InputMaybe<Int_Comparison_Exp>;
  boardConfigs?: InputMaybe<Quality_BoardConfig_Bool_Exp>;
  boardConfigs_aggregate?: InputMaybe<Quality_BoardConfig_Aggregate_Bool_Exp>;
  distanceUnit?: InputMaybe<String_Comparison_Exp>;
  enabledModules?: InputMaybe<ConstructionSiteEnabledModule_Bool_Exp>;
  enabledModules_aggregate?: InputMaybe<ConstructionSiteEnabledModule_Aggregate_Bool_Exp>;
  haveRingZero?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isArticulated?: InputMaybe<Boolean_Comparison_Exp>;
  isAutofillEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  isCompleted?: InputMaybe<Boolean_Comparison_Exp>;
  isEngineerRequiredInReport?: InputMaybe<Boolean_Comparison_Exp>;
  isManagerRequiredInReport?: InputMaybe<Boolean_Comparison_Exp>;
  isQualityValidatorActivated?: InputMaybe<Boolean_Comparison_Exp>;
  keyPositionPrefix?: InputMaybe<String_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  lowerCaseName?: InputMaybe<String_Comparison_Exp>;
  managerValidationRequired?: InputMaybe<Boolean_Comparison_Exp>;
  mapConfiguration?: InputMaybe<MapConfiguration_Bool_Exp>;
  mapPois?: InputMaybe<MapPoi_Bool_Exp>;
  mapPois_aggregate?: InputMaybe<MapPoi_Aggregate_Bool_Exp>;
  mapTraces?: InputMaybe<MapTrace_Bool_Exp>;
  mapTraces_aggregate?: InputMaybe<MapTrace_Aggregate_Bool_Exp>;
  metrics?: InputMaybe<Parameter_Metric_Bool_Exp>;
  metrics_aggregate?: InputMaybe<Parameter_Metric_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nbDaysPerWeek?: InputMaybe<Int_Comparison_Exp>;
  nbKeyPosition?: InputMaybe<Int_Comparison_Exp>;
  nbTotalMeters?: InputMaybe<Numeric_Comparison_Exp>;
  nbTotalRings?: InputMaybe<Int_Comparison_Exp>;
  opcua?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  ringLengthCode0?: InputMaybe<Numeric_Comparison_Exp>;
  ringLengthCode1?: InputMaybe<Numeric_Comparison_Exp>;
  rings?: InputMaybe<Parameter_Ring_Bool_Exp>;
  rings_aggregate?: InputMaybe<Parameter_Ring_Aggregate_Bool_Exp>;
  shiftReports?: InputMaybe<ShiftReport_Bool_Exp>;
  shiftReports_aggregate?: InputMaybe<ShiftReport_Aggregate_Bool_Exp>;
  timeZone?: InputMaybe<String_Comparison_Exp>;
  tolerance?: InputMaybe<Int_Comparison_Exp>;
  tunnelBoringMachineName?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userPermissions?: InputMaybe<UserPermission_Bool_Exp>;
  userPermissions_aggregate?: InputMaybe<UserPermission_Aggregate_Bool_Exp>;
  userQualityRoles?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
  userQualityRoles_aggregate?: InputMaybe<Quality_UserQualityRole_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "constructionSite" */
export enum ConstructionSite_Constraint {
  /** unique or primary key constraint on columns "opcua" */
  ConstructionSiteOpcuaKey = 'constructionSite_opcua_key',
  /** unique or primary key constraint on columns "id" */
  ConstructionSitePkey = 'constructionSite_pkey'
}

/** input type for incrementing numeric columns in table "constructionSite" */
export type ConstructionSite_Inc_Input = {
  aggregatedReportActivityLevel?: InputMaybe<Scalars['Int']['input']>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Scalars['Int']['input']>;
  bestBuildThreshold?: InputMaybe<Scalars['Int']['input']>;
  bestExcavationThreshold?: InputMaybe<Scalars['Int']['input']>;
  nbDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  nbKeyPosition?: InputMaybe<Scalars['Int']['input']>;
  nbTotalMeters?: InputMaybe<Scalars['numeric']['input']>;
  nbTotalRings?: InputMaybe<Scalars['Int']['input']>;
  ringLengthCode0?: InputMaybe<Scalars['numeric']['input']>;
  ringLengthCode1?: InputMaybe<Scalars['numeric']['input']>;
  tolerance?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "constructionSite" */
export type ConstructionSite_Insert_Input = {
  aggregatedReportActivityLevel?: InputMaybe<Scalars['Int']['input']>;
  autofillApi?: InputMaybe<AutofillApi_Obj_Rel_Insert_Input>;
  autofillApiId?: InputMaybe<Scalars['uuid']['input']>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Scalars['Int']['input']>;
  autofillOpcuaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  bestBuildThreshold?: InputMaybe<Scalars['Int']['input']>;
  bestExcavationThreshold?: InputMaybe<Scalars['Int']['input']>;
  boardConfigs?: InputMaybe<Quality_BoardConfig_Arr_Rel_Insert_Input>;
  distanceUnit?: InputMaybe<Scalars['String']['input']>;
  enabledModules?: InputMaybe<ConstructionSiteEnabledModule_Arr_Rel_Insert_Input>;
  haveRingZero?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArticulated?: InputMaybe<Scalars['Boolean']['input']>;
  isAutofillEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isEngineerRequiredInReport?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerRequiredInReport?: InputMaybe<Scalars['Boolean']['input']>;
  isQualityValidatorActivated?: InputMaybe<Scalars['Boolean']['input']>;
  keyPositionPrefix?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  managerValidationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  mapConfiguration?: InputMaybe<MapConfiguration_Obj_Rel_Insert_Input>;
  mapPois?: InputMaybe<MapPoi_Arr_Rel_Insert_Input>;
  mapTraces?: InputMaybe<MapTrace_Arr_Rel_Insert_Input>;
  metrics?: InputMaybe<Parameter_Metric_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  nbDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  nbKeyPosition?: InputMaybe<Scalars['Int']['input']>;
  nbTotalMeters?: InputMaybe<Scalars['numeric']['input']>;
  nbTotalRings?: InputMaybe<Scalars['Int']['input']>;
  opcua?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  ringLengthCode0?: InputMaybe<Scalars['numeric']['input']>;
  ringLengthCode1?: InputMaybe<Scalars['numeric']['input']>;
  rings?: InputMaybe<Parameter_Ring_Arr_Rel_Insert_Input>;
  shiftReports?: InputMaybe<ShiftReport_Arr_Rel_Insert_Input>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  tolerance?: InputMaybe<Scalars['Int']['input']>;
  tunnelBoringMachineName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userPermissions?: InputMaybe<UserPermission_Arr_Rel_Insert_Input>;
  userQualityRoles?: InputMaybe<Quality_UserQualityRole_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ConstructionSite_Max_Fields = {
  __typename?: 'constructionSite_max_fields';
  aggregatedReportActivityLevel?: Maybe<Scalars['Int']['output']>;
  autofillApiId?: Maybe<Scalars['uuid']['output']>;
  autofillOpcuaEmptyRangeTolerance?: Maybe<Scalars['Int']['output']>;
  bestBuildThreshold?: Maybe<Scalars['Int']['output']>;
  bestExcavationThreshold?: Maybe<Scalars['Int']['output']>;
  distanceUnit?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  keyPositionPrefix?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "construction_site_lower_case_name" */
  lowerCaseName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nbDaysPerWeek?: Maybe<Scalars['Int']['output']>;
  nbKeyPosition?: Maybe<Scalars['Int']['output']>;
  nbTotalMeters?: Maybe<Scalars['numeric']['output']>;
  nbTotalRings?: Maybe<Scalars['Int']['output']>;
  opcua?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  ringLengthCode0?: Maybe<Scalars['numeric']['output']>;
  ringLengthCode1?: Maybe<Scalars['numeric']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  tolerance?: Maybe<Scalars['Int']['output']>;
  tunnelBoringMachineName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "constructionSite" */
export type ConstructionSite_Max_Order_By = {
  aggregatedReportActivityLevel?: InputMaybe<Order_By>;
  autofillApiId?: InputMaybe<Order_By>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Order_By>;
  bestBuildThreshold?: InputMaybe<Order_By>;
  bestExcavationThreshold?: InputMaybe<Order_By>;
  distanceUnit?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keyPositionPrefix?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nbDaysPerWeek?: InputMaybe<Order_By>;
  nbKeyPosition?: InputMaybe<Order_By>;
  nbTotalMeters?: InputMaybe<Order_By>;
  nbTotalRings?: InputMaybe<Order_By>;
  opcua?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  ringLengthCode0?: InputMaybe<Order_By>;
  ringLengthCode1?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  tolerance?: InputMaybe<Order_By>;
  tunnelBoringMachineName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ConstructionSite_Min_Fields = {
  __typename?: 'constructionSite_min_fields';
  aggregatedReportActivityLevel?: Maybe<Scalars['Int']['output']>;
  autofillApiId?: Maybe<Scalars['uuid']['output']>;
  autofillOpcuaEmptyRangeTolerance?: Maybe<Scalars['Int']['output']>;
  bestBuildThreshold?: Maybe<Scalars['Int']['output']>;
  bestExcavationThreshold?: Maybe<Scalars['Int']['output']>;
  distanceUnit?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  keyPositionPrefix?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "construction_site_lower_case_name" */
  lowerCaseName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nbDaysPerWeek?: Maybe<Scalars['Int']['output']>;
  nbKeyPosition?: Maybe<Scalars['Int']['output']>;
  nbTotalMeters?: Maybe<Scalars['numeric']['output']>;
  nbTotalRings?: Maybe<Scalars['Int']['output']>;
  opcua?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  ringLengthCode0?: Maybe<Scalars['numeric']['output']>;
  ringLengthCode1?: Maybe<Scalars['numeric']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  tolerance?: Maybe<Scalars['Int']['output']>;
  tunnelBoringMachineName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "constructionSite" */
export type ConstructionSite_Min_Order_By = {
  aggregatedReportActivityLevel?: InputMaybe<Order_By>;
  autofillApiId?: InputMaybe<Order_By>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Order_By>;
  bestBuildThreshold?: InputMaybe<Order_By>;
  bestExcavationThreshold?: InputMaybe<Order_By>;
  distanceUnit?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keyPositionPrefix?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nbDaysPerWeek?: InputMaybe<Order_By>;
  nbKeyPosition?: InputMaybe<Order_By>;
  nbTotalMeters?: InputMaybe<Order_By>;
  nbTotalRings?: InputMaybe<Order_By>;
  opcua?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  ringLengthCode0?: InputMaybe<Order_By>;
  ringLengthCode1?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  tolerance?: InputMaybe<Order_By>;
  tunnelBoringMachineName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "constructionSite" */
export type ConstructionSite_Mutation_Response = {
  __typename?: 'constructionSite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConstructionSite>;
};

/** input type for inserting object relation for remote table "constructionSite" */
export type ConstructionSite_Obj_Rel_Insert_Input = {
  data: ConstructionSite_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ConstructionSite_On_Conflict>;
};

/** on_conflict condition type for table "constructionSite" */
export type ConstructionSite_On_Conflict = {
  constraint: ConstructionSite_Constraint;
  update_columns?: Array<ConstructionSite_Update_Column>;
  where?: InputMaybe<ConstructionSite_Bool_Exp>;
};

/** Ordering options when selecting data from "constructionSite". */
export type ConstructionSite_Order_By = {
  aggregatedReportActivityLevel?: InputMaybe<Order_By>;
  autofillApi?: InputMaybe<AutofillApi_Order_By>;
  autofillApiId?: InputMaybe<Order_By>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Order_By>;
  autofillOpcuaEnabled?: InputMaybe<Order_By>;
  bestBuildThreshold?: InputMaybe<Order_By>;
  bestExcavationThreshold?: InputMaybe<Order_By>;
  boardConfigs_aggregate?: InputMaybe<Quality_BoardConfig_Aggregate_Order_By>;
  distanceUnit?: InputMaybe<Order_By>;
  enabledModules_aggregate?: InputMaybe<ConstructionSiteEnabledModule_Aggregate_Order_By>;
  haveRingZero?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isArticulated?: InputMaybe<Order_By>;
  isAutofillEnabled?: InputMaybe<Order_By>;
  isCompleted?: InputMaybe<Order_By>;
  isEngineerRequiredInReport?: InputMaybe<Order_By>;
  isManagerRequiredInReport?: InputMaybe<Order_By>;
  isQualityValidatorActivated?: InputMaybe<Order_By>;
  keyPositionPrefix?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  lowerCaseName?: InputMaybe<Order_By>;
  managerValidationRequired?: InputMaybe<Order_By>;
  mapConfiguration?: InputMaybe<MapConfiguration_Order_By>;
  mapPois_aggregate?: InputMaybe<MapPoi_Aggregate_Order_By>;
  mapTraces_aggregate?: InputMaybe<MapTrace_Aggregate_Order_By>;
  metrics_aggregate?: InputMaybe<Parameter_Metric_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  nbDaysPerWeek?: InputMaybe<Order_By>;
  nbKeyPosition?: InputMaybe<Order_By>;
  nbTotalMeters?: InputMaybe<Order_By>;
  nbTotalRings?: InputMaybe<Order_By>;
  opcua?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  ringLengthCode0?: InputMaybe<Order_By>;
  ringLengthCode1?: InputMaybe<Order_By>;
  rings_aggregate?: InputMaybe<Parameter_Ring_Aggregate_Order_By>;
  shiftReports_aggregate?: InputMaybe<ShiftReport_Aggregate_Order_By>;
  timeZone?: InputMaybe<Order_By>;
  tolerance?: InputMaybe<Order_By>;
  tunnelBoringMachineName?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userPermissions_aggregate?: InputMaybe<UserPermission_Aggregate_Order_By>;
  userQualityRoles_aggregate?: InputMaybe<Quality_UserQualityRole_Aggregate_Order_By>;
};

/** primary key columns input for table: constructionSite */
export type ConstructionSite_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "constructionSite" */
export enum ConstructionSite_Select_Column {
  /** column name */
  AggregatedReportActivityLevel = 'aggregatedReportActivityLevel',
  /** column name */
  AutofillApiId = 'autofillApiId',
  /** column name */
  AutofillOpcuaEmptyRangeTolerance = 'autofillOpcuaEmptyRangeTolerance',
  /** column name */
  AutofillOpcuaEnabled = 'autofillOpcuaEnabled',
  /** column name */
  BestBuildThreshold = 'bestBuildThreshold',
  /** column name */
  BestExcavationThreshold = 'bestExcavationThreshold',
  /** column name */
  DistanceUnit = 'distanceUnit',
  /** column name */
  HaveRingZero = 'haveRingZero',
  /** column name */
  Id = 'id',
  /** column name */
  IsArticulated = 'isArticulated',
  /** column name */
  IsAutofillEnabled = 'isAutofillEnabled',
  /** column name */
  IsCompleted = 'isCompleted',
  /** column name */
  IsEngineerRequiredInReport = 'isEngineerRequiredInReport',
  /** column name */
  IsManagerRequiredInReport = 'isManagerRequiredInReport',
  /** column name */
  IsQualityValidatorActivated = 'isQualityValidatorActivated',
  /** column name */
  KeyPositionPrefix = 'keyPositionPrefix',
  /** column name */
  Language = 'language',
  /** column name */
  Logo = 'logo',
  /** column name */
  ManagerValidationRequired = 'managerValidationRequired',
  /** column name */
  Name = 'name',
  /** column name */
  NbDaysPerWeek = 'nbDaysPerWeek',
  /** column name */
  NbKeyPosition = 'nbKeyPosition',
  /** column name */
  NbTotalMeters = 'nbTotalMeters',
  /** column name */
  NbTotalRings = 'nbTotalRings',
  /** column name */
  Opcua = 'opcua',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  RingLengthCode0 = 'ringLengthCode0',
  /** column name */
  RingLengthCode1 = 'ringLengthCode1',
  /** column name */
  TimeZone = 'timeZone',
  /** column name */
  Tolerance = 'tolerance',
  /** column name */
  TunnelBoringMachineName = 'tunnelBoringMachineName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "constructionSite_aggregate_bool_exp_bool_and_arguments_columns" columns of table "constructionSite" */
export enum ConstructionSite_Select_Column_ConstructionSite_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AutofillOpcuaEnabled = 'autofillOpcuaEnabled',
  /** column name */
  HaveRingZero = 'haveRingZero',
  /** column name */
  IsArticulated = 'isArticulated',
  /** column name */
  IsAutofillEnabled = 'isAutofillEnabled',
  /** column name */
  IsCompleted = 'isCompleted',
  /** column name */
  IsEngineerRequiredInReport = 'isEngineerRequiredInReport',
  /** column name */
  IsManagerRequiredInReport = 'isManagerRequiredInReport',
  /** column name */
  IsQualityValidatorActivated = 'isQualityValidatorActivated',
  /** column name */
  ManagerValidationRequired = 'managerValidationRequired'
}

/** select "constructionSite_aggregate_bool_exp_bool_or_arguments_columns" columns of table "constructionSite" */
export enum ConstructionSite_Select_Column_ConstructionSite_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AutofillOpcuaEnabled = 'autofillOpcuaEnabled',
  /** column name */
  HaveRingZero = 'haveRingZero',
  /** column name */
  IsArticulated = 'isArticulated',
  /** column name */
  IsAutofillEnabled = 'isAutofillEnabled',
  /** column name */
  IsCompleted = 'isCompleted',
  /** column name */
  IsEngineerRequiredInReport = 'isEngineerRequiredInReport',
  /** column name */
  IsManagerRequiredInReport = 'isManagerRequiredInReport',
  /** column name */
  IsQualityValidatorActivated = 'isQualityValidatorActivated',
  /** column name */
  ManagerValidationRequired = 'managerValidationRequired'
}

/** input type for updating data in table "constructionSite" */
export type ConstructionSite_Set_Input = {
  aggregatedReportActivityLevel?: InputMaybe<Scalars['Int']['input']>;
  autofillApiId?: InputMaybe<Scalars['uuid']['input']>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Scalars['Int']['input']>;
  autofillOpcuaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  bestBuildThreshold?: InputMaybe<Scalars['Int']['input']>;
  bestExcavationThreshold?: InputMaybe<Scalars['Int']['input']>;
  distanceUnit?: InputMaybe<Scalars['String']['input']>;
  haveRingZero?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArticulated?: InputMaybe<Scalars['Boolean']['input']>;
  isAutofillEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isEngineerRequiredInReport?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerRequiredInReport?: InputMaybe<Scalars['Boolean']['input']>;
  isQualityValidatorActivated?: InputMaybe<Scalars['Boolean']['input']>;
  keyPositionPrefix?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  managerValidationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nbDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  nbKeyPosition?: InputMaybe<Scalars['Int']['input']>;
  nbTotalMeters?: InputMaybe<Scalars['numeric']['input']>;
  nbTotalRings?: InputMaybe<Scalars['Int']['input']>;
  opcua?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  ringLengthCode0?: InputMaybe<Scalars['numeric']['input']>;
  ringLengthCode1?: InputMaybe<Scalars['numeric']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  tolerance?: InputMaybe<Scalars['Int']['input']>;
  tunnelBoringMachineName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type ConstructionSite_Stddev_Fields = {
  __typename?: 'constructionSite_stddev_fields';
  aggregatedReportActivityLevel?: Maybe<Scalars['Float']['output']>;
  autofillOpcuaEmptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  bestBuildThreshold?: Maybe<Scalars['Float']['output']>;
  bestExcavationThreshold?: Maybe<Scalars['Float']['output']>;
  nbDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  nbKeyPosition?: Maybe<Scalars['Float']['output']>;
  nbTotalMeters?: Maybe<Scalars['Float']['output']>;
  nbTotalRings?: Maybe<Scalars['Float']['output']>;
  ringLengthCode0?: Maybe<Scalars['Float']['output']>;
  ringLengthCode1?: Maybe<Scalars['Float']['output']>;
  tolerance?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "constructionSite" */
export type ConstructionSite_Stddev_Order_By = {
  aggregatedReportActivityLevel?: InputMaybe<Order_By>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Order_By>;
  bestBuildThreshold?: InputMaybe<Order_By>;
  bestExcavationThreshold?: InputMaybe<Order_By>;
  nbDaysPerWeek?: InputMaybe<Order_By>;
  nbKeyPosition?: InputMaybe<Order_By>;
  nbTotalMeters?: InputMaybe<Order_By>;
  nbTotalRings?: InputMaybe<Order_By>;
  ringLengthCode0?: InputMaybe<Order_By>;
  ringLengthCode1?: InputMaybe<Order_By>;
  tolerance?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ConstructionSite_Stddev_Pop_Fields = {
  __typename?: 'constructionSite_stddev_pop_fields';
  aggregatedReportActivityLevel?: Maybe<Scalars['Float']['output']>;
  autofillOpcuaEmptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  bestBuildThreshold?: Maybe<Scalars['Float']['output']>;
  bestExcavationThreshold?: Maybe<Scalars['Float']['output']>;
  nbDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  nbKeyPosition?: Maybe<Scalars['Float']['output']>;
  nbTotalMeters?: Maybe<Scalars['Float']['output']>;
  nbTotalRings?: Maybe<Scalars['Float']['output']>;
  ringLengthCode0?: Maybe<Scalars['Float']['output']>;
  ringLengthCode1?: Maybe<Scalars['Float']['output']>;
  tolerance?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "constructionSite" */
export type ConstructionSite_Stddev_Pop_Order_By = {
  aggregatedReportActivityLevel?: InputMaybe<Order_By>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Order_By>;
  bestBuildThreshold?: InputMaybe<Order_By>;
  bestExcavationThreshold?: InputMaybe<Order_By>;
  nbDaysPerWeek?: InputMaybe<Order_By>;
  nbKeyPosition?: InputMaybe<Order_By>;
  nbTotalMeters?: InputMaybe<Order_By>;
  nbTotalRings?: InputMaybe<Order_By>;
  ringLengthCode0?: InputMaybe<Order_By>;
  ringLengthCode1?: InputMaybe<Order_By>;
  tolerance?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ConstructionSite_Stddev_Samp_Fields = {
  __typename?: 'constructionSite_stddev_samp_fields';
  aggregatedReportActivityLevel?: Maybe<Scalars['Float']['output']>;
  autofillOpcuaEmptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  bestBuildThreshold?: Maybe<Scalars['Float']['output']>;
  bestExcavationThreshold?: Maybe<Scalars['Float']['output']>;
  nbDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  nbKeyPosition?: Maybe<Scalars['Float']['output']>;
  nbTotalMeters?: Maybe<Scalars['Float']['output']>;
  nbTotalRings?: Maybe<Scalars['Float']['output']>;
  ringLengthCode0?: Maybe<Scalars['Float']['output']>;
  ringLengthCode1?: Maybe<Scalars['Float']['output']>;
  tolerance?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "constructionSite" */
export type ConstructionSite_Stddev_Samp_Order_By = {
  aggregatedReportActivityLevel?: InputMaybe<Order_By>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Order_By>;
  bestBuildThreshold?: InputMaybe<Order_By>;
  bestExcavationThreshold?: InputMaybe<Order_By>;
  nbDaysPerWeek?: InputMaybe<Order_By>;
  nbKeyPosition?: InputMaybe<Order_By>;
  nbTotalMeters?: InputMaybe<Order_By>;
  nbTotalRings?: InputMaybe<Order_By>;
  ringLengthCode0?: InputMaybe<Order_By>;
  ringLengthCode1?: InputMaybe<Order_By>;
  tolerance?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "constructionSite" */
export type ConstructionSite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ConstructionSite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ConstructionSite_Stream_Cursor_Value_Input = {
  aggregatedReportActivityLevel?: InputMaybe<Scalars['Int']['input']>;
  autofillApiId?: InputMaybe<Scalars['uuid']['input']>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Scalars['Int']['input']>;
  autofillOpcuaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  bestBuildThreshold?: InputMaybe<Scalars['Int']['input']>;
  bestExcavationThreshold?: InputMaybe<Scalars['Int']['input']>;
  distanceUnit?: InputMaybe<Scalars['String']['input']>;
  haveRingZero?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArticulated?: InputMaybe<Scalars['Boolean']['input']>;
  isAutofillEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isEngineerRequiredInReport?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerRequiredInReport?: InputMaybe<Scalars['Boolean']['input']>;
  isQualityValidatorActivated?: InputMaybe<Scalars['Boolean']['input']>;
  keyPositionPrefix?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  managerValidationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nbDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  nbKeyPosition?: InputMaybe<Scalars['Int']['input']>;
  nbTotalMeters?: InputMaybe<Scalars['numeric']['input']>;
  nbTotalRings?: InputMaybe<Scalars['Int']['input']>;
  opcua?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  ringLengthCode0?: InputMaybe<Scalars['numeric']['input']>;
  ringLengthCode1?: InputMaybe<Scalars['numeric']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  tolerance?: InputMaybe<Scalars['Int']['input']>;
  tunnelBoringMachineName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type ConstructionSite_Sum_Fields = {
  __typename?: 'constructionSite_sum_fields';
  aggregatedReportActivityLevel?: Maybe<Scalars['Int']['output']>;
  autofillOpcuaEmptyRangeTolerance?: Maybe<Scalars['Int']['output']>;
  bestBuildThreshold?: Maybe<Scalars['Int']['output']>;
  bestExcavationThreshold?: Maybe<Scalars['Int']['output']>;
  nbDaysPerWeek?: Maybe<Scalars['Int']['output']>;
  nbKeyPosition?: Maybe<Scalars['Int']['output']>;
  nbTotalMeters?: Maybe<Scalars['numeric']['output']>;
  nbTotalRings?: Maybe<Scalars['Int']['output']>;
  ringLengthCode0?: Maybe<Scalars['numeric']['output']>;
  ringLengthCode1?: Maybe<Scalars['numeric']['output']>;
  tolerance?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "constructionSite" */
export type ConstructionSite_Sum_Order_By = {
  aggregatedReportActivityLevel?: InputMaybe<Order_By>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Order_By>;
  bestBuildThreshold?: InputMaybe<Order_By>;
  bestExcavationThreshold?: InputMaybe<Order_By>;
  nbDaysPerWeek?: InputMaybe<Order_By>;
  nbKeyPosition?: InputMaybe<Order_By>;
  nbTotalMeters?: InputMaybe<Order_By>;
  nbTotalRings?: InputMaybe<Order_By>;
  ringLengthCode0?: InputMaybe<Order_By>;
  ringLengthCode1?: InputMaybe<Order_By>;
  tolerance?: InputMaybe<Order_By>;
};

/** update columns of table "constructionSite" */
export enum ConstructionSite_Update_Column {
  /** column name */
  AggregatedReportActivityLevel = 'aggregatedReportActivityLevel',
  /** column name */
  AutofillApiId = 'autofillApiId',
  /** column name */
  AutofillOpcuaEmptyRangeTolerance = 'autofillOpcuaEmptyRangeTolerance',
  /** column name */
  AutofillOpcuaEnabled = 'autofillOpcuaEnabled',
  /** column name */
  BestBuildThreshold = 'bestBuildThreshold',
  /** column name */
  BestExcavationThreshold = 'bestExcavationThreshold',
  /** column name */
  DistanceUnit = 'distanceUnit',
  /** column name */
  HaveRingZero = 'haveRingZero',
  /** column name */
  Id = 'id',
  /** column name */
  IsArticulated = 'isArticulated',
  /** column name */
  IsAutofillEnabled = 'isAutofillEnabled',
  /** column name */
  IsCompleted = 'isCompleted',
  /** column name */
  IsEngineerRequiredInReport = 'isEngineerRequiredInReport',
  /** column name */
  IsManagerRequiredInReport = 'isManagerRequiredInReport',
  /** column name */
  IsQualityValidatorActivated = 'isQualityValidatorActivated',
  /** column name */
  KeyPositionPrefix = 'keyPositionPrefix',
  /** column name */
  Language = 'language',
  /** column name */
  Logo = 'logo',
  /** column name */
  ManagerValidationRequired = 'managerValidationRequired',
  /** column name */
  Name = 'name',
  /** column name */
  NbDaysPerWeek = 'nbDaysPerWeek',
  /** column name */
  NbKeyPosition = 'nbKeyPosition',
  /** column name */
  NbTotalMeters = 'nbTotalMeters',
  /** column name */
  NbTotalRings = 'nbTotalRings',
  /** column name */
  Opcua = 'opcua',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  RingLengthCode0 = 'ringLengthCode0',
  /** column name */
  RingLengthCode1 = 'ringLengthCode1',
  /** column name */
  TimeZone = 'timeZone',
  /** column name */
  Tolerance = 'tolerance',
  /** column name */
  TunnelBoringMachineName = 'tunnelBoringMachineName',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ConstructionSite_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ConstructionSite_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConstructionSite_Set_Input>;
  /** filter the rows which have to be updated */
  where: ConstructionSite_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ConstructionSite_Var_Pop_Fields = {
  __typename?: 'constructionSite_var_pop_fields';
  aggregatedReportActivityLevel?: Maybe<Scalars['Float']['output']>;
  autofillOpcuaEmptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  bestBuildThreshold?: Maybe<Scalars['Float']['output']>;
  bestExcavationThreshold?: Maybe<Scalars['Float']['output']>;
  nbDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  nbKeyPosition?: Maybe<Scalars['Float']['output']>;
  nbTotalMeters?: Maybe<Scalars['Float']['output']>;
  nbTotalRings?: Maybe<Scalars['Float']['output']>;
  ringLengthCode0?: Maybe<Scalars['Float']['output']>;
  ringLengthCode1?: Maybe<Scalars['Float']['output']>;
  tolerance?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "constructionSite" */
export type ConstructionSite_Var_Pop_Order_By = {
  aggregatedReportActivityLevel?: InputMaybe<Order_By>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Order_By>;
  bestBuildThreshold?: InputMaybe<Order_By>;
  bestExcavationThreshold?: InputMaybe<Order_By>;
  nbDaysPerWeek?: InputMaybe<Order_By>;
  nbKeyPosition?: InputMaybe<Order_By>;
  nbTotalMeters?: InputMaybe<Order_By>;
  nbTotalRings?: InputMaybe<Order_By>;
  ringLengthCode0?: InputMaybe<Order_By>;
  ringLengthCode1?: InputMaybe<Order_By>;
  tolerance?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ConstructionSite_Var_Samp_Fields = {
  __typename?: 'constructionSite_var_samp_fields';
  aggregatedReportActivityLevel?: Maybe<Scalars['Float']['output']>;
  autofillOpcuaEmptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  bestBuildThreshold?: Maybe<Scalars['Float']['output']>;
  bestExcavationThreshold?: Maybe<Scalars['Float']['output']>;
  nbDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  nbKeyPosition?: Maybe<Scalars['Float']['output']>;
  nbTotalMeters?: Maybe<Scalars['Float']['output']>;
  nbTotalRings?: Maybe<Scalars['Float']['output']>;
  ringLengthCode0?: Maybe<Scalars['Float']['output']>;
  ringLengthCode1?: Maybe<Scalars['Float']['output']>;
  tolerance?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "constructionSite" */
export type ConstructionSite_Var_Samp_Order_By = {
  aggregatedReportActivityLevel?: InputMaybe<Order_By>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Order_By>;
  bestBuildThreshold?: InputMaybe<Order_By>;
  bestExcavationThreshold?: InputMaybe<Order_By>;
  nbDaysPerWeek?: InputMaybe<Order_By>;
  nbKeyPosition?: InputMaybe<Order_By>;
  nbTotalMeters?: InputMaybe<Order_By>;
  nbTotalRings?: InputMaybe<Order_By>;
  ringLengthCode0?: InputMaybe<Order_By>;
  ringLengthCode1?: InputMaybe<Order_By>;
  tolerance?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ConstructionSite_Variance_Fields = {
  __typename?: 'constructionSite_variance_fields';
  aggregatedReportActivityLevel?: Maybe<Scalars['Float']['output']>;
  autofillOpcuaEmptyRangeTolerance?: Maybe<Scalars['Float']['output']>;
  bestBuildThreshold?: Maybe<Scalars['Float']['output']>;
  bestExcavationThreshold?: Maybe<Scalars['Float']['output']>;
  nbDaysPerWeek?: Maybe<Scalars['Float']['output']>;
  nbKeyPosition?: Maybe<Scalars['Float']['output']>;
  nbTotalMeters?: Maybe<Scalars['Float']['output']>;
  nbTotalRings?: Maybe<Scalars['Float']['output']>;
  ringLengthCode0?: Maybe<Scalars['Float']['output']>;
  ringLengthCode1?: Maybe<Scalars['Float']['output']>;
  tolerance?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "constructionSite" */
export type ConstructionSite_Variance_Order_By = {
  aggregatedReportActivityLevel?: InputMaybe<Order_By>;
  autofillOpcuaEmptyRangeTolerance?: InputMaybe<Order_By>;
  bestBuildThreshold?: InputMaybe<Order_By>;
  bestExcavationThreshold?: InputMaybe<Order_By>;
  nbDaysPerWeek?: InputMaybe<Order_By>;
  nbKeyPosition?: InputMaybe<Order_By>;
  nbTotalMeters?: InputMaybe<Order_By>;
  nbTotalRings?: InputMaybe<Order_By>;
  ringLengthCode0?: InputMaybe<Order_By>;
  ringLengthCode1?: InputMaybe<Order_By>;
  tolerance?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "dailyShiftTemplate" */
export type DailyShiftTemplate = {
  __typename?: 'dailyShiftTemplate';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  day: Scalars['day_enum']['output'];
  durationShift1?: Maybe<Scalars['time']['output']>;
  durationShift2?: Maybe<Scalars['time']['output']>;
  durationShift3?: Maybe<Scalars['time']['output']>;
  id: Scalars['uuid']['output'];
  isProductionDay: Scalars['Boolean']['output'];
  /** A computed field, executes function "count_defined_shifts" */
  nbEnabledShifts?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['time']['output'];
};

/** aggregated selection of "dailyShiftTemplate" */
export type DailyShiftTemplate_Aggregate = {
  __typename?: 'dailyShiftTemplate_aggregate';
  aggregate?: Maybe<DailyShiftTemplate_Aggregate_Fields>;
  nodes: Array<DailyShiftTemplate>;
};

/** aggregate fields of "dailyShiftTemplate" */
export type DailyShiftTemplate_Aggregate_Fields = {
  __typename?: 'dailyShiftTemplate_aggregate_fields';
  avg?: Maybe<DailyShiftTemplate_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<DailyShiftTemplate_Max_Fields>;
  min?: Maybe<DailyShiftTemplate_Min_Fields>;
  stddev?: Maybe<DailyShiftTemplate_Stddev_Fields>;
  stddev_pop?: Maybe<DailyShiftTemplate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<DailyShiftTemplate_Stddev_Samp_Fields>;
  sum?: Maybe<DailyShiftTemplate_Sum_Fields>;
  var_pop?: Maybe<DailyShiftTemplate_Var_Pop_Fields>;
  var_samp?: Maybe<DailyShiftTemplate_Var_Samp_Fields>;
  variance?: Maybe<DailyShiftTemplate_Variance_Fields>;
};


/** aggregate fields of "dailyShiftTemplate" */
export type DailyShiftTemplate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DailyShiftTemplate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type DailyShiftTemplate_Avg_Fields = {
  __typename?: 'dailyShiftTemplate_avg_fields';
  /** A computed field, executes function "count_defined_shifts" */
  nbEnabledShifts?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to filter rows from the table "dailyShiftTemplate". All fields are combined with a logical 'AND'. */
export type DailyShiftTemplate_Bool_Exp = {
  _and?: InputMaybe<Array<DailyShiftTemplate_Bool_Exp>>;
  _not?: InputMaybe<DailyShiftTemplate_Bool_Exp>;
  _or?: InputMaybe<Array<DailyShiftTemplate_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  day?: InputMaybe<Day_Enum_Comparison_Exp>;
  durationShift1?: InputMaybe<Time_Comparison_Exp>;
  durationShift2?: InputMaybe<Time_Comparison_Exp>;
  durationShift3?: InputMaybe<Time_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isProductionDay?: InputMaybe<Boolean_Comparison_Exp>;
  nbEnabledShifts?: InputMaybe<Int_Comparison_Exp>;
  startTime?: InputMaybe<Time_Comparison_Exp>;
};

/** unique or primary key constraints on table "dailyShiftTemplate" */
export enum DailyShiftTemplate_Constraint {
  /** unique or primary key constraint on columns "id" */
  DailyShiftTemplatePkey = 'dailyShiftTemplate_pkey',
  /** unique or primary key constraint on columns "constructionSiteId", "day" */
  UniqueSiteDay = 'unique_site_day'
}

/** input type for inserting data into table "dailyShiftTemplate" */
export type DailyShiftTemplate_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  day?: InputMaybe<Scalars['day_enum']['input']>;
  durationShift1?: InputMaybe<Scalars['time']['input']>;
  durationShift2?: InputMaybe<Scalars['time']['input']>;
  durationShift3?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isProductionDay?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['time']['input']>;
};

/** aggregate max on columns */
export type DailyShiftTemplate_Max_Fields = {
  __typename?: 'dailyShiftTemplate_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  day?: Maybe<Scalars['day_enum']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "count_defined_shifts" */
  nbEnabledShifts?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type DailyShiftTemplate_Min_Fields = {
  __typename?: 'dailyShiftTemplate_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  day?: Maybe<Scalars['day_enum']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "count_defined_shifts" */
  nbEnabledShifts?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "dailyShiftTemplate" */
export type DailyShiftTemplate_Mutation_Response = {
  __typename?: 'dailyShiftTemplate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DailyShiftTemplate>;
};

/** on_conflict condition type for table "dailyShiftTemplate" */
export type DailyShiftTemplate_On_Conflict = {
  constraint: DailyShiftTemplate_Constraint;
  update_columns?: Array<DailyShiftTemplate_Update_Column>;
  where?: InputMaybe<DailyShiftTemplate_Bool_Exp>;
};

/** Ordering options when selecting data from "dailyShiftTemplate". */
export type DailyShiftTemplate_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  durationShift1?: InputMaybe<Order_By>;
  durationShift2?: InputMaybe<Order_By>;
  durationShift3?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isProductionDay?: InputMaybe<Order_By>;
  nbEnabledShifts?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dailyShiftTemplate */
export type DailyShiftTemplate_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "dailyShiftTemplate" */
export enum DailyShiftTemplate_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Day = 'day',
  /** column name */
  DurationShift1 = 'durationShift1',
  /** column name */
  DurationShift2 = 'durationShift2',
  /** column name */
  DurationShift3 = 'durationShift3',
  /** column name */
  Id = 'id',
  /** column name */
  IsProductionDay = 'isProductionDay',
  /** column name */
  StartTime = 'startTime'
}

/** input type for updating data in table "dailyShiftTemplate" */
export type DailyShiftTemplate_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  day?: InputMaybe<Scalars['day_enum']['input']>;
  durationShift1?: InputMaybe<Scalars['time']['input']>;
  durationShift2?: InputMaybe<Scalars['time']['input']>;
  durationShift3?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isProductionDay?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['time']['input']>;
};

/** aggregate stddev on columns */
export type DailyShiftTemplate_Stddev_Fields = {
  __typename?: 'dailyShiftTemplate_stddev_fields';
  /** A computed field, executes function "count_defined_shifts" */
  nbEnabledShifts?: Maybe<Scalars['Int']['output']>;
};

/** aggregate stddev_pop on columns */
export type DailyShiftTemplate_Stddev_Pop_Fields = {
  __typename?: 'dailyShiftTemplate_stddev_pop_fields';
  /** A computed field, executes function "count_defined_shifts" */
  nbEnabledShifts?: Maybe<Scalars['Int']['output']>;
};

/** aggregate stddev_samp on columns */
export type DailyShiftTemplate_Stddev_Samp_Fields = {
  __typename?: 'dailyShiftTemplate_stddev_samp_fields';
  /** A computed field, executes function "count_defined_shifts" */
  nbEnabledShifts?: Maybe<Scalars['Int']['output']>;
};

/** Streaming cursor of the table "dailyShiftTemplate" */
export type DailyShiftTemplate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DailyShiftTemplate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DailyShiftTemplate_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  day?: InputMaybe<Scalars['day_enum']['input']>;
  durationShift1?: InputMaybe<Scalars['time']['input']>;
  durationShift2?: InputMaybe<Scalars['time']['input']>;
  durationShift3?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isProductionDay?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['time']['input']>;
};

/** aggregate sum on columns */
export type DailyShiftTemplate_Sum_Fields = {
  __typename?: 'dailyShiftTemplate_sum_fields';
  /** A computed field, executes function "count_defined_shifts" */
  nbEnabledShifts?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "dailyShiftTemplate" */
export enum DailyShiftTemplate_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Day = 'day',
  /** column name */
  DurationShift1 = 'durationShift1',
  /** column name */
  DurationShift2 = 'durationShift2',
  /** column name */
  DurationShift3 = 'durationShift3',
  /** column name */
  Id = 'id',
  /** column name */
  IsProductionDay = 'isProductionDay',
  /** column name */
  StartTime = 'startTime'
}

export type DailyShiftTemplate_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DailyShiftTemplate_Set_Input>;
  /** filter the rows which have to be updated */
  where: DailyShiftTemplate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type DailyShiftTemplate_Var_Pop_Fields = {
  __typename?: 'dailyShiftTemplate_var_pop_fields';
  /** A computed field, executes function "count_defined_shifts" */
  nbEnabledShifts?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_samp on columns */
export type DailyShiftTemplate_Var_Samp_Fields = {
  __typename?: 'dailyShiftTemplate_var_samp_fields';
  /** A computed field, executes function "count_defined_shifts" */
  nbEnabledShifts?: Maybe<Scalars['Int']['output']>;
};

/** aggregate variance on columns */
export type DailyShiftTemplate_Variance_Fields = {
  __typename?: 'dailyShiftTemplate_variance_fields';
  /** A computed field, executes function "count_defined_shifts" */
  nbEnabledShifts?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** Boolean expression to compare columns of type "day_enum". All fields are combined with logical 'AND'. */
export type Day_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['day_enum']['input']>;
  _gt?: InputMaybe<Scalars['day_enum']['input']>;
  _gte?: InputMaybe<Scalars['day_enum']['input']>;
  _in?: InputMaybe<Array<Scalars['day_enum']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['day_enum']['input']>;
  _lte?: InputMaybe<Scalars['day_enum']['input']>;
  _neq?: InputMaybe<Scalars['day_enum']['input']>;
  _nin?: InputMaybe<Array<Scalars['day_enum']['input']>>;
};

/** columns and relationships of "file.bucketFile" */
export type File_BucketFile = {
  __typename?: 'file_bucketFile';
  bucketType: File_BucketTypeEnum_Enum;
  id: Scalars['uuid']['output'];
  mimeType: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

/** aggregated selection of "file.bucketFile" */
export type File_BucketFile_Aggregate = {
  __typename?: 'file_bucketFile_aggregate';
  aggregate?: Maybe<File_BucketFile_Aggregate_Fields>;
  nodes: Array<File_BucketFile>;
};

/** aggregate fields of "file.bucketFile" */
export type File_BucketFile_Aggregate_Fields = {
  __typename?: 'file_bucketFile_aggregate_fields';
  avg?: Maybe<File_BucketFile_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<File_BucketFile_Max_Fields>;
  min?: Maybe<File_BucketFile_Min_Fields>;
  stddev?: Maybe<File_BucketFile_Stddev_Fields>;
  stddev_pop?: Maybe<File_BucketFile_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<File_BucketFile_Stddev_Samp_Fields>;
  sum?: Maybe<File_BucketFile_Sum_Fields>;
  var_pop?: Maybe<File_BucketFile_Var_Pop_Fields>;
  var_samp?: Maybe<File_BucketFile_Var_Samp_Fields>;
  variance?: Maybe<File_BucketFile_Variance_Fields>;
};


/** aggregate fields of "file.bucketFile" */
export type File_BucketFile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_BucketFile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type File_BucketFile_Avg_Fields = {
  __typename?: 'file_bucketFile_avg_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "file.bucketFile". All fields are combined with a logical 'AND'. */
export type File_BucketFile_Bool_Exp = {
  _and?: InputMaybe<Array<File_BucketFile_Bool_Exp>>;
  _not?: InputMaybe<File_BucketFile_Bool_Exp>;
  _or?: InputMaybe<Array<File_BucketFile_Bool_Exp>>;
  bucketType?: InputMaybe<File_BucketTypeEnum_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mimeType?: InputMaybe<String_Comparison_Exp>;
  path?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "file.bucketFile" */
export enum File_BucketFile_Constraint {
  /** unique or primary key constraint on columns "id" */
  BucketFilePkey = 'bucketFile_pkey'
}

/** input type for incrementing numeric columns in table "file.bucketFile" */
export type File_BucketFile_Inc_Input = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "file.bucketFile" */
export type File_BucketFile_Insert_Input = {
  bucketType?: InputMaybe<File_BucketTypeEnum_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type File_BucketFile_Max_Fields = {
  __typename?: 'file_bucketFile_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type File_BucketFile_Min_Fields = {
  __typename?: 'file_bucketFile_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "file.bucketFile" */
export type File_BucketFile_Mutation_Response = {
  __typename?: 'file_bucketFile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<File_BucketFile>;
};

/** on_conflict condition type for table "file.bucketFile" */
export type File_BucketFile_On_Conflict = {
  constraint: File_BucketFile_Constraint;
  update_columns?: Array<File_BucketFile_Update_Column>;
  where?: InputMaybe<File_BucketFile_Bool_Exp>;
};

/** Ordering options when selecting data from "file.bucketFile". */
export type File_BucketFile_Order_By = {
  bucketType?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** primary key columns input for table: file.bucketFile */
export type File_BucketFile_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "file.bucketFile" */
export enum File_BucketFile_Select_Column {
  /** column name */
  BucketType = 'bucketType',
  /** column name */
  Id = 'id',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Path = 'path',
  /** column name */
  Size = 'size'
}

/** input type for updating data in table "file.bucketFile" */
export type File_BucketFile_Set_Input = {
  bucketType?: InputMaybe<File_BucketTypeEnum_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type File_BucketFile_Stddev_Fields = {
  __typename?: 'file_bucketFile_stddev_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type File_BucketFile_Stddev_Pop_Fields = {
  __typename?: 'file_bucketFile_stddev_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type File_BucketFile_Stddev_Samp_Fields = {
  __typename?: 'file_bucketFile_stddev_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "file_bucketFile" */
export type File_BucketFile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_BucketFile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_BucketFile_Stream_Cursor_Value_Input = {
  bucketType?: InputMaybe<File_BucketTypeEnum_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type File_BucketFile_Sum_Fields = {
  __typename?: 'file_bucketFile_sum_fields';
  size?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "file.bucketFile" */
export enum File_BucketFile_Update_Column {
  /** column name */
  BucketType = 'bucketType',
  /** column name */
  Id = 'id',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Path = 'path',
  /** column name */
  Size = 'size'
}

export type File_BucketFile_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<File_BucketFile_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<File_BucketFile_Set_Input>;
  /** filter the rows which have to be updated */
  where: File_BucketFile_Bool_Exp;
};

/** aggregate var_pop on columns */
export type File_BucketFile_Var_Pop_Fields = {
  __typename?: 'file_bucketFile_var_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type File_BucketFile_Var_Samp_Fields = {
  __typename?: 'file_bucketFile_var_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type File_BucketFile_Variance_Fields = {
  __typename?: 'file_bucketFile_variance_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "file.bucketTypeEnum" */
export type File_BucketTypeEnum = {
  __typename?: 'file_bucketTypeEnum';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

/** aggregated selection of "file.bucketTypeEnum" */
export type File_BucketTypeEnum_Aggregate = {
  __typename?: 'file_bucketTypeEnum_aggregate';
  aggregate?: Maybe<File_BucketTypeEnum_Aggregate_Fields>;
  nodes: Array<File_BucketTypeEnum>;
};

/** aggregate fields of "file.bucketTypeEnum" */
export type File_BucketTypeEnum_Aggregate_Fields = {
  __typename?: 'file_bucketTypeEnum_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<File_BucketTypeEnum_Max_Fields>;
  min?: Maybe<File_BucketTypeEnum_Min_Fields>;
};


/** aggregate fields of "file.bucketTypeEnum" */
export type File_BucketTypeEnum_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_BucketTypeEnum_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "file.bucketTypeEnum". All fields are combined with a logical 'AND'. */
export type File_BucketTypeEnum_Bool_Exp = {
  _and?: InputMaybe<Array<File_BucketTypeEnum_Bool_Exp>>;
  _not?: InputMaybe<File_BucketTypeEnum_Bool_Exp>;
  _or?: InputMaybe<Array<File_BucketTypeEnum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "file.bucketTypeEnum" */
export enum File_BucketTypeEnum_Constraint {
  /** unique or primary key constraint on columns "id" */
  BucketTypeEnumPkey = 'bucketTypeEnum_pkey'
}

export enum File_BucketTypeEnum_Enum {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** Boolean expression to compare columns of type "file_bucketTypeEnum_enum". All fields are combined with logical 'AND'. */
export type File_BucketTypeEnum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<File_BucketTypeEnum_Enum>;
  _in?: InputMaybe<Array<File_BucketTypeEnum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<File_BucketTypeEnum_Enum>;
  _nin?: InputMaybe<Array<File_BucketTypeEnum_Enum>>;
};

/** input type for inserting data into table "file.bucketTypeEnum" */
export type File_BucketTypeEnum_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type File_BucketTypeEnum_Max_Fields = {
  __typename?: 'file_bucketTypeEnum_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type File_BucketTypeEnum_Min_Fields = {
  __typename?: 'file_bucketTypeEnum_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "file.bucketTypeEnum" */
export type File_BucketTypeEnum_Mutation_Response = {
  __typename?: 'file_bucketTypeEnum_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<File_BucketTypeEnum>;
};

/** on_conflict condition type for table "file.bucketTypeEnum" */
export type File_BucketTypeEnum_On_Conflict = {
  constraint: File_BucketTypeEnum_Constraint;
  update_columns?: Array<File_BucketTypeEnum_Update_Column>;
  where?: InputMaybe<File_BucketTypeEnum_Bool_Exp>;
};

/** Ordering options when selecting data from "file.bucketTypeEnum". */
export type File_BucketTypeEnum_Order_By = {
  comment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: file.bucketTypeEnum */
export type File_BucketTypeEnum_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "file.bucketTypeEnum" */
export enum File_BucketTypeEnum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "file.bucketTypeEnum" */
export type File_BucketTypeEnum_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "file_bucketTypeEnum" */
export type File_BucketTypeEnum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_BucketTypeEnum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_BucketTypeEnum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "file.bucketTypeEnum" */
export enum File_BucketTypeEnum_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

export type File_BucketTypeEnum_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<File_BucketTypeEnum_Set_Input>;
  /** filter the rows which have to be updated */
  where: File_BucketTypeEnum_Bool_Exp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "graphSet" */
export type GraphSet = {
  __typename?: 'graphSet';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  graphs: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  title: Scalars['String']['output'];
  type: GraphSetTypeEnum_Enum;
  /** An object relationship */
  user: User;
  userId: Scalars['uuid']['output'];
  version: Scalars['Int']['output'];
};


/** columns and relationships of "graphSet" */
export type GraphSetGraphsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "graphSetTypeEnum" */
export type GraphSetTypeEnum = {
  __typename?: 'graphSetTypeEnum';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

/** aggregated selection of "graphSetTypeEnum" */
export type GraphSetTypeEnum_Aggregate = {
  __typename?: 'graphSetTypeEnum_aggregate';
  aggregate?: Maybe<GraphSetTypeEnum_Aggregate_Fields>;
  nodes: Array<GraphSetTypeEnum>;
};

/** aggregate fields of "graphSetTypeEnum" */
export type GraphSetTypeEnum_Aggregate_Fields = {
  __typename?: 'graphSetTypeEnum_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<GraphSetTypeEnum_Max_Fields>;
  min?: Maybe<GraphSetTypeEnum_Min_Fields>;
};


/** aggregate fields of "graphSetTypeEnum" */
export type GraphSetTypeEnum_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<GraphSetTypeEnum_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "graphSetTypeEnum". All fields are combined with a logical 'AND'. */
export type GraphSetTypeEnum_Bool_Exp = {
  _and?: InputMaybe<Array<GraphSetTypeEnum_Bool_Exp>>;
  _not?: InputMaybe<GraphSetTypeEnum_Bool_Exp>;
  _or?: InputMaybe<Array<GraphSetTypeEnum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "graphSetTypeEnum" */
export enum GraphSetTypeEnum_Constraint {
  /** unique or primary key constraint on columns "id" */
  GraphSetTypeEnumPkey = 'graphSetTypeEnum_pkey'
}

export enum GraphSetTypeEnum_Enum {
  Period = 'PERIOD',
  Ring = 'RING'
}

/** Boolean expression to compare columns of type "graphSetTypeEnum_enum". All fields are combined with logical 'AND'. */
export type GraphSetTypeEnum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<GraphSetTypeEnum_Enum>;
  _in?: InputMaybe<Array<GraphSetTypeEnum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<GraphSetTypeEnum_Enum>;
  _nin?: InputMaybe<Array<GraphSetTypeEnum_Enum>>;
};

/** input type for inserting data into table "graphSetTypeEnum" */
export type GraphSetTypeEnum_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type GraphSetTypeEnum_Max_Fields = {
  __typename?: 'graphSetTypeEnum_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type GraphSetTypeEnum_Min_Fields = {
  __typename?: 'graphSetTypeEnum_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "graphSetTypeEnum" */
export type GraphSetTypeEnum_Mutation_Response = {
  __typename?: 'graphSetTypeEnum_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GraphSetTypeEnum>;
};

/** on_conflict condition type for table "graphSetTypeEnum" */
export type GraphSetTypeEnum_On_Conflict = {
  constraint: GraphSetTypeEnum_Constraint;
  update_columns?: Array<GraphSetTypeEnum_Update_Column>;
  where?: InputMaybe<GraphSetTypeEnum_Bool_Exp>;
};

/** Ordering options when selecting data from "graphSetTypeEnum". */
export type GraphSetTypeEnum_Order_By = {
  comment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: graphSetTypeEnum */
export type GraphSetTypeEnum_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "graphSetTypeEnum" */
export enum GraphSetTypeEnum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "graphSetTypeEnum" */
export type GraphSetTypeEnum_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "graphSetTypeEnum" */
export type GraphSetTypeEnum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: GraphSetTypeEnum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type GraphSetTypeEnum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "graphSetTypeEnum" */
export enum GraphSetTypeEnum_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

export type GraphSetTypeEnum_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GraphSetTypeEnum_Set_Input>;
  /** filter the rows which have to be updated */
  where: GraphSetTypeEnum_Bool_Exp;
};

/** aggregated selection of "graphSet" */
export type GraphSet_Aggregate = {
  __typename?: 'graphSet_aggregate';
  aggregate?: Maybe<GraphSet_Aggregate_Fields>;
  nodes: Array<GraphSet>;
};

/** aggregate fields of "graphSet" */
export type GraphSet_Aggregate_Fields = {
  __typename?: 'graphSet_aggregate_fields';
  avg?: Maybe<GraphSet_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<GraphSet_Max_Fields>;
  min?: Maybe<GraphSet_Min_Fields>;
  stddev?: Maybe<GraphSet_Stddev_Fields>;
  stddev_pop?: Maybe<GraphSet_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<GraphSet_Stddev_Samp_Fields>;
  sum?: Maybe<GraphSet_Sum_Fields>;
  var_pop?: Maybe<GraphSet_Var_Pop_Fields>;
  var_samp?: Maybe<GraphSet_Var_Samp_Fields>;
  variance?: Maybe<GraphSet_Variance_Fields>;
};


/** aggregate fields of "graphSet" */
export type GraphSet_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<GraphSet_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type GraphSet_Append_Input = {
  graphs?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type GraphSet_Avg_Fields = {
  __typename?: 'graphSet_avg_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "graphSet". All fields are combined with a logical 'AND'. */
export type GraphSet_Bool_Exp = {
  _and?: InputMaybe<Array<GraphSet_Bool_Exp>>;
  _not?: InputMaybe<GraphSet_Bool_Exp>;
  _or?: InputMaybe<Array<GraphSet_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  graphs?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<GraphSetTypeEnum_Enum_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "graphSet" */
export enum GraphSet_Constraint {
  /** unique or primary key constraint on columns "userId", "constructionSiteId", "type", "title" */
  GraphSetConstructionSiteIdUserIdTypeNameKey = 'graphSet_constructionSiteId_userId_type_name_key',
  /** unique or primary key constraint on columns "id" */
  GraphSetPkey = 'graphSet_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type GraphSet_Delete_At_Path_Input = {
  graphs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type GraphSet_Delete_Elem_Input = {
  graphs?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type GraphSet_Delete_Key_Input = {
  graphs?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "graphSet" */
export type GraphSet_Inc_Input = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "graphSet" */
export type GraphSet_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  graphs?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GraphSetTypeEnum_Enum>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type GraphSet_Max_Fields = {
  __typename?: 'graphSet_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type GraphSet_Min_Fields = {
  __typename?: 'graphSet_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "graphSet" */
export type GraphSet_Mutation_Response = {
  __typename?: 'graphSet_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GraphSet>;
};

/** on_conflict condition type for table "graphSet" */
export type GraphSet_On_Conflict = {
  constraint: GraphSet_Constraint;
  update_columns?: Array<GraphSet_Update_Column>;
  where?: InputMaybe<GraphSet_Bool_Exp>;
};

/** Ordering options when selecting data from "graphSet". */
export type GraphSet_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  graphs?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: graphSet */
export type GraphSet_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type GraphSet_Prepend_Input = {
  graphs?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "graphSet" */
export enum GraphSet_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Graphs = 'graphs',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "graphSet" */
export type GraphSet_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  graphs?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GraphSetTypeEnum_Enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type GraphSet_Stddev_Fields = {
  __typename?: 'graphSet_stddev_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type GraphSet_Stddev_Pop_Fields = {
  __typename?: 'graphSet_stddev_pop_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type GraphSet_Stddev_Samp_Fields = {
  __typename?: 'graphSet_stddev_samp_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "graphSet" */
export type GraphSet_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: GraphSet_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type GraphSet_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  graphs?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GraphSetTypeEnum_Enum>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type GraphSet_Sum_Fields = {
  __typename?: 'graphSet_sum_fields';
  version?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "graphSet" */
export enum GraphSet_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Graphs = 'graphs',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'userId',
  /** column name */
  Version = 'version'
}

export type GraphSet_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<GraphSet_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<GraphSet_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<GraphSet_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<GraphSet_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GraphSet_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<GraphSet_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GraphSet_Set_Input>;
  /** filter the rows which have to be updated */
  where: GraphSet_Bool_Exp;
};

/** aggregate var_pop on columns */
export type GraphSet_Var_Pop_Fields = {
  __typename?: 'graphSet_var_pop_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type GraphSet_Var_Samp_Fields = {
  __typename?: 'graphSet_var_samp_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type GraphSet_Variance_Fields = {
  __typename?: 'graphSet_variance_fields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "indicator" */
export type Indicator = {
  __typename?: 'indicator';
  /** An object relationship */
  constructionSite?: Maybe<ConstructionSite>;
  constructionSiteId: Scalars['uuid']['output'];
  formula: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  isDisabled: Scalars['Boolean']['output'];
  nameEn: Scalars['String']['output'];
  nameEs: Scalars['String']['output'];
  nameFr: Scalars['String']['output'];
  showInAggregatedReport: Scalars['Boolean']['output'];
  showInShiftReport: Scalars['Boolean']['output'];
  unit: Scalars['String']['output'];
};

/** aggregated selection of "indicator" */
export type Indicator_Aggregate = {
  __typename?: 'indicator_aggregate';
  aggregate?: Maybe<Indicator_Aggregate_Fields>;
  nodes: Array<Indicator>;
};

/** aggregate fields of "indicator" */
export type Indicator_Aggregate_Fields = {
  __typename?: 'indicator_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Indicator_Max_Fields>;
  min?: Maybe<Indicator_Min_Fields>;
};


/** aggregate fields of "indicator" */
export type Indicator_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Indicator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "indicator". All fields are combined with a logical 'AND'. */
export type Indicator_Bool_Exp = {
  _and?: InputMaybe<Array<Indicator_Bool_Exp>>;
  _not?: InputMaybe<Indicator_Bool_Exp>;
  _or?: InputMaybe<Array<Indicator_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  formula?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isDisabled?: InputMaybe<Boolean_Comparison_Exp>;
  nameEn?: InputMaybe<String_Comparison_Exp>;
  nameEs?: InputMaybe<String_Comparison_Exp>;
  nameFr?: InputMaybe<String_Comparison_Exp>;
  showInAggregatedReport?: InputMaybe<Boolean_Comparison_Exp>;
  showInShiftReport?: InputMaybe<Boolean_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "indicator" */
export enum Indicator_Constraint {
  /** unique or primary key constraint on columns "id" */
  IndicatorPkey = 'indicator_pkey'
}

/** input type for inserting data into table "indicator" */
export type Indicator_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  formula?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameEs?: InputMaybe<Scalars['String']['input']>;
  nameFr?: InputMaybe<Scalars['String']['input']>;
  showInAggregatedReport?: InputMaybe<Scalars['Boolean']['input']>;
  showInShiftReport?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Indicator_Max_Fields = {
  __typename?: 'indicator_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nameEn?: Maybe<Scalars['String']['output']>;
  nameEs?: Maybe<Scalars['String']['output']>;
  nameFr?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Indicator_Min_Fields = {
  __typename?: 'indicator_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nameEn?: Maybe<Scalars['String']['output']>;
  nameEs?: Maybe<Scalars['String']['output']>;
  nameFr?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "indicator" */
export type Indicator_Mutation_Response = {
  __typename?: 'indicator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Indicator>;
};

/** on_conflict condition type for table "indicator" */
export type Indicator_On_Conflict = {
  constraint: Indicator_Constraint;
  update_columns?: Array<Indicator_Update_Column>;
  where?: InputMaybe<Indicator_Bool_Exp>;
};

/** Ordering options when selecting data from "indicator". */
export type Indicator_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  formula?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDisabled?: InputMaybe<Order_By>;
  nameEn?: InputMaybe<Order_By>;
  nameEs?: InputMaybe<Order_By>;
  nameFr?: InputMaybe<Order_By>;
  showInAggregatedReport?: InputMaybe<Order_By>;
  showInShiftReport?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
};

/** primary key columns input for table: indicator */
export type Indicator_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "indicator" */
export enum Indicator_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Formula = 'formula',
  /** column name */
  Id = 'id',
  /** column name */
  IsDisabled = 'isDisabled',
  /** column name */
  NameEn = 'nameEn',
  /** column name */
  NameEs = 'nameEs',
  /** column name */
  NameFr = 'nameFr',
  /** column name */
  ShowInAggregatedReport = 'showInAggregatedReport',
  /** column name */
  ShowInShiftReport = 'showInShiftReport',
  /** column name */
  Unit = 'unit'
}

/** input type for updating data in table "indicator" */
export type Indicator_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  formula?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameEs?: InputMaybe<Scalars['String']['input']>;
  nameFr?: InputMaybe<Scalars['String']['input']>;
  showInAggregatedReport?: InputMaybe<Scalars['Boolean']['input']>;
  showInShiftReport?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "indicator" */
export type Indicator_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Indicator_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Indicator_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  formula?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameEs?: InputMaybe<Scalars['String']['input']>;
  nameFr?: InputMaybe<Scalars['String']['input']>;
  showInAggregatedReport?: InputMaybe<Scalars['Boolean']['input']>;
  showInShiftReport?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "indicator" */
export enum Indicator_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Formula = 'formula',
  /** column name */
  Id = 'id',
  /** column name */
  IsDisabled = 'isDisabled',
  /** column name */
  NameEn = 'nameEn',
  /** column name */
  NameEs = 'nameEs',
  /** column name */
  NameFr = 'nameFr',
  /** column name */
  ShowInAggregatedReport = 'showInAggregatedReport',
  /** column name */
  ShowInShiftReport = 'showInShiftReport',
  /** column name */
  Unit = 'unit'
}

export type Indicator_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Indicator_Set_Input>;
  /** filter the rows which have to be updated */
  where: Indicator_Bool_Exp;
};

/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type Interval_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['interval']['input']>;
  _gt?: InputMaybe<Scalars['interval']['input']>;
  _gte?: InputMaybe<Scalars['interval']['input']>;
  _in?: InputMaybe<Array<Scalars['interval']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['interval']['input']>;
  _lte?: InputMaybe<Scalars['interval']['input']>;
  _neq?: InputMaybe<Scalars['interval']['input']>;
  _nin?: InputMaybe<Array<Scalars['interval']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "mapConfiguration" */
export type MapConfiguration = {
  __typename?: 'mapConfiguration';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  latitude: Scalars['float8']['output'];
  longitude: Scalars['float8']['output'];
  traceColor?: Maybe<Scalars['String']['output']>;
  zoom: Scalars['float8']['output'];
};

/** aggregated selection of "mapConfiguration" */
export type MapConfiguration_Aggregate = {
  __typename?: 'mapConfiguration_aggregate';
  aggregate?: Maybe<MapConfiguration_Aggregate_Fields>;
  nodes: Array<MapConfiguration>;
};

/** aggregate fields of "mapConfiguration" */
export type MapConfiguration_Aggregate_Fields = {
  __typename?: 'mapConfiguration_aggregate_fields';
  avg?: Maybe<MapConfiguration_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MapConfiguration_Max_Fields>;
  min?: Maybe<MapConfiguration_Min_Fields>;
  stddev?: Maybe<MapConfiguration_Stddev_Fields>;
  stddev_pop?: Maybe<MapConfiguration_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MapConfiguration_Stddev_Samp_Fields>;
  sum?: Maybe<MapConfiguration_Sum_Fields>;
  var_pop?: Maybe<MapConfiguration_Var_Pop_Fields>;
  var_samp?: Maybe<MapConfiguration_Var_Samp_Fields>;
  variance?: Maybe<MapConfiguration_Variance_Fields>;
};


/** aggregate fields of "mapConfiguration" */
export type MapConfiguration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MapConfiguration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type MapConfiguration_Avg_Fields = {
  __typename?: 'mapConfiguration_avg_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  zoom?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mapConfiguration". All fields are combined with a logical 'AND'. */
export type MapConfiguration_Bool_Exp = {
  _and?: InputMaybe<Array<MapConfiguration_Bool_Exp>>;
  _not?: InputMaybe<MapConfiguration_Bool_Exp>;
  _or?: InputMaybe<Array<MapConfiguration_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  latitude?: InputMaybe<Float8_Comparison_Exp>;
  longitude?: InputMaybe<Float8_Comparison_Exp>;
  traceColor?: InputMaybe<String_Comparison_Exp>;
  zoom?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "mapConfiguration" */
export enum MapConfiguration_Constraint {
  /** unique or primary key constraint on columns "constructionSiteId" */
  MapConfigurationConstructionSiteIdKey = 'mapConfiguration_constructionSiteId_key',
  /** unique or primary key constraint on columns "id" */
  MapConfigurationPkey = 'mapConfiguration_pkey'
}

/** input type for incrementing numeric columns in table "mapConfiguration" */
export type MapConfiguration_Inc_Input = {
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  zoom?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "mapConfiguration" */
export type MapConfiguration_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  traceColor?: InputMaybe<Scalars['String']['input']>;
  zoom?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate max on columns */
export type MapConfiguration_Max_Fields = {
  __typename?: 'mapConfiguration_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  traceColor?: Maybe<Scalars['String']['output']>;
  zoom?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type MapConfiguration_Min_Fields = {
  __typename?: 'mapConfiguration_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  traceColor?: Maybe<Scalars['String']['output']>;
  zoom?: Maybe<Scalars['float8']['output']>;
};

/** response of any mutation on the table "mapConfiguration" */
export type MapConfiguration_Mutation_Response = {
  __typename?: 'mapConfiguration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MapConfiguration>;
};

/** input type for inserting object relation for remote table "mapConfiguration" */
export type MapConfiguration_Obj_Rel_Insert_Input = {
  data: MapConfiguration_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<MapConfiguration_On_Conflict>;
};

/** on_conflict condition type for table "mapConfiguration" */
export type MapConfiguration_On_Conflict = {
  constraint: MapConfiguration_Constraint;
  update_columns?: Array<MapConfiguration_Update_Column>;
  where?: InputMaybe<MapConfiguration_Bool_Exp>;
};

/** Ordering options when selecting data from "mapConfiguration". */
export type MapConfiguration_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  traceColor?: InputMaybe<Order_By>;
  zoom?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mapConfiguration */
export type MapConfiguration_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mapConfiguration" */
export enum MapConfiguration_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  TraceColor = 'traceColor',
  /** column name */
  Zoom = 'zoom'
}

/** input type for updating data in table "mapConfiguration" */
export type MapConfiguration_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  traceColor?: InputMaybe<Scalars['String']['input']>;
  zoom?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate stddev on columns */
export type MapConfiguration_Stddev_Fields = {
  __typename?: 'mapConfiguration_stddev_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  zoom?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type MapConfiguration_Stddev_Pop_Fields = {
  __typename?: 'mapConfiguration_stddev_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  zoom?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type MapConfiguration_Stddev_Samp_Fields = {
  __typename?: 'mapConfiguration_stddev_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  zoom?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mapConfiguration" */
export type MapConfiguration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MapConfiguration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MapConfiguration_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  traceColor?: InputMaybe<Scalars['String']['input']>;
  zoom?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type MapConfiguration_Sum_Fields = {
  __typename?: 'mapConfiguration_sum_fields';
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  zoom?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "mapConfiguration" */
export enum MapConfiguration_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  TraceColor = 'traceColor',
  /** column name */
  Zoom = 'zoom'
}

export type MapConfiguration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MapConfiguration_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MapConfiguration_Set_Input>;
  /** filter the rows which have to be updated */
  where: MapConfiguration_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MapConfiguration_Var_Pop_Fields = {
  __typename?: 'mapConfiguration_var_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  zoom?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type MapConfiguration_Var_Samp_Fields = {
  __typename?: 'mapConfiguration_var_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  zoom?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type MapConfiguration_Variance_Fields = {
  __typename?: 'mapConfiguration_variance_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  zoom?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mapPoi" */
export type MapPoi = {
  __typename?: 'mapPoi';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['bigint']['output'];
  latitude: Scalars['float8']['output'];
  longitude: Scalars['float8']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "mapPoi" */
export type MapPoi_Aggregate = {
  __typename?: 'mapPoi_aggregate';
  aggregate?: Maybe<MapPoi_Aggregate_Fields>;
  nodes: Array<MapPoi>;
};

export type MapPoi_Aggregate_Bool_Exp = {
  avg?: InputMaybe<MapPoi_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<MapPoi_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<MapPoi_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<MapPoi_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<MapPoi_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<MapPoi_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<MapPoi_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<MapPoi_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<MapPoi_Aggregate_Bool_Exp_Var_Samp>;
};

export type MapPoi_Aggregate_Bool_Exp_Avg = {
  arguments: MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapPoi_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapPoi_Aggregate_Bool_Exp_Corr = {
  arguments: MapPoi_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapPoi_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapPoi_Aggregate_Bool_Exp_Corr_Arguments = {
  X: MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type MapPoi_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MapPoi_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapPoi_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type MapPoi_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: MapPoi_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapPoi_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapPoi_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type MapPoi_Aggregate_Bool_Exp_Max = {
  arguments: MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapPoi_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapPoi_Aggregate_Bool_Exp_Min = {
  arguments: MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapPoi_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapPoi_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapPoi_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapPoi_Aggregate_Bool_Exp_Sum = {
  arguments: MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapPoi_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapPoi_Aggregate_Bool_Exp_Var_Samp = {
  arguments: MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapPoi_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "mapPoi" */
export type MapPoi_Aggregate_Fields = {
  __typename?: 'mapPoi_aggregate_fields';
  avg?: Maybe<MapPoi_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MapPoi_Max_Fields>;
  min?: Maybe<MapPoi_Min_Fields>;
  stddev?: Maybe<MapPoi_Stddev_Fields>;
  stddev_pop?: Maybe<MapPoi_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MapPoi_Stddev_Samp_Fields>;
  sum?: Maybe<MapPoi_Sum_Fields>;
  var_pop?: Maybe<MapPoi_Var_Pop_Fields>;
  var_samp?: Maybe<MapPoi_Var_Samp_Fields>;
  variance?: Maybe<MapPoi_Variance_Fields>;
};


/** aggregate fields of "mapPoi" */
export type MapPoi_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MapPoi_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mapPoi" */
export type MapPoi_Aggregate_Order_By = {
  avg?: InputMaybe<MapPoi_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MapPoi_Max_Order_By>;
  min?: InputMaybe<MapPoi_Min_Order_By>;
  stddev?: InputMaybe<MapPoi_Stddev_Order_By>;
  stddev_pop?: InputMaybe<MapPoi_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<MapPoi_Stddev_Samp_Order_By>;
  sum?: InputMaybe<MapPoi_Sum_Order_By>;
  var_pop?: InputMaybe<MapPoi_Var_Pop_Order_By>;
  var_samp?: InputMaybe<MapPoi_Var_Samp_Order_By>;
  variance?: InputMaybe<MapPoi_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mapPoi" */
export type MapPoi_Arr_Rel_Insert_Input = {
  data: Array<MapPoi_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MapPoi_On_Conflict>;
};

/** aggregate avg on columns */
export type MapPoi_Avg_Fields = {
  __typename?: 'mapPoi_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mapPoi" */
export type MapPoi_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mapPoi". All fields are combined with a logical 'AND'. */
export type MapPoi_Bool_Exp = {
  _and?: InputMaybe<Array<MapPoi_Bool_Exp>>;
  _not?: InputMaybe<MapPoi_Bool_Exp>;
  _or?: InputMaybe<Array<MapPoi_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  latitude?: InputMaybe<Float8_Comparison_Exp>;
  longitude?: InputMaybe<Float8_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "mapPoi" */
export enum MapPoi_Constraint {
  /** unique or primary key constraint on columns "id" */
  MapPoiPkey = 'mapPoi_pkey'
}

/** input type for incrementing numeric columns in table "mapPoi" */
export type MapPoi_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "mapPoi" */
export type MapPoi_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MapPoi_Max_Fields = {
  __typename?: 'mapPoi_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "mapPoi" */
export type MapPoi_Max_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MapPoi_Min_Fields = {
  __typename?: 'mapPoi_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "mapPoi" */
export type MapPoi_Min_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mapPoi" */
export type MapPoi_Mutation_Response = {
  __typename?: 'mapPoi_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MapPoi>;
};

/** on_conflict condition type for table "mapPoi" */
export type MapPoi_On_Conflict = {
  constraint: MapPoi_Constraint;
  update_columns?: Array<MapPoi_Update_Column>;
  where?: InputMaybe<MapPoi_Bool_Exp>;
};

/** Ordering options when selecting data from "mapPoi". */
export type MapPoi_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mapPoi */
export type MapPoi_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "mapPoi" */
export enum MapPoi_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name'
}

/** select "mapPoi_aggregate_bool_exp_avg_arguments_columns" columns of table "mapPoi" */
export enum MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "mapPoi_aggregate_bool_exp_corr_arguments_columns" columns of table "mapPoi" */
export enum MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "mapPoi_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "mapPoi" */
export enum MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "mapPoi_aggregate_bool_exp_max_arguments_columns" columns of table "mapPoi" */
export enum MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "mapPoi_aggregate_bool_exp_min_arguments_columns" columns of table "mapPoi" */
export enum MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "mapPoi_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "mapPoi" */
export enum MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "mapPoi_aggregate_bool_exp_sum_arguments_columns" columns of table "mapPoi" */
export enum MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** select "mapPoi_aggregate_bool_exp_var_samp_arguments_columns" columns of table "mapPoi" */
export enum MapPoi_Select_Column_MapPoi_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** input type for updating data in table "mapPoi" */
export type MapPoi_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type MapPoi_Stddev_Fields = {
  __typename?: 'mapPoi_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mapPoi" */
export type MapPoi_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type MapPoi_Stddev_Pop_Fields = {
  __typename?: 'mapPoi_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mapPoi" */
export type MapPoi_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type MapPoi_Stddev_Samp_Fields = {
  __typename?: 'mapPoi_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mapPoi" */
export type MapPoi_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mapPoi" */
export type MapPoi_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MapPoi_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MapPoi_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type MapPoi_Sum_Fields = {
  __typename?: 'mapPoi_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "mapPoi" */
export type MapPoi_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** update columns of table "mapPoi" */
export enum MapPoi_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Name = 'name'
}

export type MapPoi_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MapPoi_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MapPoi_Set_Input>;
  /** filter the rows which have to be updated */
  where: MapPoi_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MapPoi_Var_Pop_Fields = {
  __typename?: 'mapPoi_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mapPoi" */
export type MapPoi_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type MapPoi_Var_Samp_Fields = {
  __typename?: 'mapPoi_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mapPoi" */
export type MapPoi_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type MapPoi_Variance_Fields = {
  __typename?: 'mapPoi_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mapPoi" */
export type MapPoi_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** columns and relationships of "mapTrace" */
export type MapTrace = {
  __typename?: 'mapTrace';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['bigint']['output'];
  latitude: Scalars['float8']['output'];
  longitude: Scalars['float8']['output'];
  mp: Scalars['float8']['output'];
};

/** aggregated selection of "mapTrace" */
export type MapTrace_Aggregate = {
  __typename?: 'mapTrace_aggregate';
  aggregate?: Maybe<MapTrace_Aggregate_Fields>;
  nodes: Array<MapTrace>;
};

export type MapTrace_Aggregate_Bool_Exp = {
  avg?: InputMaybe<MapTrace_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<MapTrace_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<MapTrace_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<MapTrace_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<MapTrace_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<MapTrace_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<MapTrace_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<MapTrace_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<MapTrace_Aggregate_Bool_Exp_Var_Samp>;
};

export type MapTrace_Aggregate_Bool_Exp_Avg = {
  arguments: MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapTrace_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapTrace_Aggregate_Bool_Exp_Corr = {
  arguments: MapTrace_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapTrace_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapTrace_Aggregate_Bool_Exp_Corr_Arguments = {
  X: MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type MapTrace_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MapTrace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapTrace_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type MapTrace_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: MapTrace_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapTrace_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapTrace_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type MapTrace_Aggregate_Bool_Exp_Max = {
  arguments: MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapTrace_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapTrace_Aggregate_Bool_Exp_Min = {
  arguments: MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapTrace_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapTrace_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapTrace_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapTrace_Aggregate_Bool_Exp_Sum = {
  arguments: MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapTrace_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type MapTrace_Aggregate_Bool_Exp_Var_Samp = {
  arguments: MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MapTrace_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "mapTrace" */
export type MapTrace_Aggregate_Fields = {
  __typename?: 'mapTrace_aggregate_fields';
  avg?: Maybe<MapTrace_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MapTrace_Max_Fields>;
  min?: Maybe<MapTrace_Min_Fields>;
  stddev?: Maybe<MapTrace_Stddev_Fields>;
  stddev_pop?: Maybe<MapTrace_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MapTrace_Stddev_Samp_Fields>;
  sum?: Maybe<MapTrace_Sum_Fields>;
  var_pop?: Maybe<MapTrace_Var_Pop_Fields>;
  var_samp?: Maybe<MapTrace_Var_Samp_Fields>;
  variance?: Maybe<MapTrace_Variance_Fields>;
};


/** aggregate fields of "mapTrace" */
export type MapTrace_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MapTrace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mapTrace" */
export type MapTrace_Aggregate_Order_By = {
  avg?: InputMaybe<MapTrace_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MapTrace_Max_Order_By>;
  min?: InputMaybe<MapTrace_Min_Order_By>;
  stddev?: InputMaybe<MapTrace_Stddev_Order_By>;
  stddev_pop?: InputMaybe<MapTrace_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<MapTrace_Stddev_Samp_Order_By>;
  sum?: InputMaybe<MapTrace_Sum_Order_By>;
  var_pop?: InputMaybe<MapTrace_Var_Pop_Order_By>;
  var_samp?: InputMaybe<MapTrace_Var_Samp_Order_By>;
  variance?: InputMaybe<MapTrace_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mapTrace" */
export type MapTrace_Arr_Rel_Insert_Input = {
  data: Array<MapTrace_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MapTrace_On_Conflict>;
};

/** aggregate avg on columns */
export type MapTrace_Avg_Fields = {
  __typename?: 'mapTrace_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mp?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mapTrace" */
export type MapTrace_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  mp?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mapTrace". All fields are combined with a logical 'AND'. */
export type MapTrace_Bool_Exp = {
  _and?: InputMaybe<Array<MapTrace_Bool_Exp>>;
  _not?: InputMaybe<MapTrace_Bool_Exp>;
  _or?: InputMaybe<Array<MapTrace_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  latitude?: InputMaybe<Float8_Comparison_Exp>;
  longitude?: InputMaybe<Float8_Comparison_Exp>;
  mp?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "mapTrace" */
export enum MapTrace_Constraint {
  /** unique or primary key constraint on columns "mp", "constructionSiteId" */
  MapTraceConstructionSiteIdPmKey = 'mapTrace_constructionSiteId_pm_key',
  /** unique or primary key constraint on columns "id" */
  MapTracePkey = 'mapTrace_pkey'
}

/** input type for incrementing numeric columns in table "mapTrace" */
export type MapTrace_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  mp?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "mapTrace" */
export type MapTrace_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  mp?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate max on columns */
export type MapTrace_Max_Fields = {
  __typename?: 'mapTrace_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  mp?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "mapTrace" */
export type MapTrace_Max_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  mp?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MapTrace_Min_Fields = {
  __typename?: 'mapTrace_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  mp?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "mapTrace" */
export type MapTrace_Min_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  mp?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mapTrace" */
export type MapTrace_Mutation_Response = {
  __typename?: 'mapTrace_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MapTrace>;
};

/** on_conflict condition type for table "mapTrace" */
export type MapTrace_On_Conflict = {
  constraint: MapTrace_Constraint;
  update_columns?: Array<MapTrace_Update_Column>;
  where?: InputMaybe<MapTrace_Bool_Exp>;
};

/** Ordering options when selecting data from "mapTrace". */
export type MapTrace_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  mp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mapTrace */
export type MapTrace_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "mapTrace" */
export enum MapTrace_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Mp = 'mp'
}

/** select "mapTrace_aggregate_bool_exp_avg_arguments_columns" columns of table "mapTrace" */
export enum MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Mp = 'mp'
}

/** select "mapTrace_aggregate_bool_exp_corr_arguments_columns" columns of table "mapTrace" */
export enum MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Mp = 'mp'
}

/** select "mapTrace_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "mapTrace" */
export enum MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Mp = 'mp'
}

/** select "mapTrace_aggregate_bool_exp_max_arguments_columns" columns of table "mapTrace" */
export enum MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Mp = 'mp'
}

/** select "mapTrace_aggregate_bool_exp_min_arguments_columns" columns of table "mapTrace" */
export enum MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Mp = 'mp'
}

/** select "mapTrace_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "mapTrace" */
export enum MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Mp = 'mp'
}

/** select "mapTrace_aggregate_bool_exp_sum_arguments_columns" columns of table "mapTrace" */
export enum MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Mp = 'mp'
}

/** select "mapTrace_aggregate_bool_exp_var_samp_arguments_columns" columns of table "mapTrace" */
export enum MapTrace_Select_Column_MapTrace_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Mp = 'mp'
}

/** input type for updating data in table "mapTrace" */
export type MapTrace_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  mp?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate stddev on columns */
export type MapTrace_Stddev_Fields = {
  __typename?: 'mapTrace_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mapTrace" */
export type MapTrace_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  mp?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type MapTrace_Stddev_Pop_Fields = {
  __typename?: 'mapTrace_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mapTrace" */
export type MapTrace_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  mp?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type MapTrace_Stddev_Samp_Fields = {
  __typename?: 'mapTrace_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mp?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mapTrace" */
export type MapTrace_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  mp?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mapTrace" */
export type MapTrace_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MapTrace_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MapTrace_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  latitude?: InputMaybe<Scalars['float8']['input']>;
  longitude?: InputMaybe<Scalars['float8']['input']>;
  mp?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type MapTrace_Sum_Fields = {
  __typename?: 'mapTrace_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  latitude?: Maybe<Scalars['float8']['output']>;
  longitude?: Maybe<Scalars['float8']['output']>;
  mp?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "mapTrace" */
export type MapTrace_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  mp?: InputMaybe<Order_By>;
};

/** update columns of table "mapTrace" */
export enum MapTrace_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Mp = 'mp'
}

export type MapTrace_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MapTrace_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MapTrace_Set_Input>;
  /** filter the rows which have to be updated */
  where: MapTrace_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MapTrace_Var_Pop_Fields = {
  __typename?: 'mapTrace_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mapTrace" */
export type MapTrace_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  mp?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type MapTrace_Var_Samp_Fields = {
  __typename?: 'mapTrace_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mp?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mapTrace" */
export type MapTrace_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  mp?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type MapTrace_Variance_Fields = {
  __typename?: 'mapTrace_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mp?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mapTrace" */
export type MapTrace_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  mp?: InputMaybe<Order_By>;
};

/** columns and relationships of "module" */
export type Module = {
  __typename?: 'module';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

/** aggregated selection of "module" */
export type Module_Aggregate = {
  __typename?: 'module_aggregate';
  aggregate?: Maybe<Module_Aggregate_Fields>;
  nodes: Array<Module>;
};

/** aggregate fields of "module" */
export type Module_Aggregate_Fields = {
  __typename?: 'module_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Module_Max_Fields>;
  min?: Maybe<Module_Min_Fields>;
};


/** aggregate fields of "module" */
export type Module_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Module_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "module". All fields are combined with a logical 'AND'. */
export type Module_Bool_Exp = {
  _and?: InputMaybe<Array<Module_Bool_Exp>>;
  _not?: InputMaybe<Module_Bool_Exp>;
  _or?: InputMaybe<Array<Module_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "module" */
export enum Module_Constraint {
  /** unique or primary key constraint on columns "id" */
  ModulePkey = 'module_pkey'
}

export enum Module_Enum {
  Backoffice = 'BACKOFFICE',
  Dashboard = 'DASHBOARD',
  DataAnalysis = 'DATA_ANALYSIS',
  ProdPerf = 'PROD_PERF',
  QualityControl = 'QUALITY_CONTROL',
  QualityScan = 'QUALITY_SCAN',
  ShiftReport = 'SHIFT_REPORT',
  Steering = 'STEERING'
}

/** Boolean expression to compare columns of type "module_enum". All fields are combined with logical 'AND'. */
export type Module_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Module_Enum>;
  _in?: InputMaybe<Array<Module_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Module_Enum>;
  _nin?: InputMaybe<Array<Module_Enum>>;
};

/** input type for inserting data into table "module" */
export type Module_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Module_Max_Fields = {
  __typename?: 'module_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Module_Min_Fields = {
  __typename?: 'module_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "module" */
export type Module_Mutation_Response = {
  __typename?: 'module_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Module>;
};

/** on_conflict condition type for table "module" */
export type Module_On_Conflict = {
  constraint: Module_Constraint;
  update_columns?: Array<Module_Update_Column>;
  where?: InputMaybe<Module_Bool_Exp>;
};

/** Ordering options when selecting data from "module". */
export type Module_Order_By = {
  comment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: module */
export type Module_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "module" */
export enum Module_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "module" */
export type Module_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "module" */
export type Module_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Module_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Module_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "module" */
export enum Module_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

export type Module_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Module_Set_Input>;
  /** filter the rows which have to be updated */
  where: Module_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  createActivityExport?: Maybe<FileUrlResponseV2>;
  /** Create a link to delete resource on private bucket */
  createFileDeleteTempUrl?: Maybe<TempUrlResponse>;
  /** Create a link to upload resource on private bucket */
  createFileUploadTempUrl?: Maybe<TempUrlResponse>;
  createMapPoiExport?: Maybe<FileUrlResponseV2>;
  createMapTraceExport?: Maybe<FileUrlResponseV2>;
  /** Create a link to delete resource on public bucket */
  createPublicFileDeleteTempUrl?: Maybe<TempUrlResponse>;
  /** Create a link to upload resource on public bucket */
  createPublicFileUploadTempUrl?: Maybe<TempUrlResponse>;
  createScanUser: MutationBasicResult;
  createTimescaleTable: MutationBasicResult;
  /**
   * Delete a ring's compliance report PDF (bucket object + reference), keeping
   * the compliance data. Reserved to data-manager / admin.
   */
  deleteRingComplianceReport: MutationBasicResult;
  deleteScanUser: MutationBasicResult;
  /** delete data from the table: "activity" */
  delete_activity?: Maybe<Activity_Mutation_Response>;
  /** delete single row from the table: "activity" */
  delete_activity_by_pk?: Maybe<Activity>;
  /** delete data from the table: "autofillApi" */
  delete_autofillApi?: Maybe<AutofillApi_Mutation_Response>;
  /** delete single row from the table: "autofillApi" */
  delete_autofillApi_by_pk?: Maybe<AutofillApi>;
  /** delete data from the table: "constructionSite" */
  delete_constructionSite?: Maybe<ConstructionSite_Mutation_Response>;
  /** delete data from the table: "constructionSiteEnabledModule" */
  delete_constructionSiteEnabledModule?: Maybe<ConstructionSiteEnabledModule_Mutation_Response>;
  /** delete single row from the table: "constructionSiteEnabledModule" */
  delete_constructionSiteEnabledModule_by_pk?: Maybe<ConstructionSiteEnabledModule>;
  /** delete single row from the table: "constructionSite" */
  delete_constructionSite_by_pk?: Maybe<ConstructionSite>;
  /** delete data from the table: "dailyShiftTemplate" */
  delete_dailyShiftTemplate?: Maybe<DailyShiftTemplate_Mutation_Response>;
  /** delete single row from the table: "dailyShiftTemplate" */
  delete_dailyShiftTemplate_by_pk?: Maybe<DailyShiftTemplate>;
  /** delete data from the table: "file.bucketFile" */
  delete_file_bucketFile?: Maybe<File_BucketFile_Mutation_Response>;
  /** delete single row from the table: "file.bucketFile" */
  delete_file_bucketFile_by_pk?: Maybe<File_BucketFile>;
  /** delete data from the table: "file.bucketTypeEnum" */
  delete_file_bucketTypeEnum?: Maybe<File_BucketTypeEnum_Mutation_Response>;
  /** delete single row from the table: "file.bucketTypeEnum" */
  delete_file_bucketTypeEnum_by_pk?: Maybe<File_BucketTypeEnum>;
  /** delete data from the table: "graphSet" */
  delete_graphSet?: Maybe<GraphSet_Mutation_Response>;
  /** delete data from the table: "graphSetTypeEnum" */
  delete_graphSetTypeEnum?: Maybe<GraphSetTypeEnum_Mutation_Response>;
  /** delete single row from the table: "graphSetTypeEnum" */
  delete_graphSetTypeEnum_by_pk?: Maybe<GraphSetTypeEnum>;
  /** delete single row from the table: "graphSet" */
  delete_graphSet_by_pk?: Maybe<GraphSet>;
  /** delete data from the table: "indicator" */
  delete_indicator?: Maybe<Indicator_Mutation_Response>;
  /** delete single row from the table: "indicator" */
  delete_indicator_by_pk?: Maybe<Indicator>;
  /** delete data from the table: "mapConfiguration" */
  delete_mapConfiguration?: Maybe<MapConfiguration_Mutation_Response>;
  /** delete single row from the table: "mapConfiguration" */
  delete_mapConfiguration_by_pk?: Maybe<MapConfiguration>;
  /** delete data from the table: "mapPoi" */
  delete_mapPoi?: Maybe<MapPoi_Mutation_Response>;
  /** delete single row from the table: "mapPoi" */
  delete_mapPoi_by_pk?: Maybe<MapPoi>;
  /** delete data from the table: "mapTrace" */
  delete_mapTrace?: Maybe<MapTrace_Mutation_Response>;
  /** delete single row from the table: "mapTrace" */
  delete_mapTrace_by_pk?: Maybe<MapTrace>;
  /** delete data from the table: "module" */
  delete_module?: Maybe<Module_Mutation_Response>;
  /** delete single row from the table: "module" */
  delete_module_by_pk?: Maybe<Module>;
  /** delete data from the table: "operator" */
  delete_operator?: Maybe<Operator_Mutation_Response>;
  /** delete single row from the table: "operator" */
  delete_operator_by_pk?: Maybe<Operator>;
  /** delete data from the table: "parameter.constructionSiteParameterNameConfig" */
  delete_parameter_constructionSiteParameterNameConfig?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Mutation_Response>;
  /** delete single row from the table: "parameter.constructionSiteParameterNameConfig" */
  delete_parameter_constructionSiteParameterNameConfig_by_pk?: Maybe<Parameter_ConstructionSiteParameterNameConfig>;
  /** delete data from the table: "parameter.familyDef" */
  delete_parameter_familyDef?: Maybe<Parameter_FamilyDef_Mutation_Response>;
  /** delete single row from the table: "parameter.familyDef" */
  delete_parameter_familyDef_by_pk?: Maybe<Parameter_FamilyDef>;
  /** delete data from the table: "parameter.metric" */
  delete_parameter_metric?: Maybe<Parameter_Metric_Mutation_Response>;
  /** delete single row from the table: "parameter.metric" */
  delete_parameter_metric_by_pk?: Maybe<Parameter_Metric>;
  /** delete data from the table: "parameter.parameterDef" */
  delete_parameter_parameterDef?: Maybe<Parameter_ParameterDef_Mutation_Response>;
  /** delete single row from the table: "parameter.parameterDef" */
  delete_parameter_parameterDef_by_pk?: Maybe<Parameter_ParameterDef>;
  /** delete data from the table: "parameter.ring" */
  delete_parameter_ring?: Maybe<Parameter_Ring_Mutation_Response>;
  /** delete data from the table: "parameter.ringProjection" */
  delete_parameter_ringProjection?: Maybe<Parameter_RingProjection_Mutation_Response>;
  /** delete single row from the table: "parameter.ringProjection" */
  delete_parameter_ringProjection_by_pk?: Maybe<Parameter_RingProjection>;
  /** delete single row from the table: "parameter.ring" */
  delete_parameter_ring_by_pk?: Maybe<Parameter_Ring>;
  /** delete data from the table: "parameter.value" */
  delete_parameter_value?: Maybe<Parameter_Value_Mutation_Response>;
  /** delete single row from the table: "parameter.value" */
  delete_parameter_value_by_pk?: Maybe<Parameter_Value>;
  /** delete data from the table: "permissionType" */
  delete_permissionType?: Maybe<PermissionType_Mutation_Response>;
  /** delete single row from the table: "permissionType" */
  delete_permissionType_by_pk?: Maybe<PermissionType>;
  /** delete data from the table: "project" */
  delete_project?: Maybe<Project_Mutation_Response>;
  /** delete single row from the table: "project" */
  delete_project_by_pk?: Maybe<Project>;
  /** delete data from the table: "quality.boardConfig" */
  delete_quality_boardConfig?: Maybe<Quality_BoardConfig_Mutation_Response>;
  /** delete single row from the table: "quality.boardConfig" */
  delete_quality_boardConfig_by_pk?: Maybe<Quality_BoardConfig>;
  /** delete data from the table: "quality.boardSegment" */
  delete_quality_boardSegment?: Maybe<Quality_BoardSegment_Mutation_Response>;
  /** delete single row from the table: "quality.boardSegment" */
  delete_quality_boardSegment_by_pk?: Maybe<Quality_BoardSegment>;
  /** delete data from the table: "quality.defectRepair" */
  delete_quality_defectRepair?: Maybe<Quality_DefectRepair_Mutation_Response>;
  /** delete data from the table: "quality.defectRepairPicture" */
  delete_quality_defectRepairPicture?: Maybe<Quality_DefectRepairPicture_Mutation_Response>;
  /** delete single row from the table: "quality.defectRepairPicture" */
  delete_quality_defectRepairPicture_by_pk?: Maybe<Quality_DefectRepairPicture>;
  /** delete data from the table: "quality.defectRepairType" */
  delete_quality_defectRepairType?: Maybe<Quality_DefectRepairType_Mutation_Response>;
  /** delete single row from the table: "quality.defectRepairType" */
  delete_quality_defectRepairType_by_pk?: Maybe<Quality_DefectRepairType>;
  /** delete single row from the table: "quality.defectRepair" */
  delete_quality_defectRepair_by_pk?: Maybe<Quality_DefectRepair>;
  /** delete data from the table: "quality.defectReport" */
  delete_quality_defectReport?: Maybe<Quality_DefectReport_Mutation_Response>;
  /** delete data from the table: "quality.defectReportPicture" */
  delete_quality_defectReportPicture?: Maybe<Quality_DefectReportPicture_Mutation_Response>;
  /** delete single row from the table: "quality.defectReportPicture" */
  delete_quality_defectReportPicture_by_pk?: Maybe<Quality_DefectReportPicture>;
  /** delete data from the table: "quality.defectReportType" */
  delete_quality_defectReportType?: Maybe<Quality_DefectReportType_Mutation_Response>;
  /** delete single row from the table: "quality.defectReportType" */
  delete_quality_defectReportType_by_pk?: Maybe<Quality_DefectReportType>;
  /** delete single row from the table: "quality.defectReport" */
  delete_quality_defectReport_by_pk?: Maybe<Quality_DefectReport>;
  /** delete data from the table: "quality.importConfig" */
  delete_quality_importConfig?: Maybe<Quality_ImportConfig_Mutation_Response>;
  /** delete single row from the table: "quality.importConfig" */
  delete_quality_importConfig_by_pk?: Maybe<Quality_ImportConfig>;
  /** delete data from the table: "quality.importExtraColumn" */
  delete_quality_importExtraColumn?: Maybe<Quality_ImportExtraColumn_Mutation_Response>;
  /** delete single row from the table: "quality.importExtraColumn" */
  delete_quality_importExtraColumn_by_pk?: Maybe<Quality_ImportExtraColumn>;
  /** delete data from the table: "quality.importTask" */
  delete_quality_importTask?: Maybe<Quality_ImportTask_Mutation_Response>;
  /** delete single row from the table: "quality.importTask" */
  delete_quality_importTask_by_pk?: Maybe<Quality_ImportTask>;
  /** delete data from the table: "quality.indicator" */
  delete_quality_indicator?: Maybe<Quality_Indicator_Mutation_Response>;
  /** delete single row from the table: "quality.indicator" */
  delete_quality_indicator_by_pk?: Maybe<Quality_Indicator>;
  /** delete data from the table: "quality.quarantineDefect" */
  delete_quality_quarantineDefect?: Maybe<Quality_QuarantineDefect_Mutation_Response>;
  /** delete data from the table: "quality.quarantineDefectOrientationEnum" */
  delete_quality_quarantineDefectOrientationEnum?: Maybe<Quality_QuarantineDefectOrientationEnum_Mutation_Response>;
  /** delete single row from the table: "quality.quarantineDefectOrientationEnum" */
  delete_quality_quarantineDefectOrientationEnum_by_pk?: Maybe<Quality_QuarantineDefectOrientationEnum>;
  /** delete data from the table: "quality.quarantineDefectPicture" */
  delete_quality_quarantineDefectPicture?: Maybe<Quality_QuarantineDefectPicture_Mutation_Response>;
  /** delete single row from the table: "quality.quarantineDefectPicture" */
  delete_quality_quarantineDefectPicture_by_pk?: Maybe<Quality_QuarantineDefectPicture>;
  /** delete data from the table: "quality.quarantineDefectType" */
  delete_quality_quarantineDefectType?: Maybe<Quality_QuarantineDefectType_Mutation_Response>;
  /** delete single row from the table: "quality.quarantineDefectType" */
  delete_quality_quarantineDefectType_by_pk?: Maybe<Quality_QuarantineDefectType>;
  /** delete single row from the table: "quality.quarantineDefect" */
  delete_quality_quarantineDefect_by_pk?: Maybe<Quality_QuarantineDefect>;
  /** delete data from the table: "quality.repairReport" */
  delete_quality_repairReport?: Maybe<Quality_RepairReport_Mutation_Response>;
  /** delete data from the table: "quality.repairReportPicture" */
  delete_quality_repairReportPicture?: Maybe<Quality_RepairReportPicture_Mutation_Response>;
  /** delete single row from the table: "quality.repairReportPicture" */
  delete_quality_repairReportPicture_by_pk?: Maybe<Quality_RepairReportPicture>;
  /** delete single row from the table: "quality.repairReport" */
  delete_quality_repairReport_by_pk?: Maybe<Quality_RepairReport>;
  /** delete data from the table: "quality.ringValidation" */
  delete_quality_ringValidation?: Maybe<Quality_RingValidation_Mutation_Response>;
  /** delete single row from the table: "quality.ringValidation" */
  delete_quality_ringValidation_by_pk?: Maybe<Quality_RingValidation>;
  /** delete data from the table: "quality.scanCodeConfig" */
  delete_quality_scanCodeConfig?: Maybe<Quality_ScanCodeConfig_Mutation_Response>;
  /** delete single row from the table: "quality.scanCodeConfig" */
  delete_quality_scanCodeConfig_by_pk?: Maybe<Quality_ScanCodeConfig>;
  /** delete data from the table: "quality.scanConfig" */
  delete_quality_scanConfig?: Maybe<Quality_ScanConfig_Mutation_Response>;
  /** delete single row from the table: "quality.scanConfig" */
  delete_quality_scanConfig_by_pk?: Maybe<Quality_ScanConfig>;
  /** delete data from the table: "quality.scanSite" */
  delete_quality_scanSite?: Maybe<Quality_ScanSite_Mutation_Response>;
  /** delete data from the table: "quality.scanSiteConstructionSite" */
  delete_quality_scanSiteConstructionSite?: Maybe<Quality_ScanSiteConstructionSite_Mutation_Response>;
  /** delete single row from the table: "quality.scanSiteConstructionSite" */
  delete_quality_scanSiteConstructionSite_by_pk?: Maybe<Quality_ScanSiteConstructionSite>;
  /** delete single row from the table: "quality.scanSite" */
  delete_quality_scanSite_by_pk?: Maybe<Quality_ScanSite>;
  /** delete data from the table: "quality.scanTypeEnum" */
  delete_quality_scanTypeEnum?: Maybe<Quality_ScanTypeEnum_Mutation_Response>;
  /** delete single row from the table: "quality.scanTypeEnum" */
  delete_quality_scanTypeEnum_by_pk?: Maybe<Quality_ScanTypeEnum>;
  /** delete data from the table: "quality.segment" */
  delete_quality_segment?: Maybe<Quality_Segment_Mutation_Response>;
  /** delete data from the table: "quality.segmentDrawConfig" */
  delete_quality_segmentDrawConfig?: Maybe<Quality_SegmentDrawConfig_Mutation_Response>;
  /** delete single row from the table: "quality.segmentDrawConfig" */
  delete_quality_segmentDrawConfig_by_pk?: Maybe<Quality_SegmentDrawConfig>;
  /** delete data from the table: "quality.segmentExtraParameter" */
  delete_quality_segmentExtraParameter?: Maybe<Quality_SegmentExtraParameter_Mutation_Response>;
  /** delete single row from the table: "quality.segmentExtraParameter" */
  delete_quality_segmentExtraParameter_by_pk?: Maybe<Quality_SegmentExtraParameter>;
  /** delete data from the table: "quality.segmentHistory" */
  delete_quality_segmentHistory?: Maybe<Quality_SegmentHistory_Mutation_Response>;
  /** delete data from the table: "quality.segmentHistoryStatusEnum" */
  delete_quality_segmentHistoryStatusEnum?: Maybe<Quality_SegmentHistoryStatusEnum_Mutation_Response>;
  /** delete single row from the table: "quality.segmentHistoryStatusEnum" */
  delete_quality_segmentHistoryStatusEnum_by_pk?: Maybe<Quality_SegmentHistoryStatusEnum>;
  /** delete single row from the table: "quality.segmentHistory" */
  delete_quality_segmentHistory_by_pk?: Maybe<Quality_SegmentHistory>;
  /** delete data from the table: "quality.segmentRefusal" */
  delete_quality_segmentRefusal?: Maybe<Quality_SegmentRefusal_Mutation_Response>;
  /** delete data from the table: "quality.segmentRefusalPicture" */
  delete_quality_segmentRefusalPicture?: Maybe<Quality_SegmentRefusalPicture_Mutation_Response>;
  /** delete single row from the table: "quality.segmentRefusalPicture" */
  delete_quality_segmentRefusalPicture_by_pk?: Maybe<Quality_SegmentRefusalPicture>;
  /** delete single row from the table: "quality.segmentRefusal" */
  delete_quality_segmentRefusal_by_pk?: Maybe<Quality_SegmentRefusal>;
  /** delete single row from the table: "quality.segment" */
  delete_quality_segment_by_pk?: Maybe<Quality_Segment>;
  /** delete data from the table: "quality.shapeEnum" */
  delete_quality_shapeEnum?: Maybe<Quality_ShapeEnum_Mutation_Response>;
  /** delete single row from the table: "quality.shapeEnum" */
  delete_quality_shapeEnum_by_pk?: Maybe<Quality_ShapeEnum>;
  /** delete data from the table: "quality.tunnelPosition" */
  delete_quality_tunnelPosition?: Maybe<Quality_TunnelPosition_Mutation_Response>;
  /** delete single row from the table: "quality.tunnelPosition" */
  delete_quality_tunnelPosition_by_pk?: Maybe<Quality_TunnelPosition>;
  /** delete data from the table: "quality.userQualityRole" */
  delete_quality_userQualityRole?: Maybe<Quality_UserQualityRole_Mutation_Response>;
  /** delete single row from the table: "quality.userQualityRole" */
  delete_quality_userQualityRole_by_pk?: Maybe<Quality_UserQualityRole>;
  /** delete data from the table: "quality.virtualRing" */
  delete_quality_virtualRing?: Maybe<Quality_VirtualRing_Mutation_Response>;
  /** delete single row from the table: "quality.virtualRing" */
  delete_quality_virtualRing_by_pk?: Maybe<Quality_VirtualRing>;
  /** delete data from the table: "recurringTask" */
  delete_recurringTask?: Maybe<RecurringTask_Mutation_Response>;
  /** delete single row from the table: "recurringTask" */
  delete_recurringTask_by_pk?: Maybe<RecurringTask>;
  /** delete data from the table: "scan.user" */
  delete_scan_user?: Maybe<Scan_User_Mutation_Response>;
  /** delete single row from the table: "scan.user" */
  delete_scan_user_by_pk?: Maybe<Scan_User>;
  /** delete data from the table: "shift" */
  delete_shift?: Maybe<Shift_Mutation_Response>;
  /** delete data from the table: "shiftLeader" */
  delete_shiftLeader?: Maybe<ShiftLeader_Mutation_Response>;
  /** delete single row from the table: "shiftLeader" */
  delete_shiftLeader_by_pk?: Maybe<ShiftLeader>;
  /** delete data from the table: "shiftReport" */
  delete_shiftReport?: Maybe<ShiftReport_Mutation_Response>;
  /** delete single row from the table: "shiftReport" */
  delete_shiftReport_by_pk?: Maybe<ShiftReport>;
  /** delete single row from the table: "shift" */
  delete_shift_by_pk?: Maybe<Shift>;
  /** delete data from the table: "task" */
  delete_task?: Maybe<Task_Mutation_Response>;
  /** delete single row from the table: "task" */
  delete_task_by_pk?: Maybe<Task>;
  /** delete data from the table: "team" */
  delete_team?: Maybe<Team_Mutation_Response>;
  /** delete single row from the table: "team" */
  delete_team_by_pk?: Maybe<Team>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<User_Mutation_Response>;
  /** delete data from the table: "userPermission" */
  delete_userPermission?: Maybe<UserPermission_Mutation_Response>;
  /** delete single row from the table: "userPermission" */
  delete_userPermission_by_pk?: Maybe<UserPermission>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  /** Generate aggregated pdf */
  generateAggregatedPdf?: Maybe<FileUrlResponse>;
  /** Generate excel from the input */
  generateExcelFromBIData: FileUrlResponse;
  /** Export Task within date range to excel */
  generateExcelFromTaskRangeExport: FileUrlResponse;
  /**
   * Generate the compliance report PDF of a single ring and wait for completion.
   * Reserved to data-manager / admin.
   */
  generateRingComplianceReport: MutationBasicResult;
  /** Generate shiftReport pdf */
  generateShiftReportPdf?: Maybe<FileUrlResponse>;
  /** Generate shiftReport pdfs (zipped) */
  generateShiftReportPdfs?: Maybe<FileUrlResponse>;
  /** insert data into the table: "activity" */
  insert_activity?: Maybe<Activity_Mutation_Response>;
  /** insert a single row into the table: "activity" */
  insert_activity_one?: Maybe<Activity>;
  /** insert data into the table: "autofillApi" */
  insert_autofillApi?: Maybe<AutofillApi_Mutation_Response>;
  /** insert a single row into the table: "autofillApi" */
  insert_autofillApi_one?: Maybe<AutofillApi>;
  /** insert data into the table: "constructionSite" */
  insert_constructionSite?: Maybe<ConstructionSite_Mutation_Response>;
  /** insert data into the table: "constructionSiteEnabledModule" */
  insert_constructionSiteEnabledModule?: Maybe<ConstructionSiteEnabledModule_Mutation_Response>;
  /** insert a single row into the table: "constructionSiteEnabledModule" */
  insert_constructionSiteEnabledModule_one?: Maybe<ConstructionSiteEnabledModule>;
  /** insert a single row into the table: "constructionSite" */
  insert_constructionSite_one?: Maybe<ConstructionSite>;
  /** insert data into the table: "dailyShiftTemplate" */
  insert_dailyShiftTemplate?: Maybe<DailyShiftTemplate_Mutation_Response>;
  /** insert a single row into the table: "dailyShiftTemplate" */
  insert_dailyShiftTemplate_one?: Maybe<DailyShiftTemplate>;
  /** insert data into the table: "file.bucketFile" */
  insert_file_bucketFile?: Maybe<File_BucketFile_Mutation_Response>;
  /** insert a single row into the table: "file.bucketFile" */
  insert_file_bucketFile_one?: Maybe<File_BucketFile>;
  /** insert data into the table: "file.bucketTypeEnum" */
  insert_file_bucketTypeEnum?: Maybe<File_BucketTypeEnum_Mutation_Response>;
  /** insert a single row into the table: "file.bucketTypeEnum" */
  insert_file_bucketTypeEnum_one?: Maybe<File_BucketTypeEnum>;
  /** insert data into the table: "graphSet" */
  insert_graphSet?: Maybe<GraphSet_Mutation_Response>;
  /** insert data into the table: "graphSetTypeEnum" */
  insert_graphSetTypeEnum?: Maybe<GraphSetTypeEnum_Mutation_Response>;
  /** insert a single row into the table: "graphSetTypeEnum" */
  insert_graphSetTypeEnum_one?: Maybe<GraphSetTypeEnum>;
  /** insert a single row into the table: "graphSet" */
  insert_graphSet_one?: Maybe<GraphSet>;
  /** insert data into the table: "indicator" */
  insert_indicator?: Maybe<Indicator_Mutation_Response>;
  /** insert a single row into the table: "indicator" */
  insert_indicator_one?: Maybe<Indicator>;
  /** insert data into the table: "mapConfiguration" */
  insert_mapConfiguration?: Maybe<MapConfiguration_Mutation_Response>;
  /** insert a single row into the table: "mapConfiguration" */
  insert_mapConfiguration_one?: Maybe<MapConfiguration>;
  /** insert data into the table: "mapPoi" */
  insert_mapPoi?: Maybe<MapPoi_Mutation_Response>;
  /** insert a single row into the table: "mapPoi" */
  insert_mapPoi_one?: Maybe<MapPoi>;
  /** insert data into the table: "mapTrace" */
  insert_mapTrace?: Maybe<MapTrace_Mutation_Response>;
  /** insert a single row into the table: "mapTrace" */
  insert_mapTrace_one?: Maybe<MapTrace>;
  /** insert data into the table: "module" */
  insert_module?: Maybe<Module_Mutation_Response>;
  /** insert a single row into the table: "module" */
  insert_module_one?: Maybe<Module>;
  /** insert data into the table: "operator" */
  insert_operator?: Maybe<Operator_Mutation_Response>;
  /** insert a single row into the table: "operator" */
  insert_operator_one?: Maybe<Operator>;
  /** insert data into the table: "parameter.constructionSiteParameterNameConfig" */
  insert_parameter_constructionSiteParameterNameConfig?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Mutation_Response>;
  /** insert a single row into the table: "parameter.constructionSiteParameterNameConfig" */
  insert_parameter_constructionSiteParameterNameConfig_one?: Maybe<Parameter_ConstructionSiteParameterNameConfig>;
  /** insert data into the table: "parameter.familyDef" */
  insert_parameter_familyDef?: Maybe<Parameter_FamilyDef_Mutation_Response>;
  /** insert a single row into the table: "parameter.familyDef" */
  insert_parameter_familyDef_one?: Maybe<Parameter_FamilyDef>;
  /** insert data into the table: "parameter.metric" */
  insert_parameter_metric?: Maybe<Parameter_Metric_Mutation_Response>;
  /** insert a single row into the table: "parameter.metric" */
  insert_parameter_metric_one?: Maybe<Parameter_Metric>;
  /** insert data into the table: "parameter.parameterDef" */
  insert_parameter_parameterDef?: Maybe<Parameter_ParameterDef_Mutation_Response>;
  /** insert a single row into the table: "parameter.parameterDef" */
  insert_parameter_parameterDef_one?: Maybe<Parameter_ParameterDef>;
  /** insert data into the table: "parameter.ring" */
  insert_parameter_ring?: Maybe<Parameter_Ring_Mutation_Response>;
  /** insert data into the table: "parameter.ringProjection" */
  insert_parameter_ringProjection?: Maybe<Parameter_RingProjection_Mutation_Response>;
  /** insert a single row into the table: "parameter.ringProjection" */
  insert_parameter_ringProjection_one?: Maybe<Parameter_RingProjection>;
  /** insert a single row into the table: "parameter.ring" */
  insert_parameter_ring_one?: Maybe<Parameter_Ring>;
  /** insert data into the table: "parameter.value" */
  insert_parameter_value?: Maybe<Parameter_Value_Mutation_Response>;
  /** insert a single row into the table: "parameter.value" */
  insert_parameter_value_one?: Maybe<Parameter_Value>;
  /** insert data into the table: "permissionType" */
  insert_permissionType?: Maybe<PermissionType_Mutation_Response>;
  /** insert a single row into the table: "permissionType" */
  insert_permissionType_one?: Maybe<PermissionType>;
  /** insert data into the table: "project" */
  insert_project?: Maybe<Project_Mutation_Response>;
  /** insert a single row into the table: "project" */
  insert_project_one?: Maybe<Project>;
  /** insert data into the table: "quality.boardConfig" */
  insert_quality_boardConfig?: Maybe<Quality_BoardConfig_Mutation_Response>;
  /** insert a single row into the table: "quality.boardConfig" */
  insert_quality_boardConfig_one?: Maybe<Quality_BoardConfig>;
  /** insert data into the table: "quality.boardSegment" */
  insert_quality_boardSegment?: Maybe<Quality_BoardSegment_Mutation_Response>;
  /** insert a single row into the table: "quality.boardSegment" */
  insert_quality_boardSegment_one?: Maybe<Quality_BoardSegment>;
  /** insert data into the table: "quality.defectRepair" */
  insert_quality_defectRepair?: Maybe<Quality_DefectRepair_Mutation_Response>;
  /** insert data into the table: "quality.defectRepairPicture" */
  insert_quality_defectRepairPicture?: Maybe<Quality_DefectRepairPicture_Mutation_Response>;
  /** insert a single row into the table: "quality.defectRepairPicture" */
  insert_quality_defectRepairPicture_one?: Maybe<Quality_DefectRepairPicture>;
  /** insert data into the table: "quality.defectRepairType" */
  insert_quality_defectRepairType?: Maybe<Quality_DefectRepairType_Mutation_Response>;
  /** insert a single row into the table: "quality.defectRepairType" */
  insert_quality_defectRepairType_one?: Maybe<Quality_DefectRepairType>;
  /** insert a single row into the table: "quality.defectRepair" */
  insert_quality_defectRepair_one?: Maybe<Quality_DefectRepair>;
  /** insert data into the table: "quality.defectReport" */
  insert_quality_defectReport?: Maybe<Quality_DefectReport_Mutation_Response>;
  /** insert data into the table: "quality.defectReportPicture" */
  insert_quality_defectReportPicture?: Maybe<Quality_DefectReportPicture_Mutation_Response>;
  /** insert a single row into the table: "quality.defectReportPicture" */
  insert_quality_defectReportPicture_one?: Maybe<Quality_DefectReportPicture>;
  /** insert data into the table: "quality.defectReportType" */
  insert_quality_defectReportType?: Maybe<Quality_DefectReportType_Mutation_Response>;
  /** insert a single row into the table: "quality.defectReportType" */
  insert_quality_defectReportType_one?: Maybe<Quality_DefectReportType>;
  /** insert a single row into the table: "quality.defectReport" */
  insert_quality_defectReport_one?: Maybe<Quality_DefectReport>;
  /** insert data into the table: "quality.importConfig" */
  insert_quality_importConfig?: Maybe<Quality_ImportConfig_Mutation_Response>;
  /** insert a single row into the table: "quality.importConfig" */
  insert_quality_importConfig_one?: Maybe<Quality_ImportConfig>;
  /** insert data into the table: "quality.importExtraColumn" */
  insert_quality_importExtraColumn?: Maybe<Quality_ImportExtraColumn_Mutation_Response>;
  /** insert a single row into the table: "quality.importExtraColumn" */
  insert_quality_importExtraColumn_one?: Maybe<Quality_ImportExtraColumn>;
  /** insert data into the table: "quality.importTask" */
  insert_quality_importTask?: Maybe<Quality_ImportTask_Mutation_Response>;
  /** insert a single row into the table: "quality.importTask" */
  insert_quality_importTask_one?: Maybe<Quality_ImportTask>;
  /** insert data into the table: "quality.indicator" */
  insert_quality_indicator?: Maybe<Quality_Indicator_Mutation_Response>;
  /** insert a single row into the table: "quality.indicator" */
  insert_quality_indicator_one?: Maybe<Quality_Indicator>;
  /** insert data into the table: "quality.quarantineDefect" */
  insert_quality_quarantineDefect?: Maybe<Quality_QuarantineDefect_Mutation_Response>;
  /** insert data into the table: "quality.quarantineDefectOrientationEnum" */
  insert_quality_quarantineDefectOrientationEnum?: Maybe<Quality_QuarantineDefectOrientationEnum_Mutation_Response>;
  /** insert a single row into the table: "quality.quarantineDefectOrientationEnum" */
  insert_quality_quarantineDefectOrientationEnum_one?: Maybe<Quality_QuarantineDefectOrientationEnum>;
  /** insert data into the table: "quality.quarantineDefectPicture" */
  insert_quality_quarantineDefectPicture?: Maybe<Quality_QuarantineDefectPicture_Mutation_Response>;
  /** insert a single row into the table: "quality.quarantineDefectPicture" */
  insert_quality_quarantineDefectPicture_one?: Maybe<Quality_QuarantineDefectPicture>;
  /** insert data into the table: "quality.quarantineDefectType" */
  insert_quality_quarantineDefectType?: Maybe<Quality_QuarantineDefectType_Mutation_Response>;
  /** insert a single row into the table: "quality.quarantineDefectType" */
  insert_quality_quarantineDefectType_one?: Maybe<Quality_QuarantineDefectType>;
  /** insert a single row into the table: "quality.quarantineDefect" */
  insert_quality_quarantineDefect_one?: Maybe<Quality_QuarantineDefect>;
  /** insert data into the table: "quality.repairReport" */
  insert_quality_repairReport?: Maybe<Quality_RepairReport_Mutation_Response>;
  /** insert data into the table: "quality.repairReportPicture" */
  insert_quality_repairReportPicture?: Maybe<Quality_RepairReportPicture_Mutation_Response>;
  /** insert a single row into the table: "quality.repairReportPicture" */
  insert_quality_repairReportPicture_one?: Maybe<Quality_RepairReportPicture>;
  /** insert a single row into the table: "quality.repairReport" */
  insert_quality_repairReport_one?: Maybe<Quality_RepairReport>;
  /** insert data into the table: "quality.ringValidation" */
  insert_quality_ringValidation?: Maybe<Quality_RingValidation_Mutation_Response>;
  /** insert a single row into the table: "quality.ringValidation" */
  insert_quality_ringValidation_one?: Maybe<Quality_RingValidation>;
  /** insert data into the table: "quality.scanCodeConfig" */
  insert_quality_scanCodeConfig?: Maybe<Quality_ScanCodeConfig_Mutation_Response>;
  /** insert a single row into the table: "quality.scanCodeConfig" */
  insert_quality_scanCodeConfig_one?: Maybe<Quality_ScanCodeConfig>;
  /** insert data into the table: "quality.scanConfig" */
  insert_quality_scanConfig?: Maybe<Quality_ScanConfig_Mutation_Response>;
  /** insert a single row into the table: "quality.scanConfig" */
  insert_quality_scanConfig_one?: Maybe<Quality_ScanConfig>;
  /** insert data into the table: "quality.scanSite" */
  insert_quality_scanSite?: Maybe<Quality_ScanSite_Mutation_Response>;
  /** insert data into the table: "quality.scanSiteConstructionSite" */
  insert_quality_scanSiteConstructionSite?: Maybe<Quality_ScanSiteConstructionSite_Mutation_Response>;
  /** insert a single row into the table: "quality.scanSiteConstructionSite" */
  insert_quality_scanSiteConstructionSite_one?: Maybe<Quality_ScanSiteConstructionSite>;
  /** insert a single row into the table: "quality.scanSite" */
  insert_quality_scanSite_one?: Maybe<Quality_ScanSite>;
  /** insert data into the table: "quality.scanTypeEnum" */
  insert_quality_scanTypeEnum?: Maybe<Quality_ScanTypeEnum_Mutation_Response>;
  /** insert a single row into the table: "quality.scanTypeEnum" */
  insert_quality_scanTypeEnum_one?: Maybe<Quality_ScanTypeEnum>;
  /** insert data into the table: "quality.segment" */
  insert_quality_segment?: Maybe<Quality_Segment_Mutation_Response>;
  /** insert data into the table: "quality.segmentDrawConfig" */
  insert_quality_segmentDrawConfig?: Maybe<Quality_SegmentDrawConfig_Mutation_Response>;
  /** insert a single row into the table: "quality.segmentDrawConfig" */
  insert_quality_segmentDrawConfig_one?: Maybe<Quality_SegmentDrawConfig>;
  /** insert data into the table: "quality.segmentExtraParameter" */
  insert_quality_segmentExtraParameter?: Maybe<Quality_SegmentExtraParameter_Mutation_Response>;
  /** insert a single row into the table: "quality.segmentExtraParameter" */
  insert_quality_segmentExtraParameter_one?: Maybe<Quality_SegmentExtraParameter>;
  /** insert data into the table: "quality.segmentHistory" */
  insert_quality_segmentHistory?: Maybe<Quality_SegmentHistory_Mutation_Response>;
  /** insert data into the table: "quality.segmentHistoryStatusEnum" */
  insert_quality_segmentHistoryStatusEnum?: Maybe<Quality_SegmentHistoryStatusEnum_Mutation_Response>;
  /** insert a single row into the table: "quality.segmentHistoryStatusEnum" */
  insert_quality_segmentHistoryStatusEnum_one?: Maybe<Quality_SegmentHistoryStatusEnum>;
  /** insert a single row into the table: "quality.segmentHistory" */
  insert_quality_segmentHistory_one?: Maybe<Quality_SegmentHistory>;
  /** insert data into the table: "quality.segmentRefusal" */
  insert_quality_segmentRefusal?: Maybe<Quality_SegmentRefusal_Mutation_Response>;
  /** insert data into the table: "quality.segmentRefusalPicture" */
  insert_quality_segmentRefusalPicture?: Maybe<Quality_SegmentRefusalPicture_Mutation_Response>;
  /** insert a single row into the table: "quality.segmentRefusalPicture" */
  insert_quality_segmentRefusalPicture_one?: Maybe<Quality_SegmentRefusalPicture>;
  /** insert a single row into the table: "quality.segmentRefusal" */
  insert_quality_segmentRefusal_one?: Maybe<Quality_SegmentRefusal>;
  /** insert a single row into the table: "quality.segment" */
  insert_quality_segment_one?: Maybe<Quality_Segment>;
  /** insert data into the table: "quality.shapeEnum" */
  insert_quality_shapeEnum?: Maybe<Quality_ShapeEnum_Mutation_Response>;
  /** insert a single row into the table: "quality.shapeEnum" */
  insert_quality_shapeEnum_one?: Maybe<Quality_ShapeEnum>;
  /** insert data into the table: "quality.tunnelPosition" */
  insert_quality_tunnelPosition?: Maybe<Quality_TunnelPosition_Mutation_Response>;
  /** insert a single row into the table: "quality.tunnelPosition" */
  insert_quality_tunnelPosition_one?: Maybe<Quality_TunnelPosition>;
  /** insert data into the table: "quality.userQualityRole" */
  insert_quality_userQualityRole?: Maybe<Quality_UserQualityRole_Mutation_Response>;
  /** insert a single row into the table: "quality.userQualityRole" */
  insert_quality_userQualityRole_one?: Maybe<Quality_UserQualityRole>;
  /** insert data into the table: "quality.virtualRing" */
  insert_quality_virtualRing?: Maybe<Quality_VirtualRing_Mutation_Response>;
  /** insert a single row into the table: "quality.virtualRing" */
  insert_quality_virtualRing_one?: Maybe<Quality_VirtualRing>;
  /** insert data into the table: "recurringTask" */
  insert_recurringTask?: Maybe<RecurringTask_Mutation_Response>;
  /** insert a single row into the table: "recurringTask" */
  insert_recurringTask_one?: Maybe<RecurringTask>;
  /** insert data into the table: "scan.user" */
  insert_scan_user?: Maybe<Scan_User_Mutation_Response>;
  /** insert a single row into the table: "scan.user" */
  insert_scan_user_one?: Maybe<Scan_User>;
  /** insert data into the table: "shift" */
  insert_shift?: Maybe<Shift_Mutation_Response>;
  /** insert data into the table: "shiftLeader" */
  insert_shiftLeader?: Maybe<ShiftLeader_Mutation_Response>;
  /** insert a single row into the table: "shiftLeader" */
  insert_shiftLeader_one?: Maybe<ShiftLeader>;
  /** insert data into the table: "shiftReport" */
  insert_shiftReport?: Maybe<ShiftReport_Mutation_Response>;
  /** insert a single row into the table: "shiftReport" */
  insert_shiftReport_one?: Maybe<ShiftReport>;
  /** insert a single row into the table: "shift" */
  insert_shift_one?: Maybe<Shift>;
  /** insert data into the table: "task" */
  insert_task?: Maybe<Task_Mutation_Response>;
  /** insert a single row into the table: "task" */
  insert_task_one?: Maybe<Task>;
  /** insert data into the table: "team" */
  insert_team?: Maybe<Team_Mutation_Response>;
  /** insert a single row into the table: "team" */
  insert_team_one?: Maybe<Team>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<User_Mutation_Response>;
  /** insert data into the table: "userPermission" */
  insert_userPermission?: Maybe<UserPermission_Mutation_Response>;
  /** insert a single row into the table: "userPermission" */
  insert_userPermission_one?: Maybe<UserPermission>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  shiftReportAutofill: ShiftReportAutofillResponse;
  shiftReportAutofillV2: ShiftReportAutofillV2Response;
  /**
   * Cancel the approval of every APPROVED ring in the ring-number range
   * (APPROVED -> COMPLIANT): clears the validation date/user and deletes the
   * associated PDF. Reserved to data-manager / admin.
   */
  unapproveRingComplianceReports: RingComplianceInvalidationResult;
  updateActivityTechnicalData?: Maybe<MutationBasicResult>;
  /** update data of the table: "activity" */
  update_activity?: Maybe<Activity_Mutation_Response>;
  /** update single row of the table: "activity" */
  update_activity_by_pk?: Maybe<Activity>;
  /** update multiples rows of table: "activity" */
  update_activity_many?: Maybe<Array<Maybe<Activity_Mutation_Response>>>;
  /** update data of the table: "autofillApi" */
  update_autofillApi?: Maybe<AutofillApi_Mutation_Response>;
  /** update single row of the table: "autofillApi" */
  update_autofillApi_by_pk?: Maybe<AutofillApi>;
  /** update multiples rows of table: "autofillApi" */
  update_autofillApi_many?: Maybe<Array<Maybe<AutofillApi_Mutation_Response>>>;
  /** update data of the table: "constructionSite" */
  update_constructionSite?: Maybe<ConstructionSite_Mutation_Response>;
  /** update data of the table: "constructionSiteEnabledModule" */
  update_constructionSiteEnabledModule?: Maybe<ConstructionSiteEnabledModule_Mutation_Response>;
  /** update single row of the table: "constructionSiteEnabledModule" */
  update_constructionSiteEnabledModule_by_pk?: Maybe<ConstructionSiteEnabledModule>;
  /** update multiples rows of table: "constructionSiteEnabledModule" */
  update_constructionSiteEnabledModule_many?: Maybe<Array<Maybe<ConstructionSiteEnabledModule_Mutation_Response>>>;
  /** update single row of the table: "constructionSite" */
  update_constructionSite_by_pk?: Maybe<ConstructionSite>;
  /** update multiples rows of table: "constructionSite" */
  update_constructionSite_many?: Maybe<Array<Maybe<ConstructionSite_Mutation_Response>>>;
  /** update data of the table: "dailyShiftTemplate" */
  update_dailyShiftTemplate?: Maybe<DailyShiftTemplate_Mutation_Response>;
  /** update single row of the table: "dailyShiftTemplate" */
  update_dailyShiftTemplate_by_pk?: Maybe<DailyShiftTemplate>;
  /** update multiples rows of table: "dailyShiftTemplate" */
  update_dailyShiftTemplate_many?: Maybe<Array<Maybe<DailyShiftTemplate_Mutation_Response>>>;
  /** update data of the table: "file.bucketFile" */
  update_file_bucketFile?: Maybe<File_BucketFile_Mutation_Response>;
  /** update single row of the table: "file.bucketFile" */
  update_file_bucketFile_by_pk?: Maybe<File_BucketFile>;
  /** update multiples rows of table: "file.bucketFile" */
  update_file_bucketFile_many?: Maybe<Array<Maybe<File_BucketFile_Mutation_Response>>>;
  /** update data of the table: "file.bucketTypeEnum" */
  update_file_bucketTypeEnum?: Maybe<File_BucketTypeEnum_Mutation_Response>;
  /** update single row of the table: "file.bucketTypeEnum" */
  update_file_bucketTypeEnum_by_pk?: Maybe<File_BucketTypeEnum>;
  /** update multiples rows of table: "file.bucketTypeEnum" */
  update_file_bucketTypeEnum_many?: Maybe<Array<Maybe<File_BucketTypeEnum_Mutation_Response>>>;
  /** update data of the table: "graphSet" */
  update_graphSet?: Maybe<GraphSet_Mutation_Response>;
  /** update data of the table: "graphSetTypeEnum" */
  update_graphSetTypeEnum?: Maybe<GraphSetTypeEnum_Mutation_Response>;
  /** update single row of the table: "graphSetTypeEnum" */
  update_graphSetTypeEnum_by_pk?: Maybe<GraphSetTypeEnum>;
  /** update multiples rows of table: "graphSetTypeEnum" */
  update_graphSetTypeEnum_many?: Maybe<Array<Maybe<GraphSetTypeEnum_Mutation_Response>>>;
  /** update single row of the table: "graphSet" */
  update_graphSet_by_pk?: Maybe<GraphSet>;
  /** update multiples rows of table: "graphSet" */
  update_graphSet_many?: Maybe<Array<Maybe<GraphSet_Mutation_Response>>>;
  /** update data of the table: "indicator" */
  update_indicator?: Maybe<Indicator_Mutation_Response>;
  /** update single row of the table: "indicator" */
  update_indicator_by_pk?: Maybe<Indicator>;
  /** update multiples rows of table: "indicator" */
  update_indicator_many?: Maybe<Array<Maybe<Indicator_Mutation_Response>>>;
  /** update data of the table: "mapConfiguration" */
  update_mapConfiguration?: Maybe<MapConfiguration_Mutation_Response>;
  /** update single row of the table: "mapConfiguration" */
  update_mapConfiguration_by_pk?: Maybe<MapConfiguration>;
  /** update multiples rows of table: "mapConfiguration" */
  update_mapConfiguration_many?: Maybe<Array<Maybe<MapConfiguration_Mutation_Response>>>;
  /** update data of the table: "mapPoi" */
  update_mapPoi?: Maybe<MapPoi_Mutation_Response>;
  /** update single row of the table: "mapPoi" */
  update_mapPoi_by_pk?: Maybe<MapPoi>;
  /** update multiples rows of table: "mapPoi" */
  update_mapPoi_many?: Maybe<Array<Maybe<MapPoi_Mutation_Response>>>;
  /** update data of the table: "mapTrace" */
  update_mapTrace?: Maybe<MapTrace_Mutation_Response>;
  /** update single row of the table: "mapTrace" */
  update_mapTrace_by_pk?: Maybe<MapTrace>;
  /** update multiples rows of table: "mapTrace" */
  update_mapTrace_many?: Maybe<Array<Maybe<MapTrace_Mutation_Response>>>;
  /** update data of the table: "module" */
  update_module?: Maybe<Module_Mutation_Response>;
  /** update single row of the table: "module" */
  update_module_by_pk?: Maybe<Module>;
  /** update multiples rows of table: "module" */
  update_module_many?: Maybe<Array<Maybe<Module_Mutation_Response>>>;
  /** update data of the table: "operator" */
  update_operator?: Maybe<Operator_Mutation_Response>;
  /** update single row of the table: "operator" */
  update_operator_by_pk?: Maybe<Operator>;
  /** update multiples rows of table: "operator" */
  update_operator_many?: Maybe<Array<Maybe<Operator_Mutation_Response>>>;
  /** update data of the table: "parameter.constructionSiteParameterNameConfig" */
  update_parameter_constructionSiteParameterNameConfig?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Mutation_Response>;
  /** update single row of the table: "parameter.constructionSiteParameterNameConfig" */
  update_parameter_constructionSiteParameterNameConfig_by_pk?: Maybe<Parameter_ConstructionSiteParameterNameConfig>;
  /** update multiples rows of table: "parameter.constructionSiteParameterNameConfig" */
  update_parameter_constructionSiteParameterNameConfig_many?: Maybe<Array<Maybe<Parameter_ConstructionSiteParameterNameConfig_Mutation_Response>>>;
  /** update data of the table: "parameter.familyDef" */
  update_parameter_familyDef?: Maybe<Parameter_FamilyDef_Mutation_Response>;
  /** update single row of the table: "parameter.familyDef" */
  update_parameter_familyDef_by_pk?: Maybe<Parameter_FamilyDef>;
  /** update multiples rows of table: "parameter.familyDef" */
  update_parameter_familyDef_many?: Maybe<Array<Maybe<Parameter_FamilyDef_Mutation_Response>>>;
  /** update data of the table: "parameter.metric" */
  update_parameter_metric?: Maybe<Parameter_Metric_Mutation_Response>;
  /** update single row of the table: "parameter.metric" */
  update_parameter_metric_by_pk?: Maybe<Parameter_Metric>;
  /** update multiples rows of table: "parameter.metric" */
  update_parameter_metric_many?: Maybe<Array<Maybe<Parameter_Metric_Mutation_Response>>>;
  /** update data of the table: "parameter.parameterDef" */
  update_parameter_parameterDef?: Maybe<Parameter_ParameterDef_Mutation_Response>;
  /** update single row of the table: "parameter.parameterDef" */
  update_parameter_parameterDef_by_pk?: Maybe<Parameter_ParameterDef>;
  /** update multiples rows of table: "parameter.parameterDef" */
  update_parameter_parameterDef_many?: Maybe<Array<Maybe<Parameter_ParameterDef_Mutation_Response>>>;
  /** update data of the table: "parameter.ring" */
  update_parameter_ring?: Maybe<Parameter_Ring_Mutation_Response>;
  /** update data of the table: "parameter.ringProjection" */
  update_parameter_ringProjection?: Maybe<Parameter_RingProjection_Mutation_Response>;
  /** update single row of the table: "parameter.ringProjection" */
  update_parameter_ringProjection_by_pk?: Maybe<Parameter_RingProjection>;
  /** update multiples rows of table: "parameter.ringProjection" */
  update_parameter_ringProjection_many?: Maybe<Array<Maybe<Parameter_RingProjection_Mutation_Response>>>;
  /** update single row of the table: "parameter.ring" */
  update_parameter_ring_by_pk?: Maybe<Parameter_Ring>;
  /** update multiples rows of table: "parameter.ring" */
  update_parameter_ring_many?: Maybe<Array<Maybe<Parameter_Ring_Mutation_Response>>>;
  /** update data of the table: "parameter.value" */
  update_parameter_value?: Maybe<Parameter_Value_Mutation_Response>;
  /** update single row of the table: "parameter.value" */
  update_parameter_value_by_pk?: Maybe<Parameter_Value>;
  /** update multiples rows of table: "parameter.value" */
  update_parameter_value_many?: Maybe<Array<Maybe<Parameter_Value_Mutation_Response>>>;
  /** update data of the table: "permissionType" */
  update_permissionType?: Maybe<PermissionType_Mutation_Response>;
  /** update single row of the table: "permissionType" */
  update_permissionType_by_pk?: Maybe<PermissionType>;
  /** update multiples rows of table: "permissionType" */
  update_permissionType_many?: Maybe<Array<Maybe<PermissionType_Mutation_Response>>>;
  /** update data of the table: "project" */
  update_project?: Maybe<Project_Mutation_Response>;
  /** update single row of the table: "project" */
  update_project_by_pk?: Maybe<Project>;
  /** update multiples rows of table: "project" */
  update_project_many?: Maybe<Array<Maybe<Project_Mutation_Response>>>;
  /** update data of the table: "quality.boardConfig" */
  update_quality_boardConfig?: Maybe<Quality_BoardConfig_Mutation_Response>;
  /** update single row of the table: "quality.boardConfig" */
  update_quality_boardConfig_by_pk?: Maybe<Quality_BoardConfig>;
  /** update multiples rows of table: "quality.boardConfig" */
  update_quality_boardConfig_many?: Maybe<Array<Maybe<Quality_BoardConfig_Mutation_Response>>>;
  /** update data of the table: "quality.boardSegment" */
  update_quality_boardSegment?: Maybe<Quality_BoardSegment_Mutation_Response>;
  /** update single row of the table: "quality.boardSegment" */
  update_quality_boardSegment_by_pk?: Maybe<Quality_BoardSegment>;
  /** update multiples rows of table: "quality.boardSegment" */
  update_quality_boardSegment_many?: Maybe<Array<Maybe<Quality_BoardSegment_Mutation_Response>>>;
  /** update data of the table: "quality.defectRepair" */
  update_quality_defectRepair?: Maybe<Quality_DefectRepair_Mutation_Response>;
  /** update data of the table: "quality.defectRepairPicture" */
  update_quality_defectRepairPicture?: Maybe<Quality_DefectRepairPicture_Mutation_Response>;
  /** update single row of the table: "quality.defectRepairPicture" */
  update_quality_defectRepairPicture_by_pk?: Maybe<Quality_DefectRepairPicture>;
  /** update multiples rows of table: "quality.defectRepairPicture" */
  update_quality_defectRepairPicture_many?: Maybe<Array<Maybe<Quality_DefectRepairPicture_Mutation_Response>>>;
  /** update data of the table: "quality.defectRepairType" */
  update_quality_defectRepairType?: Maybe<Quality_DefectRepairType_Mutation_Response>;
  /** update single row of the table: "quality.defectRepairType" */
  update_quality_defectRepairType_by_pk?: Maybe<Quality_DefectRepairType>;
  /** update multiples rows of table: "quality.defectRepairType" */
  update_quality_defectRepairType_many?: Maybe<Array<Maybe<Quality_DefectRepairType_Mutation_Response>>>;
  /** update single row of the table: "quality.defectRepair" */
  update_quality_defectRepair_by_pk?: Maybe<Quality_DefectRepair>;
  /** update multiples rows of table: "quality.defectRepair" */
  update_quality_defectRepair_many?: Maybe<Array<Maybe<Quality_DefectRepair_Mutation_Response>>>;
  /** update data of the table: "quality.defectReport" */
  update_quality_defectReport?: Maybe<Quality_DefectReport_Mutation_Response>;
  /** update data of the table: "quality.defectReportPicture" */
  update_quality_defectReportPicture?: Maybe<Quality_DefectReportPicture_Mutation_Response>;
  /** update single row of the table: "quality.defectReportPicture" */
  update_quality_defectReportPicture_by_pk?: Maybe<Quality_DefectReportPicture>;
  /** update multiples rows of table: "quality.defectReportPicture" */
  update_quality_defectReportPicture_many?: Maybe<Array<Maybe<Quality_DefectReportPicture_Mutation_Response>>>;
  /** update data of the table: "quality.defectReportType" */
  update_quality_defectReportType?: Maybe<Quality_DefectReportType_Mutation_Response>;
  /** update single row of the table: "quality.defectReportType" */
  update_quality_defectReportType_by_pk?: Maybe<Quality_DefectReportType>;
  /** update multiples rows of table: "quality.defectReportType" */
  update_quality_defectReportType_many?: Maybe<Array<Maybe<Quality_DefectReportType_Mutation_Response>>>;
  /** update single row of the table: "quality.defectReport" */
  update_quality_defectReport_by_pk?: Maybe<Quality_DefectReport>;
  /** update multiples rows of table: "quality.defectReport" */
  update_quality_defectReport_many?: Maybe<Array<Maybe<Quality_DefectReport_Mutation_Response>>>;
  /** update data of the table: "quality.importConfig" */
  update_quality_importConfig?: Maybe<Quality_ImportConfig_Mutation_Response>;
  /** update single row of the table: "quality.importConfig" */
  update_quality_importConfig_by_pk?: Maybe<Quality_ImportConfig>;
  /** update multiples rows of table: "quality.importConfig" */
  update_quality_importConfig_many?: Maybe<Array<Maybe<Quality_ImportConfig_Mutation_Response>>>;
  /** update data of the table: "quality.importExtraColumn" */
  update_quality_importExtraColumn?: Maybe<Quality_ImportExtraColumn_Mutation_Response>;
  /** update single row of the table: "quality.importExtraColumn" */
  update_quality_importExtraColumn_by_pk?: Maybe<Quality_ImportExtraColumn>;
  /** update multiples rows of table: "quality.importExtraColumn" */
  update_quality_importExtraColumn_many?: Maybe<Array<Maybe<Quality_ImportExtraColumn_Mutation_Response>>>;
  /** update data of the table: "quality.importTask" */
  update_quality_importTask?: Maybe<Quality_ImportTask_Mutation_Response>;
  /** update single row of the table: "quality.importTask" */
  update_quality_importTask_by_pk?: Maybe<Quality_ImportTask>;
  /** update multiples rows of table: "quality.importTask" */
  update_quality_importTask_many?: Maybe<Array<Maybe<Quality_ImportTask_Mutation_Response>>>;
  /** update data of the table: "quality.indicator" */
  update_quality_indicator?: Maybe<Quality_Indicator_Mutation_Response>;
  /** update single row of the table: "quality.indicator" */
  update_quality_indicator_by_pk?: Maybe<Quality_Indicator>;
  /** update multiples rows of table: "quality.indicator" */
  update_quality_indicator_many?: Maybe<Array<Maybe<Quality_Indicator_Mutation_Response>>>;
  /** update data of the table: "quality.quarantineDefect" */
  update_quality_quarantineDefect?: Maybe<Quality_QuarantineDefect_Mutation_Response>;
  /** update data of the table: "quality.quarantineDefectOrientationEnum" */
  update_quality_quarantineDefectOrientationEnum?: Maybe<Quality_QuarantineDefectOrientationEnum_Mutation_Response>;
  /** update single row of the table: "quality.quarantineDefectOrientationEnum" */
  update_quality_quarantineDefectOrientationEnum_by_pk?: Maybe<Quality_QuarantineDefectOrientationEnum>;
  /** update multiples rows of table: "quality.quarantineDefectOrientationEnum" */
  update_quality_quarantineDefectOrientationEnum_many?: Maybe<Array<Maybe<Quality_QuarantineDefectOrientationEnum_Mutation_Response>>>;
  /** update data of the table: "quality.quarantineDefectPicture" */
  update_quality_quarantineDefectPicture?: Maybe<Quality_QuarantineDefectPicture_Mutation_Response>;
  /** update single row of the table: "quality.quarantineDefectPicture" */
  update_quality_quarantineDefectPicture_by_pk?: Maybe<Quality_QuarantineDefectPicture>;
  /** update multiples rows of table: "quality.quarantineDefectPicture" */
  update_quality_quarantineDefectPicture_many?: Maybe<Array<Maybe<Quality_QuarantineDefectPicture_Mutation_Response>>>;
  /** update data of the table: "quality.quarantineDefectType" */
  update_quality_quarantineDefectType?: Maybe<Quality_QuarantineDefectType_Mutation_Response>;
  /** update single row of the table: "quality.quarantineDefectType" */
  update_quality_quarantineDefectType_by_pk?: Maybe<Quality_QuarantineDefectType>;
  /** update multiples rows of table: "quality.quarantineDefectType" */
  update_quality_quarantineDefectType_many?: Maybe<Array<Maybe<Quality_QuarantineDefectType_Mutation_Response>>>;
  /** update single row of the table: "quality.quarantineDefect" */
  update_quality_quarantineDefect_by_pk?: Maybe<Quality_QuarantineDefect>;
  /** update multiples rows of table: "quality.quarantineDefect" */
  update_quality_quarantineDefect_many?: Maybe<Array<Maybe<Quality_QuarantineDefect_Mutation_Response>>>;
  /** update data of the table: "quality.repairReport" */
  update_quality_repairReport?: Maybe<Quality_RepairReport_Mutation_Response>;
  /** update data of the table: "quality.repairReportPicture" */
  update_quality_repairReportPicture?: Maybe<Quality_RepairReportPicture_Mutation_Response>;
  /** update single row of the table: "quality.repairReportPicture" */
  update_quality_repairReportPicture_by_pk?: Maybe<Quality_RepairReportPicture>;
  /** update multiples rows of table: "quality.repairReportPicture" */
  update_quality_repairReportPicture_many?: Maybe<Array<Maybe<Quality_RepairReportPicture_Mutation_Response>>>;
  /** update single row of the table: "quality.repairReport" */
  update_quality_repairReport_by_pk?: Maybe<Quality_RepairReport>;
  /** update multiples rows of table: "quality.repairReport" */
  update_quality_repairReport_many?: Maybe<Array<Maybe<Quality_RepairReport_Mutation_Response>>>;
  /** update data of the table: "quality.ringValidation" */
  update_quality_ringValidation?: Maybe<Quality_RingValidation_Mutation_Response>;
  /** update single row of the table: "quality.ringValidation" */
  update_quality_ringValidation_by_pk?: Maybe<Quality_RingValidation>;
  /** update multiples rows of table: "quality.ringValidation" */
  update_quality_ringValidation_many?: Maybe<Array<Maybe<Quality_RingValidation_Mutation_Response>>>;
  /** update data of the table: "quality.scanCodeConfig" */
  update_quality_scanCodeConfig?: Maybe<Quality_ScanCodeConfig_Mutation_Response>;
  /** update single row of the table: "quality.scanCodeConfig" */
  update_quality_scanCodeConfig_by_pk?: Maybe<Quality_ScanCodeConfig>;
  /** update multiples rows of table: "quality.scanCodeConfig" */
  update_quality_scanCodeConfig_many?: Maybe<Array<Maybe<Quality_ScanCodeConfig_Mutation_Response>>>;
  /** update data of the table: "quality.scanConfig" */
  update_quality_scanConfig?: Maybe<Quality_ScanConfig_Mutation_Response>;
  /** update single row of the table: "quality.scanConfig" */
  update_quality_scanConfig_by_pk?: Maybe<Quality_ScanConfig>;
  /** update multiples rows of table: "quality.scanConfig" */
  update_quality_scanConfig_many?: Maybe<Array<Maybe<Quality_ScanConfig_Mutation_Response>>>;
  /** update data of the table: "quality.scanSite" */
  update_quality_scanSite?: Maybe<Quality_ScanSite_Mutation_Response>;
  /** update data of the table: "quality.scanSiteConstructionSite" */
  update_quality_scanSiteConstructionSite?: Maybe<Quality_ScanSiteConstructionSite_Mutation_Response>;
  /** update single row of the table: "quality.scanSiteConstructionSite" */
  update_quality_scanSiteConstructionSite_by_pk?: Maybe<Quality_ScanSiteConstructionSite>;
  /** update multiples rows of table: "quality.scanSiteConstructionSite" */
  update_quality_scanSiteConstructionSite_many?: Maybe<Array<Maybe<Quality_ScanSiteConstructionSite_Mutation_Response>>>;
  /** update single row of the table: "quality.scanSite" */
  update_quality_scanSite_by_pk?: Maybe<Quality_ScanSite>;
  /** update multiples rows of table: "quality.scanSite" */
  update_quality_scanSite_many?: Maybe<Array<Maybe<Quality_ScanSite_Mutation_Response>>>;
  /** update data of the table: "quality.scanTypeEnum" */
  update_quality_scanTypeEnum?: Maybe<Quality_ScanTypeEnum_Mutation_Response>;
  /** update single row of the table: "quality.scanTypeEnum" */
  update_quality_scanTypeEnum_by_pk?: Maybe<Quality_ScanTypeEnum>;
  /** update multiples rows of table: "quality.scanTypeEnum" */
  update_quality_scanTypeEnum_many?: Maybe<Array<Maybe<Quality_ScanTypeEnum_Mutation_Response>>>;
  /** update data of the table: "quality.segment" */
  update_quality_segment?: Maybe<Quality_Segment_Mutation_Response>;
  /** update data of the table: "quality.segmentDrawConfig" */
  update_quality_segmentDrawConfig?: Maybe<Quality_SegmentDrawConfig_Mutation_Response>;
  /** update single row of the table: "quality.segmentDrawConfig" */
  update_quality_segmentDrawConfig_by_pk?: Maybe<Quality_SegmentDrawConfig>;
  /** update multiples rows of table: "quality.segmentDrawConfig" */
  update_quality_segmentDrawConfig_many?: Maybe<Array<Maybe<Quality_SegmentDrawConfig_Mutation_Response>>>;
  /** update data of the table: "quality.segmentExtraParameter" */
  update_quality_segmentExtraParameter?: Maybe<Quality_SegmentExtraParameter_Mutation_Response>;
  /** update single row of the table: "quality.segmentExtraParameter" */
  update_quality_segmentExtraParameter_by_pk?: Maybe<Quality_SegmentExtraParameter>;
  /** update multiples rows of table: "quality.segmentExtraParameter" */
  update_quality_segmentExtraParameter_many?: Maybe<Array<Maybe<Quality_SegmentExtraParameter_Mutation_Response>>>;
  /** update data of the table: "quality.segmentHistory" */
  update_quality_segmentHistory?: Maybe<Quality_SegmentHistory_Mutation_Response>;
  /** update data of the table: "quality.segmentHistoryStatusEnum" */
  update_quality_segmentHistoryStatusEnum?: Maybe<Quality_SegmentHistoryStatusEnum_Mutation_Response>;
  /** update single row of the table: "quality.segmentHistoryStatusEnum" */
  update_quality_segmentHistoryStatusEnum_by_pk?: Maybe<Quality_SegmentHistoryStatusEnum>;
  /** update multiples rows of table: "quality.segmentHistoryStatusEnum" */
  update_quality_segmentHistoryStatusEnum_many?: Maybe<Array<Maybe<Quality_SegmentHistoryStatusEnum_Mutation_Response>>>;
  /** update single row of the table: "quality.segmentHistory" */
  update_quality_segmentHistory_by_pk?: Maybe<Quality_SegmentHistory>;
  /** update multiples rows of table: "quality.segmentHistory" */
  update_quality_segmentHistory_many?: Maybe<Array<Maybe<Quality_SegmentHistory_Mutation_Response>>>;
  /** update data of the table: "quality.segmentRefusal" */
  update_quality_segmentRefusal?: Maybe<Quality_SegmentRefusal_Mutation_Response>;
  /** update data of the table: "quality.segmentRefusalPicture" */
  update_quality_segmentRefusalPicture?: Maybe<Quality_SegmentRefusalPicture_Mutation_Response>;
  /** update single row of the table: "quality.segmentRefusalPicture" */
  update_quality_segmentRefusalPicture_by_pk?: Maybe<Quality_SegmentRefusalPicture>;
  /** update multiples rows of table: "quality.segmentRefusalPicture" */
  update_quality_segmentRefusalPicture_many?: Maybe<Array<Maybe<Quality_SegmentRefusalPicture_Mutation_Response>>>;
  /** update single row of the table: "quality.segmentRefusal" */
  update_quality_segmentRefusal_by_pk?: Maybe<Quality_SegmentRefusal>;
  /** update multiples rows of table: "quality.segmentRefusal" */
  update_quality_segmentRefusal_many?: Maybe<Array<Maybe<Quality_SegmentRefusal_Mutation_Response>>>;
  /** update single row of the table: "quality.segment" */
  update_quality_segment_by_pk?: Maybe<Quality_Segment>;
  /** update multiples rows of table: "quality.segment" */
  update_quality_segment_many?: Maybe<Array<Maybe<Quality_Segment_Mutation_Response>>>;
  /** update data of the table: "quality.shapeEnum" */
  update_quality_shapeEnum?: Maybe<Quality_ShapeEnum_Mutation_Response>;
  /** update single row of the table: "quality.shapeEnum" */
  update_quality_shapeEnum_by_pk?: Maybe<Quality_ShapeEnum>;
  /** update multiples rows of table: "quality.shapeEnum" */
  update_quality_shapeEnum_many?: Maybe<Array<Maybe<Quality_ShapeEnum_Mutation_Response>>>;
  /** update data of the table: "quality.tunnelPosition" */
  update_quality_tunnelPosition?: Maybe<Quality_TunnelPosition_Mutation_Response>;
  /** update single row of the table: "quality.tunnelPosition" */
  update_quality_tunnelPosition_by_pk?: Maybe<Quality_TunnelPosition>;
  /** update multiples rows of table: "quality.tunnelPosition" */
  update_quality_tunnelPosition_many?: Maybe<Array<Maybe<Quality_TunnelPosition_Mutation_Response>>>;
  /** update data of the table: "quality.userQualityRole" */
  update_quality_userQualityRole?: Maybe<Quality_UserQualityRole_Mutation_Response>;
  /** update single row of the table: "quality.userQualityRole" */
  update_quality_userQualityRole_by_pk?: Maybe<Quality_UserQualityRole>;
  /** update multiples rows of table: "quality.userQualityRole" */
  update_quality_userQualityRole_many?: Maybe<Array<Maybe<Quality_UserQualityRole_Mutation_Response>>>;
  /** update data of the table: "quality.virtualRing" */
  update_quality_virtualRing?: Maybe<Quality_VirtualRing_Mutation_Response>;
  /** update single row of the table: "quality.virtualRing" */
  update_quality_virtualRing_by_pk?: Maybe<Quality_VirtualRing>;
  /** update multiples rows of table: "quality.virtualRing" */
  update_quality_virtualRing_many?: Maybe<Array<Maybe<Quality_VirtualRing_Mutation_Response>>>;
  /** update data of the table: "recurringTask" */
  update_recurringTask?: Maybe<RecurringTask_Mutation_Response>;
  /** update single row of the table: "recurringTask" */
  update_recurringTask_by_pk?: Maybe<RecurringTask>;
  /** update multiples rows of table: "recurringTask" */
  update_recurringTask_many?: Maybe<Array<Maybe<RecurringTask_Mutation_Response>>>;
  /** update data of the table: "scan.user" */
  update_scan_user?: Maybe<Scan_User_Mutation_Response>;
  /** update single row of the table: "scan.user" */
  update_scan_user_by_pk?: Maybe<Scan_User>;
  /** update multiples rows of table: "scan.user" */
  update_scan_user_many?: Maybe<Array<Maybe<Scan_User_Mutation_Response>>>;
  /** update data of the table: "shift" */
  update_shift?: Maybe<Shift_Mutation_Response>;
  /** update data of the table: "shiftLeader" */
  update_shiftLeader?: Maybe<ShiftLeader_Mutation_Response>;
  /** update single row of the table: "shiftLeader" */
  update_shiftLeader_by_pk?: Maybe<ShiftLeader>;
  /** update multiples rows of table: "shiftLeader" */
  update_shiftLeader_many?: Maybe<Array<Maybe<ShiftLeader_Mutation_Response>>>;
  /** update data of the table: "shiftReport" */
  update_shiftReport?: Maybe<ShiftReport_Mutation_Response>;
  /** update single row of the table: "shiftReport" */
  update_shiftReport_by_pk?: Maybe<ShiftReport>;
  /** update multiples rows of table: "shiftReport" */
  update_shiftReport_many?: Maybe<Array<Maybe<ShiftReport_Mutation_Response>>>;
  /** update single row of the table: "shift" */
  update_shift_by_pk?: Maybe<Shift>;
  /** update multiples rows of table: "shift" */
  update_shift_many?: Maybe<Array<Maybe<Shift_Mutation_Response>>>;
  /** update data of the table: "task" */
  update_task?: Maybe<Task_Mutation_Response>;
  /** update single row of the table: "task" */
  update_task_by_pk?: Maybe<Task>;
  /** update multiples rows of table: "task" */
  update_task_many?: Maybe<Array<Maybe<Task_Mutation_Response>>>;
  /** update data of the table: "team" */
  update_team?: Maybe<Team_Mutation_Response>;
  /** update single row of the table: "team" */
  update_team_by_pk?: Maybe<Team>;
  /** update multiples rows of table: "team" */
  update_team_many?: Maybe<Array<Maybe<Team_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update data of the table: "userPermission" */
  update_userPermission?: Maybe<UserPermission_Mutation_Response>;
  /** update single row of the table: "userPermission" */
  update_userPermission_by_pk?: Maybe<UserPermission>;
  /** update multiples rows of table: "userPermission" */
  update_userPermission_many?: Maybe<Array<Maybe<UserPermission_Mutation_Response>>>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
  world?: Maybe<Scalars['String']['output']>;
};


/** mutation root */
export type Mutation_RootCreateActivityExportArgs = {
  constructionSiteId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateFileDeleteTempUrlArgs = {
  fileName: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateFileUploadTempUrlArgs = {
  fileName: Scalars['String']['input'];
  folderName?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootCreateMapPoiExportArgs = {
  constructionSiteId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateMapTraceExportArgs = {
  constructionSiteId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreatePublicFileDeleteTempUrlArgs = {
  fileName: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreatePublicFileUploadTempUrlArgs = {
  fileName: Scalars['String']['input'];
  folderName?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootCreateScanUserArgs = {
  password: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootCreateTimescaleTableArgs = {
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRingComplianceReportArgs = {
  constructionSiteId: Scalars['ID']['input'];
  ringId: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootDeleteScanUserArgs = {
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ActivityArgs = {
  where: Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Activity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AutofillApiArgs = {
  where: AutofillApi_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AutofillApi_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionSiteArgs = {
  where: ConstructionSite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionSiteEnabledModuleArgs = {
  where: ConstructionSiteEnabledModule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ConstructionSiteEnabledModule_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConstructionSite_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DailyShiftTemplateArgs = {
  where: DailyShiftTemplate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_DailyShiftTemplate_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_File_BucketFileArgs = {
  where: File_BucketFile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_BucketFile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_File_BucketTypeEnumArgs = {
  where: File_BucketTypeEnum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_BucketTypeEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_GraphSetArgs = {
  where: GraphSet_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_GraphSetTypeEnumArgs = {
  where: GraphSetTypeEnum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_GraphSetTypeEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_GraphSet_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_IndicatorArgs = {
  where: Indicator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Indicator_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MapConfigurationArgs = {
  where: MapConfiguration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MapConfiguration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MapPoiArgs = {
  where: MapPoi_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MapPoi_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MapTraceArgs = {
  where: MapTrace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MapTrace_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ModuleArgs = {
  where: Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Module_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OperatorArgs = {
  where: Operator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operator_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parameter_ConstructionSiteParameterNameConfigArgs = {
  where: Parameter_ConstructionSiteParameterNameConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parameter_ConstructionSiteParameterNameConfig_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parameter_FamilyDefArgs = {
  where: Parameter_FamilyDef_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parameter_FamilyDef_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parameter_MetricArgs = {
  where: Parameter_Metric_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parameter_Metric_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parameter_ParameterDefArgs = {
  where: Parameter_ParameterDef_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parameter_ParameterDef_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parameter_RingArgs = {
  where: Parameter_Ring_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parameter_RingProjectionArgs = {
  where: Parameter_RingProjection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parameter_RingProjection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parameter_Ring_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Parameter_ValueArgs = {
  where: Parameter_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parameter_Value_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PermissionTypeArgs = {
  where: PermissionType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PermissionType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectArgs = {
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_BoardConfigArgs = {
  where: Quality_BoardConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_BoardConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_BoardSegmentArgs = {
  where: Quality_BoardSegment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_BoardSegment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_DefectRepairArgs = {
  where: Quality_DefectRepair_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_DefectRepairPictureArgs = {
  where: Quality_DefectRepairPicture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_DefectRepairPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_DefectRepairTypeArgs = {
  where: Quality_DefectRepairType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_DefectRepairType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_DefectRepair_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_DefectReportArgs = {
  where: Quality_DefectReport_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_DefectReportPictureArgs = {
  where: Quality_DefectReportPicture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_DefectReportPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_DefectReportTypeArgs = {
  where: Quality_DefectReportType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_DefectReportType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_DefectReport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_ImportConfigArgs = {
  where: Quality_ImportConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_ImportConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_ImportExtraColumnArgs = {
  where: Quality_ImportExtraColumn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_ImportExtraColumn_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_ImportTaskArgs = {
  where: Quality_ImportTask_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_ImportTask_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_IndicatorArgs = {
  where: Quality_Indicator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_Indicator_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_QuarantineDefectArgs = {
  where: Quality_QuarantineDefect_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_QuarantineDefectOrientationEnumArgs = {
  where: Quality_QuarantineDefectOrientationEnum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_QuarantineDefectOrientationEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_QuarantineDefectPictureArgs = {
  where: Quality_QuarantineDefectPicture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_QuarantineDefectPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_QuarantineDefectTypeArgs = {
  where: Quality_QuarantineDefectType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_QuarantineDefectType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_QuarantineDefect_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_RepairReportArgs = {
  where: Quality_RepairReport_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_RepairReportPictureArgs = {
  where: Quality_RepairReportPicture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_RepairReportPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_RepairReport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_RingValidationArgs = {
  where: Quality_RingValidation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_RingValidation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_ScanCodeConfigArgs = {
  where: Quality_ScanCodeConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_ScanCodeConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_ScanConfigArgs = {
  where: Quality_ScanConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_ScanConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_ScanSiteArgs = {
  where: Quality_ScanSite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_ScanSiteConstructionSiteArgs = {
  where: Quality_ScanSiteConstructionSite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_ScanSiteConstructionSite_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_ScanSite_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_ScanTypeEnumArgs = {
  where: Quality_ScanTypeEnum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_ScanTypeEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_SegmentArgs = {
  where: Quality_Segment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_SegmentDrawConfigArgs = {
  where: Quality_SegmentDrawConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_SegmentDrawConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_SegmentExtraParameterArgs = {
  where: Quality_SegmentExtraParameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_SegmentExtraParameter_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_SegmentHistoryArgs = {
  where: Quality_SegmentHistory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_SegmentHistoryStatusEnumArgs = {
  where: Quality_SegmentHistoryStatusEnum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_SegmentHistoryStatusEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_SegmentHistory_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_SegmentRefusalArgs = {
  where: Quality_SegmentRefusal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_SegmentRefusalPictureArgs = {
  where: Quality_SegmentRefusalPicture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_SegmentRefusalPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_SegmentRefusal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_Segment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_ShapeEnumArgs = {
  where: Quality_ShapeEnum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_ShapeEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_TunnelPositionArgs = {
  where: Quality_TunnelPosition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_TunnelPosition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_UserQualityRoleArgs = {
  where: Quality_UserQualityRole_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_UserQualityRole_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quality_VirtualRingArgs = {
  where: Quality_VirtualRing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quality_VirtualRing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RecurringTaskArgs = {
  where: RecurringTask_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RecurringTask_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Scan_UserArgs = {
  where: Scan_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scan_User_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ShiftArgs = {
  where: Shift_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ShiftLeaderArgs = {
  where: ShiftLeader_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ShiftLeader_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ShiftReportArgs = {
  where: ShiftReport_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ShiftReport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Shift_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TaskArgs = {
  where: Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TeamArgs = {
  where: Team_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserPermissionArgs = {
  where: UserPermission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserPermission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootGenerateAggregatedPdfArgs = {
  constructionSiteId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  language: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGenerateExcelFromBiDataArgs = {
  fileName: Scalars['String']['input'];
  graphData: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGenerateExcelFromTaskRangeExportArgs = {
  constructionSiteId: Scalars['ID']['input'];
  endDate: Scalars['date']['input'];
  locale: Scalars['String']['input'];
  startDate: Scalars['date']['input'];
};


/** mutation root */
export type Mutation_RootGenerateRingComplianceReportArgs = {
  constructionSiteId: Scalars['ID']['input'];
  ringId: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootGenerateShiftReportPdfArgs = {
  language: Scalars['String']['input'];
  shiftReportId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGenerateShiftReportPdfsArgs = {
  constructionSiteId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  language: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsert_ActivityArgs = {
  objects: Array<Activity_Insert_Input>;
  on_conflict?: InputMaybe<Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_OneArgs = {
  object: Activity_Insert_Input;
  on_conflict?: InputMaybe<Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AutofillApiArgs = {
  objects: Array<AutofillApi_Insert_Input>;
  on_conflict?: InputMaybe<AutofillApi_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AutofillApi_OneArgs = {
  object: AutofillApi_Insert_Input;
  on_conflict?: InputMaybe<AutofillApi_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionSiteArgs = {
  objects: Array<ConstructionSite_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionSite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionSiteEnabledModuleArgs = {
  objects: Array<ConstructionSiteEnabledModule_Insert_Input>;
  on_conflict?: InputMaybe<ConstructionSiteEnabledModule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionSiteEnabledModule_OneArgs = {
  object: ConstructionSiteEnabledModule_Insert_Input;
  on_conflict?: InputMaybe<ConstructionSiteEnabledModule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConstructionSite_OneArgs = {
  object: ConstructionSite_Insert_Input;
  on_conflict?: InputMaybe<ConstructionSite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DailyShiftTemplateArgs = {
  objects: Array<DailyShiftTemplate_Insert_Input>;
  on_conflict?: InputMaybe<DailyShiftTemplate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DailyShiftTemplate_OneArgs = {
  object: DailyShiftTemplate_Insert_Input;
  on_conflict?: InputMaybe<DailyShiftTemplate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_BucketFileArgs = {
  objects: Array<File_BucketFile_Insert_Input>;
  on_conflict?: InputMaybe<File_BucketFile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_BucketFile_OneArgs = {
  object: File_BucketFile_Insert_Input;
  on_conflict?: InputMaybe<File_BucketFile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_BucketTypeEnumArgs = {
  objects: Array<File_BucketTypeEnum_Insert_Input>;
  on_conflict?: InputMaybe<File_BucketTypeEnum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_BucketTypeEnum_OneArgs = {
  object: File_BucketTypeEnum_Insert_Input;
  on_conflict?: InputMaybe<File_BucketTypeEnum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GraphSetArgs = {
  objects: Array<GraphSet_Insert_Input>;
  on_conflict?: InputMaybe<GraphSet_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GraphSetTypeEnumArgs = {
  objects: Array<GraphSetTypeEnum_Insert_Input>;
  on_conflict?: InputMaybe<GraphSetTypeEnum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GraphSetTypeEnum_OneArgs = {
  object: GraphSetTypeEnum_Insert_Input;
  on_conflict?: InputMaybe<GraphSetTypeEnum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GraphSet_OneArgs = {
  object: GraphSet_Insert_Input;
  on_conflict?: InputMaybe<GraphSet_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IndicatorArgs = {
  objects: Array<Indicator_Insert_Input>;
  on_conflict?: InputMaybe<Indicator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Indicator_OneArgs = {
  object: Indicator_Insert_Input;
  on_conflict?: InputMaybe<Indicator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MapConfigurationArgs = {
  objects: Array<MapConfiguration_Insert_Input>;
  on_conflict?: InputMaybe<MapConfiguration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MapConfiguration_OneArgs = {
  object: MapConfiguration_Insert_Input;
  on_conflict?: InputMaybe<MapConfiguration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MapPoiArgs = {
  objects: Array<MapPoi_Insert_Input>;
  on_conflict?: InputMaybe<MapPoi_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MapPoi_OneArgs = {
  object: MapPoi_Insert_Input;
  on_conflict?: InputMaybe<MapPoi_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MapTraceArgs = {
  objects: Array<MapTrace_Insert_Input>;
  on_conflict?: InputMaybe<MapTrace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MapTrace_OneArgs = {
  object: MapTrace_Insert_Input;
  on_conflict?: InputMaybe<MapTrace_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ModuleArgs = {
  objects: Array<Module_Insert_Input>;
  on_conflict?: InputMaybe<Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_OneArgs = {
  object: Module_Insert_Input;
  on_conflict?: InputMaybe<Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OperatorArgs = {
  objects: Array<Operator_Insert_Input>;
  on_conflict?: InputMaybe<Operator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operator_OneArgs = {
  object: Operator_Insert_Input;
  on_conflict?: InputMaybe<Operator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_ConstructionSiteParameterNameConfigArgs = {
  objects: Array<Parameter_ConstructionSiteParameterNameConfig_Insert_Input>;
  on_conflict?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_ConstructionSiteParameterNameConfig_OneArgs = {
  object: Parameter_ConstructionSiteParameterNameConfig_Insert_Input;
  on_conflict?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_FamilyDefArgs = {
  objects: Array<Parameter_FamilyDef_Insert_Input>;
  on_conflict?: InputMaybe<Parameter_FamilyDef_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_FamilyDef_OneArgs = {
  object: Parameter_FamilyDef_Insert_Input;
  on_conflict?: InputMaybe<Parameter_FamilyDef_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_MetricArgs = {
  objects: Array<Parameter_Metric_Insert_Input>;
  on_conflict?: InputMaybe<Parameter_Metric_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_Metric_OneArgs = {
  object: Parameter_Metric_Insert_Input;
  on_conflict?: InputMaybe<Parameter_Metric_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_ParameterDefArgs = {
  objects: Array<Parameter_ParameterDef_Insert_Input>;
  on_conflict?: InputMaybe<Parameter_ParameterDef_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_ParameterDef_OneArgs = {
  object: Parameter_ParameterDef_Insert_Input;
  on_conflict?: InputMaybe<Parameter_ParameterDef_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_RingArgs = {
  objects: Array<Parameter_Ring_Insert_Input>;
  on_conflict?: InputMaybe<Parameter_Ring_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_RingProjectionArgs = {
  objects: Array<Parameter_RingProjection_Insert_Input>;
  on_conflict?: InputMaybe<Parameter_RingProjection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_RingProjection_OneArgs = {
  object: Parameter_RingProjection_Insert_Input;
  on_conflict?: InputMaybe<Parameter_RingProjection_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_Ring_OneArgs = {
  object: Parameter_Ring_Insert_Input;
  on_conflict?: InputMaybe<Parameter_Ring_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_ValueArgs = {
  objects: Array<Parameter_Value_Insert_Input>;
  on_conflict?: InputMaybe<Parameter_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parameter_Value_OneArgs = {
  object: Parameter_Value_Insert_Input;
  on_conflict?: InputMaybe<Parameter_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PermissionTypeArgs = {
  objects: Array<PermissionType_Insert_Input>;
  on_conflict?: InputMaybe<PermissionType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PermissionType_OneArgs = {
  object: PermissionType_Insert_Input;
  on_conflict?: InputMaybe<PermissionType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectArgs = {
  objects: Array<Project_Insert_Input>;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_OneArgs = {
  object: Project_Insert_Input;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_BoardConfigArgs = {
  objects: Array<Quality_BoardConfig_Insert_Input>;
  on_conflict?: InputMaybe<Quality_BoardConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_BoardConfig_OneArgs = {
  object: Quality_BoardConfig_Insert_Input;
  on_conflict?: InputMaybe<Quality_BoardConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_BoardSegmentArgs = {
  objects: Array<Quality_BoardSegment_Insert_Input>;
  on_conflict?: InputMaybe<Quality_BoardSegment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_BoardSegment_OneArgs = {
  object: Quality_BoardSegment_Insert_Input;
  on_conflict?: InputMaybe<Quality_BoardSegment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_DefectRepairArgs = {
  objects: Array<Quality_DefectRepair_Insert_Input>;
  on_conflict?: InputMaybe<Quality_DefectRepair_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_DefectRepairPictureArgs = {
  objects: Array<Quality_DefectRepairPicture_Insert_Input>;
  on_conflict?: InputMaybe<Quality_DefectRepairPicture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_DefectRepairPicture_OneArgs = {
  object: Quality_DefectRepairPicture_Insert_Input;
  on_conflict?: InputMaybe<Quality_DefectRepairPicture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_DefectRepairTypeArgs = {
  objects: Array<Quality_DefectRepairType_Insert_Input>;
  on_conflict?: InputMaybe<Quality_DefectRepairType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_DefectRepairType_OneArgs = {
  object: Quality_DefectRepairType_Insert_Input;
  on_conflict?: InputMaybe<Quality_DefectRepairType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_DefectRepair_OneArgs = {
  object: Quality_DefectRepair_Insert_Input;
  on_conflict?: InputMaybe<Quality_DefectRepair_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_DefectReportArgs = {
  objects: Array<Quality_DefectReport_Insert_Input>;
  on_conflict?: InputMaybe<Quality_DefectReport_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_DefectReportPictureArgs = {
  objects: Array<Quality_DefectReportPicture_Insert_Input>;
  on_conflict?: InputMaybe<Quality_DefectReportPicture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_DefectReportPicture_OneArgs = {
  object: Quality_DefectReportPicture_Insert_Input;
  on_conflict?: InputMaybe<Quality_DefectReportPicture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_DefectReportTypeArgs = {
  objects: Array<Quality_DefectReportType_Insert_Input>;
  on_conflict?: InputMaybe<Quality_DefectReportType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_DefectReportType_OneArgs = {
  object: Quality_DefectReportType_Insert_Input;
  on_conflict?: InputMaybe<Quality_DefectReportType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_DefectReport_OneArgs = {
  object: Quality_DefectReport_Insert_Input;
  on_conflict?: InputMaybe<Quality_DefectReport_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ImportConfigArgs = {
  objects: Array<Quality_ImportConfig_Insert_Input>;
  on_conflict?: InputMaybe<Quality_ImportConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ImportConfig_OneArgs = {
  object: Quality_ImportConfig_Insert_Input;
  on_conflict?: InputMaybe<Quality_ImportConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ImportExtraColumnArgs = {
  objects: Array<Quality_ImportExtraColumn_Insert_Input>;
  on_conflict?: InputMaybe<Quality_ImportExtraColumn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ImportExtraColumn_OneArgs = {
  object: Quality_ImportExtraColumn_Insert_Input;
  on_conflict?: InputMaybe<Quality_ImportExtraColumn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ImportTaskArgs = {
  objects: Array<Quality_ImportTask_Insert_Input>;
  on_conflict?: InputMaybe<Quality_ImportTask_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ImportTask_OneArgs = {
  object: Quality_ImportTask_Insert_Input;
  on_conflict?: InputMaybe<Quality_ImportTask_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_IndicatorArgs = {
  objects: Array<Quality_Indicator_Insert_Input>;
  on_conflict?: InputMaybe<Quality_Indicator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_Indicator_OneArgs = {
  object: Quality_Indicator_Insert_Input;
  on_conflict?: InputMaybe<Quality_Indicator_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_QuarantineDefectArgs = {
  objects: Array<Quality_QuarantineDefect_Insert_Input>;
  on_conflict?: InputMaybe<Quality_QuarantineDefect_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_QuarantineDefectOrientationEnumArgs = {
  objects: Array<Quality_QuarantineDefectOrientationEnum_Insert_Input>;
  on_conflict?: InputMaybe<Quality_QuarantineDefectOrientationEnum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_QuarantineDefectOrientationEnum_OneArgs = {
  object: Quality_QuarantineDefectOrientationEnum_Insert_Input;
  on_conflict?: InputMaybe<Quality_QuarantineDefectOrientationEnum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_QuarantineDefectPictureArgs = {
  objects: Array<Quality_QuarantineDefectPicture_Insert_Input>;
  on_conflict?: InputMaybe<Quality_QuarantineDefectPicture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_QuarantineDefectPicture_OneArgs = {
  object: Quality_QuarantineDefectPicture_Insert_Input;
  on_conflict?: InputMaybe<Quality_QuarantineDefectPicture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_QuarantineDefectTypeArgs = {
  objects: Array<Quality_QuarantineDefectType_Insert_Input>;
  on_conflict?: InputMaybe<Quality_QuarantineDefectType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_QuarantineDefectType_OneArgs = {
  object: Quality_QuarantineDefectType_Insert_Input;
  on_conflict?: InputMaybe<Quality_QuarantineDefectType_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_QuarantineDefect_OneArgs = {
  object: Quality_QuarantineDefect_Insert_Input;
  on_conflict?: InputMaybe<Quality_QuarantineDefect_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_RepairReportArgs = {
  objects: Array<Quality_RepairReport_Insert_Input>;
  on_conflict?: InputMaybe<Quality_RepairReport_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_RepairReportPictureArgs = {
  objects: Array<Quality_RepairReportPicture_Insert_Input>;
  on_conflict?: InputMaybe<Quality_RepairReportPicture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_RepairReportPicture_OneArgs = {
  object: Quality_RepairReportPicture_Insert_Input;
  on_conflict?: InputMaybe<Quality_RepairReportPicture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_RepairReport_OneArgs = {
  object: Quality_RepairReport_Insert_Input;
  on_conflict?: InputMaybe<Quality_RepairReport_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_RingValidationArgs = {
  objects: Array<Quality_RingValidation_Insert_Input>;
  on_conflict?: InputMaybe<Quality_RingValidation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_RingValidation_OneArgs = {
  object: Quality_RingValidation_Insert_Input;
  on_conflict?: InputMaybe<Quality_RingValidation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ScanCodeConfigArgs = {
  objects: Array<Quality_ScanCodeConfig_Insert_Input>;
  on_conflict?: InputMaybe<Quality_ScanCodeConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ScanCodeConfig_OneArgs = {
  object: Quality_ScanCodeConfig_Insert_Input;
  on_conflict?: InputMaybe<Quality_ScanCodeConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ScanConfigArgs = {
  objects: Array<Quality_ScanConfig_Insert_Input>;
  on_conflict?: InputMaybe<Quality_ScanConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ScanConfig_OneArgs = {
  object: Quality_ScanConfig_Insert_Input;
  on_conflict?: InputMaybe<Quality_ScanConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ScanSiteArgs = {
  objects: Array<Quality_ScanSite_Insert_Input>;
  on_conflict?: InputMaybe<Quality_ScanSite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ScanSiteConstructionSiteArgs = {
  objects: Array<Quality_ScanSiteConstructionSite_Insert_Input>;
  on_conflict?: InputMaybe<Quality_ScanSiteConstructionSite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ScanSiteConstructionSite_OneArgs = {
  object: Quality_ScanSiteConstructionSite_Insert_Input;
  on_conflict?: InputMaybe<Quality_ScanSiteConstructionSite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ScanSite_OneArgs = {
  object: Quality_ScanSite_Insert_Input;
  on_conflict?: InputMaybe<Quality_ScanSite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ScanTypeEnumArgs = {
  objects: Array<Quality_ScanTypeEnum_Insert_Input>;
  on_conflict?: InputMaybe<Quality_ScanTypeEnum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ScanTypeEnum_OneArgs = {
  object: Quality_ScanTypeEnum_Insert_Input;
  on_conflict?: InputMaybe<Quality_ScanTypeEnum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_SegmentArgs = {
  objects: Array<Quality_Segment_Insert_Input>;
  on_conflict?: InputMaybe<Quality_Segment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_SegmentDrawConfigArgs = {
  objects: Array<Quality_SegmentDrawConfig_Insert_Input>;
  on_conflict?: InputMaybe<Quality_SegmentDrawConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_SegmentDrawConfig_OneArgs = {
  object: Quality_SegmentDrawConfig_Insert_Input;
  on_conflict?: InputMaybe<Quality_SegmentDrawConfig_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_SegmentExtraParameterArgs = {
  objects: Array<Quality_SegmentExtraParameter_Insert_Input>;
  on_conflict?: InputMaybe<Quality_SegmentExtraParameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_SegmentExtraParameter_OneArgs = {
  object: Quality_SegmentExtraParameter_Insert_Input;
  on_conflict?: InputMaybe<Quality_SegmentExtraParameter_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_SegmentHistoryArgs = {
  objects: Array<Quality_SegmentHistory_Insert_Input>;
  on_conflict?: InputMaybe<Quality_SegmentHistory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_SegmentHistoryStatusEnumArgs = {
  objects: Array<Quality_SegmentHistoryStatusEnum_Insert_Input>;
  on_conflict?: InputMaybe<Quality_SegmentHistoryStatusEnum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_SegmentHistoryStatusEnum_OneArgs = {
  object: Quality_SegmentHistoryStatusEnum_Insert_Input;
  on_conflict?: InputMaybe<Quality_SegmentHistoryStatusEnum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_SegmentHistory_OneArgs = {
  object: Quality_SegmentHistory_Insert_Input;
  on_conflict?: InputMaybe<Quality_SegmentHistory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_SegmentRefusalArgs = {
  objects: Array<Quality_SegmentRefusal_Insert_Input>;
  on_conflict?: InputMaybe<Quality_SegmentRefusal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_SegmentRefusalPictureArgs = {
  objects: Array<Quality_SegmentRefusalPicture_Insert_Input>;
  on_conflict?: InputMaybe<Quality_SegmentRefusalPicture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_SegmentRefusalPicture_OneArgs = {
  object: Quality_SegmentRefusalPicture_Insert_Input;
  on_conflict?: InputMaybe<Quality_SegmentRefusalPicture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_SegmentRefusal_OneArgs = {
  object: Quality_SegmentRefusal_Insert_Input;
  on_conflict?: InputMaybe<Quality_SegmentRefusal_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_Segment_OneArgs = {
  object: Quality_Segment_Insert_Input;
  on_conflict?: InputMaybe<Quality_Segment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ShapeEnumArgs = {
  objects: Array<Quality_ShapeEnum_Insert_Input>;
  on_conflict?: InputMaybe<Quality_ShapeEnum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_ShapeEnum_OneArgs = {
  object: Quality_ShapeEnum_Insert_Input;
  on_conflict?: InputMaybe<Quality_ShapeEnum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_TunnelPositionArgs = {
  objects: Array<Quality_TunnelPosition_Insert_Input>;
  on_conflict?: InputMaybe<Quality_TunnelPosition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_TunnelPosition_OneArgs = {
  object: Quality_TunnelPosition_Insert_Input;
  on_conflict?: InputMaybe<Quality_TunnelPosition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_UserQualityRoleArgs = {
  objects: Array<Quality_UserQualityRole_Insert_Input>;
  on_conflict?: InputMaybe<Quality_UserQualityRole_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_UserQualityRole_OneArgs = {
  object: Quality_UserQualityRole_Insert_Input;
  on_conflict?: InputMaybe<Quality_UserQualityRole_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_VirtualRingArgs = {
  objects: Array<Quality_VirtualRing_Insert_Input>;
  on_conflict?: InputMaybe<Quality_VirtualRing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quality_VirtualRing_OneArgs = {
  object: Quality_VirtualRing_Insert_Input;
  on_conflict?: InputMaybe<Quality_VirtualRing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RecurringTaskArgs = {
  objects: Array<RecurringTask_Insert_Input>;
  on_conflict?: InputMaybe<RecurringTask_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RecurringTask_OneArgs = {
  object: RecurringTask_Insert_Input;
  on_conflict?: InputMaybe<RecurringTask_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scan_UserArgs = {
  objects: Array<Scan_User_Insert_Input>;
  on_conflict?: InputMaybe<Scan_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scan_User_OneArgs = {
  object: Scan_User_Insert_Input;
  on_conflict?: InputMaybe<Scan_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ShiftArgs = {
  objects: Array<Shift_Insert_Input>;
  on_conflict?: InputMaybe<Shift_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ShiftLeaderArgs = {
  objects: Array<ShiftLeader_Insert_Input>;
  on_conflict?: InputMaybe<ShiftLeader_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ShiftLeader_OneArgs = {
  object: ShiftLeader_Insert_Input;
  on_conflict?: InputMaybe<ShiftLeader_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ShiftReportArgs = {
  objects: Array<ShiftReport_Insert_Input>;
  on_conflict?: InputMaybe<ShiftReport_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ShiftReport_OneArgs = {
  object: ShiftReport_Insert_Input;
  on_conflict?: InputMaybe<ShiftReport_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Shift_OneArgs = {
  object: Shift_Insert_Input;
  on_conflict?: InputMaybe<Shift_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TaskArgs = {
  objects: Array<Task_Insert_Input>;
  on_conflict?: InputMaybe<Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_OneArgs = {
  object: Task_Insert_Input;
  on_conflict?: InputMaybe<Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TeamArgs = {
  objects: Array<Team_Insert_Input>;
  on_conflict?: InputMaybe<Team_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_OneArgs = {
  object: Team_Insert_Input;
  on_conflict?: InputMaybe<Team_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserPermissionArgs = {
  objects: Array<UserPermission_Insert_Input>;
  on_conflict?: InputMaybe<UserPermission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserPermission_OneArgs = {
  object: UserPermission_Insert_Input;
  on_conflict?: InputMaybe<UserPermission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootShiftReportAutofillArgs = {
  input: ShiftReportAutofillInput;
};


/** mutation root */
export type Mutation_RootShiftReportAutofillV2Args = {
  input: ShiftReportAutofillV2Input;
};


/** mutation root */
export type Mutation_RootUnapproveRingComplianceReportsArgs = {
  constructionSiteId: Scalars['ID']['input'];
  fromRingNumber: Scalars['Int']['input'];
  toRingNumber: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootUpdateActivityTechnicalDataArgs = {
  id: Scalars['ID']['input'];
};


/** mutation root */
export type Mutation_RootUpdate_ActivityArgs = {
  _inc?: InputMaybe<Activity_Inc_Input>;
  _set?: InputMaybe<Activity_Set_Input>;
  where: Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_By_PkArgs = {
  _inc?: InputMaybe<Activity_Inc_Input>;
  _set?: InputMaybe<Activity_Set_Input>;
  pk_columns: Activity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_ManyArgs = {
  updates: Array<Activity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AutofillApiArgs = {
  _inc?: InputMaybe<AutofillApi_Inc_Input>;
  _set?: InputMaybe<AutofillApi_Set_Input>;
  where: AutofillApi_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AutofillApi_By_PkArgs = {
  _inc?: InputMaybe<AutofillApi_Inc_Input>;
  _set?: InputMaybe<AutofillApi_Set_Input>;
  pk_columns: AutofillApi_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AutofillApi_ManyArgs = {
  updates: Array<AutofillApi_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionSiteArgs = {
  _inc?: InputMaybe<ConstructionSite_Inc_Input>;
  _set?: InputMaybe<ConstructionSite_Set_Input>;
  where: ConstructionSite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionSiteEnabledModuleArgs = {
  _set?: InputMaybe<ConstructionSiteEnabledModule_Set_Input>;
  where: ConstructionSiteEnabledModule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionSiteEnabledModule_By_PkArgs = {
  _set?: InputMaybe<ConstructionSiteEnabledModule_Set_Input>;
  pk_columns: ConstructionSiteEnabledModule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionSiteEnabledModule_ManyArgs = {
  updates: Array<ConstructionSiteEnabledModule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionSite_By_PkArgs = {
  _inc?: InputMaybe<ConstructionSite_Inc_Input>;
  _set?: InputMaybe<ConstructionSite_Set_Input>;
  pk_columns: ConstructionSite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ConstructionSite_ManyArgs = {
  updates: Array<ConstructionSite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DailyShiftTemplateArgs = {
  _set?: InputMaybe<DailyShiftTemplate_Set_Input>;
  where: DailyShiftTemplate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_DailyShiftTemplate_By_PkArgs = {
  _set?: InputMaybe<DailyShiftTemplate_Set_Input>;
  pk_columns: DailyShiftTemplate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_DailyShiftTemplate_ManyArgs = {
  updates: Array<DailyShiftTemplate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_File_BucketFileArgs = {
  _inc?: InputMaybe<File_BucketFile_Inc_Input>;
  _set?: InputMaybe<File_BucketFile_Set_Input>;
  where: File_BucketFile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_BucketFile_By_PkArgs = {
  _inc?: InputMaybe<File_BucketFile_Inc_Input>;
  _set?: InputMaybe<File_BucketFile_Set_Input>;
  pk_columns: File_BucketFile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_File_BucketFile_ManyArgs = {
  updates: Array<File_BucketFile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_File_BucketTypeEnumArgs = {
  _set?: InputMaybe<File_BucketTypeEnum_Set_Input>;
  where: File_BucketTypeEnum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_BucketTypeEnum_By_PkArgs = {
  _set?: InputMaybe<File_BucketTypeEnum_Set_Input>;
  pk_columns: File_BucketTypeEnum_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_File_BucketTypeEnum_ManyArgs = {
  updates: Array<File_BucketTypeEnum_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GraphSetArgs = {
  _append?: InputMaybe<GraphSet_Append_Input>;
  _delete_at_path?: InputMaybe<GraphSet_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<GraphSet_Delete_Elem_Input>;
  _delete_key?: InputMaybe<GraphSet_Delete_Key_Input>;
  _inc?: InputMaybe<GraphSet_Inc_Input>;
  _prepend?: InputMaybe<GraphSet_Prepend_Input>;
  _set?: InputMaybe<GraphSet_Set_Input>;
  where: GraphSet_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_GraphSetTypeEnumArgs = {
  _set?: InputMaybe<GraphSetTypeEnum_Set_Input>;
  where: GraphSetTypeEnum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_GraphSetTypeEnum_By_PkArgs = {
  _set?: InputMaybe<GraphSetTypeEnum_Set_Input>;
  pk_columns: GraphSetTypeEnum_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_GraphSetTypeEnum_ManyArgs = {
  updates: Array<GraphSetTypeEnum_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GraphSet_By_PkArgs = {
  _append?: InputMaybe<GraphSet_Append_Input>;
  _delete_at_path?: InputMaybe<GraphSet_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<GraphSet_Delete_Elem_Input>;
  _delete_key?: InputMaybe<GraphSet_Delete_Key_Input>;
  _inc?: InputMaybe<GraphSet_Inc_Input>;
  _prepend?: InputMaybe<GraphSet_Prepend_Input>;
  _set?: InputMaybe<GraphSet_Set_Input>;
  pk_columns: GraphSet_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_GraphSet_ManyArgs = {
  updates: Array<GraphSet_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorArgs = {
  _set?: InputMaybe<Indicator_Set_Input>;
  where: Indicator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Indicator_By_PkArgs = {
  _set?: InputMaybe<Indicator_Set_Input>;
  pk_columns: Indicator_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Indicator_ManyArgs = {
  updates: Array<Indicator_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MapConfigurationArgs = {
  _inc?: InputMaybe<MapConfiguration_Inc_Input>;
  _set?: InputMaybe<MapConfiguration_Set_Input>;
  where: MapConfiguration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MapConfiguration_By_PkArgs = {
  _inc?: InputMaybe<MapConfiguration_Inc_Input>;
  _set?: InputMaybe<MapConfiguration_Set_Input>;
  pk_columns: MapConfiguration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MapConfiguration_ManyArgs = {
  updates: Array<MapConfiguration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MapPoiArgs = {
  _inc?: InputMaybe<MapPoi_Inc_Input>;
  _set?: InputMaybe<MapPoi_Set_Input>;
  where: MapPoi_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MapPoi_By_PkArgs = {
  _inc?: InputMaybe<MapPoi_Inc_Input>;
  _set?: InputMaybe<MapPoi_Set_Input>;
  pk_columns: MapPoi_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MapPoi_ManyArgs = {
  updates: Array<MapPoi_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MapTraceArgs = {
  _inc?: InputMaybe<MapTrace_Inc_Input>;
  _set?: InputMaybe<MapTrace_Set_Input>;
  where: MapTrace_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MapTrace_By_PkArgs = {
  _inc?: InputMaybe<MapTrace_Inc_Input>;
  _set?: InputMaybe<MapTrace_Set_Input>;
  pk_columns: MapTrace_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MapTrace_ManyArgs = {
  updates: Array<MapTrace_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ModuleArgs = {
  _set?: InputMaybe<Module_Set_Input>;
  where: Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Module_By_PkArgs = {
  _set?: InputMaybe<Module_Set_Input>;
  pk_columns: Module_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Module_ManyArgs = {
  updates: Array<Module_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OperatorArgs = {
  _set?: InputMaybe<Operator_Set_Input>;
  where: Operator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operator_By_PkArgs = {
  _set?: InputMaybe<Operator_Set_Input>;
  pk_columns: Operator_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operator_ManyArgs = {
  updates: Array<Operator_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_ConstructionSiteParameterNameConfigArgs = {
  _inc?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Inc_Input>;
  _set?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Set_Input>;
  where: Parameter_ConstructionSiteParameterNameConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_ConstructionSiteParameterNameConfig_By_PkArgs = {
  _inc?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Inc_Input>;
  _set?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Set_Input>;
  pk_columns: Parameter_ConstructionSiteParameterNameConfig_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_ConstructionSiteParameterNameConfig_ManyArgs = {
  updates: Array<Parameter_ConstructionSiteParameterNameConfig_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_FamilyDefArgs = {
  _inc?: InputMaybe<Parameter_FamilyDef_Inc_Input>;
  _set?: InputMaybe<Parameter_FamilyDef_Set_Input>;
  where: Parameter_FamilyDef_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_FamilyDef_By_PkArgs = {
  _inc?: InputMaybe<Parameter_FamilyDef_Inc_Input>;
  _set?: InputMaybe<Parameter_FamilyDef_Set_Input>;
  pk_columns: Parameter_FamilyDef_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_FamilyDef_ManyArgs = {
  updates: Array<Parameter_FamilyDef_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_MetricArgs = {
  _append?: InputMaybe<Parameter_Metric_Append_Input>;
  _delete_at_path?: InputMaybe<Parameter_Metric_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Parameter_Metric_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Parameter_Metric_Delete_Key_Input>;
  _inc?: InputMaybe<Parameter_Metric_Inc_Input>;
  _prepend?: InputMaybe<Parameter_Metric_Prepend_Input>;
  _set?: InputMaybe<Parameter_Metric_Set_Input>;
  where: Parameter_Metric_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_Metric_By_PkArgs = {
  _append?: InputMaybe<Parameter_Metric_Append_Input>;
  _delete_at_path?: InputMaybe<Parameter_Metric_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Parameter_Metric_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Parameter_Metric_Delete_Key_Input>;
  _inc?: InputMaybe<Parameter_Metric_Inc_Input>;
  _prepend?: InputMaybe<Parameter_Metric_Prepend_Input>;
  _set?: InputMaybe<Parameter_Metric_Set_Input>;
  pk_columns: Parameter_Metric_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_Metric_ManyArgs = {
  updates: Array<Parameter_Metric_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_ParameterDefArgs = {
  _inc?: InputMaybe<Parameter_ParameterDef_Inc_Input>;
  _set?: InputMaybe<Parameter_ParameterDef_Set_Input>;
  where: Parameter_ParameterDef_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_ParameterDef_By_PkArgs = {
  _inc?: InputMaybe<Parameter_ParameterDef_Inc_Input>;
  _set?: InputMaybe<Parameter_ParameterDef_Set_Input>;
  pk_columns: Parameter_ParameterDef_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_ParameterDef_ManyArgs = {
  updates: Array<Parameter_ParameterDef_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_RingArgs = {
  _inc?: InputMaybe<Parameter_Ring_Inc_Input>;
  _set?: InputMaybe<Parameter_Ring_Set_Input>;
  where: Parameter_Ring_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_RingProjectionArgs = {
  _inc?: InputMaybe<Parameter_RingProjection_Inc_Input>;
  _set?: InputMaybe<Parameter_RingProjection_Set_Input>;
  where: Parameter_RingProjection_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_RingProjection_By_PkArgs = {
  _inc?: InputMaybe<Parameter_RingProjection_Inc_Input>;
  _set?: InputMaybe<Parameter_RingProjection_Set_Input>;
  pk_columns: Parameter_RingProjection_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_RingProjection_ManyArgs = {
  updates: Array<Parameter_RingProjection_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_Ring_By_PkArgs = {
  _inc?: InputMaybe<Parameter_Ring_Inc_Input>;
  _set?: InputMaybe<Parameter_Ring_Set_Input>;
  pk_columns: Parameter_Ring_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_Ring_ManyArgs = {
  updates: Array<Parameter_Ring_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_ValueArgs = {
  _inc?: InputMaybe<Parameter_Value_Inc_Input>;
  _set?: InputMaybe<Parameter_Value_Set_Input>;
  where: Parameter_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_Value_By_PkArgs = {
  _inc?: InputMaybe<Parameter_Value_Inc_Input>;
  _set?: InputMaybe<Parameter_Value_Set_Input>;
  pk_columns: Parameter_Value_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parameter_Value_ManyArgs = {
  updates: Array<Parameter_Value_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PermissionTypeArgs = {
  _set?: InputMaybe<PermissionType_Set_Input>;
  where: PermissionType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_PermissionType_By_PkArgs = {
  _set?: InputMaybe<PermissionType_Set_Input>;
  pk_columns: PermissionType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PermissionType_ManyArgs = {
  updates: Array<PermissionType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectArgs = {
  _set?: InputMaybe<Project_Set_Input>;
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_By_PkArgs = {
  _set?: InputMaybe<Project_Set_Input>;
  pk_columns: Project_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ManyArgs = {
  updates: Array<Project_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_BoardConfigArgs = {
  _inc?: InputMaybe<Quality_BoardConfig_Inc_Input>;
  _set?: InputMaybe<Quality_BoardConfig_Set_Input>;
  where: Quality_BoardConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_BoardConfig_By_PkArgs = {
  _inc?: InputMaybe<Quality_BoardConfig_Inc_Input>;
  _set?: InputMaybe<Quality_BoardConfig_Set_Input>;
  pk_columns: Quality_BoardConfig_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_BoardConfig_ManyArgs = {
  updates: Array<Quality_BoardConfig_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_BoardSegmentArgs = {
  _set?: InputMaybe<Quality_BoardSegment_Set_Input>;
  where: Quality_BoardSegment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_BoardSegment_By_PkArgs = {
  _set?: InputMaybe<Quality_BoardSegment_Set_Input>;
  pk_columns: Quality_BoardSegment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_BoardSegment_ManyArgs = {
  updates: Array<Quality_BoardSegment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectRepairArgs = {
  _set?: InputMaybe<Quality_DefectRepair_Set_Input>;
  where: Quality_DefectRepair_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectRepairPictureArgs = {
  _set?: InputMaybe<Quality_DefectRepairPicture_Set_Input>;
  where: Quality_DefectRepairPicture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectRepairPicture_By_PkArgs = {
  _set?: InputMaybe<Quality_DefectRepairPicture_Set_Input>;
  pk_columns: Quality_DefectRepairPicture_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectRepairPicture_ManyArgs = {
  updates: Array<Quality_DefectRepairPicture_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectRepairTypeArgs = {
  _set?: InputMaybe<Quality_DefectRepairType_Set_Input>;
  where: Quality_DefectRepairType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectRepairType_By_PkArgs = {
  _set?: InputMaybe<Quality_DefectRepairType_Set_Input>;
  pk_columns: Quality_DefectRepairType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectRepairType_ManyArgs = {
  updates: Array<Quality_DefectRepairType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectRepair_By_PkArgs = {
  _set?: InputMaybe<Quality_DefectRepair_Set_Input>;
  pk_columns: Quality_DefectRepair_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectRepair_ManyArgs = {
  updates: Array<Quality_DefectRepair_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectReportArgs = {
  _append?: InputMaybe<Quality_DefectReport_Append_Input>;
  _delete_at_path?: InputMaybe<Quality_DefectReport_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quality_DefectReport_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quality_DefectReport_Delete_Key_Input>;
  _prepend?: InputMaybe<Quality_DefectReport_Prepend_Input>;
  _set?: InputMaybe<Quality_DefectReport_Set_Input>;
  where: Quality_DefectReport_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectReportPictureArgs = {
  _set?: InputMaybe<Quality_DefectReportPicture_Set_Input>;
  where: Quality_DefectReportPicture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectReportPicture_By_PkArgs = {
  _set?: InputMaybe<Quality_DefectReportPicture_Set_Input>;
  pk_columns: Quality_DefectReportPicture_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectReportPicture_ManyArgs = {
  updates: Array<Quality_DefectReportPicture_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectReportTypeArgs = {
  _set?: InputMaybe<Quality_DefectReportType_Set_Input>;
  where: Quality_DefectReportType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectReportType_By_PkArgs = {
  _set?: InputMaybe<Quality_DefectReportType_Set_Input>;
  pk_columns: Quality_DefectReportType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectReportType_ManyArgs = {
  updates: Array<Quality_DefectReportType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectReport_By_PkArgs = {
  _append?: InputMaybe<Quality_DefectReport_Append_Input>;
  _delete_at_path?: InputMaybe<Quality_DefectReport_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quality_DefectReport_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quality_DefectReport_Delete_Key_Input>;
  _prepend?: InputMaybe<Quality_DefectReport_Prepend_Input>;
  _set?: InputMaybe<Quality_DefectReport_Set_Input>;
  pk_columns: Quality_DefectReport_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_DefectReport_ManyArgs = {
  updates: Array<Quality_DefectReport_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ImportConfigArgs = {
  _set?: InputMaybe<Quality_ImportConfig_Set_Input>;
  where: Quality_ImportConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ImportConfig_By_PkArgs = {
  _set?: InputMaybe<Quality_ImportConfig_Set_Input>;
  pk_columns: Quality_ImportConfig_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ImportConfig_ManyArgs = {
  updates: Array<Quality_ImportConfig_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ImportExtraColumnArgs = {
  _set?: InputMaybe<Quality_ImportExtraColumn_Set_Input>;
  where: Quality_ImportExtraColumn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ImportExtraColumn_By_PkArgs = {
  _set?: InputMaybe<Quality_ImportExtraColumn_Set_Input>;
  pk_columns: Quality_ImportExtraColumn_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ImportExtraColumn_ManyArgs = {
  updates: Array<Quality_ImportExtraColumn_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ImportTaskArgs = {
  _append?: InputMaybe<Quality_ImportTask_Append_Input>;
  _delete_at_path?: InputMaybe<Quality_ImportTask_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quality_ImportTask_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quality_ImportTask_Delete_Key_Input>;
  _inc?: InputMaybe<Quality_ImportTask_Inc_Input>;
  _prepend?: InputMaybe<Quality_ImportTask_Prepend_Input>;
  _set?: InputMaybe<Quality_ImportTask_Set_Input>;
  where: Quality_ImportTask_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ImportTask_By_PkArgs = {
  _append?: InputMaybe<Quality_ImportTask_Append_Input>;
  _delete_at_path?: InputMaybe<Quality_ImportTask_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quality_ImportTask_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quality_ImportTask_Delete_Key_Input>;
  _inc?: InputMaybe<Quality_ImportTask_Inc_Input>;
  _prepend?: InputMaybe<Quality_ImportTask_Prepend_Input>;
  _set?: InputMaybe<Quality_ImportTask_Set_Input>;
  pk_columns: Quality_ImportTask_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ImportTask_ManyArgs = {
  updates: Array<Quality_ImportTask_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_IndicatorArgs = {
  _set?: InputMaybe<Quality_Indicator_Set_Input>;
  where: Quality_Indicator_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Indicator_By_PkArgs = {
  _set?: InputMaybe<Quality_Indicator_Set_Input>;
  pk_columns: Quality_Indicator_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Indicator_ManyArgs = {
  updates: Array<Quality_Indicator_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_QuarantineDefectArgs = {
  _inc?: InputMaybe<Quality_QuarantineDefect_Inc_Input>;
  _set?: InputMaybe<Quality_QuarantineDefect_Set_Input>;
  where: Quality_QuarantineDefect_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_QuarantineDefectOrientationEnumArgs = {
  _set?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Set_Input>;
  where: Quality_QuarantineDefectOrientationEnum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_QuarantineDefectOrientationEnum_By_PkArgs = {
  _set?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Set_Input>;
  pk_columns: Quality_QuarantineDefectOrientationEnum_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_QuarantineDefectOrientationEnum_ManyArgs = {
  updates: Array<Quality_QuarantineDefectOrientationEnum_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_QuarantineDefectPictureArgs = {
  _set?: InputMaybe<Quality_QuarantineDefectPicture_Set_Input>;
  where: Quality_QuarantineDefectPicture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_QuarantineDefectPicture_By_PkArgs = {
  _set?: InputMaybe<Quality_QuarantineDefectPicture_Set_Input>;
  pk_columns: Quality_QuarantineDefectPicture_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_QuarantineDefectPicture_ManyArgs = {
  updates: Array<Quality_QuarantineDefectPicture_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_QuarantineDefectTypeArgs = {
  _set?: InputMaybe<Quality_QuarantineDefectType_Set_Input>;
  where: Quality_QuarantineDefectType_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_QuarantineDefectType_By_PkArgs = {
  _set?: InputMaybe<Quality_QuarantineDefectType_Set_Input>;
  pk_columns: Quality_QuarantineDefectType_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_QuarantineDefectType_ManyArgs = {
  updates: Array<Quality_QuarantineDefectType_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_QuarantineDefect_By_PkArgs = {
  _inc?: InputMaybe<Quality_QuarantineDefect_Inc_Input>;
  _set?: InputMaybe<Quality_QuarantineDefect_Set_Input>;
  pk_columns: Quality_QuarantineDefect_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_QuarantineDefect_ManyArgs = {
  updates: Array<Quality_QuarantineDefect_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_RepairReportArgs = {
  _set?: InputMaybe<Quality_RepairReport_Set_Input>;
  where: Quality_RepairReport_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_RepairReportPictureArgs = {
  _set?: InputMaybe<Quality_RepairReportPicture_Set_Input>;
  where: Quality_RepairReportPicture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_RepairReportPicture_By_PkArgs = {
  _set?: InputMaybe<Quality_RepairReportPicture_Set_Input>;
  pk_columns: Quality_RepairReportPicture_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_RepairReportPicture_ManyArgs = {
  updates: Array<Quality_RepairReportPicture_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_RepairReport_By_PkArgs = {
  _set?: InputMaybe<Quality_RepairReport_Set_Input>;
  pk_columns: Quality_RepairReport_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_RepairReport_ManyArgs = {
  updates: Array<Quality_RepairReport_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_RingValidationArgs = {
  _append?: InputMaybe<Quality_RingValidation_Append_Input>;
  _delete_at_path?: InputMaybe<Quality_RingValidation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quality_RingValidation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quality_RingValidation_Delete_Key_Input>;
  _prepend?: InputMaybe<Quality_RingValidation_Prepend_Input>;
  _set?: InputMaybe<Quality_RingValidation_Set_Input>;
  where: Quality_RingValidation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_RingValidation_By_PkArgs = {
  _append?: InputMaybe<Quality_RingValidation_Append_Input>;
  _delete_at_path?: InputMaybe<Quality_RingValidation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quality_RingValidation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quality_RingValidation_Delete_Key_Input>;
  _prepend?: InputMaybe<Quality_RingValidation_Prepend_Input>;
  _set?: InputMaybe<Quality_RingValidation_Set_Input>;
  pk_columns: Quality_RingValidation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_RingValidation_ManyArgs = {
  updates: Array<Quality_RingValidation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanCodeConfigArgs = {
  _set?: InputMaybe<Quality_ScanCodeConfig_Set_Input>;
  where: Quality_ScanCodeConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanCodeConfig_By_PkArgs = {
  _set?: InputMaybe<Quality_ScanCodeConfig_Set_Input>;
  pk_columns: Quality_ScanCodeConfig_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanCodeConfig_ManyArgs = {
  updates: Array<Quality_ScanCodeConfig_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanConfigArgs = {
  _inc?: InputMaybe<Quality_ScanConfig_Inc_Input>;
  _set?: InputMaybe<Quality_ScanConfig_Set_Input>;
  where: Quality_ScanConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanConfig_By_PkArgs = {
  _inc?: InputMaybe<Quality_ScanConfig_Inc_Input>;
  _set?: InputMaybe<Quality_ScanConfig_Set_Input>;
  pk_columns: Quality_ScanConfig_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanConfig_ManyArgs = {
  updates: Array<Quality_ScanConfig_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanSiteArgs = {
  _set?: InputMaybe<Quality_ScanSite_Set_Input>;
  where: Quality_ScanSite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanSiteConstructionSiteArgs = {
  _set?: InputMaybe<Quality_ScanSiteConstructionSite_Set_Input>;
  where: Quality_ScanSiteConstructionSite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanSiteConstructionSite_By_PkArgs = {
  _set?: InputMaybe<Quality_ScanSiteConstructionSite_Set_Input>;
  pk_columns: Quality_ScanSiteConstructionSite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanSiteConstructionSite_ManyArgs = {
  updates: Array<Quality_ScanSiteConstructionSite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanSite_By_PkArgs = {
  _set?: InputMaybe<Quality_ScanSite_Set_Input>;
  pk_columns: Quality_ScanSite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanSite_ManyArgs = {
  updates: Array<Quality_ScanSite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanTypeEnumArgs = {
  _set?: InputMaybe<Quality_ScanTypeEnum_Set_Input>;
  where: Quality_ScanTypeEnum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanTypeEnum_By_PkArgs = {
  _set?: InputMaybe<Quality_ScanTypeEnum_Set_Input>;
  pk_columns: Quality_ScanTypeEnum_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ScanTypeEnum_ManyArgs = {
  updates: Array<Quality_ScanTypeEnum_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentArgs = {
  _set?: InputMaybe<Quality_Segment_Set_Input>;
  where: Quality_Segment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentDrawConfigArgs = {
  _inc?: InputMaybe<Quality_SegmentDrawConfig_Inc_Input>;
  _set?: InputMaybe<Quality_SegmentDrawConfig_Set_Input>;
  where: Quality_SegmentDrawConfig_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentDrawConfig_By_PkArgs = {
  _inc?: InputMaybe<Quality_SegmentDrawConfig_Inc_Input>;
  _set?: InputMaybe<Quality_SegmentDrawConfig_Set_Input>;
  pk_columns: Quality_SegmentDrawConfig_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentDrawConfig_ManyArgs = {
  updates: Array<Quality_SegmentDrawConfig_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentExtraParameterArgs = {
  _set?: InputMaybe<Quality_SegmentExtraParameter_Set_Input>;
  where: Quality_SegmentExtraParameter_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentExtraParameter_By_PkArgs = {
  _set?: InputMaybe<Quality_SegmentExtraParameter_Set_Input>;
  pk_columns: Quality_SegmentExtraParameter_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentExtraParameter_ManyArgs = {
  updates: Array<Quality_SegmentExtraParameter_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentHistoryArgs = {
  _set?: InputMaybe<Quality_SegmentHistory_Set_Input>;
  where: Quality_SegmentHistory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentHistoryStatusEnumArgs = {
  _set?: InputMaybe<Quality_SegmentHistoryStatusEnum_Set_Input>;
  where: Quality_SegmentHistoryStatusEnum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentHistoryStatusEnum_By_PkArgs = {
  _set?: InputMaybe<Quality_SegmentHistoryStatusEnum_Set_Input>;
  pk_columns: Quality_SegmentHistoryStatusEnum_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentHistoryStatusEnum_ManyArgs = {
  updates: Array<Quality_SegmentHistoryStatusEnum_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentHistory_By_PkArgs = {
  _set?: InputMaybe<Quality_SegmentHistory_Set_Input>;
  pk_columns: Quality_SegmentHistory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentHistory_ManyArgs = {
  updates: Array<Quality_SegmentHistory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentRefusalArgs = {
  _set?: InputMaybe<Quality_SegmentRefusal_Set_Input>;
  where: Quality_SegmentRefusal_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentRefusalPictureArgs = {
  _set?: InputMaybe<Quality_SegmentRefusalPicture_Set_Input>;
  where: Quality_SegmentRefusalPicture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentRefusalPicture_By_PkArgs = {
  _set?: InputMaybe<Quality_SegmentRefusalPicture_Set_Input>;
  pk_columns: Quality_SegmentRefusalPicture_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentRefusalPicture_ManyArgs = {
  updates: Array<Quality_SegmentRefusalPicture_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentRefusal_By_PkArgs = {
  _set?: InputMaybe<Quality_SegmentRefusal_Set_Input>;
  pk_columns: Quality_SegmentRefusal_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_SegmentRefusal_ManyArgs = {
  updates: Array<Quality_SegmentRefusal_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Segment_By_PkArgs = {
  _set?: InputMaybe<Quality_Segment_Set_Input>;
  pk_columns: Quality_Segment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_Segment_ManyArgs = {
  updates: Array<Quality_Segment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ShapeEnumArgs = {
  _set?: InputMaybe<Quality_ShapeEnum_Set_Input>;
  where: Quality_ShapeEnum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ShapeEnum_By_PkArgs = {
  _set?: InputMaybe<Quality_ShapeEnum_Set_Input>;
  pk_columns: Quality_ShapeEnum_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_ShapeEnum_ManyArgs = {
  updates: Array<Quality_ShapeEnum_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_TunnelPositionArgs = {
  _inc?: InputMaybe<Quality_TunnelPosition_Inc_Input>;
  _set?: InputMaybe<Quality_TunnelPosition_Set_Input>;
  where: Quality_TunnelPosition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_TunnelPosition_By_PkArgs = {
  _inc?: InputMaybe<Quality_TunnelPosition_Inc_Input>;
  _set?: InputMaybe<Quality_TunnelPosition_Set_Input>;
  pk_columns: Quality_TunnelPosition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_TunnelPosition_ManyArgs = {
  updates: Array<Quality_TunnelPosition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_UserQualityRoleArgs = {
  _set?: InputMaybe<Quality_UserQualityRole_Set_Input>;
  where: Quality_UserQualityRole_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_UserQualityRole_By_PkArgs = {
  _set?: InputMaybe<Quality_UserQualityRole_Set_Input>;
  pk_columns: Quality_UserQualityRole_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_UserQualityRole_ManyArgs = {
  updates: Array<Quality_UserQualityRole_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_VirtualRingArgs = {
  _inc?: InputMaybe<Quality_VirtualRing_Inc_Input>;
  _set?: InputMaybe<Quality_VirtualRing_Set_Input>;
  where: Quality_VirtualRing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_VirtualRing_By_PkArgs = {
  _inc?: InputMaybe<Quality_VirtualRing_Inc_Input>;
  _set?: InputMaybe<Quality_VirtualRing_Set_Input>;
  pk_columns: Quality_VirtualRing_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quality_VirtualRing_ManyArgs = {
  updates: Array<Quality_VirtualRing_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RecurringTaskArgs = {
  _inc?: InputMaybe<RecurringTask_Inc_Input>;
  _set?: InputMaybe<RecurringTask_Set_Input>;
  where: RecurringTask_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RecurringTask_By_PkArgs = {
  _inc?: InputMaybe<RecurringTask_Inc_Input>;
  _set?: InputMaybe<RecurringTask_Set_Input>;
  pk_columns: RecurringTask_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RecurringTask_ManyArgs = {
  updates: Array<RecurringTask_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Scan_UserArgs = {
  _set?: InputMaybe<Scan_User_Set_Input>;
  where: Scan_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scan_User_By_PkArgs = {
  _set?: InputMaybe<Scan_User_Set_Input>;
  pk_columns: Scan_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scan_User_ManyArgs = {
  updates: Array<Scan_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ShiftArgs = {
  _set?: InputMaybe<Shift_Set_Input>;
  where: Shift_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ShiftLeaderArgs = {
  _set?: InputMaybe<ShiftLeader_Set_Input>;
  where: ShiftLeader_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ShiftLeader_By_PkArgs = {
  _set?: InputMaybe<ShiftLeader_Set_Input>;
  pk_columns: ShiftLeader_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ShiftLeader_ManyArgs = {
  updates: Array<ShiftLeader_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ShiftReportArgs = {
  _inc?: InputMaybe<ShiftReport_Inc_Input>;
  _set?: InputMaybe<ShiftReport_Set_Input>;
  where: ShiftReport_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ShiftReport_By_PkArgs = {
  _inc?: InputMaybe<ShiftReport_Inc_Input>;
  _set?: InputMaybe<ShiftReport_Set_Input>;
  pk_columns: ShiftReport_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ShiftReport_ManyArgs = {
  updates: Array<ShiftReport_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Shift_By_PkArgs = {
  _set?: InputMaybe<Shift_Set_Input>;
  pk_columns: Shift_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Shift_ManyArgs = {
  updates: Array<Shift_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TaskArgs = {
  _append?: InputMaybe<Task_Append_Input>;
  _delete_at_path?: InputMaybe<Task_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Task_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Task_Delete_Key_Input>;
  _inc?: InputMaybe<Task_Inc_Input>;
  _prepend?: InputMaybe<Task_Prepend_Input>;
  _set?: InputMaybe<Task_Set_Input>;
  where: Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_By_PkArgs = {
  _append?: InputMaybe<Task_Append_Input>;
  _delete_at_path?: InputMaybe<Task_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Task_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Task_Delete_Key_Input>;
  _inc?: InputMaybe<Task_Inc_Input>;
  _prepend?: InputMaybe<Task_Prepend_Input>;
  _set?: InputMaybe<Task_Set_Input>;
  pk_columns: Task_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_ManyArgs = {
  updates: Array<Task_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TeamArgs = {
  _set?: InputMaybe<Team_Set_Input>;
  where: Team_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Team_By_PkArgs = {
  _set?: InputMaybe<Team_Set_Input>;
  pk_columns: Team_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Team_ManyArgs = {
  updates: Array<Team_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserPermissionArgs = {
  _set?: InputMaybe<UserPermission_Set_Input>;
  where: UserPermission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserPermission_By_PkArgs = {
  _set?: InputMaybe<UserPermission_Set_Input>;
  pk_columns: UserPermission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserPermission_ManyArgs = {
  updates: Array<UserPermission_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "operator" */
export type Operator = {
  __typename?: 'operator';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  isHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  shiftReports: Array<ShiftReport>;
  /** An aggregate relationship */
  shiftReports_aggregate: ShiftReport_Aggregate;
};


/** columns and relationships of "operator" */
export type OperatorShiftReportsArgs = {
  distinct_on?: InputMaybe<Array<ShiftReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftReport_Order_By>>;
  where?: InputMaybe<ShiftReport_Bool_Exp>;
};


/** columns and relationships of "operator" */
export type OperatorShiftReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ShiftReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftReport_Order_By>>;
  where?: InputMaybe<ShiftReport_Bool_Exp>;
};

/** aggregated selection of "operator" */
export type Operator_Aggregate = {
  __typename?: 'operator_aggregate';
  aggregate?: Maybe<Operator_Aggregate_Fields>;
  nodes: Array<Operator>;
};

/** aggregate fields of "operator" */
export type Operator_Aggregate_Fields = {
  __typename?: 'operator_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Operator_Max_Fields>;
  min?: Maybe<Operator_Min_Fields>;
};


/** aggregate fields of "operator" */
export type Operator_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "operator". All fields are combined with a logical 'AND'. */
export type Operator_Bool_Exp = {
  _and?: InputMaybe<Array<Operator_Bool_Exp>>;
  _not?: InputMaybe<Operator_Bool_Exp>;
  _or?: InputMaybe<Array<Operator_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  shiftReports?: InputMaybe<ShiftReport_Bool_Exp>;
  shiftReports_aggregate?: InputMaybe<ShiftReport_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "operator" */
export enum Operator_Constraint {
  /** unique or primary key constraint on columns "id" */
  OperatorPkey = 'operator_pkey'
}

/** input type for inserting data into table "operator" */
export type Operator_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shiftReports?: InputMaybe<ShiftReport_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Operator_Max_Fields = {
  __typename?: 'operator_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Operator_Min_Fields = {
  __typename?: 'operator_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "operator" */
export type Operator_Mutation_Response = {
  __typename?: 'operator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Operator>;
};

/** input type for inserting object relation for remote table "operator" */
export type Operator_Obj_Rel_Insert_Input = {
  data: Operator_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Operator_On_Conflict>;
};

/** on_conflict condition type for table "operator" */
export type Operator_On_Conflict = {
  constraint: Operator_Constraint;
  update_columns?: Array<Operator_Update_Column>;
  where?: InputMaybe<Operator_Bool_Exp>;
};

/** Ordering options when selecting data from "operator". */
export type Operator_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isHidden?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  shiftReports_aggregate?: InputMaybe<ShiftReport_Aggregate_Order_By>;
};

/** primary key columns input for table: operator */
export type Operator_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "operator" */
export enum Operator_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "operator" */
export type Operator_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "operator" */
export type Operator_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operator_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operator_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "operator" */
export enum Operator_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Name = 'name'
}

export type Operator_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operator_Set_Input>;
  /** filter the rows which have to be updated */
  where: Operator_Bool_Exp;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "parameter.constructionSiteParameterNameConfig" */
export type Parameter_ConstructionSiteParameterNameConfig = {
  __typename?: 'parameter_constructionSiteParameterNameConfig';
  buildDuration: Scalars['Int']['output'];
  buildEnd: Scalars['Int']['output'];
  buildGoAheadCalculation: Scalars['Int']['output'];
  buildStart: Scalars['Int']['output'];
  constructionSiteId: Scalars['uuid']['output'];
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Int']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Int']['output']>;
  excavationDuration: Scalars['Int']['output'];
  excavationEnd: Scalars['Int']['output'];
  excavationGoAheadCalculation: Scalars['Int']['output'];
  excavationStart: Scalars['Int']['output'];
  frontHorizontalPosition: Scalars['Int']['output'];
  frontHorizontalTrend?: Maybe<Scalars['Int']['output']>;
  frontVerticalPosition: Scalars['Int']['output'];
  frontVerticalTrend?: Maybe<Scalars['Int']['output']>;
  horizontalTrend: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  keyPosition: Scalars['Int']['output'];
  leftSkirtClearance?: Maybe<Scalars['Int']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Int']['output']>;
  metricPoint: Scalars['Int']['output'];
  rearHorizontalPosition: Scalars['Int']['output'];
  rearVerticalPosition: Scalars['Int']['output'];
  rightSkirtClearance?: Maybe<Scalars['Int']['output']>;
  ringLength?: Maybe<Scalars['Int']['output']>;
  ringNumber: Scalars['Int']['output'];
  upperSkirtClearance?: Maybe<Scalars['Int']['output']>;
  verticalTrend: Scalars['Int']['output'];
};

/** aggregated selection of "parameter.constructionSiteParameterNameConfig" */
export type Parameter_ConstructionSiteParameterNameConfig_Aggregate = {
  __typename?: 'parameter_constructionSiteParameterNameConfig_aggregate';
  aggregate?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Aggregate_Fields>;
  nodes: Array<Parameter_ConstructionSiteParameterNameConfig>;
};

/** aggregate fields of "parameter.constructionSiteParameterNameConfig" */
export type Parameter_ConstructionSiteParameterNameConfig_Aggregate_Fields = {
  __typename?: 'parameter_constructionSiteParameterNameConfig_aggregate_fields';
  avg?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Max_Fields>;
  min?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Min_Fields>;
  stddev?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Stddev_Fields>;
  stddev_pop?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Stddev_Samp_Fields>;
  sum?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Sum_Fields>;
  var_pop?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Var_Pop_Fields>;
  var_samp?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Var_Samp_Fields>;
  variance?: Maybe<Parameter_ConstructionSiteParameterNameConfig_Variance_Fields>;
};


/** aggregate fields of "parameter.constructionSiteParameterNameConfig" */
export type Parameter_ConstructionSiteParameterNameConfig_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parameter_ConstructionSiteParameterNameConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Parameter_ConstructionSiteParameterNameConfig_Avg_Fields = {
  __typename?: 'parameter_constructionSiteParameterNameConfig_avg_fields';
  buildDuration?: Maybe<Scalars['Float']['output']>;
  buildEnd?: Maybe<Scalars['Float']['output']>;
  buildGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  buildStart?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  excavationDuration?: Maybe<Scalars['Float']['output']>;
  excavationEnd?: Maybe<Scalars['Float']['output']>;
  excavationGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  excavationStart?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  horizontalTrend?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  metricPoint?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringLength?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
  verticalTrend?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "parameter.constructionSiteParameterNameConfig". All fields are combined with a logical 'AND'. */
export type Parameter_ConstructionSiteParameterNameConfig_Bool_Exp = {
  _and?: InputMaybe<Array<Parameter_ConstructionSiteParameterNameConfig_Bool_Exp>>;
  _not?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Bool_Exp>;
  _or?: InputMaybe<Array<Parameter_ConstructionSiteParameterNameConfig_Bool_Exp>>;
  buildDuration?: InputMaybe<Int_Comparison_Exp>;
  buildEnd?: InputMaybe<Int_Comparison_Exp>;
  buildGoAheadCalculation?: InputMaybe<Int_Comparison_Exp>;
  buildStart?: InputMaybe<Int_Comparison_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  cuttingWheelHorizontalPosition?: InputMaybe<Int_Comparison_Exp>;
  cuttingWheelVerticalPosition?: InputMaybe<Int_Comparison_Exp>;
  excavationDuration?: InputMaybe<Int_Comparison_Exp>;
  excavationEnd?: InputMaybe<Int_Comparison_Exp>;
  excavationGoAheadCalculation?: InputMaybe<Int_Comparison_Exp>;
  excavationStart?: InputMaybe<Int_Comparison_Exp>;
  frontHorizontalPosition?: InputMaybe<Int_Comparison_Exp>;
  frontHorizontalTrend?: InputMaybe<Int_Comparison_Exp>;
  frontVerticalPosition?: InputMaybe<Int_Comparison_Exp>;
  frontVerticalTrend?: InputMaybe<Int_Comparison_Exp>;
  horizontalTrend?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  keyPosition?: InputMaybe<Int_Comparison_Exp>;
  leftSkirtClearance?: InputMaybe<Int_Comparison_Exp>;
  lowerSkirtClearance?: InputMaybe<Int_Comparison_Exp>;
  metricPoint?: InputMaybe<Int_Comparison_Exp>;
  rearHorizontalPosition?: InputMaybe<Int_Comparison_Exp>;
  rearVerticalPosition?: InputMaybe<Int_Comparison_Exp>;
  rightSkirtClearance?: InputMaybe<Int_Comparison_Exp>;
  ringLength?: InputMaybe<Int_Comparison_Exp>;
  ringNumber?: InputMaybe<Int_Comparison_Exp>;
  upperSkirtClearance?: InputMaybe<Int_Comparison_Exp>;
  verticalTrend?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "parameter.constructionSiteParameterNameConfig" */
export enum Parameter_ConstructionSiteParameterNameConfig_Constraint {
  /** unique or primary key constraint on columns "id" */
  ConstructionSiteParameterNameConfigIdKey = 'constructionSiteParameterNameConfig_id_key',
  /** unique or primary key constraint on columns "id" */
  ConstructionSiteParameterNameConfigPkey = 'constructionSiteParameterNameConfig_pkey'
}

/** input type for incrementing numeric columns in table "parameter.constructionSiteParameterNameConfig" */
export type Parameter_ConstructionSiteParameterNameConfig_Inc_Input = {
  buildDuration?: InputMaybe<Scalars['Int']['input']>;
  buildEnd?: InputMaybe<Scalars['Int']['input']>;
  buildGoAheadCalculation?: InputMaybe<Scalars['Int']['input']>;
  buildStart?: InputMaybe<Scalars['Int']['input']>;
  cuttingWheelHorizontalPosition?: InputMaybe<Scalars['Int']['input']>;
  cuttingWheelVerticalPosition?: InputMaybe<Scalars['Int']['input']>;
  excavationDuration?: InputMaybe<Scalars['Int']['input']>;
  excavationEnd?: InputMaybe<Scalars['Int']['input']>;
  excavationGoAheadCalculation?: InputMaybe<Scalars['Int']['input']>;
  excavationStart?: InputMaybe<Scalars['Int']['input']>;
  frontHorizontalPosition?: InputMaybe<Scalars['Int']['input']>;
  frontHorizontalTrend?: InputMaybe<Scalars['Int']['input']>;
  frontVerticalPosition?: InputMaybe<Scalars['Int']['input']>;
  frontVerticalTrend?: InputMaybe<Scalars['Int']['input']>;
  horizontalTrend?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  keyPosition?: InputMaybe<Scalars['Int']['input']>;
  leftSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  lowerSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  metricPoint?: InputMaybe<Scalars['Int']['input']>;
  rearHorizontalPosition?: InputMaybe<Scalars['Int']['input']>;
  rearVerticalPosition?: InputMaybe<Scalars['Int']['input']>;
  rightSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  ringLength?: InputMaybe<Scalars['Int']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  upperSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  verticalTrend?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "parameter.constructionSiteParameterNameConfig" */
export type Parameter_ConstructionSiteParameterNameConfig_Insert_Input = {
  buildDuration?: InputMaybe<Scalars['Int']['input']>;
  buildEnd?: InputMaybe<Scalars['Int']['input']>;
  buildGoAheadCalculation?: InputMaybe<Scalars['Int']['input']>;
  buildStart?: InputMaybe<Scalars['Int']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  cuttingWheelHorizontalPosition?: InputMaybe<Scalars['Int']['input']>;
  cuttingWheelVerticalPosition?: InputMaybe<Scalars['Int']['input']>;
  excavationDuration?: InputMaybe<Scalars['Int']['input']>;
  excavationEnd?: InputMaybe<Scalars['Int']['input']>;
  excavationGoAheadCalculation?: InputMaybe<Scalars['Int']['input']>;
  excavationStart?: InputMaybe<Scalars['Int']['input']>;
  frontHorizontalPosition?: InputMaybe<Scalars['Int']['input']>;
  frontHorizontalTrend?: InputMaybe<Scalars['Int']['input']>;
  frontVerticalPosition?: InputMaybe<Scalars['Int']['input']>;
  frontVerticalTrend?: InputMaybe<Scalars['Int']['input']>;
  horizontalTrend?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  keyPosition?: InputMaybe<Scalars['Int']['input']>;
  leftSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  lowerSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  metricPoint?: InputMaybe<Scalars['Int']['input']>;
  rearHorizontalPosition?: InputMaybe<Scalars['Int']['input']>;
  rearVerticalPosition?: InputMaybe<Scalars['Int']['input']>;
  rightSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  ringLength?: InputMaybe<Scalars['Int']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  upperSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  verticalTrend?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Parameter_ConstructionSiteParameterNameConfig_Max_Fields = {
  __typename?: 'parameter_constructionSiteParameterNameConfig_max_fields';
  buildDuration?: Maybe<Scalars['Int']['output']>;
  buildEnd?: Maybe<Scalars['Int']['output']>;
  buildGoAheadCalculation?: Maybe<Scalars['Int']['output']>;
  buildStart?: Maybe<Scalars['Int']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Int']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Int']['output']>;
  excavationDuration?: Maybe<Scalars['Int']['output']>;
  excavationEnd?: Maybe<Scalars['Int']['output']>;
  excavationGoAheadCalculation?: Maybe<Scalars['Int']['output']>;
  excavationStart?: Maybe<Scalars['Int']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Int']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Int']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Int']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Int']['output']>;
  horizontalTrend?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  keyPosition?: Maybe<Scalars['Int']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Int']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Int']['output']>;
  metricPoint?: Maybe<Scalars['Int']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Int']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Int']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Int']['output']>;
  ringLength?: Maybe<Scalars['Int']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Int']['output']>;
  verticalTrend?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Parameter_ConstructionSiteParameterNameConfig_Min_Fields = {
  __typename?: 'parameter_constructionSiteParameterNameConfig_min_fields';
  buildDuration?: Maybe<Scalars['Int']['output']>;
  buildEnd?: Maybe<Scalars['Int']['output']>;
  buildGoAheadCalculation?: Maybe<Scalars['Int']['output']>;
  buildStart?: Maybe<Scalars['Int']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Int']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Int']['output']>;
  excavationDuration?: Maybe<Scalars['Int']['output']>;
  excavationEnd?: Maybe<Scalars['Int']['output']>;
  excavationGoAheadCalculation?: Maybe<Scalars['Int']['output']>;
  excavationStart?: Maybe<Scalars['Int']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Int']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Int']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Int']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Int']['output']>;
  horizontalTrend?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  keyPosition?: Maybe<Scalars['Int']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Int']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Int']['output']>;
  metricPoint?: Maybe<Scalars['Int']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Int']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Int']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Int']['output']>;
  ringLength?: Maybe<Scalars['Int']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Int']['output']>;
  verticalTrend?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "parameter.constructionSiteParameterNameConfig" */
export type Parameter_ConstructionSiteParameterNameConfig_Mutation_Response = {
  __typename?: 'parameter_constructionSiteParameterNameConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parameter_ConstructionSiteParameterNameConfig>;
};

/** on_conflict condition type for table "parameter.constructionSiteParameterNameConfig" */
export type Parameter_ConstructionSiteParameterNameConfig_On_Conflict = {
  constraint: Parameter_ConstructionSiteParameterNameConfig_Constraint;
  update_columns?: Array<Parameter_ConstructionSiteParameterNameConfig_Update_Column>;
  where?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "parameter.constructionSiteParameterNameConfig". */
export type Parameter_ConstructionSiteParameterNameConfig_Order_By = {
  buildDuration?: InputMaybe<Order_By>;
  buildEnd?: InputMaybe<Order_By>;
  buildGoAheadCalculation?: InputMaybe<Order_By>;
  buildStart?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  cuttingWheelHorizontalPosition?: InputMaybe<Order_By>;
  cuttingWheelVerticalPosition?: InputMaybe<Order_By>;
  excavationDuration?: InputMaybe<Order_By>;
  excavationEnd?: InputMaybe<Order_By>;
  excavationGoAheadCalculation?: InputMaybe<Order_By>;
  excavationStart?: InputMaybe<Order_By>;
  frontHorizontalPosition?: InputMaybe<Order_By>;
  frontHorizontalTrend?: InputMaybe<Order_By>;
  frontVerticalPosition?: InputMaybe<Order_By>;
  frontVerticalTrend?: InputMaybe<Order_By>;
  horizontalTrend?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  leftSkirtClearance?: InputMaybe<Order_By>;
  lowerSkirtClearance?: InputMaybe<Order_By>;
  metricPoint?: InputMaybe<Order_By>;
  rearHorizontalPosition?: InputMaybe<Order_By>;
  rearVerticalPosition?: InputMaybe<Order_By>;
  rightSkirtClearance?: InputMaybe<Order_By>;
  ringLength?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  upperSkirtClearance?: InputMaybe<Order_By>;
  verticalTrend?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parameter.constructionSiteParameterNameConfig */
export type Parameter_ConstructionSiteParameterNameConfig_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "parameter.constructionSiteParameterNameConfig" */
export enum Parameter_ConstructionSiteParameterNameConfig_Select_Column {
  /** column name */
  BuildDuration = 'buildDuration',
  /** column name */
  BuildEnd = 'buildEnd',
  /** column name */
  BuildGoAheadCalculation = 'buildGoAheadCalculation',
  /** column name */
  BuildStart = 'buildStart',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  CuttingWheelHorizontalPosition = 'cuttingWheelHorizontalPosition',
  /** column name */
  CuttingWheelVerticalPosition = 'cuttingWheelVerticalPosition',
  /** column name */
  ExcavationDuration = 'excavationDuration',
  /** column name */
  ExcavationEnd = 'excavationEnd',
  /** column name */
  ExcavationGoAheadCalculation = 'excavationGoAheadCalculation',
  /** column name */
  ExcavationStart = 'excavationStart',
  /** column name */
  FrontHorizontalPosition = 'frontHorizontalPosition',
  /** column name */
  FrontHorizontalTrend = 'frontHorizontalTrend',
  /** column name */
  FrontVerticalPosition = 'frontVerticalPosition',
  /** column name */
  FrontVerticalTrend = 'frontVerticalTrend',
  /** column name */
  HorizontalTrend = 'horizontalTrend',
  /** column name */
  Id = 'id',
  /** column name */
  KeyPosition = 'keyPosition',
  /** column name */
  LeftSkirtClearance = 'leftSkirtClearance',
  /** column name */
  LowerSkirtClearance = 'lowerSkirtClearance',
  /** column name */
  MetricPoint = 'metricPoint',
  /** column name */
  RearHorizontalPosition = 'rearHorizontalPosition',
  /** column name */
  RearVerticalPosition = 'rearVerticalPosition',
  /** column name */
  RightSkirtClearance = 'rightSkirtClearance',
  /** column name */
  RingLength = 'ringLength',
  /** column name */
  RingNumber = 'ringNumber',
  /** column name */
  UpperSkirtClearance = 'upperSkirtClearance',
  /** column name */
  VerticalTrend = 'verticalTrend'
}

/** input type for updating data in table "parameter.constructionSiteParameterNameConfig" */
export type Parameter_ConstructionSiteParameterNameConfig_Set_Input = {
  buildDuration?: InputMaybe<Scalars['Int']['input']>;
  buildEnd?: InputMaybe<Scalars['Int']['input']>;
  buildGoAheadCalculation?: InputMaybe<Scalars['Int']['input']>;
  buildStart?: InputMaybe<Scalars['Int']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  cuttingWheelHorizontalPosition?: InputMaybe<Scalars['Int']['input']>;
  cuttingWheelVerticalPosition?: InputMaybe<Scalars['Int']['input']>;
  excavationDuration?: InputMaybe<Scalars['Int']['input']>;
  excavationEnd?: InputMaybe<Scalars['Int']['input']>;
  excavationGoAheadCalculation?: InputMaybe<Scalars['Int']['input']>;
  excavationStart?: InputMaybe<Scalars['Int']['input']>;
  frontHorizontalPosition?: InputMaybe<Scalars['Int']['input']>;
  frontHorizontalTrend?: InputMaybe<Scalars['Int']['input']>;
  frontVerticalPosition?: InputMaybe<Scalars['Int']['input']>;
  frontVerticalTrend?: InputMaybe<Scalars['Int']['input']>;
  horizontalTrend?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  keyPosition?: InputMaybe<Scalars['Int']['input']>;
  leftSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  lowerSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  metricPoint?: InputMaybe<Scalars['Int']['input']>;
  rearHorizontalPosition?: InputMaybe<Scalars['Int']['input']>;
  rearVerticalPosition?: InputMaybe<Scalars['Int']['input']>;
  rightSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  ringLength?: InputMaybe<Scalars['Int']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  upperSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  verticalTrend?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Parameter_ConstructionSiteParameterNameConfig_Stddev_Fields = {
  __typename?: 'parameter_constructionSiteParameterNameConfig_stddev_fields';
  buildDuration?: Maybe<Scalars['Float']['output']>;
  buildEnd?: Maybe<Scalars['Float']['output']>;
  buildGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  buildStart?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  excavationDuration?: Maybe<Scalars['Float']['output']>;
  excavationEnd?: Maybe<Scalars['Float']['output']>;
  excavationGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  excavationStart?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  horizontalTrend?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  metricPoint?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringLength?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
  verticalTrend?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Parameter_ConstructionSiteParameterNameConfig_Stddev_Pop_Fields = {
  __typename?: 'parameter_constructionSiteParameterNameConfig_stddev_pop_fields';
  buildDuration?: Maybe<Scalars['Float']['output']>;
  buildEnd?: Maybe<Scalars['Float']['output']>;
  buildGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  buildStart?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  excavationDuration?: Maybe<Scalars['Float']['output']>;
  excavationEnd?: Maybe<Scalars['Float']['output']>;
  excavationGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  excavationStart?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  horizontalTrend?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  metricPoint?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringLength?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
  verticalTrend?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Parameter_ConstructionSiteParameterNameConfig_Stddev_Samp_Fields = {
  __typename?: 'parameter_constructionSiteParameterNameConfig_stddev_samp_fields';
  buildDuration?: Maybe<Scalars['Float']['output']>;
  buildEnd?: Maybe<Scalars['Float']['output']>;
  buildGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  buildStart?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  excavationDuration?: Maybe<Scalars['Float']['output']>;
  excavationEnd?: Maybe<Scalars['Float']['output']>;
  excavationGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  excavationStart?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  horizontalTrend?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  metricPoint?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringLength?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
  verticalTrend?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "parameter_constructionSiteParameterNameConfig" */
export type Parameter_ConstructionSiteParameterNameConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parameter_ConstructionSiteParameterNameConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parameter_ConstructionSiteParameterNameConfig_Stream_Cursor_Value_Input = {
  buildDuration?: InputMaybe<Scalars['Int']['input']>;
  buildEnd?: InputMaybe<Scalars['Int']['input']>;
  buildGoAheadCalculation?: InputMaybe<Scalars['Int']['input']>;
  buildStart?: InputMaybe<Scalars['Int']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  cuttingWheelHorizontalPosition?: InputMaybe<Scalars['Int']['input']>;
  cuttingWheelVerticalPosition?: InputMaybe<Scalars['Int']['input']>;
  excavationDuration?: InputMaybe<Scalars['Int']['input']>;
  excavationEnd?: InputMaybe<Scalars['Int']['input']>;
  excavationGoAheadCalculation?: InputMaybe<Scalars['Int']['input']>;
  excavationStart?: InputMaybe<Scalars['Int']['input']>;
  frontHorizontalPosition?: InputMaybe<Scalars['Int']['input']>;
  frontHorizontalTrend?: InputMaybe<Scalars['Int']['input']>;
  frontVerticalPosition?: InputMaybe<Scalars['Int']['input']>;
  frontVerticalTrend?: InputMaybe<Scalars['Int']['input']>;
  horizontalTrend?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  keyPosition?: InputMaybe<Scalars['Int']['input']>;
  leftSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  lowerSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  metricPoint?: InputMaybe<Scalars['Int']['input']>;
  rearHorizontalPosition?: InputMaybe<Scalars['Int']['input']>;
  rearVerticalPosition?: InputMaybe<Scalars['Int']['input']>;
  rightSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  ringLength?: InputMaybe<Scalars['Int']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  upperSkirtClearance?: InputMaybe<Scalars['Int']['input']>;
  verticalTrend?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Parameter_ConstructionSiteParameterNameConfig_Sum_Fields = {
  __typename?: 'parameter_constructionSiteParameterNameConfig_sum_fields';
  buildDuration?: Maybe<Scalars['Int']['output']>;
  buildEnd?: Maybe<Scalars['Int']['output']>;
  buildGoAheadCalculation?: Maybe<Scalars['Int']['output']>;
  buildStart?: Maybe<Scalars['Int']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Int']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Int']['output']>;
  excavationDuration?: Maybe<Scalars['Int']['output']>;
  excavationEnd?: Maybe<Scalars['Int']['output']>;
  excavationGoAheadCalculation?: Maybe<Scalars['Int']['output']>;
  excavationStart?: Maybe<Scalars['Int']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Int']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Int']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Int']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Int']['output']>;
  horizontalTrend?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  keyPosition?: Maybe<Scalars['Int']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Int']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Int']['output']>;
  metricPoint?: Maybe<Scalars['Int']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Int']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Int']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Int']['output']>;
  ringLength?: Maybe<Scalars['Int']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Int']['output']>;
  verticalTrend?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "parameter.constructionSiteParameterNameConfig" */
export enum Parameter_ConstructionSiteParameterNameConfig_Update_Column {
  /** column name */
  BuildDuration = 'buildDuration',
  /** column name */
  BuildEnd = 'buildEnd',
  /** column name */
  BuildGoAheadCalculation = 'buildGoAheadCalculation',
  /** column name */
  BuildStart = 'buildStart',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  CuttingWheelHorizontalPosition = 'cuttingWheelHorizontalPosition',
  /** column name */
  CuttingWheelVerticalPosition = 'cuttingWheelVerticalPosition',
  /** column name */
  ExcavationDuration = 'excavationDuration',
  /** column name */
  ExcavationEnd = 'excavationEnd',
  /** column name */
  ExcavationGoAheadCalculation = 'excavationGoAheadCalculation',
  /** column name */
  ExcavationStart = 'excavationStart',
  /** column name */
  FrontHorizontalPosition = 'frontHorizontalPosition',
  /** column name */
  FrontHorizontalTrend = 'frontHorizontalTrend',
  /** column name */
  FrontVerticalPosition = 'frontVerticalPosition',
  /** column name */
  FrontVerticalTrend = 'frontVerticalTrend',
  /** column name */
  HorizontalTrend = 'horizontalTrend',
  /** column name */
  Id = 'id',
  /** column name */
  KeyPosition = 'keyPosition',
  /** column name */
  LeftSkirtClearance = 'leftSkirtClearance',
  /** column name */
  LowerSkirtClearance = 'lowerSkirtClearance',
  /** column name */
  MetricPoint = 'metricPoint',
  /** column name */
  RearHorizontalPosition = 'rearHorizontalPosition',
  /** column name */
  RearVerticalPosition = 'rearVerticalPosition',
  /** column name */
  RightSkirtClearance = 'rightSkirtClearance',
  /** column name */
  RingLength = 'ringLength',
  /** column name */
  RingNumber = 'ringNumber',
  /** column name */
  UpperSkirtClearance = 'upperSkirtClearance',
  /** column name */
  VerticalTrend = 'verticalTrend'
}

export type Parameter_ConstructionSiteParameterNameConfig_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parameter_ConstructionSiteParameterNameConfig_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parameter_ConstructionSiteParameterNameConfig_Var_Pop_Fields = {
  __typename?: 'parameter_constructionSiteParameterNameConfig_var_pop_fields';
  buildDuration?: Maybe<Scalars['Float']['output']>;
  buildEnd?: Maybe<Scalars['Float']['output']>;
  buildGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  buildStart?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  excavationDuration?: Maybe<Scalars['Float']['output']>;
  excavationEnd?: Maybe<Scalars['Float']['output']>;
  excavationGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  excavationStart?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  horizontalTrend?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  metricPoint?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringLength?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
  verticalTrend?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Parameter_ConstructionSiteParameterNameConfig_Var_Samp_Fields = {
  __typename?: 'parameter_constructionSiteParameterNameConfig_var_samp_fields';
  buildDuration?: Maybe<Scalars['Float']['output']>;
  buildEnd?: Maybe<Scalars['Float']['output']>;
  buildGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  buildStart?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  excavationDuration?: Maybe<Scalars['Float']['output']>;
  excavationEnd?: Maybe<Scalars['Float']['output']>;
  excavationGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  excavationStart?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  horizontalTrend?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  metricPoint?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringLength?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
  verticalTrend?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Parameter_ConstructionSiteParameterNameConfig_Variance_Fields = {
  __typename?: 'parameter_constructionSiteParameterNameConfig_variance_fields';
  buildDuration?: Maybe<Scalars['Float']['output']>;
  buildEnd?: Maybe<Scalars['Float']['output']>;
  buildGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  buildStart?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  excavationDuration?: Maybe<Scalars['Float']['output']>;
  excavationEnd?: Maybe<Scalars['Float']['output']>;
  excavationGoAheadCalculation?: Maybe<Scalars['Float']['output']>;
  excavationStart?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  horizontalTrend?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  metricPoint?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringLength?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
  verticalTrend?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "parameter.familyDef" */
export type Parameter_FamilyDef = {
  __typename?: 'parameter_familyDef';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  customName?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  parameterDefs: Array<Parameter_ParameterDef>;
  /** An aggregate relationship */
  parameterDefs_aggregate: Parameter_ParameterDef_Aggregate;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "parameter.familyDef" */
export type Parameter_FamilyDefParameterDefsArgs = {
  distinct_on?: InputMaybe<Array<Parameter_ParameterDef_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_ParameterDef_Order_By>>;
  where?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
};


/** columns and relationships of "parameter.familyDef" */
export type Parameter_FamilyDefParameterDefs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_ParameterDef_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_ParameterDef_Order_By>>;
  where?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
};

/** aggregated selection of "parameter.familyDef" */
export type Parameter_FamilyDef_Aggregate = {
  __typename?: 'parameter_familyDef_aggregate';
  aggregate?: Maybe<Parameter_FamilyDef_Aggregate_Fields>;
  nodes: Array<Parameter_FamilyDef>;
};

/** aggregate fields of "parameter.familyDef" */
export type Parameter_FamilyDef_Aggregate_Fields = {
  __typename?: 'parameter_familyDef_aggregate_fields';
  avg?: Maybe<Parameter_FamilyDef_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parameter_FamilyDef_Max_Fields>;
  min?: Maybe<Parameter_FamilyDef_Min_Fields>;
  stddev?: Maybe<Parameter_FamilyDef_Stddev_Fields>;
  stddev_pop?: Maybe<Parameter_FamilyDef_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parameter_FamilyDef_Stddev_Samp_Fields>;
  sum?: Maybe<Parameter_FamilyDef_Sum_Fields>;
  var_pop?: Maybe<Parameter_FamilyDef_Var_Pop_Fields>;
  var_samp?: Maybe<Parameter_FamilyDef_Var_Samp_Fields>;
  variance?: Maybe<Parameter_FamilyDef_Variance_Fields>;
};


/** aggregate fields of "parameter.familyDef" */
export type Parameter_FamilyDef_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parameter_FamilyDef_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Parameter_FamilyDef_Avg_Fields = {
  __typename?: 'parameter_familyDef_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "parameter.familyDef". All fields are combined with a logical 'AND'. */
export type Parameter_FamilyDef_Bool_Exp = {
  _and?: InputMaybe<Array<Parameter_FamilyDef_Bool_Exp>>;
  _not?: InputMaybe<Parameter_FamilyDef_Bool_Exp>;
  _or?: InputMaybe<Array<Parameter_FamilyDef_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  customName?: InputMaybe<String_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parameterDefs?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
  parameterDefs_aggregate?: InputMaybe<Parameter_ParameterDef_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "parameter.familyDef" */
export enum Parameter_FamilyDef_Constraint {
  /** unique or primary key constraint on columns "constructionSiteId", "name" */
  FamilyDefConstructionSiteIdNameKey = 'familyDef_constructionSiteId_name_key',
  /** unique or primary key constraint on columns "id" */
  FamilyDefPkey = 'familyDef_pkey'
}

/** input type for incrementing numeric columns in table "parameter.familyDef" */
export type Parameter_FamilyDef_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "parameter.familyDef" */
export type Parameter_FamilyDef_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameterDefs?: InputMaybe<Parameter_ParameterDef_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Parameter_FamilyDef_Max_Fields = {
  __typename?: 'parameter_familyDef_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Parameter_FamilyDef_Min_Fields = {
  __typename?: 'parameter_familyDef_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "parameter.familyDef" */
export type Parameter_FamilyDef_Mutation_Response = {
  __typename?: 'parameter_familyDef_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parameter_FamilyDef>;
};

/** input type for inserting object relation for remote table "parameter.familyDef" */
export type Parameter_FamilyDef_Obj_Rel_Insert_Input = {
  data: Parameter_FamilyDef_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Parameter_FamilyDef_On_Conflict>;
};

/** on_conflict condition type for table "parameter.familyDef" */
export type Parameter_FamilyDef_On_Conflict = {
  constraint: Parameter_FamilyDef_Constraint;
  update_columns?: Array<Parameter_FamilyDef_Update_Column>;
  where?: InputMaybe<Parameter_FamilyDef_Bool_Exp>;
};

/** Ordering options when selecting data from "parameter.familyDef". */
export type Parameter_FamilyDef_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  customName?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isHidden?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parameterDefs_aggregate?: InputMaybe<Parameter_ParameterDef_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parameter.familyDef */
export type Parameter_FamilyDef_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "parameter.familyDef" */
export enum Parameter_FamilyDef_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomName = 'customName',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "parameter.familyDef" */
export type Parameter_FamilyDef_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Parameter_FamilyDef_Stddev_Fields = {
  __typename?: 'parameter_familyDef_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Parameter_FamilyDef_Stddev_Pop_Fields = {
  __typename?: 'parameter_familyDef_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Parameter_FamilyDef_Stddev_Samp_Fields = {
  __typename?: 'parameter_familyDef_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "parameter_familyDef" */
export type Parameter_FamilyDef_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parameter_FamilyDef_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parameter_FamilyDef_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Parameter_FamilyDef_Sum_Fields = {
  __typename?: 'parameter_familyDef_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "parameter.familyDef" */
export enum Parameter_FamilyDef_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomName = 'customName',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Parameter_FamilyDef_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parameter_FamilyDef_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parameter_FamilyDef_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parameter_FamilyDef_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parameter_FamilyDef_Var_Pop_Fields = {
  __typename?: 'parameter_familyDef_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Parameter_FamilyDef_Var_Samp_Fields = {
  __typename?: 'parameter_familyDef_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Parameter_FamilyDef_Variance_Fields = {
  __typename?: 'parameter_familyDef_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "parameter.metric" */
export type Parameter_Metric = {
  __typename?: 'parameter_metric';
  batchDate: Scalars['timestamptz']['output'];
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['bigint']['output'];
  isBuilding?: Maybe<Scalars['Boolean']['output']>;
  isExcavating?: Maybe<Scalars['Boolean']['output']>;
  parametersMetric?: Maybe<Scalars['jsonb']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "parameter.metric" */
export type Parameter_MetricParametersMetricArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "parameter.metric" */
export type Parameter_Metric_Aggregate = {
  __typename?: 'parameter_metric_aggregate';
  aggregate?: Maybe<Parameter_Metric_Aggregate_Fields>;
  nodes: Array<Parameter_Metric>;
};

export type Parameter_Metric_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Parameter_Metric_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Parameter_Metric_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Parameter_Metric_Aggregate_Bool_Exp_Count>;
};

export type Parameter_Metric_Aggregate_Bool_Exp_Bool_And = {
  arguments: Parameter_Metric_Select_Column_Parameter_Metric_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_Metric_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parameter_Metric_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Parameter_Metric_Select_Column_Parameter_Metric_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_Metric_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parameter_Metric_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parameter_Metric_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_Metric_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parameter.metric" */
export type Parameter_Metric_Aggregate_Fields = {
  __typename?: 'parameter_metric_aggregate_fields';
  avg?: Maybe<Parameter_Metric_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parameter_Metric_Max_Fields>;
  min?: Maybe<Parameter_Metric_Min_Fields>;
  stddev?: Maybe<Parameter_Metric_Stddev_Fields>;
  stddev_pop?: Maybe<Parameter_Metric_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parameter_Metric_Stddev_Samp_Fields>;
  sum?: Maybe<Parameter_Metric_Sum_Fields>;
  var_pop?: Maybe<Parameter_Metric_Var_Pop_Fields>;
  var_samp?: Maybe<Parameter_Metric_Var_Samp_Fields>;
  variance?: Maybe<Parameter_Metric_Variance_Fields>;
};


/** aggregate fields of "parameter.metric" */
export type Parameter_Metric_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parameter_Metric_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parameter.metric" */
export type Parameter_Metric_Aggregate_Order_By = {
  avg?: InputMaybe<Parameter_Metric_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parameter_Metric_Max_Order_By>;
  min?: InputMaybe<Parameter_Metric_Min_Order_By>;
  stddev?: InputMaybe<Parameter_Metric_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parameter_Metric_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parameter_Metric_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parameter_Metric_Sum_Order_By>;
  var_pop?: InputMaybe<Parameter_Metric_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parameter_Metric_Var_Samp_Order_By>;
  variance?: InputMaybe<Parameter_Metric_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Parameter_Metric_Append_Input = {
  parametersMetric?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "parameter.metric" */
export type Parameter_Metric_Arr_Rel_Insert_Input = {
  data: Array<Parameter_Metric_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parameter_Metric_On_Conflict>;
};

/** aggregate avg on columns */
export type Parameter_Metric_Avg_Fields = {
  __typename?: 'parameter_metric_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parameter.metric" */
export type Parameter_Metric_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parameter.metric". All fields are combined with a logical 'AND'. */
export type Parameter_Metric_Bool_Exp = {
  _and?: InputMaybe<Array<Parameter_Metric_Bool_Exp>>;
  _not?: InputMaybe<Parameter_Metric_Bool_Exp>;
  _or?: InputMaybe<Array<Parameter_Metric_Bool_Exp>>;
  batchDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isBuilding?: InputMaybe<Boolean_Comparison_Exp>;
  isExcavating?: InputMaybe<Boolean_Comparison_Exp>;
  parametersMetric?: InputMaybe<Jsonb_Comparison_Exp>;
  ring?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "parameter.metric" */
export enum Parameter_Metric_Constraint {
  /** unique or primary key constraint on columns "id" */
  MetricPkey = 'metric_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Parameter_Metric_Delete_At_Path_Input = {
  parametersMetric?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Parameter_Metric_Delete_Elem_Input = {
  parametersMetric?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Parameter_Metric_Delete_Key_Input = {
  parametersMetric?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "parameter.metric" */
export type Parameter_Metric_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "parameter.metric" */
export type Parameter_Metric_Insert_Input = {
  batchDate?: InputMaybe<Scalars['timestamptz']['input']>;
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isBuilding?: InputMaybe<Scalars['Boolean']['input']>;
  isExcavating?: InputMaybe<Scalars['Boolean']['input']>;
  parametersMetric?: InputMaybe<Scalars['jsonb']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Parameter_Metric_Max_Fields = {
  __typename?: 'parameter_metric_max_fields';
  batchDate?: Maybe<Scalars['timestamptz']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "parameter.metric" */
export type Parameter_Metric_Max_Order_By = {
  batchDate?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parameter_Metric_Min_Fields = {
  __typename?: 'parameter_metric_min_fields';
  batchDate?: Maybe<Scalars['timestamptz']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "parameter.metric" */
export type Parameter_Metric_Min_Order_By = {
  batchDate?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parameter.metric" */
export type Parameter_Metric_Mutation_Response = {
  __typename?: 'parameter_metric_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parameter_Metric>;
};

/** on_conflict condition type for table "parameter.metric" */
export type Parameter_Metric_On_Conflict = {
  constraint: Parameter_Metric_Constraint;
  update_columns?: Array<Parameter_Metric_Update_Column>;
  where?: InputMaybe<Parameter_Metric_Bool_Exp>;
};

/** Ordering options when selecting data from "parameter.metric". */
export type Parameter_Metric_Order_By = {
  batchDate?: InputMaybe<Order_By>;
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isBuilding?: InputMaybe<Order_By>;
  isExcavating?: InputMaybe<Order_By>;
  parametersMetric?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parameter.metric */
export type Parameter_Metric_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Parameter_Metric_Prepend_Input = {
  parametersMetric?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "parameter.metric" */
export enum Parameter_Metric_Select_Column {
  /** column name */
  BatchDate = 'batchDate',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  IsBuilding = 'isBuilding',
  /** column name */
  IsExcavating = 'isExcavating',
  /** column name */
  ParametersMetric = 'parametersMetric',
  /** column name */
  Ring = 'ring'
}

/** select "parameter_metric_aggregate_bool_exp_bool_and_arguments_columns" columns of table "parameter.metric" */
export enum Parameter_Metric_Select_Column_Parameter_Metric_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsBuilding = 'isBuilding',
  /** column name */
  IsExcavating = 'isExcavating'
}

/** select "parameter_metric_aggregate_bool_exp_bool_or_arguments_columns" columns of table "parameter.metric" */
export enum Parameter_Metric_Select_Column_Parameter_Metric_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsBuilding = 'isBuilding',
  /** column name */
  IsExcavating = 'isExcavating'
}

/** input type for updating data in table "parameter.metric" */
export type Parameter_Metric_Set_Input = {
  batchDate?: InputMaybe<Scalars['timestamptz']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isBuilding?: InputMaybe<Scalars['Boolean']['input']>;
  isExcavating?: InputMaybe<Scalars['Boolean']['input']>;
  parametersMetric?: InputMaybe<Scalars['jsonb']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Parameter_Metric_Stddev_Fields = {
  __typename?: 'parameter_metric_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parameter.metric" */
export type Parameter_Metric_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parameter_Metric_Stddev_Pop_Fields = {
  __typename?: 'parameter_metric_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parameter.metric" */
export type Parameter_Metric_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parameter_Metric_Stddev_Samp_Fields = {
  __typename?: 'parameter_metric_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parameter.metric" */
export type Parameter_Metric_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parameter_metric" */
export type Parameter_Metric_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parameter_Metric_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parameter_Metric_Stream_Cursor_Value_Input = {
  batchDate?: InputMaybe<Scalars['timestamptz']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isBuilding?: InputMaybe<Scalars['Boolean']['input']>;
  isExcavating?: InputMaybe<Scalars['Boolean']['input']>;
  parametersMetric?: InputMaybe<Scalars['jsonb']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Parameter_Metric_Sum_Fields = {
  __typename?: 'parameter_metric_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "parameter.metric" */
export type Parameter_Metric_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** update columns of table "parameter.metric" */
export enum Parameter_Metric_Update_Column {
  /** column name */
  BatchDate = 'batchDate',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  IsBuilding = 'isBuilding',
  /** column name */
  IsExcavating = 'isExcavating',
  /** column name */
  ParametersMetric = 'parametersMetric',
  /** column name */
  Ring = 'ring'
}

export type Parameter_Metric_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Parameter_Metric_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Parameter_Metric_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Parameter_Metric_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Parameter_Metric_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parameter_Metric_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Parameter_Metric_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parameter_Metric_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parameter_Metric_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parameter_Metric_Var_Pop_Fields = {
  __typename?: 'parameter_metric_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parameter.metric" */
export type Parameter_Metric_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parameter_Metric_Var_Samp_Fields = {
  __typename?: 'parameter_metric_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parameter.metric" */
export type Parameter_Metric_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parameter_Metric_Variance_Fields = {
  __typename?: 'parameter_metric_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parameter.metric" */
export type Parameter_Metric_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** columns and relationships of "parameter.parameterDef" */
export type Parameter_ParameterDef = {
  __typename?: 'parameter_parameterDef';
  createdAt: Scalars['timestamptz']['output'];
  customName?: Maybe<Scalars['String']['output']>;
  customUnit?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  displayUnit: Scalars['String']['output'];
  /** An object relationship */
  familyDef: Parameter_FamilyDef;
  familyDefId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  values: Array<Parameter_Value>;
  /** An aggregate relationship */
  values_aggregate: Parameter_Value_Aggregate;
};


/** columns and relationships of "parameter.parameterDef" */
export type Parameter_ParameterDefValuesArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Value_Order_By>>;
  where?: InputMaybe<Parameter_Value_Bool_Exp>;
};


/** columns and relationships of "parameter.parameterDef" */
export type Parameter_ParameterDefValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Value_Order_By>>;
  where?: InputMaybe<Parameter_Value_Bool_Exp>;
};

/** aggregated selection of "parameter.parameterDef" */
export type Parameter_ParameterDef_Aggregate = {
  __typename?: 'parameter_parameterDef_aggregate';
  aggregate?: Maybe<Parameter_ParameterDef_Aggregate_Fields>;
  nodes: Array<Parameter_ParameterDef>;
};

export type Parameter_ParameterDef_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Parameter_ParameterDef_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Parameter_ParameterDef_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Parameter_ParameterDef_Aggregate_Bool_Exp_Count>;
};

export type Parameter_ParameterDef_Aggregate_Bool_Exp_Bool_And = {
  arguments: Parameter_ParameterDef_Select_Column_Parameter_ParameterDef_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parameter_ParameterDef_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Parameter_ParameterDef_Select_Column_Parameter_ParameterDef_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Parameter_ParameterDef_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parameter_ParameterDef_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parameter.parameterDef" */
export type Parameter_ParameterDef_Aggregate_Fields = {
  __typename?: 'parameter_parameterDef_aggregate_fields';
  avg?: Maybe<Parameter_ParameterDef_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parameter_ParameterDef_Max_Fields>;
  min?: Maybe<Parameter_ParameterDef_Min_Fields>;
  stddev?: Maybe<Parameter_ParameterDef_Stddev_Fields>;
  stddev_pop?: Maybe<Parameter_ParameterDef_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parameter_ParameterDef_Stddev_Samp_Fields>;
  sum?: Maybe<Parameter_ParameterDef_Sum_Fields>;
  var_pop?: Maybe<Parameter_ParameterDef_Var_Pop_Fields>;
  var_samp?: Maybe<Parameter_ParameterDef_Var_Samp_Fields>;
  variance?: Maybe<Parameter_ParameterDef_Variance_Fields>;
};


/** aggregate fields of "parameter.parameterDef" */
export type Parameter_ParameterDef_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parameter_ParameterDef_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parameter.parameterDef" */
export type Parameter_ParameterDef_Aggregate_Order_By = {
  avg?: InputMaybe<Parameter_ParameterDef_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parameter_ParameterDef_Max_Order_By>;
  min?: InputMaybe<Parameter_ParameterDef_Min_Order_By>;
  stddev?: InputMaybe<Parameter_ParameterDef_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parameter_ParameterDef_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parameter_ParameterDef_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parameter_ParameterDef_Sum_Order_By>;
  var_pop?: InputMaybe<Parameter_ParameterDef_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parameter_ParameterDef_Var_Samp_Order_By>;
  variance?: InputMaybe<Parameter_ParameterDef_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parameter.parameterDef" */
export type Parameter_ParameterDef_Arr_Rel_Insert_Input = {
  data: Array<Parameter_ParameterDef_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parameter_ParameterDef_On_Conflict>;
};

/** aggregate avg on columns */
export type Parameter_ParameterDef_Avg_Fields = {
  __typename?: 'parameter_parameterDef_avg_fields';
  familyDefId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parameter.parameterDef" */
export type Parameter_ParameterDef_Avg_Order_By = {
  familyDefId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parameter.parameterDef". All fields are combined with a logical 'AND'. */
export type Parameter_ParameterDef_Bool_Exp = {
  _and?: InputMaybe<Array<Parameter_ParameterDef_Bool_Exp>>;
  _not?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
  _or?: InputMaybe<Array<Parameter_ParameterDef_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  customName?: InputMaybe<String_Comparison_Exp>;
  customUnit?: InputMaybe<String_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  displayUnit?: InputMaybe<String_Comparison_Exp>;
  familyDef?: InputMaybe<Parameter_FamilyDef_Bool_Exp>;
  familyDefId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  values?: InputMaybe<Parameter_Value_Bool_Exp>;
  values_aggregate?: InputMaybe<Parameter_Value_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "parameter.parameterDef" */
export enum Parameter_ParameterDef_Constraint {
  /** unique or primary key constraint on columns "familyDefId", "name" */
  ParameterDefNameFamilyDefIdKey = 'parameterDef_name_familyDefId_key',
  /** unique or primary key constraint on columns "id" */
  ParameterDefPkey = 'parameterDef_pkey'
}

/** input type for incrementing numeric columns in table "parameter.parameterDef" */
export type Parameter_ParameterDef_Inc_Input = {
  familyDefId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "parameter.parameterDef" */
export type Parameter_ParameterDef_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  customUnit?: InputMaybe<Scalars['String']['input']>;
  familyDef?: InputMaybe<Parameter_FamilyDef_Obj_Rel_Insert_Input>;
  familyDefId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  values?: InputMaybe<Parameter_Value_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Parameter_ParameterDef_Max_Fields = {
  __typename?: 'parameter_parameterDef_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  customUnit?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayUnit?: Maybe<Scalars['String']['output']>;
  familyDefId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "parameter.parameterDef" */
export type Parameter_ParameterDef_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  customName?: InputMaybe<Order_By>;
  customUnit?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  displayUnit?: InputMaybe<Order_By>;
  familyDefId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parameter_ParameterDef_Min_Fields = {
  __typename?: 'parameter_parameterDef_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  customUnit?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayUnit?: Maybe<Scalars['String']['output']>;
  familyDefId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "parameter.parameterDef" */
export type Parameter_ParameterDef_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  customName?: InputMaybe<Order_By>;
  customUnit?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  displayUnit?: InputMaybe<Order_By>;
  familyDefId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parameter.parameterDef" */
export type Parameter_ParameterDef_Mutation_Response = {
  __typename?: 'parameter_parameterDef_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parameter_ParameterDef>;
};

/** input type for inserting object relation for remote table "parameter.parameterDef" */
export type Parameter_ParameterDef_Obj_Rel_Insert_Input = {
  data: Parameter_ParameterDef_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Parameter_ParameterDef_On_Conflict>;
};

/** on_conflict condition type for table "parameter.parameterDef" */
export type Parameter_ParameterDef_On_Conflict = {
  constraint: Parameter_ParameterDef_Constraint;
  update_columns?: Array<Parameter_ParameterDef_Update_Column>;
  where?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
};

/** Ordering options when selecting data from "parameter.parameterDef". */
export type Parameter_ParameterDef_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  customName?: InputMaybe<Order_By>;
  customUnit?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  displayUnit?: InputMaybe<Order_By>;
  familyDef?: InputMaybe<Parameter_FamilyDef_Order_By>;
  familyDefId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isHidden?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  values_aggregate?: InputMaybe<Parameter_Value_Aggregate_Order_By>;
};

/** primary key columns input for table: parameter.parameterDef */
export type Parameter_ParameterDef_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "parameter.parameterDef" */
export enum Parameter_ParameterDef_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomName = 'customName',
  /** column name */
  CustomUnit = 'customUnit',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  DisplayUnit = 'displayUnit',
  /** column name */
  FamilyDefId = 'familyDefId',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  Unit = 'unit',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "parameter_parameterDef_aggregate_bool_exp_bool_and_arguments_columns" columns of table "parameter.parameterDef" */
export enum Parameter_ParameterDef_Select_Column_Parameter_ParameterDef_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsHidden = 'isHidden'
}

/** select "parameter_parameterDef_aggregate_bool_exp_bool_or_arguments_columns" columns of table "parameter.parameterDef" */
export enum Parameter_ParameterDef_Select_Column_Parameter_ParameterDef_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsHidden = 'isHidden'
}

/** input type for updating data in table "parameter.parameterDef" */
export type Parameter_ParameterDef_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  customUnit?: InputMaybe<Scalars['String']['input']>;
  familyDefId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Parameter_ParameterDef_Stddev_Fields = {
  __typename?: 'parameter_parameterDef_stddev_fields';
  familyDefId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parameter.parameterDef" */
export type Parameter_ParameterDef_Stddev_Order_By = {
  familyDefId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parameter_ParameterDef_Stddev_Pop_Fields = {
  __typename?: 'parameter_parameterDef_stddev_pop_fields';
  familyDefId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parameter.parameterDef" */
export type Parameter_ParameterDef_Stddev_Pop_Order_By = {
  familyDefId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parameter_ParameterDef_Stddev_Samp_Fields = {
  __typename?: 'parameter_parameterDef_stddev_samp_fields';
  familyDefId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parameter.parameterDef" */
export type Parameter_ParameterDef_Stddev_Samp_Order_By = {
  familyDefId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parameter_parameterDef" */
export type Parameter_ParameterDef_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parameter_ParameterDef_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parameter_ParameterDef_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  customUnit?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayUnit?: InputMaybe<Scalars['String']['input']>;
  familyDefId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Parameter_ParameterDef_Sum_Fields = {
  __typename?: 'parameter_parameterDef_sum_fields';
  familyDefId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "parameter.parameterDef" */
export type Parameter_ParameterDef_Sum_Order_By = {
  familyDefId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "parameter.parameterDef" */
export enum Parameter_ParameterDef_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CustomName = 'customName',
  /** column name */
  CustomUnit = 'customUnit',
  /** column name */
  FamilyDefId = 'familyDefId',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  Unit = 'unit',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Parameter_ParameterDef_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parameter_ParameterDef_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parameter_ParameterDef_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parameter_ParameterDef_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parameter_ParameterDef_Var_Pop_Fields = {
  __typename?: 'parameter_parameterDef_var_pop_fields';
  familyDefId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parameter.parameterDef" */
export type Parameter_ParameterDef_Var_Pop_Order_By = {
  familyDefId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parameter_ParameterDef_Var_Samp_Fields = {
  __typename?: 'parameter_parameterDef_var_samp_fields';
  familyDefId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parameter.parameterDef" */
export type Parameter_ParameterDef_Var_Samp_Order_By = {
  familyDefId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parameter_ParameterDef_Variance_Fields = {
  __typename?: 'parameter_parameterDef_variance_fields';
  familyDefId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parameter.parameterDef" */
export type Parameter_ParameterDef_Variance_Order_By = {
  familyDefId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "parameter.ring" */
export type Parameter_Ring = {
  __typename?: 'parameter_ring';
  batchDate: Scalars['timestamptz']['output'];
  buildEnd?: Maybe<Scalars['timestamptz']['output']>;
  buildEndMetricPoint?: Maybe<Scalars['float8']['output']>;
  buildStart?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  cuttingWheelHorizontalPosition?: Maybe<Scalars['float8']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['float8']['output']>;
  excavationEnd?: Maybe<Scalars['timestamptz']['output']>;
  excavationStart?: Maybe<Scalars['timestamptz']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['float8']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['float8']['output']>;
  frontVerticalPosition?: Maybe<Scalars['float8']['output']>;
  frontVerticalTrend?: Maybe<Scalars['float8']['output']>;
  id: Scalars['uuid']['output'];
  keyPosition?: Maybe<Scalars['Int']['output']>;
  leftSkirtClearance?: Maybe<Scalars['float8']['output']>;
  length?: Maybe<Scalars['float8']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['float8']['output']>;
  realBuildDuration?: Maybe<Scalars['interval']['output']>;
  realExcavationDuration?: Maybe<Scalars['interval']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['float8']['output']>;
  rearHorizontalTrend?: Maybe<Scalars['float8']['output']>;
  rearVerticalPosition?: Maybe<Scalars['float8']['output']>;
  rearVerticalTrend?: Maybe<Scalars['float8']['output']>;
  rightSkirtClearance?: Maybe<Scalars['float8']['output']>;
  ringNumber: Scalars['Int']['output'];
  /** An array relationship */
  segments: Array<Quality_Segment>;
  /** An aggregate relationship */
  segments_aggregate: Quality_Segment_Aggregate;
  totalBuildDuration?: Maybe<Scalars['interval']['output']>;
  totalExcavationDuration?: Maybe<Scalars['interval']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  upperSkirtClearance?: Maybe<Scalars['float8']['output']>;
};


/** columns and relationships of "parameter.ring" */
export type Parameter_RingSegmentsArgs = {
  distinct_on?: InputMaybe<Array<Quality_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_Segment_Order_By>>;
  where?: InputMaybe<Quality_Segment_Bool_Exp>;
};


/** columns and relationships of "parameter.ring" */
export type Parameter_RingSegments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_Segment_Order_By>>;
  where?: InputMaybe<Quality_Segment_Bool_Exp>;
};

/** columns and relationships of "parameter.ringProjection" */
export type Parameter_RingProjection = {
  __typename?: 'parameter_ringProjection';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  expectedRingNumber: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  projectionDate: Scalars['date']['output'];
};

/** aggregated selection of "parameter.ringProjection" */
export type Parameter_RingProjection_Aggregate = {
  __typename?: 'parameter_ringProjection_aggregate';
  aggregate?: Maybe<Parameter_RingProjection_Aggregate_Fields>;
  nodes: Array<Parameter_RingProjection>;
};

/** aggregate fields of "parameter.ringProjection" */
export type Parameter_RingProjection_Aggregate_Fields = {
  __typename?: 'parameter_ringProjection_aggregate_fields';
  avg?: Maybe<Parameter_RingProjection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parameter_RingProjection_Max_Fields>;
  min?: Maybe<Parameter_RingProjection_Min_Fields>;
  stddev?: Maybe<Parameter_RingProjection_Stddev_Fields>;
  stddev_pop?: Maybe<Parameter_RingProjection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parameter_RingProjection_Stddev_Samp_Fields>;
  sum?: Maybe<Parameter_RingProjection_Sum_Fields>;
  var_pop?: Maybe<Parameter_RingProjection_Var_Pop_Fields>;
  var_samp?: Maybe<Parameter_RingProjection_Var_Samp_Fields>;
  variance?: Maybe<Parameter_RingProjection_Variance_Fields>;
};


/** aggregate fields of "parameter.ringProjection" */
export type Parameter_RingProjection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parameter_RingProjection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Parameter_RingProjection_Avg_Fields = {
  __typename?: 'parameter_ringProjection_avg_fields';
  expectedRingNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "parameter.ringProjection". All fields are combined with a logical 'AND'. */
export type Parameter_RingProjection_Bool_Exp = {
  _and?: InputMaybe<Array<Parameter_RingProjection_Bool_Exp>>;
  _not?: InputMaybe<Parameter_RingProjection_Bool_Exp>;
  _or?: InputMaybe<Array<Parameter_RingProjection_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  expectedRingNumber?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  projectionDate?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "parameter.ringProjection" */
export enum Parameter_RingProjection_Constraint {
  /** unique or primary key constraint on columns "id" */
  RingProjectionPkey = 'ringProjection_pkey',
  /** unique or primary key constraint on columns "projectionDate", "constructionSiteId" */
  UniqueProjection = 'unique_projection'
}

/** input type for incrementing numeric columns in table "parameter.ringProjection" */
export type Parameter_RingProjection_Inc_Input = {
  expectedRingNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "parameter.ringProjection" */
export type Parameter_RingProjection_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  expectedRingNumber?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectionDate?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate max on columns */
export type Parameter_RingProjection_Max_Fields = {
  __typename?: 'parameter_ringProjection_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  expectedRingNumber?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectionDate?: Maybe<Scalars['date']['output']>;
};

/** aggregate min on columns */
export type Parameter_RingProjection_Min_Fields = {
  __typename?: 'parameter_ringProjection_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  expectedRingNumber?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectionDate?: Maybe<Scalars['date']['output']>;
};

/** response of any mutation on the table "parameter.ringProjection" */
export type Parameter_RingProjection_Mutation_Response = {
  __typename?: 'parameter_ringProjection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parameter_RingProjection>;
};

/** on_conflict condition type for table "parameter.ringProjection" */
export type Parameter_RingProjection_On_Conflict = {
  constraint: Parameter_RingProjection_Constraint;
  update_columns?: Array<Parameter_RingProjection_Update_Column>;
  where?: InputMaybe<Parameter_RingProjection_Bool_Exp>;
};

/** Ordering options when selecting data from "parameter.ringProjection". */
export type Parameter_RingProjection_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  expectedRingNumber?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectionDate?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parameter.ringProjection */
export type Parameter_RingProjection_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "parameter.ringProjection" */
export enum Parameter_RingProjection_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  ExpectedRingNumber = 'expectedRingNumber',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectionDate = 'projectionDate'
}

/** input type for updating data in table "parameter.ringProjection" */
export type Parameter_RingProjection_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  expectedRingNumber?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectionDate?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate stddev on columns */
export type Parameter_RingProjection_Stddev_Fields = {
  __typename?: 'parameter_ringProjection_stddev_fields';
  expectedRingNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Parameter_RingProjection_Stddev_Pop_Fields = {
  __typename?: 'parameter_ringProjection_stddev_pop_fields';
  expectedRingNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Parameter_RingProjection_Stddev_Samp_Fields = {
  __typename?: 'parameter_ringProjection_stddev_samp_fields';
  expectedRingNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "parameter_ringProjection" */
export type Parameter_RingProjection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parameter_RingProjection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parameter_RingProjection_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  expectedRingNumber?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectionDate?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate sum on columns */
export type Parameter_RingProjection_Sum_Fields = {
  __typename?: 'parameter_ringProjection_sum_fields';
  expectedRingNumber?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "parameter.ringProjection" */
export enum Parameter_RingProjection_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  ExpectedRingNumber = 'expectedRingNumber',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectionDate = 'projectionDate'
}

export type Parameter_RingProjection_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parameter_RingProjection_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parameter_RingProjection_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parameter_RingProjection_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parameter_RingProjection_Var_Pop_Fields = {
  __typename?: 'parameter_ringProjection_var_pop_fields';
  expectedRingNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Parameter_RingProjection_Var_Samp_Fields = {
  __typename?: 'parameter_ringProjection_var_samp_fields';
  expectedRingNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Parameter_RingProjection_Variance_Fields = {
  __typename?: 'parameter_ringProjection_variance_fields';
  expectedRingNumber?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "parameter.ringWithProductionDay" */
export type Parameter_RingWithProductionDay = {
  __typename?: 'parameter_ringWithProductionDay';
  buildEnd?: Maybe<Scalars['timestamptz']['output']>;
  buildEndMetricPoint?: Maybe<Scalars['float8']['output']>;
  buildStart?: Maybe<Scalars['timestamptz']['output']>;
  calendarDate?: Maybe<Scalars['date']['output']>;
  calendarDayOfWeek?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  constructionSite?: Maybe<ConstructionSite>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  excavationEnd?: Maybe<Scalars['timestamptz']['output']>;
  excavationStart?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  keyPosition?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['float8']['output']>;
  productionDate?: Maybe<Scalars['date']['output']>;
  productionDayOfWeek?: Maybe<Scalars['String']['output']>;
  realBuildDuration?: Maybe<Scalars['interval']['output']>;
  realExcavationDuration?: Maybe<Scalars['interval']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  totalBuildDuration?: Maybe<Scalars['interval']['output']>;
  totalExcavationDuration?: Maybe<Scalars['interval']['output']>;
};

/** aggregated selection of "parameter.ringWithProductionDay" */
export type Parameter_RingWithProductionDay_Aggregate = {
  __typename?: 'parameter_ringWithProductionDay_aggregate';
  aggregate?: Maybe<Parameter_RingWithProductionDay_Aggregate_Fields>;
  nodes: Array<Parameter_RingWithProductionDay>;
};

/** aggregate fields of "parameter.ringWithProductionDay" */
export type Parameter_RingWithProductionDay_Aggregate_Fields = {
  __typename?: 'parameter_ringWithProductionDay_aggregate_fields';
  avg?: Maybe<Parameter_RingWithProductionDay_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parameter_RingWithProductionDay_Max_Fields>;
  min?: Maybe<Parameter_RingWithProductionDay_Min_Fields>;
  stddev?: Maybe<Parameter_RingWithProductionDay_Stddev_Fields>;
  stddev_pop?: Maybe<Parameter_RingWithProductionDay_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parameter_RingWithProductionDay_Stddev_Samp_Fields>;
  sum?: Maybe<Parameter_RingWithProductionDay_Sum_Fields>;
  var_pop?: Maybe<Parameter_RingWithProductionDay_Var_Pop_Fields>;
  var_samp?: Maybe<Parameter_RingWithProductionDay_Var_Samp_Fields>;
  variance?: Maybe<Parameter_RingWithProductionDay_Variance_Fields>;
};


/** aggregate fields of "parameter.ringWithProductionDay" */
export type Parameter_RingWithProductionDay_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parameter_RingWithProductionDay_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Parameter_RingWithProductionDay_Avg_Fields = {
  __typename?: 'parameter_ringWithProductionDay_avg_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "parameter.ringWithProductionDay". All fields are combined with a logical 'AND'. */
export type Parameter_RingWithProductionDay_Bool_Exp = {
  _and?: InputMaybe<Array<Parameter_RingWithProductionDay_Bool_Exp>>;
  _not?: InputMaybe<Parameter_RingWithProductionDay_Bool_Exp>;
  _or?: InputMaybe<Array<Parameter_RingWithProductionDay_Bool_Exp>>;
  buildEnd?: InputMaybe<Timestamptz_Comparison_Exp>;
  buildEndMetricPoint?: InputMaybe<Float8_Comparison_Exp>;
  buildStart?: InputMaybe<Timestamptz_Comparison_Exp>;
  calendarDate?: InputMaybe<Date_Comparison_Exp>;
  calendarDayOfWeek?: InputMaybe<String_Comparison_Exp>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  excavationEnd?: InputMaybe<Timestamptz_Comparison_Exp>;
  excavationStart?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  keyPosition?: InputMaybe<Int_Comparison_Exp>;
  length?: InputMaybe<Float8_Comparison_Exp>;
  productionDate?: InputMaybe<Date_Comparison_Exp>;
  productionDayOfWeek?: InputMaybe<String_Comparison_Exp>;
  realBuildDuration?: InputMaybe<Interval_Comparison_Exp>;
  realExcavationDuration?: InputMaybe<Interval_Comparison_Exp>;
  ringNumber?: InputMaybe<Int_Comparison_Exp>;
  totalBuildDuration?: InputMaybe<Interval_Comparison_Exp>;
  totalExcavationDuration?: InputMaybe<Interval_Comparison_Exp>;
};

/** aggregate max on columns */
export type Parameter_RingWithProductionDay_Max_Fields = {
  __typename?: 'parameter_ringWithProductionDay_max_fields';
  buildEnd?: Maybe<Scalars['timestamptz']['output']>;
  buildEndMetricPoint?: Maybe<Scalars['float8']['output']>;
  buildStart?: Maybe<Scalars['timestamptz']['output']>;
  calendarDate?: Maybe<Scalars['date']['output']>;
  calendarDayOfWeek?: Maybe<Scalars['String']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  excavationEnd?: Maybe<Scalars['timestamptz']['output']>;
  excavationStart?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  keyPosition?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['float8']['output']>;
  productionDate?: Maybe<Scalars['date']['output']>;
  productionDayOfWeek?: Maybe<Scalars['String']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Parameter_RingWithProductionDay_Min_Fields = {
  __typename?: 'parameter_ringWithProductionDay_min_fields';
  buildEnd?: Maybe<Scalars['timestamptz']['output']>;
  buildEndMetricPoint?: Maybe<Scalars['float8']['output']>;
  buildStart?: Maybe<Scalars['timestamptz']['output']>;
  calendarDate?: Maybe<Scalars['date']['output']>;
  calendarDayOfWeek?: Maybe<Scalars['String']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  excavationEnd?: Maybe<Scalars['timestamptz']['output']>;
  excavationStart?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  keyPosition?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['float8']['output']>;
  productionDate?: Maybe<Scalars['date']['output']>;
  productionDayOfWeek?: Maybe<Scalars['String']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "parameter.ringWithProductionDay". */
export type Parameter_RingWithProductionDay_Order_By = {
  buildEnd?: InputMaybe<Order_By>;
  buildEndMetricPoint?: InputMaybe<Order_By>;
  buildStart?: InputMaybe<Order_By>;
  calendarDate?: InputMaybe<Order_By>;
  calendarDayOfWeek?: InputMaybe<Order_By>;
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  excavationEnd?: InputMaybe<Order_By>;
  excavationStart?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  productionDate?: InputMaybe<Order_By>;
  productionDayOfWeek?: InputMaybe<Order_By>;
  realBuildDuration?: InputMaybe<Order_By>;
  realExcavationDuration?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  totalBuildDuration?: InputMaybe<Order_By>;
  totalExcavationDuration?: InputMaybe<Order_By>;
};

/** select columns of table "parameter.ringWithProductionDay" */
export enum Parameter_RingWithProductionDay_Select_Column {
  /** column name */
  BuildEnd = 'buildEnd',
  /** column name */
  BuildEndMetricPoint = 'buildEndMetricPoint',
  /** column name */
  BuildStart = 'buildStart',
  /** column name */
  CalendarDate = 'calendarDate',
  /** column name */
  CalendarDayOfWeek = 'calendarDayOfWeek',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  ExcavationEnd = 'excavationEnd',
  /** column name */
  ExcavationStart = 'excavationStart',
  /** column name */
  Id = 'id',
  /** column name */
  KeyPosition = 'keyPosition',
  /** column name */
  Length = 'length',
  /** column name */
  ProductionDate = 'productionDate',
  /** column name */
  ProductionDayOfWeek = 'productionDayOfWeek',
  /** column name */
  RealBuildDuration = 'realBuildDuration',
  /** column name */
  RealExcavationDuration = 'realExcavationDuration',
  /** column name */
  RingNumber = 'ringNumber',
  /** column name */
  TotalBuildDuration = 'totalBuildDuration',
  /** column name */
  TotalExcavationDuration = 'totalExcavationDuration'
}

/** aggregate stddev on columns */
export type Parameter_RingWithProductionDay_Stddev_Fields = {
  __typename?: 'parameter_ringWithProductionDay_stddev_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Parameter_RingWithProductionDay_Stddev_Pop_Fields = {
  __typename?: 'parameter_ringWithProductionDay_stddev_pop_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Parameter_RingWithProductionDay_Stddev_Samp_Fields = {
  __typename?: 'parameter_ringWithProductionDay_stddev_samp_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "parameter_ringWithProductionDay" */
export type Parameter_RingWithProductionDay_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parameter_RingWithProductionDay_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parameter_RingWithProductionDay_Stream_Cursor_Value_Input = {
  buildEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  buildEndMetricPoint?: InputMaybe<Scalars['float8']['input']>;
  buildStart?: InputMaybe<Scalars['timestamptz']['input']>;
  calendarDate?: InputMaybe<Scalars['date']['input']>;
  calendarDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  excavationEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  excavationStart?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  keyPosition?: InputMaybe<Scalars['Int']['input']>;
  length?: InputMaybe<Scalars['float8']['input']>;
  productionDate?: InputMaybe<Scalars['date']['input']>;
  productionDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  realBuildDuration?: InputMaybe<Scalars['interval']['input']>;
  realExcavationDuration?: InputMaybe<Scalars['interval']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  totalBuildDuration?: InputMaybe<Scalars['interval']['input']>;
  totalExcavationDuration?: InputMaybe<Scalars['interval']['input']>;
};

/** aggregate sum on columns */
export type Parameter_RingWithProductionDay_Sum_Fields = {
  __typename?: 'parameter_ringWithProductionDay_sum_fields';
  buildEndMetricPoint?: Maybe<Scalars['float8']['output']>;
  keyPosition?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['float8']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Parameter_RingWithProductionDay_Var_Pop_Fields = {
  __typename?: 'parameter_ringWithProductionDay_var_pop_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Parameter_RingWithProductionDay_Var_Samp_Fields = {
  __typename?: 'parameter_ringWithProductionDay_var_samp_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Parameter_RingWithProductionDay_Variance_Fields = {
  __typename?: 'parameter_ringWithProductionDay_variance_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "parameter.ringWithShifts" */
export type Parameter_RingWithShifts = {
  __typename?: 'parameter_ringWithShifts';
  buildEndZoned?: Maybe<Scalars['timestamp']['output']>;
  buildShift?: Maybe<Scalars['Int']['output']>;
  calendarDate?: Maybe<Scalars['date']['output']>;
  calendarDayOfWeek?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  constructionSite?: Maybe<ConstructionSite>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  productionDate?: Maybe<Scalars['date']['output']>;
  productionDayOfWeek?: Maybe<Scalars['String']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  shift1EndDate?: Maybe<Scalars['timestamp']['output']>;
  shift2EndDate?: Maybe<Scalars['timestamp']['output']>;
  shift3EndDate?: Maybe<Scalars['timestamp']['output']>;
  shiftEndDate?: Maybe<Scalars['timestamp']['output']>;
  shiftStartDate?: Maybe<Scalars['timestamp']['output']>;
  shiftStartTime?: Maybe<Scalars['time']['output']>;
};

/** aggregated selection of "parameter.ringWithShifts" */
export type Parameter_RingWithShifts_Aggregate = {
  __typename?: 'parameter_ringWithShifts_aggregate';
  aggregate?: Maybe<Parameter_RingWithShifts_Aggregate_Fields>;
  nodes: Array<Parameter_RingWithShifts>;
};

/** aggregate fields of "parameter.ringWithShifts" */
export type Parameter_RingWithShifts_Aggregate_Fields = {
  __typename?: 'parameter_ringWithShifts_aggregate_fields';
  avg?: Maybe<Parameter_RingWithShifts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parameter_RingWithShifts_Max_Fields>;
  min?: Maybe<Parameter_RingWithShifts_Min_Fields>;
  stddev?: Maybe<Parameter_RingWithShifts_Stddev_Fields>;
  stddev_pop?: Maybe<Parameter_RingWithShifts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parameter_RingWithShifts_Stddev_Samp_Fields>;
  sum?: Maybe<Parameter_RingWithShifts_Sum_Fields>;
  var_pop?: Maybe<Parameter_RingWithShifts_Var_Pop_Fields>;
  var_samp?: Maybe<Parameter_RingWithShifts_Var_Samp_Fields>;
  variance?: Maybe<Parameter_RingWithShifts_Variance_Fields>;
};


/** aggregate fields of "parameter.ringWithShifts" */
export type Parameter_RingWithShifts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parameter_RingWithShifts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Parameter_RingWithShifts_Avg_Fields = {
  __typename?: 'parameter_ringWithShifts_avg_fields';
  buildShift?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "parameter.ringWithShifts". All fields are combined with a logical 'AND'. */
export type Parameter_RingWithShifts_Bool_Exp = {
  _and?: InputMaybe<Array<Parameter_RingWithShifts_Bool_Exp>>;
  _not?: InputMaybe<Parameter_RingWithShifts_Bool_Exp>;
  _or?: InputMaybe<Array<Parameter_RingWithShifts_Bool_Exp>>;
  buildEndZoned?: InputMaybe<Timestamp_Comparison_Exp>;
  buildShift?: InputMaybe<Int_Comparison_Exp>;
  calendarDate?: InputMaybe<Date_Comparison_Exp>;
  calendarDayOfWeek?: InputMaybe<String_Comparison_Exp>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  productionDate?: InputMaybe<Date_Comparison_Exp>;
  productionDayOfWeek?: InputMaybe<String_Comparison_Exp>;
  ringNumber?: InputMaybe<Int_Comparison_Exp>;
  shift1EndDate?: InputMaybe<Timestamp_Comparison_Exp>;
  shift2EndDate?: InputMaybe<Timestamp_Comparison_Exp>;
  shift3EndDate?: InputMaybe<Timestamp_Comparison_Exp>;
  shiftEndDate?: InputMaybe<Timestamp_Comparison_Exp>;
  shiftStartDate?: InputMaybe<Timestamp_Comparison_Exp>;
  shiftStartTime?: InputMaybe<Time_Comparison_Exp>;
};

/** aggregate max on columns */
export type Parameter_RingWithShifts_Max_Fields = {
  __typename?: 'parameter_ringWithShifts_max_fields';
  buildEndZoned?: Maybe<Scalars['timestamp']['output']>;
  buildShift?: Maybe<Scalars['Int']['output']>;
  calendarDate?: Maybe<Scalars['date']['output']>;
  calendarDayOfWeek?: Maybe<Scalars['String']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  productionDate?: Maybe<Scalars['date']['output']>;
  productionDayOfWeek?: Maybe<Scalars['String']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  shift1EndDate?: Maybe<Scalars['timestamp']['output']>;
  shift2EndDate?: Maybe<Scalars['timestamp']['output']>;
  shift3EndDate?: Maybe<Scalars['timestamp']['output']>;
  shiftEndDate?: Maybe<Scalars['timestamp']['output']>;
  shiftStartDate?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Parameter_RingWithShifts_Min_Fields = {
  __typename?: 'parameter_ringWithShifts_min_fields';
  buildEndZoned?: Maybe<Scalars['timestamp']['output']>;
  buildShift?: Maybe<Scalars['Int']['output']>;
  calendarDate?: Maybe<Scalars['date']['output']>;
  calendarDayOfWeek?: Maybe<Scalars['String']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  productionDate?: Maybe<Scalars['date']['output']>;
  productionDayOfWeek?: Maybe<Scalars['String']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  shift1EndDate?: Maybe<Scalars['timestamp']['output']>;
  shift2EndDate?: Maybe<Scalars['timestamp']['output']>;
  shift3EndDate?: Maybe<Scalars['timestamp']['output']>;
  shiftEndDate?: Maybe<Scalars['timestamp']['output']>;
  shiftStartDate?: Maybe<Scalars['timestamp']['output']>;
};

/** Ordering options when selecting data from "parameter.ringWithShifts". */
export type Parameter_RingWithShifts_Order_By = {
  buildEndZoned?: InputMaybe<Order_By>;
  buildShift?: InputMaybe<Order_By>;
  calendarDate?: InputMaybe<Order_By>;
  calendarDayOfWeek?: InputMaybe<Order_By>;
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  productionDate?: InputMaybe<Order_By>;
  productionDayOfWeek?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  shift1EndDate?: InputMaybe<Order_By>;
  shift2EndDate?: InputMaybe<Order_By>;
  shift3EndDate?: InputMaybe<Order_By>;
  shiftEndDate?: InputMaybe<Order_By>;
  shiftStartDate?: InputMaybe<Order_By>;
  shiftStartTime?: InputMaybe<Order_By>;
};

/** select columns of table "parameter.ringWithShifts" */
export enum Parameter_RingWithShifts_Select_Column {
  /** column name */
  BuildEndZoned = 'buildEndZoned',
  /** column name */
  BuildShift = 'buildShift',
  /** column name */
  CalendarDate = 'calendarDate',
  /** column name */
  CalendarDayOfWeek = 'calendarDayOfWeek',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  ProductionDate = 'productionDate',
  /** column name */
  ProductionDayOfWeek = 'productionDayOfWeek',
  /** column name */
  RingNumber = 'ringNumber',
  /** column name */
  Shift1EndDate = 'shift1EndDate',
  /** column name */
  Shift2EndDate = 'shift2EndDate',
  /** column name */
  Shift3EndDate = 'shift3EndDate',
  /** column name */
  ShiftEndDate = 'shiftEndDate',
  /** column name */
  ShiftStartDate = 'shiftStartDate',
  /** column name */
  ShiftStartTime = 'shiftStartTime'
}

/** aggregate stddev on columns */
export type Parameter_RingWithShifts_Stddev_Fields = {
  __typename?: 'parameter_ringWithShifts_stddev_fields';
  buildShift?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Parameter_RingWithShifts_Stddev_Pop_Fields = {
  __typename?: 'parameter_ringWithShifts_stddev_pop_fields';
  buildShift?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Parameter_RingWithShifts_Stddev_Samp_Fields = {
  __typename?: 'parameter_ringWithShifts_stddev_samp_fields';
  buildShift?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "parameter_ringWithShifts" */
export type Parameter_RingWithShifts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parameter_RingWithShifts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parameter_RingWithShifts_Stream_Cursor_Value_Input = {
  buildEndZoned?: InputMaybe<Scalars['timestamp']['input']>;
  buildShift?: InputMaybe<Scalars['Int']['input']>;
  calendarDate?: InputMaybe<Scalars['date']['input']>;
  calendarDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  productionDate?: InputMaybe<Scalars['date']['input']>;
  productionDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  shift1EndDate?: InputMaybe<Scalars['timestamp']['input']>;
  shift2EndDate?: InputMaybe<Scalars['timestamp']['input']>;
  shift3EndDate?: InputMaybe<Scalars['timestamp']['input']>;
  shiftEndDate?: InputMaybe<Scalars['timestamp']['input']>;
  shiftStartDate?: InputMaybe<Scalars['timestamp']['input']>;
  shiftStartTime?: InputMaybe<Scalars['time']['input']>;
};

/** aggregate sum on columns */
export type Parameter_RingWithShifts_Sum_Fields = {
  __typename?: 'parameter_ringWithShifts_sum_fields';
  buildShift?: Maybe<Scalars['Int']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Parameter_RingWithShifts_Var_Pop_Fields = {
  __typename?: 'parameter_ringWithShifts_var_pop_fields';
  buildShift?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Parameter_RingWithShifts_Var_Samp_Fields = {
  __typename?: 'parameter_ringWithShifts_var_samp_fields';
  buildShift?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Parameter_RingWithShifts_Variance_Fields = {
  __typename?: 'parameter_ringWithShifts_variance_fields';
  buildShift?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "parameter.ring" */
export type Parameter_Ring_Aggregate = {
  __typename?: 'parameter_ring_aggregate';
  aggregate?: Maybe<Parameter_Ring_Aggregate_Fields>;
  nodes: Array<Parameter_Ring>;
};

export type Parameter_Ring_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Parameter_Ring_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Parameter_Ring_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Parameter_Ring_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Parameter_Ring_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Parameter_Ring_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Parameter_Ring_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Parameter_Ring_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Parameter_Ring_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Parameter_Ring_Aggregate_Bool_Exp_Var_Samp>;
};

export type Parameter_Ring_Aggregate_Bool_Exp_Avg = {
  arguments: Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_Ring_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Parameter_Ring_Aggregate_Bool_Exp_Corr = {
  arguments: Parameter_Ring_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_Ring_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Parameter_Ring_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Parameter_Ring_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parameter_Ring_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_Ring_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Parameter_Ring_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Parameter_Ring_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_Ring_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Parameter_Ring_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Parameter_Ring_Aggregate_Bool_Exp_Max = {
  arguments: Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_Ring_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Parameter_Ring_Aggregate_Bool_Exp_Min = {
  arguments: Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_Ring_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Parameter_Ring_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_Ring_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Parameter_Ring_Aggregate_Bool_Exp_Sum = {
  arguments: Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_Ring_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Parameter_Ring_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_Ring_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "parameter.ring" */
export type Parameter_Ring_Aggregate_Fields = {
  __typename?: 'parameter_ring_aggregate_fields';
  avg?: Maybe<Parameter_Ring_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parameter_Ring_Max_Fields>;
  min?: Maybe<Parameter_Ring_Min_Fields>;
  stddev?: Maybe<Parameter_Ring_Stddev_Fields>;
  stddev_pop?: Maybe<Parameter_Ring_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parameter_Ring_Stddev_Samp_Fields>;
  sum?: Maybe<Parameter_Ring_Sum_Fields>;
  var_pop?: Maybe<Parameter_Ring_Var_Pop_Fields>;
  var_samp?: Maybe<Parameter_Ring_Var_Samp_Fields>;
  variance?: Maybe<Parameter_Ring_Variance_Fields>;
};


/** aggregate fields of "parameter.ring" */
export type Parameter_Ring_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parameter_Ring_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parameter.ring" */
export type Parameter_Ring_Aggregate_Order_By = {
  avg?: InputMaybe<Parameter_Ring_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parameter_Ring_Max_Order_By>;
  min?: InputMaybe<Parameter_Ring_Min_Order_By>;
  stddev?: InputMaybe<Parameter_Ring_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parameter_Ring_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parameter_Ring_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parameter_Ring_Sum_Order_By>;
  var_pop?: InputMaybe<Parameter_Ring_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parameter_Ring_Var_Samp_Order_By>;
  variance?: InputMaybe<Parameter_Ring_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parameter.ring" */
export type Parameter_Ring_Arr_Rel_Insert_Input = {
  data: Array<Parameter_Ring_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parameter_Ring_On_Conflict>;
};

/** aggregate avg on columns */
export type Parameter_Ring_Avg_Fields = {
  __typename?: 'parameter_ring_avg_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalTrend?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parameter.ring" */
export type Parameter_Ring_Avg_Order_By = {
  buildEndMetricPoint?: InputMaybe<Order_By>;
  cuttingWheelHorizontalPosition?: InputMaybe<Order_By>;
  cuttingWheelVerticalPosition?: InputMaybe<Order_By>;
  frontHorizontalPosition?: InputMaybe<Order_By>;
  frontHorizontalTrend?: InputMaybe<Order_By>;
  frontVerticalPosition?: InputMaybe<Order_By>;
  frontVerticalTrend?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  leftSkirtClearance?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lowerSkirtClearance?: InputMaybe<Order_By>;
  rearHorizontalPosition?: InputMaybe<Order_By>;
  rearHorizontalTrend?: InputMaybe<Order_By>;
  rearVerticalPosition?: InputMaybe<Order_By>;
  rearVerticalTrend?: InputMaybe<Order_By>;
  rightSkirtClearance?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  upperSkirtClearance?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parameter.ring". All fields are combined with a logical 'AND'. */
export type Parameter_Ring_Bool_Exp = {
  _and?: InputMaybe<Array<Parameter_Ring_Bool_Exp>>;
  _not?: InputMaybe<Parameter_Ring_Bool_Exp>;
  _or?: InputMaybe<Array<Parameter_Ring_Bool_Exp>>;
  batchDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  buildEnd?: InputMaybe<Timestamptz_Comparison_Exp>;
  buildEndMetricPoint?: InputMaybe<Float8_Comparison_Exp>;
  buildStart?: InputMaybe<Timestamptz_Comparison_Exp>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  cuttingWheelHorizontalPosition?: InputMaybe<Float8_Comparison_Exp>;
  cuttingWheelVerticalPosition?: InputMaybe<Float8_Comparison_Exp>;
  excavationEnd?: InputMaybe<Timestamptz_Comparison_Exp>;
  excavationStart?: InputMaybe<Timestamptz_Comparison_Exp>;
  frontHorizontalPosition?: InputMaybe<Float8_Comparison_Exp>;
  frontHorizontalTrend?: InputMaybe<Float8_Comparison_Exp>;
  frontVerticalPosition?: InputMaybe<Float8_Comparison_Exp>;
  frontVerticalTrend?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  keyPosition?: InputMaybe<Int_Comparison_Exp>;
  leftSkirtClearance?: InputMaybe<Float8_Comparison_Exp>;
  length?: InputMaybe<Float8_Comparison_Exp>;
  lowerSkirtClearance?: InputMaybe<Float8_Comparison_Exp>;
  realBuildDuration?: InputMaybe<Interval_Comparison_Exp>;
  realExcavationDuration?: InputMaybe<Interval_Comparison_Exp>;
  rearHorizontalPosition?: InputMaybe<Float8_Comparison_Exp>;
  rearHorizontalTrend?: InputMaybe<Float8_Comparison_Exp>;
  rearVerticalPosition?: InputMaybe<Float8_Comparison_Exp>;
  rearVerticalTrend?: InputMaybe<Float8_Comparison_Exp>;
  rightSkirtClearance?: InputMaybe<Float8_Comparison_Exp>;
  ringNumber?: InputMaybe<Int_Comparison_Exp>;
  segments?: InputMaybe<Quality_Segment_Bool_Exp>;
  segments_aggregate?: InputMaybe<Quality_Segment_Aggregate_Bool_Exp>;
  totalBuildDuration?: InputMaybe<Interval_Comparison_Exp>;
  totalExcavationDuration?: InputMaybe<Interval_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  upperSkirtClearance?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "parameter.ring" */
export enum Parameter_Ring_Constraint {
  /** unique or primary key constraint on columns "constructionSiteId", "ringNumber" */
  RingConstructionSiteIdRingNumberKey = 'ring_constructionSiteId_ringNumber_key',
  /** unique or primary key constraint on columns "id" */
  RingPkey = 'ring_pkey'
}

/** input type for incrementing numeric columns in table "parameter.ring" */
export type Parameter_Ring_Inc_Input = {
  buildEndMetricPoint?: InputMaybe<Scalars['float8']['input']>;
  cuttingWheelHorizontalPosition?: InputMaybe<Scalars['float8']['input']>;
  cuttingWheelVerticalPosition?: InputMaybe<Scalars['float8']['input']>;
  frontHorizontalPosition?: InputMaybe<Scalars['float8']['input']>;
  frontHorizontalTrend?: InputMaybe<Scalars['float8']['input']>;
  frontVerticalPosition?: InputMaybe<Scalars['float8']['input']>;
  frontVerticalTrend?: InputMaybe<Scalars['float8']['input']>;
  keyPosition?: InputMaybe<Scalars['Int']['input']>;
  leftSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
  length?: InputMaybe<Scalars['float8']['input']>;
  lowerSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
  rearHorizontalPosition?: InputMaybe<Scalars['float8']['input']>;
  rearHorizontalTrend?: InputMaybe<Scalars['float8']['input']>;
  rearVerticalPosition?: InputMaybe<Scalars['float8']['input']>;
  rearVerticalTrend?: InputMaybe<Scalars['float8']['input']>;
  rightSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  upperSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "parameter.ring" */
export type Parameter_Ring_Insert_Input = {
  batchDate?: InputMaybe<Scalars['timestamptz']['input']>;
  buildEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  buildEndMetricPoint?: InputMaybe<Scalars['float8']['input']>;
  buildStart?: InputMaybe<Scalars['timestamptz']['input']>;
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  cuttingWheelHorizontalPosition?: InputMaybe<Scalars['float8']['input']>;
  cuttingWheelVerticalPosition?: InputMaybe<Scalars['float8']['input']>;
  excavationEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  excavationStart?: InputMaybe<Scalars['timestamptz']['input']>;
  frontHorizontalPosition?: InputMaybe<Scalars['float8']['input']>;
  frontHorizontalTrend?: InputMaybe<Scalars['float8']['input']>;
  frontVerticalPosition?: InputMaybe<Scalars['float8']['input']>;
  frontVerticalTrend?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  keyPosition?: InputMaybe<Scalars['Int']['input']>;
  leftSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
  length?: InputMaybe<Scalars['float8']['input']>;
  lowerSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
  realBuildDuration?: InputMaybe<Scalars['interval']['input']>;
  realExcavationDuration?: InputMaybe<Scalars['interval']['input']>;
  rearHorizontalPosition?: InputMaybe<Scalars['float8']['input']>;
  rearHorizontalTrend?: InputMaybe<Scalars['float8']['input']>;
  rearVerticalPosition?: InputMaybe<Scalars['float8']['input']>;
  rearVerticalTrend?: InputMaybe<Scalars['float8']['input']>;
  rightSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  segments?: InputMaybe<Quality_Segment_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  upperSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate max on columns */
export type Parameter_Ring_Max_Fields = {
  __typename?: 'parameter_ring_max_fields';
  batchDate?: Maybe<Scalars['timestamptz']['output']>;
  buildEnd?: Maybe<Scalars['timestamptz']['output']>;
  buildEndMetricPoint?: Maybe<Scalars['float8']['output']>;
  buildStart?: Maybe<Scalars['timestamptz']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['float8']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['float8']['output']>;
  excavationEnd?: Maybe<Scalars['timestamptz']['output']>;
  excavationStart?: Maybe<Scalars['timestamptz']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['float8']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['float8']['output']>;
  frontVerticalPosition?: Maybe<Scalars['float8']['output']>;
  frontVerticalTrend?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  keyPosition?: Maybe<Scalars['Int']['output']>;
  leftSkirtClearance?: Maybe<Scalars['float8']['output']>;
  length?: Maybe<Scalars['float8']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['float8']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['float8']['output']>;
  rearHorizontalTrend?: Maybe<Scalars['float8']['output']>;
  rearVerticalPosition?: Maybe<Scalars['float8']['output']>;
  rearVerticalTrend?: Maybe<Scalars['float8']['output']>;
  rightSkirtClearance?: Maybe<Scalars['float8']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  upperSkirtClearance?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "parameter.ring" */
export type Parameter_Ring_Max_Order_By = {
  batchDate?: InputMaybe<Order_By>;
  buildEnd?: InputMaybe<Order_By>;
  buildEndMetricPoint?: InputMaybe<Order_By>;
  buildStart?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cuttingWheelHorizontalPosition?: InputMaybe<Order_By>;
  cuttingWheelVerticalPosition?: InputMaybe<Order_By>;
  excavationEnd?: InputMaybe<Order_By>;
  excavationStart?: InputMaybe<Order_By>;
  frontHorizontalPosition?: InputMaybe<Order_By>;
  frontHorizontalTrend?: InputMaybe<Order_By>;
  frontVerticalPosition?: InputMaybe<Order_By>;
  frontVerticalTrend?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  leftSkirtClearance?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lowerSkirtClearance?: InputMaybe<Order_By>;
  rearHorizontalPosition?: InputMaybe<Order_By>;
  rearHorizontalTrend?: InputMaybe<Order_By>;
  rearVerticalPosition?: InputMaybe<Order_By>;
  rearVerticalTrend?: InputMaybe<Order_By>;
  rightSkirtClearance?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  upperSkirtClearance?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parameter_Ring_Min_Fields = {
  __typename?: 'parameter_ring_min_fields';
  batchDate?: Maybe<Scalars['timestamptz']['output']>;
  buildEnd?: Maybe<Scalars['timestamptz']['output']>;
  buildEndMetricPoint?: Maybe<Scalars['float8']['output']>;
  buildStart?: Maybe<Scalars['timestamptz']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['float8']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['float8']['output']>;
  excavationEnd?: Maybe<Scalars['timestamptz']['output']>;
  excavationStart?: Maybe<Scalars['timestamptz']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['float8']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['float8']['output']>;
  frontVerticalPosition?: Maybe<Scalars['float8']['output']>;
  frontVerticalTrend?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  keyPosition?: Maybe<Scalars['Int']['output']>;
  leftSkirtClearance?: Maybe<Scalars['float8']['output']>;
  length?: Maybe<Scalars['float8']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['float8']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['float8']['output']>;
  rearHorizontalTrend?: Maybe<Scalars['float8']['output']>;
  rearVerticalPosition?: Maybe<Scalars['float8']['output']>;
  rearVerticalTrend?: Maybe<Scalars['float8']['output']>;
  rightSkirtClearance?: Maybe<Scalars['float8']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  upperSkirtClearance?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "parameter.ring" */
export type Parameter_Ring_Min_Order_By = {
  batchDate?: InputMaybe<Order_By>;
  buildEnd?: InputMaybe<Order_By>;
  buildEndMetricPoint?: InputMaybe<Order_By>;
  buildStart?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cuttingWheelHorizontalPosition?: InputMaybe<Order_By>;
  cuttingWheelVerticalPosition?: InputMaybe<Order_By>;
  excavationEnd?: InputMaybe<Order_By>;
  excavationStart?: InputMaybe<Order_By>;
  frontHorizontalPosition?: InputMaybe<Order_By>;
  frontHorizontalTrend?: InputMaybe<Order_By>;
  frontVerticalPosition?: InputMaybe<Order_By>;
  frontVerticalTrend?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  leftSkirtClearance?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lowerSkirtClearance?: InputMaybe<Order_By>;
  rearHorizontalPosition?: InputMaybe<Order_By>;
  rearHorizontalTrend?: InputMaybe<Order_By>;
  rearVerticalPosition?: InputMaybe<Order_By>;
  rearVerticalTrend?: InputMaybe<Order_By>;
  rightSkirtClearance?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  upperSkirtClearance?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parameter.ring" */
export type Parameter_Ring_Mutation_Response = {
  __typename?: 'parameter_ring_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parameter_Ring>;
};

/** input type for inserting object relation for remote table "parameter.ring" */
export type Parameter_Ring_Obj_Rel_Insert_Input = {
  data: Parameter_Ring_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Parameter_Ring_On_Conflict>;
};

/** on_conflict condition type for table "parameter.ring" */
export type Parameter_Ring_On_Conflict = {
  constraint: Parameter_Ring_Constraint;
  update_columns?: Array<Parameter_Ring_Update_Column>;
  where?: InputMaybe<Parameter_Ring_Bool_Exp>;
};

/** Ordering options when selecting data from "parameter.ring". */
export type Parameter_Ring_Order_By = {
  batchDate?: InputMaybe<Order_By>;
  buildEnd?: InputMaybe<Order_By>;
  buildEndMetricPoint?: InputMaybe<Order_By>;
  buildStart?: InputMaybe<Order_By>;
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  cuttingWheelHorizontalPosition?: InputMaybe<Order_By>;
  cuttingWheelVerticalPosition?: InputMaybe<Order_By>;
  excavationEnd?: InputMaybe<Order_By>;
  excavationStart?: InputMaybe<Order_By>;
  frontHorizontalPosition?: InputMaybe<Order_By>;
  frontHorizontalTrend?: InputMaybe<Order_By>;
  frontVerticalPosition?: InputMaybe<Order_By>;
  frontVerticalTrend?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  leftSkirtClearance?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lowerSkirtClearance?: InputMaybe<Order_By>;
  realBuildDuration?: InputMaybe<Order_By>;
  realExcavationDuration?: InputMaybe<Order_By>;
  rearHorizontalPosition?: InputMaybe<Order_By>;
  rearHorizontalTrend?: InputMaybe<Order_By>;
  rearVerticalPosition?: InputMaybe<Order_By>;
  rearVerticalTrend?: InputMaybe<Order_By>;
  rightSkirtClearance?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  segments_aggregate?: InputMaybe<Quality_Segment_Aggregate_Order_By>;
  totalBuildDuration?: InputMaybe<Order_By>;
  totalExcavationDuration?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  upperSkirtClearance?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parameter.ring */
export type Parameter_Ring_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "parameter.ring" */
export enum Parameter_Ring_Select_Column {
  /** column name */
  BatchDate = 'batchDate',
  /** column name */
  BuildEnd = 'buildEnd',
  /** column name */
  BuildEndMetricPoint = 'buildEndMetricPoint',
  /** column name */
  BuildStart = 'buildStart',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CuttingWheelHorizontalPosition = 'cuttingWheelHorizontalPosition',
  /** column name */
  CuttingWheelVerticalPosition = 'cuttingWheelVerticalPosition',
  /** column name */
  ExcavationEnd = 'excavationEnd',
  /** column name */
  ExcavationStart = 'excavationStart',
  /** column name */
  FrontHorizontalPosition = 'frontHorizontalPosition',
  /** column name */
  FrontHorizontalTrend = 'frontHorizontalTrend',
  /** column name */
  FrontVerticalPosition = 'frontVerticalPosition',
  /** column name */
  FrontVerticalTrend = 'frontVerticalTrend',
  /** column name */
  Id = 'id',
  /** column name */
  KeyPosition = 'keyPosition',
  /** column name */
  LeftSkirtClearance = 'leftSkirtClearance',
  /** column name */
  Length = 'length',
  /** column name */
  LowerSkirtClearance = 'lowerSkirtClearance',
  /** column name */
  RealBuildDuration = 'realBuildDuration',
  /** column name */
  RealExcavationDuration = 'realExcavationDuration',
  /** column name */
  RearHorizontalPosition = 'rearHorizontalPosition',
  /** column name */
  RearHorizontalTrend = 'rearHorizontalTrend',
  /** column name */
  RearVerticalPosition = 'rearVerticalPosition',
  /** column name */
  RearVerticalTrend = 'rearVerticalTrend',
  /** column name */
  RightSkirtClearance = 'rightSkirtClearance',
  /** column name */
  RingNumber = 'ringNumber',
  /** column name */
  TotalBuildDuration = 'totalBuildDuration',
  /** column name */
  TotalExcavationDuration = 'totalExcavationDuration',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpperSkirtClearance = 'upperSkirtClearance'
}

/** select "parameter_ring_aggregate_bool_exp_avg_arguments_columns" columns of table "parameter.ring" */
export enum Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  BuildEndMetricPoint = 'buildEndMetricPoint',
  /** column name */
  CuttingWheelHorizontalPosition = 'cuttingWheelHorizontalPosition',
  /** column name */
  CuttingWheelVerticalPosition = 'cuttingWheelVerticalPosition',
  /** column name */
  FrontHorizontalPosition = 'frontHorizontalPosition',
  /** column name */
  FrontHorizontalTrend = 'frontHorizontalTrend',
  /** column name */
  FrontVerticalPosition = 'frontVerticalPosition',
  /** column name */
  FrontVerticalTrend = 'frontVerticalTrend',
  /** column name */
  LeftSkirtClearance = 'leftSkirtClearance',
  /** column name */
  Length = 'length',
  /** column name */
  LowerSkirtClearance = 'lowerSkirtClearance',
  /** column name */
  RearHorizontalPosition = 'rearHorizontalPosition',
  /** column name */
  RearHorizontalTrend = 'rearHorizontalTrend',
  /** column name */
  RearVerticalPosition = 'rearVerticalPosition',
  /** column name */
  RearVerticalTrend = 'rearVerticalTrend',
  /** column name */
  RightSkirtClearance = 'rightSkirtClearance',
  /** column name */
  UpperSkirtClearance = 'upperSkirtClearance'
}

/** select "parameter_ring_aggregate_bool_exp_corr_arguments_columns" columns of table "parameter.ring" */
export enum Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  BuildEndMetricPoint = 'buildEndMetricPoint',
  /** column name */
  CuttingWheelHorizontalPosition = 'cuttingWheelHorizontalPosition',
  /** column name */
  CuttingWheelVerticalPosition = 'cuttingWheelVerticalPosition',
  /** column name */
  FrontHorizontalPosition = 'frontHorizontalPosition',
  /** column name */
  FrontHorizontalTrend = 'frontHorizontalTrend',
  /** column name */
  FrontVerticalPosition = 'frontVerticalPosition',
  /** column name */
  FrontVerticalTrend = 'frontVerticalTrend',
  /** column name */
  LeftSkirtClearance = 'leftSkirtClearance',
  /** column name */
  Length = 'length',
  /** column name */
  LowerSkirtClearance = 'lowerSkirtClearance',
  /** column name */
  RearHorizontalPosition = 'rearHorizontalPosition',
  /** column name */
  RearHorizontalTrend = 'rearHorizontalTrend',
  /** column name */
  RearVerticalPosition = 'rearVerticalPosition',
  /** column name */
  RearVerticalTrend = 'rearVerticalTrend',
  /** column name */
  RightSkirtClearance = 'rightSkirtClearance',
  /** column name */
  UpperSkirtClearance = 'upperSkirtClearance'
}

/** select "parameter_ring_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "parameter.ring" */
export enum Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  BuildEndMetricPoint = 'buildEndMetricPoint',
  /** column name */
  CuttingWheelHorizontalPosition = 'cuttingWheelHorizontalPosition',
  /** column name */
  CuttingWheelVerticalPosition = 'cuttingWheelVerticalPosition',
  /** column name */
  FrontHorizontalPosition = 'frontHorizontalPosition',
  /** column name */
  FrontHorizontalTrend = 'frontHorizontalTrend',
  /** column name */
  FrontVerticalPosition = 'frontVerticalPosition',
  /** column name */
  FrontVerticalTrend = 'frontVerticalTrend',
  /** column name */
  LeftSkirtClearance = 'leftSkirtClearance',
  /** column name */
  Length = 'length',
  /** column name */
  LowerSkirtClearance = 'lowerSkirtClearance',
  /** column name */
  RearHorizontalPosition = 'rearHorizontalPosition',
  /** column name */
  RearHorizontalTrend = 'rearHorizontalTrend',
  /** column name */
  RearVerticalPosition = 'rearVerticalPosition',
  /** column name */
  RearVerticalTrend = 'rearVerticalTrend',
  /** column name */
  RightSkirtClearance = 'rightSkirtClearance',
  /** column name */
  UpperSkirtClearance = 'upperSkirtClearance'
}

/** select "parameter_ring_aggregate_bool_exp_max_arguments_columns" columns of table "parameter.ring" */
export enum Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  BuildEndMetricPoint = 'buildEndMetricPoint',
  /** column name */
  CuttingWheelHorizontalPosition = 'cuttingWheelHorizontalPosition',
  /** column name */
  CuttingWheelVerticalPosition = 'cuttingWheelVerticalPosition',
  /** column name */
  FrontHorizontalPosition = 'frontHorizontalPosition',
  /** column name */
  FrontHorizontalTrend = 'frontHorizontalTrend',
  /** column name */
  FrontVerticalPosition = 'frontVerticalPosition',
  /** column name */
  FrontVerticalTrend = 'frontVerticalTrend',
  /** column name */
  LeftSkirtClearance = 'leftSkirtClearance',
  /** column name */
  Length = 'length',
  /** column name */
  LowerSkirtClearance = 'lowerSkirtClearance',
  /** column name */
  RearHorizontalPosition = 'rearHorizontalPosition',
  /** column name */
  RearHorizontalTrend = 'rearHorizontalTrend',
  /** column name */
  RearVerticalPosition = 'rearVerticalPosition',
  /** column name */
  RearVerticalTrend = 'rearVerticalTrend',
  /** column name */
  RightSkirtClearance = 'rightSkirtClearance',
  /** column name */
  UpperSkirtClearance = 'upperSkirtClearance'
}

/** select "parameter_ring_aggregate_bool_exp_min_arguments_columns" columns of table "parameter.ring" */
export enum Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  BuildEndMetricPoint = 'buildEndMetricPoint',
  /** column name */
  CuttingWheelHorizontalPosition = 'cuttingWheelHorizontalPosition',
  /** column name */
  CuttingWheelVerticalPosition = 'cuttingWheelVerticalPosition',
  /** column name */
  FrontHorizontalPosition = 'frontHorizontalPosition',
  /** column name */
  FrontHorizontalTrend = 'frontHorizontalTrend',
  /** column name */
  FrontVerticalPosition = 'frontVerticalPosition',
  /** column name */
  FrontVerticalTrend = 'frontVerticalTrend',
  /** column name */
  LeftSkirtClearance = 'leftSkirtClearance',
  /** column name */
  Length = 'length',
  /** column name */
  LowerSkirtClearance = 'lowerSkirtClearance',
  /** column name */
  RearHorizontalPosition = 'rearHorizontalPosition',
  /** column name */
  RearHorizontalTrend = 'rearHorizontalTrend',
  /** column name */
  RearVerticalPosition = 'rearVerticalPosition',
  /** column name */
  RearVerticalTrend = 'rearVerticalTrend',
  /** column name */
  RightSkirtClearance = 'rightSkirtClearance',
  /** column name */
  UpperSkirtClearance = 'upperSkirtClearance'
}

/** select "parameter_ring_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "parameter.ring" */
export enum Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  BuildEndMetricPoint = 'buildEndMetricPoint',
  /** column name */
  CuttingWheelHorizontalPosition = 'cuttingWheelHorizontalPosition',
  /** column name */
  CuttingWheelVerticalPosition = 'cuttingWheelVerticalPosition',
  /** column name */
  FrontHorizontalPosition = 'frontHorizontalPosition',
  /** column name */
  FrontHorizontalTrend = 'frontHorizontalTrend',
  /** column name */
  FrontVerticalPosition = 'frontVerticalPosition',
  /** column name */
  FrontVerticalTrend = 'frontVerticalTrend',
  /** column name */
  LeftSkirtClearance = 'leftSkirtClearance',
  /** column name */
  Length = 'length',
  /** column name */
  LowerSkirtClearance = 'lowerSkirtClearance',
  /** column name */
  RearHorizontalPosition = 'rearHorizontalPosition',
  /** column name */
  RearHorizontalTrend = 'rearHorizontalTrend',
  /** column name */
  RearVerticalPosition = 'rearVerticalPosition',
  /** column name */
  RearVerticalTrend = 'rearVerticalTrend',
  /** column name */
  RightSkirtClearance = 'rightSkirtClearance',
  /** column name */
  UpperSkirtClearance = 'upperSkirtClearance'
}

/** select "parameter_ring_aggregate_bool_exp_sum_arguments_columns" columns of table "parameter.ring" */
export enum Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  BuildEndMetricPoint = 'buildEndMetricPoint',
  /** column name */
  CuttingWheelHorizontalPosition = 'cuttingWheelHorizontalPosition',
  /** column name */
  CuttingWheelVerticalPosition = 'cuttingWheelVerticalPosition',
  /** column name */
  FrontHorizontalPosition = 'frontHorizontalPosition',
  /** column name */
  FrontHorizontalTrend = 'frontHorizontalTrend',
  /** column name */
  FrontVerticalPosition = 'frontVerticalPosition',
  /** column name */
  FrontVerticalTrend = 'frontVerticalTrend',
  /** column name */
  LeftSkirtClearance = 'leftSkirtClearance',
  /** column name */
  Length = 'length',
  /** column name */
  LowerSkirtClearance = 'lowerSkirtClearance',
  /** column name */
  RearHorizontalPosition = 'rearHorizontalPosition',
  /** column name */
  RearHorizontalTrend = 'rearHorizontalTrend',
  /** column name */
  RearVerticalPosition = 'rearVerticalPosition',
  /** column name */
  RearVerticalTrend = 'rearVerticalTrend',
  /** column name */
  RightSkirtClearance = 'rightSkirtClearance',
  /** column name */
  UpperSkirtClearance = 'upperSkirtClearance'
}

/** select "parameter_ring_aggregate_bool_exp_var_samp_arguments_columns" columns of table "parameter.ring" */
export enum Parameter_Ring_Select_Column_Parameter_Ring_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  BuildEndMetricPoint = 'buildEndMetricPoint',
  /** column name */
  CuttingWheelHorizontalPosition = 'cuttingWheelHorizontalPosition',
  /** column name */
  CuttingWheelVerticalPosition = 'cuttingWheelVerticalPosition',
  /** column name */
  FrontHorizontalPosition = 'frontHorizontalPosition',
  /** column name */
  FrontHorizontalTrend = 'frontHorizontalTrend',
  /** column name */
  FrontVerticalPosition = 'frontVerticalPosition',
  /** column name */
  FrontVerticalTrend = 'frontVerticalTrend',
  /** column name */
  LeftSkirtClearance = 'leftSkirtClearance',
  /** column name */
  Length = 'length',
  /** column name */
  LowerSkirtClearance = 'lowerSkirtClearance',
  /** column name */
  RearHorizontalPosition = 'rearHorizontalPosition',
  /** column name */
  RearHorizontalTrend = 'rearHorizontalTrend',
  /** column name */
  RearVerticalPosition = 'rearVerticalPosition',
  /** column name */
  RearVerticalTrend = 'rearVerticalTrend',
  /** column name */
  RightSkirtClearance = 'rightSkirtClearance',
  /** column name */
  UpperSkirtClearance = 'upperSkirtClearance'
}

/** input type for updating data in table "parameter.ring" */
export type Parameter_Ring_Set_Input = {
  batchDate?: InputMaybe<Scalars['timestamptz']['input']>;
  buildEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  buildEndMetricPoint?: InputMaybe<Scalars['float8']['input']>;
  buildStart?: InputMaybe<Scalars['timestamptz']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  cuttingWheelHorizontalPosition?: InputMaybe<Scalars['float8']['input']>;
  cuttingWheelVerticalPosition?: InputMaybe<Scalars['float8']['input']>;
  excavationEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  excavationStart?: InputMaybe<Scalars['timestamptz']['input']>;
  frontHorizontalPosition?: InputMaybe<Scalars['float8']['input']>;
  frontHorizontalTrend?: InputMaybe<Scalars['float8']['input']>;
  frontVerticalPosition?: InputMaybe<Scalars['float8']['input']>;
  frontVerticalTrend?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  keyPosition?: InputMaybe<Scalars['Int']['input']>;
  leftSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
  length?: InputMaybe<Scalars['float8']['input']>;
  lowerSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
  realBuildDuration?: InputMaybe<Scalars['interval']['input']>;
  realExcavationDuration?: InputMaybe<Scalars['interval']['input']>;
  rearHorizontalPosition?: InputMaybe<Scalars['float8']['input']>;
  rearHorizontalTrend?: InputMaybe<Scalars['float8']['input']>;
  rearVerticalPosition?: InputMaybe<Scalars['float8']['input']>;
  rearVerticalTrend?: InputMaybe<Scalars['float8']['input']>;
  rightSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  upperSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate stddev on columns */
export type Parameter_Ring_Stddev_Fields = {
  __typename?: 'parameter_ring_stddev_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalTrend?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parameter.ring" */
export type Parameter_Ring_Stddev_Order_By = {
  buildEndMetricPoint?: InputMaybe<Order_By>;
  cuttingWheelHorizontalPosition?: InputMaybe<Order_By>;
  cuttingWheelVerticalPosition?: InputMaybe<Order_By>;
  frontHorizontalPosition?: InputMaybe<Order_By>;
  frontHorizontalTrend?: InputMaybe<Order_By>;
  frontVerticalPosition?: InputMaybe<Order_By>;
  frontVerticalTrend?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  leftSkirtClearance?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lowerSkirtClearance?: InputMaybe<Order_By>;
  rearHorizontalPosition?: InputMaybe<Order_By>;
  rearHorizontalTrend?: InputMaybe<Order_By>;
  rearVerticalPosition?: InputMaybe<Order_By>;
  rearVerticalTrend?: InputMaybe<Order_By>;
  rightSkirtClearance?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  upperSkirtClearance?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parameter_Ring_Stddev_Pop_Fields = {
  __typename?: 'parameter_ring_stddev_pop_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalTrend?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parameter.ring" */
export type Parameter_Ring_Stddev_Pop_Order_By = {
  buildEndMetricPoint?: InputMaybe<Order_By>;
  cuttingWheelHorizontalPosition?: InputMaybe<Order_By>;
  cuttingWheelVerticalPosition?: InputMaybe<Order_By>;
  frontHorizontalPosition?: InputMaybe<Order_By>;
  frontHorizontalTrend?: InputMaybe<Order_By>;
  frontVerticalPosition?: InputMaybe<Order_By>;
  frontVerticalTrend?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  leftSkirtClearance?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lowerSkirtClearance?: InputMaybe<Order_By>;
  rearHorizontalPosition?: InputMaybe<Order_By>;
  rearHorizontalTrend?: InputMaybe<Order_By>;
  rearVerticalPosition?: InputMaybe<Order_By>;
  rearVerticalTrend?: InputMaybe<Order_By>;
  rightSkirtClearance?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  upperSkirtClearance?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parameter_Ring_Stddev_Samp_Fields = {
  __typename?: 'parameter_ring_stddev_samp_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalTrend?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parameter.ring" */
export type Parameter_Ring_Stddev_Samp_Order_By = {
  buildEndMetricPoint?: InputMaybe<Order_By>;
  cuttingWheelHorizontalPosition?: InputMaybe<Order_By>;
  cuttingWheelVerticalPosition?: InputMaybe<Order_By>;
  frontHorizontalPosition?: InputMaybe<Order_By>;
  frontHorizontalTrend?: InputMaybe<Order_By>;
  frontVerticalPosition?: InputMaybe<Order_By>;
  frontVerticalTrend?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  leftSkirtClearance?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lowerSkirtClearance?: InputMaybe<Order_By>;
  rearHorizontalPosition?: InputMaybe<Order_By>;
  rearHorizontalTrend?: InputMaybe<Order_By>;
  rearVerticalPosition?: InputMaybe<Order_By>;
  rearVerticalTrend?: InputMaybe<Order_By>;
  rightSkirtClearance?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  upperSkirtClearance?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parameter_ring" */
export type Parameter_Ring_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parameter_Ring_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parameter_Ring_Stream_Cursor_Value_Input = {
  batchDate?: InputMaybe<Scalars['timestamptz']['input']>;
  buildEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  buildEndMetricPoint?: InputMaybe<Scalars['float8']['input']>;
  buildStart?: InputMaybe<Scalars['timestamptz']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  cuttingWheelHorizontalPosition?: InputMaybe<Scalars['float8']['input']>;
  cuttingWheelVerticalPosition?: InputMaybe<Scalars['float8']['input']>;
  excavationEnd?: InputMaybe<Scalars['timestamptz']['input']>;
  excavationStart?: InputMaybe<Scalars['timestamptz']['input']>;
  frontHorizontalPosition?: InputMaybe<Scalars['float8']['input']>;
  frontHorizontalTrend?: InputMaybe<Scalars['float8']['input']>;
  frontVerticalPosition?: InputMaybe<Scalars['float8']['input']>;
  frontVerticalTrend?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  keyPosition?: InputMaybe<Scalars['Int']['input']>;
  leftSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
  length?: InputMaybe<Scalars['float8']['input']>;
  lowerSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
  realBuildDuration?: InputMaybe<Scalars['interval']['input']>;
  realExcavationDuration?: InputMaybe<Scalars['interval']['input']>;
  rearHorizontalPosition?: InputMaybe<Scalars['float8']['input']>;
  rearHorizontalTrend?: InputMaybe<Scalars['float8']['input']>;
  rearVerticalPosition?: InputMaybe<Scalars['float8']['input']>;
  rearVerticalTrend?: InputMaybe<Scalars['float8']['input']>;
  rightSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  totalBuildDuration?: InputMaybe<Scalars['interval']['input']>;
  totalExcavationDuration?: InputMaybe<Scalars['interval']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  upperSkirtClearance?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Parameter_Ring_Sum_Fields = {
  __typename?: 'parameter_ring_sum_fields';
  buildEndMetricPoint?: Maybe<Scalars['float8']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['float8']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['float8']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['float8']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['float8']['output']>;
  frontVerticalPosition?: Maybe<Scalars['float8']['output']>;
  frontVerticalTrend?: Maybe<Scalars['float8']['output']>;
  keyPosition?: Maybe<Scalars['Int']['output']>;
  leftSkirtClearance?: Maybe<Scalars['float8']['output']>;
  length?: Maybe<Scalars['float8']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['float8']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['float8']['output']>;
  rearHorizontalTrend?: Maybe<Scalars['float8']['output']>;
  rearVerticalPosition?: Maybe<Scalars['float8']['output']>;
  rearVerticalTrend?: Maybe<Scalars['float8']['output']>;
  rightSkirtClearance?: Maybe<Scalars['float8']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  upperSkirtClearance?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "parameter.ring" */
export type Parameter_Ring_Sum_Order_By = {
  buildEndMetricPoint?: InputMaybe<Order_By>;
  cuttingWheelHorizontalPosition?: InputMaybe<Order_By>;
  cuttingWheelVerticalPosition?: InputMaybe<Order_By>;
  frontHorizontalPosition?: InputMaybe<Order_By>;
  frontHorizontalTrend?: InputMaybe<Order_By>;
  frontVerticalPosition?: InputMaybe<Order_By>;
  frontVerticalTrend?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  leftSkirtClearance?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lowerSkirtClearance?: InputMaybe<Order_By>;
  rearHorizontalPosition?: InputMaybe<Order_By>;
  rearHorizontalTrend?: InputMaybe<Order_By>;
  rearVerticalPosition?: InputMaybe<Order_By>;
  rearVerticalTrend?: InputMaybe<Order_By>;
  rightSkirtClearance?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  upperSkirtClearance?: InputMaybe<Order_By>;
};

/** update columns of table "parameter.ring" */
export enum Parameter_Ring_Update_Column {
  /** column name */
  BatchDate = 'batchDate',
  /** column name */
  BuildEnd = 'buildEnd',
  /** column name */
  BuildEndMetricPoint = 'buildEndMetricPoint',
  /** column name */
  BuildStart = 'buildStart',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CuttingWheelHorizontalPosition = 'cuttingWheelHorizontalPosition',
  /** column name */
  CuttingWheelVerticalPosition = 'cuttingWheelVerticalPosition',
  /** column name */
  ExcavationEnd = 'excavationEnd',
  /** column name */
  ExcavationStart = 'excavationStart',
  /** column name */
  FrontHorizontalPosition = 'frontHorizontalPosition',
  /** column name */
  FrontHorizontalTrend = 'frontHorizontalTrend',
  /** column name */
  FrontVerticalPosition = 'frontVerticalPosition',
  /** column name */
  FrontVerticalTrend = 'frontVerticalTrend',
  /** column name */
  Id = 'id',
  /** column name */
  KeyPosition = 'keyPosition',
  /** column name */
  LeftSkirtClearance = 'leftSkirtClearance',
  /** column name */
  Length = 'length',
  /** column name */
  LowerSkirtClearance = 'lowerSkirtClearance',
  /** column name */
  RealBuildDuration = 'realBuildDuration',
  /** column name */
  RealExcavationDuration = 'realExcavationDuration',
  /** column name */
  RearHorizontalPosition = 'rearHorizontalPosition',
  /** column name */
  RearHorizontalTrend = 'rearHorizontalTrend',
  /** column name */
  RearVerticalPosition = 'rearVerticalPosition',
  /** column name */
  RearVerticalTrend = 'rearVerticalTrend',
  /** column name */
  RightSkirtClearance = 'rightSkirtClearance',
  /** column name */
  RingNumber = 'ringNumber',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpperSkirtClearance = 'upperSkirtClearance'
}

export type Parameter_Ring_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parameter_Ring_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parameter_Ring_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parameter_Ring_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parameter_Ring_Var_Pop_Fields = {
  __typename?: 'parameter_ring_var_pop_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalTrend?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parameter.ring" */
export type Parameter_Ring_Var_Pop_Order_By = {
  buildEndMetricPoint?: InputMaybe<Order_By>;
  cuttingWheelHorizontalPosition?: InputMaybe<Order_By>;
  cuttingWheelVerticalPosition?: InputMaybe<Order_By>;
  frontHorizontalPosition?: InputMaybe<Order_By>;
  frontHorizontalTrend?: InputMaybe<Order_By>;
  frontVerticalPosition?: InputMaybe<Order_By>;
  frontVerticalTrend?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  leftSkirtClearance?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lowerSkirtClearance?: InputMaybe<Order_By>;
  rearHorizontalPosition?: InputMaybe<Order_By>;
  rearHorizontalTrend?: InputMaybe<Order_By>;
  rearVerticalPosition?: InputMaybe<Order_By>;
  rearVerticalTrend?: InputMaybe<Order_By>;
  rightSkirtClearance?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  upperSkirtClearance?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parameter_Ring_Var_Samp_Fields = {
  __typename?: 'parameter_ring_var_samp_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalTrend?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parameter.ring" */
export type Parameter_Ring_Var_Samp_Order_By = {
  buildEndMetricPoint?: InputMaybe<Order_By>;
  cuttingWheelHorizontalPosition?: InputMaybe<Order_By>;
  cuttingWheelVerticalPosition?: InputMaybe<Order_By>;
  frontHorizontalPosition?: InputMaybe<Order_By>;
  frontHorizontalTrend?: InputMaybe<Order_By>;
  frontVerticalPosition?: InputMaybe<Order_By>;
  frontVerticalTrend?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  leftSkirtClearance?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lowerSkirtClearance?: InputMaybe<Order_By>;
  rearHorizontalPosition?: InputMaybe<Order_By>;
  rearHorizontalTrend?: InputMaybe<Order_By>;
  rearVerticalPosition?: InputMaybe<Order_By>;
  rearVerticalTrend?: InputMaybe<Order_By>;
  rightSkirtClearance?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  upperSkirtClearance?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parameter_Ring_Variance_Fields = {
  __typename?: 'parameter_ring_variance_fields';
  buildEndMetricPoint?: Maybe<Scalars['Float']['output']>;
  cuttingWheelHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  cuttingWheelVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  frontHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  frontVerticalPosition?: Maybe<Scalars['Float']['output']>;
  frontVerticalTrend?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  leftSkirtClearance?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  lowerSkirtClearance?: Maybe<Scalars['Float']['output']>;
  rearHorizontalPosition?: Maybe<Scalars['Float']['output']>;
  rearHorizontalTrend?: Maybe<Scalars['Float']['output']>;
  rearVerticalPosition?: Maybe<Scalars['Float']['output']>;
  rearVerticalTrend?: Maybe<Scalars['Float']['output']>;
  rightSkirtClearance?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
  upperSkirtClearance?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parameter.ring" */
export type Parameter_Ring_Variance_Order_By = {
  buildEndMetricPoint?: InputMaybe<Order_By>;
  cuttingWheelHorizontalPosition?: InputMaybe<Order_By>;
  cuttingWheelVerticalPosition?: InputMaybe<Order_By>;
  frontHorizontalPosition?: InputMaybe<Order_By>;
  frontHorizontalTrend?: InputMaybe<Order_By>;
  frontVerticalPosition?: InputMaybe<Order_By>;
  frontVerticalTrend?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  leftSkirtClearance?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  lowerSkirtClearance?: InputMaybe<Order_By>;
  rearHorizontalPosition?: InputMaybe<Order_By>;
  rearHorizontalTrend?: InputMaybe<Order_By>;
  rearVerticalPosition?: InputMaybe<Order_By>;
  rearVerticalTrend?: InputMaybe<Order_By>;
  rightSkirtClearance?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  upperSkirtClearance?: InputMaybe<Order_By>;
};

/** columns and relationships of "parameter.value" */
export type Parameter_Value = {
  __typename?: 'parameter_value';
  batchDate: Scalars['timestamptz']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  parameterDef: Parameter_ParameterDef;
  parameterDefId: Scalars['Int']['output'];
  serverDate: Scalars['timestamptz']['output'];
  sourceDate: Scalars['timestamptz']['output'];
  value: Scalars['numeric']['output'];
};

/** aggregated selection of "parameter.value" */
export type Parameter_Value_Aggregate = {
  __typename?: 'parameter_value_aggregate';
  aggregate?: Maybe<Parameter_Value_Aggregate_Fields>;
  nodes: Array<Parameter_Value>;
};

export type Parameter_Value_Aggregate_Bool_Exp = {
  count?: InputMaybe<Parameter_Value_Aggregate_Bool_Exp_Count>;
};

export type Parameter_Value_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parameter_Value_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Parameter_Value_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parameter.value" */
export type Parameter_Value_Aggregate_Fields = {
  __typename?: 'parameter_value_aggregate_fields';
  avg?: Maybe<Parameter_Value_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Parameter_Value_Max_Fields>;
  min?: Maybe<Parameter_Value_Min_Fields>;
  stddev?: Maybe<Parameter_Value_Stddev_Fields>;
  stddev_pop?: Maybe<Parameter_Value_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parameter_Value_Stddev_Samp_Fields>;
  sum?: Maybe<Parameter_Value_Sum_Fields>;
  var_pop?: Maybe<Parameter_Value_Var_Pop_Fields>;
  var_samp?: Maybe<Parameter_Value_Var_Samp_Fields>;
  variance?: Maybe<Parameter_Value_Variance_Fields>;
};


/** aggregate fields of "parameter.value" */
export type Parameter_Value_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parameter_Value_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "parameter.value" */
export type Parameter_Value_Aggregate_Order_By = {
  avg?: InputMaybe<Parameter_Value_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parameter_Value_Max_Order_By>;
  min?: InputMaybe<Parameter_Value_Min_Order_By>;
  stddev?: InputMaybe<Parameter_Value_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Parameter_Value_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Parameter_Value_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Parameter_Value_Sum_Order_By>;
  var_pop?: InputMaybe<Parameter_Value_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Parameter_Value_Var_Samp_Order_By>;
  variance?: InputMaybe<Parameter_Value_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "parameter.value" */
export type Parameter_Value_Arr_Rel_Insert_Input = {
  data: Array<Parameter_Value_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parameter_Value_On_Conflict>;
};

/** aggregate avg on columns */
export type Parameter_Value_Avg_Fields = {
  __typename?: 'parameter_value_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parameterDefId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "parameter.value" */
export type Parameter_Value_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  parameterDefId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "parameter.value". All fields are combined with a logical 'AND'. */
export type Parameter_Value_Bool_Exp = {
  _and?: InputMaybe<Array<Parameter_Value_Bool_Exp>>;
  _not?: InputMaybe<Parameter_Value_Bool_Exp>;
  _or?: InputMaybe<Array<Parameter_Value_Bool_Exp>>;
  batchDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  parameterDef?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
  parameterDefId?: InputMaybe<Int_Comparison_Exp>;
  serverDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  sourceDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "parameter.value" */
export enum Parameter_Value_Constraint {
  /** unique or primary key constraint on columns "id" */
  ValuePkey = 'value_pkey'
}

/** input type for incrementing numeric columns in table "parameter.value" */
export type Parameter_Value_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  parameterDefId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "parameter.value" */
export type Parameter_Value_Insert_Input = {
  batchDate?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parameterDef?: InputMaybe<Parameter_ParameterDef_Obj_Rel_Insert_Input>;
  parameterDefId?: InputMaybe<Scalars['Int']['input']>;
  serverDate?: InputMaybe<Scalars['timestamptz']['input']>;
  sourceDate?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Parameter_Value_Max_Fields = {
  __typename?: 'parameter_value_max_fields';
  batchDate?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  parameterDefId?: Maybe<Scalars['Int']['output']>;
  serverDate?: Maybe<Scalars['timestamptz']['output']>;
  sourceDate?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "parameter.value" */
export type Parameter_Value_Max_Order_By = {
  batchDate?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameterDefId?: InputMaybe<Order_By>;
  serverDate?: InputMaybe<Order_By>;
  sourceDate?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parameter_Value_Min_Fields = {
  __typename?: 'parameter_value_min_fields';
  batchDate?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  parameterDefId?: Maybe<Scalars['Int']['output']>;
  serverDate?: Maybe<Scalars['timestamptz']['output']>;
  sourceDate?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "parameter.value" */
export type Parameter_Value_Min_Order_By = {
  batchDate?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameterDefId?: InputMaybe<Order_By>;
  serverDate?: InputMaybe<Order_By>;
  sourceDate?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parameter.value" */
export type Parameter_Value_Mutation_Response = {
  __typename?: 'parameter_value_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parameter_Value>;
};

/** on_conflict condition type for table "parameter.value" */
export type Parameter_Value_On_Conflict = {
  constraint: Parameter_Value_Constraint;
  update_columns?: Array<Parameter_Value_Update_Column>;
  where?: InputMaybe<Parameter_Value_Bool_Exp>;
};

/** Ordering options when selecting data from "parameter.value". */
export type Parameter_Value_Order_By = {
  batchDate?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parameterDef?: InputMaybe<Parameter_ParameterDef_Order_By>;
  parameterDefId?: InputMaybe<Order_By>;
  serverDate?: InputMaybe<Order_By>;
  sourceDate?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parameter.value */
export type Parameter_Value_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "parameter.value" */
export enum Parameter_Value_Select_Column {
  /** column name */
  BatchDate = 'batchDate',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParameterDefId = 'parameterDefId',
  /** column name */
  ServerDate = 'serverDate',
  /** column name */
  SourceDate = 'sourceDate',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "parameter.value" */
export type Parameter_Value_Set_Input = {
  batchDate?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parameterDefId?: InputMaybe<Scalars['Int']['input']>;
  serverDate?: InputMaybe<Scalars['timestamptz']['input']>;
  sourceDate?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Parameter_Value_Stddev_Fields = {
  __typename?: 'parameter_value_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parameterDefId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "parameter.value" */
export type Parameter_Value_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  parameterDefId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Parameter_Value_Stddev_Pop_Fields = {
  __typename?: 'parameter_value_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parameterDefId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "parameter.value" */
export type Parameter_Value_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parameterDefId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Parameter_Value_Stddev_Samp_Fields = {
  __typename?: 'parameter_value_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parameterDefId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "parameter.value" */
export type Parameter_Value_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parameterDefId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "parameter_value" */
export type Parameter_Value_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parameter_Value_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parameter_Value_Stream_Cursor_Value_Input = {
  batchDate?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  parameterDefId?: InputMaybe<Scalars['Int']['input']>;
  serverDate?: InputMaybe<Scalars['timestamptz']['input']>;
  sourceDate?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Parameter_Value_Sum_Fields = {
  __typename?: 'parameter_value_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  parameterDefId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "parameter.value" */
export type Parameter_Value_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  parameterDefId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "parameter.value" */
export enum Parameter_Value_Update_Column {
  /** column name */
  BatchDate = 'batchDate',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParameterDefId = 'parameterDefId',
  /** column name */
  ServerDate = 'serverDate',
  /** column name */
  SourceDate = 'sourceDate',
  /** column name */
  Value = 'value'
}

export type Parameter_Value_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Parameter_Value_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parameter_Value_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parameter_Value_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Parameter_Value_Var_Pop_Fields = {
  __typename?: 'parameter_value_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parameterDefId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "parameter.value" */
export type Parameter_Value_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parameterDefId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Parameter_Value_Var_Samp_Fields = {
  __typename?: 'parameter_value_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parameterDefId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "parameter.value" */
export type Parameter_Value_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parameterDefId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Parameter_Value_Variance_Fields = {
  __typename?: 'parameter_value_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parameterDefId?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "parameter.value" */
export type Parameter_Value_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  parameterDefId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "permissionType" */
export type PermissionType = {
  __typename?: 'permissionType';
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "permissionType" */
export type PermissionType_Aggregate = {
  __typename?: 'permissionType_aggregate';
  aggregate?: Maybe<PermissionType_Aggregate_Fields>;
  nodes: Array<PermissionType>;
};

/** aggregate fields of "permissionType" */
export type PermissionType_Aggregate_Fields = {
  __typename?: 'permissionType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PermissionType_Max_Fields>;
  min?: Maybe<PermissionType_Min_Fields>;
};


/** aggregate fields of "permissionType" */
export type PermissionType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PermissionType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "permissionType". All fields are combined with a logical 'AND'. */
export type PermissionType_Bool_Exp = {
  _and?: InputMaybe<Array<PermissionType_Bool_Exp>>;
  _not?: InputMaybe<PermissionType_Bool_Exp>;
  _or?: InputMaybe<Array<PermissionType_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "permissionType" */
export enum PermissionType_Constraint {
  /** unique or primary key constraint on columns "id" */
  PermissionTypePkey = 'permissionType_pkey'
}

/** input type for inserting data into table "permissionType" */
export type PermissionType_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type PermissionType_Max_Fields = {
  __typename?: 'permissionType_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type PermissionType_Min_Fields = {
  __typename?: 'permissionType_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "permissionType" */
export type PermissionType_Mutation_Response = {
  __typename?: 'permissionType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PermissionType>;
};

/** input type for inserting object relation for remote table "permissionType" */
export type PermissionType_Obj_Rel_Insert_Input = {
  data: PermissionType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<PermissionType_On_Conflict>;
};

/** on_conflict condition type for table "permissionType" */
export type PermissionType_On_Conflict = {
  constraint: PermissionType_Constraint;
  update_columns?: Array<PermissionType_Update_Column>;
  where?: InputMaybe<PermissionType_Bool_Exp>;
};

/** Ordering options when selecting data from "permissionType". */
export type PermissionType_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: permissionType */
export type PermissionType_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "permissionType" */
export enum PermissionType_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "permissionType" */
export type PermissionType_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "permissionType" */
export type PermissionType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PermissionType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PermissionType_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "permissionType" */
export enum PermissionType_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type PermissionType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PermissionType_Set_Input>;
  /** filter the rows which have to be updated */
  where: PermissionType_Bool_Exp;
};

/** columns and relationships of "project" */
export type Project = {
  __typename?: 'project';
  /** An array relationship */
  constructionSites: Array<ConstructionSite>;
  /** An aggregate relationship */
  constructionSites_aggregate: ConstructionSite_Aggregate;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  segments: Array<Quality_Segment>;
  /** An aggregate relationship */
  segments_aggregate: Quality_Segment_Aggregate;
};


/** columns and relationships of "project" */
export type ProjectConstructionSitesArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSite_Order_By>>;
  where?: InputMaybe<ConstructionSite_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectConstructionSites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSite_Order_By>>;
  where?: InputMaybe<ConstructionSite_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectSegmentsArgs = {
  distinct_on?: InputMaybe<Array<Quality_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_Segment_Order_By>>;
  where?: InputMaybe<Quality_Segment_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectSegments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_Segment_Order_By>>;
  where?: InputMaybe<Quality_Segment_Bool_Exp>;
};

/** aggregated selection of "project" */
export type Project_Aggregate = {
  __typename?: 'project_aggregate';
  aggregate?: Maybe<Project_Aggregate_Fields>;
  nodes: Array<Project>;
};

/** aggregate fields of "project" */
export type Project_Aggregate_Fields = {
  __typename?: 'project_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Max_Fields>;
  min?: Maybe<Project_Min_Fields>;
};


/** aggregate fields of "project" */
export type Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project". All fields are combined with a logical 'AND'. */
export type Project_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Bool_Exp>>;
  _not?: InputMaybe<Project_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Bool_Exp>>;
  constructionSites?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSites_aggregate?: InputMaybe<ConstructionSite_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  segments?: InputMaybe<Quality_Segment_Bool_Exp>;
  segments_aggregate?: InputMaybe<Quality_Segment_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "project" */
export enum Project_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectPkey = 'project_pkey'
}

/** input type for inserting data into table "project" */
export type Project_Insert_Input = {
  constructionSites?: InputMaybe<ConstructionSite_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  segments?: InputMaybe<Quality_Segment_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Project_Max_Fields = {
  __typename?: 'project_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Project_Min_Fields = {
  __typename?: 'project_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "project" */
export type Project_Mutation_Response = {
  __typename?: 'project_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project>;
};

/** input type for inserting object relation for remote table "project" */
export type Project_Obj_Rel_Insert_Input = {
  data: Project_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_On_Conflict>;
};

/** on_conflict condition type for table "project" */
export type Project_On_Conflict = {
  constraint: Project_Constraint;
  update_columns?: Array<Project_Update_Column>;
  where?: InputMaybe<Project_Bool_Exp>;
};

/** Ordering options when selecting data from "project". */
export type Project_Order_By = {
  constructionSites_aggregate?: InputMaybe<ConstructionSite_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  segments_aggregate?: InputMaybe<Quality_Segment_Aggregate_Order_By>;
};

/** primary key columns input for table: project */
export type Project_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project" */
export enum Project_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "project" */
export type Project_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "project" */
export type Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "project" */
export enum Project_Update_Column {
  /** column name */
  Id = 'id'
}

export type Project_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Bool_Exp;
};

/** columns and relationships of "quality.boardConfig" */
export type Quality_BoardConfig = {
  __typename?: 'quality_boardConfig';
  /** An object relationship */
  constructionSite?: Maybe<ConstructionSite>;
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  segmentDrawConfigs: Array<Quality_SegmentDrawConfig>;
  /** An aggregate relationship */
  segmentDrawConfigs_aggregate: Quality_SegmentDrawConfig_Aggregate;
  segmentWidth: Scalars['Int']['output'];
  /** An array relationship */
  tunnelPositions: Array<Quality_TunnelPosition>;
  /** An aggregate relationship */
  tunnelPositions_aggregate: Quality_TunnelPosition_Aggregate;
};


/** columns and relationships of "quality.boardConfig" */
export type Quality_BoardConfigSegmentDrawConfigsArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentDrawConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentDrawConfig_Order_By>>;
  where?: InputMaybe<Quality_SegmentDrawConfig_Bool_Exp>;
};


/** columns and relationships of "quality.boardConfig" */
export type Quality_BoardConfigSegmentDrawConfigs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentDrawConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentDrawConfig_Order_By>>;
  where?: InputMaybe<Quality_SegmentDrawConfig_Bool_Exp>;
};


/** columns and relationships of "quality.boardConfig" */
export type Quality_BoardConfigTunnelPositionsArgs = {
  distinct_on?: InputMaybe<Array<Quality_TunnelPosition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_TunnelPosition_Order_By>>;
  where?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
};


/** columns and relationships of "quality.boardConfig" */
export type Quality_BoardConfigTunnelPositions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_TunnelPosition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_TunnelPosition_Order_By>>;
  where?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
};

/** aggregated selection of "quality.boardConfig" */
export type Quality_BoardConfig_Aggregate = {
  __typename?: 'quality_boardConfig_aggregate';
  aggregate?: Maybe<Quality_BoardConfig_Aggregate_Fields>;
  nodes: Array<Quality_BoardConfig>;
};

export type Quality_BoardConfig_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quality_BoardConfig_Aggregate_Bool_Exp_Count>;
};

export type Quality_BoardConfig_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quality_BoardConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_BoardConfig_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quality.boardConfig" */
export type Quality_BoardConfig_Aggregate_Fields = {
  __typename?: 'quality_boardConfig_aggregate_fields';
  avg?: Maybe<Quality_BoardConfig_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_BoardConfig_Max_Fields>;
  min?: Maybe<Quality_BoardConfig_Min_Fields>;
  stddev?: Maybe<Quality_BoardConfig_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_BoardConfig_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_BoardConfig_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_BoardConfig_Sum_Fields>;
  var_pop?: Maybe<Quality_BoardConfig_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_BoardConfig_Var_Samp_Fields>;
  variance?: Maybe<Quality_BoardConfig_Variance_Fields>;
};


/** aggregate fields of "quality.boardConfig" */
export type Quality_BoardConfig_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_BoardConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quality.boardConfig" */
export type Quality_BoardConfig_Aggregate_Order_By = {
  avg?: InputMaybe<Quality_BoardConfig_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quality_BoardConfig_Max_Order_By>;
  min?: InputMaybe<Quality_BoardConfig_Min_Order_By>;
  stddev?: InputMaybe<Quality_BoardConfig_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quality_BoardConfig_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quality_BoardConfig_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quality_BoardConfig_Sum_Order_By>;
  var_pop?: InputMaybe<Quality_BoardConfig_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quality_BoardConfig_Var_Samp_Order_By>;
  variance?: InputMaybe<Quality_BoardConfig_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quality.boardConfig" */
export type Quality_BoardConfig_Arr_Rel_Insert_Input = {
  data: Array<Quality_BoardConfig_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_BoardConfig_On_Conflict>;
};

/** aggregate avg on columns */
export type Quality_BoardConfig_Avg_Fields = {
  __typename?: 'quality_boardConfig_avg_fields';
  segmentWidth?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quality.boardConfig" */
export type Quality_BoardConfig_Avg_Order_By = {
  segmentWidth?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quality.boardConfig". All fields are combined with a logical 'AND'. */
export type Quality_BoardConfig_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_BoardConfig_Bool_Exp>>;
  _not?: InputMaybe<Quality_BoardConfig_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_BoardConfig_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  segmentDrawConfigs?: InputMaybe<Quality_SegmentDrawConfig_Bool_Exp>;
  segmentDrawConfigs_aggregate?: InputMaybe<Quality_SegmentDrawConfig_Aggregate_Bool_Exp>;
  segmentWidth?: InputMaybe<Int_Comparison_Exp>;
  tunnelPositions?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
  tunnelPositions_aggregate?: InputMaybe<Quality_TunnelPosition_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "quality.boardConfig" */
export enum Quality_BoardConfig_Constraint {
  /** unique or primary key constraint on columns "id" */
  BoardConfigPkey = 'boardConfig_pkey'
}

/** input type for incrementing numeric columns in table "quality.boardConfig" */
export type Quality_BoardConfig_Inc_Input = {
  segmentWidth?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quality.boardConfig" */
export type Quality_BoardConfig_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  segmentDrawConfigs?: InputMaybe<Quality_SegmentDrawConfig_Arr_Rel_Insert_Input>;
  segmentWidth?: InputMaybe<Scalars['Int']['input']>;
  tunnelPositions?: InputMaybe<Quality_TunnelPosition_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Quality_BoardConfig_Max_Fields = {
  __typename?: 'quality_boardConfig_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  segmentWidth?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "quality.boardConfig" */
export type Quality_BoardConfig_Max_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segmentWidth?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quality_BoardConfig_Min_Fields = {
  __typename?: 'quality_boardConfig_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  segmentWidth?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "quality.boardConfig" */
export type Quality_BoardConfig_Min_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segmentWidth?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quality.boardConfig" */
export type Quality_BoardConfig_Mutation_Response = {
  __typename?: 'quality_boardConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_BoardConfig>;
};

/** input type for inserting object relation for remote table "quality.boardConfig" */
export type Quality_BoardConfig_Obj_Rel_Insert_Input = {
  data: Quality_BoardConfig_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_BoardConfig_On_Conflict>;
};

/** on_conflict condition type for table "quality.boardConfig" */
export type Quality_BoardConfig_On_Conflict = {
  constraint: Quality_BoardConfig_Constraint;
  update_columns?: Array<Quality_BoardConfig_Update_Column>;
  where?: InputMaybe<Quality_BoardConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.boardConfig". */
export type Quality_BoardConfig_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segmentDrawConfigs_aggregate?: InputMaybe<Quality_SegmentDrawConfig_Aggregate_Order_By>;
  segmentWidth?: InputMaybe<Order_By>;
  tunnelPositions_aggregate?: InputMaybe<Quality_TunnelPosition_Aggregate_Order_By>;
};

/** primary key columns input for table: quality.boardConfig */
export type Quality_BoardConfig_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.boardConfig" */
export enum Quality_BoardConfig_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentWidth = 'segmentWidth'
}

/** input type for updating data in table "quality.boardConfig" */
export type Quality_BoardConfig_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  segmentWidth?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Quality_BoardConfig_Stddev_Fields = {
  __typename?: 'quality_boardConfig_stddev_fields';
  segmentWidth?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quality.boardConfig" */
export type Quality_BoardConfig_Stddev_Order_By = {
  segmentWidth?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quality_BoardConfig_Stddev_Pop_Fields = {
  __typename?: 'quality_boardConfig_stddev_pop_fields';
  segmentWidth?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quality.boardConfig" */
export type Quality_BoardConfig_Stddev_Pop_Order_By = {
  segmentWidth?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quality_BoardConfig_Stddev_Samp_Fields = {
  __typename?: 'quality_boardConfig_stddev_samp_fields';
  segmentWidth?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quality.boardConfig" */
export type Quality_BoardConfig_Stddev_Samp_Order_By = {
  segmentWidth?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quality_boardConfig" */
export type Quality_BoardConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_BoardConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_BoardConfig_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  segmentWidth?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Quality_BoardConfig_Sum_Fields = {
  __typename?: 'quality_boardConfig_sum_fields';
  segmentWidth?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "quality.boardConfig" */
export type Quality_BoardConfig_Sum_Order_By = {
  segmentWidth?: InputMaybe<Order_By>;
};

/** update columns of table "quality.boardConfig" */
export enum Quality_BoardConfig_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentWidth = 'segmentWidth'
}

export type Quality_BoardConfig_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quality_BoardConfig_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_BoardConfig_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_BoardConfig_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quality_BoardConfig_Var_Pop_Fields = {
  __typename?: 'quality_boardConfig_var_pop_fields';
  segmentWidth?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quality.boardConfig" */
export type Quality_BoardConfig_Var_Pop_Order_By = {
  segmentWidth?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quality_BoardConfig_Var_Samp_Fields = {
  __typename?: 'quality_boardConfig_var_samp_fields';
  segmentWidth?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quality.boardConfig" */
export type Quality_BoardConfig_Var_Samp_Order_By = {
  segmentWidth?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quality_BoardConfig_Variance_Fields = {
  __typename?: 'quality_boardConfig_variance_fields';
  segmentWidth?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quality.boardConfig" */
export type Quality_BoardConfig_Variance_Order_By = {
  segmentWidth?: InputMaybe<Order_By>;
};

/** columns and relationships of "quality.boardSegment" */
export type Quality_BoardSegment = {
  __typename?: 'quality_boardSegment';
  id: Scalars['uuid']['output'];
  ringId: Scalars['uuid']['output'];
  segmentType: Scalars['String']['output'];
  serialNumber?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "quality.boardSegment" */
export type Quality_BoardSegment_Aggregate = {
  __typename?: 'quality_boardSegment_aggregate';
  aggregate?: Maybe<Quality_BoardSegment_Aggregate_Fields>;
  nodes: Array<Quality_BoardSegment>;
};

/** aggregate fields of "quality.boardSegment" */
export type Quality_BoardSegment_Aggregate_Fields = {
  __typename?: 'quality_boardSegment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_BoardSegment_Max_Fields>;
  min?: Maybe<Quality_BoardSegment_Min_Fields>;
};


/** aggregate fields of "quality.boardSegment" */
export type Quality_BoardSegment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_BoardSegment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.boardSegment". All fields are combined with a logical 'AND'. */
export type Quality_BoardSegment_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_BoardSegment_Bool_Exp>>;
  _not?: InputMaybe<Quality_BoardSegment_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_BoardSegment_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ringId?: InputMaybe<Uuid_Comparison_Exp>;
  segmentType?: InputMaybe<String_Comparison_Exp>;
  serialNumber?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.boardSegment" */
export enum Quality_BoardSegment_Constraint {
  /** unique or primary key constraint on columns "id" */
  BoardSegmentPkey = 'boardSegment_pkey',
  /** unique or primary key constraint on columns "ringId", "segmentType" */
  BoardSegmentRingIdSegmentTypeKey = 'boardSegment_ringId_segmentType_key'
}

/** input type for inserting data into table "quality.boardSegment" */
export type Quality_BoardSegment_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  ringId?: InputMaybe<Scalars['uuid']['input']>;
  segmentType?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quality_BoardSegment_Max_Fields = {
  __typename?: 'quality_boardSegment_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  ringId?: Maybe<Scalars['uuid']['output']>;
  segmentType?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quality_BoardSegment_Min_Fields = {
  __typename?: 'quality_boardSegment_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  ringId?: Maybe<Scalars['uuid']['output']>;
  segmentType?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quality.boardSegment" */
export type Quality_BoardSegment_Mutation_Response = {
  __typename?: 'quality_boardSegment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_BoardSegment>;
};

/** on_conflict condition type for table "quality.boardSegment" */
export type Quality_BoardSegment_On_Conflict = {
  constraint: Quality_BoardSegment_Constraint;
  update_columns?: Array<Quality_BoardSegment_Update_Column>;
  where?: InputMaybe<Quality_BoardSegment_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.boardSegment". */
export type Quality_BoardSegment_Order_By = {
  id?: InputMaybe<Order_By>;
  ringId?: InputMaybe<Order_By>;
  segmentType?: InputMaybe<Order_By>;
  serialNumber?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.boardSegment */
export type Quality_BoardSegment_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.boardSegment" */
export enum Quality_BoardSegment_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RingId = 'ringId',
  /** column name */
  SegmentType = 'segmentType',
  /** column name */
  SerialNumber = 'serialNumber'
}

/** input type for updating data in table "quality.boardSegment" */
export type Quality_BoardSegment_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  ringId?: InputMaybe<Scalars['uuid']['input']>;
  segmentType?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quality_boardSegment" */
export type Quality_BoardSegment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_BoardSegment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_BoardSegment_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  ringId?: InputMaybe<Scalars['uuid']['input']>;
  segmentType?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quality.boardSegment" */
export enum Quality_BoardSegment_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RingId = 'ringId',
  /** column name */
  SegmentType = 'segmentType',
  /** column name */
  SerialNumber = 'serialNumber'
}

export type Quality_BoardSegment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_BoardSegment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_BoardSegment_Bool_Exp;
};

/** columns and relationships of "quality.defectRepair" */
export type Quality_DefectRepair = {
  __typename?: 'quality_defectRepair';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  defectRepairType?: Maybe<Quality_DefectRepairType>;
  defectRepairTypeId: Scalars['uuid']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  quarantineDefectId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** columns and relationships of "quality.defectRepairPicture" */
export type Quality_DefectRepairPicture = {
  __typename?: 'quality_defectRepairPicture';
  bucketFileId: Scalars['uuid']['output'];
  defectRepairId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "quality.defectRepairPicture" */
export type Quality_DefectRepairPicture_Aggregate = {
  __typename?: 'quality_defectRepairPicture_aggregate';
  aggregate?: Maybe<Quality_DefectRepairPicture_Aggregate_Fields>;
  nodes: Array<Quality_DefectRepairPicture>;
};

/** aggregate fields of "quality.defectRepairPicture" */
export type Quality_DefectRepairPicture_Aggregate_Fields = {
  __typename?: 'quality_defectRepairPicture_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_DefectRepairPicture_Max_Fields>;
  min?: Maybe<Quality_DefectRepairPicture_Min_Fields>;
};


/** aggregate fields of "quality.defectRepairPicture" */
export type Quality_DefectRepairPicture_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_DefectRepairPicture_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.defectRepairPicture". All fields are combined with a logical 'AND'. */
export type Quality_DefectRepairPicture_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_DefectRepairPicture_Bool_Exp>>;
  _not?: InputMaybe<Quality_DefectRepairPicture_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_DefectRepairPicture_Bool_Exp>>;
  bucketFileId?: InputMaybe<Uuid_Comparison_Exp>;
  defectRepairId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.defectRepairPicture" */
export enum Quality_DefectRepairPicture_Constraint {
  /** unique or primary key constraint on columns "id" */
  DefectRepairPicturePkey = 'defectRepairPicture_pkey'
}

/** input type for inserting data into table "quality.defectRepairPicture" */
export type Quality_DefectRepairPicture_Insert_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  defectRepairId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Quality_DefectRepairPicture_Max_Fields = {
  __typename?: 'quality_defectRepairPicture_max_fields';
  bucketFileId?: Maybe<Scalars['uuid']['output']>;
  defectRepairId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Quality_DefectRepairPicture_Min_Fields = {
  __typename?: 'quality_defectRepairPicture_min_fields';
  bucketFileId?: Maybe<Scalars['uuid']['output']>;
  defectRepairId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "quality.defectRepairPicture" */
export type Quality_DefectRepairPicture_Mutation_Response = {
  __typename?: 'quality_defectRepairPicture_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_DefectRepairPicture>;
};

/** on_conflict condition type for table "quality.defectRepairPicture" */
export type Quality_DefectRepairPicture_On_Conflict = {
  constraint: Quality_DefectRepairPicture_Constraint;
  update_columns?: Array<Quality_DefectRepairPicture_Update_Column>;
  where?: InputMaybe<Quality_DefectRepairPicture_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.defectRepairPicture". */
export type Quality_DefectRepairPicture_Order_By = {
  bucketFileId?: InputMaybe<Order_By>;
  defectRepairId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.defectRepairPicture */
export type Quality_DefectRepairPicture_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.defectRepairPicture" */
export enum Quality_DefectRepairPicture_Select_Column {
  /** column name */
  BucketFileId = 'bucketFileId',
  /** column name */
  DefectRepairId = 'defectRepairId',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "quality.defectRepairPicture" */
export type Quality_DefectRepairPicture_Set_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  defectRepairId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "quality_defectRepairPicture" */
export type Quality_DefectRepairPicture_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_DefectRepairPicture_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_DefectRepairPicture_Stream_Cursor_Value_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  defectRepairId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "quality.defectRepairPicture" */
export enum Quality_DefectRepairPicture_Update_Column {
  /** column name */
  BucketFileId = 'bucketFileId',
  /** column name */
  DefectRepairId = 'defectRepairId',
  /** column name */
  Id = 'id'
}

export type Quality_DefectRepairPicture_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_DefectRepairPicture_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_DefectRepairPicture_Bool_Exp;
};

/** columns and relationships of "quality.defectRepairType" */
export type Quality_DefectRepairType = {
  __typename?: 'quality_defectRepairType';
  id: Scalars['uuid']['output'];
  isHidden: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  projectId: Scalars['uuid']['output'];
};

/** aggregated selection of "quality.defectRepairType" */
export type Quality_DefectRepairType_Aggregate = {
  __typename?: 'quality_defectRepairType_aggregate';
  aggregate?: Maybe<Quality_DefectRepairType_Aggregate_Fields>;
  nodes: Array<Quality_DefectRepairType>;
};

/** aggregate fields of "quality.defectRepairType" */
export type Quality_DefectRepairType_Aggregate_Fields = {
  __typename?: 'quality_defectRepairType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_DefectRepairType_Max_Fields>;
  min?: Maybe<Quality_DefectRepairType_Min_Fields>;
};


/** aggregate fields of "quality.defectRepairType" */
export type Quality_DefectRepairType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_DefectRepairType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.defectRepairType". All fields are combined with a logical 'AND'. */
export type Quality_DefectRepairType_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_DefectRepairType_Bool_Exp>>;
  _not?: InputMaybe<Quality_DefectRepairType_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_DefectRepairType_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.defectRepairType" */
export enum Quality_DefectRepairType_Constraint {
  /** unique or primary key constraint on columns "id" */
  DefectRepairTypePkey = 'defectRepairType_pkey'
}

/** input type for inserting data into table "quality.defectRepairType" */
export type Quality_DefectRepairType_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Quality_DefectRepairType_Max_Fields = {
  __typename?: 'quality_defectRepairType_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Quality_DefectRepairType_Min_Fields = {
  __typename?: 'quality_defectRepairType_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "quality.defectRepairType" */
export type Quality_DefectRepairType_Mutation_Response = {
  __typename?: 'quality_defectRepairType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_DefectRepairType>;
};

/** input type for inserting object relation for remote table "quality.defectRepairType" */
export type Quality_DefectRepairType_Obj_Rel_Insert_Input = {
  data: Quality_DefectRepairType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_DefectRepairType_On_Conflict>;
};

/** on_conflict condition type for table "quality.defectRepairType" */
export type Quality_DefectRepairType_On_Conflict = {
  constraint: Quality_DefectRepairType_Constraint;
  update_columns?: Array<Quality_DefectRepairType_Update_Column>;
  where?: InputMaybe<Quality_DefectRepairType_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.defectRepairType". */
export type Quality_DefectRepairType_Order_By = {
  id?: InputMaybe<Order_By>;
  isHidden?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.defectRepairType */
export type Quality_DefectRepairType_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.defectRepairType" */
export enum Quality_DefectRepairType_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Label = 'label',
  /** column name */
  ProjectId = 'projectId'
}

/** input type for updating data in table "quality.defectRepairType" */
export type Quality_DefectRepairType_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "quality_defectRepairType" */
export type Quality_DefectRepairType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_DefectRepairType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_DefectRepairType_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "quality.defectRepairType" */
export enum Quality_DefectRepairType_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Label = 'label',
  /** column name */
  ProjectId = 'projectId'
}

export type Quality_DefectRepairType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_DefectRepairType_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_DefectRepairType_Bool_Exp;
};

/** aggregated selection of "quality.defectRepair" */
export type Quality_DefectRepair_Aggregate = {
  __typename?: 'quality_defectRepair_aggregate';
  aggregate?: Maybe<Quality_DefectRepair_Aggregate_Fields>;
  nodes: Array<Quality_DefectRepair>;
};

/** aggregate fields of "quality.defectRepair" */
export type Quality_DefectRepair_Aggregate_Fields = {
  __typename?: 'quality_defectRepair_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_DefectRepair_Max_Fields>;
  min?: Maybe<Quality_DefectRepair_Min_Fields>;
};


/** aggregate fields of "quality.defectRepair" */
export type Quality_DefectRepair_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_DefectRepair_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.defectRepair". All fields are combined with a logical 'AND'. */
export type Quality_DefectRepair_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_DefectRepair_Bool_Exp>>;
  _not?: InputMaybe<Quality_DefectRepair_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_DefectRepair_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  defectRepairType?: InputMaybe<Quality_DefectRepairType_Bool_Exp>;
  defectRepairTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  quarantineDefectId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.defectRepair" */
export enum Quality_DefectRepair_Constraint {
  /** unique or primary key constraint on columns "id" */
  DefectRepairPkey = 'defectRepair_pkey'
}

/** input type for inserting data into table "quality.defectRepair" */
export type Quality_DefectRepair_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  defectRepairType?: InputMaybe<Quality_DefectRepairType_Obj_Rel_Insert_Input>;
  defectRepairTypeId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quarantineDefectId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quality_DefectRepair_Max_Fields = {
  __typename?: 'quality_defectRepair_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  defectRepairTypeId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quarantineDefectId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Quality_DefectRepair_Min_Fields = {
  __typename?: 'quality_defectRepair_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  defectRepairTypeId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quarantineDefectId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "quality.defectRepair" */
export type Quality_DefectRepair_Mutation_Response = {
  __typename?: 'quality_defectRepair_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_DefectRepair>;
};

/** input type for inserting object relation for remote table "quality.defectRepair" */
export type Quality_DefectRepair_Obj_Rel_Insert_Input = {
  data: Quality_DefectRepair_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_DefectRepair_On_Conflict>;
};

/** on_conflict condition type for table "quality.defectRepair" */
export type Quality_DefectRepair_On_Conflict = {
  constraint: Quality_DefectRepair_Constraint;
  update_columns?: Array<Quality_DefectRepair_Update_Column>;
  where?: InputMaybe<Quality_DefectRepair_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.defectRepair". */
export type Quality_DefectRepair_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  defectRepairType?: InputMaybe<Quality_DefectRepairType_Order_By>;
  defectRepairTypeId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quarantineDefectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.defectRepair */
export type Quality_DefectRepair_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.defectRepair" */
export enum Quality_DefectRepair_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefectRepairTypeId = 'defectRepairTypeId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  QuarantineDefectId = 'quarantineDefectId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "quality.defectRepair" */
export type Quality_DefectRepair_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  defectRepairTypeId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quarantineDefectId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "quality_defectRepair" */
export type Quality_DefectRepair_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_DefectRepair_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_DefectRepair_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  defectRepairTypeId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quarantineDefectId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "quality.defectRepair" */
export enum Quality_DefectRepair_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefectRepairTypeId = 'defectRepairTypeId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  QuarantineDefectId = 'quarantineDefectId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Quality_DefectRepair_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_DefectRepair_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_DefectRepair_Bool_Exp;
};

/** columns and relationships of "quality.defectReport" */
export type Quality_DefectReport = {
  __typename?: 'quality_defectReport';
  authorId: Scalars['uuid']['output'];
  boardSegmentId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  defectReportTypeId: Scalars['uuid']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  indicatorId?: Maybe<Scalars['uuid']['output']>;
  strokes: Scalars['jsonb']['output'];
  submittedAt?: Maybe<Scalars['timestamptz']['output']>;
  toRepair: Scalars['Boolean']['output'];
};


/** columns and relationships of "quality.defectReport" */
export type Quality_DefectReportStrokesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "quality.defectReportPicture" */
export type Quality_DefectReportPicture = {
  __typename?: 'quality_defectReportPicture';
  bucketFileId: Scalars['uuid']['output'];
  defectReportId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "quality.defectReportPicture" */
export type Quality_DefectReportPicture_Aggregate = {
  __typename?: 'quality_defectReportPicture_aggregate';
  aggregate?: Maybe<Quality_DefectReportPicture_Aggregate_Fields>;
  nodes: Array<Quality_DefectReportPicture>;
};

/** aggregate fields of "quality.defectReportPicture" */
export type Quality_DefectReportPicture_Aggregate_Fields = {
  __typename?: 'quality_defectReportPicture_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_DefectReportPicture_Max_Fields>;
  min?: Maybe<Quality_DefectReportPicture_Min_Fields>;
};


/** aggregate fields of "quality.defectReportPicture" */
export type Quality_DefectReportPicture_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_DefectReportPicture_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.defectReportPicture". All fields are combined with a logical 'AND'. */
export type Quality_DefectReportPicture_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_DefectReportPicture_Bool_Exp>>;
  _not?: InputMaybe<Quality_DefectReportPicture_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_DefectReportPicture_Bool_Exp>>;
  bucketFileId?: InputMaybe<Uuid_Comparison_Exp>;
  defectReportId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.defectReportPicture" */
export enum Quality_DefectReportPicture_Constraint {
  /** unique or primary key constraint on columns "id" */
  DefectReportPicturePkey = 'defectReportPicture_pkey'
}

/** input type for inserting data into table "quality.defectReportPicture" */
export type Quality_DefectReportPicture_Insert_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  defectReportId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Quality_DefectReportPicture_Max_Fields = {
  __typename?: 'quality_defectReportPicture_max_fields';
  bucketFileId?: Maybe<Scalars['uuid']['output']>;
  defectReportId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Quality_DefectReportPicture_Min_Fields = {
  __typename?: 'quality_defectReportPicture_min_fields';
  bucketFileId?: Maybe<Scalars['uuid']['output']>;
  defectReportId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "quality.defectReportPicture" */
export type Quality_DefectReportPicture_Mutation_Response = {
  __typename?: 'quality_defectReportPicture_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_DefectReportPicture>;
};

/** on_conflict condition type for table "quality.defectReportPicture" */
export type Quality_DefectReportPicture_On_Conflict = {
  constraint: Quality_DefectReportPicture_Constraint;
  update_columns?: Array<Quality_DefectReportPicture_Update_Column>;
  where?: InputMaybe<Quality_DefectReportPicture_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.defectReportPicture". */
export type Quality_DefectReportPicture_Order_By = {
  bucketFileId?: InputMaybe<Order_By>;
  defectReportId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.defectReportPicture */
export type Quality_DefectReportPicture_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.defectReportPicture" */
export enum Quality_DefectReportPicture_Select_Column {
  /** column name */
  BucketFileId = 'bucketFileId',
  /** column name */
  DefectReportId = 'defectReportId',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "quality.defectReportPicture" */
export type Quality_DefectReportPicture_Set_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  defectReportId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "quality_defectReportPicture" */
export type Quality_DefectReportPicture_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_DefectReportPicture_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_DefectReportPicture_Stream_Cursor_Value_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  defectReportId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "quality.defectReportPicture" */
export enum Quality_DefectReportPicture_Update_Column {
  /** column name */
  BucketFileId = 'bucketFileId',
  /** column name */
  DefectReportId = 'defectReportId',
  /** column name */
  Id = 'id'
}

export type Quality_DefectReportPicture_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_DefectReportPicture_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_DefectReportPicture_Bool_Exp;
};

/** columns and relationships of "quality.defectReportType" */
export type Quality_DefectReportType = {
  __typename?: 'quality_defectReportType';
  color: Scalars['String']['output'];
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
};

/** aggregated selection of "quality.defectReportType" */
export type Quality_DefectReportType_Aggregate = {
  __typename?: 'quality_defectReportType_aggregate';
  aggregate?: Maybe<Quality_DefectReportType_Aggregate_Fields>;
  nodes: Array<Quality_DefectReportType>;
};

/** aggregate fields of "quality.defectReportType" */
export type Quality_DefectReportType_Aggregate_Fields = {
  __typename?: 'quality_defectReportType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_DefectReportType_Max_Fields>;
  min?: Maybe<Quality_DefectReportType_Min_Fields>;
};


/** aggregate fields of "quality.defectReportType" */
export type Quality_DefectReportType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_DefectReportType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.defectReportType". All fields are combined with a logical 'AND'. */
export type Quality_DefectReportType_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_DefectReportType_Bool_Exp>>;
  _not?: InputMaybe<Quality_DefectReportType_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_DefectReportType_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.defectReportType" */
export enum Quality_DefectReportType_Constraint {
  /** unique or primary key constraint on columns "label", "constructionSiteId" */
  DefectReportTypeConstructionSiteIdLabelKey = 'defectReportType_constructionSiteId_label_key',
  /** unique or primary key constraint on columns "id" */
  DefectReportTypePkey = 'defectReportType_pkey'
}

/** input type for inserting data into table "quality.defectReportType" */
export type Quality_DefectReportType_Insert_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quality_DefectReportType_Max_Fields = {
  __typename?: 'quality_defectReportType_max_fields';
  color?: Maybe<Scalars['String']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quality_DefectReportType_Min_Fields = {
  __typename?: 'quality_defectReportType_min_fields';
  color?: Maybe<Scalars['String']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quality.defectReportType" */
export type Quality_DefectReportType_Mutation_Response = {
  __typename?: 'quality_defectReportType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_DefectReportType>;
};

/** on_conflict condition type for table "quality.defectReportType" */
export type Quality_DefectReportType_On_Conflict = {
  constraint: Quality_DefectReportType_Constraint;
  update_columns?: Array<Quality_DefectReportType_Update_Column>;
  where?: InputMaybe<Quality_DefectReportType_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.defectReportType". */
export type Quality_DefectReportType_Order_By = {
  color?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isHidden?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.defectReportType */
export type Quality_DefectReportType_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.defectReportType" */
export enum Quality_DefectReportType_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Label = 'label'
}

/** input type for updating data in table "quality.defectReportType" */
export type Quality_DefectReportType_Set_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quality_defectReportType" */
export type Quality_DefectReportType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_DefectReportType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_DefectReportType_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quality.defectReportType" */
export enum Quality_DefectReportType_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Label = 'label'
}

export type Quality_DefectReportType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_DefectReportType_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_DefectReportType_Bool_Exp;
};

/** columns and relationships of "quality.defectReportView" */
export type Quality_DefectReportView = {
  __typename?: 'quality_defectReportView';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  defectAuthor?: Maybe<Scalars['String']['output']>;
  defectDescription?: Maybe<Scalars['String']['output']>;
  defectType?: Maybe<Scalars['String']['output']>;
  defectTypeId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicator?: Maybe<Scalars['String']['output']>;
  indicatorId?: Maybe<Scalars['uuid']['output']>;
  repairAuthor?: Maybe<Scalars['String']['output']>;
  repairDate?: Maybe<Scalars['timestamptz']['output']>;
  repairDescription?: Maybe<Scalars['String']['output']>;
  repairId?: Maybe<Scalars['uuid']['output']>;
  reportDate?: Maybe<Scalars['timestamptz']['output']>;
  ringId?: Maybe<Scalars['uuid']['output']>;
  ringKey?: Maybe<Scalars['Int']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  segmentType?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  toRepair?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "quality.defectReportView" */
export type Quality_DefectReportView_Aggregate = {
  __typename?: 'quality_defectReportView_aggregate';
  aggregate?: Maybe<Quality_DefectReportView_Aggregate_Fields>;
  nodes: Array<Quality_DefectReportView>;
};

/** aggregate fields of "quality.defectReportView" */
export type Quality_DefectReportView_Aggregate_Fields = {
  __typename?: 'quality_defectReportView_aggregate_fields';
  avg?: Maybe<Quality_DefectReportView_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_DefectReportView_Max_Fields>;
  min?: Maybe<Quality_DefectReportView_Min_Fields>;
  stddev?: Maybe<Quality_DefectReportView_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_DefectReportView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_DefectReportView_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_DefectReportView_Sum_Fields>;
  var_pop?: Maybe<Quality_DefectReportView_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_DefectReportView_Var_Samp_Fields>;
  variance?: Maybe<Quality_DefectReportView_Variance_Fields>;
};


/** aggregate fields of "quality.defectReportView" */
export type Quality_DefectReportView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_DefectReportView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Quality_DefectReportView_Avg_Fields = {
  __typename?: 'quality_defectReportView_avg_fields';
  ringKey?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "quality.defectReportView". All fields are combined with a logical 'AND'. */
export type Quality_DefectReportView_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_DefectReportView_Bool_Exp>>;
  _not?: InputMaybe<Quality_DefectReportView_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_DefectReportView_Bool_Exp>>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  defectAuthor?: InputMaybe<String_Comparison_Exp>;
  defectDescription?: InputMaybe<String_Comparison_Exp>;
  defectType?: InputMaybe<String_Comparison_Exp>;
  defectTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indicator?: InputMaybe<String_Comparison_Exp>;
  indicatorId?: InputMaybe<Uuid_Comparison_Exp>;
  repairAuthor?: InputMaybe<String_Comparison_Exp>;
  repairDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  repairDescription?: InputMaybe<String_Comparison_Exp>;
  repairId?: InputMaybe<Uuid_Comparison_Exp>;
  reportDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  ringId?: InputMaybe<Uuid_Comparison_Exp>;
  ringKey?: InputMaybe<Int_Comparison_Exp>;
  ringNumber?: InputMaybe<Int_Comparison_Exp>;
  segmentType?: InputMaybe<String_Comparison_Exp>;
  serialNumber?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  toRepair?: InputMaybe<Boolean_Comparison_Exp>;
};

/** aggregate max on columns */
export type Quality_DefectReportView_Max_Fields = {
  __typename?: 'quality_defectReportView_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  defectAuthor?: Maybe<Scalars['String']['output']>;
  defectDescription?: Maybe<Scalars['String']['output']>;
  defectType?: Maybe<Scalars['String']['output']>;
  defectTypeId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicator?: Maybe<Scalars['String']['output']>;
  indicatorId?: Maybe<Scalars['uuid']['output']>;
  repairAuthor?: Maybe<Scalars['String']['output']>;
  repairDate?: Maybe<Scalars['timestamptz']['output']>;
  repairDescription?: Maybe<Scalars['String']['output']>;
  repairId?: Maybe<Scalars['uuid']['output']>;
  reportDate?: Maybe<Scalars['timestamptz']['output']>;
  ringId?: Maybe<Scalars['uuid']['output']>;
  ringKey?: Maybe<Scalars['Int']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  segmentType?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quality_DefectReportView_Min_Fields = {
  __typename?: 'quality_defectReportView_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  defectAuthor?: Maybe<Scalars['String']['output']>;
  defectDescription?: Maybe<Scalars['String']['output']>;
  defectType?: Maybe<Scalars['String']['output']>;
  defectTypeId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicator?: Maybe<Scalars['String']['output']>;
  indicatorId?: Maybe<Scalars['uuid']['output']>;
  repairAuthor?: Maybe<Scalars['String']['output']>;
  repairDate?: Maybe<Scalars['timestamptz']['output']>;
  repairDescription?: Maybe<Scalars['String']['output']>;
  repairId?: Maybe<Scalars['uuid']['output']>;
  reportDate?: Maybe<Scalars['timestamptz']['output']>;
  ringId?: Maybe<Scalars['uuid']['output']>;
  ringKey?: Maybe<Scalars['Int']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  segmentType?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "quality.defectReportView". */
export type Quality_DefectReportView_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  defectAuthor?: InputMaybe<Order_By>;
  defectDescription?: InputMaybe<Order_By>;
  defectType?: InputMaybe<Order_By>;
  defectTypeId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicator?: InputMaybe<Order_By>;
  indicatorId?: InputMaybe<Order_By>;
  repairAuthor?: InputMaybe<Order_By>;
  repairDate?: InputMaybe<Order_By>;
  repairDescription?: InputMaybe<Order_By>;
  repairId?: InputMaybe<Order_By>;
  reportDate?: InputMaybe<Order_By>;
  ringId?: InputMaybe<Order_By>;
  ringKey?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  segmentType?: InputMaybe<Order_By>;
  serialNumber?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  toRepair?: InputMaybe<Order_By>;
};

/** select columns of table "quality.defectReportView" */
export enum Quality_DefectReportView_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  DefectAuthor = 'defectAuthor',
  /** column name */
  DefectDescription = 'defectDescription',
  /** column name */
  DefectType = 'defectType',
  /** column name */
  DefectTypeId = 'defectTypeId',
  /** column name */
  Id = 'id',
  /** column name */
  Indicator = 'indicator',
  /** column name */
  IndicatorId = 'indicatorId',
  /** column name */
  RepairAuthor = 'repairAuthor',
  /** column name */
  RepairDate = 'repairDate',
  /** column name */
  RepairDescription = 'repairDescription',
  /** column name */
  RepairId = 'repairId',
  /** column name */
  ReportDate = 'reportDate',
  /** column name */
  RingId = 'ringId',
  /** column name */
  RingKey = 'ringKey',
  /** column name */
  RingNumber = 'ringNumber',
  /** column name */
  SegmentType = 'segmentType',
  /** column name */
  SerialNumber = 'serialNumber',
  /** column name */
  Status = 'status',
  /** column name */
  ToRepair = 'toRepair'
}

/** aggregate stddev on columns */
export type Quality_DefectReportView_Stddev_Fields = {
  __typename?: 'quality_defectReportView_stddev_fields';
  ringKey?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Quality_DefectReportView_Stddev_Pop_Fields = {
  __typename?: 'quality_defectReportView_stddev_pop_fields';
  ringKey?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Quality_DefectReportView_Stddev_Samp_Fields = {
  __typename?: 'quality_defectReportView_stddev_samp_fields';
  ringKey?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "quality_defectReportView" */
export type Quality_DefectReportView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_DefectReportView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_DefectReportView_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  defectAuthor?: InputMaybe<Scalars['String']['input']>;
  defectDescription?: InputMaybe<Scalars['String']['input']>;
  defectType?: InputMaybe<Scalars['String']['input']>;
  defectTypeId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicator?: InputMaybe<Scalars['String']['input']>;
  indicatorId?: InputMaybe<Scalars['uuid']['input']>;
  repairAuthor?: InputMaybe<Scalars['String']['input']>;
  repairDate?: InputMaybe<Scalars['timestamptz']['input']>;
  repairDescription?: InputMaybe<Scalars['String']['input']>;
  repairId?: InputMaybe<Scalars['uuid']['input']>;
  reportDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ringId?: InputMaybe<Scalars['uuid']['input']>;
  ringKey?: InputMaybe<Scalars['Int']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  segmentType?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  toRepair?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Quality_DefectReportView_Sum_Fields = {
  __typename?: 'quality_defectReportView_sum_fields';
  ringKey?: Maybe<Scalars['Int']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Quality_DefectReportView_Var_Pop_Fields = {
  __typename?: 'quality_defectReportView_var_pop_fields';
  ringKey?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Quality_DefectReportView_Var_Samp_Fields = {
  __typename?: 'quality_defectReportView_var_samp_fields';
  ringKey?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Quality_DefectReportView_Variance_Fields = {
  __typename?: 'quality_defectReportView_variance_fields';
  ringKey?: Maybe<Scalars['Float']['output']>;
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "quality.defectReport" */
export type Quality_DefectReport_Aggregate = {
  __typename?: 'quality_defectReport_aggregate';
  aggregate?: Maybe<Quality_DefectReport_Aggregate_Fields>;
  nodes: Array<Quality_DefectReport>;
};

/** aggregate fields of "quality.defectReport" */
export type Quality_DefectReport_Aggregate_Fields = {
  __typename?: 'quality_defectReport_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_DefectReport_Max_Fields>;
  min?: Maybe<Quality_DefectReport_Min_Fields>;
};


/** aggregate fields of "quality.defectReport" */
export type Quality_DefectReport_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_DefectReport_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Quality_DefectReport_Append_Input = {
  strokes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "quality.defectReport". All fields are combined with a logical 'AND'. */
export type Quality_DefectReport_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_DefectReport_Bool_Exp>>;
  _not?: InputMaybe<Quality_DefectReport_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_DefectReport_Bool_Exp>>;
  authorId?: InputMaybe<Uuid_Comparison_Exp>;
  boardSegmentId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  defectReportTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indicatorId?: InputMaybe<Uuid_Comparison_Exp>;
  strokes?: InputMaybe<Jsonb_Comparison_Exp>;
  submittedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  toRepair?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.defectReport" */
export enum Quality_DefectReport_Constraint {
  /** unique or primary key constraint on columns "id" */
  DefectReportPkey = 'defectReport_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Quality_DefectReport_Delete_At_Path_Input = {
  strokes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Quality_DefectReport_Delete_Elem_Input = {
  strokes?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Quality_DefectReport_Delete_Key_Input = {
  strokes?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "quality.defectReport" */
export type Quality_DefectReport_Insert_Input = {
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  boardSegmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  defectReportTypeId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorId?: InputMaybe<Scalars['uuid']['input']>;
  strokes?: InputMaybe<Scalars['jsonb']['input']>;
  submittedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  toRepair?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Quality_DefectReport_Max_Fields = {
  __typename?: 'quality_defectReport_max_fields';
  authorId?: Maybe<Scalars['uuid']['output']>;
  boardSegmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  defectReportTypeId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicatorId?: Maybe<Scalars['uuid']['output']>;
  submittedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Quality_DefectReport_Min_Fields = {
  __typename?: 'quality_defectReport_min_fields';
  authorId?: Maybe<Scalars['uuid']['output']>;
  boardSegmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  defectReportTypeId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indicatorId?: Maybe<Scalars['uuid']['output']>;
  submittedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "quality.defectReport" */
export type Quality_DefectReport_Mutation_Response = {
  __typename?: 'quality_defectReport_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_DefectReport>;
};

/** on_conflict condition type for table "quality.defectReport" */
export type Quality_DefectReport_On_Conflict = {
  constraint: Quality_DefectReport_Constraint;
  update_columns?: Array<Quality_DefectReport_Update_Column>;
  where?: InputMaybe<Quality_DefectReport_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.defectReport". */
export type Quality_DefectReport_Order_By = {
  authorId?: InputMaybe<Order_By>;
  boardSegmentId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  defectReportTypeId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indicatorId?: InputMaybe<Order_By>;
  strokes?: InputMaybe<Order_By>;
  submittedAt?: InputMaybe<Order_By>;
  toRepair?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.defectReport */
export type Quality_DefectReport_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Quality_DefectReport_Prepend_Input = {
  strokes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "quality.defectReport" */
export enum Quality_DefectReport_Select_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  BoardSegmentId = 'boardSegmentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefectReportTypeId = 'defectReportTypeId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IndicatorId = 'indicatorId',
  /** column name */
  Strokes = 'strokes',
  /** column name */
  SubmittedAt = 'submittedAt',
  /** column name */
  ToRepair = 'toRepair'
}

/** input type for updating data in table "quality.defectReport" */
export type Quality_DefectReport_Set_Input = {
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  boardSegmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  defectReportTypeId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorId?: InputMaybe<Scalars['uuid']['input']>;
  strokes?: InputMaybe<Scalars['jsonb']['input']>;
  submittedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  toRepair?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "quality_defectReport" */
export type Quality_DefectReport_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_DefectReport_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_DefectReport_Stream_Cursor_Value_Input = {
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  boardSegmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  defectReportTypeId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicatorId?: InputMaybe<Scalars['uuid']['input']>;
  strokes?: InputMaybe<Scalars['jsonb']['input']>;
  submittedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  toRepair?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "quality.defectReport" */
export enum Quality_DefectReport_Update_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  BoardSegmentId = 'boardSegmentId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefectReportTypeId = 'defectReportTypeId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IndicatorId = 'indicatorId',
  /** column name */
  Strokes = 'strokes',
  /** column name */
  SubmittedAt = 'submittedAt',
  /** column name */
  ToRepair = 'toRepair'
}

export type Quality_DefectReport_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Quality_DefectReport_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Quality_DefectReport_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Quality_DefectReport_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Quality_DefectReport_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Quality_DefectReport_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_DefectReport_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_DefectReport_Bool_Exp;
};

/** columns and relationships of "quality.importConfig" */
export type Quality_ImportConfig = {
  __typename?: 'quality_importConfig';
  /** An array relationship */
  extraColumns: Array<Quality_ImportExtraColumn>;
  /** An aggregate relationship */
  extraColumns_aggregate: Quality_ImportExtraColumn_Aggregate;
  id: Scalars['uuid']['output'];
  manufactureDateColumn: Scalars['String']['output'];
  moldColumn: Scalars['String']['output'];
  /** An object relationship */
  project?: Maybe<Project>;
  projectId: Scalars['uuid']['output'];
  segmentTypeColumn: Scalars['String']['output'];
  serialNumberColumn: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "quality.importConfig" */
export type Quality_ImportConfigExtraColumnsArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportExtraColumn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportExtraColumn_Order_By>>;
  where?: InputMaybe<Quality_ImportExtraColumn_Bool_Exp>;
};


/** columns and relationships of "quality.importConfig" */
export type Quality_ImportConfigExtraColumns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportExtraColumn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportExtraColumn_Order_By>>;
  where?: InputMaybe<Quality_ImportExtraColumn_Bool_Exp>;
};

/** aggregated selection of "quality.importConfig" */
export type Quality_ImportConfig_Aggregate = {
  __typename?: 'quality_importConfig_aggregate';
  aggregate?: Maybe<Quality_ImportConfig_Aggregate_Fields>;
  nodes: Array<Quality_ImportConfig>;
};

/** aggregate fields of "quality.importConfig" */
export type Quality_ImportConfig_Aggregate_Fields = {
  __typename?: 'quality_importConfig_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_ImportConfig_Max_Fields>;
  min?: Maybe<Quality_ImportConfig_Min_Fields>;
};


/** aggregate fields of "quality.importConfig" */
export type Quality_ImportConfig_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_ImportConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.importConfig". All fields are combined with a logical 'AND'. */
export type Quality_ImportConfig_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_ImportConfig_Bool_Exp>>;
  _not?: InputMaybe<Quality_ImportConfig_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_ImportConfig_Bool_Exp>>;
  extraColumns?: InputMaybe<Quality_ImportExtraColumn_Bool_Exp>;
  extraColumns_aggregate?: InputMaybe<Quality_ImportExtraColumn_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  manufactureDateColumn?: InputMaybe<String_Comparison_Exp>;
  moldColumn?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  segmentTypeColumn?: InputMaybe<String_Comparison_Exp>;
  serialNumberColumn?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.importConfig" */
export enum Quality_ImportConfig_Constraint {
  /** unique or primary key constraint on columns "id" */
  ImportConfigPkey = 'importConfig_pkey'
}

/** input type for inserting data into table "quality.importConfig" */
export type Quality_ImportConfig_Insert_Input = {
  extraColumns?: InputMaybe<Quality_ImportExtraColumn_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manufactureDateColumn?: InputMaybe<Scalars['String']['input']>;
  moldColumn?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  segmentTypeColumn?: InputMaybe<Scalars['String']['input']>;
  serialNumberColumn?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quality_ImportConfig_Max_Fields = {
  __typename?: 'quality_importConfig_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  manufactureDateColumn?: Maybe<Scalars['String']['output']>;
  moldColumn?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  segmentTypeColumn?: Maybe<Scalars['String']['output']>;
  serialNumberColumn?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Quality_ImportConfig_Min_Fields = {
  __typename?: 'quality_importConfig_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  manufactureDateColumn?: Maybe<Scalars['String']['output']>;
  moldColumn?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  segmentTypeColumn?: Maybe<Scalars['String']['output']>;
  serialNumberColumn?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "quality.importConfig" */
export type Quality_ImportConfig_Mutation_Response = {
  __typename?: 'quality_importConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_ImportConfig>;
};

/** input type for inserting object relation for remote table "quality.importConfig" */
export type Quality_ImportConfig_Obj_Rel_Insert_Input = {
  data: Quality_ImportConfig_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_ImportConfig_On_Conflict>;
};

/** on_conflict condition type for table "quality.importConfig" */
export type Quality_ImportConfig_On_Conflict = {
  constraint: Quality_ImportConfig_Constraint;
  update_columns?: Array<Quality_ImportConfig_Update_Column>;
  where?: InputMaybe<Quality_ImportConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.importConfig". */
export type Quality_ImportConfig_Order_By = {
  extraColumns_aggregate?: InputMaybe<Quality_ImportExtraColumn_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  manufactureDateColumn?: InputMaybe<Order_By>;
  moldColumn?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  segmentTypeColumn?: InputMaybe<Order_By>;
  serialNumberColumn?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.importConfig */
export type Quality_ImportConfig_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.importConfig" */
export enum Quality_ImportConfig_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ManufactureDateColumn = 'manufactureDateColumn',
  /** column name */
  MoldColumn = 'moldColumn',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  SegmentTypeColumn = 'segmentTypeColumn',
  /** column name */
  SerialNumberColumn = 'serialNumberColumn',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "quality.importConfig" */
export type Quality_ImportConfig_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  manufactureDateColumn?: InputMaybe<Scalars['String']['input']>;
  moldColumn?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  segmentTypeColumn?: InputMaybe<Scalars['String']['input']>;
  serialNumberColumn?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "quality_importConfig" */
export type Quality_ImportConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_ImportConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_ImportConfig_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  manufactureDateColumn?: InputMaybe<Scalars['String']['input']>;
  moldColumn?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  segmentTypeColumn?: InputMaybe<Scalars['String']['input']>;
  serialNumberColumn?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "quality.importConfig" */
export enum Quality_ImportConfig_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ManufactureDateColumn = 'manufactureDateColumn',
  /** column name */
  MoldColumn = 'moldColumn',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  SegmentTypeColumn = 'segmentTypeColumn',
  /** column name */
  SerialNumberColumn = 'serialNumberColumn',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Quality_ImportConfig_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_ImportConfig_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_ImportConfig_Bool_Exp;
};

/** columns and relationships of "quality.importExtraColumn" */
export type Quality_ImportExtraColumn = {
  __typename?: 'quality_importExtraColumn';
  columnHeader: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  importConfig?: Maybe<Quality_ImportConfig>;
  importConfigId: Scalars['uuid']['output'];
  segmentParameter: Scalars['String']['output'];
};

/** aggregated selection of "quality.importExtraColumn" */
export type Quality_ImportExtraColumn_Aggregate = {
  __typename?: 'quality_importExtraColumn_aggregate';
  aggregate?: Maybe<Quality_ImportExtraColumn_Aggregate_Fields>;
  nodes: Array<Quality_ImportExtraColumn>;
};

export type Quality_ImportExtraColumn_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quality_ImportExtraColumn_Aggregate_Bool_Exp_Count>;
};

export type Quality_ImportExtraColumn_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quality_ImportExtraColumn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_ImportExtraColumn_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quality.importExtraColumn" */
export type Quality_ImportExtraColumn_Aggregate_Fields = {
  __typename?: 'quality_importExtraColumn_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_ImportExtraColumn_Max_Fields>;
  min?: Maybe<Quality_ImportExtraColumn_Min_Fields>;
};


/** aggregate fields of "quality.importExtraColumn" */
export type Quality_ImportExtraColumn_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_ImportExtraColumn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quality.importExtraColumn" */
export type Quality_ImportExtraColumn_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quality_ImportExtraColumn_Max_Order_By>;
  min?: InputMaybe<Quality_ImportExtraColumn_Min_Order_By>;
};

/** input type for inserting array relation for remote table "quality.importExtraColumn" */
export type Quality_ImportExtraColumn_Arr_Rel_Insert_Input = {
  data: Array<Quality_ImportExtraColumn_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_ImportExtraColumn_On_Conflict>;
};

/** Boolean expression to filter rows from the table "quality.importExtraColumn". All fields are combined with a logical 'AND'. */
export type Quality_ImportExtraColumn_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_ImportExtraColumn_Bool_Exp>>;
  _not?: InputMaybe<Quality_ImportExtraColumn_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_ImportExtraColumn_Bool_Exp>>;
  columnHeader?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  importConfig?: InputMaybe<Quality_ImportConfig_Bool_Exp>;
  importConfigId?: InputMaybe<Uuid_Comparison_Exp>;
  segmentParameter?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.importExtraColumn" */
export enum Quality_ImportExtraColumn_Constraint {
  /** unique or primary key constraint on columns "id" */
  ImportExtraColumnPkey = 'importExtraColumn_pkey'
}

/** input type for inserting data into table "quality.importExtraColumn" */
export type Quality_ImportExtraColumn_Insert_Input = {
  columnHeader?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  importConfig?: InputMaybe<Quality_ImportConfig_Obj_Rel_Insert_Input>;
  importConfigId?: InputMaybe<Scalars['uuid']['input']>;
  segmentParameter?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quality_ImportExtraColumn_Max_Fields = {
  __typename?: 'quality_importExtraColumn_max_fields';
  columnHeader?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  importConfigId?: Maybe<Scalars['uuid']['output']>;
  segmentParameter?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "quality.importExtraColumn" */
export type Quality_ImportExtraColumn_Max_Order_By = {
  columnHeader?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  importConfigId?: InputMaybe<Order_By>;
  segmentParameter?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quality_ImportExtraColumn_Min_Fields = {
  __typename?: 'quality_importExtraColumn_min_fields';
  columnHeader?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  importConfigId?: Maybe<Scalars['uuid']['output']>;
  segmentParameter?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "quality.importExtraColumn" */
export type Quality_ImportExtraColumn_Min_Order_By = {
  columnHeader?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  importConfigId?: InputMaybe<Order_By>;
  segmentParameter?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quality.importExtraColumn" */
export type Quality_ImportExtraColumn_Mutation_Response = {
  __typename?: 'quality_importExtraColumn_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_ImportExtraColumn>;
};

/** on_conflict condition type for table "quality.importExtraColumn" */
export type Quality_ImportExtraColumn_On_Conflict = {
  constraint: Quality_ImportExtraColumn_Constraint;
  update_columns?: Array<Quality_ImportExtraColumn_Update_Column>;
  where?: InputMaybe<Quality_ImportExtraColumn_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.importExtraColumn". */
export type Quality_ImportExtraColumn_Order_By = {
  columnHeader?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  importConfig?: InputMaybe<Quality_ImportConfig_Order_By>;
  importConfigId?: InputMaybe<Order_By>;
  segmentParameter?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.importExtraColumn */
export type Quality_ImportExtraColumn_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.importExtraColumn" */
export enum Quality_ImportExtraColumn_Select_Column {
  /** column name */
  ColumnHeader = 'columnHeader',
  /** column name */
  Id = 'id',
  /** column name */
  ImportConfigId = 'importConfigId',
  /** column name */
  SegmentParameter = 'segmentParameter'
}

/** input type for updating data in table "quality.importExtraColumn" */
export type Quality_ImportExtraColumn_Set_Input = {
  columnHeader?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  importConfigId?: InputMaybe<Scalars['uuid']['input']>;
  segmentParameter?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quality_importExtraColumn" */
export type Quality_ImportExtraColumn_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_ImportExtraColumn_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_ImportExtraColumn_Stream_Cursor_Value_Input = {
  columnHeader?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  importConfigId?: InputMaybe<Scalars['uuid']['input']>;
  segmentParameter?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quality.importExtraColumn" */
export enum Quality_ImportExtraColumn_Update_Column {
  /** column name */
  ColumnHeader = 'columnHeader',
  /** column name */
  Id = 'id',
  /** column name */
  ImportConfigId = 'importConfigId',
  /** column name */
  SegmentParameter = 'segmentParameter'
}

export type Quality_ImportExtraColumn_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_ImportExtraColumn_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_ImportExtraColumn_Bool_Exp;
};

/** columns and relationships of "quality.importTask" */
export type Quality_ImportTask = {
  __typename?: 'quality_importTask';
  createdAt: Scalars['timestamptz']['output'];
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  projectId: Scalars['uuid']['output'];
  segmentCreated: Scalars['Int']['output'];
  segmentFailed: Scalars['Int']['output'];
  segmentUpdated: Scalars['Int']['output'];
  warnings?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "quality.importTask" */
export type Quality_ImportTaskWarningsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "quality.importTask" */
export type Quality_ImportTask_Aggregate = {
  __typename?: 'quality_importTask_aggregate';
  aggregate?: Maybe<Quality_ImportTask_Aggregate_Fields>;
  nodes: Array<Quality_ImportTask>;
};

/** aggregate fields of "quality.importTask" */
export type Quality_ImportTask_Aggregate_Fields = {
  __typename?: 'quality_importTask_aggregate_fields';
  avg?: Maybe<Quality_ImportTask_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_ImportTask_Max_Fields>;
  min?: Maybe<Quality_ImportTask_Min_Fields>;
  stddev?: Maybe<Quality_ImportTask_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_ImportTask_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_ImportTask_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_ImportTask_Sum_Fields>;
  var_pop?: Maybe<Quality_ImportTask_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_ImportTask_Var_Samp_Fields>;
  variance?: Maybe<Quality_ImportTask_Variance_Fields>;
};


/** aggregate fields of "quality.importTask" */
export type Quality_ImportTask_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_ImportTask_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Quality_ImportTask_Append_Input = {
  warnings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Quality_ImportTask_Avg_Fields = {
  __typename?: 'quality_importTask_avg_fields';
  segmentCreated?: Maybe<Scalars['Float']['output']>;
  segmentFailed?: Maybe<Scalars['Float']['output']>;
  segmentUpdated?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "quality.importTask". All fields are combined with a logical 'AND'. */
export type Quality_ImportTask_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_ImportTask_Bool_Exp>>;
  _not?: InputMaybe<Quality_ImportTask_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_ImportTask_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  segmentCreated?: InputMaybe<Int_Comparison_Exp>;
  segmentFailed?: InputMaybe<Int_Comparison_Exp>;
  segmentUpdated?: InputMaybe<Int_Comparison_Exp>;
  warnings?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.importTask" */
export enum Quality_ImportTask_Constraint {
  /** unique or primary key constraint on columns "id" */
  ImportTaskPkey = 'importTask_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Quality_ImportTask_Delete_At_Path_Input = {
  warnings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Quality_ImportTask_Delete_Elem_Input = {
  warnings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Quality_ImportTask_Delete_Key_Input = {
  warnings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "quality.importTask" */
export type Quality_ImportTask_Inc_Input = {
  segmentCreated?: InputMaybe<Scalars['Int']['input']>;
  segmentFailed?: InputMaybe<Scalars['Int']['input']>;
  segmentUpdated?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quality.importTask" */
export type Quality_ImportTask_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  segmentCreated?: InputMaybe<Scalars['Int']['input']>;
  segmentFailed?: InputMaybe<Scalars['Int']['input']>;
  segmentUpdated?: InputMaybe<Scalars['Int']['input']>;
  warnings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Quality_ImportTask_Max_Fields = {
  __typename?: 'quality_importTask_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  segmentCreated?: Maybe<Scalars['Int']['output']>;
  segmentFailed?: Maybe<Scalars['Int']['output']>;
  segmentUpdated?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Quality_ImportTask_Min_Fields = {
  __typename?: 'quality_importTask_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  segmentCreated?: Maybe<Scalars['Int']['output']>;
  segmentFailed?: Maybe<Scalars['Int']['output']>;
  segmentUpdated?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "quality.importTask" */
export type Quality_ImportTask_Mutation_Response = {
  __typename?: 'quality_importTask_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_ImportTask>;
};

/** on_conflict condition type for table "quality.importTask" */
export type Quality_ImportTask_On_Conflict = {
  constraint: Quality_ImportTask_Constraint;
  update_columns?: Array<Quality_ImportTask_Update_Column>;
  where?: InputMaybe<Quality_ImportTask_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.importTask". */
export type Quality_ImportTask_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  segmentCreated?: InputMaybe<Order_By>;
  segmentFailed?: InputMaybe<Order_By>;
  segmentUpdated?: InputMaybe<Order_By>;
  warnings?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.importTask */
export type Quality_ImportTask_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Quality_ImportTask_Prepend_Input = {
  warnings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "quality.importTask" */
export enum Quality_ImportTask_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  SegmentCreated = 'segmentCreated',
  /** column name */
  SegmentFailed = 'segmentFailed',
  /** column name */
  SegmentUpdated = 'segmentUpdated',
  /** column name */
  Warnings = 'warnings'
}

/** input type for updating data in table "quality.importTask" */
export type Quality_ImportTask_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  segmentCreated?: InputMaybe<Scalars['Int']['input']>;
  segmentFailed?: InputMaybe<Scalars['Int']['input']>;
  segmentUpdated?: InputMaybe<Scalars['Int']['input']>;
  warnings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Quality_ImportTask_Stddev_Fields = {
  __typename?: 'quality_importTask_stddev_fields';
  segmentCreated?: Maybe<Scalars['Float']['output']>;
  segmentFailed?: Maybe<Scalars['Float']['output']>;
  segmentUpdated?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Quality_ImportTask_Stddev_Pop_Fields = {
  __typename?: 'quality_importTask_stddev_pop_fields';
  segmentCreated?: Maybe<Scalars['Float']['output']>;
  segmentFailed?: Maybe<Scalars['Float']['output']>;
  segmentUpdated?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Quality_ImportTask_Stddev_Samp_Fields = {
  __typename?: 'quality_importTask_stddev_samp_fields';
  segmentCreated?: Maybe<Scalars['Float']['output']>;
  segmentFailed?: Maybe<Scalars['Float']['output']>;
  segmentUpdated?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "quality_importTask" */
export type Quality_ImportTask_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_ImportTask_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_ImportTask_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  segmentCreated?: InputMaybe<Scalars['Int']['input']>;
  segmentFailed?: InputMaybe<Scalars['Int']['input']>;
  segmentUpdated?: InputMaybe<Scalars['Int']['input']>;
  warnings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Quality_ImportTask_Sum_Fields = {
  __typename?: 'quality_importTask_sum_fields';
  segmentCreated?: Maybe<Scalars['Int']['output']>;
  segmentFailed?: Maybe<Scalars['Int']['output']>;
  segmentUpdated?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "quality.importTask" */
export enum Quality_ImportTask_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  SegmentCreated = 'segmentCreated',
  /** column name */
  SegmentFailed = 'segmentFailed',
  /** column name */
  SegmentUpdated = 'segmentUpdated',
  /** column name */
  Warnings = 'warnings'
}

export type Quality_ImportTask_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Quality_ImportTask_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Quality_ImportTask_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Quality_ImportTask_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Quality_ImportTask_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quality_ImportTask_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Quality_ImportTask_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_ImportTask_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_ImportTask_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quality_ImportTask_Var_Pop_Fields = {
  __typename?: 'quality_importTask_var_pop_fields';
  segmentCreated?: Maybe<Scalars['Float']['output']>;
  segmentFailed?: Maybe<Scalars['Float']['output']>;
  segmentUpdated?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Quality_ImportTask_Var_Samp_Fields = {
  __typename?: 'quality_importTask_var_samp_fields';
  segmentCreated?: Maybe<Scalars['Float']['output']>;
  segmentFailed?: Maybe<Scalars['Float']['output']>;
  segmentUpdated?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Quality_ImportTask_Variance_Fields = {
  __typename?: 'quality_importTask_variance_fields';
  segmentCreated?: Maybe<Scalars['Float']['output']>;
  segmentFailed?: Maybe<Scalars['Float']['output']>;
  segmentUpdated?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "quality.indicator" */
export type Quality_Indicator = {
  __typename?: 'quality_indicator';
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  isHidden: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

/** aggregated selection of "quality.indicator" */
export type Quality_Indicator_Aggregate = {
  __typename?: 'quality_indicator_aggregate';
  aggregate?: Maybe<Quality_Indicator_Aggregate_Fields>;
  nodes: Array<Quality_Indicator>;
};

/** aggregate fields of "quality.indicator" */
export type Quality_Indicator_Aggregate_Fields = {
  __typename?: 'quality_indicator_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_Indicator_Max_Fields>;
  min?: Maybe<Quality_Indicator_Min_Fields>;
};


/** aggregate fields of "quality.indicator" */
export type Quality_Indicator_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_Indicator_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.indicator". All fields are combined with a logical 'AND'. */
export type Quality_Indicator_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_Indicator_Bool_Exp>>;
  _not?: InputMaybe<Quality_Indicator_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_Indicator_Bool_Exp>>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.indicator" */
export enum Quality_Indicator_Constraint {
  /** unique or primary key constraint on columns "id" */
  IndicatorPkey = 'indicator_pkey'
}

/** input type for inserting data into table "quality.indicator" */
export type Quality_Indicator_Insert_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quality_Indicator_Max_Fields = {
  __typename?: 'quality_indicator_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quality_Indicator_Min_Fields = {
  __typename?: 'quality_indicator_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quality.indicator" */
export type Quality_Indicator_Mutation_Response = {
  __typename?: 'quality_indicator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_Indicator>;
};

/** on_conflict condition type for table "quality.indicator" */
export type Quality_Indicator_On_Conflict = {
  constraint: Quality_Indicator_Constraint;
  update_columns?: Array<Quality_Indicator_Update_Column>;
  where?: InputMaybe<Quality_Indicator_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.indicator". */
export type Quality_Indicator_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isHidden?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.indicator */
export type Quality_Indicator_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.indicator" */
export enum Quality_Indicator_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Label = 'label'
}

/** input type for updating data in table "quality.indicator" */
export type Quality_Indicator_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quality_indicator" */
export type Quality_Indicator_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_Indicator_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_Indicator_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quality.indicator" */
export enum Quality_Indicator_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Label = 'label'
}

export type Quality_Indicator_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_Indicator_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_Indicator_Bool_Exp;
};

/** columns and relationships of "quality.quarantineDefect" */
export type Quality_QuarantineDefect = {
  __typename?: 'quality_quarantineDefect';
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  orientation: Quality_QuarantineDefectOrientationEnum_Enum;
  positionX: Scalars['float8']['output'];
  positionY: Scalars['float8']['output'];
  /** An object relationship */
  quarantineDefectType?: Maybe<Quality_QuarantineDefectType>;
  quarantineDefectTypeId: Scalars['uuid']['output'];
  /** An object relationship */
  repair?: Maybe<Quality_DefectRepair>;
  segmentHistoryId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** columns and relationships of "quality.quarantineDefectOrientationEnum" */
export type Quality_QuarantineDefectOrientationEnum = {
  __typename?: 'quality_quarantineDefectOrientationEnum';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

/** aggregated selection of "quality.quarantineDefectOrientationEnum" */
export type Quality_QuarantineDefectOrientationEnum_Aggregate = {
  __typename?: 'quality_quarantineDefectOrientationEnum_aggregate';
  aggregate?: Maybe<Quality_QuarantineDefectOrientationEnum_Aggregate_Fields>;
  nodes: Array<Quality_QuarantineDefectOrientationEnum>;
};

/** aggregate fields of "quality.quarantineDefectOrientationEnum" */
export type Quality_QuarantineDefectOrientationEnum_Aggregate_Fields = {
  __typename?: 'quality_quarantineDefectOrientationEnum_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_QuarantineDefectOrientationEnum_Max_Fields>;
  min?: Maybe<Quality_QuarantineDefectOrientationEnum_Min_Fields>;
};


/** aggregate fields of "quality.quarantineDefectOrientationEnum" */
export type Quality_QuarantineDefectOrientationEnum_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_QuarantineDefectOrientationEnum_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.quarantineDefectOrientationEnum". All fields are combined with a logical 'AND'. */
export type Quality_QuarantineDefectOrientationEnum_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_QuarantineDefectOrientationEnum_Bool_Exp>>;
  _not?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_QuarantineDefectOrientationEnum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.quarantineDefectOrientationEnum" */
export enum Quality_QuarantineDefectOrientationEnum_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuarantineDefectOrientationEnumPkey = 'quarantineDefectOrientationEnum_pkey'
}

export enum Quality_QuarantineDefectOrientationEnum_Enum {
  Down = 'DOWN',
  Up = 'UP'
}

/** Boolean expression to compare columns of type "quality_quarantineDefectOrientationEnum_enum". All fields are combined with logical 'AND'. */
export type Quality_QuarantineDefectOrientationEnum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Enum>;
  _in?: InputMaybe<Array<Quality_QuarantineDefectOrientationEnum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Enum>;
  _nin?: InputMaybe<Array<Quality_QuarantineDefectOrientationEnum_Enum>>;
};

/** input type for inserting data into table "quality.quarantineDefectOrientationEnum" */
export type Quality_QuarantineDefectOrientationEnum_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quality_QuarantineDefectOrientationEnum_Max_Fields = {
  __typename?: 'quality_quarantineDefectOrientationEnum_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quality_QuarantineDefectOrientationEnum_Min_Fields = {
  __typename?: 'quality_quarantineDefectOrientationEnum_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quality.quarantineDefectOrientationEnum" */
export type Quality_QuarantineDefectOrientationEnum_Mutation_Response = {
  __typename?: 'quality_quarantineDefectOrientationEnum_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_QuarantineDefectOrientationEnum>;
};

/** on_conflict condition type for table "quality.quarantineDefectOrientationEnum" */
export type Quality_QuarantineDefectOrientationEnum_On_Conflict = {
  constraint: Quality_QuarantineDefectOrientationEnum_Constraint;
  update_columns?: Array<Quality_QuarantineDefectOrientationEnum_Update_Column>;
  where?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.quarantineDefectOrientationEnum". */
export type Quality_QuarantineDefectOrientationEnum_Order_By = {
  comment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.quarantineDefectOrientationEnum */
export type Quality_QuarantineDefectOrientationEnum_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "quality.quarantineDefectOrientationEnum" */
export enum Quality_QuarantineDefectOrientationEnum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "quality.quarantineDefectOrientationEnum" */
export type Quality_QuarantineDefectOrientationEnum_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quality_quarantineDefectOrientationEnum" */
export type Quality_QuarantineDefectOrientationEnum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_QuarantineDefectOrientationEnum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_QuarantineDefectOrientationEnum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quality.quarantineDefectOrientationEnum" */
export enum Quality_QuarantineDefectOrientationEnum_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

export type Quality_QuarantineDefectOrientationEnum_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_QuarantineDefectOrientationEnum_Bool_Exp;
};

/** columns and relationships of "quality.quarantineDefectPicture" */
export type Quality_QuarantineDefectPicture = {
  __typename?: 'quality_quarantineDefectPicture';
  bucketFileId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  quarantineDefectId: Scalars['uuid']['output'];
};

/** aggregated selection of "quality.quarantineDefectPicture" */
export type Quality_QuarantineDefectPicture_Aggregate = {
  __typename?: 'quality_quarantineDefectPicture_aggregate';
  aggregate?: Maybe<Quality_QuarantineDefectPicture_Aggregate_Fields>;
  nodes: Array<Quality_QuarantineDefectPicture>;
};

/** aggregate fields of "quality.quarantineDefectPicture" */
export type Quality_QuarantineDefectPicture_Aggregate_Fields = {
  __typename?: 'quality_quarantineDefectPicture_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_QuarantineDefectPicture_Max_Fields>;
  min?: Maybe<Quality_QuarantineDefectPicture_Min_Fields>;
};


/** aggregate fields of "quality.quarantineDefectPicture" */
export type Quality_QuarantineDefectPicture_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_QuarantineDefectPicture_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.quarantineDefectPicture". All fields are combined with a logical 'AND'. */
export type Quality_QuarantineDefectPicture_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_QuarantineDefectPicture_Bool_Exp>>;
  _not?: InputMaybe<Quality_QuarantineDefectPicture_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_QuarantineDefectPicture_Bool_Exp>>;
  bucketFileId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  quarantineDefectId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.quarantineDefectPicture" */
export enum Quality_QuarantineDefectPicture_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuarantineDefectPicturePkey = 'quarantineDefectPicture_pkey'
}

/** input type for inserting data into table "quality.quarantineDefectPicture" */
export type Quality_QuarantineDefectPicture_Insert_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quarantineDefectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Quality_QuarantineDefectPicture_Max_Fields = {
  __typename?: 'quality_quarantineDefectPicture_max_fields';
  bucketFileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quarantineDefectId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Quality_QuarantineDefectPicture_Min_Fields = {
  __typename?: 'quality_quarantineDefectPicture_min_fields';
  bucketFileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quarantineDefectId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "quality.quarantineDefectPicture" */
export type Quality_QuarantineDefectPicture_Mutation_Response = {
  __typename?: 'quality_quarantineDefectPicture_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_QuarantineDefectPicture>;
};

/** on_conflict condition type for table "quality.quarantineDefectPicture" */
export type Quality_QuarantineDefectPicture_On_Conflict = {
  constraint: Quality_QuarantineDefectPicture_Constraint;
  update_columns?: Array<Quality_QuarantineDefectPicture_Update_Column>;
  where?: InputMaybe<Quality_QuarantineDefectPicture_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.quarantineDefectPicture". */
export type Quality_QuarantineDefectPicture_Order_By = {
  bucketFileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quarantineDefectId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.quarantineDefectPicture */
export type Quality_QuarantineDefectPicture_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.quarantineDefectPicture" */
export enum Quality_QuarantineDefectPicture_Select_Column {
  /** column name */
  BucketFileId = 'bucketFileId',
  /** column name */
  Id = 'id',
  /** column name */
  QuarantineDefectId = 'quarantineDefectId'
}

/** input type for updating data in table "quality.quarantineDefectPicture" */
export type Quality_QuarantineDefectPicture_Set_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quarantineDefectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "quality_quarantineDefectPicture" */
export type Quality_QuarantineDefectPicture_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_QuarantineDefectPicture_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_QuarantineDefectPicture_Stream_Cursor_Value_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  quarantineDefectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "quality.quarantineDefectPicture" */
export enum Quality_QuarantineDefectPicture_Update_Column {
  /** column name */
  BucketFileId = 'bucketFileId',
  /** column name */
  Id = 'id',
  /** column name */
  QuarantineDefectId = 'quarantineDefectId'
}

export type Quality_QuarantineDefectPicture_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_QuarantineDefectPicture_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_QuarantineDefectPicture_Bool_Exp;
};

/** columns and relationships of "quality.quarantineDefectType" */
export type Quality_QuarantineDefectType = {
  __typename?: 'quality_quarantineDefectType';
  id: Scalars['uuid']['output'];
  isHidden: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  projectId: Scalars['uuid']['output'];
};

/** aggregated selection of "quality.quarantineDefectType" */
export type Quality_QuarantineDefectType_Aggregate = {
  __typename?: 'quality_quarantineDefectType_aggregate';
  aggregate?: Maybe<Quality_QuarantineDefectType_Aggregate_Fields>;
  nodes: Array<Quality_QuarantineDefectType>;
};

/** aggregate fields of "quality.quarantineDefectType" */
export type Quality_QuarantineDefectType_Aggregate_Fields = {
  __typename?: 'quality_quarantineDefectType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_QuarantineDefectType_Max_Fields>;
  min?: Maybe<Quality_QuarantineDefectType_Min_Fields>;
};


/** aggregate fields of "quality.quarantineDefectType" */
export type Quality_QuarantineDefectType_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_QuarantineDefectType_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.quarantineDefectType". All fields are combined with a logical 'AND'. */
export type Quality_QuarantineDefectType_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_QuarantineDefectType_Bool_Exp>>;
  _not?: InputMaybe<Quality_QuarantineDefectType_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_QuarantineDefectType_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.quarantineDefectType" */
export enum Quality_QuarantineDefectType_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuarantineDefectTypePkey = 'quarantineDefectType_pkey'
}

/** input type for inserting data into table "quality.quarantineDefectType" */
export type Quality_QuarantineDefectType_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Quality_QuarantineDefectType_Max_Fields = {
  __typename?: 'quality_quarantineDefectType_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Quality_QuarantineDefectType_Min_Fields = {
  __typename?: 'quality_quarantineDefectType_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "quality.quarantineDefectType" */
export type Quality_QuarantineDefectType_Mutation_Response = {
  __typename?: 'quality_quarantineDefectType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_QuarantineDefectType>;
};

/** input type for inserting object relation for remote table "quality.quarantineDefectType" */
export type Quality_QuarantineDefectType_Obj_Rel_Insert_Input = {
  data: Quality_QuarantineDefectType_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_QuarantineDefectType_On_Conflict>;
};

/** on_conflict condition type for table "quality.quarantineDefectType" */
export type Quality_QuarantineDefectType_On_Conflict = {
  constraint: Quality_QuarantineDefectType_Constraint;
  update_columns?: Array<Quality_QuarantineDefectType_Update_Column>;
  where?: InputMaybe<Quality_QuarantineDefectType_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.quarantineDefectType". */
export type Quality_QuarantineDefectType_Order_By = {
  id?: InputMaybe<Order_By>;
  isHidden?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.quarantineDefectType */
export type Quality_QuarantineDefectType_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.quarantineDefectType" */
export enum Quality_QuarantineDefectType_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Label = 'label',
  /** column name */
  ProjectId = 'projectId'
}

/** input type for updating data in table "quality.quarantineDefectType" */
export type Quality_QuarantineDefectType_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "quality_quarantineDefectType" */
export type Quality_QuarantineDefectType_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_QuarantineDefectType_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_QuarantineDefectType_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "quality.quarantineDefectType" */
export enum Quality_QuarantineDefectType_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Label = 'label',
  /** column name */
  ProjectId = 'projectId'
}

export type Quality_QuarantineDefectType_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_QuarantineDefectType_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_QuarantineDefectType_Bool_Exp;
};

/** aggregated selection of "quality.quarantineDefect" */
export type Quality_QuarantineDefect_Aggregate = {
  __typename?: 'quality_quarantineDefect_aggregate';
  aggregate?: Maybe<Quality_QuarantineDefect_Aggregate_Fields>;
  nodes: Array<Quality_QuarantineDefect>;
};

/** aggregate fields of "quality.quarantineDefect" */
export type Quality_QuarantineDefect_Aggregate_Fields = {
  __typename?: 'quality_quarantineDefect_aggregate_fields';
  avg?: Maybe<Quality_QuarantineDefect_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_QuarantineDefect_Max_Fields>;
  min?: Maybe<Quality_QuarantineDefect_Min_Fields>;
  stddev?: Maybe<Quality_QuarantineDefect_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_QuarantineDefect_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_QuarantineDefect_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_QuarantineDefect_Sum_Fields>;
  var_pop?: Maybe<Quality_QuarantineDefect_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_QuarantineDefect_Var_Samp_Fields>;
  variance?: Maybe<Quality_QuarantineDefect_Variance_Fields>;
};


/** aggregate fields of "quality.quarantineDefect" */
export type Quality_QuarantineDefect_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_QuarantineDefect_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Quality_QuarantineDefect_Avg_Fields = {
  __typename?: 'quality_quarantineDefect_avg_fields';
  positionX?: Maybe<Scalars['Float']['output']>;
  positionY?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "quality.quarantineDefect". All fields are combined with a logical 'AND'. */
export type Quality_QuarantineDefect_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_QuarantineDefect_Bool_Exp>>;
  _not?: InputMaybe<Quality_QuarantineDefect_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_QuarantineDefect_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orientation?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Enum_Comparison_Exp>;
  positionX?: InputMaybe<Float8_Comparison_Exp>;
  positionY?: InputMaybe<Float8_Comparison_Exp>;
  quarantineDefectType?: InputMaybe<Quality_QuarantineDefectType_Bool_Exp>;
  quarantineDefectTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  repair?: InputMaybe<Quality_DefectRepair_Bool_Exp>;
  segmentHistoryId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.quarantineDefect" */
export enum Quality_QuarantineDefect_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuarantineDefectPkey = 'quarantineDefect_pkey'
}

/** input type for incrementing numeric columns in table "quality.quarantineDefect" */
export type Quality_QuarantineDefect_Inc_Input = {
  positionX?: InputMaybe<Scalars['float8']['input']>;
  positionY?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "quality.quarantineDefect" */
export type Quality_QuarantineDefect_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  orientation?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Enum>;
  positionX?: InputMaybe<Scalars['float8']['input']>;
  positionY?: InputMaybe<Scalars['float8']['input']>;
  quarantineDefectType?: InputMaybe<Quality_QuarantineDefectType_Obj_Rel_Insert_Input>;
  quarantineDefectTypeId?: InputMaybe<Scalars['uuid']['input']>;
  repair?: InputMaybe<Quality_DefectRepair_Obj_Rel_Insert_Input>;
  segmentHistoryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quality_QuarantineDefect_Max_Fields = {
  __typename?: 'quality_quarantineDefect_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  positionX?: Maybe<Scalars['float8']['output']>;
  positionY?: Maybe<Scalars['float8']['output']>;
  quarantineDefectTypeId?: Maybe<Scalars['uuid']['output']>;
  segmentHistoryId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Quality_QuarantineDefect_Min_Fields = {
  __typename?: 'quality_quarantineDefect_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  positionX?: Maybe<Scalars['float8']['output']>;
  positionY?: Maybe<Scalars['float8']['output']>;
  quarantineDefectTypeId?: Maybe<Scalars['uuid']['output']>;
  segmentHistoryId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "quality.quarantineDefect" */
export type Quality_QuarantineDefect_Mutation_Response = {
  __typename?: 'quality_quarantineDefect_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_QuarantineDefect>;
};

/** input type for inserting object relation for remote table "quality.quarantineDefect" */
export type Quality_QuarantineDefect_Obj_Rel_Insert_Input = {
  data: Quality_QuarantineDefect_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_QuarantineDefect_On_Conflict>;
};

/** on_conflict condition type for table "quality.quarantineDefect" */
export type Quality_QuarantineDefect_On_Conflict = {
  constraint: Quality_QuarantineDefect_Constraint;
  update_columns?: Array<Quality_QuarantineDefect_Update_Column>;
  where?: InputMaybe<Quality_QuarantineDefect_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.quarantineDefect". */
export type Quality_QuarantineDefect_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orientation?: InputMaybe<Order_By>;
  positionX?: InputMaybe<Order_By>;
  positionY?: InputMaybe<Order_By>;
  quarantineDefectType?: InputMaybe<Quality_QuarantineDefectType_Order_By>;
  quarantineDefectTypeId?: InputMaybe<Order_By>;
  repair?: InputMaybe<Quality_DefectRepair_Order_By>;
  segmentHistoryId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.quarantineDefect */
export type Quality_QuarantineDefect_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.quarantineDefect" */
export enum Quality_QuarantineDefect_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Orientation = 'orientation',
  /** column name */
  PositionX = 'positionX',
  /** column name */
  PositionY = 'positionY',
  /** column name */
  QuarantineDefectTypeId = 'quarantineDefectTypeId',
  /** column name */
  SegmentHistoryId = 'segmentHistoryId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "quality.quarantineDefect" */
export type Quality_QuarantineDefect_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  orientation?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Enum>;
  positionX?: InputMaybe<Scalars['float8']['input']>;
  positionY?: InputMaybe<Scalars['float8']['input']>;
  quarantineDefectTypeId?: InputMaybe<Scalars['uuid']['input']>;
  segmentHistoryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Quality_QuarantineDefect_Stddev_Fields = {
  __typename?: 'quality_quarantineDefect_stddev_fields';
  positionX?: Maybe<Scalars['Float']['output']>;
  positionY?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Quality_QuarantineDefect_Stddev_Pop_Fields = {
  __typename?: 'quality_quarantineDefect_stddev_pop_fields';
  positionX?: Maybe<Scalars['Float']['output']>;
  positionY?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Quality_QuarantineDefect_Stddev_Samp_Fields = {
  __typename?: 'quality_quarantineDefect_stddev_samp_fields';
  positionX?: Maybe<Scalars['Float']['output']>;
  positionY?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "quality_quarantineDefect" */
export type Quality_QuarantineDefect_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_QuarantineDefect_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_QuarantineDefect_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  orientation?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Enum>;
  positionX?: InputMaybe<Scalars['float8']['input']>;
  positionY?: InputMaybe<Scalars['float8']['input']>;
  quarantineDefectTypeId?: InputMaybe<Scalars['uuid']['input']>;
  segmentHistoryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Quality_QuarantineDefect_Sum_Fields = {
  __typename?: 'quality_quarantineDefect_sum_fields';
  positionX?: Maybe<Scalars['float8']['output']>;
  positionY?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "quality.quarantineDefect" */
export enum Quality_QuarantineDefect_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Orientation = 'orientation',
  /** column name */
  PositionX = 'positionX',
  /** column name */
  PositionY = 'positionY',
  /** column name */
  QuarantineDefectTypeId = 'quarantineDefectTypeId',
  /** column name */
  SegmentHistoryId = 'segmentHistoryId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Quality_QuarantineDefect_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quality_QuarantineDefect_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_QuarantineDefect_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_QuarantineDefect_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quality_QuarantineDefect_Var_Pop_Fields = {
  __typename?: 'quality_quarantineDefect_var_pop_fields';
  positionX?: Maybe<Scalars['Float']['output']>;
  positionY?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Quality_QuarantineDefect_Var_Samp_Fields = {
  __typename?: 'quality_quarantineDefect_var_samp_fields';
  positionX?: Maybe<Scalars['Float']['output']>;
  positionY?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Quality_QuarantineDefect_Variance_Fields = {
  __typename?: 'quality_quarantineDefect_variance_fields';
  positionX?: Maybe<Scalars['Float']['output']>;
  positionY?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "quality.repairReport" */
export type Quality_RepairReport = {
  __typename?: 'quality_repairReport';
  authorId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  defectReportId: Scalars['uuid']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  submittedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** columns and relationships of "quality.repairReportPicture" */
export type Quality_RepairReportPicture = {
  __typename?: 'quality_repairReportPicture';
  bucketFileId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  repairReportId: Scalars['uuid']['output'];
};

/** aggregated selection of "quality.repairReportPicture" */
export type Quality_RepairReportPicture_Aggregate = {
  __typename?: 'quality_repairReportPicture_aggregate';
  aggregate?: Maybe<Quality_RepairReportPicture_Aggregate_Fields>;
  nodes: Array<Quality_RepairReportPicture>;
};

/** aggregate fields of "quality.repairReportPicture" */
export type Quality_RepairReportPicture_Aggregate_Fields = {
  __typename?: 'quality_repairReportPicture_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_RepairReportPicture_Max_Fields>;
  min?: Maybe<Quality_RepairReportPicture_Min_Fields>;
};


/** aggregate fields of "quality.repairReportPicture" */
export type Quality_RepairReportPicture_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_RepairReportPicture_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.repairReportPicture". All fields are combined with a logical 'AND'. */
export type Quality_RepairReportPicture_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_RepairReportPicture_Bool_Exp>>;
  _not?: InputMaybe<Quality_RepairReportPicture_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_RepairReportPicture_Bool_Exp>>;
  bucketFileId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  repairReportId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.repairReportPicture" */
export enum Quality_RepairReportPicture_Constraint {
  /** unique or primary key constraint on columns "id" */
  RepairReportPicturePkey = 'repairReportPicture_pkey'
}

/** input type for inserting data into table "quality.repairReportPicture" */
export type Quality_RepairReportPicture_Insert_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  repairReportId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Quality_RepairReportPicture_Max_Fields = {
  __typename?: 'quality_repairReportPicture_max_fields';
  bucketFileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  repairReportId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Quality_RepairReportPicture_Min_Fields = {
  __typename?: 'quality_repairReportPicture_min_fields';
  bucketFileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  repairReportId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "quality.repairReportPicture" */
export type Quality_RepairReportPicture_Mutation_Response = {
  __typename?: 'quality_repairReportPicture_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_RepairReportPicture>;
};

/** on_conflict condition type for table "quality.repairReportPicture" */
export type Quality_RepairReportPicture_On_Conflict = {
  constraint: Quality_RepairReportPicture_Constraint;
  update_columns?: Array<Quality_RepairReportPicture_Update_Column>;
  where?: InputMaybe<Quality_RepairReportPicture_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.repairReportPicture". */
export type Quality_RepairReportPicture_Order_By = {
  bucketFileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  repairReportId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.repairReportPicture */
export type Quality_RepairReportPicture_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.repairReportPicture" */
export enum Quality_RepairReportPicture_Select_Column {
  /** column name */
  BucketFileId = 'bucketFileId',
  /** column name */
  Id = 'id',
  /** column name */
  RepairReportId = 'repairReportId'
}

/** input type for updating data in table "quality.repairReportPicture" */
export type Quality_RepairReportPicture_Set_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  repairReportId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "quality_repairReportPicture" */
export type Quality_RepairReportPicture_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_RepairReportPicture_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_RepairReportPicture_Stream_Cursor_Value_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  repairReportId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "quality.repairReportPicture" */
export enum Quality_RepairReportPicture_Update_Column {
  /** column name */
  BucketFileId = 'bucketFileId',
  /** column name */
  Id = 'id',
  /** column name */
  RepairReportId = 'repairReportId'
}

export type Quality_RepairReportPicture_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_RepairReportPicture_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_RepairReportPicture_Bool_Exp;
};

/** aggregated selection of "quality.repairReport" */
export type Quality_RepairReport_Aggregate = {
  __typename?: 'quality_repairReport_aggregate';
  aggregate?: Maybe<Quality_RepairReport_Aggregate_Fields>;
  nodes: Array<Quality_RepairReport>;
};

/** aggregate fields of "quality.repairReport" */
export type Quality_RepairReport_Aggregate_Fields = {
  __typename?: 'quality_repairReport_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_RepairReport_Max_Fields>;
  min?: Maybe<Quality_RepairReport_Min_Fields>;
};


/** aggregate fields of "quality.repairReport" */
export type Quality_RepairReport_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_RepairReport_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.repairReport". All fields are combined with a logical 'AND'. */
export type Quality_RepairReport_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_RepairReport_Bool_Exp>>;
  _not?: InputMaybe<Quality_RepairReport_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_RepairReport_Bool_Exp>>;
  authorId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  defectReportId?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  submittedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.repairReport" */
export enum Quality_RepairReport_Constraint {
  /** unique or primary key constraint on columns "defectReportId" */
  RepairReportDefectReportIdKey = 'repairReport_defectReportId_key',
  /** unique or primary key constraint on columns "id" */
  RepairReportPkey = 'repairReport_pkey'
}

/** input type for inserting data into table "quality.repairReport" */
export type Quality_RepairReport_Insert_Input = {
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  defectReportId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  submittedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quality_RepairReport_Max_Fields = {
  __typename?: 'quality_repairReport_max_fields';
  authorId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  defectReportId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  submittedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Quality_RepairReport_Min_Fields = {
  __typename?: 'quality_repairReport_min_fields';
  authorId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  defectReportId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  submittedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "quality.repairReport" */
export type Quality_RepairReport_Mutation_Response = {
  __typename?: 'quality_repairReport_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_RepairReport>;
};

/** on_conflict condition type for table "quality.repairReport" */
export type Quality_RepairReport_On_Conflict = {
  constraint: Quality_RepairReport_Constraint;
  update_columns?: Array<Quality_RepairReport_Update_Column>;
  where?: InputMaybe<Quality_RepairReport_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.repairReport". */
export type Quality_RepairReport_Order_By = {
  authorId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  defectReportId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  submittedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.repairReport */
export type Quality_RepairReport_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.repairReport" */
export enum Quality_RepairReport_Select_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefectReportId = 'defectReportId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  SubmittedAt = 'submittedAt'
}

/** input type for updating data in table "quality.repairReport" */
export type Quality_RepairReport_Set_Input = {
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  defectReportId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  submittedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "quality_repairReport" */
export type Quality_RepairReport_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_RepairReport_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_RepairReport_Stream_Cursor_Value_Input = {
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  defectReportId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  submittedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "quality.repairReport" */
export enum Quality_RepairReport_Update_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefectReportId = 'defectReportId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  SubmittedAt = 'submittedAt'
}

export type Quality_RepairReport_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_RepairReport_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_RepairReport_Bool_Exp;
};

/** columns and relationships of "quality.ringValidation" */
export type Quality_RingValidation = {
  __typename?: 'quality_ringValidation';
  approvalDate?: Maybe<Scalars['timestamptz']['output']>;
  approvalUserId?: Maybe<Scalars['uuid']['output']>;
  complianceDate?: Maybe<Scalars['timestamptz']['output']>;
  complianceUserId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  pdfBucketFileId?: Maybe<Scalars['uuid']['output']>;
  refusalDate?: Maybe<Scalars['timestamptz']['output']>;
  refusalUserId?: Maybe<Scalars['uuid']['output']>;
  refusedSegments?: Maybe<Scalars['jsonb']['output']>;
  ringId: Scalars['uuid']['output'];
};


/** columns and relationships of "quality.ringValidation" */
export type Quality_RingValidationRefusedSegmentsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "quality.ringValidationView" */
export type Quality_RingValidationView = {
  __typename?: 'quality_ringValidationView';
  approvalDate?: Maybe<Scalars['timestamptz']['output']>;
  complianceDate?: Maybe<Scalars['timestamptz']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pdfBucketFileId?: Maybe<Scalars['uuid']['output']>;
  refusalDate?: Maybe<Scalars['timestamptz']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  ringValidationId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "quality.ringValidationView" */
export type Quality_RingValidationView_Aggregate = {
  __typename?: 'quality_ringValidationView_aggregate';
  aggregate?: Maybe<Quality_RingValidationView_Aggregate_Fields>;
  nodes: Array<Quality_RingValidationView>;
};

/** aggregate fields of "quality.ringValidationView" */
export type Quality_RingValidationView_Aggregate_Fields = {
  __typename?: 'quality_ringValidationView_aggregate_fields';
  avg?: Maybe<Quality_RingValidationView_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_RingValidationView_Max_Fields>;
  min?: Maybe<Quality_RingValidationView_Min_Fields>;
  stddev?: Maybe<Quality_RingValidationView_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_RingValidationView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_RingValidationView_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_RingValidationView_Sum_Fields>;
  var_pop?: Maybe<Quality_RingValidationView_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_RingValidationView_Var_Samp_Fields>;
  variance?: Maybe<Quality_RingValidationView_Variance_Fields>;
};


/** aggregate fields of "quality.ringValidationView" */
export type Quality_RingValidationView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_RingValidationView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Quality_RingValidationView_Avg_Fields = {
  __typename?: 'quality_ringValidationView_avg_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "quality.ringValidationView". All fields are combined with a logical 'AND'. */
export type Quality_RingValidationView_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_RingValidationView_Bool_Exp>>;
  _not?: InputMaybe<Quality_RingValidationView_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_RingValidationView_Bool_Exp>>;
  approvalDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  complianceDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  pdfBucketFileId?: InputMaybe<Uuid_Comparison_Exp>;
  refusalDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  ringNumber?: InputMaybe<Int_Comparison_Exp>;
  ringValidationId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Quality_RingValidationView_Max_Fields = {
  __typename?: 'quality_ringValidationView_max_fields';
  approvalDate?: Maybe<Scalars['timestamptz']['output']>;
  complianceDate?: Maybe<Scalars['timestamptz']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pdfBucketFileId?: Maybe<Scalars['uuid']['output']>;
  refusalDate?: Maybe<Scalars['timestamptz']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  ringValidationId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quality_RingValidationView_Min_Fields = {
  __typename?: 'quality_ringValidationView_min_fields';
  approvalDate?: Maybe<Scalars['timestamptz']['output']>;
  complianceDate?: Maybe<Scalars['timestamptz']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pdfBucketFileId?: Maybe<Scalars['uuid']['output']>;
  refusalDate?: Maybe<Scalars['timestamptz']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  ringValidationId?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "quality.ringValidationView". */
export type Quality_RingValidationView_Order_By = {
  approvalDate?: InputMaybe<Order_By>;
  complianceDate?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pdfBucketFileId?: InputMaybe<Order_By>;
  refusalDate?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  ringValidationId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "quality.ringValidationView" */
export enum Quality_RingValidationView_Select_Column {
  /** column name */
  ApprovalDate = 'approvalDate',
  /** column name */
  ComplianceDate = 'complianceDate',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  PdfBucketFileId = 'pdfBucketFileId',
  /** column name */
  RefusalDate = 'refusalDate',
  /** column name */
  RingNumber = 'ringNumber',
  /** column name */
  RingValidationId = 'ringValidationId',
  /** column name */
  Status = 'status'
}

/** aggregate stddev on columns */
export type Quality_RingValidationView_Stddev_Fields = {
  __typename?: 'quality_ringValidationView_stddev_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Quality_RingValidationView_Stddev_Pop_Fields = {
  __typename?: 'quality_ringValidationView_stddev_pop_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Quality_RingValidationView_Stddev_Samp_Fields = {
  __typename?: 'quality_ringValidationView_stddev_samp_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "quality_ringValidationView" */
export type Quality_RingValidationView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_RingValidationView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_RingValidationView_Stream_Cursor_Value_Input = {
  approvalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  complianceDate?: InputMaybe<Scalars['timestamptz']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pdfBucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  refusalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  ringValidationId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Quality_RingValidationView_Sum_Fields = {
  __typename?: 'quality_ringValidationView_sum_fields';
  ringNumber?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Quality_RingValidationView_Var_Pop_Fields = {
  __typename?: 'quality_ringValidationView_var_pop_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Quality_RingValidationView_Var_Samp_Fields = {
  __typename?: 'quality_ringValidationView_var_samp_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Quality_RingValidationView_Variance_Fields = {
  __typename?: 'quality_ringValidationView_variance_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "quality.ringValidation" */
export type Quality_RingValidation_Aggregate = {
  __typename?: 'quality_ringValidation_aggregate';
  aggregate?: Maybe<Quality_RingValidation_Aggregate_Fields>;
  nodes: Array<Quality_RingValidation>;
};

/** aggregate fields of "quality.ringValidation" */
export type Quality_RingValidation_Aggregate_Fields = {
  __typename?: 'quality_ringValidation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_RingValidation_Max_Fields>;
  min?: Maybe<Quality_RingValidation_Min_Fields>;
};


/** aggregate fields of "quality.ringValidation" */
export type Quality_RingValidation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_RingValidation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Quality_RingValidation_Append_Input = {
  refusedSegments?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "quality.ringValidation". All fields are combined with a logical 'AND'. */
export type Quality_RingValidation_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_RingValidation_Bool_Exp>>;
  _not?: InputMaybe<Quality_RingValidation_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_RingValidation_Bool_Exp>>;
  approvalDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  approvalUserId?: InputMaybe<Uuid_Comparison_Exp>;
  complianceDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  complianceUserId?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  pdfBucketFileId?: InputMaybe<Uuid_Comparison_Exp>;
  refusalDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  refusalUserId?: InputMaybe<Uuid_Comparison_Exp>;
  refusedSegments?: InputMaybe<Jsonb_Comparison_Exp>;
  ringId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.ringValidation" */
export enum Quality_RingValidation_Constraint {
  /** unique or primary key constraint on columns "id" */
  RingValidationPkey = 'ringValidation_pkey',
  /** unique or primary key constraint on columns "ringId" */
  RingValidationRingIdKey = 'ringValidation_ringId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Quality_RingValidation_Delete_At_Path_Input = {
  refusedSegments?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Quality_RingValidation_Delete_Elem_Input = {
  refusedSegments?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Quality_RingValidation_Delete_Key_Input = {
  refusedSegments?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "quality.ringValidation" */
export type Quality_RingValidation_Insert_Input = {
  approvalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  approvalUserId?: InputMaybe<Scalars['uuid']['input']>;
  complianceDate?: InputMaybe<Scalars['timestamptz']['input']>;
  complianceUserId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pdfBucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  refusalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  refusalUserId?: InputMaybe<Scalars['uuid']['input']>;
  refusedSegments?: InputMaybe<Scalars['jsonb']['input']>;
  ringId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Quality_RingValidation_Max_Fields = {
  __typename?: 'quality_ringValidation_max_fields';
  approvalDate?: Maybe<Scalars['timestamptz']['output']>;
  approvalUserId?: Maybe<Scalars['uuid']['output']>;
  complianceDate?: Maybe<Scalars['timestamptz']['output']>;
  complianceUserId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pdfBucketFileId?: Maybe<Scalars['uuid']['output']>;
  refusalDate?: Maybe<Scalars['timestamptz']['output']>;
  refusalUserId?: Maybe<Scalars['uuid']['output']>;
  ringId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Quality_RingValidation_Min_Fields = {
  __typename?: 'quality_ringValidation_min_fields';
  approvalDate?: Maybe<Scalars['timestamptz']['output']>;
  approvalUserId?: Maybe<Scalars['uuid']['output']>;
  complianceDate?: Maybe<Scalars['timestamptz']['output']>;
  complianceUserId?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  pdfBucketFileId?: Maybe<Scalars['uuid']['output']>;
  refusalDate?: Maybe<Scalars['timestamptz']['output']>;
  refusalUserId?: Maybe<Scalars['uuid']['output']>;
  ringId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "quality.ringValidation" */
export type Quality_RingValidation_Mutation_Response = {
  __typename?: 'quality_ringValidation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_RingValidation>;
};

/** on_conflict condition type for table "quality.ringValidation" */
export type Quality_RingValidation_On_Conflict = {
  constraint: Quality_RingValidation_Constraint;
  update_columns?: Array<Quality_RingValidation_Update_Column>;
  where?: InputMaybe<Quality_RingValidation_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.ringValidation". */
export type Quality_RingValidation_Order_By = {
  approvalDate?: InputMaybe<Order_By>;
  approvalUserId?: InputMaybe<Order_By>;
  complianceDate?: InputMaybe<Order_By>;
  complianceUserId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pdfBucketFileId?: InputMaybe<Order_By>;
  refusalDate?: InputMaybe<Order_By>;
  refusalUserId?: InputMaybe<Order_By>;
  refusedSegments?: InputMaybe<Order_By>;
  ringId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.ringValidation */
export type Quality_RingValidation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Quality_RingValidation_Prepend_Input = {
  refusedSegments?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "quality.ringValidation" */
export enum Quality_RingValidation_Select_Column {
  /** column name */
  ApprovalDate = 'approvalDate',
  /** column name */
  ApprovalUserId = 'approvalUserId',
  /** column name */
  ComplianceDate = 'complianceDate',
  /** column name */
  ComplianceUserId = 'complianceUserId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  PdfBucketFileId = 'pdfBucketFileId',
  /** column name */
  RefusalDate = 'refusalDate',
  /** column name */
  RefusalUserId = 'refusalUserId',
  /** column name */
  RefusedSegments = 'refusedSegments',
  /** column name */
  RingId = 'ringId'
}

/** input type for updating data in table "quality.ringValidation" */
export type Quality_RingValidation_Set_Input = {
  approvalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  approvalUserId?: InputMaybe<Scalars['uuid']['input']>;
  complianceDate?: InputMaybe<Scalars['timestamptz']['input']>;
  complianceUserId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pdfBucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  refusalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  refusalUserId?: InputMaybe<Scalars['uuid']['input']>;
  refusedSegments?: InputMaybe<Scalars['jsonb']['input']>;
  ringId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "quality_ringValidation" */
export type Quality_RingValidation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_RingValidation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_RingValidation_Stream_Cursor_Value_Input = {
  approvalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  approvalUserId?: InputMaybe<Scalars['uuid']['input']>;
  complianceDate?: InputMaybe<Scalars['timestamptz']['input']>;
  complianceUserId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pdfBucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  refusalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  refusalUserId?: InputMaybe<Scalars['uuid']['input']>;
  refusedSegments?: InputMaybe<Scalars['jsonb']['input']>;
  ringId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "quality.ringValidation" */
export enum Quality_RingValidation_Update_Column {
  /** column name */
  ApprovalDate = 'approvalDate',
  /** column name */
  ApprovalUserId = 'approvalUserId',
  /** column name */
  ComplianceDate = 'complianceDate',
  /** column name */
  ComplianceUserId = 'complianceUserId',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  PdfBucketFileId = 'pdfBucketFileId',
  /** column name */
  RefusalDate = 'refusalDate',
  /** column name */
  RefusalUserId = 'refusalUserId',
  /** column name */
  RefusedSegments = 'refusedSegments',
  /** column name */
  RingId = 'ringId'
}

export type Quality_RingValidation_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Quality_RingValidation_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Quality_RingValidation_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Quality_RingValidation_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Quality_RingValidation_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Quality_RingValidation_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_RingValidation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_RingValidation_Bool_Exp;
};

/** columns and relationships of "quality.scanCodeConfig" */
export type Quality_ScanCodeConfig = {
  __typename?: 'quality_scanCodeConfig';
  code: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  projectId: Scalars['uuid']['output'];
};

/** aggregated selection of "quality.scanCodeConfig" */
export type Quality_ScanCodeConfig_Aggregate = {
  __typename?: 'quality_scanCodeConfig_aggregate';
  aggregate?: Maybe<Quality_ScanCodeConfig_Aggregate_Fields>;
  nodes: Array<Quality_ScanCodeConfig>;
};

/** aggregate fields of "quality.scanCodeConfig" */
export type Quality_ScanCodeConfig_Aggregate_Fields = {
  __typename?: 'quality_scanCodeConfig_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_ScanCodeConfig_Max_Fields>;
  min?: Maybe<Quality_ScanCodeConfig_Min_Fields>;
};


/** aggregate fields of "quality.scanCodeConfig" */
export type Quality_ScanCodeConfig_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_ScanCodeConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.scanCodeConfig". All fields are combined with a logical 'AND'. */
export type Quality_ScanCodeConfig_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_ScanCodeConfig_Bool_Exp>>;
  _not?: InputMaybe<Quality_ScanCodeConfig_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_ScanCodeConfig_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.scanCodeConfig" */
export enum Quality_ScanCodeConfig_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScanCodeConfigPkey = 'scanCodeConfig_pkey'
}

/** input type for inserting data into table "quality.scanCodeConfig" */
export type Quality_ScanCodeConfig_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Quality_ScanCodeConfig_Max_Fields = {
  __typename?: 'quality_scanCodeConfig_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Quality_ScanCodeConfig_Min_Fields = {
  __typename?: 'quality_scanCodeConfig_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "quality.scanCodeConfig" */
export type Quality_ScanCodeConfig_Mutation_Response = {
  __typename?: 'quality_scanCodeConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_ScanCodeConfig>;
};

/** on_conflict condition type for table "quality.scanCodeConfig" */
export type Quality_ScanCodeConfig_On_Conflict = {
  constraint: Quality_ScanCodeConfig_Constraint;
  update_columns?: Array<Quality_ScanCodeConfig_Update_Column>;
  where?: InputMaybe<Quality_ScanCodeConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.scanCodeConfig". */
export type Quality_ScanCodeConfig_Order_By = {
  code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.scanCodeConfig */
export type Quality_ScanCodeConfig_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.scanCodeConfig" */
export enum Quality_ScanCodeConfig_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId'
}

/** input type for updating data in table "quality.scanCodeConfig" */
export type Quality_ScanCodeConfig_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "quality_scanCodeConfig" */
export type Quality_ScanCodeConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_ScanCodeConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_ScanCodeConfig_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "quality.scanCodeConfig" */
export enum Quality_ScanCodeConfig_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId'
}

export type Quality_ScanCodeConfig_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_ScanCodeConfig_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_ScanCodeConfig_Bool_Exp;
};

/** columns and relationships of "quality.scanConfig" */
export type Quality_ScanConfig = {
  __typename?: 'quality_scanConfig';
  extractLength: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  projectId: Scalars['uuid']['output'];
  startIndex: Scalars['Int']['output'];
};

/** aggregated selection of "quality.scanConfig" */
export type Quality_ScanConfig_Aggregate = {
  __typename?: 'quality_scanConfig_aggregate';
  aggregate?: Maybe<Quality_ScanConfig_Aggregate_Fields>;
  nodes: Array<Quality_ScanConfig>;
};

/** aggregate fields of "quality.scanConfig" */
export type Quality_ScanConfig_Aggregate_Fields = {
  __typename?: 'quality_scanConfig_aggregate_fields';
  avg?: Maybe<Quality_ScanConfig_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_ScanConfig_Max_Fields>;
  min?: Maybe<Quality_ScanConfig_Min_Fields>;
  stddev?: Maybe<Quality_ScanConfig_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_ScanConfig_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_ScanConfig_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_ScanConfig_Sum_Fields>;
  var_pop?: Maybe<Quality_ScanConfig_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_ScanConfig_Var_Samp_Fields>;
  variance?: Maybe<Quality_ScanConfig_Variance_Fields>;
};


/** aggregate fields of "quality.scanConfig" */
export type Quality_ScanConfig_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_ScanConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Quality_ScanConfig_Avg_Fields = {
  __typename?: 'quality_scanConfig_avg_fields';
  extractLength?: Maybe<Scalars['Float']['output']>;
  startIndex?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "quality.scanConfig". All fields are combined with a logical 'AND'. */
export type Quality_ScanConfig_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_ScanConfig_Bool_Exp>>;
  _not?: InputMaybe<Quality_ScanConfig_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_ScanConfig_Bool_Exp>>;
  extractLength?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  startIndex?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.scanConfig" */
export enum Quality_ScanConfig_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScanConfigPkey = 'scanConfig_pkey'
}

/** input type for incrementing numeric columns in table "quality.scanConfig" */
export type Quality_ScanConfig_Inc_Input = {
  extractLength?: InputMaybe<Scalars['Int']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quality.scanConfig" */
export type Quality_ScanConfig_Insert_Input = {
  extractLength?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Quality_ScanConfig_Max_Fields = {
  __typename?: 'quality_scanConfig_max_fields';
  extractLength?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  startIndex?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Quality_ScanConfig_Min_Fields = {
  __typename?: 'quality_scanConfig_min_fields';
  extractLength?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  startIndex?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "quality.scanConfig" */
export type Quality_ScanConfig_Mutation_Response = {
  __typename?: 'quality_scanConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_ScanConfig>;
};

/** on_conflict condition type for table "quality.scanConfig" */
export type Quality_ScanConfig_On_Conflict = {
  constraint: Quality_ScanConfig_Constraint;
  update_columns?: Array<Quality_ScanConfig_Update_Column>;
  where?: InputMaybe<Quality_ScanConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.scanConfig". */
export type Quality_ScanConfig_Order_By = {
  extractLength?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  startIndex?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.scanConfig */
export type Quality_ScanConfig_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.scanConfig" */
export enum Quality_ScanConfig_Select_Column {
  /** column name */
  ExtractLength = 'extractLength',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  StartIndex = 'startIndex'
}

/** input type for updating data in table "quality.scanConfig" */
export type Quality_ScanConfig_Set_Input = {
  extractLength?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Quality_ScanConfig_Stddev_Fields = {
  __typename?: 'quality_scanConfig_stddev_fields';
  extractLength?: Maybe<Scalars['Float']['output']>;
  startIndex?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Quality_ScanConfig_Stddev_Pop_Fields = {
  __typename?: 'quality_scanConfig_stddev_pop_fields';
  extractLength?: Maybe<Scalars['Float']['output']>;
  startIndex?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Quality_ScanConfig_Stddev_Samp_Fields = {
  __typename?: 'quality_scanConfig_stddev_samp_fields';
  extractLength?: Maybe<Scalars['Float']['output']>;
  startIndex?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "quality_scanConfig" */
export type Quality_ScanConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_ScanConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_ScanConfig_Stream_Cursor_Value_Input = {
  extractLength?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Quality_ScanConfig_Sum_Fields = {
  __typename?: 'quality_scanConfig_sum_fields';
  extractLength?: Maybe<Scalars['Int']['output']>;
  startIndex?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "quality.scanConfig" */
export enum Quality_ScanConfig_Update_Column {
  /** column name */
  ExtractLength = 'extractLength',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  StartIndex = 'startIndex'
}

export type Quality_ScanConfig_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quality_ScanConfig_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_ScanConfig_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_ScanConfig_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quality_ScanConfig_Var_Pop_Fields = {
  __typename?: 'quality_scanConfig_var_pop_fields';
  extractLength?: Maybe<Scalars['Float']['output']>;
  startIndex?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Quality_ScanConfig_Var_Samp_Fields = {
  __typename?: 'quality_scanConfig_var_samp_fields';
  extractLength?: Maybe<Scalars['Float']['output']>;
  startIndex?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Quality_ScanConfig_Variance_Fields = {
  __typename?: 'quality_scanConfig_variance_fields';
  extractLength?: Maybe<Scalars['Float']['output']>;
  startIndex?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "quality.scanSite" */
export type Quality_ScanSite = {
  __typename?: 'quality_scanSite';
  id: Scalars['uuid']['output'];
  isOnHoldOptionEnabled: Scalars['Boolean']['output'];
  isQuarantineEnabled: Scalars['Boolean']['output'];
  isReceiptActivated: Scalars['Boolean']['output'];
  isTunnelActivated: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['uuid']['output'];
  /** An array relationship */
  scanSiteConstructionSites: Array<Quality_ScanSiteConstructionSite>;
  /** An aggregate relationship */
  scanSiteConstructionSites_aggregate: Quality_ScanSiteConstructionSite_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "quality.scanSite" */
export type Quality_ScanSiteScanSiteConstructionSitesArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Order_By>>;
  where?: InputMaybe<Quality_ScanSiteConstructionSite_Bool_Exp>;
};


/** columns and relationships of "quality.scanSite" */
export type Quality_ScanSiteScanSiteConstructionSites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Order_By>>;
  where?: InputMaybe<Quality_ScanSiteConstructionSite_Bool_Exp>;
};

/** columns and relationships of "quality.scanSiteConstructionSite" */
export type Quality_ScanSiteConstructionSite = {
  __typename?: 'quality_scanSiteConstructionSite';
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  scanSiteId: Scalars['uuid']['output'];
};

/** aggregated selection of "quality.scanSiteConstructionSite" */
export type Quality_ScanSiteConstructionSite_Aggregate = {
  __typename?: 'quality_scanSiteConstructionSite_aggregate';
  aggregate?: Maybe<Quality_ScanSiteConstructionSite_Aggregate_Fields>;
  nodes: Array<Quality_ScanSiteConstructionSite>;
};

export type Quality_ScanSiteConstructionSite_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quality_ScanSiteConstructionSite_Aggregate_Bool_Exp_Count>;
};

export type Quality_ScanSiteConstructionSite_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_ScanSiteConstructionSite_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quality.scanSiteConstructionSite" */
export type Quality_ScanSiteConstructionSite_Aggregate_Fields = {
  __typename?: 'quality_scanSiteConstructionSite_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_ScanSiteConstructionSite_Max_Fields>;
  min?: Maybe<Quality_ScanSiteConstructionSite_Min_Fields>;
};


/** aggregate fields of "quality.scanSiteConstructionSite" */
export type Quality_ScanSiteConstructionSite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quality.scanSiteConstructionSite" */
export type Quality_ScanSiteConstructionSite_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quality_ScanSiteConstructionSite_Max_Order_By>;
  min?: InputMaybe<Quality_ScanSiteConstructionSite_Min_Order_By>;
};

/** input type for inserting array relation for remote table "quality.scanSiteConstructionSite" */
export type Quality_ScanSiteConstructionSite_Arr_Rel_Insert_Input = {
  data: Array<Quality_ScanSiteConstructionSite_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_ScanSiteConstructionSite_On_Conflict>;
};

/** Boolean expression to filter rows from the table "quality.scanSiteConstructionSite". All fields are combined with a logical 'AND'. */
export type Quality_ScanSiteConstructionSite_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Bool_Exp>>;
  _not?: InputMaybe<Quality_ScanSiteConstructionSite_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Bool_Exp>>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  scanSiteId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.scanSiteConstructionSite" */
export enum Quality_ScanSiteConstructionSite_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScanSiteConstructionSitePkey = 'scanSiteConstructionSite_pkey'
}

/** input type for inserting data into table "quality.scanSiteConstructionSite" */
export type Quality_ScanSiteConstructionSite_Insert_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  scanSiteId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Quality_ScanSiteConstructionSite_Max_Fields = {
  __typename?: 'quality_scanSiteConstructionSite_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  scanSiteId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "quality.scanSiteConstructionSite" */
export type Quality_ScanSiteConstructionSite_Max_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scanSiteId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quality_ScanSiteConstructionSite_Min_Fields = {
  __typename?: 'quality_scanSiteConstructionSite_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  scanSiteId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "quality.scanSiteConstructionSite" */
export type Quality_ScanSiteConstructionSite_Min_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scanSiteId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quality.scanSiteConstructionSite" */
export type Quality_ScanSiteConstructionSite_Mutation_Response = {
  __typename?: 'quality_scanSiteConstructionSite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_ScanSiteConstructionSite>;
};

/** on_conflict condition type for table "quality.scanSiteConstructionSite" */
export type Quality_ScanSiteConstructionSite_On_Conflict = {
  constraint: Quality_ScanSiteConstructionSite_Constraint;
  update_columns?: Array<Quality_ScanSiteConstructionSite_Update_Column>;
  where?: InputMaybe<Quality_ScanSiteConstructionSite_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.scanSiteConstructionSite". */
export type Quality_ScanSiteConstructionSite_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scanSiteId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.scanSiteConstructionSite */
export type Quality_ScanSiteConstructionSite_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.scanSiteConstructionSite" */
export enum Quality_ScanSiteConstructionSite_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  ScanSiteId = 'scanSiteId'
}

/** input type for updating data in table "quality.scanSiteConstructionSite" */
export type Quality_ScanSiteConstructionSite_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  scanSiteId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "quality_scanSiteConstructionSite" */
export type Quality_ScanSiteConstructionSite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_ScanSiteConstructionSite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_ScanSiteConstructionSite_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  scanSiteId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "quality.scanSiteConstructionSite" */
export enum Quality_ScanSiteConstructionSite_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  ScanSiteId = 'scanSiteId'
}

export type Quality_ScanSiteConstructionSite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_ScanSiteConstructionSite_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_ScanSiteConstructionSite_Bool_Exp;
};

/** aggregated selection of "quality.scanSite" */
export type Quality_ScanSite_Aggregate = {
  __typename?: 'quality_scanSite_aggregate';
  aggregate?: Maybe<Quality_ScanSite_Aggregate_Fields>;
  nodes: Array<Quality_ScanSite>;
};

/** aggregate fields of "quality.scanSite" */
export type Quality_ScanSite_Aggregate_Fields = {
  __typename?: 'quality_scanSite_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_ScanSite_Max_Fields>;
  min?: Maybe<Quality_ScanSite_Min_Fields>;
};


/** aggregate fields of "quality.scanSite" */
export type Quality_ScanSite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_ScanSite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.scanSite". All fields are combined with a logical 'AND'. */
export type Quality_ScanSite_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_ScanSite_Bool_Exp>>;
  _not?: InputMaybe<Quality_ScanSite_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_ScanSite_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isOnHoldOptionEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  isQuarantineEnabled?: InputMaybe<Boolean_Comparison_Exp>;
  isReceiptActivated?: InputMaybe<Boolean_Comparison_Exp>;
  isTunnelActivated?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  scanSiteConstructionSites?: InputMaybe<Quality_ScanSiteConstructionSite_Bool_Exp>;
  scanSiteConstructionSites_aggregate?: InputMaybe<Quality_ScanSiteConstructionSite_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.scanSite" */
export enum Quality_ScanSite_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScanSitePkey = 'scanSite_pkey'
}

/** input type for inserting data into table "quality.scanSite" */
export type Quality_ScanSite_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isOnHoldOptionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isQuarantineEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isReceiptActivated?: InputMaybe<Scalars['Boolean']['input']>;
  isTunnelActivated?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  scanSiteConstructionSites?: InputMaybe<Quality_ScanSiteConstructionSite_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quality_ScanSite_Max_Fields = {
  __typename?: 'quality_scanSite_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Quality_ScanSite_Min_Fields = {
  __typename?: 'quality_scanSite_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "quality.scanSite" */
export type Quality_ScanSite_Mutation_Response = {
  __typename?: 'quality_scanSite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_ScanSite>;
};

/** input type for inserting object relation for remote table "quality.scanSite" */
export type Quality_ScanSite_Obj_Rel_Insert_Input = {
  data: Quality_ScanSite_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_ScanSite_On_Conflict>;
};

/** on_conflict condition type for table "quality.scanSite" */
export type Quality_ScanSite_On_Conflict = {
  constraint: Quality_ScanSite_Constraint;
  update_columns?: Array<Quality_ScanSite_Update_Column>;
  where?: InputMaybe<Quality_ScanSite_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.scanSite". */
export type Quality_ScanSite_Order_By = {
  id?: InputMaybe<Order_By>;
  isOnHoldOptionEnabled?: InputMaybe<Order_By>;
  isQuarantineEnabled?: InputMaybe<Order_By>;
  isReceiptActivated?: InputMaybe<Order_By>;
  isTunnelActivated?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  scanSiteConstructionSites_aggregate?: InputMaybe<Quality_ScanSiteConstructionSite_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.scanSite */
export type Quality_ScanSite_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.scanSite" */
export enum Quality_ScanSite_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsOnHoldOptionEnabled = 'isOnHoldOptionEnabled',
  /** column name */
  IsQuarantineEnabled = 'isQuarantineEnabled',
  /** column name */
  IsReceiptActivated = 'isReceiptActivated',
  /** column name */
  IsTunnelActivated = 'isTunnelActivated',
  /** column name */
  Label = 'label',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "quality.scanSite" */
export type Quality_ScanSite_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isOnHoldOptionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isQuarantineEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isReceiptActivated?: InputMaybe<Scalars['Boolean']['input']>;
  isTunnelActivated?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "quality_scanSite" */
export type Quality_ScanSite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_ScanSite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_ScanSite_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isOnHoldOptionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isQuarantineEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isReceiptActivated?: InputMaybe<Scalars['Boolean']['input']>;
  isTunnelActivated?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "quality.scanSite" */
export enum Quality_ScanSite_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsOnHoldOptionEnabled = 'isOnHoldOptionEnabled',
  /** column name */
  IsQuarantineEnabled = 'isQuarantineEnabled',
  /** column name */
  IsReceiptActivated = 'isReceiptActivated',
  /** column name */
  IsTunnelActivated = 'isTunnelActivated',
  /** column name */
  Label = 'label',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Quality_ScanSite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_ScanSite_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_ScanSite_Bool_Exp;
};

/** columns and relationships of "quality.scanTypeEnum" */
export type Quality_ScanTypeEnum = {
  __typename?: 'quality_scanTypeEnum';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

/** aggregated selection of "quality.scanTypeEnum" */
export type Quality_ScanTypeEnum_Aggregate = {
  __typename?: 'quality_scanTypeEnum_aggregate';
  aggregate?: Maybe<Quality_ScanTypeEnum_Aggregate_Fields>;
  nodes: Array<Quality_ScanTypeEnum>;
};

/** aggregate fields of "quality.scanTypeEnum" */
export type Quality_ScanTypeEnum_Aggregate_Fields = {
  __typename?: 'quality_scanTypeEnum_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_ScanTypeEnum_Max_Fields>;
  min?: Maybe<Quality_ScanTypeEnum_Min_Fields>;
};


/** aggregate fields of "quality.scanTypeEnum" */
export type Quality_ScanTypeEnum_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_ScanTypeEnum_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.scanTypeEnum". All fields are combined with a logical 'AND'. */
export type Quality_ScanTypeEnum_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_ScanTypeEnum_Bool_Exp>>;
  _not?: InputMaybe<Quality_ScanTypeEnum_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_ScanTypeEnum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.scanTypeEnum" */
export enum Quality_ScanTypeEnum_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScanTypeEnumPkey = 'scanTypeEnum_pkey'
}

export enum Quality_ScanTypeEnum_Enum {
  Surface = 'SURFACE',
  Tunnel = 'TUNNEL'
}

/** Boolean expression to compare columns of type "quality_scanTypeEnum_enum". All fields are combined with logical 'AND'. */
export type Quality_ScanTypeEnum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quality_ScanTypeEnum_Enum>;
  _in?: InputMaybe<Array<Quality_ScanTypeEnum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quality_ScanTypeEnum_Enum>;
  _nin?: InputMaybe<Array<Quality_ScanTypeEnum_Enum>>;
};

/** input type for inserting data into table "quality.scanTypeEnum" */
export type Quality_ScanTypeEnum_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quality_ScanTypeEnum_Max_Fields = {
  __typename?: 'quality_scanTypeEnum_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quality_ScanTypeEnum_Min_Fields = {
  __typename?: 'quality_scanTypeEnum_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quality.scanTypeEnum" */
export type Quality_ScanTypeEnum_Mutation_Response = {
  __typename?: 'quality_scanTypeEnum_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_ScanTypeEnum>;
};

/** on_conflict condition type for table "quality.scanTypeEnum" */
export type Quality_ScanTypeEnum_On_Conflict = {
  constraint: Quality_ScanTypeEnum_Constraint;
  update_columns?: Array<Quality_ScanTypeEnum_Update_Column>;
  where?: InputMaybe<Quality_ScanTypeEnum_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.scanTypeEnum". */
export type Quality_ScanTypeEnum_Order_By = {
  comment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.scanTypeEnum */
export type Quality_ScanTypeEnum_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "quality.scanTypeEnum" */
export enum Quality_ScanTypeEnum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "quality.scanTypeEnum" */
export type Quality_ScanTypeEnum_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quality_scanTypeEnum" */
export type Quality_ScanTypeEnum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_ScanTypeEnum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_ScanTypeEnum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quality.scanTypeEnum" */
export enum Quality_ScanTypeEnum_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

export type Quality_ScanTypeEnum_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_ScanTypeEnum_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_ScanTypeEnum_Bool_Exp;
};

/** columns and relationships of "quality.segment" */
export type Quality_Segment = {
  __typename?: 'quality_segment';
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  extraParameters: Array<Quality_SegmentExtraParameter>;
  /** An aggregate relationship */
  extraParameters_aggregate: Quality_SegmentExtraParameter_Aggregate;
  /** An array relationship */
  histories: Array<Quality_SegmentHistory>;
  /** An aggregate relationship */
  histories_aggregate: Quality_SegmentHistory_Aggregate;
  id: Scalars['uuid']['output'];
  manufactureDate?: Maybe<Scalars['timestamptz']['output']>;
  mold?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  project?: Maybe<Project>;
  projectId: Scalars['uuid']['output'];
  /** An object relationship */
  ring?: Maybe<Parameter_Ring>;
  ringId?: Maybe<Scalars['uuid']['output']>;
  segmentType?: Maybe<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "quality.segment" */
export type Quality_SegmentExtraParametersArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentExtraParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentExtraParameter_Order_By>>;
  where?: InputMaybe<Quality_SegmentExtraParameter_Bool_Exp>;
};


/** columns and relationships of "quality.segment" */
export type Quality_SegmentExtraParameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentExtraParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentExtraParameter_Order_By>>;
  where?: InputMaybe<Quality_SegmentExtraParameter_Bool_Exp>;
};


/** columns and relationships of "quality.segment" */
export type Quality_SegmentHistoriesArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistory_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistory_Bool_Exp>;
};


/** columns and relationships of "quality.segment" */
export type Quality_SegmentHistories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistory_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistory_Bool_Exp>;
};

/** columns and relationships of "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig = {
  __typename?: 'quality_segmentDrawConfig';
  boardConfigId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  shape: Quality_ShapeEnum_Enum;
};

/** aggregated selection of "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Aggregate = {
  __typename?: 'quality_segmentDrawConfig_aggregate';
  aggregate?: Maybe<Quality_SegmentDrawConfig_Aggregate_Fields>;
  nodes: Array<Quality_SegmentDrawConfig>;
};

export type Quality_SegmentDrawConfig_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quality_SegmentDrawConfig_Aggregate_Bool_Exp_Count>;
};

export type Quality_SegmentDrawConfig_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quality_SegmentDrawConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_SegmentDrawConfig_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Aggregate_Fields = {
  __typename?: 'quality_segmentDrawConfig_aggregate_fields';
  avg?: Maybe<Quality_SegmentDrawConfig_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_SegmentDrawConfig_Max_Fields>;
  min?: Maybe<Quality_SegmentDrawConfig_Min_Fields>;
  stddev?: Maybe<Quality_SegmentDrawConfig_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_SegmentDrawConfig_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_SegmentDrawConfig_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_SegmentDrawConfig_Sum_Fields>;
  var_pop?: Maybe<Quality_SegmentDrawConfig_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_SegmentDrawConfig_Var_Samp_Fields>;
  variance?: Maybe<Quality_SegmentDrawConfig_Variance_Fields>;
};


/** aggregate fields of "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_SegmentDrawConfig_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Aggregate_Order_By = {
  avg?: InputMaybe<Quality_SegmentDrawConfig_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quality_SegmentDrawConfig_Max_Order_By>;
  min?: InputMaybe<Quality_SegmentDrawConfig_Min_Order_By>;
  stddev?: InputMaybe<Quality_SegmentDrawConfig_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quality_SegmentDrawConfig_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quality_SegmentDrawConfig_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quality_SegmentDrawConfig_Sum_Order_By>;
  var_pop?: InputMaybe<Quality_SegmentDrawConfig_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quality_SegmentDrawConfig_Var_Samp_Order_By>;
  variance?: InputMaybe<Quality_SegmentDrawConfig_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Arr_Rel_Insert_Input = {
  data: Array<Quality_SegmentDrawConfig_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_SegmentDrawConfig_On_Conflict>;
};

/** aggregate avg on columns */
export type Quality_SegmentDrawConfig_Avg_Fields = {
  __typename?: 'quality_segmentDrawConfig_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quality.segmentDrawConfig". All fields are combined with a logical 'AND'. */
export type Quality_SegmentDrawConfig_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_SegmentDrawConfig_Bool_Exp>>;
  _not?: InputMaybe<Quality_SegmentDrawConfig_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_SegmentDrawConfig_Bool_Exp>>;
  boardConfigId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  shape?: InputMaybe<Quality_ShapeEnum_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.segmentDrawConfig" */
export enum Quality_SegmentDrawConfig_Constraint {
  /** unique or primary key constraint on columns "id" */
  SegmentDrawConfigPkey = 'segmentDrawConfig_pkey'
}

/** input type for incrementing numeric columns in table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Insert_Input = {
  boardConfigId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  shape?: InputMaybe<Quality_ShapeEnum_Enum>;
};

/** aggregate max on columns */
export type Quality_SegmentDrawConfig_Max_Fields = {
  __typename?: 'quality_segmentDrawConfig_max_fields';
  boardConfigId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Max_Order_By = {
  boardConfigId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quality_SegmentDrawConfig_Min_Fields = {
  __typename?: 'quality_segmentDrawConfig_min_fields';
  boardConfigId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Min_Order_By = {
  boardConfigId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Mutation_Response = {
  __typename?: 'quality_segmentDrawConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_SegmentDrawConfig>;
};

/** on_conflict condition type for table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_On_Conflict = {
  constraint: Quality_SegmentDrawConfig_Constraint;
  update_columns?: Array<Quality_SegmentDrawConfig_Update_Column>;
  where?: InputMaybe<Quality_SegmentDrawConfig_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.segmentDrawConfig". */
export type Quality_SegmentDrawConfig_Order_By = {
  boardConfigId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  shape?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.segmentDrawConfig */
export type Quality_SegmentDrawConfig_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.segmentDrawConfig" */
export enum Quality_SegmentDrawConfig_Select_Column {
  /** column name */
  BoardConfigId = 'boardConfigId',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Order = 'order',
  /** column name */
  Shape = 'shape'
}

/** input type for updating data in table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Set_Input = {
  boardConfigId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  shape?: InputMaybe<Quality_ShapeEnum_Enum>;
};

/** aggregate stddev on columns */
export type Quality_SegmentDrawConfig_Stddev_Fields = {
  __typename?: 'quality_segmentDrawConfig_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quality_SegmentDrawConfig_Stddev_Pop_Fields = {
  __typename?: 'quality_segmentDrawConfig_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quality_SegmentDrawConfig_Stddev_Samp_Fields = {
  __typename?: 'quality_segmentDrawConfig_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quality_segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_SegmentDrawConfig_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_SegmentDrawConfig_Stream_Cursor_Value_Input = {
  boardConfigId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  shape?: InputMaybe<Quality_ShapeEnum_Enum>;
};

/** aggregate sum on columns */
export type Quality_SegmentDrawConfig_Sum_Fields = {
  __typename?: 'quality_segmentDrawConfig_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "quality.segmentDrawConfig" */
export enum Quality_SegmentDrawConfig_Update_Column {
  /** column name */
  BoardConfigId = 'boardConfigId',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  Order = 'order',
  /** column name */
  Shape = 'shape'
}

export type Quality_SegmentDrawConfig_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quality_SegmentDrawConfig_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_SegmentDrawConfig_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_SegmentDrawConfig_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quality_SegmentDrawConfig_Var_Pop_Fields = {
  __typename?: 'quality_segmentDrawConfig_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quality_SegmentDrawConfig_Var_Samp_Fields = {
  __typename?: 'quality_segmentDrawConfig_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quality_SegmentDrawConfig_Variance_Fields = {
  __typename?: 'quality_segmentDrawConfig_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quality.segmentDrawConfig" */
export type Quality_SegmentDrawConfig_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "quality.segmentExtraParameter" */
export type Quality_SegmentExtraParameter = {
  __typename?: 'quality_segmentExtraParameter';
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  /** An object relationship */
  segment?: Maybe<Quality_Segment>;
  segmentId: Scalars['uuid']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "quality.segmentExtraParameter" */
export type Quality_SegmentExtraParameter_Aggregate = {
  __typename?: 'quality_segmentExtraParameter_aggregate';
  aggregate?: Maybe<Quality_SegmentExtraParameter_Aggregate_Fields>;
  nodes: Array<Quality_SegmentExtraParameter>;
};

export type Quality_SegmentExtraParameter_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quality_SegmentExtraParameter_Aggregate_Bool_Exp_Count>;
};

export type Quality_SegmentExtraParameter_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quality_SegmentExtraParameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_SegmentExtraParameter_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quality.segmentExtraParameter" */
export type Quality_SegmentExtraParameter_Aggregate_Fields = {
  __typename?: 'quality_segmentExtraParameter_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_SegmentExtraParameter_Max_Fields>;
  min?: Maybe<Quality_SegmentExtraParameter_Min_Fields>;
};


/** aggregate fields of "quality.segmentExtraParameter" */
export type Quality_SegmentExtraParameter_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_SegmentExtraParameter_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quality.segmentExtraParameter" */
export type Quality_SegmentExtraParameter_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quality_SegmentExtraParameter_Max_Order_By>;
  min?: InputMaybe<Quality_SegmentExtraParameter_Min_Order_By>;
};

/** input type for inserting array relation for remote table "quality.segmentExtraParameter" */
export type Quality_SegmentExtraParameter_Arr_Rel_Insert_Input = {
  data: Array<Quality_SegmentExtraParameter_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_SegmentExtraParameter_On_Conflict>;
};

/** Boolean expression to filter rows from the table "quality.segmentExtraParameter". All fields are combined with a logical 'AND'. */
export type Quality_SegmentExtraParameter_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_SegmentExtraParameter_Bool_Exp>>;
  _not?: InputMaybe<Quality_SegmentExtraParameter_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_SegmentExtraParameter_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  segment?: InputMaybe<Quality_Segment_Bool_Exp>;
  segmentId?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.segmentExtraParameter" */
export enum Quality_SegmentExtraParameter_Constraint {
  /** unique or primary key constraint on columns "id" */
  SegmentExtraParameterPkey = 'segmentExtraParameter_pkey',
  /** unique or primary key constraint on columns "segmentId", "label" */
  SegmentExtraParameterSegmentIdLabelKey = 'segmentExtraParameter_segmentId_label_key'
}

/** input type for inserting data into table "quality.segmentExtraParameter" */
export type Quality_SegmentExtraParameter_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Quality_Segment_Obj_Rel_Insert_Input>;
  segmentId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quality_SegmentExtraParameter_Max_Fields = {
  __typename?: 'quality_segmentExtraParameter_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  segmentId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "quality.segmentExtraParameter" */
export type Quality_SegmentExtraParameter_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  segmentId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quality_SegmentExtraParameter_Min_Fields = {
  __typename?: 'quality_segmentExtraParameter_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  segmentId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "quality.segmentExtraParameter" */
export type Quality_SegmentExtraParameter_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  segmentId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quality.segmentExtraParameter" */
export type Quality_SegmentExtraParameter_Mutation_Response = {
  __typename?: 'quality_segmentExtraParameter_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_SegmentExtraParameter>;
};

/** on_conflict condition type for table "quality.segmentExtraParameter" */
export type Quality_SegmentExtraParameter_On_Conflict = {
  constraint: Quality_SegmentExtraParameter_Constraint;
  update_columns?: Array<Quality_SegmentExtraParameter_Update_Column>;
  where?: InputMaybe<Quality_SegmentExtraParameter_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.segmentExtraParameter". */
export type Quality_SegmentExtraParameter_Order_By = {
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  segment?: InputMaybe<Quality_Segment_Order_By>;
  segmentId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.segmentExtraParameter */
export type Quality_SegmentExtraParameter_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.segmentExtraParameter" */
export enum Quality_SegmentExtraParameter_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  SegmentId = 'segmentId',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "quality.segmentExtraParameter" */
export type Quality_SegmentExtraParameter_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  segmentId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quality_segmentExtraParameter" */
export type Quality_SegmentExtraParameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_SegmentExtraParameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_SegmentExtraParameter_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  segmentId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quality.segmentExtraParameter" */
export enum Quality_SegmentExtraParameter_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  SegmentId = 'segmentId',
  /** column name */
  Value = 'value'
}

export type Quality_SegmentExtraParameter_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_SegmentExtraParameter_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_SegmentExtraParameter_Bool_Exp;
};

/** columns and relationships of "quality.segmentHistory" */
export type Quality_SegmentHistory = {
  __typename?: 'quality_segmentHistory';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  /** An object relationship */
  quarantineDefect?: Maybe<Quality_QuarantineDefect>;
  /** An object relationship */
  scanSite?: Maybe<Quality_ScanSite>;
  scanSiteId?: Maybe<Scalars['uuid']['output']>;
  scanType?: Maybe<Quality_ScanTypeEnum_Enum>;
  /** An object relationship */
  segment?: Maybe<Quality_Segment>;
  segmentId: Scalars['uuid']['output'];
  status: Quality_SegmentHistoryStatusEnum_Enum;
  updatedAt: Scalars['timestamptz']['output'];
};

/** columns and relationships of "quality.segmentHistoryStatusEnum" */
export type Quality_SegmentHistoryStatusEnum = {
  __typename?: 'quality_segmentHistoryStatusEnum';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

/** aggregated selection of "quality.segmentHistoryStatusEnum" */
export type Quality_SegmentHistoryStatusEnum_Aggregate = {
  __typename?: 'quality_segmentHistoryStatusEnum_aggregate';
  aggregate?: Maybe<Quality_SegmentHistoryStatusEnum_Aggregate_Fields>;
  nodes: Array<Quality_SegmentHistoryStatusEnum>;
};

/** aggregate fields of "quality.segmentHistoryStatusEnum" */
export type Quality_SegmentHistoryStatusEnum_Aggregate_Fields = {
  __typename?: 'quality_segmentHistoryStatusEnum_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_SegmentHistoryStatusEnum_Max_Fields>;
  min?: Maybe<Quality_SegmentHistoryStatusEnum_Min_Fields>;
};


/** aggregate fields of "quality.segmentHistoryStatusEnum" */
export type Quality_SegmentHistoryStatusEnum_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_SegmentHistoryStatusEnum_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.segmentHistoryStatusEnum". All fields are combined with a logical 'AND'. */
export type Quality_SegmentHistoryStatusEnum_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_SegmentHistoryStatusEnum_Bool_Exp>>;
  _not?: InputMaybe<Quality_SegmentHistoryStatusEnum_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_SegmentHistoryStatusEnum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.segmentHistoryStatusEnum" */
export enum Quality_SegmentHistoryStatusEnum_Constraint {
  /** unique or primary key constraint on columns "id" */
  SegmentHistoryStatusEnumPkey = 'segmentHistoryStatusEnum_pkey'
}

export enum Quality_SegmentHistoryStatusEnum_Enum {
  Accepted = 'ACCEPTED',
  Imported = 'IMPORTED',
  Installed = 'INSTALLED',
  OnHold = 'ON_HOLD',
  Quarantine = 'QUARANTINE',
  Rejected = 'REJECTED',
  TunnelRejected = 'TUNNEL_REJECTED'
}

/** Boolean expression to compare columns of type "quality_segmentHistoryStatusEnum_enum". All fields are combined with logical 'AND'. */
export type Quality_SegmentHistoryStatusEnum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quality_SegmentHistoryStatusEnum_Enum>;
  _in?: InputMaybe<Array<Quality_SegmentHistoryStatusEnum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quality_SegmentHistoryStatusEnum_Enum>;
  _nin?: InputMaybe<Array<Quality_SegmentHistoryStatusEnum_Enum>>;
};

/** input type for inserting data into table "quality.segmentHistoryStatusEnum" */
export type Quality_SegmentHistoryStatusEnum_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quality_SegmentHistoryStatusEnum_Max_Fields = {
  __typename?: 'quality_segmentHistoryStatusEnum_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quality_SegmentHistoryStatusEnum_Min_Fields = {
  __typename?: 'quality_segmentHistoryStatusEnum_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quality.segmentHistoryStatusEnum" */
export type Quality_SegmentHistoryStatusEnum_Mutation_Response = {
  __typename?: 'quality_segmentHistoryStatusEnum_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_SegmentHistoryStatusEnum>;
};

/** on_conflict condition type for table "quality.segmentHistoryStatusEnum" */
export type Quality_SegmentHistoryStatusEnum_On_Conflict = {
  constraint: Quality_SegmentHistoryStatusEnum_Constraint;
  update_columns?: Array<Quality_SegmentHistoryStatusEnum_Update_Column>;
  where?: InputMaybe<Quality_SegmentHistoryStatusEnum_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.segmentHistoryStatusEnum". */
export type Quality_SegmentHistoryStatusEnum_Order_By = {
  comment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.segmentHistoryStatusEnum */
export type Quality_SegmentHistoryStatusEnum_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "quality.segmentHistoryStatusEnum" */
export enum Quality_SegmentHistoryStatusEnum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "quality.segmentHistoryStatusEnum" */
export type Quality_SegmentHistoryStatusEnum_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quality_segmentHistoryStatusEnum" */
export type Quality_SegmentHistoryStatusEnum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_SegmentHistoryStatusEnum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_SegmentHistoryStatusEnum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quality.segmentHistoryStatusEnum" */
export enum Quality_SegmentHistoryStatusEnum_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

export type Quality_SegmentHistoryStatusEnum_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_SegmentHistoryStatusEnum_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_SegmentHistoryStatusEnum_Bool_Exp;
};

/** columns and relationships of "quality.segmentHistoryView" */
export type Quality_SegmentHistoryView = {
  __typename?: 'quality_segmentHistoryView';
  hasSurfaceScan?: Maybe<Scalars['Boolean']['output']>;
  hasTunnelScan?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastScanDate?: Maybe<Scalars['timestamptz']['output']>;
  lastScanSite?: Maybe<Scalars['String']['output']>;
  lastScanSiteId?: Maybe<Scalars['uuid']['output']>;
  manufactureDate?: Maybe<Scalars['timestamptz']['output']>;
  mold?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  ringId?: Maybe<Scalars['uuid']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  scanHistory?: Maybe<Scalars['jsonb']['output']>;
  segmentType?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "quality.segmentHistoryView" */
export type Quality_SegmentHistoryViewScanHistoryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "quality.segmentHistoryView" */
export type Quality_SegmentHistoryView_Aggregate = {
  __typename?: 'quality_segmentHistoryView_aggregate';
  aggregate?: Maybe<Quality_SegmentHistoryView_Aggregate_Fields>;
  nodes: Array<Quality_SegmentHistoryView>;
};

/** aggregate fields of "quality.segmentHistoryView" */
export type Quality_SegmentHistoryView_Aggregate_Fields = {
  __typename?: 'quality_segmentHistoryView_aggregate_fields';
  avg?: Maybe<Quality_SegmentHistoryView_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_SegmentHistoryView_Max_Fields>;
  min?: Maybe<Quality_SegmentHistoryView_Min_Fields>;
  stddev?: Maybe<Quality_SegmentHistoryView_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_SegmentHistoryView_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_SegmentHistoryView_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_SegmentHistoryView_Sum_Fields>;
  var_pop?: Maybe<Quality_SegmentHistoryView_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_SegmentHistoryView_Var_Samp_Fields>;
  variance?: Maybe<Quality_SegmentHistoryView_Variance_Fields>;
};


/** aggregate fields of "quality.segmentHistoryView" */
export type Quality_SegmentHistoryView_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_SegmentHistoryView_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Quality_SegmentHistoryView_Avg_Fields = {
  __typename?: 'quality_segmentHistoryView_avg_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "quality.segmentHistoryView". All fields are combined with a logical 'AND'. */
export type Quality_SegmentHistoryView_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_SegmentHistoryView_Bool_Exp>>;
  _not?: InputMaybe<Quality_SegmentHistoryView_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_SegmentHistoryView_Bool_Exp>>;
  hasSurfaceScan?: InputMaybe<Boolean_Comparison_Exp>;
  hasTunnelScan?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastScanDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  lastScanSite?: InputMaybe<String_Comparison_Exp>;
  lastScanSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  manufactureDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  mold?: InputMaybe<String_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  ringId?: InputMaybe<Uuid_Comparison_Exp>;
  ringNumber?: InputMaybe<Int_Comparison_Exp>;
  scanHistory?: InputMaybe<Jsonb_Comparison_Exp>;
  segmentType?: InputMaybe<String_Comparison_Exp>;
  serialNumber?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Quality_SegmentHistoryView_Max_Fields = {
  __typename?: 'quality_segmentHistoryView_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  lastScanDate?: Maybe<Scalars['timestamptz']['output']>;
  lastScanSite?: Maybe<Scalars['String']['output']>;
  lastScanSiteId?: Maybe<Scalars['uuid']['output']>;
  manufactureDate?: Maybe<Scalars['timestamptz']['output']>;
  mold?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  ringId?: Maybe<Scalars['uuid']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  segmentType?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quality_SegmentHistoryView_Min_Fields = {
  __typename?: 'quality_segmentHistoryView_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  lastScanDate?: Maybe<Scalars['timestamptz']['output']>;
  lastScanSite?: Maybe<Scalars['String']['output']>;
  lastScanSiteId?: Maybe<Scalars['uuid']['output']>;
  manufactureDate?: Maybe<Scalars['timestamptz']['output']>;
  mold?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  ringId?: Maybe<Scalars['uuid']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  segmentType?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "quality.segmentHistoryView". */
export type Quality_SegmentHistoryView_Order_By = {
  hasSurfaceScan?: InputMaybe<Order_By>;
  hasTunnelScan?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastScanDate?: InputMaybe<Order_By>;
  lastScanSite?: InputMaybe<Order_By>;
  lastScanSiteId?: InputMaybe<Order_By>;
  manufactureDate?: InputMaybe<Order_By>;
  mold?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  ringId?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  scanHistory?: InputMaybe<Order_By>;
  segmentType?: InputMaybe<Order_By>;
  serialNumber?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "quality.segmentHistoryView" */
export enum Quality_SegmentHistoryView_Select_Column {
  /** column name */
  HasSurfaceScan = 'hasSurfaceScan',
  /** column name */
  HasTunnelScan = 'hasTunnelScan',
  /** column name */
  Id = 'id',
  /** column name */
  LastScanDate = 'lastScanDate',
  /** column name */
  LastScanSite = 'lastScanSite',
  /** column name */
  LastScanSiteId = 'lastScanSiteId',
  /** column name */
  ManufactureDate = 'manufactureDate',
  /** column name */
  Mold = 'mold',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  RingId = 'ringId',
  /** column name */
  RingNumber = 'ringNumber',
  /** column name */
  ScanHistory = 'scanHistory',
  /** column name */
  SegmentType = 'segmentType',
  /** column name */
  SerialNumber = 'serialNumber',
  /** column name */
  Status = 'status'
}

/** aggregate stddev on columns */
export type Quality_SegmentHistoryView_Stddev_Fields = {
  __typename?: 'quality_segmentHistoryView_stddev_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Quality_SegmentHistoryView_Stddev_Pop_Fields = {
  __typename?: 'quality_segmentHistoryView_stddev_pop_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Quality_SegmentHistoryView_Stddev_Samp_Fields = {
  __typename?: 'quality_segmentHistoryView_stddev_samp_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "quality_segmentHistoryView" */
export type Quality_SegmentHistoryView_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_SegmentHistoryView_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_SegmentHistoryView_Stream_Cursor_Value_Input = {
  hasSurfaceScan?: InputMaybe<Scalars['Boolean']['input']>;
  hasTunnelScan?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastScanDate?: InputMaybe<Scalars['timestamptz']['input']>;
  lastScanSite?: InputMaybe<Scalars['String']['input']>;
  lastScanSiteId?: InputMaybe<Scalars['uuid']['input']>;
  manufactureDate?: InputMaybe<Scalars['timestamptz']['input']>;
  mold?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  ringId?: InputMaybe<Scalars['uuid']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  scanHistory?: InputMaybe<Scalars['jsonb']['input']>;
  segmentType?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Quality_SegmentHistoryView_Sum_Fields = {
  __typename?: 'quality_segmentHistoryView_sum_fields';
  ringNumber?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Quality_SegmentHistoryView_Var_Pop_Fields = {
  __typename?: 'quality_segmentHistoryView_var_pop_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Quality_SegmentHistoryView_Var_Samp_Fields = {
  __typename?: 'quality_segmentHistoryView_var_samp_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Quality_SegmentHistoryView_Variance_Fields = {
  __typename?: 'quality_segmentHistoryView_variance_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "quality.segmentHistory" */
export type Quality_SegmentHistory_Aggregate = {
  __typename?: 'quality_segmentHistory_aggregate';
  aggregate?: Maybe<Quality_SegmentHistory_Aggregate_Fields>;
  nodes: Array<Quality_SegmentHistory>;
};

export type Quality_SegmentHistory_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quality_SegmentHistory_Aggregate_Bool_Exp_Count>;
};

export type Quality_SegmentHistory_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quality_SegmentHistory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_SegmentHistory_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quality.segmentHistory" */
export type Quality_SegmentHistory_Aggregate_Fields = {
  __typename?: 'quality_segmentHistory_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_SegmentHistory_Max_Fields>;
  min?: Maybe<Quality_SegmentHistory_Min_Fields>;
};


/** aggregate fields of "quality.segmentHistory" */
export type Quality_SegmentHistory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_SegmentHistory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quality.segmentHistory" */
export type Quality_SegmentHistory_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quality_SegmentHistory_Max_Order_By>;
  min?: InputMaybe<Quality_SegmentHistory_Min_Order_By>;
};

/** input type for inserting array relation for remote table "quality.segmentHistory" */
export type Quality_SegmentHistory_Arr_Rel_Insert_Input = {
  data: Array<Quality_SegmentHistory_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_SegmentHistory_On_Conflict>;
};

/** Boolean expression to filter rows from the table "quality.segmentHistory". All fields are combined with a logical 'AND'. */
export type Quality_SegmentHistory_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_SegmentHistory_Bool_Exp>>;
  _not?: InputMaybe<Quality_SegmentHistory_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_SegmentHistory_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  quarantineDefect?: InputMaybe<Quality_QuarantineDefect_Bool_Exp>;
  scanSite?: InputMaybe<Quality_ScanSite_Bool_Exp>;
  scanSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  scanType?: InputMaybe<Quality_ScanTypeEnum_Enum_Comparison_Exp>;
  segment?: InputMaybe<Quality_Segment_Bool_Exp>;
  segmentId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Quality_SegmentHistoryStatusEnum_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.segmentHistory" */
export enum Quality_SegmentHistory_Constraint {
  /** unique or primary key constraint on columns "id" */
  SegmentHistoryPkey = 'segmentHistory_pkey'
}

/** input type for inserting data into table "quality.segmentHistory" */
export type Quality_SegmentHistory_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  quarantineDefect?: InputMaybe<Quality_QuarantineDefect_Obj_Rel_Insert_Input>;
  scanSite?: InputMaybe<Quality_ScanSite_Obj_Rel_Insert_Input>;
  scanSiteId?: InputMaybe<Scalars['uuid']['input']>;
  scanType?: InputMaybe<Quality_ScanTypeEnum_Enum>;
  segment?: InputMaybe<Quality_Segment_Obj_Rel_Insert_Input>;
  segmentId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Quality_SegmentHistoryStatusEnum_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quality_SegmentHistory_Max_Fields = {
  __typename?: 'quality_segmentHistory_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  scanSiteId?: Maybe<Scalars['uuid']['output']>;
  segmentId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "quality.segmentHistory" */
export type Quality_SegmentHistory_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  scanSiteId?: InputMaybe<Order_By>;
  segmentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quality_SegmentHistory_Min_Fields = {
  __typename?: 'quality_segmentHistory_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  scanSiteId?: Maybe<Scalars['uuid']['output']>;
  segmentId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "quality.segmentHistory" */
export type Quality_SegmentHistory_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  scanSiteId?: InputMaybe<Order_By>;
  segmentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quality.segmentHistory" */
export type Quality_SegmentHistory_Mutation_Response = {
  __typename?: 'quality_segmentHistory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_SegmentHistory>;
};

/** on_conflict condition type for table "quality.segmentHistory" */
export type Quality_SegmentHistory_On_Conflict = {
  constraint: Quality_SegmentHistory_Constraint;
  update_columns?: Array<Quality_SegmentHistory_Update_Column>;
  where?: InputMaybe<Quality_SegmentHistory_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.segmentHistory". */
export type Quality_SegmentHistory_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  quarantineDefect?: InputMaybe<Quality_QuarantineDefect_Order_By>;
  scanSite?: InputMaybe<Quality_ScanSite_Order_By>;
  scanSiteId?: InputMaybe<Order_By>;
  scanType?: InputMaybe<Order_By>;
  segment?: InputMaybe<Quality_Segment_Order_By>;
  segmentId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.segmentHistory */
export type Quality_SegmentHistory_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.segmentHistory" */
export enum Quality_SegmentHistory_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  ScanSiteId = 'scanSiteId',
  /** column name */
  ScanType = 'scanType',
  /** column name */
  SegmentId = 'segmentId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "quality.segmentHistory" */
export type Quality_SegmentHistory_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  scanSiteId?: InputMaybe<Scalars['uuid']['input']>;
  scanType?: InputMaybe<Quality_ScanTypeEnum_Enum>;
  segmentId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Quality_SegmentHistoryStatusEnum_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "quality_segmentHistory" */
export type Quality_SegmentHistory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_SegmentHistory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_SegmentHistory_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  scanSiteId?: InputMaybe<Scalars['uuid']['input']>;
  scanType?: InputMaybe<Quality_ScanTypeEnum_Enum>;
  segmentId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Quality_SegmentHistoryStatusEnum_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "quality.segmentHistory" */
export enum Quality_SegmentHistory_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  ScanSiteId = 'scanSiteId',
  /** column name */
  ScanType = 'scanType',
  /** column name */
  SegmentId = 'segmentId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Quality_SegmentHistory_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_SegmentHistory_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_SegmentHistory_Bool_Exp;
};

/** columns and relationships of "quality.segmentRefusal" */
export type Quality_SegmentRefusal = {
  __typename?: 'quality_segmentRefusal';
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  segmentHistoryId: Scalars['uuid']['output'];
};

/** columns and relationships of "quality.segmentRefusalPicture" */
export type Quality_SegmentRefusalPicture = {
  __typename?: 'quality_segmentRefusalPicture';
  bucketFileId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  segmentRefusalId: Scalars['uuid']['output'];
};

/** aggregated selection of "quality.segmentRefusalPicture" */
export type Quality_SegmentRefusalPicture_Aggregate = {
  __typename?: 'quality_segmentRefusalPicture_aggregate';
  aggregate?: Maybe<Quality_SegmentRefusalPicture_Aggregate_Fields>;
  nodes: Array<Quality_SegmentRefusalPicture>;
};

/** aggregate fields of "quality.segmentRefusalPicture" */
export type Quality_SegmentRefusalPicture_Aggregate_Fields = {
  __typename?: 'quality_segmentRefusalPicture_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_SegmentRefusalPicture_Max_Fields>;
  min?: Maybe<Quality_SegmentRefusalPicture_Min_Fields>;
};


/** aggregate fields of "quality.segmentRefusalPicture" */
export type Quality_SegmentRefusalPicture_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_SegmentRefusalPicture_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.segmentRefusalPicture". All fields are combined with a logical 'AND'. */
export type Quality_SegmentRefusalPicture_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_SegmentRefusalPicture_Bool_Exp>>;
  _not?: InputMaybe<Quality_SegmentRefusalPicture_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_SegmentRefusalPicture_Bool_Exp>>;
  bucketFileId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  segmentRefusalId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.segmentRefusalPicture" */
export enum Quality_SegmentRefusalPicture_Constraint {
  /** unique or primary key constraint on columns "id" */
  SegmentRefusalPicturePkey = 'segmentRefusalPicture_pkey'
}

/** input type for inserting data into table "quality.segmentRefusalPicture" */
export type Quality_SegmentRefusalPicture_Insert_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  segmentRefusalId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Quality_SegmentRefusalPicture_Max_Fields = {
  __typename?: 'quality_segmentRefusalPicture_max_fields';
  bucketFileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  segmentRefusalId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Quality_SegmentRefusalPicture_Min_Fields = {
  __typename?: 'quality_segmentRefusalPicture_min_fields';
  bucketFileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  segmentRefusalId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "quality.segmentRefusalPicture" */
export type Quality_SegmentRefusalPicture_Mutation_Response = {
  __typename?: 'quality_segmentRefusalPicture_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_SegmentRefusalPicture>;
};

/** on_conflict condition type for table "quality.segmentRefusalPicture" */
export type Quality_SegmentRefusalPicture_On_Conflict = {
  constraint: Quality_SegmentRefusalPicture_Constraint;
  update_columns?: Array<Quality_SegmentRefusalPicture_Update_Column>;
  where?: InputMaybe<Quality_SegmentRefusalPicture_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.segmentRefusalPicture". */
export type Quality_SegmentRefusalPicture_Order_By = {
  bucketFileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segmentRefusalId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.segmentRefusalPicture */
export type Quality_SegmentRefusalPicture_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.segmentRefusalPicture" */
export enum Quality_SegmentRefusalPicture_Select_Column {
  /** column name */
  BucketFileId = 'bucketFileId',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentRefusalId = 'segmentRefusalId'
}

/** input type for updating data in table "quality.segmentRefusalPicture" */
export type Quality_SegmentRefusalPicture_Set_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  segmentRefusalId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "quality_segmentRefusalPicture" */
export type Quality_SegmentRefusalPicture_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_SegmentRefusalPicture_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_SegmentRefusalPicture_Stream_Cursor_Value_Input = {
  bucketFileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  segmentRefusalId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "quality.segmentRefusalPicture" */
export enum Quality_SegmentRefusalPicture_Update_Column {
  /** column name */
  BucketFileId = 'bucketFileId',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentRefusalId = 'segmentRefusalId'
}

export type Quality_SegmentRefusalPicture_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_SegmentRefusalPicture_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_SegmentRefusalPicture_Bool_Exp;
};

/** aggregated selection of "quality.segmentRefusal" */
export type Quality_SegmentRefusal_Aggregate = {
  __typename?: 'quality_segmentRefusal_aggregate';
  aggregate?: Maybe<Quality_SegmentRefusal_Aggregate_Fields>;
  nodes: Array<Quality_SegmentRefusal>;
};

/** aggregate fields of "quality.segmentRefusal" */
export type Quality_SegmentRefusal_Aggregate_Fields = {
  __typename?: 'quality_segmentRefusal_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_SegmentRefusal_Max_Fields>;
  min?: Maybe<Quality_SegmentRefusal_Min_Fields>;
};


/** aggregate fields of "quality.segmentRefusal" */
export type Quality_SegmentRefusal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_SegmentRefusal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.segmentRefusal". All fields are combined with a logical 'AND'. */
export type Quality_SegmentRefusal_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_SegmentRefusal_Bool_Exp>>;
  _not?: InputMaybe<Quality_SegmentRefusal_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_SegmentRefusal_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  segmentHistoryId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.segmentRefusal" */
export enum Quality_SegmentRefusal_Constraint {
  /** unique or primary key constraint on columns "id" */
  SegmentRefusalPkey = 'segmentRefusal_pkey'
}

/** input type for inserting data into table "quality.segmentRefusal" */
export type Quality_SegmentRefusal_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  segmentHistoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Quality_SegmentRefusal_Max_Fields = {
  __typename?: 'quality_segmentRefusal_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  segmentHistoryId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Quality_SegmentRefusal_Min_Fields = {
  __typename?: 'quality_segmentRefusal_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  segmentHistoryId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "quality.segmentRefusal" */
export type Quality_SegmentRefusal_Mutation_Response = {
  __typename?: 'quality_segmentRefusal_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_SegmentRefusal>;
};

/** on_conflict condition type for table "quality.segmentRefusal" */
export type Quality_SegmentRefusal_On_Conflict = {
  constraint: Quality_SegmentRefusal_Constraint;
  update_columns?: Array<Quality_SegmentRefusal_Update_Column>;
  where?: InputMaybe<Quality_SegmentRefusal_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.segmentRefusal". */
export type Quality_SegmentRefusal_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  segmentHistoryId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.segmentRefusal */
export type Quality_SegmentRefusal_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.segmentRefusal" */
export enum Quality_SegmentRefusal_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentHistoryId = 'segmentHistoryId'
}

/** input type for updating data in table "quality.segmentRefusal" */
export type Quality_SegmentRefusal_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  segmentHistoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "quality_segmentRefusal" */
export type Quality_SegmentRefusal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_SegmentRefusal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_SegmentRefusal_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  segmentHistoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "quality.segmentRefusal" */
export enum Quality_SegmentRefusal_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  SegmentHistoryId = 'segmentHistoryId'
}

export type Quality_SegmentRefusal_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_SegmentRefusal_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_SegmentRefusal_Bool_Exp;
};

/** aggregated selection of "quality.segment" */
export type Quality_Segment_Aggregate = {
  __typename?: 'quality_segment_aggregate';
  aggregate?: Maybe<Quality_Segment_Aggregate_Fields>;
  nodes: Array<Quality_Segment>;
};

export type Quality_Segment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Quality_Segment_Aggregate_Bool_Exp_Count>;
};

export type Quality_Segment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quality_Segment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_Segment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quality.segment" */
export type Quality_Segment_Aggregate_Fields = {
  __typename?: 'quality_segment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_Segment_Max_Fields>;
  min?: Maybe<Quality_Segment_Min_Fields>;
};


/** aggregate fields of "quality.segment" */
export type Quality_Segment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_Segment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quality.segment" */
export type Quality_Segment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quality_Segment_Max_Order_By>;
  min?: InputMaybe<Quality_Segment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "quality.segment" */
export type Quality_Segment_Arr_Rel_Insert_Input = {
  data: Array<Quality_Segment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_Segment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "quality.segment". All fields are combined with a logical 'AND'. */
export type Quality_Segment_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_Segment_Bool_Exp>>;
  _not?: InputMaybe<Quality_Segment_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_Segment_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  extraParameters?: InputMaybe<Quality_SegmentExtraParameter_Bool_Exp>;
  extraParameters_aggregate?: InputMaybe<Quality_SegmentExtraParameter_Aggregate_Bool_Exp>;
  histories?: InputMaybe<Quality_SegmentHistory_Bool_Exp>;
  histories_aggregate?: InputMaybe<Quality_SegmentHistory_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  manufactureDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  mold?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  ring?: InputMaybe<Parameter_Ring_Bool_Exp>;
  ringId?: InputMaybe<Uuid_Comparison_Exp>;
  segmentType?: InputMaybe<String_Comparison_Exp>;
  serialNumber?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.segment" */
export enum Quality_Segment_Constraint {
  /** unique or primary key constraint on columns "id" */
  SegmentPkey = 'segment_pkey',
  /** unique or primary key constraint on columns "serialNumber", "projectId" */
  SegmentProjectIdSerialNumberKey = 'segment_projectId_serialNumber_key'
}

/** input type for inserting data into table "quality.segment" */
export type Quality_Segment_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  extraParameters?: InputMaybe<Quality_SegmentExtraParameter_Arr_Rel_Insert_Input>;
  histories?: InputMaybe<Quality_SegmentHistory_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manufactureDate?: InputMaybe<Scalars['timestamptz']['input']>;
  mold?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  ring?: InputMaybe<Parameter_Ring_Obj_Rel_Insert_Input>;
  ringId?: InputMaybe<Scalars['uuid']['input']>;
  segmentType?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quality_Segment_Max_Fields = {
  __typename?: 'quality_segment_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  manufactureDate?: Maybe<Scalars['timestamptz']['output']>;
  mold?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  ringId?: Maybe<Scalars['uuid']['output']>;
  segmentType?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "quality.segment" */
export type Quality_Segment_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manufactureDate?: InputMaybe<Order_By>;
  mold?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  ringId?: InputMaybe<Order_By>;
  segmentType?: InputMaybe<Order_By>;
  serialNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quality_Segment_Min_Fields = {
  __typename?: 'quality_segment_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  manufactureDate?: Maybe<Scalars['timestamptz']['output']>;
  mold?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  ringId?: Maybe<Scalars['uuid']['output']>;
  segmentType?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "quality.segment" */
export type Quality_Segment_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  manufactureDate?: InputMaybe<Order_By>;
  mold?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  ringId?: InputMaybe<Order_By>;
  segmentType?: InputMaybe<Order_By>;
  serialNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quality.segment" */
export type Quality_Segment_Mutation_Response = {
  __typename?: 'quality_segment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_Segment>;
};

/** input type for inserting object relation for remote table "quality.segment" */
export type Quality_Segment_Obj_Rel_Insert_Input = {
  data: Quality_Segment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_Segment_On_Conflict>;
};

/** on_conflict condition type for table "quality.segment" */
export type Quality_Segment_On_Conflict = {
  constraint: Quality_Segment_Constraint;
  update_columns?: Array<Quality_Segment_Update_Column>;
  where?: InputMaybe<Quality_Segment_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.segment". */
export type Quality_Segment_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  extraParameters_aggregate?: InputMaybe<Quality_SegmentExtraParameter_Aggregate_Order_By>;
  histories_aggregate?: InputMaybe<Quality_SegmentHistory_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  manufactureDate?: InputMaybe<Order_By>;
  mold?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  ring?: InputMaybe<Parameter_Ring_Order_By>;
  ringId?: InputMaybe<Order_By>;
  segmentType?: InputMaybe<Order_By>;
  serialNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.segment */
export type Quality_Segment_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.segment" */
export enum Quality_Segment_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ManufactureDate = 'manufactureDate',
  /** column name */
  Mold = 'mold',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  RingId = 'ringId',
  /** column name */
  SegmentType = 'segmentType',
  /** column name */
  SerialNumber = 'serialNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "quality.segment" */
export type Quality_Segment_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manufactureDate?: InputMaybe<Scalars['timestamptz']['input']>;
  mold?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  ringId?: InputMaybe<Scalars['uuid']['input']>;
  segmentType?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "quality_segment" */
export type Quality_Segment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_Segment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_Segment_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  manufactureDate?: InputMaybe<Scalars['timestamptz']['input']>;
  mold?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  ringId?: InputMaybe<Scalars['uuid']['input']>;
  segmentType?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "quality.segment" */
export enum Quality_Segment_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ManufactureDate = 'manufactureDate',
  /** column name */
  Mold = 'mold',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  RingId = 'ringId',
  /** column name */
  SegmentType = 'segmentType',
  /** column name */
  SerialNumber = 'serialNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Quality_Segment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_Segment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_Segment_Bool_Exp;
};

/** columns and relationships of "quality.shapeEnum" */
export type Quality_ShapeEnum = {
  __typename?: 'quality_shapeEnum';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

/** aggregated selection of "quality.shapeEnum" */
export type Quality_ShapeEnum_Aggregate = {
  __typename?: 'quality_shapeEnum_aggregate';
  aggregate?: Maybe<Quality_ShapeEnum_Aggregate_Fields>;
  nodes: Array<Quality_ShapeEnum>;
};

/** aggregate fields of "quality.shapeEnum" */
export type Quality_ShapeEnum_Aggregate_Fields = {
  __typename?: 'quality_shapeEnum_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_ShapeEnum_Max_Fields>;
  min?: Maybe<Quality_ShapeEnum_Min_Fields>;
};


/** aggregate fields of "quality.shapeEnum" */
export type Quality_ShapeEnum_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_ShapeEnum_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quality.shapeEnum". All fields are combined with a logical 'AND'. */
export type Quality_ShapeEnum_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_ShapeEnum_Bool_Exp>>;
  _not?: InputMaybe<Quality_ShapeEnum_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_ShapeEnum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.shapeEnum" */
export enum Quality_ShapeEnum_Constraint {
  /** unique or primary key constraint on columns "id" */
  ShapeEnumPkey = 'shapeEnum_pkey'
}

export enum Quality_ShapeEnum_Enum {
  HalfKey = 'HALF_KEY',
  InvertKey = 'INVERT_KEY',
  Key = 'KEY',
  TiltLeft = 'TILT_LEFT',
  TiltRight = 'TILT_RIGHT'
}

/** Boolean expression to compare columns of type "quality_shapeEnum_enum". All fields are combined with logical 'AND'. */
export type Quality_ShapeEnum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Quality_ShapeEnum_Enum>;
  _in?: InputMaybe<Array<Quality_ShapeEnum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Quality_ShapeEnum_Enum>;
  _nin?: InputMaybe<Array<Quality_ShapeEnum_Enum>>;
};

/** input type for inserting data into table "quality.shapeEnum" */
export type Quality_ShapeEnum_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Quality_ShapeEnum_Max_Fields = {
  __typename?: 'quality_shapeEnum_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quality_ShapeEnum_Min_Fields = {
  __typename?: 'quality_shapeEnum_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quality.shapeEnum" */
export type Quality_ShapeEnum_Mutation_Response = {
  __typename?: 'quality_shapeEnum_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_ShapeEnum>;
};

/** on_conflict condition type for table "quality.shapeEnum" */
export type Quality_ShapeEnum_On_Conflict = {
  constraint: Quality_ShapeEnum_Constraint;
  update_columns?: Array<Quality_ShapeEnum_Update_Column>;
  where?: InputMaybe<Quality_ShapeEnum_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.shapeEnum". */
export type Quality_ShapeEnum_Order_By = {
  comment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.shapeEnum */
export type Quality_ShapeEnum_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "quality.shapeEnum" */
export enum Quality_ShapeEnum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "quality.shapeEnum" */
export type Quality_ShapeEnum_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quality_shapeEnum" */
export type Quality_ShapeEnum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_ShapeEnum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_ShapeEnum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quality.shapeEnum" */
export enum Quality_ShapeEnum_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Id = 'id'
}

export type Quality_ShapeEnum_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_ShapeEnum_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_ShapeEnum_Bool_Exp;
};

/** columns and relationships of "quality.tunnelPosition" */
export type Quality_TunnelPosition = {
  __typename?: 'quality_tunnelPosition';
  angle: Scalars['float8']['output'];
  /** An object relationship */
  boardConfig?: Maybe<Quality_BoardConfig>;
  boardConfigId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  keyPosition: Scalars['Int']['output'];
  positionX: Scalars['Int']['output'];
};

/** aggregated selection of "quality.tunnelPosition" */
export type Quality_TunnelPosition_Aggregate = {
  __typename?: 'quality_tunnelPosition_aggregate';
  aggregate?: Maybe<Quality_TunnelPosition_Aggregate_Fields>;
  nodes: Array<Quality_TunnelPosition>;
};

export type Quality_TunnelPosition_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Quality_TunnelPosition_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Quality_TunnelPosition_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Quality_TunnelPosition_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Quality_TunnelPosition_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Quality_TunnelPosition_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Quality_TunnelPosition_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Quality_TunnelPosition_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Quality_TunnelPosition_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Quality_TunnelPosition_Aggregate_Bool_Exp_Var_Samp>;
};

export type Quality_TunnelPosition_Aggregate_Bool_Exp_Avg = {
  arguments: Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quality_TunnelPosition_Aggregate_Bool_Exp_Corr = {
  arguments: Quality_TunnelPosition_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quality_TunnelPosition_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Quality_TunnelPosition_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quality_TunnelPosition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Quality_TunnelPosition_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Quality_TunnelPosition_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quality_TunnelPosition_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Quality_TunnelPosition_Aggregate_Bool_Exp_Max = {
  arguments: Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quality_TunnelPosition_Aggregate_Bool_Exp_Min = {
  arguments: Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quality_TunnelPosition_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quality_TunnelPosition_Aggregate_Bool_Exp_Sum = {
  arguments: Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quality_TunnelPosition_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "quality.tunnelPosition" */
export type Quality_TunnelPosition_Aggregate_Fields = {
  __typename?: 'quality_tunnelPosition_aggregate_fields';
  avg?: Maybe<Quality_TunnelPosition_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_TunnelPosition_Max_Fields>;
  min?: Maybe<Quality_TunnelPosition_Min_Fields>;
  stddev?: Maybe<Quality_TunnelPosition_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_TunnelPosition_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_TunnelPosition_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_TunnelPosition_Sum_Fields>;
  var_pop?: Maybe<Quality_TunnelPosition_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_TunnelPosition_Var_Samp_Fields>;
  variance?: Maybe<Quality_TunnelPosition_Variance_Fields>;
};


/** aggregate fields of "quality.tunnelPosition" */
export type Quality_TunnelPosition_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_TunnelPosition_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Aggregate_Order_By = {
  avg?: InputMaybe<Quality_TunnelPosition_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quality_TunnelPosition_Max_Order_By>;
  min?: InputMaybe<Quality_TunnelPosition_Min_Order_By>;
  stddev?: InputMaybe<Quality_TunnelPosition_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quality_TunnelPosition_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quality_TunnelPosition_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quality_TunnelPosition_Sum_Order_By>;
  var_pop?: InputMaybe<Quality_TunnelPosition_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quality_TunnelPosition_Var_Samp_Order_By>;
  variance?: InputMaybe<Quality_TunnelPosition_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Arr_Rel_Insert_Input = {
  data: Array<Quality_TunnelPosition_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_TunnelPosition_On_Conflict>;
};

/** aggregate avg on columns */
export type Quality_TunnelPosition_Avg_Fields = {
  __typename?: 'quality_tunnelPosition_avg_fields';
  angle?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  positionX?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Avg_Order_By = {
  angle?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  positionX?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quality.tunnelPosition". All fields are combined with a logical 'AND'. */
export type Quality_TunnelPosition_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_TunnelPosition_Bool_Exp>>;
  _not?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_TunnelPosition_Bool_Exp>>;
  angle?: InputMaybe<Float8_Comparison_Exp>;
  boardConfig?: InputMaybe<Quality_BoardConfig_Bool_Exp>;
  boardConfigId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  keyPosition?: InputMaybe<Int_Comparison_Exp>;
  positionX?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.tunnelPosition" */
export enum Quality_TunnelPosition_Constraint {
  /** unique or primary key constraint on columns "id" */
  TunnelPositionPkey = 'tunnelPosition_pkey'
}

/** input type for incrementing numeric columns in table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Inc_Input = {
  angle?: InputMaybe<Scalars['float8']['input']>;
  keyPosition?: InputMaybe<Scalars['Int']['input']>;
  positionX?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Insert_Input = {
  angle?: InputMaybe<Scalars['float8']['input']>;
  boardConfig?: InputMaybe<Quality_BoardConfig_Obj_Rel_Insert_Input>;
  boardConfigId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  keyPosition?: InputMaybe<Scalars['Int']['input']>;
  positionX?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Quality_TunnelPosition_Max_Fields = {
  __typename?: 'quality_tunnelPosition_max_fields';
  angle?: Maybe<Scalars['float8']['output']>;
  boardConfigId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  keyPosition?: Maybe<Scalars['Int']['output']>;
  positionX?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Max_Order_By = {
  angle?: InputMaybe<Order_By>;
  boardConfigId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  positionX?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quality_TunnelPosition_Min_Fields = {
  __typename?: 'quality_tunnelPosition_min_fields';
  angle?: Maybe<Scalars['float8']['output']>;
  boardConfigId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  keyPosition?: Maybe<Scalars['Int']['output']>;
  positionX?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Min_Order_By = {
  angle?: InputMaybe<Order_By>;
  boardConfigId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  positionX?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Mutation_Response = {
  __typename?: 'quality_tunnelPosition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_TunnelPosition>;
};

/** on_conflict condition type for table "quality.tunnelPosition" */
export type Quality_TunnelPosition_On_Conflict = {
  constraint: Quality_TunnelPosition_Constraint;
  update_columns?: Array<Quality_TunnelPosition_Update_Column>;
  where?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.tunnelPosition". */
export type Quality_TunnelPosition_Order_By = {
  angle?: InputMaybe<Order_By>;
  boardConfig?: InputMaybe<Quality_BoardConfig_Order_By>;
  boardConfigId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  positionX?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.tunnelPosition */
export type Quality_TunnelPosition_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.tunnelPosition" */
export enum Quality_TunnelPosition_Select_Column {
  /** column name */
  Angle = 'angle',
  /** column name */
  BoardConfigId = 'boardConfigId',
  /** column name */
  Id = 'id',
  /** column name */
  KeyPosition = 'keyPosition',
  /** column name */
  PositionX = 'positionX'
}

/** select "quality_tunnelPosition_aggregate_bool_exp_avg_arguments_columns" columns of table "quality.tunnelPosition" */
export enum Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Angle = 'angle'
}

/** select "quality_tunnelPosition_aggregate_bool_exp_corr_arguments_columns" columns of table "quality.tunnelPosition" */
export enum Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Angle = 'angle'
}

/** select "quality_tunnelPosition_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "quality.tunnelPosition" */
export enum Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Angle = 'angle'
}

/** select "quality_tunnelPosition_aggregate_bool_exp_max_arguments_columns" columns of table "quality.tunnelPosition" */
export enum Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Angle = 'angle'
}

/** select "quality_tunnelPosition_aggregate_bool_exp_min_arguments_columns" columns of table "quality.tunnelPosition" */
export enum Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Angle = 'angle'
}

/** select "quality_tunnelPosition_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "quality.tunnelPosition" */
export enum Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Angle = 'angle'
}

/** select "quality_tunnelPosition_aggregate_bool_exp_sum_arguments_columns" columns of table "quality.tunnelPosition" */
export enum Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Angle = 'angle'
}

/** select "quality_tunnelPosition_aggregate_bool_exp_var_samp_arguments_columns" columns of table "quality.tunnelPosition" */
export enum Quality_TunnelPosition_Select_Column_Quality_TunnelPosition_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Angle = 'angle'
}

/** input type for updating data in table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Set_Input = {
  angle?: InputMaybe<Scalars['float8']['input']>;
  boardConfigId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  keyPosition?: InputMaybe<Scalars['Int']['input']>;
  positionX?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Quality_TunnelPosition_Stddev_Fields = {
  __typename?: 'quality_tunnelPosition_stddev_fields';
  angle?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  positionX?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Stddev_Order_By = {
  angle?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  positionX?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quality_TunnelPosition_Stddev_Pop_Fields = {
  __typename?: 'quality_tunnelPosition_stddev_pop_fields';
  angle?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  positionX?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Stddev_Pop_Order_By = {
  angle?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  positionX?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quality_TunnelPosition_Stddev_Samp_Fields = {
  __typename?: 'quality_tunnelPosition_stddev_samp_fields';
  angle?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  positionX?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Stddev_Samp_Order_By = {
  angle?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  positionX?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quality_tunnelPosition" */
export type Quality_TunnelPosition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_TunnelPosition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_TunnelPosition_Stream_Cursor_Value_Input = {
  angle?: InputMaybe<Scalars['float8']['input']>;
  boardConfigId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  keyPosition?: InputMaybe<Scalars['Int']['input']>;
  positionX?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Quality_TunnelPosition_Sum_Fields = {
  __typename?: 'quality_tunnelPosition_sum_fields';
  angle?: Maybe<Scalars['float8']['output']>;
  keyPosition?: Maybe<Scalars['Int']['output']>;
  positionX?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Sum_Order_By = {
  angle?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  positionX?: InputMaybe<Order_By>;
};

/** update columns of table "quality.tunnelPosition" */
export enum Quality_TunnelPosition_Update_Column {
  /** column name */
  Angle = 'angle',
  /** column name */
  BoardConfigId = 'boardConfigId',
  /** column name */
  Id = 'id',
  /** column name */
  KeyPosition = 'keyPosition',
  /** column name */
  PositionX = 'positionX'
}

export type Quality_TunnelPosition_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quality_TunnelPosition_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_TunnelPosition_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_TunnelPosition_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quality_TunnelPosition_Var_Pop_Fields = {
  __typename?: 'quality_tunnelPosition_var_pop_fields';
  angle?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  positionX?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Var_Pop_Order_By = {
  angle?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  positionX?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quality_TunnelPosition_Var_Samp_Fields = {
  __typename?: 'quality_tunnelPosition_var_samp_fields';
  angle?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  positionX?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Var_Samp_Order_By = {
  angle?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  positionX?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quality_TunnelPosition_Variance_Fields = {
  __typename?: 'quality_tunnelPosition_variance_fields';
  angle?: Maybe<Scalars['Float']['output']>;
  keyPosition?: Maybe<Scalars['Float']['output']>;
  positionX?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quality.tunnelPosition" */
export type Quality_TunnelPosition_Variance_Order_By = {
  angle?: InputMaybe<Order_By>;
  keyPosition?: InputMaybe<Order_By>;
  positionX?: InputMaybe<Order_By>;
};

/** columns and relationships of "quality.userQualityRole" */
export type Quality_UserQualityRole = {
  __typename?: 'quality_userQualityRole';
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  repairEditor: Scalars['Boolean']['output'];
  reportEditor: Scalars['Boolean']['output'];
  ringComplianceEditor: Scalars['Boolean']['output'];
  /** An object relationship */
  user: User;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "quality.userQualityRole" */
export type Quality_UserQualityRole_Aggregate = {
  __typename?: 'quality_userQualityRole_aggregate';
  aggregate?: Maybe<Quality_UserQualityRole_Aggregate_Fields>;
  nodes: Array<Quality_UserQualityRole>;
};

export type Quality_UserQualityRole_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Quality_UserQualityRole_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quality_UserQualityRole_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Quality_UserQualityRole_Aggregate_Bool_Exp_Count>;
};

export type Quality_UserQualityRole_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quality_UserQualityRole_Select_Column_Quality_UserQualityRole_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quality_UserQualityRole_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quality_UserQualityRole_Select_Column_Quality_UserQualityRole_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quality_UserQualityRole_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quality_UserQualityRole_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quality.userQualityRole" */
export type Quality_UserQualityRole_Aggregate_Fields = {
  __typename?: 'quality_userQualityRole_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_UserQualityRole_Max_Fields>;
  min?: Maybe<Quality_UserQualityRole_Min_Fields>;
};


/** aggregate fields of "quality.userQualityRole" */
export type Quality_UserQualityRole_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_UserQualityRole_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quality.userQualityRole" */
export type Quality_UserQualityRole_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quality_UserQualityRole_Max_Order_By>;
  min?: InputMaybe<Quality_UserQualityRole_Min_Order_By>;
};

/** input type for inserting array relation for remote table "quality.userQualityRole" */
export type Quality_UserQualityRole_Arr_Rel_Insert_Input = {
  data: Array<Quality_UserQualityRole_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quality_UserQualityRole_On_Conflict>;
};

/** Boolean expression to filter rows from the table "quality.userQualityRole". All fields are combined with a logical 'AND'. */
export type Quality_UserQualityRole_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_UserQualityRole_Bool_Exp>>;
  _not?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_UserQualityRole_Bool_Exp>>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  repairEditor?: InputMaybe<Boolean_Comparison_Exp>;
  reportEditor?: InputMaybe<Boolean_Comparison_Exp>;
  ringComplianceEditor?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.userQualityRole" */
export enum Quality_UserQualityRole_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserQualityRolePkey = 'userQualityRole_pkey',
  /** unique or primary key constraint on columns "userId", "constructionSiteId" */
  UserQualityRoleUserIdConstructionSiteIdKey = 'userQualityRole_userId_constructionSiteId_key'
}

/** input type for inserting data into table "quality.userQualityRole" */
export type Quality_UserQualityRole_Insert_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  repairEditor?: InputMaybe<Scalars['Boolean']['input']>;
  reportEditor?: InputMaybe<Scalars['Boolean']['input']>;
  ringComplianceEditor?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Quality_UserQualityRole_Max_Fields = {
  __typename?: 'quality_userQualityRole_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "quality.userQualityRole" */
export type Quality_UserQualityRole_Max_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quality_UserQualityRole_Min_Fields = {
  __typename?: 'quality_userQualityRole_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "quality.userQualityRole" */
export type Quality_UserQualityRole_Min_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quality.userQualityRole" */
export type Quality_UserQualityRole_Mutation_Response = {
  __typename?: 'quality_userQualityRole_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_UserQualityRole>;
};

/** on_conflict condition type for table "quality.userQualityRole" */
export type Quality_UserQualityRole_On_Conflict = {
  constraint: Quality_UserQualityRole_Constraint;
  update_columns?: Array<Quality_UserQualityRole_Update_Column>;
  where?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.userQualityRole". */
export type Quality_UserQualityRole_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  repairEditor?: InputMaybe<Order_By>;
  reportEditor?: InputMaybe<Order_By>;
  ringComplianceEditor?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.userQualityRole */
export type Quality_UserQualityRole_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.userQualityRole" */
export enum Quality_UserQualityRole_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  RepairEditor = 'repairEditor',
  /** column name */
  ReportEditor = 'reportEditor',
  /** column name */
  RingComplianceEditor = 'ringComplianceEditor',
  /** column name */
  UserId = 'userId'
}

/** select "quality_userQualityRole_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quality.userQualityRole" */
export enum Quality_UserQualityRole_Select_Column_Quality_UserQualityRole_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  RepairEditor = 'repairEditor',
  /** column name */
  ReportEditor = 'reportEditor',
  /** column name */
  RingComplianceEditor = 'ringComplianceEditor'
}

/** select "quality_userQualityRole_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quality.userQualityRole" */
export enum Quality_UserQualityRole_Select_Column_Quality_UserQualityRole_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  RepairEditor = 'repairEditor',
  /** column name */
  ReportEditor = 'reportEditor',
  /** column name */
  RingComplianceEditor = 'ringComplianceEditor'
}

/** input type for updating data in table "quality.userQualityRole" */
export type Quality_UserQualityRole_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  repairEditor?: InputMaybe<Scalars['Boolean']['input']>;
  reportEditor?: InputMaybe<Scalars['Boolean']['input']>;
  ringComplianceEditor?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "quality_userQualityRole" */
export type Quality_UserQualityRole_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_UserQualityRole_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_UserQualityRole_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  repairEditor?: InputMaybe<Scalars['Boolean']['input']>;
  reportEditor?: InputMaybe<Scalars['Boolean']['input']>;
  ringComplianceEditor?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "quality.userQualityRole" */
export enum Quality_UserQualityRole_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  RepairEditor = 'repairEditor',
  /** column name */
  ReportEditor = 'reportEditor',
  /** column name */
  RingComplianceEditor = 'ringComplianceEditor',
  /** column name */
  UserId = 'userId'
}

export type Quality_UserQualityRole_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_UserQualityRole_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_UserQualityRole_Bool_Exp;
};

/** columns and relationships of "quality.virtualRing" */
export type Quality_VirtualRing = {
  __typename?: 'quality_virtualRing';
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  ringNumber: Scalars['Int']['output'];
  segmentId: Scalars['uuid']['output'];
};

/** aggregated selection of "quality.virtualRing" */
export type Quality_VirtualRing_Aggregate = {
  __typename?: 'quality_virtualRing_aggregate';
  aggregate?: Maybe<Quality_VirtualRing_Aggregate_Fields>;
  nodes: Array<Quality_VirtualRing>;
};

/** aggregate fields of "quality.virtualRing" */
export type Quality_VirtualRing_Aggregate_Fields = {
  __typename?: 'quality_virtualRing_aggregate_fields';
  avg?: Maybe<Quality_VirtualRing_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quality_VirtualRing_Max_Fields>;
  min?: Maybe<Quality_VirtualRing_Min_Fields>;
  stddev?: Maybe<Quality_VirtualRing_Stddev_Fields>;
  stddev_pop?: Maybe<Quality_VirtualRing_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quality_VirtualRing_Stddev_Samp_Fields>;
  sum?: Maybe<Quality_VirtualRing_Sum_Fields>;
  var_pop?: Maybe<Quality_VirtualRing_Var_Pop_Fields>;
  var_samp?: Maybe<Quality_VirtualRing_Var_Samp_Fields>;
  variance?: Maybe<Quality_VirtualRing_Variance_Fields>;
};


/** aggregate fields of "quality.virtualRing" */
export type Quality_VirtualRing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quality_VirtualRing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Quality_VirtualRing_Avg_Fields = {
  __typename?: 'quality_virtualRing_avg_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "quality.virtualRing". All fields are combined with a logical 'AND'. */
export type Quality_VirtualRing_Bool_Exp = {
  _and?: InputMaybe<Array<Quality_VirtualRing_Bool_Exp>>;
  _not?: InputMaybe<Quality_VirtualRing_Bool_Exp>;
  _or?: InputMaybe<Array<Quality_VirtualRing_Bool_Exp>>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ringNumber?: InputMaybe<Int_Comparison_Exp>;
  segmentId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quality.virtualRing" */
export enum Quality_VirtualRing_Constraint {
  /** unique or primary key constraint on columns "segmentId" */
  UniqueVirtualRingSegmentId = 'unique_virtual_ring_segment_id',
  /** unique or primary key constraint on columns "id" */
  VirtualRingPkey = 'virtualRing_pkey'
}

/** input type for incrementing numeric columns in table "quality.virtualRing" */
export type Quality_VirtualRing_Inc_Input = {
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quality.virtualRing" */
export type Quality_VirtualRing_Insert_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  segmentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Quality_VirtualRing_Max_Fields = {
  __typename?: 'quality_virtualRing_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  segmentId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Quality_VirtualRing_Min_Fields = {
  __typename?: 'quality_virtualRing_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ringNumber?: Maybe<Scalars['Int']['output']>;
  segmentId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "quality.virtualRing" */
export type Quality_VirtualRing_Mutation_Response = {
  __typename?: 'quality_virtualRing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quality_VirtualRing>;
};

/** on_conflict condition type for table "quality.virtualRing" */
export type Quality_VirtualRing_On_Conflict = {
  constraint: Quality_VirtualRing_Constraint;
  update_columns?: Array<Quality_VirtualRing_Update_Column>;
  where?: InputMaybe<Quality_VirtualRing_Bool_Exp>;
};

/** Ordering options when selecting data from "quality.virtualRing". */
export type Quality_VirtualRing_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ringNumber?: InputMaybe<Order_By>;
  segmentId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quality.virtualRing */
export type Quality_VirtualRing_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quality.virtualRing" */
export enum Quality_VirtualRing_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  RingNumber = 'ringNumber',
  /** column name */
  SegmentId = 'segmentId'
}

/** input type for updating data in table "quality.virtualRing" */
export type Quality_VirtualRing_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  segmentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Quality_VirtualRing_Stddev_Fields = {
  __typename?: 'quality_virtualRing_stddev_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Quality_VirtualRing_Stddev_Pop_Fields = {
  __typename?: 'quality_virtualRing_stddev_pop_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Quality_VirtualRing_Stddev_Samp_Fields = {
  __typename?: 'quality_virtualRing_stddev_samp_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "quality_virtualRing" */
export type Quality_VirtualRing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quality_VirtualRing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quality_VirtualRing_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ringNumber?: InputMaybe<Scalars['Int']['input']>;
  segmentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Quality_VirtualRing_Sum_Fields = {
  __typename?: 'quality_virtualRing_sum_fields';
  ringNumber?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "quality.virtualRing" */
export enum Quality_VirtualRing_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  RingNumber = 'ringNumber',
  /** column name */
  SegmentId = 'segmentId'
}

export type Quality_VirtualRing_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quality_VirtualRing_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quality_VirtualRing_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quality_VirtualRing_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quality_VirtualRing_Var_Pop_Fields = {
  __typename?: 'quality_virtualRing_var_pop_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Quality_VirtualRing_Var_Samp_Fields = {
  __typename?: 'quality_virtualRing_var_samp_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Quality_VirtualRing_Variance_Fields = {
  __typename?: 'quality_virtualRing_variance_fields';
  ringNumber?: Maybe<Scalars['Float']['output']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "activity" */
  activity: Array<Activity>;
  /** fetch data from the table: "activityFullName" */
  activityFullName: Array<ActivityFullName>;
  /** fetch aggregated fields from the table: "activityFullName" */
  activityFullName_aggregate: ActivityFullName_Aggregate;
  /** fetch aggregated fields from the table: "activity" */
  activity_aggregate: Activity_Aggregate;
  /** fetch data from the table: "activity" using primary key columns */
  activity_by_pk?: Maybe<Activity>;
  /** fetch data from the table: "autofillApi" */
  autofillApi: Array<AutofillApi>;
  /** fetch aggregated fields from the table: "autofillApi" */
  autofillApi_aggregate: AutofillApi_Aggregate;
  /** fetch data from the table: "autofillApi" using primary key columns */
  autofillApi_by_pk?: Maybe<AutofillApi>;
  /** Calculate aggregated indicators results */
  calculateAggregatedIndicatorResults?: Maybe<ShiftReportIndicatorsResults>;
  /** Calculate shiftReport indicators results */
  calculateIndicatorResults?: Maybe<ShiftReportIndicatorsResults>;
  /** fetch data from the table: "constructionSite" */
  constructionSite: Array<ConstructionSite>;
  /** fetch data from the table: "constructionSiteEnabledModule" */
  constructionSiteEnabledModule: Array<ConstructionSiteEnabledModule>;
  /** fetch aggregated fields from the table: "constructionSiteEnabledModule" */
  constructionSiteEnabledModule_aggregate: ConstructionSiteEnabledModule_Aggregate;
  /** fetch data from the table: "constructionSiteEnabledModule" using primary key columns */
  constructionSiteEnabledModule_by_pk?: Maybe<ConstructionSiteEnabledModule>;
  /** fetch aggregated fields from the table: "constructionSite" */
  constructionSite_aggregate: ConstructionSite_Aggregate;
  /** fetch data from the table: "constructionSite" using primary key columns */
  constructionSite_by_pk?: Maybe<ConstructionSite>;
  /** Create a link to read resource on private bucket */
  createFileDownloadTempUrl?: Maybe<TempUrlResponse>;
  /** Create an array of links to read resources on private bucket */
  createFilesDownloadTempUrls?: Maybe<TempUrlsResponse>;
  /** fetch data from the table: "dailyShiftTemplate" */
  dailyShiftTemplate: Array<DailyShiftTemplate>;
  /** fetch aggregated fields from the table: "dailyShiftTemplate" */
  dailyShiftTemplate_aggregate: DailyShiftTemplate_Aggregate;
  /** fetch data from the table: "dailyShiftTemplate" using primary key columns */
  dailyShiftTemplate_by_pk?: Maybe<DailyShiftTemplate>;
  doesTimescaleTableExists: Scalars['Boolean']['output'];
  externalAPICall?: Maybe<Scalars['String']['output']>;
  /** fetch data from the table: "file.bucketFile" */
  file_bucketFile: Array<File_BucketFile>;
  /** fetch aggregated fields from the table: "file.bucketFile" */
  file_bucketFile_aggregate: File_BucketFile_Aggregate;
  /** fetch data from the table: "file.bucketFile" using primary key columns */
  file_bucketFile_by_pk?: Maybe<File_BucketFile>;
  /** fetch data from the table: "file.bucketTypeEnum" */
  file_bucketTypeEnum: Array<File_BucketTypeEnum>;
  /** fetch aggregated fields from the table: "file.bucketTypeEnum" */
  file_bucketTypeEnum_aggregate: File_BucketTypeEnum_Aggregate;
  /** fetch data from the table: "file.bucketTypeEnum" using primary key columns */
  file_bucketTypeEnum_by_pk?: Maybe<File_BucketTypeEnum>;
  /** fetch data from the table: "graphSet" */
  graphSet: Array<GraphSet>;
  /** fetch data from the table: "graphSetTypeEnum" */
  graphSetTypeEnum: Array<GraphSetTypeEnum>;
  /** fetch aggregated fields from the table: "graphSetTypeEnum" */
  graphSetTypeEnum_aggregate: GraphSetTypeEnum_Aggregate;
  /** fetch data from the table: "graphSetTypeEnum" using primary key columns */
  graphSetTypeEnum_by_pk?: Maybe<GraphSetTypeEnum>;
  /** fetch aggregated fields from the table: "graphSet" */
  graphSet_aggregate: GraphSet_Aggregate;
  /** fetch data from the table: "graphSet" using primary key columns */
  graphSet_by_pk?: Maybe<GraphSet>;
  hello?: Maybe<Scalars['String']['output']>;
  /** fetch data from the table: "indicator" */
  indicator: Array<Indicator>;
  /** Analyse indicators data */
  indicatorAnalysisData: IndicatorAnalysisDataOutput;
  /** List all indicator variables */
  indicatorVariables?: Maybe<IndicatorVariablesResults>;
  /** fetch aggregated fields from the table: "indicator" */
  indicator_aggregate: Indicator_Aggregate;
  /** fetch data from the table: "indicator" using primary key columns */
  indicator_by_pk?: Maybe<Indicator>;
  /** fetch data from the table: "mapConfiguration" */
  mapConfiguration: Array<MapConfiguration>;
  /** fetch aggregated fields from the table: "mapConfiguration" */
  mapConfiguration_aggregate: MapConfiguration_Aggregate;
  /** fetch data from the table: "mapConfiguration" using primary key columns */
  mapConfiguration_by_pk?: Maybe<MapConfiguration>;
  /** fetch data from the table: "mapPoi" */
  mapPoi: Array<MapPoi>;
  /** fetch aggregated fields from the table: "mapPoi" */
  mapPoi_aggregate: MapPoi_Aggregate;
  /** fetch data from the table: "mapPoi" using primary key columns */
  mapPoi_by_pk?: Maybe<MapPoi>;
  /** fetch data from the table: "mapTrace" */
  mapTrace: Array<MapTrace>;
  /** fetch aggregated fields from the table: "mapTrace" */
  mapTrace_aggregate: MapTrace_Aggregate;
  /** fetch data from the table: "mapTrace" using primary key columns */
  mapTrace_by_pk?: Maybe<MapTrace>;
  /** fetch data from the table: "module" */
  module: Array<Module>;
  /** fetch aggregated fields from the table: "module" */
  module_aggregate: Module_Aggregate;
  /** fetch data from the table: "module" using primary key columns */
  module_by_pk?: Maybe<Module>;
  /** fetch data from the table: "operator" */
  operator: Array<Operator>;
  /** fetch aggregated fields from the table: "operator" */
  operator_aggregate: Operator_Aggregate;
  /** fetch data from the table: "operator" using primary key columns */
  operator_by_pk?: Maybe<Operator>;
  /** fetch data from the table: "parameter.constructionSiteParameterNameConfig" */
  parameter_constructionSiteParameterNameConfig: Array<Parameter_ConstructionSiteParameterNameConfig>;
  /** fetch aggregated fields from the table: "parameter.constructionSiteParameterNameConfig" */
  parameter_constructionSiteParameterNameConfig_aggregate: Parameter_ConstructionSiteParameterNameConfig_Aggregate;
  /** fetch data from the table: "parameter.constructionSiteParameterNameConfig" using primary key columns */
  parameter_constructionSiteParameterNameConfig_by_pk?: Maybe<Parameter_ConstructionSiteParameterNameConfig>;
  /** fetch data from the table: "parameter.familyDef" */
  parameter_familyDef: Array<Parameter_FamilyDef>;
  /** fetch aggregated fields from the table: "parameter.familyDef" */
  parameter_familyDef_aggregate: Parameter_FamilyDef_Aggregate;
  /** fetch data from the table: "parameter.familyDef" using primary key columns */
  parameter_familyDef_by_pk?: Maybe<Parameter_FamilyDef>;
  /** fetch data from the table: "parameter.metric" */
  parameter_metric: Array<Parameter_Metric>;
  /** fetch aggregated fields from the table: "parameter.metric" */
  parameter_metric_aggregate: Parameter_Metric_Aggregate;
  /** fetch data from the table: "parameter.metric" using primary key columns */
  parameter_metric_by_pk?: Maybe<Parameter_Metric>;
  /** fetch data from the table: "parameter.parameterDef" */
  parameter_parameterDef: Array<Parameter_ParameterDef>;
  /** fetch aggregated fields from the table: "parameter.parameterDef" */
  parameter_parameterDef_aggregate: Parameter_ParameterDef_Aggregate;
  /** fetch data from the table: "parameter.parameterDef" using primary key columns */
  parameter_parameterDef_by_pk?: Maybe<Parameter_ParameterDef>;
  /** fetch data from the table: "parameter.ring" */
  parameter_ring: Array<Parameter_Ring>;
  /** fetch data from the table: "parameter.ringProjection" */
  parameter_ringProjection: Array<Parameter_RingProjection>;
  /** fetch aggregated fields from the table: "parameter.ringProjection" */
  parameter_ringProjection_aggregate: Parameter_RingProjection_Aggregate;
  /** fetch data from the table: "parameter.ringProjection" using primary key columns */
  parameter_ringProjection_by_pk?: Maybe<Parameter_RingProjection>;
  /** fetch data from the table: "parameter.ringWithProductionDay" */
  parameter_ringWithProductionDay: Array<Parameter_RingWithProductionDay>;
  /** fetch aggregated fields from the table: "parameter.ringWithProductionDay" */
  parameter_ringWithProductionDay_aggregate: Parameter_RingWithProductionDay_Aggregate;
  /** fetch data from the table: "parameter.ringWithShifts" */
  parameter_ringWithShifts: Array<Parameter_RingWithShifts>;
  /** fetch aggregated fields from the table: "parameter.ringWithShifts" */
  parameter_ringWithShifts_aggregate: Parameter_RingWithShifts_Aggregate;
  /** fetch aggregated fields from the table: "parameter.ring" */
  parameter_ring_aggregate: Parameter_Ring_Aggregate;
  /** fetch data from the table: "parameter.ring" using primary key columns */
  parameter_ring_by_pk?: Maybe<Parameter_Ring>;
  /** fetch data from the table: "parameter.value" */
  parameter_value: Array<Parameter_Value>;
  /** fetch aggregated fields from the table: "parameter.value" */
  parameter_value_aggregate: Parameter_Value_Aggregate;
  /** fetch data from the table: "parameter.value" using primary key columns */
  parameter_value_by_pk?: Maybe<Parameter_Value>;
  /** fetch data from the table: "permissionType" */
  permissionType: Array<PermissionType>;
  /** fetch aggregated fields from the table: "permissionType" */
  permissionType_aggregate: PermissionType_Aggregate;
  /** fetch data from the table: "permissionType" using primary key columns */
  permissionType_by_pk?: Maybe<PermissionType>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** fetch data from the table: "quality.boardConfig" */
  quality_boardConfig: Array<Quality_BoardConfig>;
  /** fetch aggregated fields from the table: "quality.boardConfig" */
  quality_boardConfig_aggregate: Quality_BoardConfig_Aggregate;
  /** fetch data from the table: "quality.boardConfig" using primary key columns */
  quality_boardConfig_by_pk?: Maybe<Quality_BoardConfig>;
  /** fetch data from the table: "quality.boardSegment" */
  quality_boardSegment: Array<Quality_BoardSegment>;
  /** fetch aggregated fields from the table: "quality.boardSegment" */
  quality_boardSegment_aggregate: Quality_BoardSegment_Aggregate;
  /** fetch data from the table: "quality.boardSegment" using primary key columns */
  quality_boardSegment_by_pk?: Maybe<Quality_BoardSegment>;
  /** fetch data from the table: "quality.defectRepair" */
  quality_defectRepair: Array<Quality_DefectRepair>;
  /** fetch data from the table: "quality.defectRepairPicture" */
  quality_defectRepairPicture: Array<Quality_DefectRepairPicture>;
  /** fetch aggregated fields from the table: "quality.defectRepairPicture" */
  quality_defectRepairPicture_aggregate: Quality_DefectRepairPicture_Aggregate;
  /** fetch data from the table: "quality.defectRepairPicture" using primary key columns */
  quality_defectRepairPicture_by_pk?: Maybe<Quality_DefectRepairPicture>;
  /** fetch data from the table: "quality.defectRepairType" */
  quality_defectRepairType: Array<Quality_DefectRepairType>;
  /** fetch aggregated fields from the table: "quality.defectRepairType" */
  quality_defectRepairType_aggregate: Quality_DefectRepairType_Aggregate;
  /** fetch data from the table: "quality.defectRepairType" using primary key columns */
  quality_defectRepairType_by_pk?: Maybe<Quality_DefectRepairType>;
  /** fetch aggregated fields from the table: "quality.defectRepair" */
  quality_defectRepair_aggregate: Quality_DefectRepair_Aggregate;
  /** fetch data from the table: "quality.defectRepair" using primary key columns */
  quality_defectRepair_by_pk?: Maybe<Quality_DefectRepair>;
  /** fetch data from the table: "quality.defectReport" */
  quality_defectReport: Array<Quality_DefectReport>;
  /** fetch data from the table: "quality.defectReportPicture" */
  quality_defectReportPicture: Array<Quality_DefectReportPicture>;
  /** fetch aggregated fields from the table: "quality.defectReportPicture" */
  quality_defectReportPicture_aggregate: Quality_DefectReportPicture_Aggregate;
  /** fetch data from the table: "quality.defectReportPicture" using primary key columns */
  quality_defectReportPicture_by_pk?: Maybe<Quality_DefectReportPicture>;
  /** fetch data from the table: "quality.defectReportType" */
  quality_defectReportType: Array<Quality_DefectReportType>;
  /** fetch aggregated fields from the table: "quality.defectReportType" */
  quality_defectReportType_aggregate: Quality_DefectReportType_Aggregate;
  /** fetch data from the table: "quality.defectReportType" using primary key columns */
  quality_defectReportType_by_pk?: Maybe<Quality_DefectReportType>;
  /** fetch data from the table: "quality.defectReportView" */
  quality_defectReportView: Array<Quality_DefectReportView>;
  /** fetch aggregated fields from the table: "quality.defectReportView" */
  quality_defectReportView_aggregate: Quality_DefectReportView_Aggregate;
  /** fetch aggregated fields from the table: "quality.defectReport" */
  quality_defectReport_aggregate: Quality_DefectReport_Aggregate;
  /** fetch data from the table: "quality.defectReport" using primary key columns */
  quality_defectReport_by_pk?: Maybe<Quality_DefectReport>;
  /** fetch data from the table: "quality.importConfig" */
  quality_importConfig: Array<Quality_ImportConfig>;
  /** fetch aggregated fields from the table: "quality.importConfig" */
  quality_importConfig_aggregate: Quality_ImportConfig_Aggregate;
  /** fetch data from the table: "quality.importConfig" using primary key columns */
  quality_importConfig_by_pk?: Maybe<Quality_ImportConfig>;
  /** fetch data from the table: "quality.importExtraColumn" */
  quality_importExtraColumn: Array<Quality_ImportExtraColumn>;
  /** fetch aggregated fields from the table: "quality.importExtraColumn" */
  quality_importExtraColumn_aggregate: Quality_ImportExtraColumn_Aggregate;
  /** fetch data from the table: "quality.importExtraColumn" using primary key columns */
  quality_importExtraColumn_by_pk?: Maybe<Quality_ImportExtraColumn>;
  /** fetch data from the table: "quality.importTask" */
  quality_importTask: Array<Quality_ImportTask>;
  /** fetch aggregated fields from the table: "quality.importTask" */
  quality_importTask_aggregate: Quality_ImportTask_Aggregate;
  /** fetch data from the table: "quality.importTask" using primary key columns */
  quality_importTask_by_pk?: Maybe<Quality_ImportTask>;
  /** fetch data from the table: "quality.indicator" */
  quality_indicator: Array<Quality_Indicator>;
  /** fetch aggregated fields from the table: "quality.indicator" */
  quality_indicator_aggregate: Quality_Indicator_Aggregate;
  /** fetch data from the table: "quality.indicator" using primary key columns */
  quality_indicator_by_pk?: Maybe<Quality_Indicator>;
  /** fetch data from the table: "quality.quarantineDefect" */
  quality_quarantineDefect: Array<Quality_QuarantineDefect>;
  /** fetch data from the table: "quality.quarantineDefectOrientationEnum" */
  quality_quarantineDefectOrientationEnum: Array<Quality_QuarantineDefectOrientationEnum>;
  /** fetch aggregated fields from the table: "quality.quarantineDefectOrientationEnum" */
  quality_quarantineDefectOrientationEnum_aggregate: Quality_QuarantineDefectOrientationEnum_Aggregate;
  /** fetch data from the table: "quality.quarantineDefectOrientationEnum" using primary key columns */
  quality_quarantineDefectOrientationEnum_by_pk?: Maybe<Quality_QuarantineDefectOrientationEnum>;
  /** fetch data from the table: "quality.quarantineDefectPicture" */
  quality_quarantineDefectPicture: Array<Quality_QuarantineDefectPicture>;
  /** fetch aggregated fields from the table: "quality.quarantineDefectPicture" */
  quality_quarantineDefectPicture_aggregate: Quality_QuarantineDefectPicture_Aggregate;
  /** fetch data from the table: "quality.quarantineDefectPicture" using primary key columns */
  quality_quarantineDefectPicture_by_pk?: Maybe<Quality_QuarantineDefectPicture>;
  /** fetch data from the table: "quality.quarantineDefectType" */
  quality_quarantineDefectType: Array<Quality_QuarantineDefectType>;
  /** fetch aggregated fields from the table: "quality.quarantineDefectType" */
  quality_quarantineDefectType_aggregate: Quality_QuarantineDefectType_Aggregate;
  /** fetch data from the table: "quality.quarantineDefectType" using primary key columns */
  quality_quarantineDefectType_by_pk?: Maybe<Quality_QuarantineDefectType>;
  /** fetch aggregated fields from the table: "quality.quarantineDefect" */
  quality_quarantineDefect_aggregate: Quality_QuarantineDefect_Aggregate;
  /** fetch data from the table: "quality.quarantineDefect" using primary key columns */
  quality_quarantineDefect_by_pk?: Maybe<Quality_QuarantineDefect>;
  /** fetch data from the table: "quality.repairReport" */
  quality_repairReport: Array<Quality_RepairReport>;
  /** fetch data from the table: "quality.repairReportPicture" */
  quality_repairReportPicture: Array<Quality_RepairReportPicture>;
  /** fetch aggregated fields from the table: "quality.repairReportPicture" */
  quality_repairReportPicture_aggregate: Quality_RepairReportPicture_Aggregate;
  /** fetch data from the table: "quality.repairReportPicture" using primary key columns */
  quality_repairReportPicture_by_pk?: Maybe<Quality_RepairReportPicture>;
  /** fetch aggregated fields from the table: "quality.repairReport" */
  quality_repairReport_aggregate: Quality_RepairReport_Aggregate;
  /** fetch data from the table: "quality.repairReport" using primary key columns */
  quality_repairReport_by_pk?: Maybe<Quality_RepairReport>;
  /** fetch data from the table: "quality.ringValidation" */
  quality_ringValidation: Array<Quality_RingValidation>;
  /** fetch data from the table: "quality.ringValidationView" */
  quality_ringValidationView: Array<Quality_RingValidationView>;
  /** fetch aggregated fields from the table: "quality.ringValidationView" */
  quality_ringValidationView_aggregate: Quality_RingValidationView_Aggregate;
  /** fetch aggregated fields from the table: "quality.ringValidation" */
  quality_ringValidation_aggregate: Quality_RingValidation_Aggregate;
  /** fetch data from the table: "quality.ringValidation" using primary key columns */
  quality_ringValidation_by_pk?: Maybe<Quality_RingValidation>;
  /** fetch data from the table: "quality.scanCodeConfig" */
  quality_scanCodeConfig: Array<Quality_ScanCodeConfig>;
  /** fetch aggregated fields from the table: "quality.scanCodeConfig" */
  quality_scanCodeConfig_aggregate: Quality_ScanCodeConfig_Aggregate;
  /** fetch data from the table: "quality.scanCodeConfig" using primary key columns */
  quality_scanCodeConfig_by_pk?: Maybe<Quality_ScanCodeConfig>;
  /** fetch data from the table: "quality.scanConfig" */
  quality_scanConfig: Array<Quality_ScanConfig>;
  /** fetch aggregated fields from the table: "quality.scanConfig" */
  quality_scanConfig_aggregate: Quality_ScanConfig_Aggregate;
  /** fetch data from the table: "quality.scanConfig" using primary key columns */
  quality_scanConfig_by_pk?: Maybe<Quality_ScanConfig>;
  /** fetch data from the table: "quality.scanSite" */
  quality_scanSite: Array<Quality_ScanSite>;
  /** fetch data from the table: "quality.scanSiteConstructionSite" */
  quality_scanSiteConstructionSite: Array<Quality_ScanSiteConstructionSite>;
  /** fetch aggregated fields from the table: "quality.scanSiteConstructionSite" */
  quality_scanSiteConstructionSite_aggregate: Quality_ScanSiteConstructionSite_Aggregate;
  /** fetch data from the table: "quality.scanSiteConstructionSite" using primary key columns */
  quality_scanSiteConstructionSite_by_pk?: Maybe<Quality_ScanSiteConstructionSite>;
  /** fetch aggregated fields from the table: "quality.scanSite" */
  quality_scanSite_aggregate: Quality_ScanSite_Aggregate;
  /** fetch data from the table: "quality.scanSite" using primary key columns */
  quality_scanSite_by_pk?: Maybe<Quality_ScanSite>;
  /** fetch data from the table: "quality.scanTypeEnum" */
  quality_scanTypeEnum: Array<Quality_ScanTypeEnum>;
  /** fetch aggregated fields from the table: "quality.scanTypeEnum" */
  quality_scanTypeEnum_aggregate: Quality_ScanTypeEnum_Aggregate;
  /** fetch data from the table: "quality.scanTypeEnum" using primary key columns */
  quality_scanTypeEnum_by_pk?: Maybe<Quality_ScanTypeEnum>;
  /** fetch data from the table: "quality.segment" */
  quality_segment: Array<Quality_Segment>;
  /** fetch data from the table: "quality.segmentDrawConfig" */
  quality_segmentDrawConfig: Array<Quality_SegmentDrawConfig>;
  /** fetch aggregated fields from the table: "quality.segmentDrawConfig" */
  quality_segmentDrawConfig_aggregate: Quality_SegmentDrawConfig_Aggregate;
  /** fetch data from the table: "quality.segmentDrawConfig" using primary key columns */
  quality_segmentDrawConfig_by_pk?: Maybe<Quality_SegmentDrawConfig>;
  /** fetch data from the table: "quality.segmentExtraParameter" */
  quality_segmentExtraParameter: Array<Quality_SegmentExtraParameter>;
  /** fetch aggregated fields from the table: "quality.segmentExtraParameter" */
  quality_segmentExtraParameter_aggregate: Quality_SegmentExtraParameter_Aggregate;
  /** fetch data from the table: "quality.segmentExtraParameter" using primary key columns */
  quality_segmentExtraParameter_by_pk?: Maybe<Quality_SegmentExtraParameter>;
  /** fetch data from the table: "quality.segmentHistory" */
  quality_segmentHistory: Array<Quality_SegmentHistory>;
  /** fetch data from the table: "quality.segmentHistoryStatusEnum" */
  quality_segmentHistoryStatusEnum: Array<Quality_SegmentHistoryStatusEnum>;
  /** fetch aggregated fields from the table: "quality.segmentHistoryStatusEnum" */
  quality_segmentHistoryStatusEnum_aggregate: Quality_SegmentHistoryStatusEnum_Aggregate;
  /** fetch data from the table: "quality.segmentHistoryStatusEnum" using primary key columns */
  quality_segmentHistoryStatusEnum_by_pk?: Maybe<Quality_SegmentHistoryStatusEnum>;
  /** fetch data from the table: "quality.segmentHistoryView" */
  quality_segmentHistoryView: Array<Quality_SegmentHistoryView>;
  /** fetch aggregated fields from the table: "quality.segmentHistoryView" */
  quality_segmentHistoryView_aggregate: Quality_SegmentHistoryView_Aggregate;
  /** fetch aggregated fields from the table: "quality.segmentHistory" */
  quality_segmentHistory_aggregate: Quality_SegmentHistory_Aggregate;
  /** fetch data from the table: "quality.segmentHistory" using primary key columns */
  quality_segmentHistory_by_pk?: Maybe<Quality_SegmentHistory>;
  /** fetch data from the table: "quality.segmentRefusal" */
  quality_segmentRefusal: Array<Quality_SegmentRefusal>;
  /** fetch data from the table: "quality.segmentRefusalPicture" */
  quality_segmentRefusalPicture: Array<Quality_SegmentRefusalPicture>;
  /** fetch aggregated fields from the table: "quality.segmentRefusalPicture" */
  quality_segmentRefusalPicture_aggregate: Quality_SegmentRefusalPicture_Aggregate;
  /** fetch data from the table: "quality.segmentRefusalPicture" using primary key columns */
  quality_segmentRefusalPicture_by_pk?: Maybe<Quality_SegmentRefusalPicture>;
  /** fetch aggregated fields from the table: "quality.segmentRefusal" */
  quality_segmentRefusal_aggregate: Quality_SegmentRefusal_Aggregate;
  /** fetch data from the table: "quality.segmentRefusal" using primary key columns */
  quality_segmentRefusal_by_pk?: Maybe<Quality_SegmentRefusal>;
  /** fetch aggregated fields from the table: "quality.segment" */
  quality_segment_aggregate: Quality_Segment_Aggregate;
  /** fetch data from the table: "quality.segment" using primary key columns */
  quality_segment_by_pk?: Maybe<Quality_Segment>;
  /** fetch data from the table: "quality.shapeEnum" */
  quality_shapeEnum: Array<Quality_ShapeEnum>;
  /** fetch aggregated fields from the table: "quality.shapeEnum" */
  quality_shapeEnum_aggregate: Quality_ShapeEnum_Aggregate;
  /** fetch data from the table: "quality.shapeEnum" using primary key columns */
  quality_shapeEnum_by_pk?: Maybe<Quality_ShapeEnum>;
  /** fetch data from the table: "quality.tunnelPosition" */
  quality_tunnelPosition: Array<Quality_TunnelPosition>;
  /** fetch aggregated fields from the table: "quality.tunnelPosition" */
  quality_tunnelPosition_aggregate: Quality_TunnelPosition_Aggregate;
  /** fetch data from the table: "quality.tunnelPosition" using primary key columns */
  quality_tunnelPosition_by_pk?: Maybe<Quality_TunnelPosition>;
  /** fetch data from the table: "quality.userQualityRole" */
  quality_userQualityRole: Array<Quality_UserQualityRole>;
  /** fetch aggregated fields from the table: "quality.userQualityRole" */
  quality_userQualityRole_aggregate: Quality_UserQualityRole_Aggregate;
  /** fetch data from the table: "quality.userQualityRole" using primary key columns */
  quality_userQualityRole_by_pk?: Maybe<Quality_UserQualityRole>;
  /** fetch data from the table: "quality.virtualRing" */
  quality_virtualRing: Array<Quality_VirtualRing>;
  /** fetch aggregated fields from the table: "quality.virtualRing" */
  quality_virtualRing_aggregate: Quality_VirtualRing_Aggregate;
  /** fetch data from the table: "quality.virtualRing" using primary key columns */
  quality_virtualRing_by_pk?: Maybe<Quality_VirtualRing>;
  /** fetch data from the table: "recurringTask" */
  recurringTask: Array<RecurringTask>;
  /** fetch aggregated fields from the table: "recurringTask" */
  recurringTask_aggregate: RecurringTask_Aggregate;
  /** fetch data from the table: "recurringTask" using primary key columns */
  recurringTask_by_pk?: Maybe<RecurringTask>;
  ringAggregationTasksAnalyzer?: Maybe<Array<RingAggregationTasksAnalyzer>>;
  /**
   * Return a time-limited signed URL to read a ring's compliance report PDF.
   * Reserved to data-manager / admin.
   */
  ringComplianceReportUrl: TempUrlResponse;
  /** fetch data from the table: "scan.user" */
  scan_user: Array<Scan_User>;
  /** fetch aggregated fields from the table: "scan.user" */
  scan_user_aggregate: Scan_User_Aggregate;
  /** fetch data from the table: "scan.user" using primary key columns */
  scan_user_by_pk?: Maybe<Scan_User>;
  /** fetch data from the table: "shift" */
  shift: Array<Shift>;
  /** fetch data from the table: "shiftLeader" */
  shiftLeader: Array<ShiftLeader>;
  /** fetch aggregated fields from the table: "shiftLeader" */
  shiftLeader_aggregate: ShiftLeader_Aggregate;
  /** fetch data from the table: "shiftLeader" using primary key columns */
  shiftLeader_by_pk?: Maybe<ShiftLeader>;
  /** fetch data from the table: "shiftReport" */
  shiftReport: Array<ShiftReport>;
  shiftReportAggregatePdfData?: Maybe<ShiftReportAggregatePdfDataReponse>;
  shiftReportTasksPieChartData?: Maybe<Array<ShiftReportTasksPieChartData>>;
  /** fetch aggregated fields from the table: "shiftReport" */
  shiftReport_aggregate: ShiftReport_Aggregate;
  /** fetch data from the table: "shiftReport" using primary key columns */
  shiftReport_by_pk?: Maybe<ShiftReport>;
  shiftReportsTasksAnalyzer?: Maybe<Array<ShiftReportTasksAnalyzer>>;
  /** fetch aggregated fields from the table: "shift" */
  shift_aggregate: Shift_Aggregate;
  /** fetch data from the table: "shift" using primary key columns */
  shift_by_pk?: Maybe<Shift>;
  /** fetch data from the table: "task" */
  task: Array<Task>;
  /** fetch data from the table: "taskTotal" */
  taskTotal: Array<TaskTotal>;
  /** fetch data from the table: "taskTotalCritical" */
  taskTotalCritical: Array<TaskTotalCritical>;
  /** fetch aggregated fields from the table: "taskTotalCritical" */
  taskTotalCritical_aggregate: TaskTotalCritical_Aggregate;
  /** fetch data from the table: "taskTotalNonCritical" */
  taskTotalNonCritical: Array<TaskTotalNonCritical>;
  /** fetch aggregated fields from the table: "taskTotalNonCritical" */
  taskTotalNonCritical_aggregate: TaskTotalNonCritical_Aggregate;
  /** fetch data from the table: "taskTotalRing" */
  taskTotalRing: Array<TaskTotalRing>;
  /** fetch data from the table: "taskTotalRingCritical" */
  taskTotalRingCritical: Array<TaskTotalRingCritical>;
  /** fetch aggregated fields from the table: "taskTotalRingCritical" */
  taskTotalRingCritical_aggregate: TaskTotalRingCritical_Aggregate;
  /** fetch data from the table: "taskTotalRingNonCritical" */
  taskTotalRingNonCritical: Array<TaskTotalRingNonCritical>;
  /** fetch aggregated fields from the table: "taskTotalRingNonCritical" */
  taskTotalRingNonCritical_aggregate: TaskTotalRingNonCritical_Aggregate;
  /** fetch aggregated fields from the table: "taskTotalRing" */
  taskTotalRing_aggregate: TaskTotalRing_Aggregate;
  /** fetch aggregated fields from the table: "taskTotal" */
  taskTotal_aggregate: TaskTotal_Aggregate;
  /** fetch aggregated fields from the table: "task" */
  task_aggregate: Task_Aggregate;
  /** fetch data from the table: "task" using primary key columns */
  task_by_pk?: Maybe<Task>;
  /** fetch data from the table: "team" */
  team: Array<Team>;
  /** fetch aggregated fields from the table: "team" */
  team_aggregate: Team_Aggregate;
  /** fetch data from the table: "team" using primary key columns */
  team_by_pk?: Maybe<Team>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch data from the table: "userPermission" */
  userPermission: Array<UserPermission>;
  /** fetch aggregated fields from the table: "userPermission" */
  userPermission_aggregate: UserPermission_Aggregate;
  /** fetch data from the table: "userPermission" using primary key columns */
  userPermission_by_pk?: Maybe<UserPermission>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "validatedShiftReportWithRingCount" */
  validatedShiftReportWithRingCount: Array<ValidatedShiftReportWithRingCount>;
  /** fetch aggregated fields from the table: "validatedShiftReportWithRingCount" */
  validatedShiftReportWithRingCount_aggregate: ValidatedShiftReportWithRingCount_Aggregate;
};


export type Query_RootActivityArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Query_RootActivityFullNameArgs = {
  distinct_on?: InputMaybe<Array<ActivityFullName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityFullName_Order_By>>;
  where?: InputMaybe<ActivityFullName_Bool_Exp>;
};


export type Query_RootActivityFullName_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ActivityFullName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityFullName_Order_By>>;
  where?: InputMaybe<ActivityFullName_Bool_Exp>;
};


export type Query_RootActivity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Query_RootActivity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAutofillApiArgs = {
  distinct_on?: InputMaybe<Array<AutofillApi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AutofillApi_Order_By>>;
  where?: InputMaybe<AutofillApi_Bool_Exp>;
};


export type Query_RootAutofillApi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AutofillApi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AutofillApi_Order_By>>;
  where?: InputMaybe<AutofillApi_Bool_Exp>;
};


export type Query_RootAutofillApi_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCalculateAggregatedIndicatorResultsArgs = {
  constructionSiteId: Scalars['String']['input'];
  endDate: Scalars['date']['input'];
  startDate: Scalars['date']['input'];
};


export type Query_RootCalculateIndicatorResultsArgs = {
  constructionSiteId: Scalars['String']['input'];
  shiftReportId: Scalars['String']['input'];
};


export type Query_RootConstructionSiteArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSite_Order_By>>;
  where?: InputMaybe<ConstructionSite_Bool_Exp>;
};


export type Query_RootConstructionSiteEnabledModuleArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSiteEnabledModule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSiteEnabledModule_Order_By>>;
  where?: InputMaybe<ConstructionSiteEnabledModule_Bool_Exp>;
};


export type Query_RootConstructionSiteEnabledModule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSiteEnabledModule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSiteEnabledModule_Order_By>>;
  where?: InputMaybe<ConstructionSiteEnabledModule_Bool_Exp>;
};


export type Query_RootConstructionSiteEnabledModule_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootConstructionSite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSite_Order_By>>;
  where?: InputMaybe<ConstructionSite_Bool_Exp>;
};


export type Query_RootConstructionSite_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCreateFileDownloadTempUrlArgs = {
  fileName: Scalars['String']['input'];
};


export type Query_RootCreateFilesDownloadTempUrlsArgs = {
  fileNames: Array<Scalars['String']['input']>;
};


export type Query_RootDailyShiftTemplateArgs = {
  distinct_on?: InputMaybe<Array<DailyShiftTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DailyShiftTemplate_Order_By>>;
  where?: InputMaybe<DailyShiftTemplate_Bool_Exp>;
};


export type Query_RootDailyShiftTemplate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DailyShiftTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DailyShiftTemplate_Order_By>>;
  where?: InputMaybe<DailyShiftTemplate_Bool_Exp>;
};


export type Query_RootDailyShiftTemplate_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDoesTimescaleTableExistsArgs = {
  id: Scalars['ID']['input'];
};


export type Query_RootFile_BucketFileArgs = {
  distinct_on?: InputMaybe<Array<File_BucketFile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_BucketFile_Order_By>>;
  where?: InputMaybe<File_BucketFile_Bool_Exp>;
};


export type Query_RootFile_BucketFile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_BucketFile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_BucketFile_Order_By>>;
  where?: InputMaybe<File_BucketFile_Bool_Exp>;
};


export type Query_RootFile_BucketFile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFile_BucketTypeEnumArgs = {
  distinct_on?: InputMaybe<Array<File_BucketTypeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_BucketTypeEnum_Order_By>>;
  where?: InputMaybe<File_BucketTypeEnum_Bool_Exp>;
};


export type Query_RootFile_BucketTypeEnum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_BucketTypeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_BucketTypeEnum_Order_By>>;
  where?: InputMaybe<File_BucketTypeEnum_Bool_Exp>;
};


export type Query_RootFile_BucketTypeEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootGraphSetArgs = {
  distinct_on?: InputMaybe<Array<GraphSet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GraphSet_Order_By>>;
  where?: InputMaybe<GraphSet_Bool_Exp>;
};


export type Query_RootGraphSetTypeEnumArgs = {
  distinct_on?: InputMaybe<Array<GraphSetTypeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GraphSetTypeEnum_Order_By>>;
  where?: InputMaybe<GraphSetTypeEnum_Bool_Exp>;
};


export type Query_RootGraphSetTypeEnum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GraphSetTypeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GraphSetTypeEnum_Order_By>>;
  where?: InputMaybe<GraphSetTypeEnum_Bool_Exp>;
};


export type Query_RootGraphSetTypeEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootGraphSet_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GraphSet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GraphSet_Order_By>>;
  where?: InputMaybe<GraphSet_Bool_Exp>;
};


export type Query_RootGraphSet_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIndicatorArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Order_By>>;
  where?: InputMaybe<Indicator_Bool_Exp>;
};


export type Query_RootIndicatorAnalysisDataArgs = {
  analysisType: Scalars['String']['input'];
  constructionSiteId: Scalars['String']['input'];
  endDate: Scalars['date']['input'];
  endRing: Scalars['Int']['input'];
  indicatorsIds: Array<Scalars['String']['input']>;
  startDate: Scalars['date']['input'];
  startRing: Scalars['Int']['input'];
};


export type Query_RootIndicatorVariablesArgs = {
  constructionSiteId: Scalars['String']['input'];
};


export type Query_RootIndicator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Order_By>>;
  where?: InputMaybe<Indicator_Bool_Exp>;
};


export type Query_RootIndicator_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMapConfigurationArgs = {
  distinct_on?: InputMaybe<Array<MapConfiguration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapConfiguration_Order_By>>;
  where?: InputMaybe<MapConfiguration_Bool_Exp>;
};


export type Query_RootMapConfiguration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MapConfiguration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapConfiguration_Order_By>>;
  where?: InputMaybe<MapConfiguration_Bool_Exp>;
};


export type Query_RootMapConfiguration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMapPoiArgs = {
  distinct_on?: InputMaybe<Array<MapPoi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapPoi_Order_By>>;
  where?: InputMaybe<MapPoi_Bool_Exp>;
};


export type Query_RootMapPoi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MapPoi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapPoi_Order_By>>;
  where?: InputMaybe<MapPoi_Bool_Exp>;
};


export type Query_RootMapPoi_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootMapTraceArgs = {
  distinct_on?: InputMaybe<Array<MapTrace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapTrace_Order_By>>;
  where?: InputMaybe<MapTrace_Bool_Exp>;
};


export type Query_RootMapTrace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MapTrace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapTrace_Order_By>>;
  where?: InputMaybe<MapTrace_Bool_Exp>;
};


export type Query_RootMapTrace_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootModuleArgs = {
  distinct_on?: InputMaybe<Array<Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Module_Order_By>>;
  where?: InputMaybe<Module_Bool_Exp>;
};


export type Query_RootModule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Module_Order_By>>;
  where?: InputMaybe<Module_Bool_Exp>;
};


export type Query_RootModule_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootOperatorArgs = {
  distinct_on?: InputMaybe<Array<Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Operator_Order_By>>;
  where?: InputMaybe<Operator_Bool_Exp>;
};


export type Query_RootOperator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Operator_Order_By>>;
  where?: InputMaybe<Operator_Bool_Exp>;
};


export type Query_RootOperator_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootParameter_ConstructionSiteParameterNameConfigArgs = {
  distinct_on?: InputMaybe<Array<Parameter_ConstructionSiteParameterNameConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_ConstructionSiteParameterNameConfig_Order_By>>;
  where?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Bool_Exp>;
};


export type Query_RootParameter_ConstructionSiteParameterNameConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_ConstructionSiteParameterNameConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_ConstructionSiteParameterNameConfig_Order_By>>;
  where?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Bool_Exp>;
};


export type Query_RootParameter_ConstructionSiteParameterNameConfig_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootParameter_FamilyDefArgs = {
  distinct_on?: InputMaybe<Array<Parameter_FamilyDef_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_FamilyDef_Order_By>>;
  where?: InputMaybe<Parameter_FamilyDef_Bool_Exp>;
};


export type Query_RootParameter_FamilyDef_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_FamilyDef_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_FamilyDef_Order_By>>;
  where?: InputMaybe<Parameter_FamilyDef_Bool_Exp>;
};


export type Query_RootParameter_FamilyDef_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootParameter_MetricArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Metric_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Metric_Order_By>>;
  where?: InputMaybe<Parameter_Metric_Bool_Exp>;
};


export type Query_RootParameter_Metric_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Metric_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Metric_Order_By>>;
  where?: InputMaybe<Parameter_Metric_Bool_Exp>;
};


export type Query_RootParameter_Metric_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootParameter_ParameterDefArgs = {
  distinct_on?: InputMaybe<Array<Parameter_ParameterDef_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_ParameterDef_Order_By>>;
  where?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
};


export type Query_RootParameter_ParameterDef_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_ParameterDef_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_ParameterDef_Order_By>>;
  where?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
};


export type Query_RootParameter_ParameterDef_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootParameter_RingArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Ring_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Ring_Order_By>>;
  where?: InputMaybe<Parameter_Ring_Bool_Exp>;
};


export type Query_RootParameter_RingProjectionArgs = {
  distinct_on?: InputMaybe<Array<Parameter_RingProjection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_RingProjection_Order_By>>;
  where?: InputMaybe<Parameter_RingProjection_Bool_Exp>;
};


export type Query_RootParameter_RingProjection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_RingProjection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_RingProjection_Order_By>>;
  where?: InputMaybe<Parameter_RingProjection_Bool_Exp>;
};


export type Query_RootParameter_RingProjection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootParameter_RingWithProductionDayArgs = {
  distinct_on?: InputMaybe<Array<Parameter_RingWithProductionDay_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_RingWithProductionDay_Order_By>>;
  where?: InputMaybe<Parameter_RingWithProductionDay_Bool_Exp>;
};


export type Query_RootParameter_RingWithProductionDay_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_RingWithProductionDay_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_RingWithProductionDay_Order_By>>;
  where?: InputMaybe<Parameter_RingWithProductionDay_Bool_Exp>;
};


export type Query_RootParameter_RingWithShiftsArgs = {
  distinct_on?: InputMaybe<Array<Parameter_RingWithShifts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_RingWithShifts_Order_By>>;
  where?: InputMaybe<Parameter_RingWithShifts_Bool_Exp>;
};


export type Query_RootParameter_RingWithShifts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_RingWithShifts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_RingWithShifts_Order_By>>;
  where?: InputMaybe<Parameter_RingWithShifts_Bool_Exp>;
};


export type Query_RootParameter_Ring_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Ring_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Ring_Order_By>>;
  where?: InputMaybe<Parameter_Ring_Bool_Exp>;
};


export type Query_RootParameter_Ring_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootParameter_ValueArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Value_Order_By>>;
  where?: InputMaybe<Parameter_Value_Bool_Exp>;
};


export type Query_RootParameter_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Value_Order_By>>;
  where?: InputMaybe<Parameter_Value_Bool_Exp>;
};


export type Query_RootParameter_Value_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPermissionTypeArgs = {
  distinct_on?: InputMaybe<Array<PermissionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PermissionType_Order_By>>;
  where?: InputMaybe<PermissionType_Bool_Exp>;
};


export type Query_RootPermissionType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PermissionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PermissionType_Order_By>>;
  where?: InputMaybe<PermissionType_Bool_Exp>;
};


export type Query_RootPermissionType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProject_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_BoardConfigArgs = {
  distinct_on?: InputMaybe<Array<Quality_BoardConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_BoardConfig_Order_By>>;
  where?: InputMaybe<Quality_BoardConfig_Bool_Exp>;
};


export type Query_RootQuality_BoardConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_BoardConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_BoardConfig_Order_By>>;
  where?: InputMaybe<Quality_BoardConfig_Bool_Exp>;
};


export type Query_RootQuality_BoardConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_BoardSegmentArgs = {
  distinct_on?: InputMaybe<Array<Quality_BoardSegment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_BoardSegment_Order_By>>;
  where?: InputMaybe<Quality_BoardSegment_Bool_Exp>;
};


export type Query_RootQuality_BoardSegment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_BoardSegment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_BoardSegment_Order_By>>;
  where?: InputMaybe<Quality_BoardSegment_Bool_Exp>;
};


export type Query_RootQuality_BoardSegment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_DefectRepairArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectRepair_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectRepair_Order_By>>;
  where?: InputMaybe<Quality_DefectRepair_Bool_Exp>;
};


export type Query_RootQuality_DefectRepairPictureArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectRepairPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectRepairPicture_Order_By>>;
  where?: InputMaybe<Quality_DefectRepairPicture_Bool_Exp>;
};


export type Query_RootQuality_DefectRepairPicture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectRepairPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectRepairPicture_Order_By>>;
  where?: InputMaybe<Quality_DefectRepairPicture_Bool_Exp>;
};


export type Query_RootQuality_DefectRepairPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_DefectRepairTypeArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectRepairType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectRepairType_Order_By>>;
  where?: InputMaybe<Quality_DefectRepairType_Bool_Exp>;
};


export type Query_RootQuality_DefectRepairType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectRepairType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectRepairType_Order_By>>;
  where?: InputMaybe<Quality_DefectRepairType_Bool_Exp>;
};


export type Query_RootQuality_DefectRepairType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_DefectRepair_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectRepair_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectRepair_Order_By>>;
  where?: InputMaybe<Quality_DefectRepair_Bool_Exp>;
};


export type Query_RootQuality_DefectRepair_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_DefectReportArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReport_Order_By>>;
  where?: InputMaybe<Quality_DefectReport_Bool_Exp>;
};


export type Query_RootQuality_DefectReportPictureArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReportPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReportPicture_Order_By>>;
  where?: InputMaybe<Quality_DefectReportPicture_Bool_Exp>;
};


export type Query_RootQuality_DefectReportPicture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReportPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReportPicture_Order_By>>;
  where?: InputMaybe<Quality_DefectReportPicture_Bool_Exp>;
};


export type Query_RootQuality_DefectReportPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_DefectReportTypeArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReportType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReportType_Order_By>>;
  where?: InputMaybe<Quality_DefectReportType_Bool_Exp>;
};


export type Query_RootQuality_DefectReportType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReportType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReportType_Order_By>>;
  where?: InputMaybe<Quality_DefectReportType_Bool_Exp>;
};


export type Query_RootQuality_DefectReportType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_DefectReportViewArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReportView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReportView_Order_By>>;
  where?: InputMaybe<Quality_DefectReportView_Bool_Exp>;
};


export type Query_RootQuality_DefectReportView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReportView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReportView_Order_By>>;
  where?: InputMaybe<Quality_DefectReportView_Bool_Exp>;
};


export type Query_RootQuality_DefectReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReport_Order_By>>;
  where?: InputMaybe<Quality_DefectReport_Bool_Exp>;
};


export type Query_RootQuality_DefectReport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_ImportConfigArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportConfig_Order_By>>;
  where?: InputMaybe<Quality_ImportConfig_Bool_Exp>;
};


export type Query_RootQuality_ImportConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportConfig_Order_By>>;
  where?: InputMaybe<Quality_ImportConfig_Bool_Exp>;
};


export type Query_RootQuality_ImportConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_ImportExtraColumnArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportExtraColumn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportExtraColumn_Order_By>>;
  where?: InputMaybe<Quality_ImportExtraColumn_Bool_Exp>;
};


export type Query_RootQuality_ImportExtraColumn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportExtraColumn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportExtraColumn_Order_By>>;
  where?: InputMaybe<Quality_ImportExtraColumn_Bool_Exp>;
};


export type Query_RootQuality_ImportExtraColumn_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_ImportTaskArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportTask_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportTask_Order_By>>;
  where?: InputMaybe<Quality_ImportTask_Bool_Exp>;
};


export type Query_RootQuality_ImportTask_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportTask_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportTask_Order_By>>;
  where?: InputMaybe<Quality_ImportTask_Bool_Exp>;
};


export type Query_RootQuality_ImportTask_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_IndicatorArgs = {
  distinct_on?: InputMaybe<Array<Quality_Indicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_Indicator_Order_By>>;
  where?: InputMaybe<Quality_Indicator_Bool_Exp>;
};


export type Query_RootQuality_Indicator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Indicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_Indicator_Order_By>>;
  where?: InputMaybe<Quality_Indicator_Bool_Exp>;
};


export type Query_RootQuality_Indicator_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_QuarantineDefectArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefect_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefect_Bool_Exp>;
};


export type Query_RootQuality_QuarantineDefectOrientationEnumArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefectOrientationEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefectOrientationEnum_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Bool_Exp>;
};


export type Query_RootQuality_QuarantineDefectOrientationEnum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefectOrientationEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefectOrientationEnum_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Bool_Exp>;
};


export type Query_RootQuality_QuarantineDefectOrientationEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootQuality_QuarantineDefectPictureArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefectPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefectPicture_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefectPicture_Bool_Exp>;
};


export type Query_RootQuality_QuarantineDefectPicture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefectPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefectPicture_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefectPicture_Bool_Exp>;
};


export type Query_RootQuality_QuarantineDefectPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_QuarantineDefectTypeArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefectType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefectType_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefectType_Bool_Exp>;
};


export type Query_RootQuality_QuarantineDefectType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefectType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefectType_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefectType_Bool_Exp>;
};


export type Query_RootQuality_QuarantineDefectType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_QuarantineDefect_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefect_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefect_Bool_Exp>;
};


export type Query_RootQuality_QuarantineDefect_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_RepairReportArgs = {
  distinct_on?: InputMaybe<Array<Quality_RepairReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RepairReport_Order_By>>;
  where?: InputMaybe<Quality_RepairReport_Bool_Exp>;
};


export type Query_RootQuality_RepairReportPictureArgs = {
  distinct_on?: InputMaybe<Array<Quality_RepairReportPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RepairReportPicture_Order_By>>;
  where?: InputMaybe<Quality_RepairReportPicture_Bool_Exp>;
};


export type Query_RootQuality_RepairReportPicture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_RepairReportPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RepairReportPicture_Order_By>>;
  where?: InputMaybe<Quality_RepairReportPicture_Bool_Exp>;
};


export type Query_RootQuality_RepairReportPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_RepairReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_RepairReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RepairReport_Order_By>>;
  where?: InputMaybe<Quality_RepairReport_Bool_Exp>;
};


export type Query_RootQuality_RepairReport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_RingValidationArgs = {
  distinct_on?: InputMaybe<Array<Quality_RingValidation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RingValidation_Order_By>>;
  where?: InputMaybe<Quality_RingValidation_Bool_Exp>;
};


export type Query_RootQuality_RingValidationViewArgs = {
  distinct_on?: InputMaybe<Array<Quality_RingValidationView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RingValidationView_Order_By>>;
  where?: InputMaybe<Quality_RingValidationView_Bool_Exp>;
};


export type Query_RootQuality_RingValidationView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_RingValidationView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RingValidationView_Order_By>>;
  where?: InputMaybe<Quality_RingValidationView_Bool_Exp>;
};


export type Query_RootQuality_RingValidation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_RingValidation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RingValidation_Order_By>>;
  where?: InputMaybe<Quality_RingValidation_Bool_Exp>;
};


export type Query_RootQuality_RingValidation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_ScanCodeConfigArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanCodeConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanCodeConfig_Order_By>>;
  where?: InputMaybe<Quality_ScanCodeConfig_Bool_Exp>;
};


export type Query_RootQuality_ScanCodeConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanCodeConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanCodeConfig_Order_By>>;
  where?: InputMaybe<Quality_ScanCodeConfig_Bool_Exp>;
};


export type Query_RootQuality_ScanCodeConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_ScanConfigArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanConfig_Order_By>>;
  where?: InputMaybe<Quality_ScanConfig_Bool_Exp>;
};


export type Query_RootQuality_ScanConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanConfig_Order_By>>;
  where?: InputMaybe<Quality_ScanConfig_Bool_Exp>;
};


export type Query_RootQuality_ScanConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_ScanSiteArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanSite_Order_By>>;
  where?: InputMaybe<Quality_ScanSite_Bool_Exp>;
};


export type Query_RootQuality_ScanSiteConstructionSiteArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Order_By>>;
  where?: InputMaybe<Quality_ScanSiteConstructionSite_Bool_Exp>;
};


export type Query_RootQuality_ScanSiteConstructionSite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Order_By>>;
  where?: InputMaybe<Quality_ScanSiteConstructionSite_Bool_Exp>;
};


export type Query_RootQuality_ScanSiteConstructionSite_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_ScanSite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanSite_Order_By>>;
  where?: InputMaybe<Quality_ScanSite_Bool_Exp>;
};


export type Query_RootQuality_ScanSite_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_ScanTypeEnumArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanTypeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanTypeEnum_Order_By>>;
  where?: InputMaybe<Quality_ScanTypeEnum_Bool_Exp>;
};


export type Query_RootQuality_ScanTypeEnum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanTypeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanTypeEnum_Order_By>>;
  where?: InputMaybe<Quality_ScanTypeEnum_Bool_Exp>;
};


export type Query_RootQuality_ScanTypeEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootQuality_SegmentArgs = {
  distinct_on?: InputMaybe<Array<Quality_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_Segment_Order_By>>;
  where?: InputMaybe<Quality_Segment_Bool_Exp>;
};


export type Query_RootQuality_SegmentDrawConfigArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentDrawConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentDrawConfig_Order_By>>;
  where?: InputMaybe<Quality_SegmentDrawConfig_Bool_Exp>;
};


export type Query_RootQuality_SegmentDrawConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentDrawConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentDrawConfig_Order_By>>;
  where?: InputMaybe<Quality_SegmentDrawConfig_Bool_Exp>;
};


export type Query_RootQuality_SegmentDrawConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_SegmentExtraParameterArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentExtraParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentExtraParameter_Order_By>>;
  where?: InputMaybe<Quality_SegmentExtraParameter_Bool_Exp>;
};


export type Query_RootQuality_SegmentExtraParameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentExtraParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentExtraParameter_Order_By>>;
  where?: InputMaybe<Quality_SegmentExtraParameter_Bool_Exp>;
};


export type Query_RootQuality_SegmentExtraParameter_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_SegmentHistoryArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistory_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistory_Bool_Exp>;
};


export type Query_RootQuality_SegmentHistoryStatusEnumArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistoryStatusEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistoryStatusEnum_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistoryStatusEnum_Bool_Exp>;
};


export type Query_RootQuality_SegmentHistoryStatusEnum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistoryStatusEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistoryStatusEnum_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistoryStatusEnum_Bool_Exp>;
};


export type Query_RootQuality_SegmentHistoryStatusEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootQuality_SegmentHistoryViewArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistoryView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistoryView_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistoryView_Bool_Exp>;
};


export type Query_RootQuality_SegmentHistoryView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistoryView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistoryView_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistoryView_Bool_Exp>;
};


export type Query_RootQuality_SegmentHistory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistory_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistory_Bool_Exp>;
};


export type Query_RootQuality_SegmentHistory_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_SegmentRefusalArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentRefusal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentRefusal_Order_By>>;
  where?: InputMaybe<Quality_SegmentRefusal_Bool_Exp>;
};


export type Query_RootQuality_SegmentRefusalPictureArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentRefusalPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentRefusalPicture_Order_By>>;
  where?: InputMaybe<Quality_SegmentRefusalPicture_Bool_Exp>;
};


export type Query_RootQuality_SegmentRefusalPicture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentRefusalPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentRefusalPicture_Order_By>>;
  where?: InputMaybe<Quality_SegmentRefusalPicture_Bool_Exp>;
};


export type Query_RootQuality_SegmentRefusalPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_SegmentRefusal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentRefusal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentRefusal_Order_By>>;
  where?: InputMaybe<Quality_SegmentRefusal_Bool_Exp>;
};


export type Query_RootQuality_SegmentRefusal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_Segment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_Segment_Order_By>>;
  where?: InputMaybe<Quality_Segment_Bool_Exp>;
};


export type Query_RootQuality_Segment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_ShapeEnumArgs = {
  distinct_on?: InputMaybe<Array<Quality_ShapeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ShapeEnum_Order_By>>;
  where?: InputMaybe<Quality_ShapeEnum_Bool_Exp>;
};


export type Query_RootQuality_ShapeEnum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ShapeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ShapeEnum_Order_By>>;
  where?: InputMaybe<Quality_ShapeEnum_Bool_Exp>;
};


export type Query_RootQuality_ShapeEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootQuality_TunnelPositionArgs = {
  distinct_on?: InputMaybe<Array<Quality_TunnelPosition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_TunnelPosition_Order_By>>;
  where?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
};


export type Query_RootQuality_TunnelPosition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_TunnelPosition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_TunnelPosition_Order_By>>;
  where?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
};


export type Query_RootQuality_TunnelPosition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_UserQualityRoleArgs = {
  distinct_on?: InputMaybe<Array<Quality_UserQualityRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_UserQualityRole_Order_By>>;
  where?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
};


export type Query_RootQuality_UserQualityRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_UserQualityRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_UserQualityRole_Order_By>>;
  where?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
};


export type Query_RootQuality_UserQualityRole_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuality_VirtualRingArgs = {
  distinct_on?: InputMaybe<Array<Quality_VirtualRing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_VirtualRing_Order_By>>;
  where?: InputMaybe<Quality_VirtualRing_Bool_Exp>;
};


export type Query_RootQuality_VirtualRing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_VirtualRing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_VirtualRing_Order_By>>;
  where?: InputMaybe<Quality_VirtualRing_Bool_Exp>;
};


export type Query_RootQuality_VirtualRing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRecurringTaskArgs = {
  distinct_on?: InputMaybe<Array<RecurringTask_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RecurringTask_Order_By>>;
  where?: InputMaybe<RecurringTask_Bool_Exp>;
};


export type Query_RootRecurringTask_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RecurringTask_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RecurringTask_Order_By>>;
  where?: InputMaybe<RecurringTask_Bool_Exp>;
};


export type Query_RootRecurringTask_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRingAggregationTasksAnalyzerArgs = {
  input: RingAggregationTasksAnalyzerInput;
};


export type Query_RootRingComplianceReportUrlArgs = {
  constructionSiteId: Scalars['ID']['input'];
  ringId: Scalars['ID']['input'];
};


export type Query_RootScan_UserArgs = {
  distinct_on?: InputMaybe<Array<Scan_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scan_User_Order_By>>;
  where?: InputMaybe<Scan_User_Bool_Exp>;
};


export type Query_RootScan_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scan_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scan_User_Order_By>>;
  where?: InputMaybe<Scan_User_Bool_Exp>;
};


export type Query_RootScan_User_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootShiftArgs = {
  distinct_on?: InputMaybe<Array<Shift_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Order_By>>;
  where?: InputMaybe<Shift_Bool_Exp>;
};


export type Query_RootShiftLeaderArgs = {
  distinct_on?: InputMaybe<Array<ShiftLeader_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftLeader_Order_By>>;
  where?: InputMaybe<ShiftLeader_Bool_Exp>;
};


export type Query_RootShiftLeader_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ShiftLeader_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftLeader_Order_By>>;
  where?: InputMaybe<ShiftLeader_Bool_Exp>;
};


export type Query_RootShiftLeader_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootShiftReportArgs = {
  distinct_on?: InputMaybe<Array<ShiftReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftReport_Order_By>>;
  where?: InputMaybe<ShiftReport_Bool_Exp>;
};


export type Query_RootShiftReportAggregatePdfDataArgs = {
  input: ShiftReportAggregatePdfInput;
};


export type Query_RootShiftReportTasksPieChartDataArgs = {
  critical?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type Query_RootShiftReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ShiftReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftReport_Order_By>>;
  where?: InputMaybe<ShiftReport_Bool_Exp>;
};


export type Query_RootShiftReport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootShiftReportsTasksAnalyzerArgs = {
  input: ShiftReportTasksAnalyzerInput;
};


export type Query_RootShift_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Order_By>>;
  where?: InputMaybe<Shift_Bool_Exp>;
};


export type Query_RootShift_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTaskArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Query_RootTaskTotalArgs = {
  distinct_on?: InputMaybe<Array<TaskTotal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotal_Order_By>>;
  where?: InputMaybe<TaskTotal_Bool_Exp>;
};


export type Query_RootTaskTotalCriticalArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalCritical_Order_By>>;
  where?: InputMaybe<TaskTotalCritical_Bool_Exp>;
};


export type Query_RootTaskTotalCritical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalCritical_Order_By>>;
  where?: InputMaybe<TaskTotalCritical_Bool_Exp>;
};


export type Query_RootTaskTotalNonCriticalArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalNonCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalNonCritical_Order_By>>;
  where?: InputMaybe<TaskTotalNonCritical_Bool_Exp>;
};


export type Query_RootTaskTotalNonCritical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalNonCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalNonCritical_Order_By>>;
  where?: InputMaybe<TaskTotalNonCritical_Bool_Exp>;
};


export type Query_RootTaskTotalRingArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalRing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalRing_Order_By>>;
  where?: InputMaybe<TaskTotalRing_Bool_Exp>;
};


export type Query_RootTaskTotalRingCriticalArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalRingCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalRingCritical_Order_By>>;
  where?: InputMaybe<TaskTotalRingCritical_Bool_Exp>;
};


export type Query_RootTaskTotalRingCritical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalRingCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalRingCritical_Order_By>>;
  where?: InputMaybe<TaskTotalRingCritical_Bool_Exp>;
};


export type Query_RootTaskTotalRingNonCriticalArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalRingNonCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalRingNonCritical_Order_By>>;
  where?: InputMaybe<TaskTotalRingNonCritical_Bool_Exp>;
};


export type Query_RootTaskTotalRingNonCritical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalRingNonCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalRingNonCritical_Order_By>>;
  where?: InputMaybe<TaskTotalRingNonCritical_Bool_Exp>;
};


export type Query_RootTaskTotalRing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalRing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalRing_Order_By>>;
  where?: InputMaybe<TaskTotalRing_Bool_Exp>;
};


export type Query_RootTaskTotal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TaskTotal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotal_Order_By>>;
  where?: InputMaybe<TaskTotal_Bool_Exp>;
};


export type Query_RootTask_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Query_RootTask_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTeamArgs = {
  distinct_on?: InputMaybe<Array<Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Order_By>>;
  where?: InputMaybe<Team_Bool_Exp>;
};


export type Query_RootTeam_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Order_By>>;
  where?: InputMaybe<Team_Bool_Exp>;
};


export type Query_RootTeam_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUserPermissionArgs = {
  distinct_on?: InputMaybe<Array<UserPermission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPermission_Order_By>>;
  where?: InputMaybe<UserPermission_Bool_Exp>;
};


export type Query_RootUserPermission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPermission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPermission_Order_By>>;
  where?: InputMaybe<UserPermission_Bool_Exp>;
};


export type Query_RootUserPermission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootValidatedShiftReportWithRingCountArgs = {
  distinct_on?: InputMaybe<Array<ValidatedShiftReportWithRingCount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ValidatedShiftReportWithRingCount_Order_By>>;
  where?: InputMaybe<ValidatedShiftReportWithRingCount_Bool_Exp>;
};


export type Query_RootValidatedShiftReportWithRingCount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidatedShiftReportWithRingCount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ValidatedShiftReportWithRingCount_Order_By>>;
  where?: InputMaybe<ValidatedShiftReportWithRingCount_Bool_Exp>;
};

/** columns and relationships of "recurringTask" */
export type RecurringTask = {
  __typename?: 'recurringTask';
  activityId: Scalars['uuid']['output'];
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  critical: Scalars['Boolean']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  note?: Maybe<Scalars['String']['output']>;
  timeOffset: Scalars['Int']['output'];
  timeOrigin: Scalars['String']['output'];
};

/** aggregated selection of "recurringTask" */
export type RecurringTask_Aggregate = {
  __typename?: 'recurringTask_aggregate';
  aggregate?: Maybe<RecurringTask_Aggregate_Fields>;
  nodes: Array<RecurringTask>;
};

/** aggregate fields of "recurringTask" */
export type RecurringTask_Aggregate_Fields = {
  __typename?: 'recurringTask_aggregate_fields';
  avg?: Maybe<RecurringTask_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RecurringTask_Max_Fields>;
  min?: Maybe<RecurringTask_Min_Fields>;
  stddev?: Maybe<RecurringTask_Stddev_Fields>;
  stddev_pop?: Maybe<RecurringTask_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RecurringTask_Stddev_Samp_Fields>;
  sum?: Maybe<RecurringTask_Sum_Fields>;
  var_pop?: Maybe<RecurringTask_Var_Pop_Fields>;
  var_samp?: Maybe<RecurringTask_Var_Samp_Fields>;
  variance?: Maybe<RecurringTask_Variance_Fields>;
};


/** aggregate fields of "recurringTask" */
export type RecurringTask_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RecurringTask_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RecurringTask_Avg_Fields = {
  __typename?: 'recurringTask_avg_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  timeOffset?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "recurringTask". All fields are combined with a logical 'AND'. */
export type RecurringTask_Bool_Exp = {
  _and?: InputMaybe<Array<RecurringTask_Bool_Exp>>;
  _not?: InputMaybe<RecurringTask_Bool_Exp>;
  _or?: InputMaybe<Array<RecurringTask_Bool_Exp>>;
  activityId?: InputMaybe<Uuid_Comparison_Exp>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  critical?: InputMaybe<Boolean_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  timeOffset?: InputMaybe<Int_Comparison_Exp>;
  timeOrigin?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "recurringTask" */
export enum RecurringTask_Constraint {
  /** unique or primary key constraint on columns "id" */
  RecurringTaskPkey = 'recurringTask_pkey'
}

/** input type for incrementing numeric columns in table "recurringTask" */
export type RecurringTask_Inc_Input = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  timeOffset?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "recurringTask" */
export type RecurringTask_Insert_Input = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  critical?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  timeOffset?: InputMaybe<Scalars['Int']['input']>;
  timeOrigin?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type RecurringTask_Max_Fields = {
  __typename?: 'recurringTask_max_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  timeOffset?: Maybe<Scalars['Int']['output']>;
  timeOrigin?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type RecurringTask_Min_Fields = {
  __typename?: 'recurringTask_min_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  timeOffset?: Maybe<Scalars['Int']['output']>;
  timeOrigin?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "recurringTask" */
export type RecurringTask_Mutation_Response = {
  __typename?: 'recurringTask_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RecurringTask>;
};

/** on_conflict condition type for table "recurringTask" */
export type RecurringTask_On_Conflict = {
  constraint: RecurringTask_Constraint;
  update_columns?: Array<RecurringTask_Update_Column>;
  where?: InputMaybe<RecurringTask_Bool_Exp>;
};

/** Ordering options when selecting data from "recurringTask". */
export type RecurringTask_Order_By = {
  activityId?: InputMaybe<Order_By>;
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  critical?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  timeOffset?: InputMaybe<Order_By>;
  timeOrigin?: InputMaybe<Order_By>;
};

/** primary key columns input for table: recurringTask */
export type RecurringTask_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "recurringTask" */
export enum RecurringTask_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Critical = 'critical',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  TimeOffset = 'timeOffset',
  /** column name */
  TimeOrigin = 'timeOrigin'
}

/** input type for updating data in table "recurringTask" */
export type RecurringTask_Set_Input = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  critical?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  timeOffset?: InputMaybe<Scalars['Int']['input']>;
  timeOrigin?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type RecurringTask_Stddev_Fields = {
  __typename?: 'recurringTask_stddev_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  timeOffset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RecurringTask_Stddev_Pop_Fields = {
  __typename?: 'recurringTask_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  timeOffset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RecurringTask_Stddev_Samp_Fields = {
  __typename?: 'recurringTask_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  timeOffset?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "recurringTask" */
export type RecurringTask_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RecurringTask_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RecurringTask_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  critical?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  timeOffset?: InputMaybe<Scalars['Int']['input']>;
  timeOrigin?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type RecurringTask_Sum_Fields = {
  __typename?: 'recurringTask_sum_fields';
  duration?: Maybe<Scalars['Int']['output']>;
  timeOffset?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "recurringTask" */
export enum RecurringTask_Update_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Critical = 'critical',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  Note = 'note',
  /** column name */
  TimeOffset = 'timeOffset',
  /** column name */
  TimeOrigin = 'timeOrigin'
}

export type RecurringTask_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RecurringTask_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecurringTask_Set_Input>;
  /** filter the rows which have to be updated */
  where: RecurringTask_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RecurringTask_Var_Pop_Fields = {
  __typename?: 'recurringTask_var_pop_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  timeOffset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RecurringTask_Var_Samp_Fields = {
  __typename?: 'recurringTask_var_samp_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  timeOffset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RecurringTask_Variance_Fields = {
  __typename?: 'recurringTask_variance_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  timeOffset?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "scan.user" */
export type Scan_User = {
  __typename?: 'scan_user';
  createdAt: Scalars['timestamp']['output'];
  displayUsername?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  projectId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamp']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "scan.user" */
export type Scan_User_Aggregate = {
  __typename?: 'scan_user_aggregate';
  aggregate?: Maybe<Scan_User_Aggregate_Fields>;
  nodes: Array<Scan_User>;
};

/** aggregate fields of "scan.user" */
export type Scan_User_Aggregate_Fields = {
  __typename?: 'scan_user_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Scan_User_Max_Fields>;
  min?: Maybe<Scan_User_Min_Fields>;
};


/** aggregate fields of "scan.user" */
export type Scan_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scan_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "scan.user". All fields are combined with a logical 'AND'. */
export type Scan_User_Bool_Exp = {
  _and?: InputMaybe<Array<Scan_User_Bool_Exp>>;
  _not?: InputMaybe<Scan_User_Bool_Exp>;
  _or?: InputMaybe<Array<Scan_User_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  displayUsername?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  emailVerified?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  image?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  projectId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "scan.user" */
export enum Scan_User_Constraint {
  /** unique or primary key constraint on columns "email" */
  UserEmailKey = 'user_email_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

/** input type for inserting data into table "scan.user" */
export type Scan_User_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  displayUsername?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Scan_User_Max_Fields = {
  __typename?: 'scan_user_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  displayUsername?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Scan_User_Min_Fields = {
  __typename?: 'scan_user_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  displayUsername?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "scan.user" */
export type Scan_User_Mutation_Response = {
  __typename?: 'scan_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Scan_User>;
};

/** on_conflict condition type for table "scan.user" */
export type Scan_User_On_Conflict = {
  constraint: Scan_User_Constraint;
  update_columns?: Array<Scan_User_Update_Column>;
  where?: InputMaybe<Scan_User_Bool_Exp>;
};

/** Ordering options when selecting data from "scan.user". */
export type Scan_User_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  displayUsername?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emailVerified?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scan.user */
export type Scan_User_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** select columns of table "scan.user" */
export enum Scan_User_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisplayUsername = 'displayUsername',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "scan.user" */
export type Scan_User_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  displayUsername?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "scan_user" */
export type Scan_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scan_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scan_User_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  displayUsername?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "scan.user" */
export enum Scan_User_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisplayUsername = 'displayUsername',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'emailVerified',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectId = 'projectId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Username = 'username'
}

export type Scan_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scan_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scan_User_Bool_Exp;
};

/** columns and relationships of "shift" */
export type Shift = {
  __typename?: 'shift';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  endTime: Scalars['time']['output'];
  id: Scalars['uuid']['output'];
  isHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  startTime: Scalars['time']['output'];
};

/** columns and relationships of "shiftLeader" */
export type ShiftLeader = {
  __typename?: 'shiftLeader';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  isHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  shiftReports: Array<ShiftReport>;
  /** An aggregate relationship */
  shiftReports_aggregate: ShiftReport_Aggregate;
};


/** columns and relationships of "shiftLeader" */
export type ShiftLeaderShiftReportsArgs = {
  distinct_on?: InputMaybe<Array<ShiftReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftReport_Order_By>>;
  where?: InputMaybe<ShiftReport_Bool_Exp>;
};


/** columns and relationships of "shiftLeader" */
export type ShiftLeaderShiftReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ShiftReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftReport_Order_By>>;
  where?: InputMaybe<ShiftReport_Bool_Exp>;
};

/** aggregated selection of "shiftLeader" */
export type ShiftLeader_Aggregate = {
  __typename?: 'shiftLeader_aggregate';
  aggregate?: Maybe<ShiftLeader_Aggregate_Fields>;
  nodes: Array<ShiftLeader>;
};

/** aggregate fields of "shiftLeader" */
export type ShiftLeader_Aggregate_Fields = {
  __typename?: 'shiftLeader_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ShiftLeader_Max_Fields>;
  min?: Maybe<ShiftLeader_Min_Fields>;
};


/** aggregate fields of "shiftLeader" */
export type ShiftLeader_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ShiftLeader_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "shiftLeader". All fields are combined with a logical 'AND'. */
export type ShiftLeader_Bool_Exp = {
  _and?: InputMaybe<Array<ShiftLeader_Bool_Exp>>;
  _not?: InputMaybe<ShiftLeader_Bool_Exp>;
  _or?: InputMaybe<Array<ShiftLeader_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  shiftReports?: InputMaybe<ShiftReport_Bool_Exp>;
  shiftReports_aggregate?: InputMaybe<ShiftReport_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "shiftLeader" */
export enum ShiftLeader_Constraint {
  /** unique or primary key constraint on columns "id" */
  ShiftLeaderPkey = 'shiftLeader_pkey'
}

/** input type for inserting data into table "shiftLeader" */
export type ShiftLeader_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shiftReports?: InputMaybe<ShiftReport_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ShiftLeader_Max_Fields = {
  __typename?: 'shiftLeader_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ShiftLeader_Min_Fields = {
  __typename?: 'shiftLeader_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "shiftLeader" */
export type ShiftLeader_Mutation_Response = {
  __typename?: 'shiftLeader_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ShiftLeader>;
};

/** input type for inserting object relation for remote table "shiftLeader" */
export type ShiftLeader_Obj_Rel_Insert_Input = {
  data: ShiftLeader_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ShiftLeader_On_Conflict>;
};

/** on_conflict condition type for table "shiftLeader" */
export type ShiftLeader_On_Conflict = {
  constraint: ShiftLeader_Constraint;
  update_columns?: Array<ShiftLeader_Update_Column>;
  where?: InputMaybe<ShiftLeader_Bool_Exp>;
};

/** Ordering options when selecting data from "shiftLeader". */
export type ShiftLeader_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isHidden?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  shiftReports_aggregate?: InputMaybe<ShiftReport_Aggregate_Order_By>;
};

/** primary key columns input for table: shiftLeader */
export type ShiftLeader_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "shiftLeader" */
export enum ShiftLeader_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "shiftLeader" */
export type ShiftLeader_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "shiftLeader" */
export type ShiftLeader_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ShiftLeader_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ShiftLeader_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "shiftLeader" */
export enum ShiftLeader_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Name = 'name'
}

export type ShiftLeader_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ShiftLeader_Set_Input>;
  /** filter the rows which have to be updated */
  where: ShiftLeader_Bool_Exp;
};

/** columns and relationships of "shiftReport" */
export type ShiftReport = {
  __typename?: 'shiftReport';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  date: Scalars['date']['output'];
  endMetricPoint?: Maybe<Scalars['Float']['output']>;
  id: Scalars['uuid']['output'];
  lastFinishedRing?: Maybe<Scalars['Int']['output']>;
  managerValidation: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  operator?: Maybe<Operator>;
  operatorId?: Maybe<Scalars['uuid']['output']>;
  operatorValidation: Scalars['Boolean']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  shift: Shift;
  /** An object relationship */
  shiftEngineer?: Maybe<User>;
  shiftEngineerId?: Maybe<Scalars['uuid']['output']>;
  shiftId: Scalars['uuid']['output'];
  /** An object relationship */
  shiftLeader?: Maybe<ShiftLeader>;
  shiftLeaderId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  shiftManager?: Maybe<User>;
  shiftManagerId?: Maybe<Scalars['uuid']['output']>;
  startMetricPoint: Scalars['Float']['output'];
  /** An array relationship */
  tasks: Array<Task>;
  /** An aggregate relationship */
  tasks_aggregate: Task_Aggregate;
  /** An object relationship */
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user: User;
  userId: Scalars['uuid']['output'];
  userName: Scalars['String']['output'];
};


/** columns and relationships of "shiftReport" */
export type ShiftReportTasksArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


/** columns and relationships of "shiftReport" */
export type ShiftReportTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** aggregated selection of "shiftReport" */
export type ShiftReport_Aggregate = {
  __typename?: 'shiftReport_aggregate';
  aggregate?: Maybe<ShiftReport_Aggregate_Fields>;
  nodes: Array<ShiftReport>;
};

export type ShiftReport_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ShiftReport_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ShiftReport_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ShiftReport_Aggregate_Bool_Exp_Count>;
};

export type ShiftReport_Aggregate_Bool_Exp_Bool_And = {
  arguments: ShiftReport_Select_Column_ShiftReport_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ShiftReport_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ShiftReport_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ShiftReport_Select_Column_ShiftReport_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ShiftReport_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ShiftReport_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ShiftReport_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ShiftReport_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shiftReport" */
export type ShiftReport_Aggregate_Fields = {
  __typename?: 'shiftReport_aggregate_fields';
  avg?: Maybe<ShiftReport_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ShiftReport_Max_Fields>;
  min?: Maybe<ShiftReport_Min_Fields>;
  stddev?: Maybe<ShiftReport_Stddev_Fields>;
  stddev_pop?: Maybe<ShiftReport_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ShiftReport_Stddev_Samp_Fields>;
  sum?: Maybe<ShiftReport_Sum_Fields>;
  var_pop?: Maybe<ShiftReport_Var_Pop_Fields>;
  var_samp?: Maybe<ShiftReport_Var_Samp_Fields>;
  variance?: Maybe<ShiftReport_Variance_Fields>;
};


/** aggregate fields of "shiftReport" */
export type ShiftReport_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ShiftReport_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "shiftReport" */
export type ShiftReport_Aggregate_Order_By = {
  avg?: InputMaybe<ShiftReport_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ShiftReport_Max_Order_By>;
  min?: InputMaybe<ShiftReport_Min_Order_By>;
  stddev?: InputMaybe<ShiftReport_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ShiftReport_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ShiftReport_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ShiftReport_Sum_Order_By>;
  var_pop?: InputMaybe<ShiftReport_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ShiftReport_Var_Samp_Order_By>;
  variance?: InputMaybe<ShiftReport_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "shiftReport" */
export type ShiftReport_Arr_Rel_Insert_Input = {
  data: Array<ShiftReport_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ShiftReport_On_Conflict>;
};

/** aggregate avg on columns */
export type ShiftReport_Avg_Fields = {
  __typename?: 'shiftReport_avg_fields';
  endMetricPoint?: Maybe<Scalars['Float']['output']>;
  lastFinishedRing?: Maybe<Scalars['Float']['output']>;
  startMetricPoint?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "shiftReport" */
export type ShiftReport_Avg_Order_By = {
  endMetricPoint?: InputMaybe<Order_By>;
  lastFinishedRing?: InputMaybe<Order_By>;
  startMetricPoint?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shiftReport". All fields are combined with a logical 'AND'. */
export type ShiftReport_Bool_Exp = {
  _and?: InputMaybe<Array<ShiftReport_Bool_Exp>>;
  _not?: InputMaybe<ShiftReport_Bool_Exp>;
  _or?: InputMaybe<Array<ShiftReport_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  endMetricPoint?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastFinishedRing?: InputMaybe<Int_Comparison_Exp>;
  managerValidation?: InputMaybe<Boolean_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  operator?: InputMaybe<Operator_Bool_Exp>;
  operatorId?: InputMaybe<Uuid_Comparison_Exp>;
  operatorValidation?: InputMaybe<Boolean_Comparison_Exp>;
  pdfUrl?: InputMaybe<String_Comparison_Exp>;
  shift?: InputMaybe<Shift_Bool_Exp>;
  shiftEngineer?: InputMaybe<User_Bool_Exp>;
  shiftEngineerId?: InputMaybe<Uuid_Comparison_Exp>;
  shiftId?: InputMaybe<Uuid_Comparison_Exp>;
  shiftLeader?: InputMaybe<ShiftLeader_Bool_Exp>;
  shiftLeaderId?: InputMaybe<Uuid_Comparison_Exp>;
  shiftManager?: InputMaybe<User_Bool_Exp>;
  shiftManagerId?: InputMaybe<Uuid_Comparison_Exp>;
  startMetricPoint?: InputMaybe<Float_Comparison_Exp>;
  tasks?: InputMaybe<Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Bool_Exp>;
  team?: InputMaybe<Team_Bool_Exp>;
  teamId?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  userName?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "shiftReport" */
export enum ShiftReport_Constraint {
  /** unique or primary key constraint on columns "id" */
  ShiftReportPkey = 'shiftReport_pkey'
}

/** input type for incrementing numeric columns in table "shiftReport" */
export type ShiftReport_Inc_Input = {
  endMetricPoint?: InputMaybe<Scalars['Float']['input']>;
  lastFinishedRing?: InputMaybe<Scalars['Int']['input']>;
  startMetricPoint?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "shiftReport" */
export type ShiftReport_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  endMetricPoint?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastFinishedRing?: InputMaybe<Scalars['Int']['input']>;
  managerValidation?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Operator_Obj_Rel_Insert_Input>;
  operatorId?: InputMaybe<Scalars['uuid']['input']>;
  operatorValidation?: InputMaybe<Scalars['Boolean']['input']>;
  pdfUrl?: InputMaybe<Scalars['String']['input']>;
  shift?: InputMaybe<Shift_Obj_Rel_Insert_Input>;
  shiftEngineer?: InputMaybe<User_Obj_Rel_Insert_Input>;
  shiftEngineerId?: InputMaybe<Scalars['uuid']['input']>;
  shiftId?: InputMaybe<Scalars['uuid']['input']>;
  shiftLeader?: InputMaybe<ShiftLeader_Obj_Rel_Insert_Input>;
  shiftLeaderId?: InputMaybe<Scalars['uuid']['input']>;
  shiftManager?: InputMaybe<User_Obj_Rel_Insert_Input>;
  shiftManagerId?: InputMaybe<Scalars['uuid']['input']>;
  startMetricPoint?: InputMaybe<Scalars['Float']['input']>;
  tasks?: InputMaybe<Task_Arr_Rel_Insert_Input>;
  team?: InputMaybe<Team_Obj_Rel_Insert_Input>;
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ShiftReport_Max_Fields = {
  __typename?: 'shiftReport_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  endMetricPoint?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastFinishedRing?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  operatorId?: Maybe<Scalars['uuid']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  shiftEngineerId?: Maybe<Scalars['uuid']['output']>;
  shiftId?: Maybe<Scalars['uuid']['output']>;
  shiftLeaderId?: Maybe<Scalars['uuid']['output']>;
  shiftManagerId?: Maybe<Scalars['uuid']['output']>;
  startMetricPoint?: Maybe<Scalars['Float']['output']>;
  teamId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "shiftReport" */
export type ShiftReport_Max_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  endMetricPoint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastFinishedRing?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  operatorId?: InputMaybe<Order_By>;
  pdfUrl?: InputMaybe<Order_By>;
  shiftEngineerId?: InputMaybe<Order_By>;
  shiftId?: InputMaybe<Order_By>;
  shiftLeaderId?: InputMaybe<Order_By>;
  shiftManagerId?: InputMaybe<Order_By>;
  startMetricPoint?: InputMaybe<Order_By>;
  teamId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  userName?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ShiftReport_Min_Fields = {
  __typename?: 'shiftReport_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  endMetricPoint?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastFinishedRing?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  operatorId?: Maybe<Scalars['uuid']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  shiftEngineerId?: Maybe<Scalars['uuid']['output']>;
  shiftId?: Maybe<Scalars['uuid']['output']>;
  shiftLeaderId?: Maybe<Scalars['uuid']['output']>;
  shiftManagerId?: Maybe<Scalars['uuid']['output']>;
  startMetricPoint?: Maybe<Scalars['Float']['output']>;
  teamId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "shiftReport" */
export type ShiftReport_Min_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  endMetricPoint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastFinishedRing?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  operatorId?: InputMaybe<Order_By>;
  pdfUrl?: InputMaybe<Order_By>;
  shiftEngineerId?: InputMaybe<Order_By>;
  shiftId?: InputMaybe<Order_By>;
  shiftLeaderId?: InputMaybe<Order_By>;
  shiftManagerId?: InputMaybe<Order_By>;
  startMetricPoint?: InputMaybe<Order_By>;
  teamId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  userName?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shiftReport" */
export type ShiftReport_Mutation_Response = {
  __typename?: 'shiftReport_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ShiftReport>;
};

/** input type for inserting object relation for remote table "shiftReport" */
export type ShiftReport_Obj_Rel_Insert_Input = {
  data: ShiftReport_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ShiftReport_On_Conflict>;
};

/** on_conflict condition type for table "shiftReport" */
export type ShiftReport_On_Conflict = {
  constraint: ShiftReport_Constraint;
  update_columns?: Array<ShiftReport_Update_Column>;
  where?: InputMaybe<ShiftReport_Bool_Exp>;
};

/** Ordering options when selecting data from "shiftReport". */
export type ShiftReport_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  endMetricPoint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastFinishedRing?: InputMaybe<Order_By>;
  managerValidation?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  operator?: InputMaybe<Operator_Order_By>;
  operatorId?: InputMaybe<Order_By>;
  operatorValidation?: InputMaybe<Order_By>;
  pdfUrl?: InputMaybe<Order_By>;
  shift?: InputMaybe<Shift_Order_By>;
  shiftEngineer?: InputMaybe<User_Order_By>;
  shiftEngineerId?: InputMaybe<Order_By>;
  shiftId?: InputMaybe<Order_By>;
  shiftLeader?: InputMaybe<ShiftLeader_Order_By>;
  shiftLeaderId?: InputMaybe<Order_By>;
  shiftManager?: InputMaybe<User_Order_By>;
  shiftManagerId?: InputMaybe<Order_By>;
  startMetricPoint?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Task_Aggregate_Order_By>;
  team?: InputMaybe<Team_Order_By>;
  teamId?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
  userName?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shiftReport */
export type ShiftReport_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "shiftReport" */
export enum ShiftReport_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Date = 'date',
  /** column name */
  EndMetricPoint = 'endMetricPoint',
  /** column name */
  Id = 'id',
  /** column name */
  LastFinishedRing = 'lastFinishedRing',
  /** column name */
  ManagerValidation = 'managerValidation',
  /** column name */
  Note = 'note',
  /** column name */
  OperatorId = 'operatorId',
  /** column name */
  OperatorValidation = 'operatorValidation',
  /** column name */
  PdfUrl = 'pdfUrl',
  /** column name */
  ShiftEngineerId = 'shiftEngineerId',
  /** column name */
  ShiftId = 'shiftId',
  /** column name */
  ShiftLeaderId = 'shiftLeaderId',
  /** column name */
  ShiftManagerId = 'shiftManagerId',
  /** column name */
  StartMetricPoint = 'startMetricPoint',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UserId = 'userId',
  /** column name */
  UserName = 'userName'
}

/** select "shiftReport_aggregate_bool_exp_bool_and_arguments_columns" columns of table "shiftReport" */
export enum ShiftReport_Select_Column_ShiftReport_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ManagerValidation = 'managerValidation',
  /** column name */
  OperatorValidation = 'operatorValidation'
}

/** select "shiftReport_aggregate_bool_exp_bool_or_arguments_columns" columns of table "shiftReport" */
export enum ShiftReport_Select_Column_ShiftReport_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ManagerValidation = 'managerValidation',
  /** column name */
  OperatorValidation = 'operatorValidation'
}

/** input type for updating data in table "shiftReport" */
export type ShiftReport_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  endMetricPoint?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastFinishedRing?: InputMaybe<Scalars['Int']['input']>;
  managerValidation?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['uuid']['input']>;
  operatorValidation?: InputMaybe<Scalars['Boolean']['input']>;
  pdfUrl?: InputMaybe<Scalars['String']['input']>;
  shiftEngineerId?: InputMaybe<Scalars['uuid']['input']>;
  shiftId?: InputMaybe<Scalars['uuid']['input']>;
  shiftLeaderId?: InputMaybe<Scalars['uuid']['input']>;
  shiftManagerId?: InputMaybe<Scalars['uuid']['input']>;
  startMetricPoint?: InputMaybe<Scalars['Float']['input']>;
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ShiftReport_Stddev_Fields = {
  __typename?: 'shiftReport_stddev_fields';
  endMetricPoint?: Maybe<Scalars['Float']['output']>;
  lastFinishedRing?: Maybe<Scalars['Float']['output']>;
  startMetricPoint?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "shiftReport" */
export type ShiftReport_Stddev_Order_By = {
  endMetricPoint?: InputMaybe<Order_By>;
  lastFinishedRing?: InputMaybe<Order_By>;
  startMetricPoint?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ShiftReport_Stddev_Pop_Fields = {
  __typename?: 'shiftReport_stddev_pop_fields';
  endMetricPoint?: Maybe<Scalars['Float']['output']>;
  lastFinishedRing?: Maybe<Scalars['Float']['output']>;
  startMetricPoint?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "shiftReport" */
export type ShiftReport_Stddev_Pop_Order_By = {
  endMetricPoint?: InputMaybe<Order_By>;
  lastFinishedRing?: InputMaybe<Order_By>;
  startMetricPoint?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ShiftReport_Stddev_Samp_Fields = {
  __typename?: 'shiftReport_stddev_samp_fields';
  endMetricPoint?: Maybe<Scalars['Float']['output']>;
  lastFinishedRing?: Maybe<Scalars['Float']['output']>;
  startMetricPoint?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "shiftReport" */
export type ShiftReport_Stddev_Samp_Order_By = {
  endMetricPoint?: InputMaybe<Order_By>;
  lastFinishedRing?: InputMaybe<Order_By>;
  startMetricPoint?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "shiftReport" */
export type ShiftReport_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ShiftReport_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ShiftReport_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  endMetricPoint?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastFinishedRing?: InputMaybe<Scalars['Int']['input']>;
  managerValidation?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['uuid']['input']>;
  operatorValidation?: InputMaybe<Scalars['Boolean']['input']>;
  pdfUrl?: InputMaybe<Scalars['String']['input']>;
  shiftEngineerId?: InputMaybe<Scalars['uuid']['input']>;
  shiftId?: InputMaybe<Scalars['uuid']['input']>;
  shiftLeaderId?: InputMaybe<Scalars['uuid']['input']>;
  shiftManagerId?: InputMaybe<Scalars['uuid']['input']>;
  startMetricPoint?: InputMaybe<Scalars['Float']['input']>;
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ShiftReport_Sum_Fields = {
  __typename?: 'shiftReport_sum_fields';
  endMetricPoint?: Maybe<Scalars['Float']['output']>;
  lastFinishedRing?: Maybe<Scalars['Int']['output']>;
  startMetricPoint?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "shiftReport" */
export type ShiftReport_Sum_Order_By = {
  endMetricPoint?: InputMaybe<Order_By>;
  lastFinishedRing?: InputMaybe<Order_By>;
  startMetricPoint?: InputMaybe<Order_By>;
};

/** update columns of table "shiftReport" */
export enum ShiftReport_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Date = 'date',
  /** column name */
  EndMetricPoint = 'endMetricPoint',
  /** column name */
  Id = 'id',
  /** column name */
  LastFinishedRing = 'lastFinishedRing',
  /** column name */
  ManagerValidation = 'managerValidation',
  /** column name */
  Note = 'note',
  /** column name */
  OperatorId = 'operatorId',
  /** column name */
  OperatorValidation = 'operatorValidation',
  /** column name */
  PdfUrl = 'pdfUrl',
  /** column name */
  ShiftEngineerId = 'shiftEngineerId',
  /** column name */
  ShiftId = 'shiftId',
  /** column name */
  ShiftLeaderId = 'shiftLeaderId',
  /** column name */
  ShiftManagerId = 'shiftManagerId',
  /** column name */
  StartMetricPoint = 'startMetricPoint',
  /** column name */
  TeamId = 'teamId',
  /** column name */
  UserId = 'userId',
  /** column name */
  UserName = 'userName'
}

export type ShiftReport_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ShiftReport_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ShiftReport_Set_Input>;
  /** filter the rows which have to be updated */
  where: ShiftReport_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ShiftReport_Var_Pop_Fields = {
  __typename?: 'shiftReport_var_pop_fields';
  endMetricPoint?: Maybe<Scalars['Float']['output']>;
  lastFinishedRing?: Maybe<Scalars['Float']['output']>;
  startMetricPoint?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "shiftReport" */
export type ShiftReport_Var_Pop_Order_By = {
  endMetricPoint?: InputMaybe<Order_By>;
  lastFinishedRing?: InputMaybe<Order_By>;
  startMetricPoint?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ShiftReport_Var_Samp_Fields = {
  __typename?: 'shiftReport_var_samp_fields';
  endMetricPoint?: Maybe<Scalars['Float']['output']>;
  lastFinishedRing?: Maybe<Scalars['Float']['output']>;
  startMetricPoint?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "shiftReport" */
export type ShiftReport_Var_Samp_Order_By = {
  endMetricPoint?: InputMaybe<Order_By>;
  lastFinishedRing?: InputMaybe<Order_By>;
  startMetricPoint?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ShiftReport_Variance_Fields = {
  __typename?: 'shiftReport_variance_fields';
  endMetricPoint?: Maybe<Scalars['Float']['output']>;
  lastFinishedRing?: Maybe<Scalars['Float']['output']>;
  startMetricPoint?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "shiftReport" */
export type ShiftReport_Variance_Order_By = {
  endMetricPoint?: InputMaybe<Order_By>;
  lastFinishedRing?: InputMaybe<Order_By>;
  startMetricPoint?: InputMaybe<Order_By>;
};

/** aggregated selection of "shift" */
export type Shift_Aggregate = {
  __typename?: 'shift_aggregate';
  aggregate?: Maybe<Shift_Aggregate_Fields>;
  nodes: Array<Shift>;
};

/** aggregate fields of "shift" */
export type Shift_Aggregate_Fields = {
  __typename?: 'shift_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Shift_Max_Fields>;
  min?: Maybe<Shift_Min_Fields>;
};


/** aggregate fields of "shift" */
export type Shift_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shift_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "shift". All fields are combined with a logical 'AND'. */
export type Shift_Bool_Exp = {
  _and?: InputMaybe<Array<Shift_Bool_Exp>>;
  _not?: InputMaybe<Shift_Bool_Exp>;
  _or?: InputMaybe<Array<Shift_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  endTime?: InputMaybe<Time_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  startTime?: InputMaybe<Time_Comparison_Exp>;
};

/** unique or primary key constraints on table "shift" */
export enum Shift_Constraint {
  /** unique or primary key constraint on columns "id" */
  ShiftPkey = 'shift_pkey'
}

/** input type for inserting data into table "shift" */
export type Shift_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  endTime?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['time']['input']>;
};

/** aggregate max on columns */
export type Shift_Max_Fields = {
  __typename?: 'shift_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Shift_Min_Fields = {
  __typename?: 'shift_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "shift" */
export type Shift_Mutation_Response = {
  __typename?: 'shift_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Shift>;
};

/** input type for inserting object relation for remote table "shift" */
export type Shift_Obj_Rel_Insert_Input = {
  data: Shift_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Shift_On_Conflict>;
};

/** on_conflict condition type for table "shift" */
export type Shift_On_Conflict = {
  constraint: Shift_Constraint;
  update_columns?: Array<Shift_Update_Column>;
  where?: InputMaybe<Shift_Bool_Exp>;
};

/** Ordering options when selecting data from "shift". */
export type Shift_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  endTime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isHidden?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shift */
export type Shift_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "shift" */
export enum Shift_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Name = 'name',
  /** column name */
  StartTime = 'startTime'
}

/** input type for updating data in table "shift" */
export type Shift_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  endTime?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['time']['input']>;
};

/** Streaming cursor of the table "shift" */
export type Shift_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shift_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shift_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  endTime?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['time']['input']>;
};

/** update columns of table "shift" */
export enum Shift_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Name = 'name',
  /** column name */
  StartTime = 'startTime'
}

export type Shift_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Shift_Set_Input>;
  /** filter the rows which have to be updated */
  where: Shift_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "activity" */
  activity: Array<Activity>;
  /** fetch data from the table: "activityFullName" */
  activityFullName: Array<ActivityFullName>;
  /** fetch aggregated fields from the table: "activityFullName" */
  activityFullName_aggregate: ActivityFullName_Aggregate;
  /** fetch data from the table in a streaming manner: "activityFullName" */
  activityFullName_stream: Array<ActivityFullName>;
  /** fetch aggregated fields from the table: "activity" */
  activity_aggregate: Activity_Aggregate;
  /** fetch data from the table: "activity" using primary key columns */
  activity_by_pk?: Maybe<Activity>;
  /** fetch data from the table in a streaming manner: "activity" */
  activity_stream: Array<Activity>;
  /** fetch data from the table: "autofillApi" */
  autofillApi: Array<AutofillApi>;
  /** fetch aggregated fields from the table: "autofillApi" */
  autofillApi_aggregate: AutofillApi_Aggregate;
  /** fetch data from the table: "autofillApi" using primary key columns */
  autofillApi_by_pk?: Maybe<AutofillApi>;
  /** fetch data from the table in a streaming manner: "autofillApi" */
  autofillApi_stream: Array<AutofillApi>;
  /** fetch data from the table: "constructionSite" */
  constructionSite: Array<ConstructionSite>;
  /** fetch data from the table: "constructionSiteEnabledModule" */
  constructionSiteEnabledModule: Array<ConstructionSiteEnabledModule>;
  /** fetch aggregated fields from the table: "constructionSiteEnabledModule" */
  constructionSiteEnabledModule_aggregate: ConstructionSiteEnabledModule_Aggregate;
  /** fetch data from the table: "constructionSiteEnabledModule" using primary key columns */
  constructionSiteEnabledModule_by_pk?: Maybe<ConstructionSiteEnabledModule>;
  /** fetch data from the table in a streaming manner: "constructionSiteEnabledModule" */
  constructionSiteEnabledModule_stream: Array<ConstructionSiteEnabledModule>;
  /** fetch aggregated fields from the table: "constructionSite" */
  constructionSite_aggregate: ConstructionSite_Aggregate;
  /** fetch data from the table: "constructionSite" using primary key columns */
  constructionSite_by_pk?: Maybe<ConstructionSite>;
  /** fetch data from the table in a streaming manner: "constructionSite" */
  constructionSite_stream: Array<ConstructionSite>;
  /** fetch data from the table: "dailyShiftTemplate" */
  dailyShiftTemplate: Array<DailyShiftTemplate>;
  /** fetch aggregated fields from the table: "dailyShiftTemplate" */
  dailyShiftTemplate_aggregate: DailyShiftTemplate_Aggregate;
  /** fetch data from the table: "dailyShiftTemplate" using primary key columns */
  dailyShiftTemplate_by_pk?: Maybe<DailyShiftTemplate>;
  /** fetch data from the table in a streaming manner: "dailyShiftTemplate" */
  dailyShiftTemplate_stream: Array<DailyShiftTemplate>;
  /** fetch data from the table: "file.bucketFile" */
  file_bucketFile: Array<File_BucketFile>;
  /** fetch aggregated fields from the table: "file.bucketFile" */
  file_bucketFile_aggregate: File_BucketFile_Aggregate;
  /** fetch data from the table: "file.bucketFile" using primary key columns */
  file_bucketFile_by_pk?: Maybe<File_BucketFile>;
  /** fetch data from the table in a streaming manner: "file.bucketFile" */
  file_bucketFile_stream: Array<File_BucketFile>;
  /** fetch data from the table: "file.bucketTypeEnum" */
  file_bucketTypeEnum: Array<File_BucketTypeEnum>;
  /** fetch aggregated fields from the table: "file.bucketTypeEnum" */
  file_bucketTypeEnum_aggregate: File_BucketTypeEnum_Aggregate;
  /** fetch data from the table: "file.bucketTypeEnum" using primary key columns */
  file_bucketTypeEnum_by_pk?: Maybe<File_BucketTypeEnum>;
  /** fetch data from the table in a streaming manner: "file.bucketTypeEnum" */
  file_bucketTypeEnum_stream: Array<File_BucketTypeEnum>;
  /** fetch data from the table: "graphSet" */
  graphSet: Array<GraphSet>;
  /** fetch data from the table: "graphSetTypeEnum" */
  graphSetTypeEnum: Array<GraphSetTypeEnum>;
  /** fetch aggregated fields from the table: "graphSetTypeEnum" */
  graphSetTypeEnum_aggregate: GraphSetTypeEnum_Aggregate;
  /** fetch data from the table: "graphSetTypeEnum" using primary key columns */
  graphSetTypeEnum_by_pk?: Maybe<GraphSetTypeEnum>;
  /** fetch data from the table in a streaming manner: "graphSetTypeEnum" */
  graphSetTypeEnum_stream: Array<GraphSetTypeEnum>;
  /** fetch aggregated fields from the table: "graphSet" */
  graphSet_aggregate: GraphSet_Aggregate;
  /** fetch data from the table: "graphSet" using primary key columns */
  graphSet_by_pk?: Maybe<GraphSet>;
  /** fetch data from the table in a streaming manner: "graphSet" */
  graphSet_stream: Array<GraphSet>;
  /** fetch data from the table: "indicator" */
  indicator: Array<Indicator>;
  /** fetch aggregated fields from the table: "indicator" */
  indicator_aggregate: Indicator_Aggregate;
  /** fetch data from the table: "indicator" using primary key columns */
  indicator_by_pk?: Maybe<Indicator>;
  /** fetch data from the table in a streaming manner: "indicator" */
  indicator_stream: Array<Indicator>;
  /** fetch data from the table: "mapConfiguration" */
  mapConfiguration: Array<MapConfiguration>;
  /** fetch aggregated fields from the table: "mapConfiguration" */
  mapConfiguration_aggregate: MapConfiguration_Aggregate;
  /** fetch data from the table: "mapConfiguration" using primary key columns */
  mapConfiguration_by_pk?: Maybe<MapConfiguration>;
  /** fetch data from the table in a streaming manner: "mapConfiguration" */
  mapConfiguration_stream: Array<MapConfiguration>;
  /** fetch data from the table: "mapPoi" */
  mapPoi: Array<MapPoi>;
  /** fetch aggregated fields from the table: "mapPoi" */
  mapPoi_aggregate: MapPoi_Aggregate;
  /** fetch data from the table: "mapPoi" using primary key columns */
  mapPoi_by_pk?: Maybe<MapPoi>;
  /** fetch data from the table in a streaming manner: "mapPoi" */
  mapPoi_stream: Array<MapPoi>;
  /** fetch data from the table: "mapTrace" */
  mapTrace: Array<MapTrace>;
  /** fetch aggregated fields from the table: "mapTrace" */
  mapTrace_aggregate: MapTrace_Aggregate;
  /** fetch data from the table: "mapTrace" using primary key columns */
  mapTrace_by_pk?: Maybe<MapTrace>;
  /** fetch data from the table in a streaming manner: "mapTrace" */
  mapTrace_stream: Array<MapTrace>;
  /** fetch data from the table: "module" */
  module: Array<Module>;
  /** fetch aggregated fields from the table: "module" */
  module_aggregate: Module_Aggregate;
  /** fetch data from the table: "module" using primary key columns */
  module_by_pk?: Maybe<Module>;
  /** fetch data from the table in a streaming manner: "module" */
  module_stream: Array<Module>;
  /** fetch data from the table: "operator" */
  operator: Array<Operator>;
  /** fetch aggregated fields from the table: "operator" */
  operator_aggregate: Operator_Aggregate;
  /** fetch data from the table: "operator" using primary key columns */
  operator_by_pk?: Maybe<Operator>;
  /** fetch data from the table in a streaming manner: "operator" */
  operator_stream: Array<Operator>;
  /** fetch data from the table: "parameter.constructionSiteParameterNameConfig" */
  parameter_constructionSiteParameterNameConfig: Array<Parameter_ConstructionSiteParameterNameConfig>;
  /** fetch aggregated fields from the table: "parameter.constructionSiteParameterNameConfig" */
  parameter_constructionSiteParameterNameConfig_aggregate: Parameter_ConstructionSiteParameterNameConfig_Aggregate;
  /** fetch data from the table: "parameter.constructionSiteParameterNameConfig" using primary key columns */
  parameter_constructionSiteParameterNameConfig_by_pk?: Maybe<Parameter_ConstructionSiteParameterNameConfig>;
  /** fetch data from the table in a streaming manner: "parameter.constructionSiteParameterNameConfig" */
  parameter_constructionSiteParameterNameConfig_stream: Array<Parameter_ConstructionSiteParameterNameConfig>;
  /** fetch data from the table: "parameter.familyDef" */
  parameter_familyDef: Array<Parameter_FamilyDef>;
  /** fetch aggregated fields from the table: "parameter.familyDef" */
  parameter_familyDef_aggregate: Parameter_FamilyDef_Aggregate;
  /** fetch data from the table: "parameter.familyDef" using primary key columns */
  parameter_familyDef_by_pk?: Maybe<Parameter_FamilyDef>;
  /** fetch data from the table in a streaming manner: "parameter.familyDef" */
  parameter_familyDef_stream: Array<Parameter_FamilyDef>;
  /** fetch data from the table: "parameter.metric" */
  parameter_metric: Array<Parameter_Metric>;
  /** fetch aggregated fields from the table: "parameter.metric" */
  parameter_metric_aggregate: Parameter_Metric_Aggregate;
  /** fetch data from the table: "parameter.metric" using primary key columns */
  parameter_metric_by_pk?: Maybe<Parameter_Metric>;
  /** fetch data from the table in a streaming manner: "parameter.metric" */
  parameter_metric_stream: Array<Parameter_Metric>;
  /** fetch data from the table: "parameter.parameterDef" */
  parameter_parameterDef: Array<Parameter_ParameterDef>;
  /** fetch aggregated fields from the table: "parameter.parameterDef" */
  parameter_parameterDef_aggregate: Parameter_ParameterDef_Aggregate;
  /** fetch data from the table: "parameter.parameterDef" using primary key columns */
  parameter_parameterDef_by_pk?: Maybe<Parameter_ParameterDef>;
  /** fetch data from the table in a streaming manner: "parameter.parameterDef" */
  parameter_parameterDef_stream: Array<Parameter_ParameterDef>;
  /** fetch data from the table: "parameter.ring" */
  parameter_ring: Array<Parameter_Ring>;
  /** fetch data from the table: "parameter.ringProjection" */
  parameter_ringProjection: Array<Parameter_RingProjection>;
  /** fetch aggregated fields from the table: "parameter.ringProjection" */
  parameter_ringProjection_aggregate: Parameter_RingProjection_Aggregate;
  /** fetch data from the table: "parameter.ringProjection" using primary key columns */
  parameter_ringProjection_by_pk?: Maybe<Parameter_RingProjection>;
  /** fetch data from the table in a streaming manner: "parameter.ringProjection" */
  parameter_ringProjection_stream: Array<Parameter_RingProjection>;
  /** fetch data from the table: "parameter.ringWithProductionDay" */
  parameter_ringWithProductionDay: Array<Parameter_RingWithProductionDay>;
  /** fetch aggregated fields from the table: "parameter.ringWithProductionDay" */
  parameter_ringWithProductionDay_aggregate: Parameter_RingWithProductionDay_Aggregate;
  /** fetch data from the table in a streaming manner: "parameter.ringWithProductionDay" */
  parameter_ringWithProductionDay_stream: Array<Parameter_RingWithProductionDay>;
  /** fetch data from the table: "parameter.ringWithShifts" */
  parameter_ringWithShifts: Array<Parameter_RingWithShifts>;
  /** fetch aggregated fields from the table: "parameter.ringWithShifts" */
  parameter_ringWithShifts_aggregate: Parameter_RingWithShifts_Aggregate;
  /** fetch data from the table in a streaming manner: "parameter.ringWithShifts" */
  parameter_ringWithShifts_stream: Array<Parameter_RingWithShifts>;
  /** fetch aggregated fields from the table: "parameter.ring" */
  parameter_ring_aggregate: Parameter_Ring_Aggregate;
  /** fetch data from the table: "parameter.ring" using primary key columns */
  parameter_ring_by_pk?: Maybe<Parameter_Ring>;
  /** fetch data from the table in a streaming manner: "parameter.ring" */
  parameter_ring_stream: Array<Parameter_Ring>;
  /** fetch data from the table: "parameter.value" */
  parameter_value: Array<Parameter_Value>;
  /** fetch aggregated fields from the table: "parameter.value" */
  parameter_value_aggregate: Parameter_Value_Aggregate;
  /** fetch data from the table: "parameter.value" using primary key columns */
  parameter_value_by_pk?: Maybe<Parameter_Value>;
  /** fetch data from the table in a streaming manner: "parameter.value" */
  parameter_value_stream: Array<Parameter_Value>;
  /** fetch data from the table: "permissionType" */
  permissionType: Array<PermissionType>;
  /** fetch aggregated fields from the table: "permissionType" */
  permissionType_aggregate: PermissionType_Aggregate;
  /** fetch data from the table: "permissionType" using primary key columns */
  permissionType_by_pk?: Maybe<PermissionType>;
  /** fetch data from the table in a streaming manner: "permissionType" */
  permissionType_stream: Array<PermissionType>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** fetch data from the table in a streaming manner: "project" */
  project_stream: Array<Project>;
  /** fetch data from the table: "quality.boardConfig" */
  quality_boardConfig: Array<Quality_BoardConfig>;
  /** fetch aggregated fields from the table: "quality.boardConfig" */
  quality_boardConfig_aggregate: Quality_BoardConfig_Aggregate;
  /** fetch data from the table: "quality.boardConfig" using primary key columns */
  quality_boardConfig_by_pk?: Maybe<Quality_BoardConfig>;
  /** fetch data from the table in a streaming manner: "quality.boardConfig" */
  quality_boardConfig_stream: Array<Quality_BoardConfig>;
  /** fetch data from the table: "quality.boardSegment" */
  quality_boardSegment: Array<Quality_BoardSegment>;
  /** fetch aggregated fields from the table: "quality.boardSegment" */
  quality_boardSegment_aggregate: Quality_BoardSegment_Aggregate;
  /** fetch data from the table: "quality.boardSegment" using primary key columns */
  quality_boardSegment_by_pk?: Maybe<Quality_BoardSegment>;
  /** fetch data from the table in a streaming manner: "quality.boardSegment" */
  quality_boardSegment_stream: Array<Quality_BoardSegment>;
  /** fetch data from the table: "quality.defectRepair" */
  quality_defectRepair: Array<Quality_DefectRepair>;
  /** fetch data from the table: "quality.defectRepairPicture" */
  quality_defectRepairPicture: Array<Quality_DefectRepairPicture>;
  /** fetch aggregated fields from the table: "quality.defectRepairPicture" */
  quality_defectRepairPicture_aggregate: Quality_DefectRepairPicture_Aggregate;
  /** fetch data from the table: "quality.defectRepairPicture" using primary key columns */
  quality_defectRepairPicture_by_pk?: Maybe<Quality_DefectRepairPicture>;
  /** fetch data from the table in a streaming manner: "quality.defectRepairPicture" */
  quality_defectRepairPicture_stream: Array<Quality_DefectRepairPicture>;
  /** fetch data from the table: "quality.defectRepairType" */
  quality_defectRepairType: Array<Quality_DefectRepairType>;
  /** fetch aggregated fields from the table: "quality.defectRepairType" */
  quality_defectRepairType_aggregate: Quality_DefectRepairType_Aggregate;
  /** fetch data from the table: "quality.defectRepairType" using primary key columns */
  quality_defectRepairType_by_pk?: Maybe<Quality_DefectRepairType>;
  /** fetch data from the table in a streaming manner: "quality.defectRepairType" */
  quality_defectRepairType_stream: Array<Quality_DefectRepairType>;
  /** fetch aggregated fields from the table: "quality.defectRepair" */
  quality_defectRepair_aggregate: Quality_DefectRepair_Aggregate;
  /** fetch data from the table: "quality.defectRepair" using primary key columns */
  quality_defectRepair_by_pk?: Maybe<Quality_DefectRepair>;
  /** fetch data from the table in a streaming manner: "quality.defectRepair" */
  quality_defectRepair_stream: Array<Quality_DefectRepair>;
  /** fetch data from the table: "quality.defectReport" */
  quality_defectReport: Array<Quality_DefectReport>;
  /** fetch data from the table: "quality.defectReportPicture" */
  quality_defectReportPicture: Array<Quality_DefectReportPicture>;
  /** fetch aggregated fields from the table: "quality.defectReportPicture" */
  quality_defectReportPicture_aggregate: Quality_DefectReportPicture_Aggregate;
  /** fetch data from the table: "quality.defectReportPicture" using primary key columns */
  quality_defectReportPicture_by_pk?: Maybe<Quality_DefectReportPicture>;
  /** fetch data from the table in a streaming manner: "quality.defectReportPicture" */
  quality_defectReportPicture_stream: Array<Quality_DefectReportPicture>;
  /** fetch data from the table: "quality.defectReportType" */
  quality_defectReportType: Array<Quality_DefectReportType>;
  /** fetch aggregated fields from the table: "quality.defectReportType" */
  quality_defectReportType_aggregate: Quality_DefectReportType_Aggregate;
  /** fetch data from the table: "quality.defectReportType" using primary key columns */
  quality_defectReportType_by_pk?: Maybe<Quality_DefectReportType>;
  /** fetch data from the table in a streaming manner: "quality.defectReportType" */
  quality_defectReportType_stream: Array<Quality_DefectReportType>;
  /** fetch data from the table: "quality.defectReportView" */
  quality_defectReportView: Array<Quality_DefectReportView>;
  /** fetch aggregated fields from the table: "quality.defectReportView" */
  quality_defectReportView_aggregate: Quality_DefectReportView_Aggregate;
  /** fetch data from the table in a streaming manner: "quality.defectReportView" */
  quality_defectReportView_stream: Array<Quality_DefectReportView>;
  /** fetch aggregated fields from the table: "quality.defectReport" */
  quality_defectReport_aggregate: Quality_DefectReport_Aggregate;
  /** fetch data from the table: "quality.defectReport" using primary key columns */
  quality_defectReport_by_pk?: Maybe<Quality_DefectReport>;
  /** fetch data from the table in a streaming manner: "quality.defectReport" */
  quality_defectReport_stream: Array<Quality_DefectReport>;
  /** fetch data from the table: "quality.importConfig" */
  quality_importConfig: Array<Quality_ImportConfig>;
  /** fetch aggregated fields from the table: "quality.importConfig" */
  quality_importConfig_aggregate: Quality_ImportConfig_Aggregate;
  /** fetch data from the table: "quality.importConfig" using primary key columns */
  quality_importConfig_by_pk?: Maybe<Quality_ImportConfig>;
  /** fetch data from the table in a streaming manner: "quality.importConfig" */
  quality_importConfig_stream: Array<Quality_ImportConfig>;
  /** fetch data from the table: "quality.importExtraColumn" */
  quality_importExtraColumn: Array<Quality_ImportExtraColumn>;
  /** fetch aggregated fields from the table: "quality.importExtraColumn" */
  quality_importExtraColumn_aggregate: Quality_ImportExtraColumn_Aggregate;
  /** fetch data from the table: "quality.importExtraColumn" using primary key columns */
  quality_importExtraColumn_by_pk?: Maybe<Quality_ImportExtraColumn>;
  /** fetch data from the table in a streaming manner: "quality.importExtraColumn" */
  quality_importExtraColumn_stream: Array<Quality_ImportExtraColumn>;
  /** fetch data from the table: "quality.importTask" */
  quality_importTask: Array<Quality_ImportTask>;
  /** fetch aggregated fields from the table: "quality.importTask" */
  quality_importTask_aggregate: Quality_ImportTask_Aggregate;
  /** fetch data from the table: "quality.importTask" using primary key columns */
  quality_importTask_by_pk?: Maybe<Quality_ImportTask>;
  /** fetch data from the table in a streaming manner: "quality.importTask" */
  quality_importTask_stream: Array<Quality_ImportTask>;
  /** fetch data from the table: "quality.indicator" */
  quality_indicator: Array<Quality_Indicator>;
  /** fetch aggregated fields from the table: "quality.indicator" */
  quality_indicator_aggregate: Quality_Indicator_Aggregate;
  /** fetch data from the table: "quality.indicator" using primary key columns */
  quality_indicator_by_pk?: Maybe<Quality_Indicator>;
  /** fetch data from the table in a streaming manner: "quality.indicator" */
  quality_indicator_stream: Array<Quality_Indicator>;
  /** fetch data from the table: "quality.quarantineDefect" */
  quality_quarantineDefect: Array<Quality_QuarantineDefect>;
  /** fetch data from the table: "quality.quarantineDefectOrientationEnum" */
  quality_quarantineDefectOrientationEnum: Array<Quality_QuarantineDefectOrientationEnum>;
  /** fetch aggregated fields from the table: "quality.quarantineDefectOrientationEnum" */
  quality_quarantineDefectOrientationEnum_aggregate: Quality_QuarantineDefectOrientationEnum_Aggregate;
  /** fetch data from the table: "quality.quarantineDefectOrientationEnum" using primary key columns */
  quality_quarantineDefectOrientationEnum_by_pk?: Maybe<Quality_QuarantineDefectOrientationEnum>;
  /** fetch data from the table in a streaming manner: "quality.quarantineDefectOrientationEnum" */
  quality_quarantineDefectOrientationEnum_stream: Array<Quality_QuarantineDefectOrientationEnum>;
  /** fetch data from the table: "quality.quarantineDefectPicture" */
  quality_quarantineDefectPicture: Array<Quality_QuarantineDefectPicture>;
  /** fetch aggregated fields from the table: "quality.quarantineDefectPicture" */
  quality_quarantineDefectPicture_aggregate: Quality_QuarantineDefectPicture_Aggregate;
  /** fetch data from the table: "quality.quarantineDefectPicture" using primary key columns */
  quality_quarantineDefectPicture_by_pk?: Maybe<Quality_QuarantineDefectPicture>;
  /** fetch data from the table in a streaming manner: "quality.quarantineDefectPicture" */
  quality_quarantineDefectPicture_stream: Array<Quality_QuarantineDefectPicture>;
  /** fetch data from the table: "quality.quarantineDefectType" */
  quality_quarantineDefectType: Array<Quality_QuarantineDefectType>;
  /** fetch aggregated fields from the table: "quality.quarantineDefectType" */
  quality_quarantineDefectType_aggregate: Quality_QuarantineDefectType_Aggregate;
  /** fetch data from the table: "quality.quarantineDefectType" using primary key columns */
  quality_quarantineDefectType_by_pk?: Maybe<Quality_QuarantineDefectType>;
  /** fetch data from the table in a streaming manner: "quality.quarantineDefectType" */
  quality_quarantineDefectType_stream: Array<Quality_QuarantineDefectType>;
  /** fetch aggregated fields from the table: "quality.quarantineDefect" */
  quality_quarantineDefect_aggregate: Quality_QuarantineDefect_Aggregate;
  /** fetch data from the table: "quality.quarantineDefect" using primary key columns */
  quality_quarantineDefect_by_pk?: Maybe<Quality_QuarantineDefect>;
  /** fetch data from the table in a streaming manner: "quality.quarantineDefect" */
  quality_quarantineDefect_stream: Array<Quality_QuarantineDefect>;
  /** fetch data from the table: "quality.repairReport" */
  quality_repairReport: Array<Quality_RepairReport>;
  /** fetch data from the table: "quality.repairReportPicture" */
  quality_repairReportPicture: Array<Quality_RepairReportPicture>;
  /** fetch aggregated fields from the table: "quality.repairReportPicture" */
  quality_repairReportPicture_aggregate: Quality_RepairReportPicture_Aggregate;
  /** fetch data from the table: "quality.repairReportPicture" using primary key columns */
  quality_repairReportPicture_by_pk?: Maybe<Quality_RepairReportPicture>;
  /** fetch data from the table in a streaming manner: "quality.repairReportPicture" */
  quality_repairReportPicture_stream: Array<Quality_RepairReportPicture>;
  /** fetch aggregated fields from the table: "quality.repairReport" */
  quality_repairReport_aggregate: Quality_RepairReport_Aggregate;
  /** fetch data from the table: "quality.repairReport" using primary key columns */
  quality_repairReport_by_pk?: Maybe<Quality_RepairReport>;
  /** fetch data from the table in a streaming manner: "quality.repairReport" */
  quality_repairReport_stream: Array<Quality_RepairReport>;
  /** fetch data from the table: "quality.ringValidation" */
  quality_ringValidation: Array<Quality_RingValidation>;
  /** fetch data from the table: "quality.ringValidationView" */
  quality_ringValidationView: Array<Quality_RingValidationView>;
  /** fetch aggregated fields from the table: "quality.ringValidationView" */
  quality_ringValidationView_aggregate: Quality_RingValidationView_Aggregate;
  /** fetch data from the table in a streaming manner: "quality.ringValidationView" */
  quality_ringValidationView_stream: Array<Quality_RingValidationView>;
  /** fetch aggregated fields from the table: "quality.ringValidation" */
  quality_ringValidation_aggregate: Quality_RingValidation_Aggregate;
  /** fetch data from the table: "quality.ringValidation" using primary key columns */
  quality_ringValidation_by_pk?: Maybe<Quality_RingValidation>;
  /** fetch data from the table in a streaming manner: "quality.ringValidation" */
  quality_ringValidation_stream: Array<Quality_RingValidation>;
  /** fetch data from the table: "quality.scanCodeConfig" */
  quality_scanCodeConfig: Array<Quality_ScanCodeConfig>;
  /** fetch aggregated fields from the table: "quality.scanCodeConfig" */
  quality_scanCodeConfig_aggregate: Quality_ScanCodeConfig_Aggregate;
  /** fetch data from the table: "quality.scanCodeConfig" using primary key columns */
  quality_scanCodeConfig_by_pk?: Maybe<Quality_ScanCodeConfig>;
  /** fetch data from the table in a streaming manner: "quality.scanCodeConfig" */
  quality_scanCodeConfig_stream: Array<Quality_ScanCodeConfig>;
  /** fetch data from the table: "quality.scanConfig" */
  quality_scanConfig: Array<Quality_ScanConfig>;
  /** fetch aggregated fields from the table: "quality.scanConfig" */
  quality_scanConfig_aggregate: Quality_ScanConfig_Aggregate;
  /** fetch data from the table: "quality.scanConfig" using primary key columns */
  quality_scanConfig_by_pk?: Maybe<Quality_ScanConfig>;
  /** fetch data from the table in a streaming manner: "quality.scanConfig" */
  quality_scanConfig_stream: Array<Quality_ScanConfig>;
  /** fetch data from the table: "quality.scanSite" */
  quality_scanSite: Array<Quality_ScanSite>;
  /** fetch data from the table: "quality.scanSiteConstructionSite" */
  quality_scanSiteConstructionSite: Array<Quality_ScanSiteConstructionSite>;
  /** fetch aggregated fields from the table: "quality.scanSiteConstructionSite" */
  quality_scanSiteConstructionSite_aggregate: Quality_ScanSiteConstructionSite_Aggregate;
  /** fetch data from the table: "quality.scanSiteConstructionSite" using primary key columns */
  quality_scanSiteConstructionSite_by_pk?: Maybe<Quality_ScanSiteConstructionSite>;
  /** fetch data from the table in a streaming manner: "quality.scanSiteConstructionSite" */
  quality_scanSiteConstructionSite_stream: Array<Quality_ScanSiteConstructionSite>;
  /** fetch aggregated fields from the table: "quality.scanSite" */
  quality_scanSite_aggregate: Quality_ScanSite_Aggregate;
  /** fetch data from the table: "quality.scanSite" using primary key columns */
  quality_scanSite_by_pk?: Maybe<Quality_ScanSite>;
  /** fetch data from the table in a streaming manner: "quality.scanSite" */
  quality_scanSite_stream: Array<Quality_ScanSite>;
  /** fetch data from the table: "quality.scanTypeEnum" */
  quality_scanTypeEnum: Array<Quality_ScanTypeEnum>;
  /** fetch aggregated fields from the table: "quality.scanTypeEnum" */
  quality_scanTypeEnum_aggregate: Quality_ScanTypeEnum_Aggregate;
  /** fetch data from the table: "quality.scanTypeEnum" using primary key columns */
  quality_scanTypeEnum_by_pk?: Maybe<Quality_ScanTypeEnum>;
  /** fetch data from the table in a streaming manner: "quality.scanTypeEnum" */
  quality_scanTypeEnum_stream: Array<Quality_ScanTypeEnum>;
  /** fetch data from the table: "quality.segment" */
  quality_segment: Array<Quality_Segment>;
  /** fetch data from the table: "quality.segmentDrawConfig" */
  quality_segmentDrawConfig: Array<Quality_SegmentDrawConfig>;
  /** fetch aggregated fields from the table: "quality.segmentDrawConfig" */
  quality_segmentDrawConfig_aggregate: Quality_SegmentDrawConfig_Aggregate;
  /** fetch data from the table: "quality.segmentDrawConfig" using primary key columns */
  quality_segmentDrawConfig_by_pk?: Maybe<Quality_SegmentDrawConfig>;
  /** fetch data from the table in a streaming manner: "quality.segmentDrawConfig" */
  quality_segmentDrawConfig_stream: Array<Quality_SegmentDrawConfig>;
  /** fetch data from the table: "quality.segmentExtraParameter" */
  quality_segmentExtraParameter: Array<Quality_SegmentExtraParameter>;
  /** fetch aggregated fields from the table: "quality.segmentExtraParameter" */
  quality_segmentExtraParameter_aggregate: Quality_SegmentExtraParameter_Aggregate;
  /** fetch data from the table: "quality.segmentExtraParameter" using primary key columns */
  quality_segmentExtraParameter_by_pk?: Maybe<Quality_SegmentExtraParameter>;
  /** fetch data from the table in a streaming manner: "quality.segmentExtraParameter" */
  quality_segmentExtraParameter_stream: Array<Quality_SegmentExtraParameter>;
  /** fetch data from the table: "quality.segmentHistory" */
  quality_segmentHistory: Array<Quality_SegmentHistory>;
  /** fetch data from the table: "quality.segmentHistoryStatusEnum" */
  quality_segmentHistoryStatusEnum: Array<Quality_SegmentHistoryStatusEnum>;
  /** fetch aggregated fields from the table: "quality.segmentHistoryStatusEnum" */
  quality_segmentHistoryStatusEnum_aggregate: Quality_SegmentHistoryStatusEnum_Aggregate;
  /** fetch data from the table: "quality.segmentHistoryStatusEnum" using primary key columns */
  quality_segmentHistoryStatusEnum_by_pk?: Maybe<Quality_SegmentHistoryStatusEnum>;
  /** fetch data from the table in a streaming manner: "quality.segmentHistoryStatusEnum" */
  quality_segmentHistoryStatusEnum_stream: Array<Quality_SegmentHistoryStatusEnum>;
  /** fetch data from the table: "quality.segmentHistoryView" */
  quality_segmentHistoryView: Array<Quality_SegmentHistoryView>;
  /** fetch aggregated fields from the table: "quality.segmentHistoryView" */
  quality_segmentHistoryView_aggregate: Quality_SegmentHistoryView_Aggregate;
  /** fetch data from the table in a streaming manner: "quality.segmentHistoryView" */
  quality_segmentHistoryView_stream: Array<Quality_SegmentHistoryView>;
  /** fetch aggregated fields from the table: "quality.segmentHistory" */
  quality_segmentHistory_aggregate: Quality_SegmentHistory_Aggregate;
  /** fetch data from the table: "quality.segmentHistory" using primary key columns */
  quality_segmentHistory_by_pk?: Maybe<Quality_SegmentHistory>;
  /** fetch data from the table in a streaming manner: "quality.segmentHistory" */
  quality_segmentHistory_stream: Array<Quality_SegmentHistory>;
  /** fetch data from the table: "quality.segmentRefusal" */
  quality_segmentRefusal: Array<Quality_SegmentRefusal>;
  /** fetch data from the table: "quality.segmentRefusalPicture" */
  quality_segmentRefusalPicture: Array<Quality_SegmentRefusalPicture>;
  /** fetch aggregated fields from the table: "quality.segmentRefusalPicture" */
  quality_segmentRefusalPicture_aggregate: Quality_SegmentRefusalPicture_Aggregate;
  /** fetch data from the table: "quality.segmentRefusalPicture" using primary key columns */
  quality_segmentRefusalPicture_by_pk?: Maybe<Quality_SegmentRefusalPicture>;
  /** fetch data from the table in a streaming manner: "quality.segmentRefusalPicture" */
  quality_segmentRefusalPicture_stream: Array<Quality_SegmentRefusalPicture>;
  /** fetch aggregated fields from the table: "quality.segmentRefusal" */
  quality_segmentRefusal_aggregate: Quality_SegmentRefusal_Aggregate;
  /** fetch data from the table: "quality.segmentRefusal" using primary key columns */
  quality_segmentRefusal_by_pk?: Maybe<Quality_SegmentRefusal>;
  /** fetch data from the table in a streaming manner: "quality.segmentRefusal" */
  quality_segmentRefusal_stream: Array<Quality_SegmentRefusal>;
  /** fetch aggregated fields from the table: "quality.segment" */
  quality_segment_aggregate: Quality_Segment_Aggregate;
  /** fetch data from the table: "quality.segment" using primary key columns */
  quality_segment_by_pk?: Maybe<Quality_Segment>;
  /** fetch data from the table in a streaming manner: "quality.segment" */
  quality_segment_stream: Array<Quality_Segment>;
  /** fetch data from the table: "quality.shapeEnum" */
  quality_shapeEnum: Array<Quality_ShapeEnum>;
  /** fetch aggregated fields from the table: "quality.shapeEnum" */
  quality_shapeEnum_aggregate: Quality_ShapeEnum_Aggregate;
  /** fetch data from the table: "quality.shapeEnum" using primary key columns */
  quality_shapeEnum_by_pk?: Maybe<Quality_ShapeEnum>;
  /** fetch data from the table in a streaming manner: "quality.shapeEnum" */
  quality_shapeEnum_stream: Array<Quality_ShapeEnum>;
  /** fetch data from the table: "quality.tunnelPosition" */
  quality_tunnelPosition: Array<Quality_TunnelPosition>;
  /** fetch aggregated fields from the table: "quality.tunnelPosition" */
  quality_tunnelPosition_aggregate: Quality_TunnelPosition_Aggregate;
  /** fetch data from the table: "quality.tunnelPosition" using primary key columns */
  quality_tunnelPosition_by_pk?: Maybe<Quality_TunnelPosition>;
  /** fetch data from the table in a streaming manner: "quality.tunnelPosition" */
  quality_tunnelPosition_stream: Array<Quality_TunnelPosition>;
  /** fetch data from the table: "quality.userQualityRole" */
  quality_userQualityRole: Array<Quality_UserQualityRole>;
  /** fetch aggregated fields from the table: "quality.userQualityRole" */
  quality_userQualityRole_aggregate: Quality_UserQualityRole_Aggregate;
  /** fetch data from the table: "quality.userQualityRole" using primary key columns */
  quality_userQualityRole_by_pk?: Maybe<Quality_UserQualityRole>;
  /** fetch data from the table in a streaming manner: "quality.userQualityRole" */
  quality_userQualityRole_stream: Array<Quality_UserQualityRole>;
  /** fetch data from the table: "quality.virtualRing" */
  quality_virtualRing: Array<Quality_VirtualRing>;
  /** fetch aggregated fields from the table: "quality.virtualRing" */
  quality_virtualRing_aggregate: Quality_VirtualRing_Aggregate;
  /** fetch data from the table: "quality.virtualRing" using primary key columns */
  quality_virtualRing_by_pk?: Maybe<Quality_VirtualRing>;
  /** fetch data from the table in a streaming manner: "quality.virtualRing" */
  quality_virtualRing_stream: Array<Quality_VirtualRing>;
  /** fetch data from the table: "recurringTask" */
  recurringTask: Array<RecurringTask>;
  /** fetch aggregated fields from the table: "recurringTask" */
  recurringTask_aggregate: RecurringTask_Aggregate;
  /** fetch data from the table: "recurringTask" using primary key columns */
  recurringTask_by_pk?: Maybe<RecurringTask>;
  /** fetch data from the table in a streaming manner: "recurringTask" */
  recurringTask_stream: Array<RecurringTask>;
  /** fetch data from the table: "scan.user" */
  scan_user: Array<Scan_User>;
  /** fetch aggregated fields from the table: "scan.user" */
  scan_user_aggregate: Scan_User_Aggregate;
  /** fetch data from the table: "scan.user" using primary key columns */
  scan_user_by_pk?: Maybe<Scan_User>;
  /** fetch data from the table in a streaming manner: "scan.user" */
  scan_user_stream: Array<Scan_User>;
  /** fetch data from the table: "shift" */
  shift: Array<Shift>;
  /** fetch data from the table: "shiftLeader" */
  shiftLeader: Array<ShiftLeader>;
  /** fetch aggregated fields from the table: "shiftLeader" */
  shiftLeader_aggregate: ShiftLeader_Aggregate;
  /** fetch data from the table: "shiftLeader" using primary key columns */
  shiftLeader_by_pk?: Maybe<ShiftLeader>;
  /** fetch data from the table in a streaming manner: "shiftLeader" */
  shiftLeader_stream: Array<ShiftLeader>;
  /** fetch data from the table: "shiftReport" */
  shiftReport: Array<ShiftReport>;
  /** fetch aggregated fields from the table: "shiftReport" */
  shiftReport_aggregate: ShiftReport_Aggregate;
  /** fetch data from the table: "shiftReport" using primary key columns */
  shiftReport_by_pk?: Maybe<ShiftReport>;
  /** fetch data from the table in a streaming manner: "shiftReport" */
  shiftReport_stream: Array<ShiftReport>;
  /** fetch aggregated fields from the table: "shift" */
  shift_aggregate: Shift_Aggregate;
  /** fetch data from the table: "shift" using primary key columns */
  shift_by_pk?: Maybe<Shift>;
  /** fetch data from the table in a streaming manner: "shift" */
  shift_stream: Array<Shift>;
  /** fetch data from the table: "task" */
  task: Array<Task>;
  /** fetch data from the table: "taskTotal" */
  taskTotal: Array<TaskTotal>;
  /** fetch data from the table: "taskTotalCritical" */
  taskTotalCritical: Array<TaskTotalCritical>;
  /** fetch aggregated fields from the table: "taskTotalCritical" */
  taskTotalCritical_aggregate: TaskTotalCritical_Aggregate;
  /** fetch data from the table in a streaming manner: "taskTotalCritical" */
  taskTotalCritical_stream: Array<TaskTotalCritical>;
  /** fetch data from the table: "taskTotalNonCritical" */
  taskTotalNonCritical: Array<TaskTotalNonCritical>;
  /** fetch aggregated fields from the table: "taskTotalNonCritical" */
  taskTotalNonCritical_aggregate: TaskTotalNonCritical_Aggregate;
  /** fetch data from the table in a streaming manner: "taskTotalNonCritical" */
  taskTotalNonCritical_stream: Array<TaskTotalNonCritical>;
  /** fetch data from the table: "taskTotalRing" */
  taskTotalRing: Array<TaskTotalRing>;
  /** fetch data from the table: "taskTotalRingCritical" */
  taskTotalRingCritical: Array<TaskTotalRingCritical>;
  /** fetch aggregated fields from the table: "taskTotalRingCritical" */
  taskTotalRingCritical_aggregate: TaskTotalRingCritical_Aggregate;
  /** fetch data from the table in a streaming manner: "taskTotalRingCritical" */
  taskTotalRingCritical_stream: Array<TaskTotalRingCritical>;
  /** fetch data from the table: "taskTotalRingNonCritical" */
  taskTotalRingNonCritical: Array<TaskTotalRingNonCritical>;
  /** fetch aggregated fields from the table: "taskTotalRingNonCritical" */
  taskTotalRingNonCritical_aggregate: TaskTotalRingNonCritical_Aggregate;
  /** fetch data from the table in a streaming manner: "taskTotalRingNonCritical" */
  taskTotalRingNonCritical_stream: Array<TaskTotalRingNonCritical>;
  /** fetch aggregated fields from the table: "taskTotalRing" */
  taskTotalRing_aggregate: TaskTotalRing_Aggregate;
  /** fetch data from the table in a streaming manner: "taskTotalRing" */
  taskTotalRing_stream: Array<TaskTotalRing>;
  /** fetch aggregated fields from the table: "taskTotal" */
  taskTotal_aggregate: TaskTotal_Aggregate;
  /** fetch data from the table in a streaming manner: "taskTotal" */
  taskTotal_stream: Array<TaskTotal>;
  /** fetch aggregated fields from the table: "task" */
  task_aggregate: Task_Aggregate;
  /** fetch data from the table: "task" using primary key columns */
  task_by_pk?: Maybe<Task>;
  /** fetch data from the table in a streaming manner: "task" */
  task_stream: Array<Task>;
  /** fetch data from the table: "team" */
  team: Array<Team>;
  /** fetch aggregated fields from the table: "team" */
  team_aggregate: Team_Aggregate;
  /** fetch data from the table: "team" using primary key columns */
  team_by_pk?: Maybe<Team>;
  /** fetch data from the table in a streaming manner: "team" */
  team_stream: Array<Team>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch data from the table: "userPermission" */
  userPermission: Array<UserPermission>;
  /** fetch aggregated fields from the table: "userPermission" */
  userPermission_aggregate: UserPermission_Aggregate;
  /** fetch data from the table: "userPermission" using primary key columns */
  userPermission_by_pk?: Maybe<UserPermission>;
  /** fetch data from the table in a streaming manner: "userPermission" */
  userPermission_stream: Array<UserPermission>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
  /** fetch data from the table: "validatedShiftReportWithRingCount" */
  validatedShiftReportWithRingCount: Array<ValidatedShiftReportWithRingCount>;
  /** fetch aggregated fields from the table: "validatedShiftReportWithRingCount" */
  validatedShiftReportWithRingCount_aggregate: ValidatedShiftReportWithRingCount_Aggregate;
  /** fetch data from the table in a streaming manner: "validatedShiftReportWithRingCount" */
  validatedShiftReportWithRingCount_stream: Array<ValidatedShiftReportWithRingCount>;
};


export type Subscription_RootActivityArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Subscription_RootActivityFullNameArgs = {
  distinct_on?: InputMaybe<Array<ActivityFullName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityFullName_Order_By>>;
  where?: InputMaybe<ActivityFullName_Bool_Exp>;
};


export type Subscription_RootActivityFullName_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ActivityFullName_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityFullName_Order_By>>;
  where?: InputMaybe<ActivityFullName_Bool_Exp>;
};


export type Subscription_RootActivityFullName_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ActivityFullName_Stream_Cursor_Input>>;
  where?: InputMaybe<ActivityFullName_Bool_Exp>;
};


export type Subscription_RootActivity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Subscription_RootActivity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootActivity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activity_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Subscription_RootAutofillApiArgs = {
  distinct_on?: InputMaybe<Array<AutofillApi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AutofillApi_Order_By>>;
  where?: InputMaybe<AutofillApi_Bool_Exp>;
};


export type Subscription_RootAutofillApi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AutofillApi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AutofillApi_Order_By>>;
  where?: InputMaybe<AutofillApi_Bool_Exp>;
};


export type Subscription_RootAutofillApi_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAutofillApi_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AutofillApi_Stream_Cursor_Input>>;
  where?: InputMaybe<AutofillApi_Bool_Exp>;
};


export type Subscription_RootConstructionSiteArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSite_Order_By>>;
  where?: InputMaybe<ConstructionSite_Bool_Exp>;
};


export type Subscription_RootConstructionSiteEnabledModuleArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSiteEnabledModule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSiteEnabledModule_Order_By>>;
  where?: InputMaybe<ConstructionSiteEnabledModule_Bool_Exp>;
};


export type Subscription_RootConstructionSiteEnabledModule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSiteEnabledModule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSiteEnabledModule_Order_By>>;
  where?: InputMaybe<ConstructionSiteEnabledModule_Bool_Exp>;
};


export type Subscription_RootConstructionSiteEnabledModule_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionSiteEnabledModule_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionSiteEnabledModule_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionSiteEnabledModule_Bool_Exp>;
};


export type Subscription_RootConstructionSite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ConstructionSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ConstructionSite_Order_By>>;
  where?: InputMaybe<ConstructionSite_Bool_Exp>;
};


export type Subscription_RootConstructionSite_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConstructionSite_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConstructionSite_Stream_Cursor_Input>>;
  where?: InputMaybe<ConstructionSite_Bool_Exp>;
};


export type Subscription_RootDailyShiftTemplateArgs = {
  distinct_on?: InputMaybe<Array<DailyShiftTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DailyShiftTemplate_Order_By>>;
  where?: InputMaybe<DailyShiftTemplate_Bool_Exp>;
};


export type Subscription_RootDailyShiftTemplate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<DailyShiftTemplate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DailyShiftTemplate_Order_By>>;
  where?: InputMaybe<DailyShiftTemplate_Bool_Exp>;
};


export type Subscription_RootDailyShiftTemplate_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDailyShiftTemplate_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DailyShiftTemplate_Stream_Cursor_Input>>;
  where?: InputMaybe<DailyShiftTemplate_Bool_Exp>;
};


export type Subscription_RootFile_BucketFileArgs = {
  distinct_on?: InputMaybe<Array<File_BucketFile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_BucketFile_Order_By>>;
  where?: InputMaybe<File_BucketFile_Bool_Exp>;
};


export type Subscription_RootFile_BucketFile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_BucketFile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_BucketFile_Order_By>>;
  where?: InputMaybe<File_BucketFile_Bool_Exp>;
};


export type Subscription_RootFile_BucketFile_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFile_BucketFile_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<File_BucketFile_Stream_Cursor_Input>>;
  where?: InputMaybe<File_BucketFile_Bool_Exp>;
};


export type Subscription_RootFile_BucketTypeEnumArgs = {
  distinct_on?: InputMaybe<Array<File_BucketTypeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_BucketTypeEnum_Order_By>>;
  where?: InputMaybe<File_BucketTypeEnum_Bool_Exp>;
};


export type Subscription_RootFile_BucketTypeEnum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_BucketTypeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_BucketTypeEnum_Order_By>>;
  where?: InputMaybe<File_BucketTypeEnum_Bool_Exp>;
};


export type Subscription_RootFile_BucketTypeEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootFile_BucketTypeEnum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<File_BucketTypeEnum_Stream_Cursor_Input>>;
  where?: InputMaybe<File_BucketTypeEnum_Bool_Exp>;
};


export type Subscription_RootGraphSetArgs = {
  distinct_on?: InputMaybe<Array<GraphSet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GraphSet_Order_By>>;
  where?: InputMaybe<GraphSet_Bool_Exp>;
};


export type Subscription_RootGraphSetTypeEnumArgs = {
  distinct_on?: InputMaybe<Array<GraphSetTypeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GraphSetTypeEnum_Order_By>>;
  where?: InputMaybe<GraphSetTypeEnum_Bool_Exp>;
};


export type Subscription_RootGraphSetTypeEnum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GraphSetTypeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GraphSetTypeEnum_Order_By>>;
  where?: InputMaybe<GraphSetTypeEnum_Bool_Exp>;
};


export type Subscription_RootGraphSetTypeEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootGraphSetTypeEnum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GraphSetTypeEnum_Stream_Cursor_Input>>;
  where?: InputMaybe<GraphSetTypeEnum_Bool_Exp>;
};


export type Subscription_RootGraphSet_AggregateArgs = {
  distinct_on?: InputMaybe<Array<GraphSet_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GraphSet_Order_By>>;
  where?: InputMaybe<GraphSet_Bool_Exp>;
};


export type Subscription_RootGraphSet_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootGraphSet_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GraphSet_Stream_Cursor_Input>>;
  where?: InputMaybe<GraphSet_Bool_Exp>;
};


export type Subscription_RootIndicatorArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Order_By>>;
  where?: InputMaybe<Indicator_Bool_Exp>;
};


export type Subscription_RootIndicator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Indicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Indicator_Order_By>>;
  where?: InputMaybe<Indicator_Bool_Exp>;
};


export type Subscription_RootIndicator_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIndicator_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Indicator_Stream_Cursor_Input>>;
  where?: InputMaybe<Indicator_Bool_Exp>;
};


export type Subscription_RootMapConfigurationArgs = {
  distinct_on?: InputMaybe<Array<MapConfiguration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapConfiguration_Order_By>>;
  where?: InputMaybe<MapConfiguration_Bool_Exp>;
};


export type Subscription_RootMapConfiguration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MapConfiguration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapConfiguration_Order_By>>;
  where?: InputMaybe<MapConfiguration_Bool_Exp>;
};


export type Subscription_RootMapConfiguration_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMapConfiguration_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MapConfiguration_Stream_Cursor_Input>>;
  where?: InputMaybe<MapConfiguration_Bool_Exp>;
};


export type Subscription_RootMapPoiArgs = {
  distinct_on?: InputMaybe<Array<MapPoi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapPoi_Order_By>>;
  where?: InputMaybe<MapPoi_Bool_Exp>;
};


export type Subscription_RootMapPoi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MapPoi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapPoi_Order_By>>;
  where?: InputMaybe<MapPoi_Bool_Exp>;
};


export type Subscription_RootMapPoi_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMapPoi_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MapPoi_Stream_Cursor_Input>>;
  where?: InputMaybe<MapPoi_Bool_Exp>;
};


export type Subscription_RootMapTraceArgs = {
  distinct_on?: InputMaybe<Array<MapTrace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapTrace_Order_By>>;
  where?: InputMaybe<MapTrace_Bool_Exp>;
};


export type Subscription_RootMapTrace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MapTrace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MapTrace_Order_By>>;
  where?: InputMaybe<MapTrace_Bool_Exp>;
};


export type Subscription_RootMapTrace_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootMapTrace_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MapTrace_Stream_Cursor_Input>>;
  where?: InputMaybe<MapTrace_Bool_Exp>;
};


export type Subscription_RootModuleArgs = {
  distinct_on?: InputMaybe<Array<Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Module_Order_By>>;
  where?: InputMaybe<Module_Bool_Exp>;
};


export type Subscription_RootModule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Module_Order_By>>;
  where?: InputMaybe<Module_Bool_Exp>;
};


export type Subscription_RootModule_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootModule_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Module_Stream_Cursor_Input>>;
  where?: InputMaybe<Module_Bool_Exp>;
};


export type Subscription_RootOperatorArgs = {
  distinct_on?: InputMaybe<Array<Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Operator_Order_By>>;
  where?: InputMaybe<Operator_Bool_Exp>;
};


export type Subscription_RootOperator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Operator_Order_By>>;
  where?: InputMaybe<Operator_Bool_Exp>;
};


export type Subscription_RootOperator_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOperator_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Operator_Stream_Cursor_Input>>;
  where?: InputMaybe<Operator_Bool_Exp>;
};


export type Subscription_RootParameter_ConstructionSiteParameterNameConfigArgs = {
  distinct_on?: InputMaybe<Array<Parameter_ConstructionSiteParameterNameConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_ConstructionSiteParameterNameConfig_Order_By>>;
  where?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Bool_Exp>;
};


export type Subscription_RootParameter_ConstructionSiteParameterNameConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_ConstructionSiteParameterNameConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_ConstructionSiteParameterNameConfig_Order_By>>;
  where?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Bool_Exp>;
};


export type Subscription_RootParameter_ConstructionSiteParameterNameConfig_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootParameter_ConstructionSiteParameterNameConfig_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Stream_Cursor_Input>>;
  where?: InputMaybe<Parameter_ConstructionSiteParameterNameConfig_Bool_Exp>;
};


export type Subscription_RootParameter_FamilyDefArgs = {
  distinct_on?: InputMaybe<Array<Parameter_FamilyDef_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_FamilyDef_Order_By>>;
  where?: InputMaybe<Parameter_FamilyDef_Bool_Exp>;
};


export type Subscription_RootParameter_FamilyDef_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_FamilyDef_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_FamilyDef_Order_By>>;
  where?: InputMaybe<Parameter_FamilyDef_Bool_Exp>;
};


export type Subscription_RootParameter_FamilyDef_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootParameter_FamilyDef_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parameter_FamilyDef_Stream_Cursor_Input>>;
  where?: InputMaybe<Parameter_FamilyDef_Bool_Exp>;
};


export type Subscription_RootParameter_MetricArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Metric_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Metric_Order_By>>;
  where?: InputMaybe<Parameter_Metric_Bool_Exp>;
};


export type Subscription_RootParameter_Metric_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Metric_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Metric_Order_By>>;
  where?: InputMaybe<Parameter_Metric_Bool_Exp>;
};


export type Subscription_RootParameter_Metric_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootParameter_Metric_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parameter_Metric_Stream_Cursor_Input>>;
  where?: InputMaybe<Parameter_Metric_Bool_Exp>;
};


export type Subscription_RootParameter_ParameterDefArgs = {
  distinct_on?: InputMaybe<Array<Parameter_ParameterDef_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_ParameterDef_Order_By>>;
  where?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
};


export type Subscription_RootParameter_ParameterDef_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_ParameterDef_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_ParameterDef_Order_By>>;
  where?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
};


export type Subscription_RootParameter_ParameterDef_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootParameter_ParameterDef_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parameter_ParameterDef_Stream_Cursor_Input>>;
  where?: InputMaybe<Parameter_ParameterDef_Bool_Exp>;
};


export type Subscription_RootParameter_RingArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Ring_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Ring_Order_By>>;
  where?: InputMaybe<Parameter_Ring_Bool_Exp>;
};


export type Subscription_RootParameter_RingProjectionArgs = {
  distinct_on?: InputMaybe<Array<Parameter_RingProjection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_RingProjection_Order_By>>;
  where?: InputMaybe<Parameter_RingProjection_Bool_Exp>;
};


export type Subscription_RootParameter_RingProjection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_RingProjection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_RingProjection_Order_By>>;
  where?: InputMaybe<Parameter_RingProjection_Bool_Exp>;
};


export type Subscription_RootParameter_RingProjection_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootParameter_RingProjection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parameter_RingProjection_Stream_Cursor_Input>>;
  where?: InputMaybe<Parameter_RingProjection_Bool_Exp>;
};


export type Subscription_RootParameter_RingWithProductionDayArgs = {
  distinct_on?: InputMaybe<Array<Parameter_RingWithProductionDay_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_RingWithProductionDay_Order_By>>;
  where?: InputMaybe<Parameter_RingWithProductionDay_Bool_Exp>;
};


export type Subscription_RootParameter_RingWithProductionDay_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_RingWithProductionDay_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_RingWithProductionDay_Order_By>>;
  where?: InputMaybe<Parameter_RingWithProductionDay_Bool_Exp>;
};


export type Subscription_RootParameter_RingWithProductionDay_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parameter_RingWithProductionDay_Stream_Cursor_Input>>;
  where?: InputMaybe<Parameter_RingWithProductionDay_Bool_Exp>;
};


export type Subscription_RootParameter_RingWithShiftsArgs = {
  distinct_on?: InputMaybe<Array<Parameter_RingWithShifts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_RingWithShifts_Order_By>>;
  where?: InputMaybe<Parameter_RingWithShifts_Bool_Exp>;
};


export type Subscription_RootParameter_RingWithShifts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_RingWithShifts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_RingWithShifts_Order_By>>;
  where?: InputMaybe<Parameter_RingWithShifts_Bool_Exp>;
};


export type Subscription_RootParameter_RingWithShifts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parameter_RingWithShifts_Stream_Cursor_Input>>;
  where?: InputMaybe<Parameter_RingWithShifts_Bool_Exp>;
};


export type Subscription_RootParameter_Ring_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Ring_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Ring_Order_By>>;
  where?: InputMaybe<Parameter_Ring_Bool_Exp>;
};


export type Subscription_RootParameter_Ring_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootParameter_Ring_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parameter_Ring_Stream_Cursor_Input>>;
  where?: InputMaybe<Parameter_Ring_Bool_Exp>;
};


export type Subscription_RootParameter_ValueArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Value_Order_By>>;
  where?: InputMaybe<Parameter_Value_Bool_Exp>;
};


export type Subscription_RootParameter_Value_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parameter_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Parameter_Value_Order_By>>;
  where?: InputMaybe<Parameter_Value_Bool_Exp>;
};


export type Subscription_RootParameter_Value_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootParameter_Value_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Parameter_Value_Stream_Cursor_Input>>;
  where?: InputMaybe<Parameter_Value_Bool_Exp>;
};


export type Subscription_RootPermissionTypeArgs = {
  distinct_on?: InputMaybe<Array<PermissionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PermissionType_Order_By>>;
  where?: InputMaybe<PermissionType_Bool_Exp>;
};


export type Subscription_RootPermissionType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<PermissionType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PermissionType_Order_By>>;
  where?: InputMaybe<PermissionType_Bool_Exp>;
};


export type Subscription_RootPermissionType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPermissionType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PermissionType_Stream_Cursor_Input>>;
  where?: InputMaybe<PermissionType_Bool_Exp>;
};


export type Subscription_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootQuality_BoardConfigArgs = {
  distinct_on?: InputMaybe<Array<Quality_BoardConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_BoardConfig_Order_By>>;
  where?: InputMaybe<Quality_BoardConfig_Bool_Exp>;
};


export type Subscription_RootQuality_BoardConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_BoardConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_BoardConfig_Order_By>>;
  where?: InputMaybe<Quality_BoardConfig_Bool_Exp>;
};


export type Subscription_RootQuality_BoardConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_BoardConfig_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_BoardConfig_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_BoardConfig_Bool_Exp>;
};


export type Subscription_RootQuality_BoardSegmentArgs = {
  distinct_on?: InputMaybe<Array<Quality_BoardSegment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_BoardSegment_Order_By>>;
  where?: InputMaybe<Quality_BoardSegment_Bool_Exp>;
};


export type Subscription_RootQuality_BoardSegment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_BoardSegment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_BoardSegment_Order_By>>;
  where?: InputMaybe<Quality_BoardSegment_Bool_Exp>;
};


export type Subscription_RootQuality_BoardSegment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_BoardSegment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_BoardSegment_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_BoardSegment_Bool_Exp>;
};


export type Subscription_RootQuality_DefectRepairArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectRepair_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectRepair_Order_By>>;
  where?: InputMaybe<Quality_DefectRepair_Bool_Exp>;
};


export type Subscription_RootQuality_DefectRepairPictureArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectRepairPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectRepairPicture_Order_By>>;
  where?: InputMaybe<Quality_DefectRepairPicture_Bool_Exp>;
};


export type Subscription_RootQuality_DefectRepairPicture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectRepairPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectRepairPicture_Order_By>>;
  where?: InputMaybe<Quality_DefectRepairPicture_Bool_Exp>;
};


export type Subscription_RootQuality_DefectRepairPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_DefectRepairPicture_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_DefectRepairPicture_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_DefectRepairPicture_Bool_Exp>;
};


export type Subscription_RootQuality_DefectRepairTypeArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectRepairType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectRepairType_Order_By>>;
  where?: InputMaybe<Quality_DefectRepairType_Bool_Exp>;
};


export type Subscription_RootQuality_DefectRepairType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectRepairType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectRepairType_Order_By>>;
  where?: InputMaybe<Quality_DefectRepairType_Bool_Exp>;
};


export type Subscription_RootQuality_DefectRepairType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_DefectRepairType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_DefectRepairType_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_DefectRepairType_Bool_Exp>;
};


export type Subscription_RootQuality_DefectRepair_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectRepair_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectRepair_Order_By>>;
  where?: InputMaybe<Quality_DefectRepair_Bool_Exp>;
};


export type Subscription_RootQuality_DefectRepair_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_DefectRepair_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_DefectRepair_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_DefectRepair_Bool_Exp>;
};


export type Subscription_RootQuality_DefectReportArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReport_Order_By>>;
  where?: InputMaybe<Quality_DefectReport_Bool_Exp>;
};


export type Subscription_RootQuality_DefectReportPictureArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReportPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReportPicture_Order_By>>;
  where?: InputMaybe<Quality_DefectReportPicture_Bool_Exp>;
};


export type Subscription_RootQuality_DefectReportPicture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReportPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReportPicture_Order_By>>;
  where?: InputMaybe<Quality_DefectReportPicture_Bool_Exp>;
};


export type Subscription_RootQuality_DefectReportPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_DefectReportPicture_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_DefectReportPicture_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_DefectReportPicture_Bool_Exp>;
};


export type Subscription_RootQuality_DefectReportTypeArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReportType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReportType_Order_By>>;
  where?: InputMaybe<Quality_DefectReportType_Bool_Exp>;
};


export type Subscription_RootQuality_DefectReportType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReportType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReportType_Order_By>>;
  where?: InputMaybe<Quality_DefectReportType_Bool_Exp>;
};


export type Subscription_RootQuality_DefectReportType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_DefectReportType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_DefectReportType_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_DefectReportType_Bool_Exp>;
};


export type Subscription_RootQuality_DefectReportViewArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReportView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReportView_Order_By>>;
  where?: InputMaybe<Quality_DefectReportView_Bool_Exp>;
};


export type Subscription_RootQuality_DefectReportView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReportView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReportView_Order_By>>;
  where?: InputMaybe<Quality_DefectReportView_Bool_Exp>;
};


export type Subscription_RootQuality_DefectReportView_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_DefectReportView_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_DefectReportView_Bool_Exp>;
};


export type Subscription_RootQuality_DefectReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_DefectReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_DefectReport_Order_By>>;
  where?: InputMaybe<Quality_DefectReport_Bool_Exp>;
};


export type Subscription_RootQuality_DefectReport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_DefectReport_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_DefectReport_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_DefectReport_Bool_Exp>;
};


export type Subscription_RootQuality_ImportConfigArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportConfig_Order_By>>;
  where?: InputMaybe<Quality_ImportConfig_Bool_Exp>;
};


export type Subscription_RootQuality_ImportConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportConfig_Order_By>>;
  where?: InputMaybe<Quality_ImportConfig_Bool_Exp>;
};


export type Subscription_RootQuality_ImportConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_ImportConfig_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_ImportConfig_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_ImportConfig_Bool_Exp>;
};


export type Subscription_RootQuality_ImportExtraColumnArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportExtraColumn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportExtraColumn_Order_By>>;
  where?: InputMaybe<Quality_ImportExtraColumn_Bool_Exp>;
};


export type Subscription_RootQuality_ImportExtraColumn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportExtraColumn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportExtraColumn_Order_By>>;
  where?: InputMaybe<Quality_ImportExtraColumn_Bool_Exp>;
};


export type Subscription_RootQuality_ImportExtraColumn_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_ImportExtraColumn_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_ImportExtraColumn_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_ImportExtraColumn_Bool_Exp>;
};


export type Subscription_RootQuality_ImportTaskArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportTask_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportTask_Order_By>>;
  where?: InputMaybe<Quality_ImportTask_Bool_Exp>;
};


export type Subscription_RootQuality_ImportTask_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ImportTask_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ImportTask_Order_By>>;
  where?: InputMaybe<Quality_ImportTask_Bool_Exp>;
};


export type Subscription_RootQuality_ImportTask_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_ImportTask_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_ImportTask_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_ImportTask_Bool_Exp>;
};


export type Subscription_RootQuality_IndicatorArgs = {
  distinct_on?: InputMaybe<Array<Quality_Indicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_Indicator_Order_By>>;
  where?: InputMaybe<Quality_Indicator_Bool_Exp>;
};


export type Subscription_RootQuality_Indicator_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Indicator_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_Indicator_Order_By>>;
  where?: InputMaybe<Quality_Indicator_Bool_Exp>;
};


export type Subscription_RootQuality_Indicator_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_Indicator_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_Indicator_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_Indicator_Bool_Exp>;
};


export type Subscription_RootQuality_QuarantineDefectArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefect_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefect_Bool_Exp>;
};


export type Subscription_RootQuality_QuarantineDefectOrientationEnumArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefectOrientationEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefectOrientationEnum_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Bool_Exp>;
};


export type Subscription_RootQuality_QuarantineDefectOrientationEnum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefectOrientationEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefectOrientationEnum_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Bool_Exp>;
};


export type Subscription_RootQuality_QuarantineDefectOrientationEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootQuality_QuarantineDefectOrientationEnum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_QuarantineDefectOrientationEnum_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_QuarantineDefectOrientationEnum_Bool_Exp>;
};


export type Subscription_RootQuality_QuarantineDefectPictureArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefectPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefectPicture_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefectPicture_Bool_Exp>;
};


export type Subscription_RootQuality_QuarantineDefectPicture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefectPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefectPicture_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefectPicture_Bool_Exp>;
};


export type Subscription_RootQuality_QuarantineDefectPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_QuarantineDefectPicture_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_QuarantineDefectPicture_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_QuarantineDefectPicture_Bool_Exp>;
};


export type Subscription_RootQuality_QuarantineDefectTypeArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefectType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefectType_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefectType_Bool_Exp>;
};


export type Subscription_RootQuality_QuarantineDefectType_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefectType_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefectType_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefectType_Bool_Exp>;
};


export type Subscription_RootQuality_QuarantineDefectType_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_QuarantineDefectType_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_QuarantineDefectType_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_QuarantineDefectType_Bool_Exp>;
};


export type Subscription_RootQuality_QuarantineDefect_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_QuarantineDefect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_QuarantineDefect_Order_By>>;
  where?: InputMaybe<Quality_QuarantineDefect_Bool_Exp>;
};


export type Subscription_RootQuality_QuarantineDefect_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_QuarantineDefect_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_QuarantineDefect_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_QuarantineDefect_Bool_Exp>;
};


export type Subscription_RootQuality_RepairReportArgs = {
  distinct_on?: InputMaybe<Array<Quality_RepairReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RepairReport_Order_By>>;
  where?: InputMaybe<Quality_RepairReport_Bool_Exp>;
};


export type Subscription_RootQuality_RepairReportPictureArgs = {
  distinct_on?: InputMaybe<Array<Quality_RepairReportPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RepairReportPicture_Order_By>>;
  where?: InputMaybe<Quality_RepairReportPicture_Bool_Exp>;
};


export type Subscription_RootQuality_RepairReportPicture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_RepairReportPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RepairReportPicture_Order_By>>;
  where?: InputMaybe<Quality_RepairReportPicture_Bool_Exp>;
};


export type Subscription_RootQuality_RepairReportPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_RepairReportPicture_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_RepairReportPicture_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_RepairReportPicture_Bool_Exp>;
};


export type Subscription_RootQuality_RepairReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_RepairReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RepairReport_Order_By>>;
  where?: InputMaybe<Quality_RepairReport_Bool_Exp>;
};


export type Subscription_RootQuality_RepairReport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_RepairReport_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_RepairReport_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_RepairReport_Bool_Exp>;
};


export type Subscription_RootQuality_RingValidationArgs = {
  distinct_on?: InputMaybe<Array<Quality_RingValidation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RingValidation_Order_By>>;
  where?: InputMaybe<Quality_RingValidation_Bool_Exp>;
};


export type Subscription_RootQuality_RingValidationViewArgs = {
  distinct_on?: InputMaybe<Array<Quality_RingValidationView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RingValidationView_Order_By>>;
  where?: InputMaybe<Quality_RingValidationView_Bool_Exp>;
};


export type Subscription_RootQuality_RingValidationView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_RingValidationView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RingValidationView_Order_By>>;
  where?: InputMaybe<Quality_RingValidationView_Bool_Exp>;
};


export type Subscription_RootQuality_RingValidationView_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_RingValidationView_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_RingValidationView_Bool_Exp>;
};


export type Subscription_RootQuality_RingValidation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_RingValidation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_RingValidation_Order_By>>;
  where?: InputMaybe<Quality_RingValidation_Bool_Exp>;
};


export type Subscription_RootQuality_RingValidation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_RingValidation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_RingValidation_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_RingValidation_Bool_Exp>;
};


export type Subscription_RootQuality_ScanCodeConfigArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanCodeConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanCodeConfig_Order_By>>;
  where?: InputMaybe<Quality_ScanCodeConfig_Bool_Exp>;
};


export type Subscription_RootQuality_ScanCodeConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanCodeConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanCodeConfig_Order_By>>;
  where?: InputMaybe<Quality_ScanCodeConfig_Bool_Exp>;
};


export type Subscription_RootQuality_ScanCodeConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_ScanCodeConfig_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_ScanCodeConfig_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_ScanCodeConfig_Bool_Exp>;
};


export type Subscription_RootQuality_ScanConfigArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanConfig_Order_By>>;
  where?: InputMaybe<Quality_ScanConfig_Bool_Exp>;
};


export type Subscription_RootQuality_ScanConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanConfig_Order_By>>;
  where?: InputMaybe<Quality_ScanConfig_Bool_Exp>;
};


export type Subscription_RootQuality_ScanConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_ScanConfig_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_ScanConfig_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_ScanConfig_Bool_Exp>;
};


export type Subscription_RootQuality_ScanSiteArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanSite_Order_By>>;
  where?: InputMaybe<Quality_ScanSite_Bool_Exp>;
};


export type Subscription_RootQuality_ScanSiteConstructionSiteArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Order_By>>;
  where?: InputMaybe<Quality_ScanSiteConstructionSite_Bool_Exp>;
};


export type Subscription_RootQuality_ScanSiteConstructionSite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanSiteConstructionSite_Order_By>>;
  where?: InputMaybe<Quality_ScanSiteConstructionSite_Bool_Exp>;
};


export type Subscription_RootQuality_ScanSiteConstructionSite_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_ScanSiteConstructionSite_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_ScanSiteConstructionSite_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_ScanSiteConstructionSite_Bool_Exp>;
};


export type Subscription_RootQuality_ScanSite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanSite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanSite_Order_By>>;
  where?: InputMaybe<Quality_ScanSite_Bool_Exp>;
};


export type Subscription_RootQuality_ScanSite_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_ScanSite_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_ScanSite_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_ScanSite_Bool_Exp>;
};


export type Subscription_RootQuality_ScanTypeEnumArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanTypeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanTypeEnum_Order_By>>;
  where?: InputMaybe<Quality_ScanTypeEnum_Bool_Exp>;
};


export type Subscription_RootQuality_ScanTypeEnum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ScanTypeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ScanTypeEnum_Order_By>>;
  where?: InputMaybe<Quality_ScanTypeEnum_Bool_Exp>;
};


export type Subscription_RootQuality_ScanTypeEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootQuality_ScanTypeEnum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_ScanTypeEnum_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_ScanTypeEnum_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentArgs = {
  distinct_on?: InputMaybe<Array<Quality_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_Segment_Order_By>>;
  where?: InputMaybe<Quality_Segment_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentDrawConfigArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentDrawConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentDrawConfig_Order_By>>;
  where?: InputMaybe<Quality_SegmentDrawConfig_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentDrawConfig_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentDrawConfig_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentDrawConfig_Order_By>>;
  where?: InputMaybe<Quality_SegmentDrawConfig_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentDrawConfig_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_SegmentDrawConfig_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_SegmentDrawConfig_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_SegmentDrawConfig_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentExtraParameterArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentExtraParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentExtraParameter_Order_By>>;
  where?: InputMaybe<Quality_SegmentExtraParameter_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentExtraParameter_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentExtraParameter_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentExtraParameter_Order_By>>;
  where?: InputMaybe<Quality_SegmentExtraParameter_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentExtraParameter_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_SegmentExtraParameter_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_SegmentExtraParameter_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_SegmentExtraParameter_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentHistoryArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistory_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistory_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentHistoryStatusEnumArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistoryStatusEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistoryStatusEnum_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistoryStatusEnum_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentHistoryStatusEnum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistoryStatusEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistoryStatusEnum_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistoryStatusEnum_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentHistoryStatusEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootQuality_SegmentHistoryStatusEnum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_SegmentHistoryStatusEnum_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_SegmentHistoryStatusEnum_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentHistoryViewArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistoryView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistoryView_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistoryView_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentHistoryView_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistoryView_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistoryView_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistoryView_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentHistoryView_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_SegmentHistoryView_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_SegmentHistoryView_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentHistory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentHistory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentHistory_Order_By>>;
  where?: InputMaybe<Quality_SegmentHistory_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentHistory_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_SegmentHistory_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_SegmentHistory_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_SegmentHistory_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentRefusalArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentRefusal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentRefusal_Order_By>>;
  where?: InputMaybe<Quality_SegmentRefusal_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentRefusalPictureArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentRefusalPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentRefusalPicture_Order_By>>;
  where?: InputMaybe<Quality_SegmentRefusalPicture_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentRefusalPicture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentRefusalPicture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentRefusalPicture_Order_By>>;
  where?: InputMaybe<Quality_SegmentRefusalPicture_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentRefusalPicture_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_SegmentRefusalPicture_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_SegmentRefusalPicture_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_SegmentRefusalPicture_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentRefusal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_SegmentRefusal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_SegmentRefusal_Order_By>>;
  where?: InputMaybe<Quality_SegmentRefusal_Bool_Exp>;
};


export type Subscription_RootQuality_SegmentRefusal_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_SegmentRefusal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_SegmentRefusal_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_SegmentRefusal_Bool_Exp>;
};


export type Subscription_RootQuality_Segment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_Segment_Order_By>>;
  where?: InputMaybe<Quality_Segment_Bool_Exp>;
};


export type Subscription_RootQuality_Segment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_Segment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_Segment_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_Segment_Bool_Exp>;
};


export type Subscription_RootQuality_ShapeEnumArgs = {
  distinct_on?: InputMaybe<Array<Quality_ShapeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ShapeEnum_Order_By>>;
  where?: InputMaybe<Quality_ShapeEnum_Bool_Exp>;
};


export type Subscription_RootQuality_ShapeEnum_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_ShapeEnum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_ShapeEnum_Order_By>>;
  where?: InputMaybe<Quality_ShapeEnum_Bool_Exp>;
};


export type Subscription_RootQuality_ShapeEnum_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootQuality_ShapeEnum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_ShapeEnum_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_ShapeEnum_Bool_Exp>;
};


export type Subscription_RootQuality_TunnelPositionArgs = {
  distinct_on?: InputMaybe<Array<Quality_TunnelPosition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_TunnelPosition_Order_By>>;
  where?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
};


export type Subscription_RootQuality_TunnelPosition_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_TunnelPosition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_TunnelPosition_Order_By>>;
  where?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
};


export type Subscription_RootQuality_TunnelPosition_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_TunnelPosition_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_TunnelPosition_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_TunnelPosition_Bool_Exp>;
};


export type Subscription_RootQuality_UserQualityRoleArgs = {
  distinct_on?: InputMaybe<Array<Quality_UserQualityRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_UserQualityRole_Order_By>>;
  where?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
};


export type Subscription_RootQuality_UserQualityRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_UserQualityRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_UserQualityRole_Order_By>>;
  where?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
};


export type Subscription_RootQuality_UserQualityRole_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_UserQualityRole_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_UserQualityRole_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
};


export type Subscription_RootQuality_VirtualRingArgs = {
  distinct_on?: InputMaybe<Array<Quality_VirtualRing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_VirtualRing_Order_By>>;
  where?: InputMaybe<Quality_VirtualRing_Bool_Exp>;
};


export type Subscription_RootQuality_VirtualRing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_VirtualRing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_VirtualRing_Order_By>>;
  where?: InputMaybe<Quality_VirtualRing_Bool_Exp>;
};


export type Subscription_RootQuality_VirtualRing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuality_VirtualRing_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quality_VirtualRing_Stream_Cursor_Input>>;
  where?: InputMaybe<Quality_VirtualRing_Bool_Exp>;
};


export type Subscription_RootRecurringTaskArgs = {
  distinct_on?: InputMaybe<Array<RecurringTask_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RecurringTask_Order_By>>;
  where?: InputMaybe<RecurringTask_Bool_Exp>;
};


export type Subscription_RootRecurringTask_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RecurringTask_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RecurringTask_Order_By>>;
  where?: InputMaybe<RecurringTask_Bool_Exp>;
};


export type Subscription_RootRecurringTask_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRecurringTask_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RecurringTask_Stream_Cursor_Input>>;
  where?: InputMaybe<RecurringTask_Bool_Exp>;
};


export type Subscription_RootScan_UserArgs = {
  distinct_on?: InputMaybe<Array<Scan_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scan_User_Order_By>>;
  where?: InputMaybe<Scan_User_Bool_Exp>;
};


export type Subscription_RootScan_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scan_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scan_User_Order_By>>;
  where?: InputMaybe<Scan_User_Bool_Exp>;
};


export type Subscription_RootScan_User_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootScan_User_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scan_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Scan_User_Bool_Exp>;
};


export type Subscription_RootShiftArgs = {
  distinct_on?: InputMaybe<Array<Shift_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Order_By>>;
  where?: InputMaybe<Shift_Bool_Exp>;
};


export type Subscription_RootShiftLeaderArgs = {
  distinct_on?: InputMaybe<Array<ShiftLeader_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftLeader_Order_By>>;
  where?: InputMaybe<ShiftLeader_Bool_Exp>;
};


export type Subscription_RootShiftLeader_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ShiftLeader_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftLeader_Order_By>>;
  where?: InputMaybe<ShiftLeader_Bool_Exp>;
};


export type Subscription_RootShiftLeader_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootShiftLeader_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ShiftLeader_Stream_Cursor_Input>>;
  where?: InputMaybe<ShiftLeader_Bool_Exp>;
};


export type Subscription_RootShiftReportArgs = {
  distinct_on?: InputMaybe<Array<ShiftReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftReport_Order_By>>;
  where?: InputMaybe<ShiftReport_Bool_Exp>;
};


export type Subscription_RootShiftReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ShiftReport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ShiftReport_Order_By>>;
  where?: InputMaybe<ShiftReport_Bool_Exp>;
};


export type Subscription_RootShiftReport_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootShiftReport_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ShiftReport_Stream_Cursor_Input>>;
  where?: InputMaybe<ShiftReport_Bool_Exp>;
};


export type Subscription_RootShift_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shift_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shift_Order_By>>;
  where?: InputMaybe<Shift_Bool_Exp>;
};


export type Subscription_RootShift_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootShift_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Shift_Stream_Cursor_Input>>;
  where?: InputMaybe<Shift_Bool_Exp>;
};


export type Subscription_RootTaskArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Subscription_RootTaskTotalArgs = {
  distinct_on?: InputMaybe<Array<TaskTotal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotal_Order_By>>;
  where?: InputMaybe<TaskTotal_Bool_Exp>;
};


export type Subscription_RootTaskTotalCriticalArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalCritical_Order_By>>;
  where?: InputMaybe<TaskTotalCritical_Bool_Exp>;
};


export type Subscription_RootTaskTotalCritical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalCritical_Order_By>>;
  where?: InputMaybe<TaskTotalCritical_Bool_Exp>;
};


export type Subscription_RootTaskTotalCritical_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaskTotalCritical_Stream_Cursor_Input>>;
  where?: InputMaybe<TaskTotalCritical_Bool_Exp>;
};


export type Subscription_RootTaskTotalNonCriticalArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalNonCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalNonCritical_Order_By>>;
  where?: InputMaybe<TaskTotalNonCritical_Bool_Exp>;
};


export type Subscription_RootTaskTotalNonCritical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalNonCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalNonCritical_Order_By>>;
  where?: InputMaybe<TaskTotalNonCritical_Bool_Exp>;
};


export type Subscription_RootTaskTotalNonCritical_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaskTotalNonCritical_Stream_Cursor_Input>>;
  where?: InputMaybe<TaskTotalNonCritical_Bool_Exp>;
};


export type Subscription_RootTaskTotalRingArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalRing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalRing_Order_By>>;
  where?: InputMaybe<TaskTotalRing_Bool_Exp>;
};


export type Subscription_RootTaskTotalRingCriticalArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalRingCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalRingCritical_Order_By>>;
  where?: InputMaybe<TaskTotalRingCritical_Bool_Exp>;
};


export type Subscription_RootTaskTotalRingCritical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalRingCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalRingCritical_Order_By>>;
  where?: InputMaybe<TaskTotalRingCritical_Bool_Exp>;
};


export type Subscription_RootTaskTotalRingCritical_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaskTotalRingCritical_Stream_Cursor_Input>>;
  where?: InputMaybe<TaskTotalRingCritical_Bool_Exp>;
};


export type Subscription_RootTaskTotalRingNonCriticalArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalRingNonCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalRingNonCritical_Order_By>>;
  where?: InputMaybe<TaskTotalRingNonCritical_Bool_Exp>;
};


export type Subscription_RootTaskTotalRingNonCritical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalRingNonCritical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalRingNonCritical_Order_By>>;
  where?: InputMaybe<TaskTotalRingNonCritical_Bool_Exp>;
};


export type Subscription_RootTaskTotalRingNonCritical_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaskTotalRingNonCritical_Stream_Cursor_Input>>;
  where?: InputMaybe<TaskTotalRingNonCritical_Bool_Exp>;
};


export type Subscription_RootTaskTotalRing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TaskTotalRing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotalRing_Order_By>>;
  where?: InputMaybe<TaskTotalRing_Bool_Exp>;
};


export type Subscription_RootTaskTotalRing_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaskTotalRing_Stream_Cursor_Input>>;
  where?: InputMaybe<TaskTotalRing_Bool_Exp>;
};


export type Subscription_RootTaskTotal_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TaskTotal_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskTotal_Order_By>>;
  where?: InputMaybe<TaskTotal_Bool_Exp>;
};


export type Subscription_RootTaskTotal_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaskTotal_Stream_Cursor_Input>>;
  where?: InputMaybe<TaskTotal_Bool_Exp>;
};


export type Subscription_RootTask_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Subscription_RootTask_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Subscription_RootTeamArgs = {
  distinct_on?: InputMaybe<Array<Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Order_By>>;
  where?: InputMaybe<Team_Bool_Exp>;
};


export type Subscription_RootTeam_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Order_By>>;
  where?: InputMaybe<Team_Bool_Exp>;
};


export type Subscription_RootTeam_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTeam_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Team_Stream_Cursor_Input>>;
  where?: InputMaybe<Team_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUserPermissionArgs = {
  distinct_on?: InputMaybe<Array<UserPermission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPermission_Order_By>>;
  where?: InputMaybe<UserPermission_Bool_Exp>;
};


export type Subscription_RootUserPermission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPermission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPermission_Order_By>>;
  where?: InputMaybe<UserPermission_Bool_Exp>;
};


export type Subscription_RootUserPermission_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUserPermission_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserPermission_Stream_Cursor_Input>>;
  where?: InputMaybe<UserPermission_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootValidatedShiftReportWithRingCountArgs = {
  distinct_on?: InputMaybe<Array<ValidatedShiftReportWithRingCount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ValidatedShiftReportWithRingCount_Order_By>>;
  where?: InputMaybe<ValidatedShiftReportWithRingCount_Bool_Exp>;
};


export type Subscription_RootValidatedShiftReportWithRingCount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidatedShiftReportWithRingCount_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ValidatedShiftReportWithRingCount_Order_By>>;
  where?: InputMaybe<ValidatedShiftReportWithRingCount_Bool_Exp>;
};


export type Subscription_RootValidatedShiftReportWithRingCount_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ValidatedShiftReportWithRingCount_Stream_Cursor_Input>>;
  where?: InputMaybe<ValidatedShiftReportWithRingCount_Bool_Exp>;
};

/** columns and relationships of "task" */
export type Task = {
  __typename?: 'task';
  /** An object relationship */
  activity: Activity;
  /** An object relationship */
  activityFullName?: Maybe<ActivityFullName>;
  activityId: Scalars['uuid']['output'];
  critical: Scalars['Boolean']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  endDate: Scalars['timestamptz']['output'];
  ended: Scalars['Boolean']['output'];
  files: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  isValidated: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  ring: Scalars['Int']['output'];
  /** An object relationship */
  shiftReport: ShiftReport;
  shiftReportId: Scalars['uuid']['output'];
  startDate: Scalars['timestamptz']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "task" */
export type TaskFilesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "taskTotal" */
export type TaskTotal = {
  __typename?: 'taskTotal';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  shiftName?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  shiftReport?: Maybe<ShiftReport>;
  shiftReportId?: Maybe<Scalars['uuid']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  taskStartDate?: Maybe<Scalars['timestamptz']['output']>;
  totalTime?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "taskTotalCritical" */
export type TaskTotalCritical = {
  __typename?: 'taskTotalCritical';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  shiftName?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  shiftReport?: Maybe<ShiftReport>;
  shiftReportId?: Maybe<Scalars['uuid']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  taskStartDate?: Maybe<Scalars['timestamptz']['output']>;
  totalTime?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "taskTotalCritical" */
export type TaskTotalCritical_Aggregate = {
  __typename?: 'taskTotalCritical_aggregate';
  aggregate?: Maybe<TaskTotalCritical_Aggregate_Fields>;
  nodes: Array<TaskTotalCritical>;
};

/** aggregate fields of "taskTotalCritical" */
export type TaskTotalCritical_Aggregate_Fields = {
  __typename?: 'taskTotalCritical_aggregate_fields';
  avg?: Maybe<TaskTotalCritical_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TaskTotalCritical_Max_Fields>;
  min?: Maybe<TaskTotalCritical_Min_Fields>;
  stddev?: Maybe<TaskTotalCritical_Stddev_Fields>;
  stddev_pop?: Maybe<TaskTotalCritical_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TaskTotalCritical_Stddev_Samp_Fields>;
  sum?: Maybe<TaskTotalCritical_Sum_Fields>;
  var_pop?: Maybe<TaskTotalCritical_Var_Pop_Fields>;
  var_samp?: Maybe<TaskTotalCritical_Var_Samp_Fields>;
  variance?: Maybe<TaskTotalCritical_Variance_Fields>;
};


/** aggregate fields of "taskTotalCritical" */
export type TaskTotalCritical_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TaskTotalCritical_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TaskTotalCritical_Avg_Fields = {
  __typename?: 'taskTotalCritical_avg_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "taskTotalCritical". All fields are combined with a logical 'AND'. */
export type TaskTotalCritical_Bool_Exp = {
  _and?: InputMaybe<Array<TaskTotalCritical_Bool_Exp>>;
  _not?: InputMaybe<TaskTotalCritical_Bool_Exp>;
  _or?: InputMaybe<Array<TaskTotalCritical_Bool_Exp>>;
  activityId?: InputMaybe<Uuid_Comparison_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  ring?: InputMaybe<Int_Comparison_Exp>;
  shiftName?: InputMaybe<String_Comparison_Exp>;
  shiftReport?: InputMaybe<ShiftReport_Bool_Exp>;
  shiftReportId?: InputMaybe<Uuid_Comparison_Exp>;
  taskId?: InputMaybe<Uuid_Comparison_Exp>;
  taskStartDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  totalTime?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type TaskTotalCritical_Max_Fields = {
  __typename?: 'taskTotalCritical_max_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  shiftName?: Maybe<Scalars['String']['output']>;
  shiftReportId?: Maybe<Scalars['uuid']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  taskStartDate?: Maybe<Scalars['timestamptz']['output']>;
  totalTime?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type TaskTotalCritical_Min_Fields = {
  __typename?: 'taskTotalCritical_min_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  shiftName?: Maybe<Scalars['String']['output']>;
  shiftReportId?: Maybe<Scalars['uuid']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  taskStartDate?: Maybe<Scalars['timestamptz']['output']>;
  totalTime?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "taskTotalCritical". */
export type TaskTotalCritical_Order_By = {
  activityId?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
  shiftName?: InputMaybe<Order_By>;
  shiftReport?: InputMaybe<ShiftReport_Order_By>;
  shiftReportId?: InputMaybe<Order_By>;
  taskId?: InputMaybe<Order_By>;
  taskStartDate?: InputMaybe<Order_By>;
  totalTime?: InputMaybe<Order_By>;
};

/** select columns of table "taskTotalCritical" */
export enum TaskTotalCritical_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Date = 'date',
  /** column name */
  Ring = 'ring',
  /** column name */
  ShiftName = 'shiftName',
  /** column name */
  ShiftReportId = 'shiftReportId',
  /** column name */
  TaskId = 'taskId',
  /** column name */
  TaskStartDate = 'taskStartDate',
  /** column name */
  TotalTime = 'totalTime'
}

/** aggregate stddev on columns */
export type TaskTotalCritical_Stddev_Fields = {
  __typename?: 'taskTotalCritical_stddev_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TaskTotalCritical_Stddev_Pop_Fields = {
  __typename?: 'taskTotalCritical_stddev_pop_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TaskTotalCritical_Stddev_Samp_Fields = {
  __typename?: 'taskTotalCritical_stddev_samp_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "taskTotalCritical" */
export type TaskTotalCritical_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TaskTotalCritical_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TaskTotalCritical_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
  shiftName?: InputMaybe<Scalars['String']['input']>;
  shiftReportId?: InputMaybe<Scalars['uuid']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  taskStartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  totalTime?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type TaskTotalCritical_Sum_Fields = {
  __typename?: 'taskTotalCritical_sum_fields';
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type TaskTotalCritical_Var_Pop_Fields = {
  __typename?: 'taskTotalCritical_var_pop_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TaskTotalCritical_Var_Samp_Fields = {
  __typename?: 'taskTotalCritical_var_samp_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TaskTotalCritical_Variance_Fields = {
  __typename?: 'taskTotalCritical_variance_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "taskTotalNonCritical" */
export type TaskTotalNonCritical = {
  __typename?: 'taskTotalNonCritical';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  shiftName?: Maybe<Scalars['String']['output']>;
  shiftReportId?: Maybe<Scalars['uuid']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  taskStartDate?: Maybe<Scalars['timestamptz']['output']>;
  totalTime?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "taskTotalNonCritical" */
export type TaskTotalNonCritical_Aggregate = {
  __typename?: 'taskTotalNonCritical_aggregate';
  aggregate?: Maybe<TaskTotalNonCritical_Aggregate_Fields>;
  nodes: Array<TaskTotalNonCritical>;
};

/** aggregate fields of "taskTotalNonCritical" */
export type TaskTotalNonCritical_Aggregate_Fields = {
  __typename?: 'taskTotalNonCritical_aggregate_fields';
  avg?: Maybe<TaskTotalNonCritical_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TaskTotalNonCritical_Max_Fields>;
  min?: Maybe<TaskTotalNonCritical_Min_Fields>;
  stddev?: Maybe<TaskTotalNonCritical_Stddev_Fields>;
  stddev_pop?: Maybe<TaskTotalNonCritical_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TaskTotalNonCritical_Stddev_Samp_Fields>;
  sum?: Maybe<TaskTotalNonCritical_Sum_Fields>;
  var_pop?: Maybe<TaskTotalNonCritical_Var_Pop_Fields>;
  var_samp?: Maybe<TaskTotalNonCritical_Var_Samp_Fields>;
  variance?: Maybe<TaskTotalNonCritical_Variance_Fields>;
};


/** aggregate fields of "taskTotalNonCritical" */
export type TaskTotalNonCritical_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TaskTotalNonCritical_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TaskTotalNonCritical_Avg_Fields = {
  __typename?: 'taskTotalNonCritical_avg_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "taskTotalNonCritical". All fields are combined with a logical 'AND'. */
export type TaskTotalNonCritical_Bool_Exp = {
  _and?: InputMaybe<Array<TaskTotalNonCritical_Bool_Exp>>;
  _not?: InputMaybe<TaskTotalNonCritical_Bool_Exp>;
  _or?: InputMaybe<Array<TaskTotalNonCritical_Bool_Exp>>;
  activityId?: InputMaybe<Uuid_Comparison_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  ring?: InputMaybe<Int_Comparison_Exp>;
  shiftName?: InputMaybe<String_Comparison_Exp>;
  shiftReportId?: InputMaybe<Uuid_Comparison_Exp>;
  taskId?: InputMaybe<Uuid_Comparison_Exp>;
  taskStartDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  totalTime?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type TaskTotalNonCritical_Max_Fields = {
  __typename?: 'taskTotalNonCritical_max_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  shiftName?: Maybe<Scalars['String']['output']>;
  shiftReportId?: Maybe<Scalars['uuid']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  taskStartDate?: Maybe<Scalars['timestamptz']['output']>;
  totalTime?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type TaskTotalNonCritical_Min_Fields = {
  __typename?: 'taskTotalNonCritical_min_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  shiftName?: Maybe<Scalars['String']['output']>;
  shiftReportId?: Maybe<Scalars['uuid']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  taskStartDate?: Maybe<Scalars['timestamptz']['output']>;
  totalTime?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "taskTotalNonCritical". */
export type TaskTotalNonCritical_Order_By = {
  activityId?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
  shiftName?: InputMaybe<Order_By>;
  shiftReportId?: InputMaybe<Order_By>;
  taskId?: InputMaybe<Order_By>;
  taskStartDate?: InputMaybe<Order_By>;
  totalTime?: InputMaybe<Order_By>;
};

/** select columns of table "taskTotalNonCritical" */
export enum TaskTotalNonCritical_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Date = 'date',
  /** column name */
  Ring = 'ring',
  /** column name */
  ShiftName = 'shiftName',
  /** column name */
  ShiftReportId = 'shiftReportId',
  /** column name */
  TaskId = 'taskId',
  /** column name */
  TaskStartDate = 'taskStartDate',
  /** column name */
  TotalTime = 'totalTime'
}

/** aggregate stddev on columns */
export type TaskTotalNonCritical_Stddev_Fields = {
  __typename?: 'taskTotalNonCritical_stddev_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TaskTotalNonCritical_Stddev_Pop_Fields = {
  __typename?: 'taskTotalNonCritical_stddev_pop_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TaskTotalNonCritical_Stddev_Samp_Fields = {
  __typename?: 'taskTotalNonCritical_stddev_samp_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "taskTotalNonCritical" */
export type TaskTotalNonCritical_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TaskTotalNonCritical_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TaskTotalNonCritical_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
  shiftName?: InputMaybe<Scalars['String']['input']>;
  shiftReportId?: InputMaybe<Scalars['uuid']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  taskStartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  totalTime?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type TaskTotalNonCritical_Sum_Fields = {
  __typename?: 'taskTotalNonCritical_sum_fields';
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type TaskTotalNonCritical_Var_Pop_Fields = {
  __typename?: 'taskTotalNonCritical_var_pop_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TaskTotalNonCritical_Var_Samp_Fields = {
  __typename?: 'taskTotalNonCritical_var_samp_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TaskTotalNonCritical_Variance_Fields = {
  __typename?: 'taskTotalNonCritical_variance_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "taskTotalRing" */
export type TaskTotalRing = {
  __typename?: 'taskTotalRing';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['bigint']['output']>;
};

/** columns and relationships of "taskTotalRingCritical" */
export type TaskTotalRingCritical = {
  __typename?: 'taskTotalRingCritical';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "taskTotalRingCritical" */
export type TaskTotalRingCritical_Aggregate = {
  __typename?: 'taskTotalRingCritical_aggregate';
  aggregate?: Maybe<TaskTotalRingCritical_Aggregate_Fields>;
  nodes: Array<TaskTotalRingCritical>;
};

/** aggregate fields of "taskTotalRingCritical" */
export type TaskTotalRingCritical_Aggregate_Fields = {
  __typename?: 'taskTotalRingCritical_aggregate_fields';
  avg?: Maybe<TaskTotalRingCritical_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TaskTotalRingCritical_Max_Fields>;
  min?: Maybe<TaskTotalRingCritical_Min_Fields>;
  stddev?: Maybe<TaskTotalRingCritical_Stddev_Fields>;
  stddev_pop?: Maybe<TaskTotalRingCritical_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TaskTotalRingCritical_Stddev_Samp_Fields>;
  sum?: Maybe<TaskTotalRingCritical_Sum_Fields>;
  var_pop?: Maybe<TaskTotalRingCritical_Var_Pop_Fields>;
  var_samp?: Maybe<TaskTotalRingCritical_Var_Samp_Fields>;
  variance?: Maybe<TaskTotalRingCritical_Variance_Fields>;
};


/** aggregate fields of "taskTotalRingCritical" */
export type TaskTotalRingCritical_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TaskTotalRingCritical_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TaskTotalRingCritical_Avg_Fields = {
  __typename?: 'taskTotalRingCritical_avg_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "taskTotalRingCritical". All fields are combined with a logical 'AND'. */
export type TaskTotalRingCritical_Bool_Exp = {
  _and?: InputMaybe<Array<TaskTotalRingCritical_Bool_Exp>>;
  _not?: InputMaybe<TaskTotalRingCritical_Bool_Exp>;
  _or?: InputMaybe<Array<TaskTotalRingCritical_Bool_Exp>>;
  activityId?: InputMaybe<Uuid_Comparison_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ring?: InputMaybe<Int_Comparison_Exp>;
  totalTime?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type TaskTotalRingCritical_Max_Fields = {
  __typename?: 'taskTotalRingCritical_max_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type TaskTotalRingCritical_Min_Fields = {
  __typename?: 'taskTotalRingCritical_min_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "taskTotalRingCritical". */
export type TaskTotalRingCritical_Order_By = {
  activityId?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
  totalTime?: InputMaybe<Order_By>;
};

/** select columns of table "taskTotalRingCritical" */
export enum TaskTotalRingCritical_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  Ring = 'ring',
  /** column name */
  TotalTime = 'totalTime'
}

/** aggregate stddev on columns */
export type TaskTotalRingCritical_Stddev_Fields = {
  __typename?: 'taskTotalRingCritical_stddev_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TaskTotalRingCritical_Stddev_Pop_Fields = {
  __typename?: 'taskTotalRingCritical_stddev_pop_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TaskTotalRingCritical_Stddev_Samp_Fields = {
  __typename?: 'taskTotalRingCritical_stddev_samp_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "taskTotalRingCritical" */
export type TaskTotalRingCritical_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TaskTotalRingCritical_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TaskTotalRingCritical_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
  totalTime?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type TaskTotalRingCritical_Sum_Fields = {
  __typename?: 'taskTotalRingCritical_sum_fields';
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type TaskTotalRingCritical_Var_Pop_Fields = {
  __typename?: 'taskTotalRingCritical_var_pop_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TaskTotalRingCritical_Var_Samp_Fields = {
  __typename?: 'taskTotalRingCritical_var_samp_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TaskTotalRingCritical_Variance_Fields = {
  __typename?: 'taskTotalRingCritical_variance_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "taskTotalRingNonCritical" */
export type TaskTotalRingNonCritical = {
  __typename?: 'taskTotalRingNonCritical';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "taskTotalRingNonCritical" */
export type TaskTotalRingNonCritical_Aggregate = {
  __typename?: 'taskTotalRingNonCritical_aggregate';
  aggregate?: Maybe<TaskTotalRingNonCritical_Aggregate_Fields>;
  nodes: Array<TaskTotalRingNonCritical>;
};

/** aggregate fields of "taskTotalRingNonCritical" */
export type TaskTotalRingNonCritical_Aggregate_Fields = {
  __typename?: 'taskTotalRingNonCritical_aggregate_fields';
  avg?: Maybe<TaskTotalRingNonCritical_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TaskTotalRingNonCritical_Max_Fields>;
  min?: Maybe<TaskTotalRingNonCritical_Min_Fields>;
  stddev?: Maybe<TaskTotalRingNonCritical_Stddev_Fields>;
  stddev_pop?: Maybe<TaskTotalRingNonCritical_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TaskTotalRingNonCritical_Stddev_Samp_Fields>;
  sum?: Maybe<TaskTotalRingNonCritical_Sum_Fields>;
  var_pop?: Maybe<TaskTotalRingNonCritical_Var_Pop_Fields>;
  var_samp?: Maybe<TaskTotalRingNonCritical_Var_Samp_Fields>;
  variance?: Maybe<TaskTotalRingNonCritical_Variance_Fields>;
};


/** aggregate fields of "taskTotalRingNonCritical" */
export type TaskTotalRingNonCritical_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TaskTotalRingNonCritical_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TaskTotalRingNonCritical_Avg_Fields = {
  __typename?: 'taskTotalRingNonCritical_avg_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "taskTotalRingNonCritical". All fields are combined with a logical 'AND'. */
export type TaskTotalRingNonCritical_Bool_Exp = {
  _and?: InputMaybe<Array<TaskTotalRingNonCritical_Bool_Exp>>;
  _not?: InputMaybe<TaskTotalRingNonCritical_Bool_Exp>;
  _or?: InputMaybe<Array<TaskTotalRingNonCritical_Bool_Exp>>;
  activityId?: InputMaybe<Uuid_Comparison_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ring?: InputMaybe<Int_Comparison_Exp>;
  totalTime?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type TaskTotalRingNonCritical_Max_Fields = {
  __typename?: 'taskTotalRingNonCritical_max_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type TaskTotalRingNonCritical_Min_Fields = {
  __typename?: 'taskTotalRingNonCritical_min_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "taskTotalRingNonCritical". */
export type TaskTotalRingNonCritical_Order_By = {
  activityId?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
  totalTime?: InputMaybe<Order_By>;
};

/** select columns of table "taskTotalRingNonCritical" */
export enum TaskTotalRingNonCritical_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  Ring = 'ring',
  /** column name */
  TotalTime = 'totalTime'
}

/** aggregate stddev on columns */
export type TaskTotalRingNonCritical_Stddev_Fields = {
  __typename?: 'taskTotalRingNonCritical_stddev_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TaskTotalRingNonCritical_Stddev_Pop_Fields = {
  __typename?: 'taskTotalRingNonCritical_stddev_pop_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TaskTotalRingNonCritical_Stddev_Samp_Fields = {
  __typename?: 'taskTotalRingNonCritical_stddev_samp_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "taskTotalRingNonCritical" */
export type TaskTotalRingNonCritical_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TaskTotalRingNonCritical_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TaskTotalRingNonCritical_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
  totalTime?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type TaskTotalRingNonCritical_Sum_Fields = {
  __typename?: 'taskTotalRingNonCritical_sum_fields';
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type TaskTotalRingNonCritical_Var_Pop_Fields = {
  __typename?: 'taskTotalRingNonCritical_var_pop_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TaskTotalRingNonCritical_Var_Samp_Fields = {
  __typename?: 'taskTotalRingNonCritical_var_samp_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TaskTotalRingNonCritical_Variance_Fields = {
  __typename?: 'taskTotalRingNonCritical_variance_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "taskTotalRing" */
export type TaskTotalRing_Aggregate = {
  __typename?: 'taskTotalRing_aggregate';
  aggregate?: Maybe<TaskTotalRing_Aggregate_Fields>;
  nodes: Array<TaskTotalRing>;
};

/** aggregate fields of "taskTotalRing" */
export type TaskTotalRing_Aggregate_Fields = {
  __typename?: 'taskTotalRing_aggregate_fields';
  avg?: Maybe<TaskTotalRing_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TaskTotalRing_Max_Fields>;
  min?: Maybe<TaskTotalRing_Min_Fields>;
  stddev?: Maybe<TaskTotalRing_Stddev_Fields>;
  stddev_pop?: Maybe<TaskTotalRing_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TaskTotalRing_Stddev_Samp_Fields>;
  sum?: Maybe<TaskTotalRing_Sum_Fields>;
  var_pop?: Maybe<TaskTotalRing_Var_Pop_Fields>;
  var_samp?: Maybe<TaskTotalRing_Var_Samp_Fields>;
  variance?: Maybe<TaskTotalRing_Variance_Fields>;
};


/** aggregate fields of "taskTotalRing" */
export type TaskTotalRing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TaskTotalRing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TaskTotalRing_Avg_Fields = {
  __typename?: 'taskTotalRing_avg_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "taskTotalRing". All fields are combined with a logical 'AND'. */
export type TaskTotalRing_Bool_Exp = {
  _and?: InputMaybe<Array<TaskTotalRing_Bool_Exp>>;
  _not?: InputMaybe<TaskTotalRing_Bool_Exp>;
  _or?: InputMaybe<Array<TaskTotalRing_Bool_Exp>>;
  activityId?: InputMaybe<Uuid_Comparison_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ring?: InputMaybe<Int_Comparison_Exp>;
  totalTime?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type TaskTotalRing_Max_Fields = {
  __typename?: 'taskTotalRing_max_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type TaskTotalRing_Min_Fields = {
  __typename?: 'taskTotalRing_min_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "taskTotalRing". */
export type TaskTotalRing_Order_By = {
  activityId?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
  totalTime?: InputMaybe<Order_By>;
};

/** select columns of table "taskTotalRing" */
export enum TaskTotalRing_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  Ring = 'ring',
  /** column name */
  TotalTime = 'totalTime'
}

/** aggregate stddev on columns */
export type TaskTotalRing_Stddev_Fields = {
  __typename?: 'taskTotalRing_stddev_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TaskTotalRing_Stddev_Pop_Fields = {
  __typename?: 'taskTotalRing_stddev_pop_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TaskTotalRing_Stddev_Samp_Fields = {
  __typename?: 'taskTotalRing_stddev_samp_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "taskTotalRing" */
export type TaskTotalRing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TaskTotalRing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TaskTotalRing_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
  totalTime?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type TaskTotalRing_Sum_Fields = {
  __typename?: 'taskTotalRing_sum_fields';
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type TaskTotalRing_Var_Pop_Fields = {
  __typename?: 'taskTotalRing_var_pop_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TaskTotalRing_Var_Samp_Fields = {
  __typename?: 'taskTotalRing_var_samp_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TaskTotalRing_Variance_Fields = {
  __typename?: 'taskTotalRing_variance_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "taskTotal" */
export type TaskTotal_Aggregate = {
  __typename?: 'taskTotal_aggregate';
  aggregate?: Maybe<TaskTotal_Aggregate_Fields>;
  nodes: Array<TaskTotal>;
};

/** aggregate fields of "taskTotal" */
export type TaskTotal_Aggregate_Fields = {
  __typename?: 'taskTotal_aggregate_fields';
  avg?: Maybe<TaskTotal_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TaskTotal_Max_Fields>;
  min?: Maybe<TaskTotal_Min_Fields>;
  stddev?: Maybe<TaskTotal_Stddev_Fields>;
  stddev_pop?: Maybe<TaskTotal_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TaskTotal_Stddev_Samp_Fields>;
  sum?: Maybe<TaskTotal_Sum_Fields>;
  var_pop?: Maybe<TaskTotal_Var_Pop_Fields>;
  var_samp?: Maybe<TaskTotal_Var_Samp_Fields>;
  variance?: Maybe<TaskTotal_Variance_Fields>;
};


/** aggregate fields of "taskTotal" */
export type TaskTotal_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TaskTotal_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TaskTotal_Avg_Fields = {
  __typename?: 'taskTotal_avg_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "taskTotal". All fields are combined with a logical 'AND'. */
export type TaskTotal_Bool_Exp = {
  _and?: InputMaybe<Array<TaskTotal_Bool_Exp>>;
  _not?: InputMaybe<TaskTotal_Bool_Exp>;
  _or?: InputMaybe<Array<TaskTotal_Bool_Exp>>;
  activityId?: InputMaybe<Uuid_Comparison_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  ring?: InputMaybe<Int_Comparison_Exp>;
  shiftName?: InputMaybe<String_Comparison_Exp>;
  shiftReport?: InputMaybe<ShiftReport_Bool_Exp>;
  shiftReportId?: InputMaybe<Uuid_Comparison_Exp>;
  taskId?: InputMaybe<Uuid_Comparison_Exp>;
  taskStartDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  totalTime?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type TaskTotal_Max_Fields = {
  __typename?: 'taskTotal_max_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  shiftName?: Maybe<Scalars['String']['output']>;
  shiftReportId?: Maybe<Scalars['uuid']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  taskStartDate?: Maybe<Scalars['timestamptz']['output']>;
  totalTime?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type TaskTotal_Min_Fields = {
  __typename?: 'taskTotal_min_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  shiftName?: Maybe<Scalars['String']['output']>;
  shiftReportId?: Maybe<Scalars['uuid']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  taskStartDate?: Maybe<Scalars['timestamptz']['output']>;
  totalTime?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "taskTotal". */
export type TaskTotal_Order_By = {
  activityId?: InputMaybe<Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
  shiftName?: InputMaybe<Order_By>;
  shiftReport?: InputMaybe<ShiftReport_Order_By>;
  shiftReportId?: InputMaybe<Order_By>;
  taskId?: InputMaybe<Order_By>;
  taskStartDate?: InputMaybe<Order_By>;
  totalTime?: InputMaybe<Order_By>;
};

/** select columns of table "taskTotal" */
export enum TaskTotal_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Date = 'date',
  /** column name */
  Ring = 'ring',
  /** column name */
  ShiftName = 'shiftName',
  /** column name */
  ShiftReportId = 'shiftReportId',
  /** column name */
  TaskId = 'taskId',
  /** column name */
  TaskStartDate = 'taskStartDate',
  /** column name */
  TotalTime = 'totalTime'
}

/** aggregate stddev on columns */
export type TaskTotal_Stddev_Fields = {
  __typename?: 'taskTotal_stddev_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TaskTotal_Stddev_Pop_Fields = {
  __typename?: 'taskTotal_stddev_pop_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TaskTotal_Stddev_Samp_Fields = {
  __typename?: 'taskTotal_stddev_samp_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "taskTotal" */
export type TaskTotal_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TaskTotal_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TaskTotal_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
  shiftName?: InputMaybe<Scalars['String']['input']>;
  shiftReportId?: InputMaybe<Scalars['uuid']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  taskStartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  totalTime?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type TaskTotal_Sum_Fields = {
  __typename?: 'taskTotal_sum_fields';
  ring?: Maybe<Scalars['Int']['output']>;
  totalTime?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type TaskTotal_Var_Pop_Fields = {
  __typename?: 'taskTotal_var_pop_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TaskTotal_Var_Samp_Fields = {
  __typename?: 'taskTotal_var_samp_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TaskTotal_Variance_Fields = {
  __typename?: 'taskTotal_variance_fields';
  ring?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "task" */
export type Task_Aggregate = {
  __typename?: 'task_aggregate';
  aggregate?: Maybe<Task_Aggregate_Fields>;
  nodes: Array<Task>;
};

export type Task_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Task_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Task_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Task_Aggregate_Bool_Exp_Count>;
};

export type Task_Aggregate_Bool_Exp_Bool_And = {
  arguments: Task_Select_Column_Task_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Task_Select_Column_Task_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Task_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Task_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "task" */
export type Task_Aggregate_Fields = {
  __typename?: 'task_aggregate_fields';
  avg?: Maybe<Task_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Task_Max_Fields>;
  min?: Maybe<Task_Min_Fields>;
  stddev?: Maybe<Task_Stddev_Fields>;
  stddev_pop?: Maybe<Task_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Task_Stddev_Samp_Fields>;
  sum?: Maybe<Task_Sum_Fields>;
  var_pop?: Maybe<Task_Var_Pop_Fields>;
  var_samp?: Maybe<Task_Var_Samp_Fields>;
  variance?: Maybe<Task_Variance_Fields>;
};


/** aggregate fields of "task" */
export type Task_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "task" */
export type Task_Aggregate_Order_By = {
  avg?: InputMaybe<Task_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Task_Max_Order_By>;
  min?: InputMaybe<Task_Min_Order_By>;
  stddev?: InputMaybe<Task_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Task_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Task_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Task_Sum_Order_By>;
  var_pop?: InputMaybe<Task_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Task_Var_Samp_Order_By>;
  variance?: InputMaybe<Task_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Task_Append_Input = {
  files?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "task" */
export type Task_Arr_Rel_Insert_Input = {
  data: Array<Task_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_On_Conflict>;
};

/** aggregate avg on columns */
export type Task_Avg_Fields = {
  __typename?: 'task_avg_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "task" */
export type Task_Avg_Order_By = {
  duration?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "task". All fields are combined with a logical 'AND'. */
export type Task_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Bool_Exp>>;
  _not?: InputMaybe<Task_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Bool_Exp>>;
  activity?: InputMaybe<Activity_Bool_Exp>;
  activityFullName?: InputMaybe<ActivityFullName_Bool_Exp>;
  activityId?: InputMaybe<Uuid_Comparison_Exp>;
  critical?: InputMaybe<Boolean_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  endDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  ended?: InputMaybe<Boolean_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isValidated?: InputMaybe<Boolean_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  ring?: InputMaybe<Int_Comparison_Exp>;
  shiftReport?: InputMaybe<ShiftReport_Bool_Exp>;
  shiftReportId?: InputMaybe<Uuid_Comparison_Exp>;
  startDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "task" */
export enum Task_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaskPkey = 'task_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Task_Delete_At_Path_Input = {
  files?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Task_Delete_Elem_Input = {
  files?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Task_Delete_Key_Input = {
  files?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "task" */
export type Task_Inc_Input = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "task" */
export type Task_Insert_Input = {
  activity?: InputMaybe<Activity_Obj_Rel_Insert_Input>;
  activityFullName?: InputMaybe<ActivityFullName_Obj_Rel_Insert_Input>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  critical?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ended?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
  shiftReport?: InputMaybe<ShiftReport_Obj_Rel_Insert_Input>;
  shiftReportId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Task_Max_Fields = {
  __typename?: 'task_max_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  shiftReportId?: Maybe<Scalars['uuid']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "task" */
export type Task_Max_Order_By = {
  activityId?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
  shiftReportId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Task_Min_Fields = {
  __typename?: 'task_min_fields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
  shiftReportId?: Maybe<Scalars['uuid']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "task" */
export type Task_Min_Order_By = {
  activityId?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
  shiftReportId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "task" */
export type Task_Mutation_Response = {
  __typename?: 'task_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task>;
};

/** on_conflict condition type for table "task" */
export type Task_On_Conflict = {
  constraint: Task_Constraint;
  update_columns?: Array<Task_Update_Column>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** Ordering options when selecting data from "task". */
export type Task_Order_By = {
  activity?: InputMaybe<Activity_Order_By>;
  activityFullName?: InputMaybe<ActivityFullName_Order_By>;
  activityId?: InputMaybe<Order_By>;
  critical?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  ended?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isValidated?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
  shiftReport?: InputMaybe<ShiftReport_Order_By>;
  shiftReportId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task */
export type Task_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Task_Prepend_Input = {
  files?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "task" */
export enum Task_Select_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  Critical = 'critical',
  /** column name */
  Duration = 'duration',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Ended = 'ended',
  /** column name */
  Files = 'files',
  /** column name */
  Id = 'id',
  /** column name */
  IsValidated = 'isValidated',
  /** column name */
  Note = 'note',
  /** column name */
  Ring = 'ring',
  /** column name */
  ShiftReportId = 'shiftReportId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "task_aggregate_bool_exp_bool_and_arguments_columns" columns of table "task" */
export enum Task_Select_Column_Task_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Critical = 'critical',
  /** column name */
  Ended = 'ended',
  /** column name */
  IsValidated = 'isValidated'
}

/** select "task_aggregate_bool_exp_bool_or_arguments_columns" columns of table "task" */
export enum Task_Select_Column_Task_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Critical = 'critical',
  /** column name */
  Ended = 'ended',
  /** column name */
  IsValidated = 'isValidated'
}

/** input type for updating data in table "task" */
export type Task_Set_Input = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  critical?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ended?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
  shiftReportId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Task_Stddev_Fields = {
  __typename?: 'task_stddev_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "task" */
export type Task_Stddev_Order_By = {
  duration?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Task_Stddev_Pop_Fields = {
  __typename?: 'task_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "task" */
export type Task_Stddev_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Task_Stddev_Samp_Fields = {
  __typename?: 'task_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "task" */
export type Task_Stddev_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "task" */
export type Task_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Stream_Cursor_Value_Input = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  critical?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  ended?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  ring?: InputMaybe<Scalars['Int']['input']>;
  shiftReportId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Task_Sum_Fields = {
  __typename?: 'task_sum_fields';
  duration?: Maybe<Scalars['Int']['output']>;
  ring?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "task" */
export type Task_Sum_Order_By = {
  duration?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** update columns of table "task" */
export enum Task_Update_Column {
  /** column name */
  ActivityId = 'activityId',
  /** column name */
  Critical = 'critical',
  /** column name */
  Duration = 'duration',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  Ended = 'ended',
  /** column name */
  Files = 'files',
  /** column name */
  Id = 'id',
  /** column name */
  IsValidated = 'isValidated',
  /** column name */
  Note = 'note',
  /** column name */
  Ring = 'ring',
  /** column name */
  ShiftReportId = 'shiftReportId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Task_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Task_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Task_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Task_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Task_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Task_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Task_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Task_Var_Pop_Fields = {
  __typename?: 'task_var_pop_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "task" */
export type Task_Var_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Task_Var_Samp_Fields = {
  __typename?: 'task_var_samp_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "task" */
export type Task_Var_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Task_Variance_Fields = {
  __typename?: 'task_variance_fields';
  duration?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "task" */
export type Task_Variance_Order_By = {
  duration?: InputMaybe<Order_By>;
  ring?: InputMaybe<Order_By>;
};

/** columns and relationships of "team" */
export type Team = {
  __typename?: 'team';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

/** aggregated selection of "team" */
export type Team_Aggregate = {
  __typename?: 'team_aggregate';
  aggregate?: Maybe<Team_Aggregate_Fields>;
  nodes: Array<Team>;
};

/** aggregate fields of "team" */
export type Team_Aggregate_Fields = {
  __typename?: 'team_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Team_Max_Fields>;
  min?: Maybe<Team_Min_Fields>;
};


/** aggregate fields of "team" */
export type Team_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Team_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "team". All fields are combined with a logical 'AND'. */
export type Team_Bool_Exp = {
  _and?: InputMaybe<Array<Team_Bool_Exp>>;
  _not?: InputMaybe<Team_Bool_Exp>;
  _or?: InputMaybe<Array<Team_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "team" */
export enum Team_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamPkey = 'team_pkey'
}

/** input type for inserting data into table "team" */
export type Team_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Team_Max_Fields = {
  __typename?: 'team_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Team_Min_Fields = {
  __typename?: 'team_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "team" */
export type Team_Mutation_Response = {
  __typename?: 'team_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Team>;
};

/** input type for inserting object relation for remote table "team" */
export type Team_Obj_Rel_Insert_Input = {
  data: Team_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Team_On_Conflict>;
};

/** on_conflict condition type for table "team" */
export type Team_On_Conflict = {
  constraint: Team_Constraint;
  update_columns?: Array<Team_Update_Column>;
  where?: InputMaybe<Team_Bool_Exp>;
};

/** Ordering options when selecting data from "team". */
export type Team_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isHidden?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: team */
export type Team_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "team" */
export enum Team_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "team" */
export type Team_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "team" */
export type Team_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "team" */
export enum Team_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  IsHidden = 'isHidden',
  /** column name */
  Name = 'name'
}

export type Team_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Team_Set_Input>;
  /** filter the rows which have to be updated */
  where: Team_Bool_Exp;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  authId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isActive: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  permissions: Array<UserPermission>;
  /** An aggregate relationship */
  permissions_aggregate: UserPermission_Aggregate;
  /** An array relationship */
  qualityRole: Array<Quality_UserQualityRole>;
  /** An aggregate relationship */
  qualityRole_aggregate: Quality_UserQualityRole_Aggregate;
  roles: Scalars['jsonb']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "user" */
export type UserPermissionsArgs = {
  distinct_on?: InputMaybe<Array<UserPermission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPermission_Order_By>>;
  where?: InputMaybe<UserPermission_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPermission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserPermission_Order_By>>;
  where?: InputMaybe<UserPermission_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserQualityRoleArgs = {
  distinct_on?: InputMaybe<Array<Quality_UserQualityRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_UserQualityRole_Order_By>>;
  where?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserQualityRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quality_UserQualityRole_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quality_UserQualityRole_Order_By>>;
  where?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRolesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "userPermission" */
export type UserPermission = {
  __typename?: 'userPermission';
  /** An object relationship */
  constructionSite: ConstructionSite;
  constructionSiteId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  module: Module_Enum;
  /** An object relationship */
  permissionType: PermissionType;
  permissionTypeId: Scalars['uuid']['output'];
  /** An object relationship */
  user: User;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "userPermission" */
export type UserPermission_Aggregate = {
  __typename?: 'userPermission_aggregate';
  aggregate?: Maybe<UserPermission_Aggregate_Fields>;
  nodes: Array<UserPermission>;
};

export type UserPermission_Aggregate_Bool_Exp = {
  count?: InputMaybe<UserPermission_Aggregate_Bool_Exp_Count>;
};

export type UserPermission_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UserPermission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserPermission_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "userPermission" */
export type UserPermission_Aggregate_Fields = {
  __typename?: 'userPermission_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserPermission_Max_Fields>;
  min?: Maybe<UserPermission_Min_Fields>;
};


/** aggregate fields of "userPermission" */
export type UserPermission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserPermission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "userPermission" */
export type UserPermission_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserPermission_Max_Order_By>;
  min?: InputMaybe<UserPermission_Min_Order_By>;
};

/** input type for inserting array relation for remote table "userPermission" */
export type UserPermission_Arr_Rel_Insert_Input = {
  data: Array<UserPermission_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserPermission_On_Conflict>;
};

/** Boolean expression to filter rows from the table "userPermission". All fields are combined with a logical 'AND'. */
export type UserPermission_Bool_Exp = {
  _and?: InputMaybe<Array<UserPermission_Bool_Exp>>;
  _not?: InputMaybe<UserPermission_Bool_Exp>;
  _or?: InputMaybe<Array<UserPermission_Bool_Exp>>;
  constructionSite?: InputMaybe<ConstructionSite_Bool_Exp>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  module?: InputMaybe<Module_Enum_Comparison_Exp>;
  permissionType?: InputMaybe<PermissionType_Bool_Exp>;
  permissionTypeId?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "userPermission" */
export enum UserPermission_Constraint {
  /** unique or primary key constraint on columns "userId", "module", "constructionSiteId", "permissionTypeId" */
  UserPermissionPermissionTypeIdConstructionSiteIdUserIdModul = 'userPermission_permissionTypeId_constructionSiteId_userId_modul',
  /** unique or primary key constraint on columns "id" */
  UserPermissionPkey = 'userPermission_pkey'
}

/** input type for inserting data into table "userPermission" */
export type UserPermission_Insert_Input = {
  constructionSite?: InputMaybe<ConstructionSite_Obj_Rel_Insert_Input>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  module?: InputMaybe<Module_Enum>;
  permissionType?: InputMaybe<PermissionType_Obj_Rel_Insert_Input>;
  permissionTypeId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type UserPermission_Max_Fields = {
  __typename?: 'userPermission_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  permissionTypeId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "userPermission" */
export type UserPermission_Max_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permissionTypeId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserPermission_Min_Fields = {
  __typename?: 'userPermission_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  permissionTypeId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "userPermission" */
export type UserPermission_Min_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permissionTypeId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userPermission" */
export type UserPermission_Mutation_Response = {
  __typename?: 'userPermission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPermission>;
};

/** on_conflict condition type for table "userPermission" */
export type UserPermission_On_Conflict = {
  constraint: UserPermission_Constraint;
  update_columns?: Array<UserPermission_Update_Column>;
  where?: InputMaybe<UserPermission_Bool_Exp>;
};

/** Ordering options when selecting data from "userPermission". */
export type UserPermission_Order_By = {
  constructionSite?: InputMaybe<ConstructionSite_Order_By>;
  constructionSiteId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module?: InputMaybe<Order_By>;
  permissionType?: InputMaybe<PermissionType_Order_By>;
  permissionTypeId?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: userPermission */
export type UserPermission_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "userPermission" */
export enum UserPermission_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  Module = 'module',
  /** column name */
  PermissionTypeId = 'permissionTypeId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "userPermission" */
export type UserPermission_Set_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  module?: InputMaybe<Module_Enum>;
  permissionTypeId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "userPermission" */
export type UserPermission_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserPermission_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPermission_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  module?: InputMaybe<Module_Enum>;
  permissionTypeId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "userPermission" */
export enum UserPermission_Update_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Id = 'id',
  /** column name */
  Module = 'module',
  /** column name */
  PermissionTypeId = 'permissionTypeId',
  /** column name */
  UserId = 'userId'
}

export type UserPermission_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPermission_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserPermission_Bool_Exp;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Append_Input = {
  roles?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  authId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isActive?: InputMaybe<Boolean_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  permissions?: InputMaybe<UserPermission_Bool_Exp>;
  permissions_aggregate?: InputMaybe<UserPermission_Aggregate_Bool_Exp>;
  qualityRole?: InputMaybe<Quality_UserQualityRole_Bool_Exp>;
  qualityRole_aggregate?: InputMaybe<Quality_UserQualityRole_Aggregate_Bool_Exp>;
  roles?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user" */
export enum User_Constraint {
  /** unique or primary key constraint on columns "authId" */
  UserAuthIdKey = 'user_authId_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Delete_At_Path_Input = {
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Delete_Elem_Input = {
  roles?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Delete_Key_Input = {
  roles?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  authId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UserPermission_Arr_Rel_Insert_Input>;
  qualityRole?: InputMaybe<Quality_UserQualityRole_Arr_Rel_Insert_Input>;
  roles?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  authId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  authId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  authId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isActive?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  permissions_aggregate?: InputMaybe<UserPermission_Aggregate_Order_By>;
  qualityRole_aggregate?: InputMaybe<Quality_UserQualityRole_Aggregate_Order_By>;
  roles?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Prepend_Input = {
  roles?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "user" */
export enum User_Select_Column {
  /** column name */
  AuthId = 'authId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Roles = 'roles',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "user" */
export type User_Set_Input = {
  authId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  authId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "user" */
export enum User_Update_Column {
  /** column name */
  AuthId = 'authId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'isActive',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Roles = 'roles',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type User_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "validatedShiftReportWithRingCount" */
export type ValidatedShiftReportWithRingCount = {
  __typename?: 'validatedShiftReportWithRingCount';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ringCount?: Maybe<Scalars['bigint']['output']>;
  ringList?: Maybe<Array<Scalars['Int']['output']>>;
  shiftId?: Maybe<Scalars['uuid']['output']>;
  teamId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "validatedShiftReportWithRingCount" */
export type ValidatedShiftReportWithRingCount_Aggregate = {
  __typename?: 'validatedShiftReportWithRingCount_aggregate';
  aggregate?: Maybe<ValidatedShiftReportWithRingCount_Aggregate_Fields>;
  nodes: Array<ValidatedShiftReportWithRingCount>;
};

/** aggregate fields of "validatedShiftReportWithRingCount" */
export type ValidatedShiftReportWithRingCount_Aggregate_Fields = {
  __typename?: 'validatedShiftReportWithRingCount_aggregate_fields';
  avg?: Maybe<ValidatedShiftReportWithRingCount_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ValidatedShiftReportWithRingCount_Max_Fields>;
  min?: Maybe<ValidatedShiftReportWithRingCount_Min_Fields>;
  stddev?: Maybe<ValidatedShiftReportWithRingCount_Stddev_Fields>;
  stddev_pop?: Maybe<ValidatedShiftReportWithRingCount_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ValidatedShiftReportWithRingCount_Stddev_Samp_Fields>;
  sum?: Maybe<ValidatedShiftReportWithRingCount_Sum_Fields>;
  var_pop?: Maybe<ValidatedShiftReportWithRingCount_Var_Pop_Fields>;
  var_samp?: Maybe<ValidatedShiftReportWithRingCount_Var_Samp_Fields>;
  variance?: Maybe<ValidatedShiftReportWithRingCount_Variance_Fields>;
};


/** aggregate fields of "validatedShiftReportWithRingCount" */
export type ValidatedShiftReportWithRingCount_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ValidatedShiftReportWithRingCount_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ValidatedShiftReportWithRingCount_Avg_Fields = {
  __typename?: 'validatedShiftReportWithRingCount_avg_fields';
  ringCount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "validatedShiftReportWithRingCount". All fields are combined with a logical 'AND'. */
export type ValidatedShiftReportWithRingCount_Bool_Exp = {
  _and?: InputMaybe<Array<ValidatedShiftReportWithRingCount_Bool_Exp>>;
  _not?: InputMaybe<ValidatedShiftReportWithRingCount_Bool_Exp>;
  _or?: InputMaybe<Array<ValidatedShiftReportWithRingCount_Bool_Exp>>;
  constructionSiteId?: InputMaybe<Uuid_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ringCount?: InputMaybe<Bigint_Comparison_Exp>;
  ringList?: InputMaybe<Int_Array_Comparison_Exp>;
  shiftId?: InputMaybe<Uuid_Comparison_Exp>;
  teamId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type ValidatedShiftReportWithRingCount_Max_Fields = {
  __typename?: 'validatedShiftReportWithRingCount_max_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ringCount?: Maybe<Scalars['bigint']['output']>;
  ringList?: Maybe<Array<Scalars['Int']['output']>>;
  shiftId?: Maybe<Scalars['uuid']['output']>;
  teamId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type ValidatedShiftReportWithRingCount_Min_Fields = {
  __typename?: 'validatedShiftReportWithRingCount_min_fields';
  constructionSiteId?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ringCount?: Maybe<Scalars['bigint']['output']>;
  ringList?: Maybe<Array<Scalars['Int']['output']>>;
  shiftId?: Maybe<Scalars['uuid']['output']>;
  teamId?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "validatedShiftReportWithRingCount". */
export type ValidatedShiftReportWithRingCount_Order_By = {
  constructionSiteId?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ringCount?: InputMaybe<Order_By>;
  ringList?: InputMaybe<Order_By>;
  shiftId?: InputMaybe<Order_By>;
  teamId?: InputMaybe<Order_By>;
};

/** select columns of table "validatedShiftReportWithRingCount" */
export enum ValidatedShiftReportWithRingCount_Select_Column {
  /** column name */
  ConstructionSiteId = 'constructionSiteId',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  RingCount = 'ringCount',
  /** column name */
  RingList = 'ringList',
  /** column name */
  ShiftId = 'shiftId',
  /** column name */
  TeamId = 'teamId'
}

/** aggregate stddev on columns */
export type ValidatedShiftReportWithRingCount_Stddev_Fields = {
  __typename?: 'validatedShiftReportWithRingCount_stddev_fields';
  ringCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ValidatedShiftReportWithRingCount_Stddev_Pop_Fields = {
  __typename?: 'validatedShiftReportWithRingCount_stddev_pop_fields';
  ringCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ValidatedShiftReportWithRingCount_Stddev_Samp_Fields = {
  __typename?: 'validatedShiftReportWithRingCount_stddev_samp_fields';
  ringCount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "validatedShiftReportWithRingCount" */
export type ValidatedShiftReportWithRingCount_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ValidatedShiftReportWithRingCount_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ValidatedShiftReportWithRingCount_Stream_Cursor_Value_Input = {
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ringCount?: InputMaybe<Scalars['bigint']['input']>;
  ringList?: InputMaybe<Array<Scalars['Int']['input']>>;
  shiftId?: InputMaybe<Scalars['uuid']['input']>;
  teamId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type ValidatedShiftReportWithRingCount_Sum_Fields = {
  __typename?: 'validatedShiftReportWithRingCount_sum_fields';
  ringCount?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type ValidatedShiftReportWithRingCount_Var_Pop_Fields = {
  __typename?: 'validatedShiftReportWithRingCount_var_pop_fields';
  ringCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ValidatedShiftReportWithRingCount_Var_Samp_Fields = {
  __typename?: 'validatedShiftReportWithRingCount_var_samp_fields';
  ringCount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ValidatedShiftReportWithRingCount_Variance_Fields = {
  __typename?: 'validatedShiftReportWithRingCount_variance_fields';
  ringCount?: Maybe<Scalars['Float']['output']>;
};

export type GetHighestMetricPointQueryVariables = Exact<{
  constructionSiteId: Uuid_Comparison_Exp;
  productionDay: Date_Comparison_Exp;
}>;


export type GetHighestMetricPointQuery = { __typename?: 'query_root', parameter_ringWithProductionDay_aggregate: { __typename?: 'parameter_ringWithProductionDay_aggregate', aggregate?: { __typename?: 'parameter_ringWithProductionDay_aggregate_fields', max?: { __typename?: 'parameter_ringWithProductionDay_max_fields', buildEndMetricPoint?: any | null } | null } | null } };

export type GetTbmInfosQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
  compareDate: Scalars['timestamptz']['input'];
}>;


export type GetTbmInfosQuery = { __typename?: 'query_root', constructionSite: Array<{ __typename?: 'constructionSite', id: any, timeZone: string, nbTotalRings?: number | null, nbTotalMeters?: any | null, isCompleted: boolean, mapConfiguration?: { __typename?: 'mapConfiguration', id: any, latitude: any, longitude: any, zoom: any, traceColor?: string | null } | null, metrics_aggregate: { __typename?: 'parameter_metric_aggregate', nodes: Array<{ __typename?: 'parameter_metric', id: any, isBuilding?: boolean | null, isExcavating?: boolean | null }> }, mapTraces: Array<{ __typename?: 'mapTrace', id: any, mp: any, latitude: any, longitude: any }>, rings: Array<{ __typename?: 'parameter_ring', id: any, buildEndMetricPoint?: any | null, ringNumber: number }>, mapPois: Array<{ __typename?: 'mapPoi', id: any, name: string, latitude: any, longitude: any }> }> };

export type GetTbmLastMetricQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
  compareDate: Scalars['timestamptz']['input'];
}>;


export type GetTbmLastMetricQuery = { __typename?: 'query_root', parameter_metric_aggregate: { __typename?: 'parameter_metric_aggregate', aggregate?: { __typename?: 'parameter_metric_aggregate_fields', max?: { __typename?: 'parameter_metric_max_fields', batchDate?: any | null } | null } | null } };

export type ParameterDefFragment = { __typename?: 'parameter_parameterDef', id: number, name: string, unit: string };

export type ParameterFamiliesQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
}>;


export type ParameterFamiliesQuery = { __typename?: 'query_root', parameter_familyDef: Array<{ __typename?: 'parameter_familyDef', id: number, name: string, parameterDefs: Array<{ __typename?: 'parameter_parameterDef', id: number, name: string, unit: string }> }> };

export type GetSavedGraphCountQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
  type: GraphSetTypeEnum_Enum;
}>;


export type GetSavedGraphCountQuery = { __typename?: 'query_root', graphSet_aggregate: { __typename?: 'graphSet_aggregate', aggregate?: { __typename?: 'graphSet_aggregate_fields', count: number } | null } };

export type GetGraphSetListQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
  type: GraphSetTypeEnum_Enum;
}>;


export type GetGraphSetListQuery = { __typename?: 'query_root', graphSet: Array<{ __typename?: 'graphSet', id: any, title: string, type: GraphSetTypeEnum_Enum, version: number }> };

export type GetGraphSetQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetGraphSetQuery = { __typename?: 'query_root', graphSet_by_pk?: { __typename?: 'graphSet', id: any, title: string, type: GraphSetTypeEnum_Enum, graphs: any } | null };

export type DeleteSavedGraphSetMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteSavedGraphSetMutation = { __typename?: 'mutation_root', delete_graphSet_by_pk?: { __typename?: 'graphSet', id: any } | null };

export type GetCurrentRingQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
}>;


export type GetCurrentRingQuery = { __typename?: 'query_root', parameter_ring_aggregate: { __typename?: 'parameter_ring_aggregate', aggregate?: { __typename?: 'parameter_ring_aggregate_fields', max?: { __typename?: 'parameter_ring_max_fields', ringNumber?: number | null } | null } | null } };

export type GetShiftReportNameQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetShiftReportNameQuery = { __typename?: 'query_root', shiftReport?: { __typename?: 'shiftReport', id: any, constructionSiteId: any } | null };

export type GetRingConstructionSiteQueryVariables = Exact<{
  ringId: Scalars['uuid']['input'];
}>;


export type GetRingConstructionSiteQuery = { __typename?: 'query_root', parameter_ring_by_pk?: { __typename?: 'parameter_ring', id: any, constructionSiteId: any } | null };

export type UpdateParameterRingMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  updatedFields: Parameter_Ring_Set_Input;
}>;


export type UpdateParameterRingMutation = { __typename?: 'mutation_root', update_parameter_ring_by_pk?: { __typename: 'parameter_ring', id: any } | null };

export type GetRingsQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Parameter_Ring_Bool_Exp>;
  orderBy?: InputMaybe<Array<Parameter_Ring_Order_By> | Parameter_Ring_Order_By>;
}>;


export type GetRingsQuery = { __typename?: 'query_root', parameter_ring: Array<{ __typename?: 'parameter_ring', id: any, ringNumber: number, keyPosition?: number | null, length?: any | null, buildEndMetricPoint?: any | null, excavationStart?: any | null, excavationEnd?: any | null, totalExcavationDuration?: string | null, realExcavationDuration?: string | null, buildStart?: any | null, buildEnd?: any | null, totalBuildDuration?: string | null, realBuildDuration?: string | null }>, parameter_ring_aggregate: { __typename?: 'parameter_ring_aggregate', aggregate?: { __typename?: 'parameter_ring_aggregate_fields', count: number } | null } };

export type DeleteProjectionMutationVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
}>;


export type DeleteProjectionMutation = { __typename?: 'mutation_root', delete_parameter_ringProjection?: { __typename?: 'parameter_ringProjection_mutation_response', affected_rows: number } | null };

export type GetRingProjectionCountQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
}>;


export type GetRingProjectionCountQuery = { __typename?: 'query_root', ringProjection: { __typename?: 'parameter_ringProjection_aggregate', aggregate?: { __typename?: 'parameter_ringProjection_aggregate_fields', count: number } | null } };

export type GetSegmentHistoryOptionsQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
  projectId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetSegmentHistoryOptionsQuery = { __typename?: 'query_root', scanSites: Array<{ __typename?: 'quality_scanSite', id: any, label: string, isReceiptActivated: boolean }>, defectTypes: Array<{ __typename?: 'quality_quarantineDefectType', id: any, label: string }> };

export type GetDefectRepairOptionsQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetDefectRepairOptionsQuery = { __typename?: 'query_root', defectTypes: Array<{ __typename?: 'quality_defectRepairType', id: any, label: string }> };

export type GetFiltersDataQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
  projectId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetFiltersDataQuery = { __typename?: 'query_root', serialNumbers: Array<{ __typename?: 'quality_segment', id: any, serialNumber: string }>, scanSites: Array<{ __typename?: 'quality_scanSite', id: any, label: string, isQuarantineEnabled: boolean, isOnHoldOptionEnabled: boolean, isReceiptActivated: boolean }>, segmentTypes: Array<{ __typename?: 'quality_segment', segmentType?: string | null }> };

export type GetSegmentHistoryExtraColumnsQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
}>;


export type GetSegmentHistoryExtraColumnsQuery = { __typename?: 'query_root', extraColumns: Array<{ __typename?: 'quality_importExtraColumn', id: any, segmentParameter: string }> };

export type GetLastImportTaskQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetLastImportTaskQuery = { __typename?: 'query_root', lastTask: Array<{ __typename?: 'quality_importTask', id: any, segmentCreated: number, segmentUpdated: number, segmentFailed: number, endDate?: any | null, warnings?: any | null }>, ongoingTask: Array<{ __typename?: 'quality_importTask', createdAt: any }> };

export type GetImportConfigQueryVariables = Exact<{
  projectId: Scalars['uuid']['input'];
}>;


export type GetImportConfigQuery = { __typename?: 'query_root', mainColumns: Array<{ __typename?: 'quality_importConfig', serialNumberColumn: string, segmentTypeColumn: string, moldColumn: string, manufactureDateColumn: string }>, extraColumns: Array<{ __typename?: 'quality_importExtraColumn', columnHeader: string, segmentParameter: string }> };

export type GetImportTaskQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetImportTaskQuery = { __typename?: 'query_root', task: Array<{ __typename?: 'quality_importTask', warnings?: any | null }> };

export type ActivityFullFragment = { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean };

export type ActivityTreeFullFragment = { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null }> }> }> };

export type ActivityWithoutHiddenTreeFullFragment = { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null }> }> }> };

export type ActivityInvertedTreeFullFragment = { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean } | null } | null } | null };

export type ActivityMinimalFragment = { __typename?: 'activity', id: any, name: string, key: any, title: string };

export type ActivityExtendedFragment = { __typename?: 'activity', id: any, name: string, hidden: boolean, key: any, title: string };

export type AvailableCustomIndicatorsQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
}>;


export type AvailableCustomIndicatorsQuery = { __typename?: 'query_root', indicator: Array<{ __typename?: 'indicator', id: any, nameEn: string, nameFr: string, nameEs: string, unit: string }> };

export type ActivityMinimalTreeFragment = { __typename?: 'activity', id: any, name: string, hidden: boolean, key: any, title: string, children: Array<{ __typename?: 'activity', id: any, name: string, hidden: boolean, key: any, title: string, children: Array<{ __typename?: 'activity', id: any, name: string, hidden: boolean, key: any, title: string, children: Array<{ __typename?: 'activity', id: any, name: string, hidden: boolean, key: any, title: string }> }> }> };

export type GetTasksAnalyzerMetadataQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
}>;


export type GetTasksAnalyzerMetadataQuery = { __typename?: 'query_root', activity: Array<{ __typename?: 'activity', id: any, name: string, hidden: boolean, key: any, title: string, children: Array<{ __typename?: 'activity', id: any, name: string, hidden: boolean, key: any, title: string, children: Array<{ __typename?: 'activity', id: any, name: string, hidden: boolean, key: any, title: string, children: Array<{ __typename?: 'activity', id: any, name: string, hidden: boolean, key: any, title: string }> }> }> }>, hiddenActivitiesWithTasks: Array<{ __typename?: 'activity', id: any }> };

export type GetProductionAnalyzeSeriesQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
}>;


export type GetProductionAnalyzeSeriesQuery = { __typename?: 'query_root', shift: Array<{ __typename?: 'shift', id: any, name: string }>, team: Array<{ __typename?: 'team', id: any, name: string }> };

export type GetNewReportFieldsQueryVariables = Exact<{
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetNewReportFieldsQuery = { __typename?: 'query_root', shifts: Array<{ __typename?: 'shift', id: any, name: string, constructionSiteId: any, startTime: any, endTime: any }>, recurringTasks: Array<{ __typename?: 'recurringTask', id: any, constructionSiteId: any, activityId: any, duration: number, timeOffset: number, timeOrigin: string, note?: string | null, critical: boolean }>, operators: Array<{ __typename?: 'operator', id: any, name: string }>, shiftLeaders: Array<{ __typename?: 'shiftLeader', id: any, name: string }>, teams: Array<{ __typename?: 'team', id: any, name: string }>, shiftEngineers: Array<{ __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null }>, shiftManagers: Array<{ __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null }> };

export type ShiftReportCheckFragment = { __typename?: 'shiftReport', id: any, operatorValidation: boolean };

export type CheckNewReportQueryVariables = Exact<{
  date?: InputMaybe<Scalars['date']['input']>;
  shiftId: Scalars['uuid']['input'];
  constructionSiteId: Scalars['uuid']['input'];
}>;


export type CheckNewReportQuery = { __typename?: 'query_root', shiftReport: Array<{ __typename?: 'shiftReport', id: any, operatorValidation: boolean }> };

export type StartNewReportMutationVariables = Exact<{
  object: ShiftReport_Insert_Input;
}>;


export type StartNewReportMutation = { __typename?: 'mutation_root', shiftReport?: { __typename?: 'shiftReport', id: any, date: any, operatorId?: any | null, shiftLeaderId?: any | null, shiftEngineerId?: any | null, shiftManagerId?: any | null, startMetricPoint: number, endMetricPoint?: number | null, shiftId: any, constructionSiteId: any } | null };

export type GetShiftProductionTimeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  critical?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetShiftProductionTimeQuery = { __typename?: 'query_root', shiftReportTasksPieChartData?: Array<{ __typename?: 'ShiftReportTasksPieChartData', id: string, activityName: string, activityNameExport: string, activityId: string, total: number }> | null };

export type AggregatedShiftReportFragment = { __typename?: 'ShiftReportAggregatePdfDataReponse', id: string, logo: string, name: string, distanceUnit: string, language: string, distance: number, endMetricPoint: number, endRing: number, startMetricPoint: number, startRing: number, totalRing: number, topLevelTasksAggregate: Array<{ __typename?: 'ShiftReportAggregateTopLevelTask', id: string, name: string, total: number }>, topLevelCriticalTasksAggregate: Array<{ __typename?: 'ShiftReportAggregateTopLevelTask', id: string, name: string, total: number }> };

export type ShiftReportAggregatePdfDataQueryVariables = Exact<{
  constructionSiteId: Scalars['ID']['input'];
  endDate: Scalars['date']['input'];
  groupBy: ShiftReportAggregateGroupByEnum;
  startDate: Scalars['date']['input'];
}>;


export type ShiftReportAggregatePdfDataQuery = { __typename?: 'query_root', shiftReportAggregatePdfData?: { __typename?: 'ShiftReportAggregatePdfDataReponse', id: string, logo: string, name: string, distanceUnit: string, language: string, distance: number, endMetricPoint: number, endRing: number, startMetricPoint: number, startRing: number, totalRing: number, topLevelTasksAggregate: Array<{ __typename?: 'ShiftReportAggregateTopLevelTask', id: string, name: string, total: number }>, topLevelCriticalTasksAggregate: Array<{ __typename?: 'ShiftReportAggregateTopLevelTask', id: string, name: string, total: number }> } | null };

export type GetConstructionSiteByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetConstructionSiteByIdQuery = { __typename?: 'query_root', constructionSite_by_pk?: { __typename?: 'constructionSite', logo: string, name: string, distanceUnit: string, language: string } | null };

export type GetTasksByConstructionSiteInRangeQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
  startDate: Scalars['date']['input'];
  endDate: Scalars['date']['input'];
}>;


export type GetTasksByConstructionSiteInRangeQuery = { __typename?: 'query_root', task: Array<{ __typename?: 'task', id: any, duration?: number | null, critical: boolean, activity: { __typename?: 'activity', id: any, type: string, constructionSiteId: any } }> };

export type GetAggregatedIndicatorResultsQueryVariables = Exact<{
  constructionSiteId: Scalars['String']['input'];
  startDate: Scalars['date']['input'];
  endDate: Scalars['date']['input'];
}>;


export type GetAggregatedIndicatorResultsQuery = { __typename?: 'query_root', calculateAggregatedIndicatorResults?: { __typename?: 'ShiftReportIndicatorsResults', message?: string | null, success: boolean, data?: Array<{ __typename?: 'IndicatorResult', id: string, unit: string, value?: number | null, nameFr: string, nameEn: string, nameEs: string }> | null } | null };

export type GetDailyReportTimelineMetadataQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
  date: Scalars['date']['input'];
}>;


export type GetDailyReportTimelineMetadataQuery = { __typename?: 'query_root', tasks: Array<{ __typename?: 'task', id: any, activityId: any, startDate: any, endDate: any, duration?: number | null, ring: number, note?: string | null, critical: boolean, files: any, ended: boolean, isValidated: boolean, shiftReport: { __typename?: 'shiftReport', id: any, shift: { __typename?: 'shift', id: any, name: string, startTime: any, endTime: any } }, activity: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean } | null } | null } | null } }>, activities: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null }> }> }> }> };

export type GetPreviousReportQueryVariables = Exact<{
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetPreviousReportQuery = { __typename?: 'query_root', shiftReport: Array<{ __typename?: 'shiftReport', id: any, date: any, note?: string | null, startMetricPoint: number, endMetricPoint?: number | null, lastFinishedRing?: number | null, operatorValidation: boolean, managerValidation: boolean, userId: any, userName: string, operator?: { __typename?: 'operator', id: any, name: string } | null, shiftLeader?: { __typename?: 'shiftLeader', id: any, name: string } | null, team?: { __typename?: 'team', id: any, name: string } | null, shiftEngineer?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shiftManager?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shift: { __typename?: 'shift', id: any, name: string }, tasks_aggregate: { __typename?: 'task_aggregate', files?: { __typename?: 'task_aggregate_fields', count: number } | null } }> };

export type ShiftReportAutofillMutationVariables = Exact<{
  shiftReportId: Scalars['ID']['input'];
  startDate: Scalars['date']['input'];
  endDate: Scalars['date']['input'];
}>;


export type ShiftReportAutofillMutation = { __typename?: 'mutation_root', shiftReportAutofill: { __typename?: 'ShiftReportAutofillResponse', success: boolean, count: number, message: string } };

export type ShiftReportAutofillV2MutationVariables = Exact<{
  shiftReportId: Scalars['ID']['input'];
  startDate: Scalars['date']['input'];
  endDate: Scalars['date']['input'];
}>;


export type ShiftReportAutofillV2Mutation = { __typename?: 'mutation_root', shiftReportAutofillV2: { __typename?: 'ShiftReportAutofillV2Response', count: number } };

export type EditEndFieldsReportMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  startMetricPoint?: InputMaybe<Scalars['Float']['input']>;
  endMetricPoint?: InputMaybe<Scalars['Float']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  operatorId?: InputMaybe<Scalars['uuid']['input']>;
  shiftLeaderId?: InputMaybe<Scalars['uuid']['input']>;
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  shiftEngineerId?: InputMaybe<Scalars['uuid']['input']>;
  shiftManagerId?: InputMaybe<Scalars['uuid']['input']>;
  shiftId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type EditEndFieldsReportMutation = { __typename?: 'mutation_root', update_shiftReport_by_pk?: { __typename?: 'shiftReport', id: any } | null };

export type EditEndFieldsReportUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  startMetricPoint?: InputMaybe<Scalars['Float']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  operatorId?: InputMaybe<Scalars['uuid']['input']>;
  shiftLeaderId?: InputMaybe<Scalars['uuid']['input']>;
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  shiftEngineerId?: InputMaybe<Scalars['uuid']['input']>;
  shiftManagerId?: InputMaybe<Scalars['uuid']['input']>;
  shiftId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type EditEndFieldsReportUserMutation = { __typename?: 'mutation_root', update_shiftReport_by_pk?: { __typename?: 'shiftReport', id: any } | null };

export type EditTasksDateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type EditTasksDateMutation = { __typename?: 'mutation_root', update_task_by_pk?: { __typename?: 'task', id: any } | null };

export type ShiftFullFragment = { __typename?: 'shift', id: any, constructionSiteId: any, startTime: any, endTime: any, name: string };

export type TaskFullFragment = { __typename?: 'task', id: any, activityId: any, startDate: any, endDate: any, duration?: number | null, ring: number, note?: string | null, critical: boolean, files: any, ended: boolean, isValidated: boolean, activity: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean } | null } | null } | null } };

export type ShiftReportChartViewFragment = { __typename?: 'shiftReport', operatorValidation: boolean, managerValidation: boolean, note?: string | null, startMetricPoint: number, endMetricPoint?: number | null, lastFinishedRing?: number | null, userId: any, id: any, date: any, userName: string, shift: { __typename?: 'shift', id: any, name: string, constructionSiteId: any, startTime: any, endTime: any }, tasks: Array<{ __typename?: 'task', id: any, activityId: any, startDate: any, endDate: any, duration?: number | null, ring: number, note?: string | null, critical: boolean, files: any, ended: boolean, isValidated: boolean, activity: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean } | null } | null } | null } }>, operator?: { __typename?: 'operator', id: any, name: string } | null, shiftLeader?: { __typename?: 'shiftLeader', id: any, name: string } | null, team?: { __typename?: 'team', id: any, name: string } | null, shiftEngineer?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shiftManager?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, tasks_aggregate: { __typename?: 'task_aggregate', files?: { __typename?: 'task_aggregate_fields', count: number } | null } };

export type GetShiftReportMetadataQueryVariables = Exact<{
  shiftReportId: Scalars['uuid']['input'];
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetShiftReportMetadataQuery = { __typename?: 'query_root', shiftReport?: { __typename?: 'shiftReport', operatorValidation: boolean, managerValidation: boolean, note?: string | null, startMetricPoint: number, endMetricPoint?: number | null, lastFinishedRing?: number | null, userId: any, id: any, date: any, userName: string, constructionSite: { __typename?: 'constructionSite', id: any, name: string, logo: string }, shift: { __typename?: 'shift', id: any, name: string, constructionSiteId: any, startTime: any, endTime: any }, tasks: Array<{ __typename?: 'task', id: any, activityId: any, startDate: any, endDate: any, duration?: number | null, ring: number, note?: string | null, critical: boolean, files: any, ended: boolean, isValidated: boolean, activity: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean } | null } | null } | null } }>, operator?: { __typename?: 'operator', id: any, name: string } | null, shiftLeader?: { __typename?: 'shiftLeader', id: any, name: string } | null, team?: { __typename?: 'team', id: any, name: string } | null, shiftEngineer?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shiftManager?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, tasks_aggregate: { __typename?: 'task_aggregate', files?: { __typename?: 'task_aggregate_fields', count: number } | null } } | null, activities: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null }> }> }> }>, excavationOrBuildActivities: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean }> };

export type ShiftReportNoteUpdateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShiftReportNoteUpdateMutation = { __typename?: 'mutation_root', update_shiftReport_by_pk?: { __typename?: 'shiftReport', id: any, note?: string | null } | null };

export type ManagerReportUpdateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  lastFinishedRing?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ManagerReportUpdateMutation = { __typename?: 'mutation_root', update_shiftReport_by_pk?: { __typename?: 'shiftReport', id: any } | null };

export type InvalidateOperatorValidationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type InvalidateOperatorValidationMutation = { __typename?: 'mutation_root', update_shiftReport_by_pk?: { __typename?: 'shiftReport', id: any } | null };

export type GetPreviousReportTasksQueryVariables = Exact<{
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  shiftReportId?: InputMaybe<Scalars['uuid']['input']>;
  shiftStartTime?: InputMaybe<Scalars['time']['input']>;
}>;


export type GetPreviousReportTasksQuery = { __typename?: 'query_root', shiftReport: Array<{ __typename?: 'shiftReport', id: any, lastFinishedRing?: number | null, tasks: Array<{ __typename?: 'task', id: any, ring: number, ended: boolean }> }> };

export type EndReportMetaFragment = { __typename?: 'shiftReport', id: any, startMetricPoint: number, endMetricPoint?: number | null, lastFinishedRing?: number | null, note?: string | null, operatorValidation: boolean, tasks: Array<{ __typename?: 'task', id: any, ring: number, ended: boolean, activity: { __typename?: 'activity', id: any, type: string } }> };

export type GetEndReportMetaQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEndReportMetaQuery = { __typename?: 'query_root', shiftReport?: { __typename?: 'shiftReport', id: any, startMetricPoint: number, endMetricPoint?: number | null, lastFinishedRing?: number | null, note?: string | null, operatorValidation: boolean, tasks: Array<{ __typename?: 'task', id: any, ring: number, ended: boolean, activity: { __typename?: 'activity', id: any, type: string } }> } | null };

export type FinishReportMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  endMetricPoint?: InputMaybe<Scalars['Float']['input']>;
  lastFinishedRing?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type FinishReportMutation = { __typename?: 'mutation_root', update_shiftReport_by_pk?: { __typename?: 'shiftReport', id: any } | null };

export type FinishReportManagerMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  endMetricPoint?: InputMaybe<Scalars['Float']['input']>;
  lastFinishedRing?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  managerValidation?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FinishReportManagerMutation = { __typename?: 'mutation_root', update_shiftReport_by_pk?: { __typename?: 'shiftReport', id: any } | null };

export type GenerateShiftReportPdfMutationVariables = Exact<{
  id: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type GenerateShiftReportPdfMutation = { __typename?: 'mutation_root', generateShiftReportPdf?: { __typename?: 'FileUrlResponse', success?: boolean | null, url?: string | null } | null };

export type GenerateShiftReportPdfsMutationVariables = Exact<{
  constructionSiteId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type GenerateShiftReportPdfsMutation = { __typename?: 'mutation_root', generateShiftReportPdfs?: { __typename?: 'FileUrlResponse', success?: boolean | null, url?: string | null } | null };

export type GenerateAggregatedPdfMutationVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  constructionSiteId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type GenerateAggregatedPdfMutation = { __typename?: 'mutation_root', generateAggregatedPdf?: { __typename?: 'FileUrlResponse', success?: boolean | null, url?: string | null } | null };

export type GetReportsQueryVariables = Exact<{
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
}>;


export type GetReportsQuery = { __typename?: 'query_root', shiftReport: Array<{ __typename?: 'shiftReport', id: any, date: any, note?: string | null, startMetricPoint: number, endMetricPoint?: number | null, lastFinishedRing?: number | null, operatorValidation: boolean, managerValidation: boolean, userId: any, userName: string, operator?: { __typename?: 'operator', id: any, name: string } | null, shiftLeader?: { __typename?: 'shiftLeader', id: any, name: string } | null, team?: { __typename?: 'team', id: any, name: string } | null, shiftEngineer?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shiftManager?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shift: { __typename?: 'shift', id: any, name: string }, tasks_aggregate: { __typename?: 'task_aggregate', files?: { __typename?: 'task_aggregate_fields', count: number } | null } }>, shiftReportAggregate: { __typename?: 'shiftReport_aggregate', aggregate?: { __typename?: 'shiftReport_aggregate_fields', count: number } | null } };

export type GetReportsBeingEditedQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetReportsBeingEditedQuery = { __typename?: 'query_root', shiftReports: Array<{ __typename?: 'shiftReport', id: any, date: any, note?: string | null, startMetricPoint: number, endMetricPoint?: number | null, lastFinishedRing?: number | null, operatorValidation: boolean, managerValidation: boolean, userId: any, userName: string, operator?: { __typename?: 'operator', id: any, name: string } | null, shiftLeader?: { __typename?: 'shiftLeader', id: any, name: string } | null, team?: { __typename?: 'team', id: any, name: string } | null, shiftEngineer?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shiftManager?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shift: { __typename?: 'shift', id: any, name: string }, tasks_aggregate: { __typename?: 'task_aggregate', files?: { __typename?: 'task_aggregate_fields', count: number } | null } }>, shiftReportAggregate: { __typename?: 'shiftReport_aggregate', aggregate?: { __typename?: 'shiftReport_aggregate_fields', count: number } | null } };

export type GetReportsToReviewQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetReportsToReviewQuery = { __typename?: 'query_root', shiftReports: Array<{ __typename?: 'shiftReport', id: any, date: any, note?: string | null, startMetricPoint: number, endMetricPoint?: number | null, lastFinishedRing?: number | null, operatorValidation: boolean, managerValidation: boolean, userId: any, userName: string, operator?: { __typename?: 'operator', id: any, name: string } | null, shiftLeader?: { __typename?: 'shiftLeader', id: any, name: string } | null, team?: { __typename?: 'team', id: any, name: string } | null, shiftEngineer?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shiftManager?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shift: { __typename?: 'shift', id: any, name: string }, tasks_aggregate: { __typename?: 'task_aggregate', files?: { __typename?: 'task_aggregate_fields', count: number } | null } }>, shiftReportAggregate: { __typename?: 'shiftReport_aggregate', aggregate?: { __typename?: 'shiftReport_aggregate_fields', count: number } | null } };

export type GetManagerReportHistoryQueryVariables = Exact<{
  filter: ShiftReport_Bool_Exp;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetManagerReportHistoryQuery = { __typename?: 'query_root', operators: Array<{ __typename?: 'operator', id: any, name: string }>, shiftLeaders: Array<{ __typename?: 'shiftLeader', id: any, name: string }>, shiftEngineers: Array<{ __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null }>, shiftManagers: Array<{ __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null }>, shift: Array<{ __typename?: 'shift', id: any, name: string }>, team: Array<{ __typename?: 'team', id: any, name: string }>, shiftReports: Array<{ __typename?: 'shiftReport', id: any, date: any, note?: string | null, startMetricPoint: number, endMetricPoint?: number | null, lastFinishedRing?: number | null, operatorValidation: boolean, managerValidation: boolean, userId: any, userName: string, operator?: { __typename?: 'operator', id: any, name: string } | null, shiftLeader?: { __typename?: 'shiftLeader', id: any, name: string } | null, team?: { __typename?: 'team', id: any, name: string } | null, shiftEngineer?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shiftManager?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shift: { __typename?: 'shift', id: any, name: string }, tasks_aggregate: { __typename?: 'task_aggregate', files?: { __typename?: 'task_aggregate_fields', count: number } | null } }>, shiftReportAggregate: { __typename?: 'shiftReport_aggregate', aggregate?: { __typename?: 'shiftReport_aggregate_fields', count: number } | null } };

export type TaskAverageTimeInfosFragment = { __typename?: 'task', id: any, duration?: number | null, ring: number, ended: boolean, activity: { __typename?: 'activity', id: any, type: string } };

export type GetIndicatorResultsQueryVariables = Exact<{
  shiftReportId: Scalars['String']['input'];
  constructionSiteId: Scalars['String']['input'];
}>;


export type GetIndicatorResultsQuery = { __typename?: 'query_root', calculateIndicatorResults?: { __typename?: 'ShiftReportIndicatorsResults', message?: string | null, success: boolean, data?: Array<{ __typename?: 'IndicatorResult', id: string, unit: string, value?: number | null, nameFr: string, nameEn: string, nameEs: string }> | null } | null };

export type GetShiftReportPdfMetadataQueryVariables = Exact<{
  shiftReportId: Scalars['uuid']['input'];
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetShiftReportPdfMetadataQuery = { __typename?: 'query_root', shiftReport?: { __typename?: 'shiftReport', operatorValidation: boolean, managerValidation: boolean, note?: string | null, startMetricPoint: number, endMetricPoint?: number | null, lastFinishedRing?: number | null, userId: any, id: any, date: any, userName: string, constructionSite: { __typename?: 'constructionSite', id: any, name: string, logo: string, distanceUnit: string, language: string }, shift: { __typename?: 'shift', id: any, name: string, constructionSiteId: any, startTime: any, endTime: any }, tasks: Array<{ __typename?: 'task', id: any, activityId: any, startDate: any, endDate: any, duration?: number | null, ring: number, note?: string | null, critical: boolean, files: any, ended: boolean, isValidated: boolean, activity: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean } | null } | null } | null } }>, operator?: { __typename?: 'operator', id: any, name: string } | null, shiftLeader?: { __typename?: 'shiftLeader', id: any, name: string } | null, team?: { __typename?: 'team', id: any, name: string } | null, shiftEngineer?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shiftManager?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, tasks_aggregate: { __typename?: 'task_aggregate', files?: { __typename?: 'task_aggregate_fields', count: number } | null } } | null, activities: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null, children: Array<{ __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string } | null }> }> }> }>, tasksForAverageExcavation: Array<{ __typename?: 'task', id: any, duration?: number | null, ring: number, ended: boolean, activity: { __typename?: 'activity', id: any, type: string } }>, tasksForAverageBuild: Array<{ __typename?: 'task', id: any, duration?: number | null, ring: number, ended: boolean, activity: { __typename?: 'activity', id: any, type: string } }> };

export type GetPreviousPrintReportQueryVariables = Exact<{
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  shiftReportId?: InputMaybe<Scalars['uuid']['input']>;
  shiftStartTime?: InputMaybe<Scalars['time']['input']>;
}>;


export type GetPreviousPrintReportQuery = { __typename?: 'query_root', shiftReport: Array<{ __typename?: 'shiftReport', id: any, lastFinishedRing?: number | null }> };

export type GetPreviousPrintTasksQueryVariables = Exact<{
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
  shiftReportId?: InputMaybe<Scalars['uuid']['input']>;
  firstEndedExcavationRing?: InputMaybe<Scalars['Int']['input']>;
  firstEndedBuildRing?: InputMaybe<Scalars['Int']['input']>;
  withExcavationTasks: Scalars['Boolean']['input'];
  withBuildTasks: Scalars['Boolean']['input'];
}>;


export type GetPreviousPrintTasksQuery = { __typename?: 'query_root', excavationTasks?: Array<{ __typename?: 'task', id: any, duration?: number | null, ring: number, ended: boolean, activity: { __typename?: 'activity', id: any, type: string } }>, buildTasks?: Array<{ __typename?: 'task', id: any, duration?: number | null, ring: number, ended: boolean, activity: { __typename?: 'activity', id: any, type: string } }> };

export type InvalidateManagerValidationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  operatorValidation?: InputMaybe<Scalars['Boolean']['input']>;
  managerValidation?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InvalidateManagerValidationMutation = { __typename?: 'mutation_root', update_shiftReport_by_pk?: { __typename?: 'shiftReport', id: any } | null };

export type ShiftReportCardInfoFragment = { __typename?: 'shiftReport', id: any, date: any, note?: string | null, startMetricPoint: number, endMetricPoint?: number | null, lastFinishedRing?: number | null, operatorValidation: boolean, managerValidation: boolean, userId: any, userName: string, operator?: { __typename?: 'operator', id: any, name: string } | null, shiftLeader?: { __typename?: 'shiftLeader', id: any, name: string } | null, team?: { __typename?: 'team', id: any, name: string } | null, shiftEngineer?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shiftManager?: { __typename?: 'user', id: any, email: string, firstName?: string | null, lastName?: string | null } | null, shift: { __typename?: 'shift', id: any, name: string }, tasks_aggregate: { __typename?: 'task_aggregate', files?: { __typename?: 'task_aggregate_fields', count: number } | null } };

export type DeleteShiftReportMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteShiftReportMutation = { __typename?: 'mutation_root', delete_shiftReport_by_pk?: { __typename?: 'shiftReport', id: any } | null };

export type GetCurrentRingShiftReportQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
}>;


export type GetCurrentRingShiftReportQuery = { __typename?: 'query_root', task: Array<{ __typename?: 'task', id: any, ring: number }> };

export type GenerateTaskExcelExportMutationVariables = Exact<{
  constructionSiteId: Scalars['ID']['input'];
  startDate: Scalars['date']['input'];
  endDate: Scalars['date']['input'];
  locale: Scalars['String']['input'];
}>;


export type GenerateTaskExcelExportMutation = { __typename?: 'mutation_root', generateExcelFromTaskRangeExport: { __typename?: 'FileUrlResponse', url?: string | null, success?: boolean | null } };

export type CreateNewTaskMutationVariables = Exact<{
  object: Task_Insert_Input;
}>;


export type CreateNewTaskMutation = { __typename?: 'mutation_root', task?: { __typename?: 'task', id: any, activityId: any, startDate: any, endDate: any, duration?: number | null, ring: number, note?: string | null, critical: boolean, files: any, ended: boolean, isValidated: boolean, activity: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean } | null } | null } | null } } | null };

export type UpdateExistingTaskMutationVariables = Exact<{
  id: Task_Pk_Columns_Input;
  input?: InputMaybe<Task_Set_Input>;
}>;


export type UpdateExistingTaskMutation = { __typename?: 'mutation_root', task?: { __typename?: 'task', id: any, activityId: any, startDate: any, endDate: any, duration?: number | null, ring: number, note?: string | null, critical: boolean, files: any, ended: boolean, isValidated: boolean, activity: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean } | null } | null } | null } } | null };

export type UpdateAndValidateTasksMutationVariables = Exact<{
  updates: Array<Task_Updates> | Task_Updates;
}>;


export type UpdateAndValidateTasksMutation = { __typename?: 'mutation_root', update_task_many?: Array<{ __typename?: 'task_mutation_response', affected_rows: number } | null> | null };

export type DeleteTaskMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTaskMutation = { __typename?: 'mutation_root', delete_task_by_pk?: { __typename?: 'task', id: any } | null };

export type UpdateTaskFilesMutationVariables = Exact<{
  id: Task_Pk_Columns_Input;
  files?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateTaskFilesMutation = { __typename?: 'mutation_root', task?: { __typename?: 'task', id: any, activityId: any, startDate: any, endDate: any, duration?: number | null, ring: number, note?: string | null, critical: boolean, files: any, ended: boolean, isValidated: boolean, activity: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean } | null } | null } | null } } | null };

export type ExtendPrevTaskMutationVariables = Exact<{
  id: Task_Pk_Columns_Input;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  durationToAdd?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ExtendPrevTaskMutation = { __typename?: 'mutation_root', task?: { __typename?: 'task', id: any, activityId: any, startDate: any, endDate: any, duration?: number | null, ring: number, note?: string | null, critical: boolean, files: any, ended: boolean, isValidated: boolean, activity: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean } | null } | null } | null } } | null };

export type ExtendNextTaskMutationVariables = Exact<{
  id: Task_Pk_Columns_Input;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  durationToAdd?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ExtendNextTaskMutation = { __typename?: 'mutation_root', task?: { __typename?: 'task', id: any, activityId: any, startDate: any, endDate: any, duration?: number | null, ring: number, note?: string | null, critical: boolean, files: any, ended: boolean, isValidated: boolean, activity: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean, parent?: { __typename?: 'activity', id: any, name: string, parentId?: any | null, hidden: boolean, color: string, secondaryColor: string, showRingNumber: boolean, type: string, level?: number | null, order: number, isAlwaysDisplayedInPdfReport?: boolean | null, value: any, label: string, disabled: boolean } | null } | null } | null } } | null };

export type GetTaskFilesUrlsQueryVariables = Exact<{
  fileNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetTaskFilesUrlsQuery = { __typename?: 'query_root', filesUrls?: { __typename?: 'TempUrlsResponse', urls: Array<string>, success?: boolean | null } | null };

export type DeleteNotValidatedTasksMutationVariables = Exact<{
  shiftReportId: Scalars['uuid']['input'];
}>;


export type DeleteNotValidatedTasksMutation = { __typename?: 'mutation_root', delete_task?: { __typename?: 'task_mutation_response', affected_rows: number } | null };

export type GetSteeringDataQueryVariables = Exact<{
  constructionSiteId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Parameter_Ring_Bool_Exp>;
  orderBy?: InputMaybe<Array<Parameter_Ring_Order_By> | Parameter_Ring_Order_By>;
}>;


export type GetSteeringDataQuery = { __typename?: 'query_root', parameter_ring: Array<{ __typename?: 'parameter_ring', id: any, ringNumber: number, keyPosition?: number | null, length?: any | null, buildEndMetricPoint?: any | null, rearHorizontalPosition?: any | null, frontHorizontalPosition?: any | null, cuttingWheelHorizontalPosition?: any | null, rearHorizontalTrend?: any | null, frontHorizontalTrend?: any | null, rearVerticalPosition?: any | null, frontVerticalPosition?: any | null, cuttingWheelVerticalPosition?: any | null, rearVerticalTrend?: any | null, frontVerticalTrend?: any | null, leftSkirtClearance?: any | null, rightSkirtClearance?: any | null, upperSkirtClearance?: any | null, lowerSkirtClearance?: any | null }>, parameter_ring_aggregate: { __typename?: 'parameter_ring_aggregate', aggregate?: { __typename?: 'parameter_ring_aggregate_fields', count: number } | null } };

export type CountShiftReportToValidateQueryVariables = Exact<{
  constructionSiteId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type CountShiftReportToValidateQuery = { __typename?: 'query_root', shiftReportCount: { __typename?: 'shiftReport_aggregate', aggregate?: { __typename?: 'shiftReport_aggregate_fields', count: number } | null } };

export type UserPermissionsFieldsFragment = { __typename?: 'userPermission', id: any, userId: any, module: Module_Enum, permissionType: { __typename?: 'permissionType', id: any, name: string } };

export type ConstructionSiteFieldsFragment = { __typename?: 'constructionSite', id: any, name: string, logo: string, managerValidationRequired: boolean, isManagerRequiredInReport: boolean, isEngineerRequiredInReport: boolean, nbDaysPerWeek: number, timeZone: string, isCompleted: boolean, isAutofillEnabled: boolean, autofillOpcuaEnabled: boolean, autofillApiId?: any | null, aggregatedReportActivityLevel: number, nbTotalRings?: number | null, distanceUnit: string, isArticulated?: boolean | null, ringLengthCode0?: any | null, ringLengthCode1?: any | null, nbKeyPosition?: number | null, keyPositionPrefix?: string | null, tunnelBoringMachineName?: string | null, tolerance: number, isQualityValidatorActivated: boolean, projectId?: any | null, enabledModules?: Array<{ __typename?: 'constructionSiteEnabledModule', id: any, module: Module_Enum }>, userPermissions: Array<{ __typename?: 'userPermission', id: any, userId: any, module: Module_Enum, permissionType: { __typename?: 'permissionType', id: any, name: string } }>, userQualityRoles: Array<{ __typename?: 'quality_userQualityRole', id: any, reportEditor: boolean, repairEditor: boolean, ringComplianceEditor: boolean }> };

export type CommonUserFieldsFragment = { __typename?: 'user', id: any, authId?: string | null, firstName?: string | null, lastName?: string | null, email: string, isActive: boolean, createdAt: any, updatedAt: any, roles: any };

export type QueryMyUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type QueryMyUserQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: any, authId?: string | null, firstName?: string | null, lastName?: string | null, email: string, isActive: boolean, createdAt: any, updatedAt: any, roles: any }> };

export type ConstructionSiteListQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  isDataManager: Scalars['Boolean']['input'];
}>;


export type ConstructionSiteListQuery = { __typename?: 'query_root', constructionSiteList: Array<{ __typename?: 'constructionSite', id: any, name: string, logo: string, managerValidationRequired: boolean, isManagerRequiredInReport: boolean, isEngineerRequiredInReport: boolean, nbDaysPerWeek: number, timeZone: string, isCompleted: boolean, isAutofillEnabled: boolean, autofillOpcuaEnabled: boolean, autofillApiId?: any | null, aggregatedReportActivityLevel: number, nbTotalRings?: number | null, distanceUnit: string, isArticulated?: boolean | null, ringLengthCode0?: any | null, ringLengthCode1?: any | null, nbKeyPosition?: number | null, keyPositionPrefix?: string | null, tunnelBoringMachineName?: string | null, tolerance: number, isQualityValidatorActivated: boolean, projectId?: any | null, enabledModules?: Array<{ __typename?: 'constructionSiteEnabledModule', id: any, module: Module_Enum }>, userPermissions: Array<{ __typename?: 'userPermission', id: any, userId: any, module: Module_Enum, permissionType: { __typename?: 'permissionType', id: any, name: string } }>, userQualityRoles: Array<{ __typename?: 'quality_userQualityRole', id: any, reportEditor: boolean, repairEditor: boolean, ringComplianceEditor: boolean }> }> };

export type UpdateUserAuthIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpdateUserAuthIdMutation = { __typename?: 'mutation_root', update_user?: { __typename?: 'user_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user', id: any, authId?: string | null, firstName?: string | null, lastName?: string | null, email: string, isActive: boolean, createdAt: any, updatedAt: any, roles: any }> } | null };

export type CreatePrivateUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  folderName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePrivateUploadUrlMutation = { __typename?: 'mutation_root', createFileUploadTempUrl?: { __typename?: 'TempUrlResponse', fileName?: string | null, url?: string | null } | null };

export type CreatePrivateDeleteUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type CreatePrivateDeleteUrlMutation = { __typename?: 'mutation_root', createFileDeleteTempUrl?: { __typename?: 'TempUrlResponse', url?: string | null } | null };

export type CreatePublicUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  folderName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePublicUploadUrlMutation = { __typename?: 'mutation_root', createPublicFileUploadTempUrl?: { __typename?: 'TempUrlResponse', fileName?: string | null, url?: string | null } | null };

export type CreatePublicDeleteUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;


export type CreatePublicDeleteUrlMutation = { __typename?: 'mutation_root', createPublicFileDeleteTempUrl?: { __typename?: 'TempUrlResponse', url?: string | null } | null };

export const ParameterDefFragmentDoc = gql`
    fragment ParameterDef on parameter_parameterDef {
  id
  name: displayName
  unit: displayUnit
}
    `;
export const ActivityFullFragmentDoc = gql`
    fragment ActivityFull on activity {
  id
  name
  parentId
  hidden
  color
  secondaryColor
  showRingNumber
  type
  level
  order
  value: id
  label: name
  disabled: hidden
  isAlwaysDisplayedInPdfReport
}
    `;
export const ActivityTreeFullFragmentDoc = gql`
    fragment ActivityTreeFull on activity {
  ...ActivityFull
  parent {
    id
    name
  }
  children: child(order_by: {order: asc}) {
    ...ActivityFull
    parent {
      id
      name
    }
    children: child(order_by: {order: asc}) {
      parent {
        id
        name
      }
      ...ActivityFull
      children: child(order_by: {order: asc}) {
        parent {
          id
          name
        }
        ...ActivityFull
      }
    }
  }
}
    ${ActivityFullFragmentDoc}`;
export const ActivityWithoutHiddenTreeFullFragmentDoc = gql`
    fragment ActivityWithoutHiddenTreeFull on activity {
  ...ActivityFull
  parent {
    id
    name
  }
  children: child(where: {hidden: {_eq: false}}, order_by: {order: asc}) {
    ...ActivityFull
    parent {
      id
      name
    }
    children: child(where: {hidden: {_eq: false}}, order_by: {order: asc}) {
      parent {
        id
        name
      }
      ...ActivityFull
      children: child(where: {hidden: {_eq: false}}, order_by: {order: asc}) {
        parent {
          id
          name
        }
        ...ActivityFull
      }
    }
  }
}
    ${ActivityFullFragmentDoc}`;
export const ActivityMinimalFragmentDoc = gql`
    fragment ActivityMinimal on activity {
  id
  name
  key: id
  title: name
}
    `;
export const ActivityExtendedFragmentDoc = gql`
    fragment ActivityExtended on activity {
  id
  name
  key: id
  title: name
  hidden
}
    `;
export const ActivityMinimalTreeFragmentDoc = gql`
    fragment ActivityMinimalTree on activity {
  ...ActivityExtended
  children: child(order_by: {order: asc}) {
    ...ActivityExtended
    children: child(order_by: {order: asc}) {
      ...ActivityExtended
      children: child(order_by: {order: asc}) {
        ...ActivityExtended
      }
    }
  }
}
    ${ActivityExtendedFragmentDoc}`;
export const ShiftReportCheckFragmentDoc = gql`
    fragment ShiftReportCheck on shiftReport {
  id
  operatorValidation
}
    `;
export const AggregatedShiftReportFragmentDoc = gql`
    fragment aggregatedShiftReport on ShiftReportAggregatePdfDataReponse {
  id
  logo
  name
  distanceUnit
  language
  distance
  endMetricPoint
  endRing
  startMetricPoint
  startRing
  totalRing
  topLevelTasksAggregate {
    id
    name
    total
  }
  topLevelCriticalTasksAggregate {
    id
    name
    total
  }
}
    `;
export const ShiftReportCardInfoFragmentDoc = gql`
    fragment ShiftReportCardInfo on shiftReport {
  id
  operator {
    id
    name
  }
  shiftLeader {
    id
    name
  }
  team {
    id
    name
  }
  shiftEngineer {
    id
    email
    firstName
    lastName
  }
  shiftManager {
    id
    email
    firstName
    lastName
  }
  shift {
    id
    name
  }
  tasks_aggregate(where: {files: {_neq: []}}) {
    files: aggregate {
      count(columns: files)
    }
  }
  date
  note
  startMetricPoint
  endMetricPoint
  lastFinishedRing
  operatorValidation
  managerValidation
  userId
  userName
}
    `;
export const ShiftFullFragmentDoc = gql`
    fragment ShiftFull on shift {
  id
  constructionSiteId
  startTime
  endTime
  name
}
    `;
export const ActivityInvertedTreeFullFragmentDoc = gql`
    fragment ActivityInvertedTreeFull on activity {
  ...ActivityFull
  parent {
    ...ActivityFull
    parent {
      ...ActivityFull
      parent {
        ...ActivityFull
      }
    }
  }
}
    ${ActivityFullFragmentDoc}`;
export const TaskFullFragmentDoc = gql`
    fragment TaskFull on task {
  id
  activityId
  activity {
    ...ActivityInvertedTreeFull
  }
  startDate
  endDate
  duration
  ring
  note
  critical
  files
  ended
  isValidated
}
    ${ActivityInvertedTreeFullFragmentDoc}`;
export const ShiftReportChartViewFragmentDoc = gql`
    fragment ShiftReportChartView on shiftReport {
  ...ShiftReportCardInfo
  operatorValidation
  managerValidation
  shift {
    ...ShiftFull
  }
  tasks(order_by: {startDate: asc}) {
    ...TaskFull
  }
  note
  startMetricPoint
  endMetricPoint
  lastFinishedRing
  userId
}
    ${ShiftReportCardInfoFragmentDoc}
${ShiftFullFragmentDoc}
${TaskFullFragmentDoc}`;
export const EndReportMetaFragmentDoc = gql`
    fragment EndReportMeta on shiftReport {
  id
  startMetricPoint
  endMetricPoint
  lastFinishedRing
  note
  operatorValidation
  tasks(order_by: {ring: desc}) {
    id
    ring
    ended
    activity {
      id
      type
    }
  }
}
    `;
export const TaskAverageTimeInfosFragmentDoc = gql`
    fragment TaskAverageTimeInfos on task {
  id
  activity {
    id
    type
  }
  duration
  ring
  ended
}
    `;
export const UserPermissionsFieldsFragmentDoc = gql`
    fragment UserPermissionsFields on userPermission {
  id
  userId
  module
  permissionType {
    id
    name
  }
}
    `;
export const ConstructionSiteFieldsFragmentDoc = gql`
    fragment ConstructionSiteFields on constructionSite {
  id
  name
  logo
  managerValidationRequired
  isManagerRequiredInReport
  isEngineerRequiredInReport
  nbDaysPerWeek
  timeZone
  isCompleted
  isAutofillEnabled
  autofillOpcuaEnabled
  autofillApiId
  aggregatedReportActivityLevel
  nbTotalRings
  distanceUnit
  isArticulated
  ringLengthCode0
  ringLengthCode1
  nbKeyPosition
  keyPositionPrefix
  tunnelBoringMachineName
  tolerance
  enabledModules @include(if: $isDataManager) {
    id
    module
  }
  userPermissions(
    where: {userId: {_eq: $userId}, permissionType: {name: {_in: ["construction-site-manager", "construction-site-full-reader", "construction-site-reader", "user"]}}}
  ) {
    ...UserPermissionsFields
  }
  isQualityValidatorActivated
  userQualityRoles(where: {userId: {_eq: $userId}}) {
    id
    reportEditor
    repairEditor
    ringComplianceEditor
  }
  projectId
}
    ${UserPermissionsFieldsFragmentDoc}`;
export const CommonUserFieldsFragmentDoc = gql`
    fragment CommonUserFields on user {
  id
  authId
  firstName
  lastName
  email
  isActive
  createdAt
  updatedAt
  roles
}
    `;
export const GetHighestMetricPointDocument = gql`
    query GetHighestMetricPoint($constructionSiteId: uuid_comparison_exp!, $productionDay: date_comparison_exp!) {
  parameter_ringWithProductionDay_aggregate(
    where: {_and: {productionDate: $productionDay, constructionSiteId: $constructionSiteId}}
  ) {
    aggregate {
      max {
        buildEndMetricPoint
      }
    }
  }
}
    `;

/**
 * __useGetHighestMetricPointQuery__
 *
 * To run a query within a React component, call `useGetHighestMetricPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHighestMetricPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHighestMetricPointQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      productionDay: // value for 'productionDay'
 *   },
 * });
 */
export function useGetHighestMetricPointQuery(baseOptions: Apollo.QueryHookOptions<GetHighestMetricPointQuery, GetHighestMetricPointQueryVariables> & ({ variables: GetHighestMetricPointQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHighestMetricPointQuery, GetHighestMetricPointQueryVariables>(GetHighestMetricPointDocument, options);
      }
export function useGetHighestMetricPointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHighestMetricPointQuery, GetHighestMetricPointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHighestMetricPointQuery, GetHighestMetricPointQueryVariables>(GetHighestMetricPointDocument, options);
        }
export function useGetHighestMetricPointSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHighestMetricPointQuery, GetHighestMetricPointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHighestMetricPointQuery, GetHighestMetricPointQueryVariables>(GetHighestMetricPointDocument, options);
        }
export type GetHighestMetricPointQueryHookResult = ReturnType<typeof useGetHighestMetricPointQuery>;
export type GetHighestMetricPointLazyQueryHookResult = ReturnType<typeof useGetHighestMetricPointLazyQuery>;
export type GetHighestMetricPointSuspenseQueryHookResult = ReturnType<typeof useGetHighestMetricPointSuspenseQuery>;
export type GetHighestMetricPointQueryResult = Apollo.QueryResult<GetHighestMetricPointQuery, GetHighestMetricPointQueryVariables>;
export const GetTbmInfosDocument = gql`
    query GetTbmInfos($constructionSiteId: uuid!, $compareDate: timestamptz!) {
  constructionSite(where: {id: {_eq: $constructionSiteId}}) {
    id
    timeZone
    nbTotalRings
    nbTotalMeters
    isCompleted
    mapConfiguration {
      id
      latitude
      longitude
      zoom
      traceColor
    }
    metrics_aggregate(
      where: {_and: {batchDate: {_gte: $compareDate}, isBuilding: {_is_null: false}, isExcavating: {_is_null: false}}}
      limit: 1
      order_by: {batchDate: desc}
    ) {
      nodes {
        id
        isBuilding
        isExcavating
      }
    }
    mapTraces(order_by: {mp: asc}) {
      id
      mp
      latitude
      longitude
    }
    rings(limit: 1, order_by: {batchDate: desc}) {
      id
      buildEndMetricPoint
      ringNumber
    }
    mapPois {
      id
      name
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetTbmInfosQuery__
 *
 * To run a query within a React component, call `useGetTbmInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTbmInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTbmInfosQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      compareDate: // value for 'compareDate'
 *   },
 * });
 */
export function useGetTbmInfosQuery(baseOptions: Apollo.QueryHookOptions<GetTbmInfosQuery, GetTbmInfosQueryVariables> & ({ variables: GetTbmInfosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTbmInfosQuery, GetTbmInfosQueryVariables>(GetTbmInfosDocument, options);
      }
export function useGetTbmInfosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTbmInfosQuery, GetTbmInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTbmInfosQuery, GetTbmInfosQueryVariables>(GetTbmInfosDocument, options);
        }
export function useGetTbmInfosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTbmInfosQuery, GetTbmInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTbmInfosQuery, GetTbmInfosQueryVariables>(GetTbmInfosDocument, options);
        }
export type GetTbmInfosQueryHookResult = ReturnType<typeof useGetTbmInfosQuery>;
export type GetTbmInfosLazyQueryHookResult = ReturnType<typeof useGetTbmInfosLazyQuery>;
export type GetTbmInfosSuspenseQueryHookResult = ReturnType<typeof useGetTbmInfosSuspenseQuery>;
export type GetTbmInfosQueryResult = Apollo.QueryResult<GetTbmInfosQuery, GetTbmInfosQueryVariables>;
export const GetTbmLastMetricDocument = gql`
    query GetTbmLastMetric($constructionSiteId: uuid!, $compareDate: timestamptz!) {
  parameter_metric_aggregate(
    where: {constructionSiteId: {_eq: $constructionSiteId}, batchDate: {_gte: $compareDate}}
  ) {
    aggregate {
      max {
        batchDate
      }
    }
  }
}
    `;

/**
 * __useGetTbmLastMetricQuery__
 *
 * To run a query within a React component, call `useGetTbmLastMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTbmLastMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTbmLastMetricQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      compareDate: // value for 'compareDate'
 *   },
 * });
 */
export function useGetTbmLastMetricQuery(baseOptions: Apollo.QueryHookOptions<GetTbmLastMetricQuery, GetTbmLastMetricQueryVariables> & ({ variables: GetTbmLastMetricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTbmLastMetricQuery, GetTbmLastMetricQueryVariables>(GetTbmLastMetricDocument, options);
      }
export function useGetTbmLastMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTbmLastMetricQuery, GetTbmLastMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTbmLastMetricQuery, GetTbmLastMetricQueryVariables>(GetTbmLastMetricDocument, options);
        }
export function useGetTbmLastMetricSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTbmLastMetricQuery, GetTbmLastMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTbmLastMetricQuery, GetTbmLastMetricQueryVariables>(GetTbmLastMetricDocument, options);
        }
export type GetTbmLastMetricQueryHookResult = ReturnType<typeof useGetTbmLastMetricQuery>;
export type GetTbmLastMetricLazyQueryHookResult = ReturnType<typeof useGetTbmLastMetricLazyQuery>;
export type GetTbmLastMetricSuspenseQueryHookResult = ReturnType<typeof useGetTbmLastMetricSuspenseQuery>;
export type GetTbmLastMetricQueryResult = Apollo.QueryResult<GetTbmLastMetricQuery, GetTbmLastMetricQueryVariables>;
export const ParameterFamiliesDocument = gql`
    query ParameterFamilies($constructionSiteId: uuid!) {
  parameter_familyDef(
    where: {constructionSite: {id: {_eq: $constructionSiteId}}, isHidden: {_eq: false}}
    order_by: {displayName: asc}
  ) {
    id
    name: displayName
    parameterDefs(where: {isHidden: {_eq: false}}, order_by: {displayName: asc}) {
      ...ParameterDef
    }
  }
}
    ${ParameterDefFragmentDoc}`;

/**
 * __useParameterFamiliesQuery__
 *
 * To run a query within a React component, call `useParameterFamiliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useParameterFamiliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParameterFamiliesQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useParameterFamiliesQuery(baseOptions: Apollo.QueryHookOptions<ParameterFamiliesQuery, ParameterFamiliesQueryVariables> & ({ variables: ParameterFamiliesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParameterFamiliesQuery, ParameterFamiliesQueryVariables>(ParameterFamiliesDocument, options);
      }
export function useParameterFamiliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParameterFamiliesQuery, ParameterFamiliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParameterFamiliesQuery, ParameterFamiliesQueryVariables>(ParameterFamiliesDocument, options);
        }
export function useParameterFamiliesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ParameterFamiliesQuery, ParameterFamiliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ParameterFamiliesQuery, ParameterFamiliesQueryVariables>(ParameterFamiliesDocument, options);
        }
export type ParameterFamiliesQueryHookResult = ReturnType<typeof useParameterFamiliesQuery>;
export type ParameterFamiliesLazyQueryHookResult = ReturnType<typeof useParameterFamiliesLazyQuery>;
export type ParameterFamiliesSuspenseQueryHookResult = ReturnType<typeof useParameterFamiliesSuspenseQuery>;
export type ParameterFamiliesQueryResult = Apollo.QueryResult<ParameterFamiliesQuery, ParameterFamiliesQueryVariables>;
export const GetSavedGraphCountDocument = gql`
    query GetSavedGraphCount($constructionSiteId: uuid!, $userId: uuid!, $type: graphSetTypeEnum_enum!) {
  graphSet_aggregate(
    where: {userId: {_eq: $userId}, constructionSiteId: {_eq: $constructionSiteId}, type: {_eq: $type}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetSavedGraphCountQuery__
 *
 * To run a query within a React component, call `useGetSavedGraphCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedGraphCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedGraphCountQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      userId: // value for 'userId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetSavedGraphCountQuery(baseOptions: Apollo.QueryHookOptions<GetSavedGraphCountQuery, GetSavedGraphCountQueryVariables> & ({ variables: GetSavedGraphCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedGraphCountQuery, GetSavedGraphCountQueryVariables>(GetSavedGraphCountDocument, options);
      }
export function useGetSavedGraphCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedGraphCountQuery, GetSavedGraphCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedGraphCountQuery, GetSavedGraphCountQueryVariables>(GetSavedGraphCountDocument, options);
        }
export function useGetSavedGraphCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSavedGraphCountQuery, GetSavedGraphCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSavedGraphCountQuery, GetSavedGraphCountQueryVariables>(GetSavedGraphCountDocument, options);
        }
export type GetSavedGraphCountQueryHookResult = ReturnType<typeof useGetSavedGraphCountQuery>;
export type GetSavedGraphCountLazyQueryHookResult = ReturnType<typeof useGetSavedGraphCountLazyQuery>;
export type GetSavedGraphCountSuspenseQueryHookResult = ReturnType<typeof useGetSavedGraphCountSuspenseQuery>;
export type GetSavedGraphCountQueryResult = Apollo.QueryResult<GetSavedGraphCountQuery, GetSavedGraphCountQueryVariables>;
export const GetGraphSetListDocument = gql`
    query GetGraphSetList($constructionSiteId: uuid!, $userId: uuid!, $type: graphSetTypeEnum_enum!) {
  graphSet(
    where: {userId: {_eq: $userId}, constructionSiteId: {_eq: $constructionSiteId}, type: {_eq: $type}}
    order_by: {title: asc}
  ) {
    id
    title
    type
    version
  }
}
    `;

/**
 * __useGetGraphSetListQuery__
 *
 * To run a query within a React component, call `useGetGraphSetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphSetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphSetListQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      userId: // value for 'userId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetGraphSetListQuery(baseOptions: Apollo.QueryHookOptions<GetGraphSetListQuery, GetGraphSetListQueryVariables> & ({ variables: GetGraphSetListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphSetListQuery, GetGraphSetListQueryVariables>(GetGraphSetListDocument, options);
      }
export function useGetGraphSetListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphSetListQuery, GetGraphSetListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphSetListQuery, GetGraphSetListQueryVariables>(GetGraphSetListDocument, options);
        }
export function useGetGraphSetListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGraphSetListQuery, GetGraphSetListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGraphSetListQuery, GetGraphSetListQueryVariables>(GetGraphSetListDocument, options);
        }
export type GetGraphSetListQueryHookResult = ReturnType<typeof useGetGraphSetListQuery>;
export type GetGraphSetListLazyQueryHookResult = ReturnType<typeof useGetGraphSetListLazyQuery>;
export type GetGraphSetListSuspenseQueryHookResult = ReturnType<typeof useGetGraphSetListSuspenseQuery>;
export type GetGraphSetListQueryResult = Apollo.QueryResult<GetGraphSetListQuery, GetGraphSetListQueryVariables>;
export const GetGraphSetDocument = gql`
    query GetGraphSet($id: uuid!) {
  graphSet_by_pk(id: $id) {
    id
    title
    type
    graphs
  }
}
    `;

/**
 * __useGetGraphSetQuery__
 *
 * To run a query within a React component, call `useGetGraphSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGraphSetQuery(baseOptions: Apollo.QueryHookOptions<GetGraphSetQuery, GetGraphSetQueryVariables> & ({ variables: GetGraphSetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphSetQuery, GetGraphSetQueryVariables>(GetGraphSetDocument, options);
      }
export function useGetGraphSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphSetQuery, GetGraphSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphSetQuery, GetGraphSetQueryVariables>(GetGraphSetDocument, options);
        }
export function useGetGraphSetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGraphSetQuery, GetGraphSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGraphSetQuery, GetGraphSetQueryVariables>(GetGraphSetDocument, options);
        }
export type GetGraphSetQueryHookResult = ReturnType<typeof useGetGraphSetQuery>;
export type GetGraphSetLazyQueryHookResult = ReturnType<typeof useGetGraphSetLazyQuery>;
export type GetGraphSetSuspenseQueryHookResult = ReturnType<typeof useGetGraphSetSuspenseQuery>;
export type GetGraphSetQueryResult = Apollo.QueryResult<GetGraphSetQuery, GetGraphSetQueryVariables>;
export const DeleteSavedGraphSetDocument = gql`
    mutation DeleteSavedGraphSet($id: uuid!) {
  delete_graphSet_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteSavedGraphSetMutationFn = Apollo.MutationFunction<DeleteSavedGraphSetMutation, DeleteSavedGraphSetMutationVariables>;

/**
 * __useDeleteSavedGraphSetMutation__
 *
 * To run a mutation, you first call `useDeleteSavedGraphSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedGraphSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedGraphSetMutation, { data, loading, error }] = useDeleteSavedGraphSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSavedGraphSetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSavedGraphSetMutation, DeleteSavedGraphSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSavedGraphSetMutation, DeleteSavedGraphSetMutationVariables>(DeleteSavedGraphSetDocument, options);
      }
export type DeleteSavedGraphSetMutationHookResult = ReturnType<typeof useDeleteSavedGraphSetMutation>;
export type DeleteSavedGraphSetMutationResult = Apollo.MutationResult<DeleteSavedGraphSetMutation>;
export type DeleteSavedGraphSetMutationOptions = Apollo.BaseMutationOptions<DeleteSavedGraphSetMutation, DeleteSavedGraphSetMutationVariables>;
export const GetCurrentRingDocument = gql`
    query GetCurrentRing($constructionSiteId: uuid!) {
  parameter_ring_aggregate(
    where: {constructionSiteId: {_eq: $constructionSiteId}}
  ) {
    aggregate {
      max {
        ringNumber
      }
    }
  }
}
    `;

/**
 * __useGetCurrentRingQuery__
 *
 * To run a query within a React component, call `useGetCurrentRingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentRingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentRingQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetCurrentRingQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentRingQuery, GetCurrentRingQueryVariables> & ({ variables: GetCurrentRingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentRingQuery, GetCurrentRingQueryVariables>(GetCurrentRingDocument, options);
      }
export function useGetCurrentRingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentRingQuery, GetCurrentRingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentRingQuery, GetCurrentRingQueryVariables>(GetCurrentRingDocument, options);
        }
export function useGetCurrentRingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentRingQuery, GetCurrentRingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentRingQuery, GetCurrentRingQueryVariables>(GetCurrentRingDocument, options);
        }
export type GetCurrentRingQueryHookResult = ReturnType<typeof useGetCurrentRingQuery>;
export type GetCurrentRingLazyQueryHookResult = ReturnType<typeof useGetCurrentRingLazyQuery>;
export type GetCurrentRingSuspenseQueryHookResult = ReturnType<typeof useGetCurrentRingSuspenseQuery>;
export type GetCurrentRingQueryResult = Apollo.QueryResult<GetCurrentRingQuery, GetCurrentRingQueryVariables>;
export const GetShiftReportNameDocument = gql`
    query GetShiftReportName($id: uuid!) {
  shiftReport: shiftReport_by_pk(id: $id) {
    id
    constructionSiteId
  }
}
    `;

/**
 * __useGetShiftReportNameQuery__
 *
 * To run a query within a React component, call `useGetShiftReportNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftReportNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftReportNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShiftReportNameQuery(baseOptions: Apollo.QueryHookOptions<GetShiftReportNameQuery, GetShiftReportNameQueryVariables> & ({ variables: GetShiftReportNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShiftReportNameQuery, GetShiftReportNameQueryVariables>(GetShiftReportNameDocument, options);
      }
export function useGetShiftReportNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShiftReportNameQuery, GetShiftReportNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShiftReportNameQuery, GetShiftReportNameQueryVariables>(GetShiftReportNameDocument, options);
        }
export function useGetShiftReportNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShiftReportNameQuery, GetShiftReportNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShiftReportNameQuery, GetShiftReportNameQueryVariables>(GetShiftReportNameDocument, options);
        }
export type GetShiftReportNameQueryHookResult = ReturnType<typeof useGetShiftReportNameQuery>;
export type GetShiftReportNameLazyQueryHookResult = ReturnType<typeof useGetShiftReportNameLazyQuery>;
export type GetShiftReportNameSuspenseQueryHookResult = ReturnType<typeof useGetShiftReportNameSuspenseQuery>;
export type GetShiftReportNameQueryResult = Apollo.QueryResult<GetShiftReportNameQuery, GetShiftReportNameQueryVariables>;
export const GetRingConstructionSiteDocument = gql`
    query GetRingConstructionSite($ringId: uuid!) {
  parameter_ring_by_pk(id: $ringId) {
    id
    constructionSiteId
  }
}
    `;

/**
 * __useGetRingConstructionSiteQuery__
 *
 * To run a query within a React component, call `useGetRingConstructionSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRingConstructionSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRingConstructionSiteQuery({
 *   variables: {
 *      ringId: // value for 'ringId'
 *   },
 * });
 */
export function useGetRingConstructionSiteQuery(baseOptions: Apollo.QueryHookOptions<GetRingConstructionSiteQuery, GetRingConstructionSiteQueryVariables> & ({ variables: GetRingConstructionSiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRingConstructionSiteQuery, GetRingConstructionSiteQueryVariables>(GetRingConstructionSiteDocument, options);
      }
export function useGetRingConstructionSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRingConstructionSiteQuery, GetRingConstructionSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRingConstructionSiteQuery, GetRingConstructionSiteQueryVariables>(GetRingConstructionSiteDocument, options);
        }
export function useGetRingConstructionSiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRingConstructionSiteQuery, GetRingConstructionSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRingConstructionSiteQuery, GetRingConstructionSiteQueryVariables>(GetRingConstructionSiteDocument, options);
        }
export type GetRingConstructionSiteQueryHookResult = ReturnType<typeof useGetRingConstructionSiteQuery>;
export type GetRingConstructionSiteLazyQueryHookResult = ReturnType<typeof useGetRingConstructionSiteLazyQuery>;
export type GetRingConstructionSiteSuspenseQueryHookResult = ReturnType<typeof useGetRingConstructionSiteSuspenseQuery>;
export type GetRingConstructionSiteQueryResult = Apollo.QueryResult<GetRingConstructionSiteQuery, GetRingConstructionSiteQueryVariables>;
export const UpdateParameterRingDocument = gql`
    mutation UpdateParameterRing($id: uuid!, $updatedFields: parameter_ring_set_input!) {
  update_parameter_ring_by_pk(pk_columns: {id: $id}, _set: $updatedFields) {
    id
    __typename
  }
}
    `;
export type UpdateParameterRingMutationFn = Apollo.MutationFunction<UpdateParameterRingMutation, UpdateParameterRingMutationVariables>;

/**
 * __useUpdateParameterRingMutation__
 *
 * To run a mutation, you first call `useUpdateParameterRingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParameterRingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParameterRingMutation, { data, loading, error }] = useUpdateParameterRingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updatedFields: // value for 'updatedFields'
 *   },
 * });
 */
export function useUpdateParameterRingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParameterRingMutation, UpdateParameterRingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParameterRingMutation, UpdateParameterRingMutationVariables>(UpdateParameterRingDocument, options);
      }
export type UpdateParameterRingMutationHookResult = ReturnType<typeof useUpdateParameterRingMutation>;
export type UpdateParameterRingMutationResult = Apollo.MutationResult<UpdateParameterRingMutation>;
export type UpdateParameterRingMutationOptions = Apollo.BaseMutationOptions<UpdateParameterRingMutation, UpdateParameterRingMutationVariables>;
export const GetRingsDocument = gql`
    query GetRings($constructionSiteId: uuid!, $limit: Int, $offset: Int, $filters: parameter_ring_bool_exp = {}, $orderBy: [parameter_ring_order_by!] = {ringNumber: desc}) {
  parameter_ring(
    where: {_and: [{constructionSiteId: {_eq: $constructionSiteId}}, $filters]}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    id
    ringNumber
    keyPosition
    length
    buildEndMetricPoint
    excavationStart
    excavationEnd
    totalExcavationDuration
    realExcavationDuration
    buildStart
    buildEnd
    totalBuildDuration
    realBuildDuration
  }
  parameter_ring_aggregate(
    where: {_and: [{constructionSiteId: {_eq: $constructionSiteId}}, $filters]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetRingsQuery__
 *
 * To run a query within a React component, call `useGetRingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRingsQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetRingsQuery(baseOptions: Apollo.QueryHookOptions<GetRingsQuery, GetRingsQueryVariables> & ({ variables: GetRingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRingsQuery, GetRingsQueryVariables>(GetRingsDocument, options);
      }
export function useGetRingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRingsQuery, GetRingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRingsQuery, GetRingsQueryVariables>(GetRingsDocument, options);
        }
export function useGetRingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRingsQuery, GetRingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRingsQuery, GetRingsQueryVariables>(GetRingsDocument, options);
        }
export type GetRingsQueryHookResult = ReturnType<typeof useGetRingsQuery>;
export type GetRingsLazyQueryHookResult = ReturnType<typeof useGetRingsLazyQuery>;
export type GetRingsSuspenseQueryHookResult = ReturnType<typeof useGetRingsSuspenseQuery>;
export type GetRingsQueryResult = Apollo.QueryResult<GetRingsQuery, GetRingsQueryVariables>;
export const DeleteProjectionDocument = gql`
    mutation DeleteProjection($constructionSiteId: uuid!) {
  delete_parameter_ringProjection(
    where: {constructionSiteId: {_eq: $constructionSiteId}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteProjectionMutationFn = Apollo.MutationFunction<DeleteProjectionMutation, DeleteProjectionMutationVariables>;

/**
 * __useDeleteProjectionMutation__
 *
 * To run a mutation, you first call `useDeleteProjectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectionMutation, { data, loading, error }] = useDeleteProjectionMutation({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useDeleteProjectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectionMutation, DeleteProjectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectionMutation, DeleteProjectionMutationVariables>(DeleteProjectionDocument, options);
      }
export type DeleteProjectionMutationHookResult = ReturnType<typeof useDeleteProjectionMutation>;
export type DeleteProjectionMutationResult = Apollo.MutationResult<DeleteProjectionMutation>;
export type DeleteProjectionMutationOptions = Apollo.BaseMutationOptions<DeleteProjectionMutation, DeleteProjectionMutationVariables>;
export const GetRingProjectionCountDocument = gql`
    query GetRingProjectionCount($constructionSiteId: uuid!) {
  ringProjection: parameter_ringProjection_aggregate(
    where: {constructionSiteId: {_eq: $constructionSiteId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetRingProjectionCountQuery__
 *
 * To run a query within a React component, call `useGetRingProjectionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRingProjectionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRingProjectionCountQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetRingProjectionCountQuery(baseOptions: Apollo.QueryHookOptions<GetRingProjectionCountQuery, GetRingProjectionCountQueryVariables> & ({ variables: GetRingProjectionCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRingProjectionCountQuery, GetRingProjectionCountQueryVariables>(GetRingProjectionCountDocument, options);
      }
export function useGetRingProjectionCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRingProjectionCountQuery, GetRingProjectionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRingProjectionCountQuery, GetRingProjectionCountQueryVariables>(GetRingProjectionCountDocument, options);
        }
export function useGetRingProjectionCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRingProjectionCountQuery, GetRingProjectionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRingProjectionCountQuery, GetRingProjectionCountQueryVariables>(GetRingProjectionCountDocument, options);
        }
export type GetRingProjectionCountQueryHookResult = ReturnType<typeof useGetRingProjectionCountQuery>;
export type GetRingProjectionCountLazyQueryHookResult = ReturnType<typeof useGetRingProjectionCountLazyQuery>;
export type GetRingProjectionCountSuspenseQueryHookResult = ReturnType<typeof useGetRingProjectionCountSuspenseQuery>;
export type GetRingProjectionCountQueryResult = Apollo.QueryResult<GetRingProjectionCountQuery, GetRingProjectionCountQueryVariables>;
export const GetSegmentHistoryOptionsDocument = gql`
    query GetSegmentHistoryOptions($constructionSiteId: uuid!, $projectId: uuid) {
  scanSites: quality_scanSite(
    order_by: {label: asc}
    where: {scanSiteConstructionSites: {constructionSiteId: {_eq: $constructionSiteId}}}
  ) {
    id
    label
    isReceiptActivated
  }
  defectTypes: quality_quarantineDefectType(
    where: {_and: [{projectId: {_eq: $projectId}}, {isHidden: {_eq: false}}]}
  ) {
    id
    label
  }
}
    `;

/**
 * __useGetSegmentHistoryOptionsQuery__
 *
 * To run a query within a React component, call `useGetSegmentHistoryOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentHistoryOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentHistoryOptionsQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetSegmentHistoryOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetSegmentHistoryOptionsQuery, GetSegmentHistoryOptionsQueryVariables> & ({ variables: GetSegmentHistoryOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentHistoryOptionsQuery, GetSegmentHistoryOptionsQueryVariables>(GetSegmentHistoryOptionsDocument, options);
      }
export function useGetSegmentHistoryOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentHistoryOptionsQuery, GetSegmentHistoryOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentHistoryOptionsQuery, GetSegmentHistoryOptionsQueryVariables>(GetSegmentHistoryOptionsDocument, options);
        }
export function useGetSegmentHistoryOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSegmentHistoryOptionsQuery, GetSegmentHistoryOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSegmentHistoryOptionsQuery, GetSegmentHistoryOptionsQueryVariables>(GetSegmentHistoryOptionsDocument, options);
        }
export type GetSegmentHistoryOptionsQueryHookResult = ReturnType<typeof useGetSegmentHistoryOptionsQuery>;
export type GetSegmentHistoryOptionsLazyQueryHookResult = ReturnType<typeof useGetSegmentHistoryOptionsLazyQuery>;
export type GetSegmentHistoryOptionsSuspenseQueryHookResult = ReturnType<typeof useGetSegmentHistoryOptionsSuspenseQuery>;
export type GetSegmentHistoryOptionsQueryResult = Apollo.QueryResult<GetSegmentHistoryOptionsQuery, GetSegmentHistoryOptionsQueryVariables>;
export const GetDefectRepairOptionsDocument = gql`
    query GetDefectRepairOptions($projectId: uuid!) {
  defectTypes: quality_defectRepairType(
    where: {_and: [{projectId: {_eq: $projectId}}, {isHidden: {_eq: false}}]}
  ) {
    id
    label
  }
}
    `;

/**
 * __useGetDefectRepairOptionsQuery__
 *
 * To run a query within a React component, call `useGetDefectRepairOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefectRepairOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefectRepairOptionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetDefectRepairOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetDefectRepairOptionsQuery, GetDefectRepairOptionsQueryVariables> & ({ variables: GetDefectRepairOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefectRepairOptionsQuery, GetDefectRepairOptionsQueryVariables>(GetDefectRepairOptionsDocument, options);
      }
export function useGetDefectRepairOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefectRepairOptionsQuery, GetDefectRepairOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefectRepairOptionsQuery, GetDefectRepairOptionsQueryVariables>(GetDefectRepairOptionsDocument, options);
        }
export function useGetDefectRepairOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDefectRepairOptionsQuery, GetDefectRepairOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDefectRepairOptionsQuery, GetDefectRepairOptionsQueryVariables>(GetDefectRepairOptionsDocument, options);
        }
export type GetDefectRepairOptionsQueryHookResult = ReturnType<typeof useGetDefectRepairOptionsQuery>;
export type GetDefectRepairOptionsLazyQueryHookResult = ReturnType<typeof useGetDefectRepairOptionsLazyQuery>;
export type GetDefectRepairOptionsSuspenseQueryHookResult = ReturnType<typeof useGetDefectRepairOptionsSuspenseQuery>;
export type GetDefectRepairOptionsQueryResult = Apollo.QueryResult<GetDefectRepairOptionsQuery, GetDefectRepairOptionsQueryVariables>;
export const GetFiltersDataDocument = gql`
    query GetFiltersData($constructionSiteId: uuid!, $projectId: uuid) {
  serialNumbers: quality_segment(
    order_by: {serialNumber: asc}
    where: {_and: [{projectId: {_eq: $projectId}}]}
  ) {
    id
    serialNumber
  }
  scanSites: quality_scanSite(
    order_by: {label: asc}
    where: {scanSiteConstructionSites: {constructionSiteId: {_eq: $constructionSiteId}}}
  ) {
    id
    label
    isQuarantineEnabled
    isOnHoldOptionEnabled
    isReceiptActivated
  }
  segmentTypes: quality_segment(
    distinct_on: [segmentType]
    order_by: {segmentType: asc}
    where: {project: {constructionSites: {id: {_eq: $constructionSiteId}}}}
  ) {
    segmentType
  }
}
    `;

/**
 * __useGetFiltersDataQuery__
 *
 * To run a query within a React component, call `useGetFiltersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFiltersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFiltersDataQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetFiltersDataQuery(baseOptions: Apollo.QueryHookOptions<GetFiltersDataQuery, GetFiltersDataQueryVariables> & ({ variables: GetFiltersDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFiltersDataQuery, GetFiltersDataQueryVariables>(GetFiltersDataDocument, options);
      }
export function useGetFiltersDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFiltersDataQuery, GetFiltersDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFiltersDataQuery, GetFiltersDataQueryVariables>(GetFiltersDataDocument, options);
        }
export function useGetFiltersDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFiltersDataQuery, GetFiltersDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFiltersDataQuery, GetFiltersDataQueryVariables>(GetFiltersDataDocument, options);
        }
export type GetFiltersDataQueryHookResult = ReturnType<typeof useGetFiltersDataQuery>;
export type GetFiltersDataLazyQueryHookResult = ReturnType<typeof useGetFiltersDataLazyQuery>;
export type GetFiltersDataSuspenseQueryHookResult = ReturnType<typeof useGetFiltersDataSuspenseQuery>;
export type GetFiltersDataQueryResult = Apollo.QueryResult<GetFiltersDataQuery, GetFiltersDataQueryVariables>;
export const GetSegmentHistoryExtraColumnsDocument = gql`
    query GetSegmentHistoryExtraColumns($constructionSiteId: uuid!) {
  extraColumns: quality_importExtraColumn(
    order_by: {columnHeader: asc}
    where: {importConfig: {project: {constructionSites: {id: {_in: [$constructionSiteId]}}}}}
  ) {
    id
    segmentParameter
  }
}
    `;

/**
 * __useGetSegmentHistoryExtraColumnsQuery__
 *
 * To run a query within a React component, call `useGetSegmentHistoryExtraColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentHistoryExtraColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentHistoryExtraColumnsQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetSegmentHistoryExtraColumnsQuery(baseOptions: Apollo.QueryHookOptions<GetSegmentHistoryExtraColumnsQuery, GetSegmentHistoryExtraColumnsQueryVariables> & ({ variables: GetSegmentHistoryExtraColumnsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentHistoryExtraColumnsQuery, GetSegmentHistoryExtraColumnsQueryVariables>(GetSegmentHistoryExtraColumnsDocument, options);
      }
export function useGetSegmentHistoryExtraColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentHistoryExtraColumnsQuery, GetSegmentHistoryExtraColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentHistoryExtraColumnsQuery, GetSegmentHistoryExtraColumnsQueryVariables>(GetSegmentHistoryExtraColumnsDocument, options);
        }
export function useGetSegmentHistoryExtraColumnsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSegmentHistoryExtraColumnsQuery, GetSegmentHistoryExtraColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSegmentHistoryExtraColumnsQuery, GetSegmentHistoryExtraColumnsQueryVariables>(GetSegmentHistoryExtraColumnsDocument, options);
        }
export type GetSegmentHistoryExtraColumnsQueryHookResult = ReturnType<typeof useGetSegmentHistoryExtraColumnsQuery>;
export type GetSegmentHistoryExtraColumnsLazyQueryHookResult = ReturnType<typeof useGetSegmentHistoryExtraColumnsLazyQuery>;
export type GetSegmentHistoryExtraColumnsSuspenseQueryHookResult = ReturnType<typeof useGetSegmentHistoryExtraColumnsSuspenseQuery>;
export type GetSegmentHistoryExtraColumnsQueryResult = Apollo.QueryResult<GetSegmentHistoryExtraColumnsQuery, GetSegmentHistoryExtraColumnsQueryVariables>;
export const GetLastImportTaskDocument = gql`
    query GetLastImportTask($projectId: uuid!) {
  lastTask: quality_importTask(
    limit: 1
    order_by: {createdAt: desc}
    where: {_and: [{projectId: {_eq: $projectId}}, {endDate: {_is_null: false}}]}
  ) {
    id
    segmentCreated
    segmentUpdated
    segmentFailed
    endDate
    warnings
  }
  ongoingTask: quality_importTask(
    limit: 1
    order_by: {createdAt: desc}
    where: {_and: [{projectId: {_eq: $projectId}}, {endDate: {_is_null: true}}]}
  ) {
    createdAt
  }
}
    `;

/**
 * __useGetLastImportTaskQuery__
 *
 * To run a query within a React component, call `useGetLastImportTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastImportTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastImportTaskQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetLastImportTaskQuery(baseOptions: Apollo.QueryHookOptions<GetLastImportTaskQuery, GetLastImportTaskQueryVariables> & ({ variables: GetLastImportTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastImportTaskQuery, GetLastImportTaskQueryVariables>(GetLastImportTaskDocument, options);
      }
export function useGetLastImportTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastImportTaskQuery, GetLastImportTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastImportTaskQuery, GetLastImportTaskQueryVariables>(GetLastImportTaskDocument, options);
        }
export function useGetLastImportTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLastImportTaskQuery, GetLastImportTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLastImportTaskQuery, GetLastImportTaskQueryVariables>(GetLastImportTaskDocument, options);
        }
export type GetLastImportTaskQueryHookResult = ReturnType<typeof useGetLastImportTaskQuery>;
export type GetLastImportTaskLazyQueryHookResult = ReturnType<typeof useGetLastImportTaskLazyQuery>;
export type GetLastImportTaskSuspenseQueryHookResult = ReturnType<typeof useGetLastImportTaskSuspenseQuery>;
export type GetLastImportTaskQueryResult = Apollo.QueryResult<GetLastImportTaskQuery, GetLastImportTaskQueryVariables>;
export const GetImportConfigDocument = gql`
    query GetImportConfig($projectId: uuid!) {
  mainColumns: quality_importConfig(
    limit: 1
    order_by: {updatedAt: desc}
    where: {projectId: {_eq: $projectId}}
  ) {
    serialNumberColumn
    segmentTypeColumn
    moldColumn
    manufactureDateColumn
  }
  extraColumns: quality_importExtraColumn(
    where: {importConfig: {project: {id: {_eq: $projectId}}}}
  ) {
    columnHeader
    segmentParameter
  }
}
    `;

/**
 * __useGetImportConfigQuery__
 *
 * To run a query within a React component, call `useGetImportConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportConfigQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetImportConfigQuery(baseOptions: Apollo.QueryHookOptions<GetImportConfigQuery, GetImportConfigQueryVariables> & ({ variables: GetImportConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImportConfigQuery, GetImportConfigQueryVariables>(GetImportConfigDocument, options);
      }
export function useGetImportConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImportConfigQuery, GetImportConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImportConfigQuery, GetImportConfigQueryVariables>(GetImportConfigDocument, options);
        }
export function useGetImportConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetImportConfigQuery, GetImportConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetImportConfigQuery, GetImportConfigQueryVariables>(GetImportConfigDocument, options);
        }
export type GetImportConfigQueryHookResult = ReturnType<typeof useGetImportConfigQuery>;
export type GetImportConfigLazyQueryHookResult = ReturnType<typeof useGetImportConfigLazyQuery>;
export type GetImportConfigSuspenseQueryHookResult = ReturnType<typeof useGetImportConfigSuspenseQuery>;
export type GetImportConfigQueryResult = Apollo.QueryResult<GetImportConfigQuery, GetImportConfigQueryVariables>;
export const GetImportTaskDocument = gql`
    query GetImportTask($id: uuid!) {
  task: quality_importTask(where: {id: {_eq: $id}}) {
    warnings
  }
}
    `;

/**
 * __useGetImportTaskQuery__
 *
 * To run a query within a React component, call `useGetImportTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetImportTaskQuery(baseOptions: Apollo.QueryHookOptions<GetImportTaskQuery, GetImportTaskQueryVariables> & ({ variables: GetImportTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImportTaskQuery, GetImportTaskQueryVariables>(GetImportTaskDocument, options);
      }
export function useGetImportTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImportTaskQuery, GetImportTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImportTaskQuery, GetImportTaskQueryVariables>(GetImportTaskDocument, options);
        }
export function useGetImportTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetImportTaskQuery, GetImportTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetImportTaskQuery, GetImportTaskQueryVariables>(GetImportTaskDocument, options);
        }
export type GetImportTaskQueryHookResult = ReturnType<typeof useGetImportTaskQuery>;
export type GetImportTaskLazyQueryHookResult = ReturnType<typeof useGetImportTaskLazyQuery>;
export type GetImportTaskSuspenseQueryHookResult = ReturnType<typeof useGetImportTaskSuspenseQuery>;
export type GetImportTaskQueryResult = Apollo.QueryResult<GetImportTaskQuery, GetImportTaskQueryVariables>;
export const AvailableCustomIndicatorsDocument = gql`
    query AvailableCustomIndicators($constructionSiteId: uuid!) {
  indicator(
    where: {constructionSite: {id: {_eq: $constructionSiteId}}, isDisabled: {_eq: false}}
  ) {
    id
    nameEn
    nameFr
    nameEs
    unit
  }
}
    `;

/**
 * __useAvailableCustomIndicatorsQuery__
 *
 * To run a query within a React component, call `useAvailableCustomIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableCustomIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableCustomIndicatorsQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useAvailableCustomIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<AvailableCustomIndicatorsQuery, AvailableCustomIndicatorsQueryVariables> & ({ variables: AvailableCustomIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableCustomIndicatorsQuery, AvailableCustomIndicatorsQueryVariables>(AvailableCustomIndicatorsDocument, options);
      }
export function useAvailableCustomIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableCustomIndicatorsQuery, AvailableCustomIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableCustomIndicatorsQuery, AvailableCustomIndicatorsQueryVariables>(AvailableCustomIndicatorsDocument, options);
        }
export function useAvailableCustomIndicatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableCustomIndicatorsQuery, AvailableCustomIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableCustomIndicatorsQuery, AvailableCustomIndicatorsQueryVariables>(AvailableCustomIndicatorsDocument, options);
        }
export type AvailableCustomIndicatorsQueryHookResult = ReturnType<typeof useAvailableCustomIndicatorsQuery>;
export type AvailableCustomIndicatorsLazyQueryHookResult = ReturnType<typeof useAvailableCustomIndicatorsLazyQuery>;
export type AvailableCustomIndicatorsSuspenseQueryHookResult = ReturnType<typeof useAvailableCustomIndicatorsSuspenseQuery>;
export type AvailableCustomIndicatorsQueryResult = Apollo.QueryResult<AvailableCustomIndicatorsQuery, AvailableCustomIndicatorsQueryVariables>;
export const GetTasksAnalyzerMetadataDocument = gql`
    query GetTasksAnalyzerMetadata($constructionSiteId: uuid!) {
  activity(
    where: {parentId: {_is_null: true}, constructionSiteId: {_eq: $constructionSiteId}}
    order_by: {order: asc}
  ) {
    ...ActivityMinimalTree
  }
  hiddenActivitiesWithTasks: activity(
    where: {tasks: {}, hidden: {_eq: true}, constructionSiteId: {_eq: $constructionSiteId}}
  ) {
    id
  }
}
    ${ActivityMinimalTreeFragmentDoc}`;

/**
 * __useGetTasksAnalyzerMetadataQuery__
 *
 * To run a query within a React component, call `useGetTasksAnalyzerMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksAnalyzerMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksAnalyzerMetadataQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetTasksAnalyzerMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetTasksAnalyzerMetadataQuery, GetTasksAnalyzerMetadataQueryVariables> & ({ variables: GetTasksAnalyzerMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksAnalyzerMetadataQuery, GetTasksAnalyzerMetadataQueryVariables>(GetTasksAnalyzerMetadataDocument, options);
      }
export function useGetTasksAnalyzerMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksAnalyzerMetadataQuery, GetTasksAnalyzerMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksAnalyzerMetadataQuery, GetTasksAnalyzerMetadataQueryVariables>(GetTasksAnalyzerMetadataDocument, options);
        }
export function useGetTasksAnalyzerMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTasksAnalyzerMetadataQuery, GetTasksAnalyzerMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTasksAnalyzerMetadataQuery, GetTasksAnalyzerMetadataQueryVariables>(GetTasksAnalyzerMetadataDocument, options);
        }
export type GetTasksAnalyzerMetadataQueryHookResult = ReturnType<typeof useGetTasksAnalyzerMetadataQuery>;
export type GetTasksAnalyzerMetadataLazyQueryHookResult = ReturnType<typeof useGetTasksAnalyzerMetadataLazyQuery>;
export type GetTasksAnalyzerMetadataSuspenseQueryHookResult = ReturnType<typeof useGetTasksAnalyzerMetadataSuspenseQuery>;
export type GetTasksAnalyzerMetadataQueryResult = Apollo.QueryResult<GetTasksAnalyzerMetadataQuery, GetTasksAnalyzerMetadataQueryVariables>;
export const GetProductionAnalyzeSeriesDocument = gql`
    query GetProductionAnalyzeSeries($constructionSiteId: uuid!) {
  shift(
    where: {constructionSiteId: {_eq: $constructionSiteId}}
    order_by: {startTime: asc}
  ) {
    id
    name
  }
  team(
    where: {constructionSiteId: {_eq: $constructionSiteId}}
    order_by: {name: asc}
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetProductionAnalyzeSeriesQuery__
 *
 * To run a query within a React component, call `useGetProductionAnalyzeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionAnalyzeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionAnalyzeSeriesQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetProductionAnalyzeSeriesQuery(baseOptions: Apollo.QueryHookOptions<GetProductionAnalyzeSeriesQuery, GetProductionAnalyzeSeriesQueryVariables> & ({ variables: GetProductionAnalyzeSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionAnalyzeSeriesQuery, GetProductionAnalyzeSeriesQueryVariables>(GetProductionAnalyzeSeriesDocument, options);
      }
export function useGetProductionAnalyzeSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionAnalyzeSeriesQuery, GetProductionAnalyzeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionAnalyzeSeriesQuery, GetProductionAnalyzeSeriesQueryVariables>(GetProductionAnalyzeSeriesDocument, options);
        }
export function useGetProductionAnalyzeSeriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductionAnalyzeSeriesQuery, GetProductionAnalyzeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductionAnalyzeSeriesQuery, GetProductionAnalyzeSeriesQueryVariables>(GetProductionAnalyzeSeriesDocument, options);
        }
export type GetProductionAnalyzeSeriesQueryHookResult = ReturnType<typeof useGetProductionAnalyzeSeriesQuery>;
export type GetProductionAnalyzeSeriesLazyQueryHookResult = ReturnType<typeof useGetProductionAnalyzeSeriesLazyQuery>;
export type GetProductionAnalyzeSeriesSuspenseQueryHookResult = ReturnType<typeof useGetProductionAnalyzeSeriesSuspenseQuery>;
export type GetProductionAnalyzeSeriesQueryResult = Apollo.QueryResult<GetProductionAnalyzeSeriesQuery, GetProductionAnalyzeSeriesQueryVariables>;
export const GetNewReportFieldsDocument = gql`
    query GetNewReportFields($constructionSiteId: uuid) {
  shifts: shift(
    where: {constructionSiteId: {_eq: $constructionSiteId}, isHidden: {_eq: false}}
  ) {
    id
    name
    constructionSiteId
    startTime
    endTime
  }
  recurringTasks: recurringTask(
    where: {constructionSiteId: {_eq: $constructionSiteId}}
  ) {
    id
    constructionSiteId
    activityId
    duration
    timeOffset
    timeOrigin
    note
    critical
  }
  operators: operator(
    where: {constructionSiteId: {_eq: $constructionSiteId}, isHidden: {_eq: false}}
  ) {
    id
    name
  }
  shiftLeaders: shiftLeader(
    where: {constructionSiteId: {_eq: $constructionSiteId}, isHidden: {_eq: false}}
  ) {
    id
    name
  }
  teams: team(
    where: {constructionSiteId: {_eq: $constructionSiteId}, isHidden: {_eq: false}}
  ) {
    id
    name
  }
  shiftEngineers: user(
    where: {permissions: {constructionSiteId: {_eq: $constructionSiteId}, permissionType: {name: {_eq: "user"}}}}
  ) {
    id
    email
    firstName
    lastName
  }
  shiftManagers: user(
    where: {permissions: {constructionSiteId: {_eq: $constructionSiteId}, permissionType: {name: {_eq: "construction-site-manager"}}}}
  ) {
    id
    email
    firstName
    lastName
  }
}
    `;

/**
 * __useGetNewReportFieldsQuery__
 *
 * To run a query within a React component, call `useGetNewReportFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewReportFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewReportFieldsQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetNewReportFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GetNewReportFieldsQuery, GetNewReportFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewReportFieldsQuery, GetNewReportFieldsQueryVariables>(GetNewReportFieldsDocument, options);
      }
export function useGetNewReportFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewReportFieldsQuery, GetNewReportFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewReportFieldsQuery, GetNewReportFieldsQueryVariables>(GetNewReportFieldsDocument, options);
        }
export function useGetNewReportFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNewReportFieldsQuery, GetNewReportFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNewReportFieldsQuery, GetNewReportFieldsQueryVariables>(GetNewReportFieldsDocument, options);
        }
export type GetNewReportFieldsQueryHookResult = ReturnType<typeof useGetNewReportFieldsQuery>;
export type GetNewReportFieldsLazyQueryHookResult = ReturnType<typeof useGetNewReportFieldsLazyQuery>;
export type GetNewReportFieldsSuspenseQueryHookResult = ReturnType<typeof useGetNewReportFieldsSuspenseQuery>;
export type GetNewReportFieldsQueryResult = Apollo.QueryResult<GetNewReportFieldsQuery, GetNewReportFieldsQueryVariables>;
export const CheckNewReportDocument = gql`
    query CheckNewReport($date: date, $shiftId: uuid!, $constructionSiteId: uuid!) {
  shiftReport(
    where: {_and: {date: {_eq: $date}, shiftId: {_eq: $shiftId}, constructionSiteId: {_eq: $constructionSiteId}}}
  ) {
    ...ShiftReportCheck
  }
}
    ${ShiftReportCheckFragmentDoc}`;

/**
 * __useCheckNewReportQuery__
 *
 * To run a query within a React component, call `useCheckNewReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckNewReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckNewReportQuery({
 *   variables: {
 *      date: // value for 'date'
 *      shiftId: // value for 'shiftId'
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useCheckNewReportQuery(baseOptions: Apollo.QueryHookOptions<CheckNewReportQuery, CheckNewReportQueryVariables> & ({ variables: CheckNewReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckNewReportQuery, CheckNewReportQueryVariables>(CheckNewReportDocument, options);
      }
export function useCheckNewReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckNewReportQuery, CheckNewReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckNewReportQuery, CheckNewReportQueryVariables>(CheckNewReportDocument, options);
        }
export function useCheckNewReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckNewReportQuery, CheckNewReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckNewReportQuery, CheckNewReportQueryVariables>(CheckNewReportDocument, options);
        }
export type CheckNewReportQueryHookResult = ReturnType<typeof useCheckNewReportQuery>;
export type CheckNewReportLazyQueryHookResult = ReturnType<typeof useCheckNewReportLazyQuery>;
export type CheckNewReportSuspenseQueryHookResult = ReturnType<typeof useCheckNewReportSuspenseQuery>;
export type CheckNewReportQueryResult = Apollo.QueryResult<CheckNewReportQuery, CheckNewReportQueryVariables>;
export const StartNewReportDocument = gql`
    mutation StartNewReport($object: shiftReport_insert_input!) {
  shiftReport: insert_shiftReport_one(object: $object) {
    id
    date
    operatorId
    shiftLeaderId
    shiftEngineerId
    shiftManagerId
    startMetricPoint
    endMetricPoint
    shiftId
    constructionSiteId
  }
}
    `;
export type StartNewReportMutationFn = Apollo.MutationFunction<StartNewReportMutation, StartNewReportMutationVariables>;

/**
 * __useStartNewReportMutation__
 *
 * To run a mutation, you first call `useStartNewReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartNewReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startNewReportMutation, { data, loading, error }] = useStartNewReportMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useStartNewReportMutation(baseOptions?: Apollo.MutationHookOptions<StartNewReportMutation, StartNewReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartNewReportMutation, StartNewReportMutationVariables>(StartNewReportDocument, options);
      }
export type StartNewReportMutationHookResult = ReturnType<typeof useStartNewReportMutation>;
export type StartNewReportMutationResult = Apollo.MutationResult<StartNewReportMutation>;
export type StartNewReportMutationOptions = Apollo.BaseMutationOptions<StartNewReportMutation, StartNewReportMutationVariables>;
export const GetShiftProductionTimeDocument = gql`
    query getShiftProductionTime($id: ID!, $critical: Boolean) {
  shiftReportTasksPieChartData(id: $id, critical: $critical) {
    id
    activityName
    activityNameExport
    activityId
    total
  }
}
    `;

/**
 * __useGetShiftProductionTimeQuery__
 *
 * To run a query within a React component, call `useGetShiftProductionTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftProductionTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftProductionTimeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      critical: // value for 'critical'
 *   },
 * });
 */
export function useGetShiftProductionTimeQuery(baseOptions: Apollo.QueryHookOptions<GetShiftProductionTimeQuery, GetShiftProductionTimeQueryVariables> & ({ variables: GetShiftProductionTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShiftProductionTimeQuery, GetShiftProductionTimeQueryVariables>(GetShiftProductionTimeDocument, options);
      }
export function useGetShiftProductionTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShiftProductionTimeQuery, GetShiftProductionTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShiftProductionTimeQuery, GetShiftProductionTimeQueryVariables>(GetShiftProductionTimeDocument, options);
        }
export function useGetShiftProductionTimeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShiftProductionTimeQuery, GetShiftProductionTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShiftProductionTimeQuery, GetShiftProductionTimeQueryVariables>(GetShiftProductionTimeDocument, options);
        }
export type GetShiftProductionTimeQueryHookResult = ReturnType<typeof useGetShiftProductionTimeQuery>;
export type GetShiftProductionTimeLazyQueryHookResult = ReturnType<typeof useGetShiftProductionTimeLazyQuery>;
export type GetShiftProductionTimeSuspenseQueryHookResult = ReturnType<typeof useGetShiftProductionTimeSuspenseQuery>;
export type GetShiftProductionTimeQueryResult = Apollo.QueryResult<GetShiftProductionTimeQuery, GetShiftProductionTimeQueryVariables>;
export const ShiftReportAggregatePdfDataDocument = gql`
    query shiftReportAggregatePdfData($constructionSiteId: ID!, $endDate: date!, $groupBy: ShiftReportAggregateGroupByEnum!, $startDate: date!) {
  shiftReportAggregatePdfData(
    input: {constructionSiteId: $constructionSiteId, endDate: $endDate, groupBy: $groupBy, startDate: $startDate}
  ) {
    ...aggregatedShiftReport
  }
}
    ${AggregatedShiftReportFragmentDoc}`;

/**
 * __useShiftReportAggregatePdfDataQuery__
 *
 * To run a query within a React component, call `useShiftReportAggregatePdfDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftReportAggregatePdfDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShiftReportAggregatePdfDataQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      endDate: // value for 'endDate'
 *      groupBy: // value for 'groupBy'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useShiftReportAggregatePdfDataQuery(baseOptions: Apollo.QueryHookOptions<ShiftReportAggregatePdfDataQuery, ShiftReportAggregatePdfDataQueryVariables> & ({ variables: ShiftReportAggregatePdfDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShiftReportAggregatePdfDataQuery, ShiftReportAggregatePdfDataQueryVariables>(ShiftReportAggregatePdfDataDocument, options);
      }
export function useShiftReportAggregatePdfDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShiftReportAggregatePdfDataQuery, ShiftReportAggregatePdfDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShiftReportAggregatePdfDataQuery, ShiftReportAggregatePdfDataQueryVariables>(ShiftReportAggregatePdfDataDocument, options);
        }
export function useShiftReportAggregatePdfDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ShiftReportAggregatePdfDataQuery, ShiftReportAggregatePdfDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShiftReportAggregatePdfDataQuery, ShiftReportAggregatePdfDataQueryVariables>(ShiftReportAggregatePdfDataDocument, options);
        }
export type ShiftReportAggregatePdfDataQueryHookResult = ReturnType<typeof useShiftReportAggregatePdfDataQuery>;
export type ShiftReportAggregatePdfDataLazyQueryHookResult = ReturnType<typeof useShiftReportAggregatePdfDataLazyQuery>;
export type ShiftReportAggregatePdfDataSuspenseQueryHookResult = ReturnType<typeof useShiftReportAggregatePdfDataSuspenseQuery>;
export type ShiftReportAggregatePdfDataQueryResult = Apollo.QueryResult<ShiftReportAggregatePdfDataQuery, ShiftReportAggregatePdfDataQueryVariables>;
export const GetConstructionSiteByIdDocument = gql`
    query getConstructionSiteById($id: uuid!) {
  constructionSite_by_pk(id: $id) {
    logo
    name
    distanceUnit
    language
  }
}
    `;

/**
 * __useGetConstructionSiteByIdQuery__
 *
 * To run a query within a React component, call `useGetConstructionSiteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConstructionSiteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConstructionSiteByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConstructionSiteByIdQuery(baseOptions: Apollo.QueryHookOptions<GetConstructionSiteByIdQuery, GetConstructionSiteByIdQueryVariables> & ({ variables: GetConstructionSiteByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConstructionSiteByIdQuery, GetConstructionSiteByIdQueryVariables>(GetConstructionSiteByIdDocument, options);
      }
export function useGetConstructionSiteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConstructionSiteByIdQuery, GetConstructionSiteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConstructionSiteByIdQuery, GetConstructionSiteByIdQueryVariables>(GetConstructionSiteByIdDocument, options);
        }
export function useGetConstructionSiteByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConstructionSiteByIdQuery, GetConstructionSiteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConstructionSiteByIdQuery, GetConstructionSiteByIdQueryVariables>(GetConstructionSiteByIdDocument, options);
        }
export type GetConstructionSiteByIdQueryHookResult = ReturnType<typeof useGetConstructionSiteByIdQuery>;
export type GetConstructionSiteByIdLazyQueryHookResult = ReturnType<typeof useGetConstructionSiteByIdLazyQuery>;
export type GetConstructionSiteByIdSuspenseQueryHookResult = ReturnType<typeof useGetConstructionSiteByIdSuspenseQuery>;
export type GetConstructionSiteByIdQueryResult = Apollo.QueryResult<GetConstructionSiteByIdQuery, GetConstructionSiteByIdQueryVariables>;
export const GetTasksByConstructionSiteInRangeDocument = gql`
    query getTasksByConstructionSiteInRange($constructionSiteId: uuid!, $startDate: date!, $endDate: date!) {
  task(
    where: {shiftReport: {date: {_lte: $endDate, _gte: $startDate}, constructionSiteId: {_eq: $constructionSiteId}, operatorValidation: {_eq: true}, _or: [{_and: {managerValidation: {_eq: true}, constructionSite: {managerValidationRequired: {_eq: true}}}}, {constructionSite: {managerValidationRequired: {_eq: false}}}]}}
  ) {
    id
    duration
    activity {
      id
      type
      constructionSiteId
    }
    critical
  }
}
    `;

/**
 * __useGetTasksByConstructionSiteInRangeQuery__
 *
 * To run a query within a React component, call `useGetTasksByConstructionSiteInRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksByConstructionSiteInRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksByConstructionSiteInRangeQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetTasksByConstructionSiteInRangeQuery(baseOptions: Apollo.QueryHookOptions<GetTasksByConstructionSiteInRangeQuery, GetTasksByConstructionSiteInRangeQueryVariables> & ({ variables: GetTasksByConstructionSiteInRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksByConstructionSiteInRangeQuery, GetTasksByConstructionSiteInRangeQueryVariables>(GetTasksByConstructionSiteInRangeDocument, options);
      }
export function useGetTasksByConstructionSiteInRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksByConstructionSiteInRangeQuery, GetTasksByConstructionSiteInRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksByConstructionSiteInRangeQuery, GetTasksByConstructionSiteInRangeQueryVariables>(GetTasksByConstructionSiteInRangeDocument, options);
        }
export function useGetTasksByConstructionSiteInRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTasksByConstructionSiteInRangeQuery, GetTasksByConstructionSiteInRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTasksByConstructionSiteInRangeQuery, GetTasksByConstructionSiteInRangeQueryVariables>(GetTasksByConstructionSiteInRangeDocument, options);
        }
export type GetTasksByConstructionSiteInRangeQueryHookResult = ReturnType<typeof useGetTasksByConstructionSiteInRangeQuery>;
export type GetTasksByConstructionSiteInRangeLazyQueryHookResult = ReturnType<typeof useGetTasksByConstructionSiteInRangeLazyQuery>;
export type GetTasksByConstructionSiteInRangeSuspenseQueryHookResult = ReturnType<typeof useGetTasksByConstructionSiteInRangeSuspenseQuery>;
export type GetTasksByConstructionSiteInRangeQueryResult = Apollo.QueryResult<GetTasksByConstructionSiteInRangeQuery, GetTasksByConstructionSiteInRangeQueryVariables>;
export const GetAggregatedIndicatorResultsDocument = gql`
    query GetAggregatedIndicatorResults($constructionSiteId: String!, $startDate: date!, $endDate: date!) {
  calculateAggregatedIndicatorResults(
    constructionSiteId: $constructionSiteId
    startDate: $startDate
    endDate: $endDate
  ) {
    message
    success
    data {
      id
      unit
      value
      nameFr
      nameEn
      nameEs
    }
  }
}
    `;

/**
 * __useGetAggregatedIndicatorResultsQuery__
 *
 * To run a query within a React component, call `useGetAggregatedIndicatorResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedIndicatorResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregatedIndicatorResultsQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetAggregatedIndicatorResultsQuery(baseOptions: Apollo.QueryHookOptions<GetAggregatedIndicatorResultsQuery, GetAggregatedIndicatorResultsQueryVariables> & ({ variables: GetAggregatedIndicatorResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregatedIndicatorResultsQuery, GetAggregatedIndicatorResultsQueryVariables>(GetAggregatedIndicatorResultsDocument, options);
      }
export function useGetAggregatedIndicatorResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregatedIndicatorResultsQuery, GetAggregatedIndicatorResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregatedIndicatorResultsQuery, GetAggregatedIndicatorResultsQueryVariables>(GetAggregatedIndicatorResultsDocument, options);
        }
export function useGetAggregatedIndicatorResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAggregatedIndicatorResultsQuery, GetAggregatedIndicatorResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAggregatedIndicatorResultsQuery, GetAggregatedIndicatorResultsQueryVariables>(GetAggregatedIndicatorResultsDocument, options);
        }
export type GetAggregatedIndicatorResultsQueryHookResult = ReturnType<typeof useGetAggregatedIndicatorResultsQuery>;
export type GetAggregatedIndicatorResultsLazyQueryHookResult = ReturnType<typeof useGetAggregatedIndicatorResultsLazyQuery>;
export type GetAggregatedIndicatorResultsSuspenseQueryHookResult = ReturnType<typeof useGetAggregatedIndicatorResultsSuspenseQuery>;
export type GetAggregatedIndicatorResultsQueryResult = Apollo.QueryResult<GetAggregatedIndicatorResultsQuery, GetAggregatedIndicatorResultsQueryVariables>;
export const GetDailyReportTimelineMetadataDocument = gql`
    query GetDailyReportTimelineMetadata($constructionSiteId: uuid!, $date: date!) {
  tasks: task(
    where: {shiftReport: {date: {_eq: $date}, constructionSiteId: {_eq: $constructionSiteId}}}
    order_by: {startDate: asc}
  ) {
    ...TaskFull
    shiftReport {
      id
      shift {
        id
        name
        startTime
        endTime
      }
    }
  }
  activities: activity(
    where: {parentId: {_is_null: true}, constructionSiteId: {_eq: $constructionSiteId}}
    order_by: {order: asc}
  ) {
    ...ActivityTreeFull
  }
}
    ${TaskFullFragmentDoc}
${ActivityTreeFullFragmentDoc}`;

/**
 * __useGetDailyReportTimelineMetadataQuery__
 *
 * To run a query within a React component, call `useGetDailyReportTimelineMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyReportTimelineMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyReportTimelineMetadataQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetDailyReportTimelineMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetDailyReportTimelineMetadataQuery, GetDailyReportTimelineMetadataQueryVariables> & ({ variables: GetDailyReportTimelineMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyReportTimelineMetadataQuery, GetDailyReportTimelineMetadataQueryVariables>(GetDailyReportTimelineMetadataDocument, options);
      }
export function useGetDailyReportTimelineMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyReportTimelineMetadataQuery, GetDailyReportTimelineMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyReportTimelineMetadataQuery, GetDailyReportTimelineMetadataQueryVariables>(GetDailyReportTimelineMetadataDocument, options);
        }
export function useGetDailyReportTimelineMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDailyReportTimelineMetadataQuery, GetDailyReportTimelineMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDailyReportTimelineMetadataQuery, GetDailyReportTimelineMetadataQueryVariables>(GetDailyReportTimelineMetadataDocument, options);
        }
export type GetDailyReportTimelineMetadataQueryHookResult = ReturnType<typeof useGetDailyReportTimelineMetadataQuery>;
export type GetDailyReportTimelineMetadataLazyQueryHookResult = ReturnType<typeof useGetDailyReportTimelineMetadataLazyQuery>;
export type GetDailyReportTimelineMetadataSuspenseQueryHookResult = ReturnType<typeof useGetDailyReportTimelineMetadataSuspenseQuery>;
export type GetDailyReportTimelineMetadataQueryResult = Apollo.QueryResult<GetDailyReportTimelineMetadataQuery, GetDailyReportTimelineMetadataQueryVariables>;
export const GetPreviousReportDocument = gql`
    query GetPreviousReport($constructionSiteId: uuid) {
  shiftReport(
    where: {constructionSiteId: {_eq: $constructionSiteId}}
    order_by: [{date: desc}, {shift: {startTime: desc}}]
    limit: 1
  ) {
    ...ShiftReportCardInfo
  }
}
    ${ShiftReportCardInfoFragmentDoc}`;

/**
 * __useGetPreviousReportQuery__
 *
 * To run a query within a React component, call `useGetPreviousReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviousReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviousReportQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetPreviousReportQuery(baseOptions?: Apollo.QueryHookOptions<GetPreviousReportQuery, GetPreviousReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviousReportQuery, GetPreviousReportQueryVariables>(GetPreviousReportDocument, options);
      }
export function useGetPreviousReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviousReportQuery, GetPreviousReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviousReportQuery, GetPreviousReportQueryVariables>(GetPreviousReportDocument, options);
        }
export function useGetPreviousReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreviousReportQuery, GetPreviousReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreviousReportQuery, GetPreviousReportQueryVariables>(GetPreviousReportDocument, options);
        }
export type GetPreviousReportQueryHookResult = ReturnType<typeof useGetPreviousReportQuery>;
export type GetPreviousReportLazyQueryHookResult = ReturnType<typeof useGetPreviousReportLazyQuery>;
export type GetPreviousReportSuspenseQueryHookResult = ReturnType<typeof useGetPreviousReportSuspenseQuery>;
export type GetPreviousReportQueryResult = Apollo.QueryResult<GetPreviousReportQuery, GetPreviousReportQueryVariables>;
export const ShiftReportAutofillDocument = gql`
    mutation ShiftReportAutofill($shiftReportId: ID!, $startDate: date!, $endDate: date!) {
  shiftReportAutofill(
    input: {shiftReportId: $shiftReportId, startDate: $startDate, endDate: $endDate}
  ) {
    success
    count
    message
  }
}
    `;
export type ShiftReportAutofillMutationFn = Apollo.MutationFunction<ShiftReportAutofillMutation, ShiftReportAutofillMutationVariables>;

/**
 * __useShiftReportAutofillMutation__
 *
 * To run a mutation, you first call `useShiftReportAutofillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShiftReportAutofillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shiftReportAutofillMutation, { data, loading, error }] = useShiftReportAutofillMutation({
 *   variables: {
 *      shiftReportId: // value for 'shiftReportId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useShiftReportAutofillMutation(baseOptions?: Apollo.MutationHookOptions<ShiftReportAutofillMutation, ShiftReportAutofillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShiftReportAutofillMutation, ShiftReportAutofillMutationVariables>(ShiftReportAutofillDocument, options);
      }
export type ShiftReportAutofillMutationHookResult = ReturnType<typeof useShiftReportAutofillMutation>;
export type ShiftReportAutofillMutationResult = Apollo.MutationResult<ShiftReportAutofillMutation>;
export type ShiftReportAutofillMutationOptions = Apollo.BaseMutationOptions<ShiftReportAutofillMutation, ShiftReportAutofillMutationVariables>;
export const ShiftReportAutofillV2Document = gql`
    mutation ShiftReportAutofillV2($shiftReportId: ID!, $startDate: date!, $endDate: date!) {
  shiftReportAutofillV2(
    input: {shiftReportId: $shiftReportId, startDate: $startDate, endDate: $endDate}
  ) {
    count
  }
}
    `;
export type ShiftReportAutofillV2MutationFn = Apollo.MutationFunction<ShiftReportAutofillV2Mutation, ShiftReportAutofillV2MutationVariables>;

/**
 * __useShiftReportAutofillV2Mutation__
 *
 * To run a mutation, you first call `useShiftReportAutofillV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShiftReportAutofillV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shiftReportAutofillV2Mutation, { data, loading, error }] = useShiftReportAutofillV2Mutation({
 *   variables: {
 *      shiftReportId: // value for 'shiftReportId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useShiftReportAutofillV2Mutation(baseOptions?: Apollo.MutationHookOptions<ShiftReportAutofillV2Mutation, ShiftReportAutofillV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShiftReportAutofillV2Mutation, ShiftReportAutofillV2MutationVariables>(ShiftReportAutofillV2Document, options);
      }
export type ShiftReportAutofillV2MutationHookResult = ReturnType<typeof useShiftReportAutofillV2Mutation>;
export type ShiftReportAutofillV2MutationResult = Apollo.MutationResult<ShiftReportAutofillV2Mutation>;
export type ShiftReportAutofillV2MutationOptions = Apollo.BaseMutationOptions<ShiftReportAutofillV2Mutation, ShiftReportAutofillV2MutationVariables>;
export const EditEndFieldsReportDocument = gql`
    mutation EditEndFieldsReport($id: uuid!, $startMetricPoint: Float, $endMetricPoint: Float, $date: date, $operatorId: uuid, $shiftLeaderId: uuid, $teamId: uuid, $shiftEngineerId: uuid, $shiftManagerId: uuid, $shiftId: uuid) {
  update_shiftReport_by_pk(
    pk_columns: {id: $id}
    _set: {startMetricPoint: $startMetricPoint, endMetricPoint: $endMetricPoint, date: $date, operatorId: $operatorId, shiftLeaderId: $shiftLeaderId, teamId: $teamId, shiftEngineerId: $shiftEngineerId, shiftManagerId: $shiftManagerId, shiftId: $shiftId}
  ) {
    id
  }
}
    `;
export type EditEndFieldsReportMutationFn = Apollo.MutationFunction<EditEndFieldsReportMutation, EditEndFieldsReportMutationVariables>;

/**
 * __useEditEndFieldsReportMutation__
 *
 * To run a mutation, you first call `useEditEndFieldsReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEndFieldsReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEndFieldsReportMutation, { data, loading, error }] = useEditEndFieldsReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startMetricPoint: // value for 'startMetricPoint'
 *      endMetricPoint: // value for 'endMetricPoint'
 *      date: // value for 'date'
 *      operatorId: // value for 'operatorId'
 *      shiftLeaderId: // value for 'shiftLeaderId'
 *      teamId: // value for 'teamId'
 *      shiftEngineerId: // value for 'shiftEngineerId'
 *      shiftManagerId: // value for 'shiftManagerId'
 *      shiftId: // value for 'shiftId'
 *   },
 * });
 */
export function useEditEndFieldsReportMutation(baseOptions?: Apollo.MutationHookOptions<EditEndFieldsReportMutation, EditEndFieldsReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEndFieldsReportMutation, EditEndFieldsReportMutationVariables>(EditEndFieldsReportDocument, options);
      }
export type EditEndFieldsReportMutationHookResult = ReturnType<typeof useEditEndFieldsReportMutation>;
export type EditEndFieldsReportMutationResult = Apollo.MutationResult<EditEndFieldsReportMutation>;
export type EditEndFieldsReportMutationOptions = Apollo.BaseMutationOptions<EditEndFieldsReportMutation, EditEndFieldsReportMutationVariables>;
export const EditEndFieldsReportUserDocument = gql`
    mutation EditEndFieldsReportUser($id: uuid!, $startMetricPoint: Float, $date: date, $operatorId: uuid, $shiftLeaderId: uuid, $teamId: uuid, $shiftEngineerId: uuid, $shiftManagerId: uuid, $shiftId: uuid) {
  update_shiftReport_by_pk(
    pk_columns: {id: $id}
    _set: {startMetricPoint: $startMetricPoint, date: $date, operatorId: $operatorId, shiftLeaderId: $shiftLeaderId, teamId: $teamId, shiftEngineerId: $shiftEngineerId, shiftManagerId: $shiftManagerId, shiftId: $shiftId}
  ) {
    id
  }
}
    `;
export type EditEndFieldsReportUserMutationFn = Apollo.MutationFunction<EditEndFieldsReportUserMutation, EditEndFieldsReportUserMutationVariables>;

/**
 * __useEditEndFieldsReportUserMutation__
 *
 * To run a mutation, you first call `useEditEndFieldsReportUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEndFieldsReportUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEndFieldsReportUserMutation, { data, loading, error }] = useEditEndFieldsReportUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startMetricPoint: // value for 'startMetricPoint'
 *      date: // value for 'date'
 *      operatorId: // value for 'operatorId'
 *      shiftLeaderId: // value for 'shiftLeaderId'
 *      teamId: // value for 'teamId'
 *      shiftEngineerId: // value for 'shiftEngineerId'
 *      shiftManagerId: // value for 'shiftManagerId'
 *      shiftId: // value for 'shiftId'
 *   },
 * });
 */
export function useEditEndFieldsReportUserMutation(baseOptions?: Apollo.MutationHookOptions<EditEndFieldsReportUserMutation, EditEndFieldsReportUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEndFieldsReportUserMutation, EditEndFieldsReportUserMutationVariables>(EditEndFieldsReportUserDocument, options);
      }
export type EditEndFieldsReportUserMutationHookResult = ReturnType<typeof useEditEndFieldsReportUserMutation>;
export type EditEndFieldsReportUserMutationResult = Apollo.MutationResult<EditEndFieldsReportUserMutation>;
export type EditEndFieldsReportUserMutationOptions = Apollo.BaseMutationOptions<EditEndFieldsReportUserMutation, EditEndFieldsReportUserMutationVariables>;
export const EditTasksDateDocument = gql`
    mutation EditTasksDate($id: uuid!, $startDate: timestamptz, $endDate: timestamptz) {
  update_task_by_pk(
    pk_columns: {id: $id}
    _set: {startDate: $startDate, endDate: $endDate, updatedAt: "now()"}
  ) {
    id
  }
}
    `;
export type EditTasksDateMutationFn = Apollo.MutationFunction<EditTasksDateMutation, EditTasksDateMutationVariables>;

/**
 * __useEditTasksDateMutation__
 *
 * To run a mutation, you first call `useEditTasksDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTasksDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTasksDateMutation, { data, loading, error }] = useEditTasksDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useEditTasksDateMutation(baseOptions?: Apollo.MutationHookOptions<EditTasksDateMutation, EditTasksDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTasksDateMutation, EditTasksDateMutationVariables>(EditTasksDateDocument, options);
      }
export type EditTasksDateMutationHookResult = ReturnType<typeof useEditTasksDateMutation>;
export type EditTasksDateMutationResult = Apollo.MutationResult<EditTasksDateMutation>;
export type EditTasksDateMutationOptions = Apollo.BaseMutationOptions<EditTasksDateMutation, EditTasksDateMutationVariables>;
export const GetShiftReportMetadataDocument = gql`
    query GetShiftReportMetadata($shiftReportId: uuid!, $constructionSiteId: uuid) {
  shiftReport: shiftReport_by_pk(id: $shiftReportId) {
    ...ShiftReportChartView
    constructionSite {
      id
      name
      logo
    }
  }
  activities: activity(
    where: {parentId: {_is_null: true}, constructionSiteId: {_eq: $constructionSiteId}, hidden: {_eq: false}}
    order_by: {order: asc}
  ) {
    ...ActivityWithoutHiddenTreeFull
  }
  excavationOrBuildActivities: activity(
    where: {_or: [{type: {_eq: "excavation"}}, {type: {_eq: "build"}}], constructionSiteId: {_eq: $constructionSiteId}}
  ) {
    ...ActivityFull
  }
}
    ${ShiftReportChartViewFragmentDoc}
${ActivityWithoutHiddenTreeFullFragmentDoc}
${ActivityFullFragmentDoc}`;

/**
 * __useGetShiftReportMetadataQuery__
 *
 * To run a query within a React component, call `useGetShiftReportMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftReportMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftReportMetadataQuery({
 *   variables: {
 *      shiftReportId: // value for 'shiftReportId'
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetShiftReportMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetShiftReportMetadataQuery, GetShiftReportMetadataQueryVariables> & ({ variables: GetShiftReportMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShiftReportMetadataQuery, GetShiftReportMetadataQueryVariables>(GetShiftReportMetadataDocument, options);
      }
export function useGetShiftReportMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShiftReportMetadataQuery, GetShiftReportMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShiftReportMetadataQuery, GetShiftReportMetadataQueryVariables>(GetShiftReportMetadataDocument, options);
        }
export function useGetShiftReportMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShiftReportMetadataQuery, GetShiftReportMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShiftReportMetadataQuery, GetShiftReportMetadataQueryVariables>(GetShiftReportMetadataDocument, options);
        }
export type GetShiftReportMetadataQueryHookResult = ReturnType<typeof useGetShiftReportMetadataQuery>;
export type GetShiftReportMetadataLazyQueryHookResult = ReturnType<typeof useGetShiftReportMetadataLazyQuery>;
export type GetShiftReportMetadataSuspenseQueryHookResult = ReturnType<typeof useGetShiftReportMetadataSuspenseQuery>;
export type GetShiftReportMetadataQueryResult = Apollo.QueryResult<GetShiftReportMetadataQuery, GetShiftReportMetadataQueryVariables>;
export const ShiftReportNoteUpdateDocument = gql`
    mutation ShiftReportNoteUpdate($id: uuid!, $note: String) {
  update_shiftReport_by_pk(pk_columns: {id: $id}, _set: {note: $note}) {
    id
    note
  }
}
    `;
export type ShiftReportNoteUpdateMutationFn = Apollo.MutationFunction<ShiftReportNoteUpdateMutation, ShiftReportNoteUpdateMutationVariables>;

/**
 * __useShiftReportNoteUpdateMutation__
 *
 * To run a mutation, you first call `useShiftReportNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShiftReportNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shiftReportNoteUpdateMutation, { data, loading, error }] = useShiftReportNoteUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useShiftReportNoteUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ShiftReportNoteUpdateMutation, ShiftReportNoteUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShiftReportNoteUpdateMutation, ShiftReportNoteUpdateMutationVariables>(ShiftReportNoteUpdateDocument, options);
      }
export type ShiftReportNoteUpdateMutationHookResult = ReturnType<typeof useShiftReportNoteUpdateMutation>;
export type ShiftReportNoteUpdateMutationResult = Apollo.MutationResult<ShiftReportNoteUpdateMutation>;
export type ShiftReportNoteUpdateMutationOptions = Apollo.BaseMutationOptions<ShiftReportNoteUpdateMutation, ShiftReportNoteUpdateMutationVariables>;
export const ManagerReportUpdateDocument = gql`
    mutation ManagerReportUpdate($id: uuid!, $note: String, $lastFinishedRing: Int) {
  update_shiftReport_by_pk(
    pk_columns: {id: $id}
    _set: {managerValidation: true, note: $note, lastFinishedRing: $lastFinishedRing}
  ) {
    id
  }
}
    `;
export type ManagerReportUpdateMutationFn = Apollo.MutationFunction<ManagerReportUpdateMutation, ManagerReportUpdateMutationVariables>;

/**
 * __useManagerReportUpdateMutation__
 *
 * To run a mutation, you first call `useManagerReportUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManagerReportUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [managerReportUpdateMutation, { data, loading, error }] = useManagerReportUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *      lastFinishedRing: // value for 'lastFinishedRing'
 *   },
 * });
 */
export function useManagerReportUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ManagerReportUpdateMutation, ManagerReportUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManagerReportUpdateMutation, ManagerReportUpdateMutationVariables>(ManagerReportUpdateDocument, options);
      }
export type ManagerReportUpdateMutationHookResult = ReturnType<typeof useManagerReportUpdateMutation>;
export type ManagerReportUpdateMutationResult = Apollo.MutationResult<ManagerReportUpdateMutation>;
export type ManagerReportUpdateMutationOptions = Apollo.BaseMutationOptions<ManagerReportUpdateMutation, ManagerReportUpdateMutationVariables>;
export const InvalidateOperatorValidationDocument = gql`
    mutation InvalidateOperatorValidation($id: uuid!) {
  update_shiftReport_by_pk(
    pk_columns: {id: $id}
    _set: {operatorValidation: false}
  ) {
    id
  }
}
    `;
export type InvalidateOperatorValidationMutationFn = Apollo.MutationFunction<InvalidateOperatorValidationMutation, InvalidateOperatorValidationMutationVariables>;

/**
 * __useInvalidateOperatorValidationMutation__
 *
 * To run a mutation, you first call `useInvalidateOperatorValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvalidateOperatorValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invalidateOperatorValidationMutation, { data, loading, error }] = useInvalidateOperatorValidationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvalidateOperatorValidationMutation(baseOptions?: Apollo.MutationHookOptions<InvalidateOperatorValidationMutation, InvalidateOperatorValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvalidateOperatorValidationMutation, InvalidateOperatorValidationMutationVariables>(InvalidateOperatorValidationDocument, options);
      }
export type InvalidateOperatorValidationMutationHookResult = ReturnType<typeof useInvalidateOperatorValidationMutation>;
export type InvalidateOperatorValidationMutationResult = Apollo.MutationResult<InvalidateOperatorValidationMutation>;
export type InvalidateOperatorValidationMutationOptions = Apollo.BaseMutationOptions<InvalidateOperatorValidationMutation, InvalidateOperatorValidationMutationVariables>;
export const GetPreviousReportTasksDocument = gql`
    query GetPreviousReportTasks($constructionSiteId: uuid, $date: date, $shiftReportId: uuid, $shiftStartTime: time) {
  shiftReport(
    where: {id: {_neq: $shiftReportId}, constructionSiteId: {_eq: $constructionSiteId}, _or: [{_and: [{date: {_eq: $date}}, {shift: {startTime: {_lt: $shiftStartTime}}}]}, {date: {_lt: $date}}]}
    order_by: [{date: desc}, {shift: {startTime: desc}}]
    limit: 1
  ) {
    id
    lastFinishedRing
    tasks(order_by: {startDate: desc}, limit: 1) {
      id
      ring
      ended
    }
  }
}
    `;

/**
 * __useGetPreviousReportTasksQuery__
 *
 * To run a query within a React component, call `useGetPreviousReportTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviousReportTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviousReportTasksQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      date: // value for 'date'
 *      shiftReportId: // value for 'shiftReportId'
 *      shiftStartTime: // value for 'shiftStartTime'
 *   },
 * });
 */
export function useGetPreviousReportTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetPreviousReportTasksQuery, GetPreviousReportTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviousReportTasksQuery, GetPreviousReportTasksQueryVariables>(GetPreviousReportTasksDocument, options);
      }
export function useGetPreviousReportTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviousReportTasksQuery, GetPreviousReportTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviousReportTasksQuery, GetPreviousReportTasksQueryVariables>(GetPreviousReportTasksDocument, options);
        }
export function useGetPreviousReportTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreviousReportTasksQuery, GetPreviousReportTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreviousReportTasksQuery, GetPreviousReportTasksQueryVariables>(GetPreviousReportTasksDocument, options);
        }
export type GetPreviousReportTasksQueryHookResult = ReturnType<typeof useGetPreviousReportTasksQuery>;
export type GetPreviousReportTasksLazyQueryHookResult = ReturnType<typeof useGetPreviousReportTasksLazyQuery>;
export type GetPreviousReportTasksSuspenseQueryHookResult = ReturnType<typeof useGetPreviousReportTasksSuspenseQuery>;
export type GetPreviousReportTasksQueryResult = Apollo.QueryResult<GetPreviousReportTasksQuery, GetPreviousReportTasksQueryVariables>;
export const GetEndReportMetaDocument = gql`
    query GetEndReportMeta($id: uuid!) {
  shiftReport: shiftReport_by_pk(id: $id) {
    ...EndReportMeta
  }
}
    ${EndReportMetaFragmentDoc}`;

/**
 * __useGetEndReportMetaQuery__
 *
 * To run a query within a React component, call `useGetEndReportMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndReportMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndReportMetaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEndReportMetaQuery(baseOptions: Apollo.QueryHookOptions<GetEndReportMetaQuery, GetEndReportMetaQueryVariables> & ({ variables: GetEndReportMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEndReportMetaQuery, GetEndReportMetaQueryVariables>(GetEndReportMetaDocument, options);
      }
export function useGetEndReportMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEndReportMetaQuery, GetEndReportMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEndReportMetaQuery, GetEndReportMetaQueryVariables>(GetEndReportMetaDocument, options);
        }
export function useGetEndReportMetaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEndReportMetaQuery, GetEndReportMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEndReportMetaQuery, GetEndReportMetaQueryVariables>(GetEndReportMetaDocument, options);
        }
export type GetEndReportMetaQueryHookResult = ReturnType<typeof useGetEndReportMetaQuery>;
export type GetEndReportMetaLazyQueryHookResult = ReturnType<typeof useGetEndReportMetaLazyQuery>;
export type GetEndReportMetaSuspenseQueryHookResult = ReturnType<typeof useGetEndReportMetaSuspenseQuery>;
export type GetEndReportMetaQueryResult = Apollo.QueryResult<GetEndReportMetaQuery, GetEndReportMetaQueryVariables>;
export const FinishReportDocument = gql`
    mutation FinishReport($id: uuid!, $endMetricPoint: Float, $lastFinishedRing: Int, $note: String) {
  update_shiftReport_by_pk(
    pk_columns: {id: $id}
    _set: {endMetricPoint: $endMetricPoint, lastFinishedRing: $lastFinishedRing, note: $note, operatorValidation: true}
  ) {
    id
  }
}
    `;
export type FinishReportMutationFn = Apollo.MutationFunction<FinishReportMutation, FinishReportMutationVariables>;

/**
 * __useFinishReportMutation__
 *
 * To run a mutation, you first call `useFinishReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishReportMutation, { data, loading, error }] = useFinishReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      endMetricPoint: // value for 'endMetricPoint'
 *      lastFinishedRing: // value for 'lastFinishedRing'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useFinishReportMutation(baseOptions?: Apollo.MutationHookOptions<FinishReportMutation, FinishReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishReportMutation, FinishReportMutationVariables>(FinishReportDocument, options);
      }
export type FinishReportMutationHookResult = ReturnType<typeof useFinishReportMutation>;
export type FinishReportMutationResult = Apollo.MutationResult<FinishReportMutation>;
export type FinishReportMutationOptions = Apollo.BaseMutationOptions<FinishReportMutation, FinishReportMutationVariables>;
export const FinishReportManagerDocument = gql`
    mutation FinishReportManager($id: uuid!, $endMetricPoint: Float, $lastFinishedRing: Int, $note: String, $managerValidation: Boolean) {
  update_shiftReport_by_pk(
    pk_columns: {id: $id}
    _set: {endMetricPoint: $endMetricPoint, lastFinishedRing: $lastFinishedRing, note: $note, operatorValidation: true, managerValidation: $managerValidation}
  ) {
    id
  }
}
    `;
export type FinishReportManagerMutationFn = Apollo.MutationFunction<FinishReportManagerMutation, FinishReportManagerMutationVariables>;

/**
 * __useFinishReportManagerMutation__
 *
 * To run a mutation, you first call `useFinishReportManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishReportManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishReportManagerMutation, { data, loading, error }] = useFinishReportManagerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      endMetricPoint: // value for 'endMetricPoint'
 *      lastFinishedRing: // value for 'lastFinishedRing'
 *      note: // value for 'note'
 *      managerValidation: // value for 'managerValidation'
 *   },
 * });
 */
export function useFinishReportManagerMutation(baseOptions?: Apollo.MutationHookOptions<FinishReportManagerMutation, FinishReportManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishReportManagerMutation, FinishReportManagerMutationVariables>(FinishReportManagerDocument, options);
      }
export type FinishReportManagerMutationHookResult = ReturnType<typeof useFinishReportManagerMutation>;
export type FinishReportManagerMutationResult = Apollo.MutationResult<FinishReportManagerMutation>;
export type FinishReportManagerMutationOptions = Apollo.BaseMutationOptions<FinishReportManagerMutation, FinishReportManagerMutationVariables>;
export const GenerateShiftReportPdfDocument = gql`
    mutation generateShiftReportPdf($id: String!, $language: String!) {
  generateShiftReportPdf(shiftReportId: $id, language: $language) {
    success
    url
  }
}
    `;
export type GenerateShiftReportPdfMutationFn = Apollo.MutationFunction<GenerateShiftReportPdfMutation, GenerateShiftReportPdfMutationVariables>;

/**
 * __useGenerateShiftReportPdfMutation__
 *
 * To run a mutation, you first call `useGenerateShiftReportPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateShiftReportPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateShiftReportPdfMutation, { data, loading, error }] = useGenerateShiftReportPdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGenerateShiftReportPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateShiftReportPdfMutation, GenerateShiftReportPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateShiftReportPdfMutation, GenerateShiftReportPdfMutationVariables>(GenerateShiftReportPdfDocument, options);
      }
export type GenerateShiftReportPdfMutationHookResult = ReturnType<typeof useGenerateShiftReportPdfMutation>;
export type GenerateShiftReportPdfMutationResult = Apollo.MutationResult<GenerateShiftReportPdfMutation>;
export type GenerateShiftReportPdfMutationOptions = Apollo.BaseMutationOptions<GenerateShiftReportPdfMutation, GenerateShiftReportPdfMutationVariables>;
export const GenerateShiftReportPdfsDocument = gql`
    mutation generateShiftReportPdfs($constructionSiteId: String!, $startDate: String!, $endDate: String!, $language: String!) {
  generateShiftReportPdfs(
    constructionSiteId: $constructionSiteId
    startDate: $startDate
    endDate: $endDate
    language: $language
  ) {
    success
    url
  }
}
    `;
export type GenerateShiftReportPdfsMutationFn = Apollo.MutationFunction<GenerateShiftReportPdfsMutation, GenerateShiftReportPdfsMutationVariables>;

/**
 * __useGenerateShiftReportPdfsMutation__
 *
 * To run a mutation, you first call `useGenerateShiftReportPdfsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateShiftReportPdfsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateShiftReportPdfsMutation, { data, loading, error }] = useGenerateShiftReportPdfsMutation({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGenerateShiftReportPdfsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateShiftReportPdfsMutation, GenerateShiftReportPdfsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateShiftReportPdfsMutation, GenerateShiftReportPdfsMutationVariables>(GenerateShiftReportPdfsDocument, options);
      }
export type GenerateShiftReportPdfsMutationHookResult = ReturnType<typeof useGenerateShiftReportPdfsMutation>;
export type GenerateShiftReportPdfsMutationResult = Apollo.MutationResult<GenerateShiftReportPdfsMutation>;
export type GenerateShiftReportPdfsMutationOptions = Apollo.BaseMutationOptions<GenerateShiftReportPdfsMutation, GenerateShiftReportPdfsMutationVariables>;
export const GenerateAggregatedPdfDocument = gql`
    mutation generateAggregatedPdf($startDate: String!, $endDate: String!, $constructionSiteId: String!, $type: String!, $language: String!) {
  generateAggregatedPdf(
    startDate: $startDate
    endDate: $endDate
    constructionSiteId: $constructionSiteId
    type: $type
    language: $language
  ) {
    success
    url
  }
}
    `;
export type GenerateAggregatedPdfMutationFn = Apollo.MutationFunction<GenerateAggregatedPdfMutation, GenerateAggregatedPdfMutationVariables>;

/**
 * __useGenerateAggregatedPdfMutation__
 *
 * To run a mutation, you first call `useGenerateAggregatedPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAggregatedPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAggregatedPdfMutation, { data, loading, error }] = useGenerateAggregatedPdfMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      constructionSiteId: // value for 'constructionSiteId'
 *      type: // value for 'type'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGenerateAggregatedPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAggregatedPdfMutation, GenerateAggregatedPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAggregatedPdfMutation, GenerateAggregatedPdfMutationVariables>(GenerateAggregatedPdfDocument, options);
      }
export type GenerateAggregatedPdfMutationHookResult = ReturnType<typeof useGenerateAggregatedPdfMutation>;
export type GenerateAggregatedPdfMutationResult = Apollo.MutationResult<GenerateAggregatedPdfMutation>;
export type GenerateAggregatedPdfMutationOptions = Apollo.BaseMutationOptions<GenerateAggregatedPdfMutation, GenerateAggregatedPdfMutationVariables>;
export const GetReportsDocument = gql`
    query GetReports($constructionSiteId: uuid, $limit: Int, $offset: Int, $date: date) {
  shiftReport(
    limit: $limit
    offset: $offset
    where: {_and: [{date: {_eq: $date}}, {constructionSiteId: {_eq: $constructionSiteId}}]}
    order_by: [{date: desc}, {shift: {startTime: desc}}]
  ) {
    ...ShiftReportCardInfo
  }
  shiftReportAggregate: shiftReport_aggregate(
    where: {_and: [{date: {_eq: $date}}, {constructionSiteId: {_eq: $constructionSiteId}}]}
  ) {
    aggregate {
      count
    }
  }
}
    ${ShiftReportCardInfoFragmentDoc}`;

/**
 * __useGetReportsQuery__
 *
 * To run a query within a React component, call `useGetReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetReportsQuery, GetReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
      }
export function useGetReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsQuery, GetReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
        }
export function useGetReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportsQuery, GetReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
        }
export type GetReportsQueryHookResult = ReturnType<typeof useGetReportsQuery>;
export type GetReportsLazyQueryHookResult = ReturnType<typeof useGetReportsLazyQuery>;
export type GetReportsSuspenseQueryHookResult = ReturnType<typeof useGetReportsSuspenseQuery>;
export type GetReportsQueryResult = Apollo.QueryResult<GetReportsQuery, GetReportsQueryVariables>;
export const GetReportsBeingEditedDocument = gql`
    query GetReportsBeingEdited($offset: Int, $limit: Int, $constructionSiteId: uuid) {
  shiftReports: shiftReport(
    limit: $limit
    offset: $offset
    order_by: [{date: desc}, {shift: {startTime: desc}}]
    where: {managerValidation: {_eq: false}, operatorValidation: {_eq: false}, constructionSiteId: {_eq: $constructionSiteId}}
  ) {
    ...ShiftReportCardInfo
  }
  shiftReportAggregate: shiftReport_aggregate(
    where: {managerValidation: {_eq: false}, operatorValidation: {_eq: false}, constructionSiteId: {_eq: $constructionSiteId}}
  ) {
    aggregate {
      count
    }
  }
}
    ${ShiftReportCardInfoFragmentDoc}`;

/**
 * __useGetReportsBeingEditedQuery__
 *
 * To run a query within a React component, call `useGetReportsBeingEditedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsBeingEditedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsBeingEditedQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetReportsBeingEditedQuery(baseOptions?: Apollo.QueryHookOptions<GetReportsBeingEditedQuery, GetReportsBeingEditedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsBeingEditedQuery, GetReportsBeingEditedQueryVariables>(GetReportsBeingEditedDocument, options);
      }
export function useGetReportsBeingEditedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsBeingEditedQuery, GetReportsBeingEditedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsBeingEditedQuery, GetReportsBeingEditedQueryVariables>(GetReportsBeingEditedDocument, options);
        }
export function useGetReportsBeingEditedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportsBeingEditedQuery, GetReportsBeingEditedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportsBeingEditedQuery, GetReportsBeingEditedQueryVariables>(GetReportsBeingEditedDocument, options);
        }
export type GetReportsBeingEditedQueryHookResult = ReturnType<typeof useGetReportsBeingEditedQuery>;
export type GetReportsBeingEditedLazyQueryHookResult = ReturnType<typeof useGetReportsBeingEditedLazyQuery>;
export type GetReportsBeingEditedSuspenseQueryHookResult = ReturnType<typeof useGetReportsBeingEditedSuspenseQuery>;
export type GetReportsBeingEditedQueryResult = Apollo.QueryResult<GetReportsBeingEditedQuery, GetReportsBeingEditedQueryVariables>;
export const GetReportsToReviewDocument = gql`
    query GetReportsToReview($offset: Int, $limit: Int, $constructionSiteId: uuid) {
  shiftReports: shiftReport(
    limit: $limit
    offset: $offset
    order_by: [{date: desc}, {shift: {startTime: desc}}]
    where: {managerValidation: {_eq: false}, operatorValidation: {_eq: true}, constructionSiteId: {_eq: $constructionSiteId}}
  ) {
    ...ShiftReportCardInfo
  }
  shiftReportAggregate: shiftReport_aggregate(
    where: {managerValidation: {_eq: false}, operatorValidation: {_eq: true}, constructionSiteId: {_eq: $constructionSiteId}}
  ) {
    aggregate {
      count
    }
  }
}
    ${ShiftReportCardInfoFragmentDoc}`;

/**
 * __useGetReportsToReviewQuery__
 *
 * To run a query within a React component, call `useGetReportsToReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsToReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsToReviewQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetReportsToReviewQuery(baseOptions?: Apollo.QueryHookOptions<GetReportsToReviewQuery, GetReportsToReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsToReviewQuery, GetReportsToReviewQueryVariables>(GetReportsToReviewDocument, options);
      }
export function useGetReportsToReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsToReviewQuery, GetReportsToReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsToReviewQuery, GetReportsToReviewQueryVariables>(GetReportsToReviewDocument, options);
        }
export function useGetReportsToReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportsToReviewQuery, GetReportsToReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportsToReviewQuery, GetReportsToReviewQueryVariables>(GetReportsToReviewDocument, options);
        }
export type GetReportsToReviewQueryHookResult = ReturnType<typeof useGetReportsToReviewQuery>;
export type GetReportsToReviewLazyQueryHookResult = ReturnType<typeof useGetReportsToReviewLazyQuery>;
export type GetReportsToReviewSuspenseQueryHookResult = ReturnType<typeof useGetReportsToReviewSuspenseQuery>;
export type GetReportsToReviewQueryResult = Apollo.QueryResult<GetReportsToReviewQuery, GetReportsToReviewQueryVariables>;
export const GetManagerReportHistoryDocument = gql`
    query GetManagerReportHistory($filter: shiftReport_bool_exp!, $offset: Int, $limit: Int, $constructionSiteId: uuid) {
  operators: operator(where: {constructionSiteId: {_eq: $constructionSiteId}}) {
    id
    name
  }
  shiftLeaders: shiftLeader(
    where: {constructionSiteId: {_eq: $constructionSiteId}}
  ) {
    id
    name
  }
  shiftEngineers: user(
    where: {permissions: {constructionSiteId: {_eq: $constructionSiteId}, permissionType: {name: {_eq: "user"}}}}
  ) {
    id
    email
    firstName
    lastName
  }
  shiftManagers: user(
    where: {permissions: {constructionSiteId: {_eq: $constructionSiteId}, permissionType: {name: {_eq: "construction-site-manager"}}}}
  ) {
    id
    email
    firstName
    lastName
  }
  shift: shift(where: {constructionSiteId: {_eq: $constructionSiteId}}) {
    id
    name
  }
  team(where: {constructionSiteId: {_eq: $constructionSiteId}}) {
    id
    name
  }
  shiftReports: shiftReport(
    limit: $limit
    offset: $offset
    order_by: [{date: desc}, {shift: {startTime: desc}}]
    where: {_and: [{constructionSiteId: {_eq: $constructionSiteId}, operatorValidation: {_eq: true}, _or: [{constructionSite: {managerValidationRequired: {_eq: false}}}, {_and: [{constructionSite: {managerValidationRequired: {_eq: true}}}, {managerValidation: {_eq: true}}]}]}, $filter]}
  ) {
    ...ShiftReportCardInfo
  }
  shiftReportAggregate: shiftReport_aggregate(
    where: {_and: [{constructionSiteId: {_eq: $constructionSiteId}, operatorValidation: {_eq: true}, _or: [{constructionSite: {managerValidationRequired: {_eq: false}}}, {_and: [{constructionSite: {managerValidationRequired: {_eq: true}}}, {managerValidation: {_eq: true}}]}]}, $filter]}
  ) {
    aggregate {
      count
    }
  }
}
    ${ShiftReportCardInfoFragmentDoc}`;

/**
 * __useGetManagerReportHistoryQuery__
 *
 * To run a query within a React component, call `useGetManagerReportHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagerReportHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagerReportHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetManagerReportHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetManagerReportHistoryQuery, GetManagerReportHistoryQueryVariables> & ({ variables: GetManagerReportHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagerReportHistoryQuery, GetManagerReportHistoryQueryVariables>(GetManagerReportHistoryDocument, options);
      }
export function useGetManagerReportHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagerReportHistoryQuery, GetManagerReportHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagerReportHistoryQuery, GetManagerReportHistoryQueryVariables>(GetManagerReportHistoryDocument, options);
        }
export function useGetManagerReportHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManagerReportHistoryQuery, GetManagerReportHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManagerReportHistoryQuery, GetManagerReportHistoryQueryVariables>(GetManagerReportHistoryDocument, options);
        }
export type GetManagerReportHistoryQueryHookResult = ReturnType<typeof useGetManagerReportHistoryQuery>;
export type GetManagerReportHistoryLazyQueryHookResult = ReturnType<typeof useGetManagerReportHistoryLazyQuery>;
export type GetManagerReportHistorySuspenseQueryHookResult = ReturnType<typeof useGetManagerReportHistorySuspenseQuery>;
export type GetManagerReportHistoryQueryResult = Apollo.QueryResult<GetManagerReportHistoryQuery, GetManagerReportHistoryQueryVariables>;
export const GetIndicatorResultsDocument = gql`
    query GetIndicatorResults($shiftReportId: String!, $constructionSiteId: String!) {
  calculateIndicatorResults(
    shiftReportId: $shiftReportId
    constructionSiteId: $constructionSiteId
  ) {
    message
    success
    data {
      id
      unit
      value
      nameFr
      nameEn
      nameEs
    }
  }
}
    `;

/**
 * __useGetIndicatorResultsQuery__
 *
 * To run a query within a React component, call `useGetIndicatorResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicatorResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndicatorResultsQuery({
 *   variables: {
 *      shiftReportId: // value for 'shiftReportId'
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetIndicatorResultsQuery(baseOptions: Apollo.QueryHookOptions<GetIndicatorResultsQuery, GetIndicatorResultsQueryVariables> & ({ variables: GetIndicatorResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndicatorResultsQuery, GetIndicatorResultsQueryVariables>(GetIndicatorResultsDocument, options);
      }
export function useGetIndicatorResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndicatorResultsQuery, GetIndicatorResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndicatorResultsQuery, GetIndicatorResultsQueryVariables>(GetIndicatorResultsDocument, options);
        }
export function useGetIndicatorResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndicatorResultsQuery, GetIndicatorResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndicatorResultsQuery, GetIndicatorResultsQueryVariables>(GetIndicatorResultsDocument, options);
        }
export type GetIndicatorResultsQueryHookResult = ReturnType<typeof useGetIndicatorResultsQuery>;
export type GetIndicatorResultsLazyQueryHookResult = ReturnType<typeof useGetIndicatorResultsLazyQuery>;
export type GetIndicatorResultsSuspenseQueryHookResult = ReturnType<typeof useGetIndicatorResultsSuspenseQuery>;
export type GetIndicatorResultsQueryResult = Apollo.QueryResult<GetIndicatorResultsQuery, GetIndicatorResultsQueryVariables>;
export const GetShiftReportPdfMetadataDocument = gql`
    query GetShiftReportPdfMetadata($shiftReportId: uuid!, $constructionSiteId: uuid) {
  shiftReport: shiftReport_by_pk(id: $shiftReportId) {
    ...ShiftReportChartView
    constructionSite {
      id
      name
      logo
      distanceUnit
      language
    }
  }
  activities: activity(
    where: {parentId: {_is_null: true}, constructionSiteId: {_eq: $constructionSiteId}}
    order_by: {order: asc}
  ) {
    ...ActivityTreeFull
  }
  tasksForAverageExcavation: task(
    where: {activity: {type: {_eq: "excavation"}}, shiftReportId: {_eq: $shiftReportId}}
    order_by: {ring: asc}
  ) {
    ...TaskAverageTimeInfos
  }
  tasksForAverageBuild: task(
    where: {activity: {type: {_eq: "build"}}, shiftReportId: {_eq: $shiftReportId}}
    order_by: {ring: asc}
  ) {
    ...TaskAverageTimeInfos
  }
}
    ${ShiftReportChartViewFragmentDoc}
${ActivityTreeFullFragmentDoc}
${TaskAverageTimeInfosFragmentDoc}`;

/**
 * __useGetShiftReportPdfMetadataQuery__
 *
 * To run a query within a React component, call `useGetShiftReportPdfMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftReportPdfMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftReportPdfMetadataQuery({
 *   variables: {
 *      shiftReportId: // value for 'shiftReportId'
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetShiftReportPdfMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetShiftReportPdfMetadataQuery, GetShiftReportPdfMetadataQueryVariables> & ({ variables: GetShiftReportPdfMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShiftReportPdfMetadataQuery, GetShiftReportPdfMetadataQueryVariables>(GetShiftReportPdfMetadataDocument, options);
      }
export function useGetShiftReportPdfMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShiftReportPdfMetadataQuery, GetShiftReportPdfMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShiftReportPdfMetadataQuery, GetShiftReportPdfMetadataQueryVariables>(GetShiftReportPdfMetadataDocument, options);
        }
export function useGetShiftReportPdfMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShiftReportPdfMetadataQuery, GetShiftReportPdfMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShiftReportPdfMetadataQuery, GetShiftReportPdfMetadataQueryVariables>(GetShiftReportPdfMetadataDocument, options);
        }
export type GetShiftReportPdfMetadataQueryHookResult = ReturnType<typeof useGetShiftReportPdfMetadataQuery>;
export type GetShiftReportPdfMetadataLazyQueryHookResult = ReturnType<typeof useGetShiftReportPdfMetadataLazyQuery>;
export type GetShiftReportPdfMetadataSuspenseQueryHookResult = ReturnType<typeof useGetShiftReportPdfMetadataSuspenseQuery>;
export type GetShiftReportPdfMetadataQueryResult = Apollo.QueryResult<GetShiftReportPdfMetadataQuery, GetShiftReportPdfMetadataQueryVariables>;
export const GetPreviousPrintReportDocument = gql`
    query GetPreviousPrintReport($constructionSiteId: uuid, $date: date, $shiftReportId: uuid, $shiftStartTime: time) {
  shiftReport(
    where: {id: {_neq: $shiftReportId}, constructionSiteId: {_eq: $constructionSiteId}, _or: [{date: {_lt: $date}}, {_and: [{date: {_eq: $date}}, {shift: {startTime: {_lt: $shiftStartTime}}}]}]}
    order_by: [{date: desc}, {shift: {startTime: desc}}]
    limit: 1
  ) {
    id
    lastFinishedRing
  }
}
    `;

/**
 * __useGetPreviousPrintReportQuery__
 *
 * To run a query within a React component, call `useGetPreviousPrintReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviousPrintReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviousPrintReportQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      date: // value for 'date'
 *      shiftReportId: // value for 'shiftReportId'
 *      shiftStartTime: // value for 'shiftStartTime'
 *   },
 * });
 */
export function useGetPreviousPrintReportQuery(baseOptions?: Apollo.QueryHookOptions<GetPreviousPrintReportQuery, GetPreviousPrintReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviousPrintReportQuery, GetPreviousPrintReportQueryVariables>(GetPreviousPrintReportDocument, options);
      }
export function useGetPreviousPrintReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviousPrintReportQuery, GetPreviousPrintReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviousPrintReportQuery, GetPreviousPrintReportQueryVariables>(GetPreviousPrintReportDocument, options);
        }
export function useGetPreviousPrintReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreviousPrintReportQuery, GetPreviousPrintReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreviousPrintReportQuery, GetPreviousPrintReportQueryVariables>(GetPreviousPrintReportDocument, options);
        }
export type GetPreviousPrintReportQueryHookResult = ReturnType<typeof useGetPreviousPrintReportQuery>;
export type GetPreviousPrintReportLazyQueryHookResult = ReturnType<typeof useGetPreviousPrintReportLazyQuery>;
export type GetPreviousPrintReportSuspenseQueryHookResult = ReturnType<typeof useGetPreviousPrintReportSuspenseQuery>;
export type GetPreviousPrintReportQueryResult = Apollo.QueryResult<GetPreviousPrintReportQuery, GetPreviousPrintReportQueryVariables>;
export const GetPreviousPrintTasksDocument = gql`
    query GetPreviousPrintTasks($constructionSiteId: uuid, $shiftReportId: uuid, $firstEndedExcavationRing: Int, $firstEndedBuildRing: Int, $withExcavationTasks: Boolean!, $withBuildTasks: Boolean!) {
  excavationTasks: task(
    where: {ring: {_eq: $firstEndedExcavationRing}, shiftReportId: {_neq: $shiftReportId}, shiftReport: {constructionSiteId: {_eq: $constructionSiteId}}, activity: {type: {_eq: "excavation"}}}
  ) @include(if: $withExcavationTasks) {
    ...TaskAverageTimeInfos
  }
  buildTasks: task(
    where: {ring: {_eq: $firstEndedBuildRing}, shiftReportId: {_neq: $shiftReportId}, shiftReport: {constructionSiteId: {_eq: $constructionSiteId}}, activity: {type: {_eq: "build"}}}
  ) @include(if: $withBuildTasks) {
    ...TaskAverageTimeInfos
  }
}
    ${TaskAverageTimeInfosFragmentDoc}`;

/**
 * __useGetPreviousPrintTasksQuery__
 *
 * To run a query within a React component, call `useGetPreviousPrintTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviousPrintTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviousPrintTasksQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      shiftReportId: // value for 'shiftReportId'
 *      firstEndedExcavationRing: // value for 'firstEndedExcavationRing'
 *      firstEndedBuildRing: // value for 'firstEndedBuildRing'
 *      withExcavationTasks: // value for 'withExcavationTasks'
 *      withBuildTasks: // value for 'withBuildTasks'
 *   },
 * });
 */
export function useGetPreviousPrintTasksQuery(baseOptions: Apollo.QueryHookOptions<GetPreviousPrintTasksQuery, GetPreviousPrintTasksQueryVariables> & ({ variables: GetPreviousPrintTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviousPrintTasksQuery, GetPreviousPrintTasksQueryVariables>(GetPreviousPrintTasksDocument, options);
      }
export function useGetPreviousPrintTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviousPrintTasksQuery, GetPreviousPrintTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviousPrintTasksQuery, GetPreviousPrintTasksQueryVariables>(GetPreviousPrintTasksDocument, options);
        }
export function useGetPreviousPrintTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreviousPrintTasksQuery, GetPreviousPrintTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreviousPrintTasksQuery, GetPreviousPrintTasksQueryVariables>(GetPreviousPrintTasksDocument, options);
        }
export type GetPreviousPrintTasksQueryHookResult = ReturnType<typeof useGetPreviousPrintTasksQuery>;
export type GetPreviousPrintTasksLazyQueryHookResult = ReturnType<typeof useGetPreviousPrintTasksLazyQuery>;
export type GetPreviousPrintTasksSuspenseQueryHookResult = ReturnType<typeof useGetPreviousPrintTasksSuspenseQuery>;
export type GetPreviousPrintTasksQueryResult = Apollo.QueryResult<GetPreviousPrintTasksQuery, GetPreviousPrintTasksQueryVariables>;
export const InvalidateManagerValidationDocument = gql`
    mutation InvalidateManagerValidation($id: uuid!, $operatorValidation: Boolean, $managerValidation: Boolean) {
  update_shiftReport_by_pk(
    pk_columns: {id: $id}
    _set: {operatorValidation: $operatorValidation, managerValidation: $managerValidation}
  ) {
    id
  }
}
    `;
export type InvalidateManagerValidationMutationFn = Apollo.MutationFunction<InvalidateManagerValidationMutation, InvalidateManagerValidationMutationVariables>;

/**
 * __useInvalidateManagerValidationMutation__
 *
 * To run a mutation, you first call `useInvalidateManagerValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvalidateManagerValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invalidateManagerValidationMutation, { data, loading, error }] = useInvalidateManagerValidationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      operatorValidation: // value for 'operatorValidation'
 *      managerValidation: // value for 'managerValidation'
 *   },
 * });
 */
export function useInvalidateManagerValidationMutation(baseOptions?: Apollo.MutationHookOptions<InvalidateManagerValidationMutation, InvalidateManagerValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvalidateManagerValidationMutation, InvalidateManagerValidationMutationVariables>(InvalidateManagerValidationDocument, options);
      }
export type InvalidateManagerValidationMutationHookResult = ReturnType<typeof useInvalidateManagerValidationMutation>;
export type InvalidateManagerValidationMutationResult = Apollo.MutationResult<InvalidateManagerValidationMutation>;
export type InvalidateManagerValidationMutationOptions = Apollo.BaseMutationOptions<InvalidateManagerValidationMutation, InvalidateManagerValidationMutationVariables>;
export const DeleteShiftReportDocument = gql`
    mutation DeleteShiftReport($id: uuid!) {
  delete_shiftReport_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteShiftReportMutationFn = Apollo.MutationFunction<DeleteShiftReportMutation, DeleteShiftReportMutationVariables>;

/**
 * __useDeleteShiftReportMutation__
 *
 * To run a mutation, you first call `useDeleteShiftReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShiftReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShiftReportMutation, { data, loading, error }] = useDeleteShiftReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteShiftReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShiftReportMutation, DeleteShiftReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShiftReportMutation, DeleteShiftReportMutationVariables>(DeleteShiftReportDocument, options);
      }
export type DeleteShiftReportMutationHookResult = ReturnType<typeof useDeleteShiftReportMutation>;
export type DeleteShiftReportMutationResult = Apollo.MutationResult<DeleteShiftReportMutation>;
export type DeleteShiftReportMutationOptions = Apollo.BaseMutationOptions<DeleteShiftReportMutation, DeleteShiftReportMutationVariables>;
export const GetCurrentRingShiftReportDocument = gql`
    query GetCurrentRingShiftReport($constructionSiteId: uuid!) {
  task(
    where: {isValidated: {_eq: true}, ended: {_eq: true}, activity: {type: {_eq: "build"}}, shiftReport: {constructionSiteId: {_eq: $constructionSiteId}, operatorValidation: {_eq: true}}}
    limit: 1
    order_by: {endDate: desc}
  ) {
    id
    ring
  }
}
    `;

/**
 * __useGetCurrentRingShiftReportQuery__
 *
 * To run a query within a React component, call `useGetCurrentRingShiftReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentRingShiftReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentRingShiftReportQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useGetCurrentRingShiftReportQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentRingShiftReportQuery, GetCurrentRingShiftReportQueryVariables> & ({ variables: GetCurrentRingShiftReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentRingShiftReportQuery, GetCurrentRingShiftReportQueryVariables>(GetCurrentRingShiftReportDocument, options);
      }
export function useGetCurrentRingShiftReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentRingShiftReportQuery, GetCurrentRingShiftReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentRingShiftReportQuery, GetCurrentRingShiftReportQueryVariables>(GetCurrentRingShiftReportDocument, options);
        }
export function useGetCurrentRingShiftReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentRingShiftReportQuery, GetCurrentRingShiftReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentRingShiftReportQuery, GetCurrentRingShiftReportQueryVariables>(GetCurrentRingShiftReportDocument, options);
        }
export type GetCurrentRingShiftReportQueryHookResult = ReturnType<typeof useGetCurrentRingShiftReportQuery>;
export type GetCurrentRingShiftReportLazyQueryHookResult = ReturnType<typeof useGetCurrentRingShiftReportLazyQuery>;
export type GetCurrentRingShiftReportSuspenseQueryHookResult = ReturnType<typeof useGetCurrentRingShiftReportSuspenseQuery>;
export type GetCurrentRingShiftReportQueryResult = Apollo.QueryResult<GetCurrentRingShiftReportQuery, GetCurrentRingShiftReportQueryVariables>;
export const GenerateTaskExcelExportDocument = gql`
    mutation GenerateTaskExcelExport($constructionSiteId: ID!, $startDate: date!, $endDate: date!, $locale: String!) {
  generateExcelFromTaskRangeExport(
    constructionSiteId: $constructionSiteId
    startDate: $startDate
    endDate: $endDate
    locale: $locale
  ) {
    url
    success
  }
}
    `;
export type GenerateTaskExcelExportMutationFn = Apollo.MutationFunction<GenerateTaskExcelExportMutation, GenerateTaskExcelExportMutationVariables>;

/**
 * __useGenerateTaskExcelExportMutation__
 *
 * To run a mutation, you first call `useGenerateTaskExcelExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTaskExcelExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTaskExcelExportMutation, { data, loading, error }] = useGenerateTaskExcelExportMutation({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGenerateTaskExcelExportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTaskExcelExportMutation, GenerateTaskExcelExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTaskExcelExportMutation, GenerateTaskExcelExportMutationVariables>(GenerateTaskExcelExportDocument, options);
      }
export type GenerateTaskExcelExportMutationHookResult = ReturnType<typeof useGenerateTaskExcelExportMutation>;
export type GenerateTaskExcelExportMutationResult = Apollo.MutationResult<GenerateTaskExcelExportMutation>;
export type GenerateTaskExcelExportMutationOptions = Apollo.BaseMutationOptions<GenerateTaskExcelExportMutation, GenerateTaskExcelExportMutationVariables>;
export const CreateNewTaskDocument = gql`
    mutation CreateNewTask($object: task_insert_input!) {
  task: insert_task_one(object: $object) {
    ...TaskFull
  }
}
    ${TaskFullFragmentDoc}`;
export type CreateNewTaskMutationFn = Apollo.MutationFunction<CreateNewTaskMutation, CreateNewTaskMutationVariables>;

/**
 * __useCreateNewTaskMutation__
 *
 * To run a mutation, you first call `useCreateNewTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewTaskMutation, { data, loading, error }] = useCreateNewTaskMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateNewTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewTaskMutation, CreateNewTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewTaskMutation, CreateNewTaskMutationVariables>(CreateNewTaskDocument, options);
      }
export type CreateNewTaskMutationHookResult = ReturnType<typeof useCreateNewTaskMutation>;
export type CreateNewTaskMutationResult = Apollo.MutationResult<CreateNewTaskMutation>;
export type CreateNewTaskMutationOptions = Apollo.BaseMutationOptions<CreateNewTaskMutation, CreateNewTaskMutationVariables>;
export const UpdateExistingTaskDocument = gql`
    mutation UpdateExistingTask($id: task_pk_columns_input!, $input: task_set_input) {
  task: update_task_by_pk(pk_columns: $id, _set: $input) {
    ...TaskFull
  }
}
    ${TaskFullFragmentDoc}`;
export type UpdateExistingTaskMutationFn = Apollo.MutationFunction<UpdateExistingTaskMutation, UpdateExistingTaskMutationVariables>;

/**
 * __useUpdateExistingTaskMutation__
 *
 * To run a mutation, you first call `useUpdateExistingTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExistingTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExistingTaskMutation, { data, loading, error }] = useUpdateExistingTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExistingTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExistingTaskMutation, UpdateExistingTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExistingTaskMutation, UpdateExistingTaskMutationVariables>(UpdateExistingTaskDocument, options);
      }
export type UpdateExistingTaskMutationHookResult = ReturnType<typeof useUpdateExistingTaskMutation>;
export type UpdateExistingTaskMutationResult = Apollo.MutationResult<UpdateExistingTaskMutation>;
export type UpdateExistingTaskMutationOptions = Apollo.BaseMutationOptions<UpdateExistingTaskMutation, UpdateExistingTaskMutationVariables>;
export const UpdateAndValidateTasksDocument = gql`
    mutation UpdateAndValidateTasks($updates: [task_updates!]!) {
  update_task_many(updates: $updates) {
    affected_rows
  }
}
    `;
export type UpdateAndValidateTasksMutationFn = Apollo.MutationFunction<UpdateAndValidateTasksMutation, UpdateAndValidateTasksMutationVariables>;

/**
 * __useUpdateAndValidateTasksMutation__
 *
 * To run a mutation, you first call `useUpdateAndValidateTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAndValidateTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAndValidateTasksMutation, { data, loading, error }] = useUpdateAndValidateTasksMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateAndValidateTasksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAndValidateTasksMutation, UpdateAndValidateTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAndValidateTasksMutation, UpdateAndValidateTasksMutationVariables>(UpdateAndValidateTasksDocument, options);
      }
export type UpdateAndValidateTasksMutationHookResult = ReturnType<typeof useUpdateAndValidateTasksMutation>;
export type UpdateAndValidateTasksMutationResult = Apollo.MutationResult<UpdateAndValidateTasksMutation>;
export type UpdateAndValidateTasksMutationOptions = Apollo.BaseMutationOptions<UpdateAndValidateTasksMutation, UpdateAndValidateTasksMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($id: uuid!) {
  delete_task_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const UpdateTaskFilesDocument = gql`
    mutation UpdateTaskFiles($id: task_pk_columns_input!, $files: jsonb) {
  task: update_task_by_pk(pk_columns: $id, _set: {files: $files}) {
    ...TaskFull
  }
}
    ${TaskFullFragmentDoc}`;
export type UpdateTaskFilesMutationFn = Apollo.MutationFunction<UpdateTaskFilesMutation, UpdateTaskFilesMutationVariables>;

/**
 * __useUpdateTaskFilesMutation__
 *
 * To run a mutation, you first call `useUpdateTaskFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskFilesMutation, { data, loading, error }] = useUpdateTaskFilesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUpdateTaskFilesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskFilesMutation, UpdateTaskFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskFilesMutation, UpdateTaskFilesMutationVariables>(UpdateTaskFilesDocument, options);
      }
export type UpdateTaskFilesMutationHookResult = ReturnType<typeof useUpdateTaskFilesMutation>;
export type UpdateTaskFilesMutationResult = Apollo.MutationResult<UpdateTaskFilesMutation>;
export type UpdateTaskFilesMutationOptions = Apollo.BaseMutationOptions<UpdateTaskFilesMutation, UpdateTaskFilesMutationVariables>;
export const ExtendPrevTaskDocument = gql`
    mutation ExtendPrevTask($id: task_pk_columns_input!, $endDate: timestamptz, $durationToAdd: Int) {
  task: update_task_by_pk(
    pk_columns: $id
    _set: {endDate: $endDate}
    _inc: {duration: $durationToAdd}
  ) {
    ...TaskFull
  }
}
    ${TaskFullFragmentDoc}`;
export type ExtendPrevTaskMutationFn = Apollo.MutationFunction<ExtendPrevTaskMutation, ExtendPrevTaskMutationVariables>;

/**
 * __useExtendPrevTaskMutation__
 *
 * To run a mutation, you first call `useExtendPrevTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendPrevTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendPrevTaskMutation, { data, loading, error }] = useExtendPrevTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      endDate: // value for 'endDate'
 *      durationToAdd: // value for 'durationToAdd'
 *   },
 * });
 */
export function useExtendPrevTaskMutation(baseOptions?: Apollo.MutationHookOptions<ExtendPrevTaskMutation, ExtendPrevTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtendPrevTaskMutation, ExtendPrevTaskMutationVariables>(ExtendPrevTaskDocument, options);
      }
export type ExtendPrevTaskMutationHookResult = ReturnType<typeof useExtendPrevTaskMutation>;
export type ExtendPrevTaskMutationResult = Apollo.MutationResult<ExtendPrevTaskMutation>;
export type ExtendPrevTaskMutationOptions = Apollo.BaseMutationOptions<ExtendPrevTaskMutation, ExtendPrevTaskMutationVariables>;
export const ExtendNextTaskDocument = gql`
    mutation ExtendNextTask($id: task_pk_columns_input!, $startDate: timestamptz, $durationToAdd: Int) {
  task: update_task_by_pk(
    pk_columns: $id
    _set: {startDate: $startDate}
    _inc: {duration: $durationToAdd}
  ) {
    ...TaskFull
  }
}
    ${TaskFullFragmentDoc}`;
export type ExtendNextTaskMutationFn = Apollo.MutationFunction<ExtendNextTaskMutation, ExtendNextTaskMutationVariables>;

/**
 * __useExtendNextTaskMutation__
 *
 * To run a mutation, you first call `useExtendNextTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendNextTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendNextTaskMutation, { data, loading, error }] = useExtendNextTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *      durationToAdd: // value for 'durationToAdd'
 *   },
 * });
 */
export function useExtendNextTaskMutation(baseOptions?: Apollo.MutationHookOptions<ExtendNextTaskMutation, ExtendNextTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtendNextTaskMutation, ExtendNextTaskMutationVariables>(ExtendNextTaskDocument, options);
      }
export type ExtendNextTaskMutationHookResult = ReturnType<typeof useExtendNextTaskMutation>;
export type ExtendNextTaskMutationResult = Apollo.MutationResult<ExtendNextTaskMutation>;
export type ExtendNextTaskMutationOptions = Apollo.BaseMutationOptions<ExtendNextTaskMutation, ExtendNextTaskMutationVariables>;
export const GetTaskFilesUrlsDocument = gql`
    query GetTaskFilesUrls($fileNames: [String!]!) {
  filesUrls: createFilesDownloadTempUrls(fileNames: $fileNames) {
    urls
    success
  }
}
    `;

/**
 * __useGetTaskFilesUrlsQuery__
 *
 * To run a query within a React component, call `useGetTaskFilesUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskFilesUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskFilesUrlsQuery({
 *   variables: {
 *      fileNames: // value for 'fileNames'
 *   },
 * });
 */
export function useGetTaskFilesUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetTaskFilesUrlsQuery, GetTaskFilesUrlsQueryVariables> & ({ variables: GetTaskFilesUrlsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskFilesUrlsQuery, GetTaskFilesUrlsQueryVariables>(GetTaskFilesUrlsDocument, options);
      }
export function useGetTaskFilesUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskFilesUrlsQuery, GetTaskFilesUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskFilesUrlsQuery, GetTaskFilesUrlsQueryVariables>(GetTaskFilesUrlsDocument, options);
        }
export function useGetTaskFilesUrlsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskFilesUrlsQuery, GetTaskFilesUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskFilesUrlsQuery, GetTaskFilesUrlsQueryVariables>(GetTaskFilesUrlsDocument, options);
        }
export type GetTaskFilesUrlsQueryHookResult = ReturnType<typeof useGetTaskFilesUrlsQuery>;
export type GetTaskFilesUrlsLazyQueryHookResult = ReturnType<typeof useGetTaskFilesUrlsLazyQuery>;
export type GetTaskFilesUrlsSuspenseQueryHookResult = ReturnType<typeof useGetTaskFilesUrlsSuspenseQuery>;
export type GetTaskFilesUrlsQueryResult = Apollo.QueryResult<GetTaskFilesUrlsQuery, GetTaskFilesUrlsQueryVariables>;
export const DeleteNotValidatedTasksDocument = gql`
    mutation DeleteNotValidatedTasks($shiftReportId: uuid!) {
  delete_task(
    where: {shiftReportId: {_eq: $shiftReportId}, isValidated: {_eq: false}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteNotValidatedTasksMutationFn = Apollo.MutationFunction<DeleteNotValidatedTasksMutation, DeleteNotValidatedTasksMutationVariables>;

/**
 * __useDeleteNotValidatedTasksMutation__
 *
 * To run a mutation, you first call `useDeleteNotValidatedTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotValidatedTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotValidatedTasksMutation, { data, loading, error }] = useDeleteNotValidatedTasksMutation({
 *   variables: {
 *      shiftReportId: // value for 'shiftReportId'
 *   },
 * });
 */
export function useDeleteNotValidatedTasksMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotValidatedTasksMutation, DeleteNotValidatedTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotValidatedTasksMutation, DeleteNotValidatedTasksMutationVariables>(DeleteNotValidatedTasksDocument, options);
      }
export type DeleteNotValidatedTasksMutationHookResult = ReturnType<typeof useDeleteNotValidatedTasksMutation>;
export type DeleteNotValidatedTasksMutationResult = Apollo.MutationResult<DeleteNotValidatedTasksMutation>;
export type DeleteNotValidatedTasksMutationOptions = Apollo.BaseMutationOptions<DeleteNotValidatedTasksMutation, DeleteNotValidatedTasksMutationVariables>;
export const GetSteeringDataDocument = gql`
    query GetSteeringData($constructionSiteId: uuid!, $limit: Int, $offset: Int, $filters: parameter_ring_bool_exp = {}, $orderBy: [parameter_ring_order_by!] = {ringNumber: desc}) {
  parameter_ring(
    where: {_and: [{constructionSiteId: {_eq: $constructionSiteId}}, $filters]}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    id
    ringNumber
    keyPosition
    length
    buildEndMetricPoint
    rearHorizontalPosition
    frontHorizontalPosition
    cuttingWheelHorizontalPosition
    rearHorizontalTrend
    frontHorizontalTrend
    rearVerticalPosition
    frontVerticalPosition
    cuttingWheelVerticalPosition
    rearVerticalTrend
    frontVerticalTrend
    leftSkirtClearance
    rightSkirtClearance
    upperSkirtClearance
    lowerSkirtClearance
  }
  parameter_ring_aggregate(
    where: {_and: [{constructionSiteId: {_eq: $constructionSiteId}}, $filters]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetSteeringDataQuery__
 *
 * To run a query within a React component, call `useGetSteeringDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSteeringDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSteeringDataQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetSteeringDataQuery(baseOptions: Apollo.QueryHookOptions<GetSteeringDataQuery, GetSteeringDataQueryVariables> & ({ variables: GetSteeringDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSteeringDataQuery, GetSteeringDataQueryVariables>(GetSteeringDataDocument, options);
      }
export function useGetSteeringDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSteeringDataQuery, GetSteeringDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSteeringDataQuery, GetSteeringDataQueryVariables>(GetSteeringDataDocument, options);
        }
export function useGetSteeringDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSteeringDataQuery, GetSteeringDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSteeringDataQuery, GetSteeringDataQueryVariables>(GetSteeringDataDocument, options);
        }
export type GetSteeringDataQueryHookResult = ReturnType<typeof useGetSteeringDataQuery>;
export type GetSteeringDataLazyQueryHookResult = ReturnType<typeof useGetSteeringDataLazyQuery>;
export type GetSteeringDataSuspenseQueryHookResult = ReturnType<typeof useGetSteeringDataSuspenseQuery>;
export type GetSteeringDataQueryResult = Apollo.QueryResult<GetSteeringDataQuery, GetSteeringDataQueryVariables>;
export const CountShiftReportToValidateDocument = gql`
    query CountShiftReportToValidate($constructionSiteId: uuid) {
  shiftReportCount: shiftReport_aggregate(
    where: {operatorValidation: {_eq: true}, managerValidation: {_eq: false}, constructionSiteId: {_eq: $constructionSiteId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useCountShiftReportToValidateQuery__
 *
 * To run a query within a React component, call `useCountShiftReportToValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountShiftReportToValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountShiftReportToValidateQuery({
 *   variables: {
 *      constructionSiteId: // value for 'constructionSiteId'
 *   },
 * });
 */
export function useCountShiftReportToValidateQuery(baseOptions?: Apollo.QueryHookOptions<CountShiftReportToValidateQuery, CountShiftReportToValidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountShiftReportToValidateQuery, CountShiftReportToValidateQueryVariables>(CountShiftReportToValidateDocument, options);
      }
export function useCountShiftReportToValidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountShiftReportToValidateQuery, CountShiftReportToValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountShiftReportToValidateQuery, CountShiftReportToValidateQueryVariables>(CountShiftReportToValidateDocument, options);
        }
export function useCountShiftReportToValidateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountShiftReportToValidateQuery, CountShiftReportToValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountShiftReportToValidateQuery, CountShiftReportToValidateQueryVariables>(CountShiftReportToValidateDocument, options);
        }
export type CountShiftReportToValidateQueryHookResult = ReturnType<typeof useCountShiftReportToValidateQuery>;
export type CountShiftReportToValidateLazyQueryHookResult = ReturnType<typeof useCountShiftReportToValidateLazyQuery>;
export type CountShiftReportToValidateSuspenseQueryHookResult = ReturnType<typeof useCountShiftReportToValidateSuspenseQuery>;
export type CountShiftReportToValidateQueryResult = Apollo.QueryResult<CountShiftReportToValidateQuery, CountShiftReportToValidateQueryVariables>;
export const QueryMyUserDocument = gql`
    query QueryMyUser($id: String, $email: String) {
  user(
    where: {_or: [{authId: {_eq: $id}}, {_and: [{email: {_eq: $email}}, {authId: {_is_null: true}}]}]}
  ) {
    ...CommonUserFields
  }
}
    ${CommonUserFieldsFragmentDoc}`;

/**
 * __useQueryMyUserQuery__
 *
 * To run a query within a React component, call `useQueryMyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryMyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryMyUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useQueryMyUserQuery(baseOptions?: Apollo.QueryHookOptions<QueryMyUserQuery, QueryMyUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryMyUserQuery, QueryMyUserQueryVariables>(QueryMyUserDocument, options);
      }
export function useQueryMyUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryMyUserQuery, QueryMyUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryMyUserQuery, QueryMyUserQueryVariables>(QueryMyUserDocument, options);
        }
export function useQueryMyUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryMyUserQuery, QueryMyUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryMyUserQuery, QueryMyUserQueryVariables>(QueryMyUserDocument, options);
        }
export type QueryMyUserQueryHookResult = ReturnType<typeof useQueryMyUserQuery>;
export type QueryMyUserLazyQueryHookResult = ReturnType<typeof useQueryMyUserLazyQuery>;
export type QueryMyUserSuspenseQueryHookResult = ReturnType<typeof useQueryMyUserSuspenseQuery>;
export type QueryMyUserQueryResult = Apollo.QueryResult<QueryMyUserQuery, QueryMyUserQueryVariables>;
export const ConstructionSiteListDocument = gql`
    query ConstructionSiteList($userId: uuid!, $isDataManager: Boolean!) {
  constructionSiteList: constructionSite(order_by: {lowerCaseName: asc}) {
    ...ConstructionSiteFields
  }
}
    ${ConstructionSiteFieldsFragmentDoc}`;

/**
 * __useConstructionSiteListQuery__
 *
 * To run a query within a React component, call `useConstructionSiteListQuery` and pass it any options that fit your needs.
 * When your component renders, `useConstructionSiteListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConstructionSiteListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      isDataManager: // value for 'isDataManager'
 *   },
 * });
 */
export function useConstructionSiteListQuery(baseOptions: Apollo.QueryHookOptions<ConstructionSiteListQuery, ConstructionSiteListQueryVariables> & ({ variables: ConstructionSiteListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConstructionSiteListQuery, ConstructionSiteListQueryVariables>(ConstructionSiteListDocument, options);
      }
export function useConstructionSiteListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConstructionSiteListQuery, ConstructionSiteListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConstructionSiteListQuery, ConstructionSiteListQueryVariables>(ConstructionSiteListDocument, options);
        }
export function useConstructionSiteListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConstructionSiteListQuery, ConstructionSiteListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConstructionSiteListQuery, ConstructionSiteListQueryVariables>(ConstructionSiteListDocument, options);
        }
export type ConstructionSiteListQueryHookResult = ReturnType<typeof useConstructionSiteListQuery>;
export type ConstructionSiteListLazyQueryHookResult = ReturnType<typeof useConstructionSiteListLazyQuery>;
export type ConstructionSiteListSuspenseQueryHookResult = ReturnType<typeof useConstructionSiteListSuspenseQuery>;
export type ConstructionSiteListQueryResult = Apollo.QueryResult<ConstructionSiteListQuery, ConstructionSiteListQueryVariables>;
export const UpdateUserAuthIdDocument = gql`
    mutation UpdateUserAuthId($id: uuid!) {
  update_user(_set: {updatedAt: "now()"}, where: {id: {_eq: $id}}) {
    returning {
      ...CommonUserFields
    }
    affected_rows
  }
}
    ${CommonUserFieldsFragmentDoc}`;
export type UpdateUserAuthIdMutationFn = Apollo.MutationFunction<UpdateUserAuthIdMutation, UpdateUserAuthIdMutationVariables>;

/**
 * __useUpdateUserAuthIdMutation__
 *
 * To run a mutation, you first call `useUpdateUserAuthIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAuthIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAuthIdMutation, { data, loading, error }] = useUpdateUserAuthIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateUserAuthIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAuthIdMutation, UpdateUserAuthIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAuthIdMutation, UpdateUserAuthIdMutationVariables>(UpdateUserAuthIdDocument, options);
      }
export type UpdateUserAuthIdMutationHookResult = ReturnType<typeof useUpdateUserAuthIdMutation>;
export type UpdateUserAuthIdMutationResult = Apollo.MutationResult<UpdateUserAuthIdMutation>;
export type UpdateUserAuthIdMutationOptions = Apollo.BaseMutationOptions<UpdateUserAuthIdMutation, UpdateUserAuthIdMutationVariables>;
export const CreatePrivateUploadUrlDocument = gql`
    mutation createPrivateUploadUrl($fileName: String!, $folderName: String) {
  createFileUploadTempUrl(fileName: $fileName, folderName: $folderName) {
    fileName
    url
  }
}
    `;
export type CreatePrivateUploadUrlMutationFn = Apollo.MutationFunction<CreatePrivateUploadUrlMutation, CreatePrivateUploadUrlMutationVariables>;

/**
 * __useCreatePrivateUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreatePrivateUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrivateUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrivateUploadUrlMutation, { data, loading, error }] = useCreatePrivateUploadUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      folderName: // value for 'folderName'
 *   },
 * });
 */
export function useCreatePrivateUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrivateUploadUrlMutation, CreatePrivateUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrivateUploadUrlMutation, CreatePrivateUploadUrlMutationVariables>(CreatePrivateUploadUrlDocument, options);
      }
export type CreatePrivateUploadUrlMutationHookResult = ReturnType<typeof useCreatePrivateUploadUrlMutation>;
export type CreatePrivateUploadUrlMutationResult = Apollo.MutationResult<CreatePrivateUploadUrlMutation>;
export type CreatePrivateUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreatePrivateUploadUrlMutation, CreatePrivateUploadUrlMutationVariables>;
export const CreatePrivateDeleteUrlDocument = gql`
    mutation createPrivateDeleteUrl($fileName: String!) {
  createFileDeleteTempUrl(fileName: $fileName) {
    url
  }
}
    `;
export type CreatePrivateDeleteUrlMutationFn = Apollo.MutationFunction<CreatePrivateDeleteUrlMutation, CreatePrivateDeleteUrlMutationVariables>;

/**
 * __useCreatePrivateDeleteUrlMutation__
 *
 * To run a mutation, you first call `useCreatePrivateDeleteUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrivateDeleteUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrivateDeleteUrlMutation, { data, loading, error }] = useCreatePrivateDeleteUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useCreatePrivateDeleteUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrivateDeleteUrlMutation, CreatePrivateDeleteUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrivateDeleteUrlMutation, CreatePrivateDeleteUrlMutationVariables>(CreatePrivateDeleteUrlDocument, options);
      }
export type CreatePrivateDeleteUrlMutationHookResult = ReturnType<typeof useCreatePrivateDeleteUrlMutation>;
export type CreatePrivateDeleteUrlMutationResult = Apollo.MutationResult<CreatePrivateDeleteUrlMutation>;
export type CreatePrivateDeleteUrlMutationOptions = Apollo.BaseMutationOptions<CreatePrivateDeleteUrlMutation, CreatePrivateDeleteUrlMutationVariables>;
export const CreatePublicUploadUrlDocument = gql`
    mutation createPublicUploadUrl($fileName: String!, $folderName: String) {
  createPublicFileUploadTempUrl(fileName: $fileName, folderName: $folderName) {
    fileName
    url
  }
}
    `;
export type CreatePublicUploadUrlMutationFn = Apollo.MutationFunction<CreatePublicUploadUrlMutation, CreatePublicUploadUrlMutationVariables>;

/**
 * __useCreatePublicUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreatePublicUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicUploadUrlMutation, { data, loading, error }] = useCreatePublicUploadUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      folderName: // value for 'folderName'
 *   },
 * });
 */
export function useCreatePublicUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreatePublicUploadUrlMutation, CreatePublicUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePublicUploadUrlMutation, CreatePublicUploadUrlMutationVariables>(CreatePublicUploadUrlDocument, options);
      }
export type CreatePublicUploadUrlMutationHookResult = ReturnType<typeof useCreatePublicUploadUrlMutation>;
export type CreatePublicUploadUrlMutationResult = Apollo.MutationResult<CreatePublicUploadUrlMutation>;
export type CreatePublicUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreatePublicUploadUrlMutation, CreatePublicUploadUrlMutationVariables>;
export const CreatePublicDeleteUrlDocument = gql`
    mutation createPublicDeleteUrl($fileName: String!) {
  createPublicFileDeleteTempUrl(fileName: $fileName) {
    url
  }
}
    `;
export type CreatePublicDeleteUrlMutationFn = Apollo.MutationFunction<CreatePublicDeleteUrlMutation, CreatePublicDeleteUrlMutationVariables>;

/**
 * __useCreatePublicDeleteUrlMutation__
 *
 * To run a mutation, you first call `useCreatePublicDeleteUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicDeleteUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicDeleteUrlMutation, { data, loading, error }] = useCreatePublicDeleteUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useCreatePublicDeleteUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreatePublicDeleteUrlMutation, CreatePublicDeleteUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePublicDeleteUrlMutation, CreatePublicDeleteUrlMutationVariables>(CreatePublicDeleteUrlDocument, options);
      }
export type CreatePublicDeleteUrlMutationHookResult = ReturnType<typeof useCreatePublicDeleteUrlMutation>;
export type CreatePublicDeleteUrlMutationResult = Apollo.MutationResult<CreatePublicDeleteUrlMutation>;
export type CreatePublicDeleteUrlMutationOptions = Apollo.BaseMutationOptions<CreatePublicDeleteUrlMutation, CreatePublicDeleteUrlMutationVariables>;